/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(520);
	module.exports = __webpack_require__(258);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(45);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(25);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(494);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(495);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(54);
	var ReactDOMComponentFlags = __webpack_require__(185);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(227);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(552);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(551);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(550);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(226);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(228);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(559);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(307);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(304);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(86);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(33);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(125);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(55);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(505);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(211);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(499);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(518);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(500);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(501);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(212);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(503);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(498);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(502);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(504);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(517);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(80);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(506);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(515);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(217);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(508);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(509);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(513);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(214);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(312);

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(84);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(306);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(305);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var MapComponent = (function (_Component) {
	    _inherits(MapComponent, _Component);
	
	    function MapComponent() {
	        _classCallCheck(this, MapComponent);
	
	        _get(Object.getPrototypeOf(MapComponent.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(MapComponent, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.state && this.state.dgElement) {
	                this.state.dgElement.remove();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this = this;
	
	            var childrenForRender = [];
	
	            if (this.state && this.state.dgElement && this.props.children) {
	                childrenForRender = _react.Children.map(this.props.children, function (child) {
	                    return (0, _react.cloneElement)(child, {
	                        element: _this.state.dgElement
	                    });
	                });
	            }
	
	            return _react2['default'].createElement(
	                'noscript',
	                null,
	                childrenForRender
	            );
	        }
	    }, {
	        key: 'checkPropsChange',
	        value: function checkPropsChange(propsName, prevProps) {
	            var _this2 = this;
	
	            if (typeof propsName == 'string') {
	                return prevProps[propsName] !== this.props[propsName];
	            } else if (typeof propsName == 'object') {
	                return propsName.some(function (name) {
	                    return prevProps[name] !== _this2.props[name];
	                });
	            }
	        }
	    }, {
	        key: 'updateLabel',
	        value: function updateLabel(prevProps) {
	            if (this.checkPropsChange('label', prevProps)) {
	                if (this.props.label) {
	                    this.state.dgElement.bindLabel(this.props.label);
	                } else {
	                    this.state.dgElement.unbindLabel();
	                }
	            }
	        }
	    }, {
	        key: 'updatePos',
	        value: function updatePos(prevProps) {
	            if (this.checkPropsChange('pos', prevProps)) {
	                this.state.dgElement.setLatLng(this.props.pos);
	            }
	        }
	    }, {
	        key: 'updatePoints',
	        value: function updatePoints(prevProps) {
	            if (this.checkPropsChange('points', prevProps)) {
	                this.state.dgElement.setLatLngs(this.props.points);
	            }
	        }
	    }, {
	        key: 'updateStyle',
	        value: function updateStyle(prevProps) {
	            if (this.checkPropsChange('style', prevProps)) {
	                this.state.dgElement.setStyle(this.props.style);
	            }
	        }
	    }, {
	        key: 'insideMap',
	        value: function insideMap() {
	            return !!this.props.element.options.zoom;
	        }
	    }, {
	        key: 'isFunction',
	        value: function isFunction(variable) {
	            return typeof variable === 'function';
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents(dgElement) {
	            for (var prop in this.props) {
	                if (prop.slice(0, 2) === 'on' && this.isFunction(this.props[prop])) {
	                    dgElement.on(prop.slice(2).toLowerCase(), this.props[prop]);
	                }
	            }
	        }
	    }, {
	        key: 'updateEvents',
	        value: function updateEvents(dgElement, prevProps) {
	            for (var prop in this.props) {
	                if (prop.slice(0, 2) === 'on') {
	                    var dgPropName = prop.slice(2).toLowerCase();
	
	                    if (!prevProps[prop] && this.isFunction(this.props[prop])) {
	                        dgElement.on(dgPropName, this.props[prop]);
	                    }
	
	                    if (this.props[prop] !== prevProps[prop] && this.isFunction(this.props[prop])) {
	                        dgElement.off(dgPropName, prevProps[prop]);
	                        dgElement.on(dgPropName, this.props[prop]);
	                    }
	
	                    if (!this.props[prop] && this.isFunction(prevProps[prop])) {
	                        dgElement.off(dgPropName, prevProps[prop]);
	                    }
	                }
	            }
	        }
	    }]);
	
	    return MapComponent;
	})(_react.Component);
	
	exports['default'] = MapComponent;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/*
	 Maps api created at 2GIS. Build on Leaflet.
	 (c) 2013-2016, 2GIS
	*/
	
	!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.DG=t()}}(function(){var define,module,exports;return function(){function t(e,i,o){function n(s,a){if(!i[s]){if(!e[s]){var l="function"==typeof require&&require;if(!a&&l)return require(s,!0);if(r)return r(s,!0);var u=new Error("Cannot find module '"+s+"'");throw u.code="MODULE_NOT_FOUND",u}var c=i[s]={exports:{}};e[s][0].call(c.exports,function(t){var i=e[s][1][t];return n(i||t)},c,c.exports,t,e,i,o)}return i[s].exports}for(var r="function"==typeof require&&require,s=0;s<o.length;s++)n(o[s]);return n}return t}()({1:[function(t,e,i){var o=".dg-firm-card__link,.dg-firm-card__phone,.dg-schedule__today-inner{text-overflow:ellipsis}.dg-popup__link,.dg-ruler__label{-webkit-tap-highlight-color:transparent}.leaflet-image-layer,.leaflet-layer,.leaflet-map-pane canvas,.leaflet-map-pane svg,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane,.leaflet-tile,.leaflet-tile-container,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden;outline:0;font:12px/1.5 \"Helvetica Neue\",Arial,Helvetica,sans-serif}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-overlay-pane svg,.leaflet-tooltip{-moz-user-select:none}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{width:1600px;height:1600px;-webkit-transform-origin:0 0}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-overlay-pane svg,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer{max-width:none!important}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-drag{-ms-touch-action:none;touch-action:none}.leaflet-tile{-webkit-filter:inherit;filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.dg-scroller_hidden_true .dg-scroller__bar-wrapper,.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-zoom-box{width:0;height:0;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:800;border:2px dotted #38f;background:rgba(255,255,255,.5)}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:800;pointer-events:visiblePainted;pointer-events:auto;float:left;clear:both}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-right .leaflet-control{float:right;margin-right:10px}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-fade-anim .leaflet-tile{will-change:opacity}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.leaflet-zoom-anim .leaflet-zoom-animated{will-change:transform;-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1),-webkit-transform .25s cubic-bezier(0,0,.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-zoom-anim .leaflet-tile{-webkit-transition:none;transition:none}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing}.leaflet-image-layer,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-image-layer.leaflet-interactive,.leaflet-marker-icon.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container a{color:#0078A8}.leaflet-container a.leaflet-active{outline:orange solid 2px}.leaflet-bar{-webkit-box-shadow:0 1px 5px rgba(0,0,0,.65);box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a,.leaflet-bar a:hover{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px 'Lucida Console',Monaco,monospace;text-indent:1px}.leaflet-control-zoom-out{font-size:20px}.leaflet-touch .leaflet-control-zoom-in{font-size:22px}.leaflet-touch .leaflet-control-zoom-out{font-size:24px}.leaflet-control-layers{-webkit-box-shadow:0 1px 5px rgba(0,0,0,.4);box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(dist/css/images/layers.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(dist/css/images/layers-2x.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-scrollbar{overflow-y:scroll;padding-right:5px}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(dist/css/images/marker-icon.png)}.leaflet-container .leaflet-control-attribution{background:#fff;background:rgba(255,255,255,.7);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;background:#fff;background:rgba(255,255,255,.5)}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{-webkit-box-shadow:none;box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center}.leaflet-popup-content-wrapper,[class^=dg-] caption,[class^=dg-] th{text-align:left}.leaflet-popup-tip-container{width:40px;position:absolute;left:50%;margin-left:-20px;overflow:hidden;pointer-events:none}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;color:#333;-webkit-box-shadow:0 3px 14px rgba(0,0,0,.4);box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{border:none;font:16px/14px Tahoma,Verdana,sans-serif;color:#c3c3c3;text-decoration:none;background:0 0}.leaflet-container a.leaflet-popup-close-button:hover{color:#999}.leaflet-oldie .leaflet-popup-content-wrapper{zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=.70710678, M12=.70710678, M21=-.70710678, M22=.70710678)}.leaflet-oldie .leaflet-popup-tip-container{margin-top:-1px}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{position:absolute;padding:6px;background-color:#fff;border:1px solid #fff;border-radius:3px;color:#222;white-space:nowrap;-webkit-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.4);box-shadow:0 1px 3px rgba(0,0,0,.4)}.leaflet-tooltip.leaflet-clickable{cursor:pointer;pointer-events:auto}.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before,.leaflet-tooltip-top:before{position:absolute;pointer-events:none;border:6px solid transparent;background:0 0;content:\"\"}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{left:50%;margin-left:-6px}.leaflet-tooltip-top:before{bottom:0;margin-bottom:-12px;border-top-color:#fff}.leaflet-popup,[class^=dg-]>[class^=dg-]:last-child{margin-bottom:0}.leaflet-tooltip-bottom:before{top:0;margin-top:-12px;margin-left:-6px;border-bottom-color:#fff}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{top:50%;margin-top:-6px}.leaflet-tooltip-left:before{right:0;margin-right:-12px;border-left-color:#fff}.leaflet-tooltip-right:before{left:0;margin-left:-12px;border-right-color:#fff}[class^=dg-],[class^=dg-]:after,[class^=dg-]:before{-webkit-box-sizing:content-box;box-sizing:content-box;margin:0;padding:0;vertical-align:baseline;font-weight:inherit;font-style:inherit;font-size:1em;font-family:inherit;line-height:1.2}[class^=dg-] abbr,[class^=dg-] fieldset,[class^=dg-] img{border:0}[class^=dg-] blockquote,[class^=dg-] q{quotes:none}[class^=dg-] blockquote:after,[class^=dg-] blockquote:before,[class^=dg-] q:after,[class^=dg-] q:before{content:'';content:none}[class^=dg-] ol,[class^=dg-] ul{list-style:none}[class^=dg-] table{border-spacing:0;border-collapse:collapse}[class^=dg-] td,[class^=dg-] th{vertical-align:middle}[class^=dg-] button::-moz-focus-inner,[class^=dg-] input::-moz-focus-inner{padding:0;border:0}.dg-label{position:absolute;top:0;left:0;max-width:none;max-height:none;width:300px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dg-label__content{display:inline-block;overflow:hidden;padding:3px 7px;min-width:30px;max-width:300px;width:auto;border-width:1px;border-style:solid;border-radius:2px;vertical-align:top;font-size:12px;border-color:#323232;border-color:rgba(50,50,50,.85);background:#323232;background:rgba(50,50,50,.85);color:#ffd26e}.leaflet-top .dg-label_name_location-error{top:5px}.leaflet-right .dg-label_name_location-error{right:40px;left:auto;text-align:right}.leaflet-bottom .dg-label_name_location-error{top:4px}.leaflet-left .dg-label_name_location-error{left:40px}.leaflet-popup-tip-container{height:0}.leaflet-popup-content-wrapper{overflow:hidden;padding:0;min-width:60px;min-height:50px;border:0;border-radius:3px;-webkit-box-shadow:none;box-shadow:none;color:#e6e6e6;font-size:14px;-webkit-transition:opacity ease-out .2s,max-height ease-out .2s,height ease-out .2s;transition:opacity ease-out .2s,max-height ease-out .2s,height ease-out .2s;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%;background:rgba(50,50,50,.9)}.leaflet-popup-content-wrapper:before{float:right;width:30px;height:17px;content:''}.leaflet-popup-content{position:relative;margin:16px;width:auto;line-height:1.4}.leaflet-popup a{outline:0}.leaflet-popup-content p{margin:0}.leaflet-popup-scrolled{overflow:visible;border:0}.leaflet-popup-inner{position:relative;z-index:0}.leaflet-popup_show_true{-webkit-transition:opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;transition:transform ease-in-out .2s,opacity ease-in-out .2s,height ease-out .2s;transition:transform ease-in-out .2s,opacity ease-in-out .2s,height ease-out .2s,-webkit-transform ease-in-out .2s;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}.leaflet-popup_show_false{opacity:0!important;-webkit-transition:all ease-in-out .1s;transition:all ease-in-out .1s;-webkit-transform:scale(.2);-ms-transform:scale(.2);transform:scale(.2)}.leaflet-popup_preloader_true{width:384px;height:52px}.leaflet-map-pane .leaflet-popup-tip-container{position:absolute;top:auto;bottom:0;left:50%;margin-left:-29px;width:58px;height:47px;background-repeat:no-repeat;-webkit-transform:translateY(47px);-ms-transform:translateY(47px);transform:translateY(47px);pointer-events:none}.leaflet-popup-tip{display:none}.leaflet-popup-tip-container_svg{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGPopup__popupShadow.png);background-position:50% 95%;background-size:36px 12px}.leaflet-retina .leaflet-popup-tip-container_svg{background-image:url(https://maps.api.2gis.ru/2.0/img/DGPopup__popupShadow@2x.png)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:3px;right:3px;z-index:1;overflow:hidden;padding:0;width:30px;height:30px;text-align:center;font-weight:400;font-size:18px;line-height:30px;cursor:pointer}.no-touch .leaflet-container a.leaflet-popup-close-button:hover{border-radius:2px;-webkit-transition:all .2s;transition:all .2s;background-color:#222;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.5);box-shadow:0 1px 3px rgba(0,0,0,.5)}.leaflet-container a.leaflet-popup-close-button:active{color:#777}.leaflet-container a.leaflet-popup-close-button:after{position:absolute;z-index:2;content:'';top:-3px;right:-5px;width:40px;height:40px}.leaflet-popup-tip-container_image{background-repeat:no-repeat;background-image:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2258%22%20height%3D%2247%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200c12.643%200%2028%207.115%2028%2044h2c0-36.885%2015.358-44%2028-44h-58z%22%20fill%3D%22rgba(50%2C50%2C50%2C.9)%22%3E%3C%2Fpath%3E%0A%3C%2Fsvg%3E%0A')}.leaflet-map-pane .leaflet-popup-tip-container_svg{fill:rgba(50,50,50,.9)}.dg-wrapper{position:relative;overflow:hidden}.dg-scroller{height:100%;overflow-y:scroll;border:0}.dg-scroller::-webkit-scrollbar{width:0}.dg-scroller__bar{z-index:1;right:0;background:#999}.dg-scroller__bar_h{bottom:2px;height:8px}.dg-header__title{width:100%;margin:0;-webkit-box-sizing:border-box;box-sizing:border-box;background:#999}.dg-header__title_state_fixed{position:absolute;z-index:1}.dg-scroller_hidden_true{overflow:auto}.dg-scroller__wrapper{position:relative;overflow:hidden}.dg-scroller__bar-wrapper{position:absolute;top:18px;right:3px;bottom:4px;width:7px;border-radius:5px}.dg-popup__header+.dg-popup__container-wrapper .dg-scroller__bar-wrapper{top:4px}.dg-scroller__bar{position:absolute;min-height:20px;width:7px;border-radius:3px;pointer-events:auto}.leaflet-popup-scrolled .dg-popup__footer:before,.leaflet-popup-scrolled .dg-popup__header:after{display:block;width:100%;height:1px;content:''}.scroller__bar-wrapper .scroller__bar{background-color:#665b4f}.scroller__bar-wrapper:hover .scroller__bar{background-color:#897a6b}.dg-popup__container{margin:0}.leaflet-popup-scrolled .dg-popup__container{padding:8px 14px 8px 0}.dg-popup__header{position:relative;padding-bottom:12px}.leaflet-popup-scrolled .dg-popup__header:after{position:relative;top:12px}.dg-popup__footer{position:relative;bottom:0;overflow:hidden}.dg-control-round,.dg-control-round__icon{position:relative;width:30px;height:30px;border-radius:50%}.dg-popup_hidden_true{display:none}.leaflet-popup-scrolled .dg-popup__footer:before,.leaflet-popup-scrolled .dg-popup__header:after{border-bottom:1px solid #636363;background-color:#494949}.dg-control-round{padding:5px;cursor:default}.dg-control-round__icon{display:block;background-color:#f0f0f0;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#fff),to(#e0e0e0));background-image:-webkit-linear-gradient(top,#fff 0,#e0e0e0 100%);background-image:linear-gradient(to bottom,#fff 0,#e0e0e0 100%);color:#2b2a29;text-align:center;text-decoration:none;text-shadow:0 1px 0 #fff;font-size:22px;line-height:30px;cursor:pointer}.no-touch .dg-control-round__icon:hover{background-color:#f5f5f5;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#ebebeb),to(#fff));background-image:-webkit-linear-gradient(top,#ebebeb 0,#fff 100%);background-image:linear-gradient(to bottom,#ebebeb 0,#fff 100%)}.dg-control-round__icon:active,.dg-control-round__icon_state_active,.no-touch .dg-control-round__icon:active{background-color:#ebebeb;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#d6d6d6),to(#fff));background-image:-webkit-linear-gradient(top,#d6d6d6 0,#fff 100%);background-image:linear-gradient(to bottom,#d6d6d6 0,#fff 100%)}.leaflet-touch .dg-control-round__icon:before{position:absolute;top:-10px;right:-15px;bottom:-10px;left:-15px;content:''}.dg-control-round_is-hidden_true{display:none}.dg-control-round{background-color:#3d3d3d;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);box-shadow:0 3px 5px 0 rgba(0,0,0,.3)}.dg-control-round__icon{-webkit-box-shadow:0 2px 2px 0 rgba(0,0,0,.4);box-shadow:0 2px 2px 0 rgba(0,0,0,.4)}.no-touch .dg-control-round__icon:hover{-webkit-box-shadow:inset 0 1px #fff,0 0 0 1px rgba(0,0,0,.3),0 1px 0 1px rgba(0,0,0,.4);box-shadow:inset 0 1px #fff,0 0 0 1px rgba(0,0,0,.3),0 1px 0 1px rgba(0,0,0,.4)}.dg-control-round__icon:active,.dg-control-round__icon_state_active,.no-touch .dg-control-round__icon:active{-webkit-box-shadow:inset 0 1px 1px 1px rgba(0,0,0,.2),0 0 0 1px rgba(0,0,0,.3),0 -1px 1px 0 #000;box-shadow:inset 0 1px 1px 1px rgba(0,0,0,.2),0 0 0 1px rgba(0,0,0,.3),0 -1px 1px 0 #000}.leaflet-disabled .dg-control-round__icon,.leaflet-disabled .dg-control-round__icon:active,.no-touch .leaflet-disabled .dg-control-round__icon:hover{background-image:none;cursor:default;background-color:#b8b8b8;-webkit-box-shadow:none;box-shadow:none}.dg-museum{position:absolute;top:0;left:0;right:0;z-index:1500;padding:4px 5px 8px;background:#333;color:#fff;opacity:.97;text-align:center}.dg-museum-browser{position:relative;top:4px;display:inline-block;width:16px;height:16px;margin:0 4px;background:url(https://maps.api.2gis.ru/2.0/img/DGMuseum.jpg) left top no-repeat}.dg-museum__chrome{background-position:0 0}.dg-museum__chrome:hover{background-position:0 -16px}.dg-museum__firefox{background-position:-16px 0}.dg-museum__firefox:hover{background-position:-16px -16px}.dg-museum__safari{background-position:-32px 0}.dg-museum__safari:hover{background-position:-32px -16px}.dg-museum__opera{width:15px;background-position:-48px 0}.dg-museum__opera:hover{background-position:-48px -16px}.dg-museum__ie{width:17px;background-position:-63px 0}.dg-museum__ie:hover{background-position:-63px -16px}.dg-museum__close{display:inline-block;margin:0 4px;width:9px;height:9px;background:url(https://maps.api.2gis.ru/2.0/img/DGMuseum_close.gif) top left no-repeat;cursor:pointer}.dg-museum__close:hover{opacity:.6}.leaflet-container{z-index:0;background:#f7f3df;cursor:default}.leaflet-container:-webkit-full-screen{width:100%!important;height:100%!important}.leaflet-container:-ms-fullscreen{width:100%!important;height:100%!important}.leaflet-container:fullscreen{width:100%!important;height:100%!important}.leaflet-dragging,.leaflet-dragging .leaflet-clickable,.leaflet-dragging .leaflet-container{cursor:move}.leaflet-control a,.leaflet-control a:focus{outline:0!important}.leaflet-container .leaflet-control-attribution{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.dg-customization__marker{background-repeat:no-repeat}.dg-customization__marker:before{position:absolute;top:0;left:0;width:100%;height:100%;background-image:inherit;background-size:contain;background-repeat:no-repeat;-webkit-transition:opacity ease-in-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,-webkit-transform ease-in-out .2s;transition:opacity ease-in-out .2s,transform ease-in-out .2s;transition:opacity ease-in-out .2s,transform ease-in-out .2s,-webkit-transform ease-in-out .2s;-webkit-transform:scale(1,1);-ms-transform:scale(1,1);transform:scale(1,1);-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}.dg-customization__marker_type_mushroom{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__marker.png);background-size:22px 34px;width:22px;height:34px;-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%;-webkit-animation:dg-customization__show-marker .2s;animation:dg-customization__show-marker .2s}.leaflet-retina .dg-customization__marker_type_mushroom{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__marker@2x.png)}.dg-customization__marker_type_mushroom:focus{outline:0}.no-touch .dg-customization__marker_type_mushroom:hover{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerHover.png);background-size:22px 34px}.leaflet-retina .no-touch .dg-customization__marker_type_mushroom:hover{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerHover@2x.png)}.dg-customization__marker_type_mushroom:active,.no-touch .dg-customization__marker_type_mushroom:active{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerActive.png);background-size:22px 34px}.leaflet-retina .dg-customization__marker_type_mushroom:active,.leaflet-retina .no-touch .dg-customization__marker_type_mushroom:active{background-image:url(https://maps.api.2gis.ru/2.0/img/DGCustomization__markerActive@2x.png)}@-webkit-keyframes dg-customization__show-marker{from{opacity:0}to{opacity:1}}@keyframes dg-customization__show-marker{from{opacity:0}to{opacity:1}}.dg-customization__marker_appear{background-position:999px}.dg-customization__marker_appear:before{content:''}.dg-customization__marker_disappear{background-position:999px;pointer-events:none}.dg-customization__marker_disappear:before{visibility:hidden;content:'';opacity:0;-webkit-transform:scale(1.2,1.8);-ms-transform:scale(1.2,1.8);transform:scale(1.2,1.8);-webkit-animation:dg-customization__marker-to-callout .2s;animation:dg-customization__marker-to-callout .2s}@-webkit-keyframes dg-customization__marker-to-callout{0%{visibility:visible;opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}100%{visibility:visible;opacity:0;-webkit-transform:scale(1.2,1.8);transform:scale(1.2,1.8)}}@keyframes dg-customization__marker-to-callout{0%{visibility:visible;opacity:1;-webkit-transform:scale(1,1);transform:scale(1,1)}100%{visibility:visible;opacity:0;-webkit-transform:scale(1.2,1.8);transform:scale(1.2,1.8)}}.dg-dragging-false{touch-action:auto;-ms-touch-action:auto}.dg-zoom{width:40px;height:74px}.dg-zoom__in{position:absolute;top:0;left:0}.leaflet-touch .dg-zoom__in:before{position:absolute;top:-5px;right:-10px;bottom:0;left:-10px;content:''}.dg-zoom__in:after,.dg-zoom__out,.dg-zoom__out:after{right:0;left:0;margin:auto;position:absolute}.dg-zoom__in:after{bottom:-1px;z-index:-1;width:12px;height:2px;-webkit-box-shadow:0 0 3px 2px rgba(0,0,0,.3);box-shadow:0 0 3px 2px rgba(0,0,0,.3);content:''}.dg-zoom__button_type_in:after,.dg-zoom__button_type_in:before,.leaflet-touch .dg-zoom__button_type_in:before{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:14px;height:2px;background-color:#7a7a7a;-webkit-box-shadow:0 1px #fff;box-shadow:0 1px #fff;content:''}.dg-zoom__button_type_in:after{width:2px;height:14px}.no-touch .dg-zoom__button_type_in:hover:after,.no-touch .dg-zoom__button_type_in:hover:before{background-color:#616161}.dg-zoom__button_type_in:active:after,.dg-zoom__button_type_in:active:before,.no-touch .dg-zoom__button_type_in:active:after,.no-touch .dg-zoom__button_type_in:active:before{background-color:#575757}.leaflet-disabled .dg-zoom__button_type_in:active:after,.leaflet-disabled .dg-zoom__button_type_in:active:before,.leaflet-disabled .dg-zoom__button_type_in:after,.leaflet-disabled .dg-zoom__button_type_in:before,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:before{-webkit-box-shadow:none;box-shadow:none}.dg-zoom__out{top:40px;width:22px;height:22px}.dg-zoom__out:after{top:-1px;width:12px;height:2px;content:''}.dg-zoom__button_type_out{width:22px;height:22px}.leaflet-touch .dg-zoom__button_type_out:before{top:-5px;right:-19px;bottom:-19px;left:-19px}.dg-zoom__button_type_out:after{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;width:10px;height:2px;background:#7a7a7a;-webkit-box-shadow:0 1px #fff;box-shadow:0 1px #fff;content:''}.no-touch .dg-zoom__button_type_out:hover:after{background:#616161}.dg-zoom__button_type_out:active:after,.no-touch .dg-zoom__button_type_out:active:after{background:#575757}.leaflet-disabled .dg-zoom__button_type_out:active:after,.leaflet-disabled .dg-zoom__button_type_out:after,.no-touch .leaflet-disabled .dg-zoom__button_type_out:hover:after{-webkit-box-shadow:none;box-shadow:none}.dg-zoom__out{-webkit-box-shadow:0 2px 3px 0 rgba(0,0,0,.3);box-shadow:0 2px 3px 0 rgba(0,0,0,.3)}.dg-zoom__out:after{background-color:#3d3d3d}.leaflet-disabled .dg-zoom__button_type_in:active:after,.leaflet-disabled .dg-zoom__button_type_in:active:before,.leaflet-disabled .dg-zoom__button_type_in:after,.leaflet-disabled .dg-zoom__button_type_in:before,.leaflet-disabled .dg-zoom__button_type_out:active:after,.leaflet-disabled .dg-zoom__button_type_out:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:after,.no-touch .leaflet-disabled .dg-zoom__button_type_in:hover:before,.no-touch .leaflet-disabled .dg-zoom__button_type_out:hover:after{background-color:#707070}.dg-attribution{background-color:transparent!important}.dg-attribution__copyright{margin:0 55px 5px 0;text-align:right;white-space:nowrap;font-size:9px;font-family:Helvetica,Arial,sans-serif}.dg-attribution__links{display:inline-block;margin:0;padding:0 5px 0 0}.dg-attribution__link-item{padding:0;list-style-type:none}.leaflet-container .dg-attribution__link{background:-webkit-gradient(linear,left top,right top,from(rgba(8,8,8,.3)),to(rgba(8,8,8,.3))) 0 95%/10px 1px repeat-x;background:-webkit-linear-gradient(left,rgba(8,8,8,.3),rgba(8,8,8,.3) 100%) 0 95%/10px 1px repeat-x;background:linear-gradient(to right,rgba(8,8,8,.3),rgba(8,8,8,.3) 100%) 0 95%/10px 1px repeat-x;color:#333;text-decoration:none;font-size:9px;font-family:Helvetica,Arial,sans-serif;cursor:pointer}.leaflet-container .dg-attribution__link:hover{background-image:-webkit-gradient(linear,left top,right top,from(#080808),to(#080808));background-image:-webkit-linear-gradient(left,#080808,#080808 100%);background-image:linear-gradient(to right,#080808,#080808 100%);color:#333;text-decoration:none}.dg-attribution__logo-url{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224%22%20width%3D%2255%22%3E%0A%20%3Cpath%20fill%3D%22%23a2c124%22%20d%3D%22m24.395%2012c0-1.4545-0.22177-2.6545-0.66532-4-0.14785%204.2545-4.879%207.8182-7.4664%2010h6.7641c0.70229-2%201.3676-3.9273%201.3676-6m-4.731-9.3455c-2.033-1.6-4.62-2.6545-7.466-2.6545-6.7276%200-12.198%205.4182-12.198%2012s5.4704%2012%2012.198%2012c3.1048%200%205.9509-1.4545%208.1317-3.3455h-8.797v-2.6545c5.3595-4.5455%208.797-7.3455%208.797-10%200-1.1273-0.81317-2.6545-2.6983-2.6545-1.4785%200-2.6983%201.3455-2.6983%204.6545h-3.4005c-0.73925-4.2182%201.8481-7.6727%206.2466-7.6727%200.66532%200%201.2567%200.21818%201.8851%200.32727%22%2F%3E%0A%20%3Cpath%20fill%3D%22%233c4347%22%20d%3D%22m36.593%209.3455h1.3676c0-2-0.66532-5.1273-4.7312-5.2727-4.732-0.2183-6.1%202.6181-6.1%205.9272v5.3455c0%204.4%203.4375%205.3455%206.0988%205.3455%201.5524%200%203.4005-0.87273%204.7312-2v-6.6909h-5.4335v2.6545h2.6983v2.6545c-1.3676%201.3455-5.4335%201.3455-5.4335-2.6545v-5.3091c0-4%205.9509-4.1455%205.6183%200h1.1828zm18.296%206.6545c0-5.8182-6.9859-4.0727-6.9859-7.6%200-1.2%200.81317-2%202.1808-2%201.4415%200%202.2547%201.0182%202.2547%202.9818h2.5874c0-2-0.66532-5.3455-4.7312-5.3455-2.7722%200-4.879%201.4182-4.879%204.3273%200%206.0727%207.1707%204.0727%207.0598%207.6727-0.07392%201.4545-1.1458%202.0727-2.3656%202.0727-1.4415%200-2.6983-0.72727-2.4395-3.3818h-2.6613c-0.25874%203.3455%201.4415%206%205.3595%206%202.699%200%204.732-2.145%204.732-5.345l-0.111%200.618zm-12.198%204h-2.6983v-16h2.6983v16z%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:55px;height:24px;background-size:55px 24px;position:absolute;margin:0 3px 0 0}.dg-control-round__icon_name_fullscreen:after,.dg-control-round__icon_name_locate:after{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;content:'';background-repeat:no-repeat}.dg-location__pin{background-repeat:no-repeat;width:20px;height:20px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.basic.png);background-position:-55px 0;background-size:87px 74px}.leaflet-retina .dg-location__pin{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.basic.png);background-position:-55px 0;background-size:91px 71.5px}.dg-location__pin_state_following{background-repeat:no-repeat;width:20px;height:20px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.basic.png);background-position:-22px -24px;background-size:87px 74px}.leaflet-retina .dg-location__pin_state_following{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.basic.png);background-position:-21px -24px;background-size:91px 71.5px}.dg-control-round__icon_state_active.dg-control-round__icon_name_locate:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_locate:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%2323a5d4%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%20fill%3D%22%232685aa%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%231c85ab%22%2F%3E%0A%3C%2Fsvg%3E%0A)}@-webkit-keyframes DGLocation__locateIconRequestingAnim{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes DGLocation__locateIconRequestingAnim{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.dg-control-round__icon_name_locate:after{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23616161%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23444%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%23444%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:18px;height:18px;background-size:18px 18px}.dg-control-round__icon_name_locate:active:after,.no-touch .dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23424242%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.553%200.447%2C10%201%2C10%20H%202.08%20C%202.52%2C13.063%204.936%2C15.48%208%2C15.92%20V%2017%20c%200%2C0.553%200.447%2C1%201%2C1%200.553%2C0%201%2C-0.447%201%2C-1%20V%2015.92%20C%2013.064%2C15.481%2015.48%2C13.064%2015.92%2C10%20H%2017%20C%2017.553%2C10%2018%2C9.553%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20z%20M%209%2C14%20C%206.24%2C14%204%2C11.762%204%2C9%204%2C6.238%206.24%2C4%209%2C4%20c%202.761%2C0%205%2C2.238%205%2C5%200%2C2.762%20-2.239%2C5%20-5%2C5%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20cx%3D%229%22%20cy%3D%229%22%20r%3D%223%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%232e2e2e%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2014%2C10.004%20C%2014%2C9.834%2013.991%2C9.667%2013.975%2C9.502%2013.723%2C12.027%2011.592%2C14%209%2C14%206.408%2C14%204.277%2C12.027%204.025%2C9.502%204.009%2C9.667%204%2C9.834%204%2C10.004%20c%200%2C2.762%202.24%2C5%205%2C5%202.761%2C0%205%2C-2.238%205%2C-5%20z%20M%2010%2C3.083%20c%203.064%2C0.439%205.48%2C2.856%205.92%2C5.921%20H%2017%20c%200.369%2C0%200.688%2C0.201%200.86%2C0.498%20C%2017.947%2C9.354%2018%2C9.184%2018%2C9%2018%2C8.448%2017.553%2C8%2017%2C8%20H%2015.92%20C%2015.48%2C4.937%2013.064%2C2.52%2010%2C2.08%20V%203.083%20z%20M%201%2C9.004%20H%202.08%20C%202.52%2C5.939%204.936%2C3.522%208%2C3.083%20V%202.08%20C%204.936%2C2.52%202.52%2C4.937%202.08%2C8%20H%201%20C%200.447%2C8%200%2C8.448%200%2C9%200%2C9.184%200.053%2C9.354%200.14%2C9.502%200.312%2C9.205%200.631%2C9.004%201%2C9.004%20z%20m%208%2C-8%20c%200.553%2C0%201%2C0.447%201%2C1%20V%201%20C%2010%2C0.448%209.553%2C0%209%2C0%208.447%2C0%208%2C0.448%208%2C1%20v%201.004%20c%200%2C-0.553%200.447%2C-1%201%2C-1%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%209%2C7%20c%201.486%2C0%202.717%2C1.082%202.955%2C2.5%20C%2011.982%2C9.337%2012%2C9.171%2012%2C9%2012%2C7.344%2010.656%2C6%209%2C6%207.344%2C6%206%2C7.344%206%2C9%206%2C9.171%206.018%2C9.337%206.045%2C9.5%206.283%2C8.082%207.514%2C7%209%2C7%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:active:after,.dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:after,.no-touch .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:hover:after{background-repeat:no-repeat;width:24px;height:24px;background-image:url(https://maps.api.2gis.ru/2.0/img/sprite.dark.png);background-position:0 0;background-size:78px 65px;-webkit-animation:DGLocation__locateIconRequestingAnim 1s linear infinite;animation:DGLocation__locateIconRequestingAnim 1s linear infinite;image-rendering:optimizeQuality}.leaflet-retina .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:active:after,.leaflet-retina .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:after,.leaflet-retina .no-touch .dg-control-round__icon_state_requesting.dg-control-round__icon_name_locate:hover:after{background-image:url(https://maps.api.2gis.ru/2.0/img/sprite@2x.dark.png);background-position:0 0;background-size:78px 65px}.dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_fullscreen:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%20m%204%2C14%20h%205%20v%20-5%20h%20-2%20v%203%20H%2010%20z%20M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20V%206%20z%20M%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%230da4d4%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C1%20H%206%20V%202%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%20m%203%2C9%20h%202%20v%201%20h%20-2%20z%20m%20-3%2C3%20h%203%20v%201%20h%20-3%20z%20m%20-7%2C0%20h%203%20v%201%20H%203%20z%20M%201%2C10%20h%202%20v%201%20H%201%20z%22%20fill%3D%22%230a84ab%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C6%20H%203%20V%207%20H%201%20z%20m%2012%2C0%20h%202%20V%207%20H%2013%20z%20M%201%2C15%20h%205%20v%201%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_name_fullscreen:after{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C3%20H%206%20V%204%20H%201%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%20m%204%2C14%20h%205%20v%20-5%20h%20-2%20v%203%20h%20-3%20z%22%20fill%3D%22%236c6c6c%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2010%2C3%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20V%206%20z%20M%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%236c6c6c%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C1%20H%206%20V%202%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%20m%203%2C9%20h%202%20v%201%20h%20-2%20z%20m%20-3%2C3%20h%203%20v%201%20h%20-3%20z%20m%20-7%2C0%20h%203%20v%201%20H%203%20z%20M%201%2C10%20h%202%20v%201%20H%201%20z%22%20fill%3D%22%234b4b4b%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%201%2C6%20H%203%20V%207%20H%201%20z%20m%2012%2C0%20h%202%20V%207%20H%2013%20z%20M%201%2C15%20h%205%20v%201%20H%201%20z%20m%209%2C0%20h%205%20v%201%20h%20-5%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:16px;height:16px;background-size:16px 16px}.dg-map-geoclicker__address+.dg-map-geoclicker__purpose,.dg-map-geoclicker__purpose+.dg-map-geoclicker__address{margin-top:-6px}.dg-control-round__icon_name_fullscreen:active:after,.no-touch .dg-control-round__icon_name_fullscreen:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012%2C9%20h%204%20v%207%20h%20-4%20z%20m%20-3%2C3%20h%205%20v%204%20H%209%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2010%2C15%20h%205%20v%20-5%20h%20-2%20v%203%20h%20-3%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%200%2C9%20h%204%20v%207%20H%200%20z%20m%202%2C3%20h%205%20v%204%20H%202%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%201%2C10%20v%205%20H%206%20V%2013%20H%203%20v%20-3%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%204%20V%207%20H%200%20z%20m%209%2C0%20h%205%20V%204%20H%209%20z%20m%203%2C0%20h%204%20v%207%20h%20-4%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2015%2C6%20V%201%20h%20-5%20v%202%20h%203%20v%203%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%202%2C0%20H%207%20V%204%20H%202%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C1%20H%201%20V%206%20H%203%20V%203%20h%203%20z%22%20fill%3D%22%23282828%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-building-callout__body{position:relative}.dg-building-callout__list{margin-bottom:8px;padding-left:24px;color:#ffe6aa;list-style:none}.dg-building-callout__list-item{position:relative;margin-bottom:4px;font-size:12px}.dg-building-callout__list-item:before{position:absolute;top:5px;left:-21px;content:'';background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%226%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%203%2C-0.002%20C%204.654%2C-0.002%205.994%2C1.342%205.994%2C3%205.994%2C4.658%204.655%2C6.002%203%2C6.002%201.345%2C6.002%200.005%2C4.658%200.005%2C3%200.005%2C1.342%201.346%2C-0.002%203%2C-0.002%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:6px;height:6px;background-size:6px 6px}.dg-map-geoclicker__address{margin-bottom:10px;font-size:16px}.dg-map-geoclicker__address-header{position:relative;margin-bottom:4px;padding-left:24px}.dg-map-geoclicker__address-header:first-child:before{position:absolute;top:5px;left:1px;content:''}.dg-map-geoclicker__address-drilldown{position:relative;margin-bottom:4px;padding-left:24px;color:#aaa;font-size:12px}.dg-map-geoclicker__address-drilldown:first-child:before{position:absolute;top:2px;left:1px;content:''}.dg-map-geoclicker__purpose{position:relative;margin-bottom:10px;padding-left:24px;font-size:16px}.dg-map-geoclicker__purpose:before{position:absolute;top:4px;left:2px;content:''}.dg-map-geoclicker__sight-description{overflow:hidden;padding:.5em 0 0 24px;max-height:3.6em}a.dg-map-geoclicker__show-more-sights-link{position:relative;margin-left:24px;border-bottom:1px dotted;text-decoration:none;color:#ffe6aa}a.dg-map-geoclicker__show-more-sights-link:after{position:absolute;top:4px;margin-left:5px;width:6px;height:10px;content:'';font-weight:700}.dg-map-geoclicker__clamped-line{display:block;white-space:nowrap}.dg-map-geoclicker__clamped-line_last{overflow:hidden;width:100%;text-overflow:ellipsis}.dg-map-geoclicker__preloader-wrapper{display:table-cell;vertical-align:middle;text-align:center}.dg-map-geoclicker__address-drilldown:first-child:before,.dg-map-geoclicker__address-header:first-child:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204.958%2C11%20C%204.958%2C9.036%206.756%2C6.751%208.719%2C6.751%208.885%2C6.223%209%2C5.656%209%2C5.063%209%2C2.267%206.985%2C0%204.5%2C0%202.015%2C0%200%2C2.267%200%2C5.063%200%2C5.656%200.114%2C6.222%200.28%2C6.751%202.243%2C6.751%204.018%2C9.012%204.018%2C11%20h%200.94%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:9px;height:11px;background-size:9px 11px}.dg-map-geoclicker__purpose:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%228%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%203.582%2C8%20c%200.211%2C0%200.798%2C0.035%201%2C0%20v%204%20l%20-2%2C-1%20V%208%20c%200.372%2C0.066%200.861%2C0%201%2C0%20z%20M%200.44%2C5.384%20C%200.163%2C4.866%200%2C4.276%200%2C3.646%200%2C1.633%201.604%2C0.002%203.582%2C0.002%20c%201.978%2C0%203.582%2C1.631%203.582%2C3.644%200%2C0.647%20-0.169%2C1.254%20-0.461%2C1.781%20L%206.641%2C5.495%206.618%2C5.567%20C%205.954%2C6.549%204.844%2C7.192%203.584%2C7.192%202.25%2C7.192%201.084%2C6.467%200.44%2C5.384%20z%20M%202.613%2C1.276%20c%20-0.549%2C0%20-0.995%2C0.453%20-0.995%2C1.013%200%2C0.559%200.446%2C1.013%200.995%2C1.013%200.551%2C0%200.996%2C-0.454%200.996%2C-1.013%200%2C-0.56%20-0.445%2C-1.013%20-0.996%2C-1.013%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:8px;height:12px;background-size:8px 12px}.dg-map-geoclicker__purpose_type_street:before{top:4px;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%208.8%2C0%20H%203.199%20L%200%2C12%20H%2012%20L%208.8%2C0%20z%20M%207%2C12%20H%205%20V%209%20h%202%20v%203%20z%20M%207%2C8%20H%205%20V%206%20H%207%20V%208%20z%20M%207%2C5%20H%205%20V%203%20H%207%20V%205%20z%20M%207%2C2%20H%205%20V%200%20h%202%20v%202%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px}.dg-map-geoclicker__purpose_type_sight:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%228%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%207%2C0%20H%202.547%20C%200.547%2C0%200%2C0.828%200%2C2.5%200%2C3.734%200.5%2C5%202%2C5%203.359%2C5%204%2C3.844%204%2C3%204%2C2.281%202.859%2C2%202%2C2%202%2C2.766%202.234%2C3%203%2C3%203%2C3.69%202.48%2C4%202%2C4%201.234%2C4%201%2C3.329%201%2C2.5%201%2C1.693%201.375%2C1%202.5%2C1%204.391%2C1%205%2C1.656%205%2C3%205%2C4.6%204.338%2C5.119%203%2C6%20v%204%20H%202%20v%202%20H%208%20V%201%20L%207%2C0%20z%20M%204%2C10%20V%206%20l%201%2C1%20v%203%20H%204%20z%20m%202%2C0%20V%206%20l%201%2C1%20v%203%20H%206%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:8px;height:12px;background-size:8px 12px}.dg-map-geoclicker__purpose_type_settlement:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209%2C9%20C%208.235%2C9%207.762%2C9.522%207.259%2C10.022%207.795%2C10.38%208.051%2C11.05%207.879%2C12%20H%2012%20C%2012%2C10.46%2010.535%2C9%209%2C9%20z%20m%20-2.868%2C1.248%20c%20-0.965%2C0%20-1.747%2C0.784%20-1.747%2C1.751%20h%203.494%20c%200%2C-0.967%20-0.782%2C-1.751%20-1.747%2C-1.751%20z%20M%2010%2C1%20V%200%20H%207%20V%201%20H%205%20V%206%20L%206%2C7%20V%202%20H%207%20V%207%20L%208%2C8%20V%202%20h%201%20v%206%20h%201%20V%202%20h%201%20v%207%20l%201%2C0.607%20V%201%20H%2010%20z%20M%206.66%2C9.539%206.721%2C9.479%20C%206.903%2C9.297%207.104%2C9.14%207.314%2C9.004%20V%208.414%20L%206.131%2C7.187%203%2C8%20v%204%20H%203.62%20C%203.62%2C10.612%204.747%2C9.483%206.132%2C9.483%206.312%2C9.482%206.49%2C9.502%206.66%2C9.539%20z%20M%202%2C12%20z%20M%201%2C2%200%2C5%20v%207%20H%202%20V%205%20L%201%2C2%20z%20M%201.111%2C6.955%20C%200.804%2C6.955%200.556%2C6.706%200.556%2C6.4%20c%200%2C-0.307%200.248%2C-0.555%200.555%2C-0.555%200.307%2C0%200.554%2C0.248%200.554%2C0.555%200%2C0.306%20-0.247%2C0.555%20-0.554%2C0.555%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px}.no-touch a.dg-map-geoclicker__show-more-sights-link:hover{color:#9cd}a.dg-map-geoclicker__show-more-sights-link:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%226%22%20height%3D%2210%22%20viewBox%3D%220%200%206%2010%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C5%20V%205.4%20L%201.4%2C10%20H%200%20L%200%2C8.6%203.6%2C5%200%2C1.4%200%2C0%201.4%2C0%206%2C4.6%20V%205%20l%200%2C0%200%2C0%200%2C0%200%2C0%200%2C0%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-map-geoclicker__drilldown{margin-bottom:10px;color:#aaa}.dg-preloader{position:relative;margin:0 auto;width:200px;height:44px;vertical-align:middle}.dg-preloader_animation_true:after,.dg-preloader_animation_true:before{position:absolute;top:50%;left:50%;outline:transparent solid 1px;image-rendering:optimizeQuality;content:''}.dg-preloader_animation_false{background-repeat:no-repeat;background-image:url(https://maps.api.2gis.ru/2.0/img/DGPreloader__preloader.gif);background-size:100px 26px;background-attachment:scroll;background-position:50% 50%}.dg-preloader_animation_true:before{margin:-22px 0 0 -22px;width:44px;height:44px;-webkit-animation:dg-preloader__outer 5s linear infinite;animation:dg-preloader__outer 5s linear infinite}.dg-preloader_animation_true.dg-preloader_size_small:before{margin:-12px 0 0 -12px;width:24px;height:24px}.dg-preloader_animation_true.dg-preloader_scheme_regular:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2244%22%20height%3D%2244%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2035.68%2C10.32%20C%2038.368%2C13.465%2040%2C17.539%2040%2C22%2040%2C31.941%2031.941%2C40%2022%2C40%2012.059%2C40%204%2C31.941%204%2C22%204%2C17.539%205.632%2C13.465%208.32%2C10.32%20L%205.48%2C7.48%20C%202.07%2C11.354%200%2C16.434%200%2C22%200%2C34.15%209.85%2C44%2022%2C44%2034.15%2C44%2044%2C34.15%2044%2C22%2044%2C16.434%2041.93%2C11.354%2038.52%2C7.48%20l%20-2.84%2C2.84%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209.271%2C9.272%20C%2012.529%2C6.015%2017.029%2C4%2022%2C4%2026.971%2C4%2031.471%2C6.015%2034.729%2C9.272%20L%2037.557%2C6.444%20C%2033.575%2C2.462%2028.075%2C0%2022%2C0%2015.925%2C0%2010.425%2C2.462%206.443%2C6.444%20l%202.828%2C2.828%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:44px 44px}.dg-preloader_animation_true.dg-preloader_scheme_regular.dg-preloader_size_small:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018.564%2C7.435%20C%2019.467%2C8.73%2020%2C10.302%2020%2C12%2020%2C16.418%2016.418%2C20%2012%2C20%207.582%2C20%204%2C16.418%204%2C12%204%2C10.302%204.533%2C8.73%205.436%2C7.435%20L%202.581%2C4.581%20C%200.969%2C6.623%200%2C9.195%200%2C12%200%2C18.627%205.373%2C24%2012%2C24%2018.627%2C24%2024%2C18.627%2024%2C12%2024%2C9.195%2023.031%2C6.623%2021.419%2C4.581%20l%20-2.855%2C2.854%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2012%2C0%20C%208.686%2C0%205.686%2C1.343%203.516%2C3.515%20L%206.343%2C6.343%20C%207.791%2C4.895%209.791%2C4%2012%2C4%20c%202.209%2C0%204.209%2C0.895%205.657%2C2.343%20L%2020.484%2C3.515%20C%2018.314%2C1.343%2015.314%2C0%2012%2C0%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:24px 24px}.dg-preloader_animation_true:after{margin:-16px 0 0 -16px;width:32px;height:32px;-webkit-animation:dg-preloader__inner 4s linear infinite;animation:dg-preloader__inner 4s linear infinite}.dg-preloader_animation_true.dg-preloader_size_small:after{margin:-6px 0 0 -6px;width:12px;height:12px}.dg-preloader_animation_true.dg-preloader_scheme_regular:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2232%22%20height%3D%2232%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206.581%2C23.419%20C%204.969%2C21.377%204%2C18.804%204%2C16%204%2C9.373%209.373%2C4%2016%2C4%20c%206.627%2C0%2012%2C5.373%2012%2C12%200%2C2.804%20-0.969%2C5.377%20-2.581%2C7.419%20l%202.847%2C2.847%20C%2030.594%2C23.487%2032%2C19.909%2032%2C16%2032%2C7.163%2024.837%2C0%2016%2C0%207.163%2C0%200%2C7.163%200%2C16%20c%200%2C3.909%201.406%2C7.487%203.734%2C10.266%20l%202.847%2C-2.847%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2027.314%2C27.314%2024.486%2C24.486%20C%2022.314%2C26.657%2019.314%2C28%2016%2C28%2012.686%2C28%209.686%2C26.657%207.516%2C24.485%20L%204.688%2C27.313%20C%207.582%2C30.209%2011.582%2C32%2016%2C32%20c%204.418%2C0%208.418%2C-1.791%2011.314%2C-4.686%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:32px 32px}.dg-preloader_animation_true.dg-preloader_scheme_regular.dg-preloader_size_small:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%203.141%2C6.86%20C%203.059%2C6.586%203%2C6.301%203%2C6%203%2C4.343%204.343%2C3%206%2C3%207.657%2C3%209%2C4.343%209%2C6%209%2C6.301%208.941%2C6.586%208.859%2C6.86%20l%202.26%2C2.259%20C%2011.674%2C8.209%2012%2C7.144%2012%2C6%2012%2C2.686%209.314%2C0%206%2C0%202.686%2C0%200%2C2.686%200%2C6%200%2C7.144%200.326%2C8.209%200.881%2C9.119%20L%203.141%2C6.86%20z%22%20fill%3D%22%23a6cd2a%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%206%2C12%20c%201.657%2C0%203.157%2C-0.672%204.243%2C-1.757%20L%208.122%2C8.122%20C%207.578%2C8.664%206.828%2C9%206%2C9%205.172%2C9%204.422%2C8.664%203.879%2C8.121%20L%201.758%2C10.242%20C%202.843%2C11.328%204.343%2C12%206%2C12%20z%22%20fill%3D%22%230da5d5%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 12px}@-webkit-keyframes dg-preloader__outer{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes dg-preloader__outer{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dg-preloader__inner{to{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}@keyframes dg-preloader__inner{to{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}.dg-popup__footer-buttons{display:table;margin-top:10px;width:100%}.dg-popup__footer-button-wrapper{display:table-cell}.dg-popup__footer-button{position:relative;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;margin-left:5%;width:95%;border-radius:2px;text-align:center;text-decoration:none;font:12px/24px Arial,sans-serif;cursor:pointer;-webkit-transition:all .1s;transition:all .1s}.dg-popup__footer-button-wrapper:first-child .dg-popup__footer-button{margin:0;width:100%}.dg-popup__footer-icon-button:before{display:inline-block;margin:-2px 5px 0 0;width:12px;height:12px;background-size:contain;background-repeat:no-repeat;content:'';vertical-align:middle}.dg-popup__button_name_back:before,.dg-popup__button_name_firm-card-back:before,.dg-popup__button_name_firm-list-back:before{width:9px;height:6px}.dg-popup__show-less-house-link{position:relative;top:6px;margin:0 15px 10px;color:#0070c0;text-decoration:none;font-size:12px;line-height:24px}.dg-popup__header-links{margin:8px 18px 0 0}.dg-popup__header-title_for_firmcard{position:relative;overflow:hidden;max-height:3.4em}.dg-popup__header-teaser{display:-webkit-box;height:3.3em;-webkit-line-clamp:3;-webkit-box-orient:vertical}.dg-popup__header-title{display:block;white-space:normal;font:22px/24px 'Arial narrow',Arial,sans-serif}.dg-popup__header-link,.dg-popup__rating{display:inline-block;vertical-align:middle}.dg-firm-card__link,.dg-popup__header-link,.dg-schedule__string-time,.dg-schedule__table-cell-group{white-space:nowrap}.dg-popup__header-link{margin-left:2.6em}.dg-popup__header-link:first-child{margin-left:1.2em}.dg-popup__rating{margin:0 .4em 3px 0;width:70px;height:14px}.dg-popup__rating-stars{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%2214%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206.999%2C0%208.748%2C4.989%2013.997%2C4.991%209.83%2C8.708%2011.324%2C14.002%206.999%2C10.871%202.674%2C14.002%204.168%2C8.708%200%2C4.991%205.249%2C4.989%206.999%2C0%20z%22%20fill%3D%22%23ffc84b%22%2F%3E%0A%3C%2Fsvg%3E%0A);float:left;height:100%}.dg-popup__link{position:relative;background-position:center bottom;background-size:10px 1px;background-repeat:repeat-x;text-decoration:none}.dg-popup__link_type_booklet:before,.dg-popup__link_type_photos:before{position:absolute;top:2px;left:-18px;display:inherit;content:'';background-repeat:no-repeat;width:12px;height:10px}.dg-popup__link_type_flamp_reviews{margin-left:.1em}.dg-popup__link_type_booklet:before{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%200%2C8%203%2C2%20V%202%20L%200%2C0%20V%208%20z%20M%204%2C10%208%2C8%20V%200%20L%204%2C2%20v%208%20z%20M%209%2C0%20v%208%20l%203%2C2%20V%202%20L%209%2C0%20z%22%20fill%3D%22%237dc814%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 10px}a.dg-popup__link{background-image:-webkit-gradient(linear,left top,right top,from(rgba(255,230,170,.3)),to(rgba(255,230,170,.3)));background-image:-webkit-linear-gradient(left,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);background-image:linear-gradient(to right,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);color:#ffe6aa}.no-touch a.dg-popup__link:hover{background-image:-webkit-gradient(linear,left top,right top,from(rgba(153,204,221,.3)),to(rgba(153,204,221,.3)));background-image:-webkit-linear-gradient(left,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);background-image:linear-gradient(to right,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);color:#9cd}.dg-popup__header-title{color:#ffc84b}.dg-popup__footer-button-wrapper .dg-popup__footer-button,.dg-popup__footer-button-wrapper .dg-popup__footer-button:hover{color:#e6e6e6}.dg-popup__footer-button{background:rgba(0,0,0,.2);-webkit-box-shadow:0 1px rgba(0,0,0,.1);box-shadow:0 1px rgba(0,0,0,.1)}.no-touch .dg-popup__footer-button:hover{-webkit-transition:all .2s;transition:all .2s;background:#222;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.5);box-shadow:0 1px 3px rgba(0,0,0,.5)}.dg-popup__rating{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%2214%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%207.002%2C0%208.751%2C4.989%2014%2C4.991%209.833%2C8.708%2011.327%2C14.002%207.002%2C10.871%202.677%2C14.002%204.171%2C8.708%200.003%2C4.991%205.252%2C4.989%207.002%2C0%20z%22%20fill%3D%22%23aaa%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-popup__link_type_photos:before{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2011%2C1%20H%2010%20L%209%2C0%20H%206%20L%205%2C1%20H%201%20L%200%2C2%20v%207%20l%201%2C1%20H%2011%20L%2012%2C9%20V%202%20L%2011%2C1%20z%20M%203%2C4%20H%202%20V%203%20h%201%20v%201%20z%20m%204.518%2C3.992%20c%20-1.381%2C0%20-2.5%2C-1.119%20-2.5%2C-2.5%200%2C-1.38%201.119%2C-2.5%202.5%2C-2.5%201.38%2C0%202.5%2C1.12%202.5%2C2.5%200%2C1.381%20-1.121%2C2.5%20-2.5%2C2.5%20z%22%20fill%3D%22%2379b0bc%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-size:12px 10px}.dg-popup__button_name_back:before,.dg-popup__button_name_firm-card-back:before,.dg-popup__button_name_firm-list-back:before{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C3%204%2C6%20V%204%20H%209%20V%202%20H%204%20V%200%20z%22%20fill%3D%22%239f9f9f%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat}.dg-popup__button_name_back:before{width:9px;height:6px;background-size:9px 6px}.dg-popup__button_name_goto:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%227%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2016.5%2C0%20C%2014.738%2C0%2013.295%2C1.306%2013.051%2C3%20H%204.949%20C%204.718%2C1.858%203.71%2C1%202.5%2C1%201.119%2C1%200%2C2.119%200%2C3.5%200%2C4.881%201.119%2C6%202.5%2C6%203.71%2C6%204.718%2C5.142%204.949%2C4%20h%208.102%20C%2013.295%2C5.693%2014.739%2C7%2016.5%2C7%2018.433%2C7%2020%2C5.433%2020%2C3.5%2020%2C1.566%2018.433%2C0%2016.5%2C0%20z%22%20fill%3D%22%239f9f9f%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:20px;height:7px;background-size:20px 7px}.dg-popup__button_name_show-entrance:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C9%209%2C6%205%2C3%20V%205%20H%200%20V%207%20H%205%20V%209%20z%20M%209.6%2C0%20H%202.4%20C%201.074%2C0%200%2C1.074%200%2C2.4%20V%204%20H%202%20V%203.6%20C%202%2C2.716%202.716%2C2%203.6%2C2%20H%208.4%20C%209.283%2C2%2010%2C2.716%2010%2C3.6%20V%208.4%20C%2010%2C9.284%209.283%2C10%208.4%2C10%20H%203.6%20C%202.716%2C10%202%2C9.284%202%2C8.4%20V%208%20H%200%20V%209.6%20C%200%2C10.925%201.074%2C12%202.4%2C12%20H%209.6%20C%2010.926%2C12%2012%2C10.925%2012%2C9.6%20V%202.4%20C%2012%2C1.074%2010.926%2C0%209.6%2C0%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-firm-card__icon{position:relative;padding-left:24px}.dg-firm-card__address:before,.dg-firm-card__icon:before{position:absolute;content:''}.dg-firm-card__icon:before{top:0;left:0;margin:auto;background-position:0 50%;background-repeat:no-repeat}.dg-firm-card__link{overflow:hidden;margin-bottom:4px;word-wrap:normal;line-height:16px}.dg-firm-card__link a{background-position:center bottom;background-size:10px 1px;background-repeat:repeat-x;text-decoration:none;background-image:-webkit-gradient(linear,left top,right top,from(rgba(255,230,170,.3)),to(rgba(255,230,170,.3)));background-image:-webkit-linear-gradient(left,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);background-image:linear-gradient(to right,rgba(255,230,170,.3),rgba(255,230,170,.3) 100%);color:#ffe6aa}.dg-firm-card__address{margin-bottom:10px;font-size:16px}.dg-firm-card__phone,.dg-firm-card__rubrics{margin-bottom:4px;line-height:16px;overflow:hidden}.dg-firm-card__address:before{top:5px;left:1px}.dg-firm-card__comment{position:relative;margin-left:5px;font-size:12px}.dg-firm-card__phone:before{top:3px;left:1px}.dg-firm-card__site:before{top:3px}.dg-firm-card__rubrics{font-size:12px}.dg-firm-card__rubrics-list{margin:0;padding:0;list-style:none}.dg-firm-card__rubrics-list-item{display:inline;cursor:default}.dg-firm-card__rubrics-list-item:before{display:inline-block;margin:0 4px;content:'•'}.dg-firm-card__rubrics-list-item:first-child:before{margin:0;content:''}.dg-firm-card__aa{margin:0 0 4px;padding:0 0 0 24px;font-size:12px}.dg-firm-card__aa-list{display:inline;margin:0;padding:0;list-style:none;line-height:16px}.dg-firm-card__aa-list-item{display:inline;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:100%;cursor:default}.dg-firm-card__aa-list-item:before{display:inline-block;margin:0 4px;content:'•'}.dg-control-round__icon_name_ruler:after,.dg-control-round__icon_name_traffic:after,.dg-schedule__today:after,.dg-schedule__today:before{content:''}.dg-firm-card__aa-list-item:first-child:before{margin:0;content:''}.dg-firm-card__aa-list-additional{display:inline;margin:0;padding:0;list-style:none;line-height:16px}.dg-firm-card__schedule{margin-bottom:10px}.no-touch .dg-firm-card__link a:hover{background-image:-webkit-gradient(linear,left top,right top,from(rgba(153,204,221,.3)),to(rgba(153,204,221,.3)));background-image:-webkit-linear-gradient(left,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);background-image:linear-gradient(to right,rgba(153,204,221,.3),rgba(153,204,221,.3) 100%);color:#9cd}.dg-firm-card__comment,.dg-firm-card__rubrics{color:#aaa}.dg-firm-card__rubrics-list-item:after{color:#6e6964}.dg-firm-card__aa-list-item:after{color:#e6e6e6}.dg-firm-card__address:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204.958%2C11%20C%204.958%2C9.036%206.756%2C6.751%208.719%2C6.751%208.885%2C6.223%209%2C5.656%209%2C5.063%209%2C2.267%206.985%2C0%204.5%2C0%202.015%2C0%200%2C2.267%200%2C5.063%200%2C5.656%200.114%2C6.222%200.28%2C6.751%202.243%2C6.751%204.018%2C9.012%204.018%2C11%20h%200.94%20z%22%20fill%3D%22%23a0a0a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:9px;height:11px;background-size:9px 11px}.dg-firm-card__phone:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2210%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%209.181%2C9.05%20C%208.673%2C9.556%208.047%2C9.873%207.391%2C10%206.156%2C9.841%205.008%2C9.417%203.998%2C8.788%20L%201.293%2C6.092%20C%200.639%2C5.053%200.203%2C3.865%200.052%2C2.589%200.19%2C1.964%200.494%2C1.368%200.983%2C0.882%20L%201.803%2C0.065%203.987%2C2.241%20V%202.79%20L%203.441%2C3.332%20c%20-0.452%2C0.451%20-0.453%2C1.183%200%2C1.634%20L%205.082%2C6.6%20c%200.452%2C0.451%201.187%2C0.451%201.639%2C0%20L%207.244%2C6.079%20H%207.838%20L%2010%2C8.233%209.181%2C9.05%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:10px;height:10px;background-size:10px 10px}.dg-firm-card__site:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.538%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.538%208.537%2C11%205.5%2C11%20z%20m%200%2C-9%20C%203.566%2C2%202%2C3.567%202%2C5.5%202%2C7.433%203.566%2C9%205.5%2C9%205.655%2C9%205.804%2C8.974%205.954%2C8.954%20L%203%2C6%20V%205%20L%205.571%2C3.286%205.984%2C2.049%20C%205.824%2C2.026%205.666%2C2%205.5%2C2%20z%20M%208.949%2C5%20H%207.375%20C%207.021%2C5.505%206.545%2C6.082%206%2C6.497%20V%208.95%20C%207.693%2C8.705%209%2C7.262%209%2C5.5%209%2C5.329%208.974%2C5.165%208.949%2C5%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-firm-card__email:before{top:5px;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%227%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2011%2C1.555%20v%203.89%20C%2011%2C6.303%2010.242%2C7%209.309%2C7%20H%201.692%20C%200.758%2C7%200%2C6.303%200%2C5.444%20V%201.554%20L%205.5%2C4.826%2011%2C1.555%20z%20M%200.191%2C0%20H%2010.808%20L%205.5%2C3.111%200.191%2C0%20z%22%20fill%3D%22%23aaa%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:7px;background-size:11px 7px}.dg-schedule__today{position:relative;display:inline-block;margin-left:24px;max-width:84%;background-position:center bottom;background-size:2px 1px;background-repeat:repeat-x;font-size:14px;line-height:16px;cursor:pointer}.dg-schedule__today:before{position:absolute;top:3px;left:-24px}.dg-schedule__today-inner{overflow:hidden;width:100%;white-space:nowrap}.dg-schedule_works-everyday_true .dg-schedule__today{background-image:none;cursor:default}.dg-schedule_works-everyday_true .dg-schedule__today:after{background-image:none}.dg-schedule_open_true .dg-schedule__today:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%2370bf00%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__now{margin:2px 7px 0 36px;font-size:12px}.dg-schedule__string{padding:3px 16px 3px 24px;text-align:left;font-size:14px}.dg-schedule__table{display:none;text-align:center;font-size:0}.dg-schedule__tc{display:inline-block;padding:2px 0 15px;width:44px;vertical-align:top;white-space:normal;font-size:14px}.dg-schedule__tc_pre{width:19px}.dg-schedule__day-name{margin:0;color:#8c8782;text-transform:capitalize}.dg-schedule__td{margin:10px 0 0}.dg-schedule_state_expanded .dg-schedule__popup{display:block;visibility:visible;max-height:1000px;opacity:1}.dg-schedule__table-clock{margin:13px 0 0}.dg-schedule__today{background-image:-webkit-gradient(linear,left top,right top,from(rgba(230,230,230,.55)),color-stop(50%,rgba(230,230,230,.55)),color-stop(51%,rgba(0,0,0,0)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(left,rgba(230,230,230,.55),rgba(230,230,230,.55) 50%,rgba(0,0,0,0) 51%,rgba(0,0,0,0) 100%);background-image:linear-gradient(to right,rgba(230,230,230,.55),rgba(230,230,230,.55) 50%,rgba(0,0,0,0) 51%,rgba(0,0,0,0) 100%)}.dg-schedule__now{color:#aaa}.dg-schedule__string-time,.dg-schedule__td{color:#e6e6e6}.dg-schedule__tc_active_true{background:rgba(255,255,255,.1)}.dg-schedule__table-clock{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__table-lunch{margin:31px 0 0;background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%204%2C7%20H%208%20C%208.58%2C7%209.461%2C6.084%209.826%2C4.977%20V%205%20C%2011.047%2C5%2012%2C3.453%2012%2C2.031%2012%2C1.453%2011.531%2C1%2011.016%2C1%20H%2010%20C%2010%2C0.188%209.781%2C0%209%2C0%20H%203%20C%202.297%2C0%202%2C0.188%202%2C1%20v%203%20c%200%2C1.49%201.137%2C3%202%2C3%20z%20m%206%2C-5%20h%200.5%20C%2010.875%2C2%2011%2C2.219%2011%2C2.5%2011%2C3.625%2010.562%2C4%2010%2C4%20V%202%20z%20M%200%2C9%20c%200%2C0.448%201.791%2C1%203%2C1%200%2C0.405%200.646%2C1%201%2C1%20h%204%20c%200.354%2C0%201%2C-0.595%201%2C-1%201.208%2C0%203%2C-0.552%203%2C-1%20V%208%20H%200%20v%201%20z%22%20fill%3D%22%23aaa5a0%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:11px;background-size:12px 11px}.dg-schedule_open_false .dg-schedule__today:before{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205.5%2C11%20C%202.463%2C11%200%2C8.537%200%2C5.5%200%2C2.462%202.463%2C0%205.5%2C0%208.537%2C0%2011%2C2.462%2011%2C5.5%2011%2C8.537%208.537%2C11%205.5%2C11%20z%20M%206%2C5.293%20V%202%20H%205%20V%205.707%20L%207.646%2C8.353%208.353%2C7.646%206%2C5.293%20z%22%20fill%3D%22%23a0a0a0%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:11px;height:11px;background-size:11px 11px}.dg-schedule__today:after,.dg-schedule__today_shown_true:after{background-repeat:no-repeat;width:10px;height:6px;background-size:10px 6px}.dg-schedule__today:after{position:absolute;right:-15px;bottom:4px;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C6%20H%204.586%20L%200%2C1.414%20V%200%20H%201.414%20L%205%2C3.586%208.586%2C0%20H%2010%20V%201.414%20L%205.414%2C6%20H%205%20z%22%20fill%3D%22%23a5a09c%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-schedule__today_shown_true:after{background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%226%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%205%2C0%20H%205.414%20L%2010%2C4.586%20V%206%20H%208.586%20L%205%2C2.414%201.414%2C6%20H%200%20V%204.586%20L%204.586%2C0%20H%205%20z%22%20fill%3D%22%23a5a09c%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-link,.dg-link:hover{background-position:0 95%;background-size:10px 1px;background-repeat:repeat-x}.dg-link_type_local{background:-webkit-gradient(linear,left top,right top,from(#9cd),color-stop(50%,#9cd),color-stop(50%,transparent));background:-webkit-linear-gradient(left,#9cd,#9cd 50%,transparent 50%);background:linear-gradient(to right,#9cd,#9cd 50%,transparent 50%)}.no-touch .dg-link_type_local:hover{background:-webkit-gradient(linear,left top,right top,from(#9bc),color-stop(50%,#9bc),color-stop(50%,transparent));background:-webkit-linear-gradient(left,#9bc,#9bc 50%,transparent 50%);background:linear-gradient(to right,#9bc,#9bc 50%,transparent 50%)}.dg-link.dg-link_type_local,.dg-link.dg-link_type_local:hover{background-size:6px 1px}.dg-control-round__icon_name_traffic:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2214%22%20viewBox%3D%220%200%2020%2014%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018%2C5%20C%2018%2C4%2017%2C1%2015%2C1%20H%2012%2010%20C%208%2C1%207%2C4%207%2C5%20H%205%20v%202%20h%201%20v%204%20c%200%2C0.6%200%2C1%201%2C1%20v%202%20h%202%20v%20-2%20h%207%20v%202%20h%202%20v%20-2%20c%201%2C0%201%2C-0.4%201%2C-1%20V%207%20h%201%20V%205%20H%2018%20z%20M%2010%2C3%20h%202%203%20c%202%2C0%202%2C1%202%2C3%20H%208%20C%208%2C4%208%2C3%2010%2C3%20z%20M%209%2C10%20H%208%20C%207.4%2C10%207%2C9.6%207%2C9%207%2C8.4%207.4%2C8%208%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20m%208%2C0%20H%2016%20C%2015.4%2C10%2015%2C9.6%2015%2C9%2015%2C8.4%2015.4%2C8%2016%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20M%204%2C4%20H%206%20V%203%20H%204%20C%201%2C3%201%2C6%201%2C7%20H%200%20v%201%20h%201%20v%204%20H%203%20V%2011%20H%205%20V%207%20H%202%20C%202%2C6%202%2C4%204%2C4%20z%20M%203%2C9%204%2C10%20H%202%20V%209%20h%201%20z%22%20fill%3D%22%23616161%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23fff%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2016%2C8%20h%201%20c%200.4%2C0%200.7%2C0.2%200.8%2C0.5%20C%2017.9%2C8.4%2018%2C8.2%2018%2C8%2018%2C7.4%2017.6%2C7%2017%2C7%20h%20-1%20c%20-0.6%2C0%20-1%2C0.4%20-1%2C1%200%2C0.2%200.1%2C0.4%200.2%2C0.5%20C%2015.3%2C8.2%2015.6%2C8%2016%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C8%20H%209%20C%209.4%2C8%209.7%2C8.2%209.8%2C8.5%209.9%2C8.4%2010%2C8.2%2010%2C8%2010%2C7.4%209.6%2C7%209%2C7%20H%208%20C%207.4%2C7%207%2C7.4%207%2C8%207%2C8.2%207.1%2C8.4%207.2%2C8.5%207.3%2C8.2%207.6%2C8%208%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%206%2C3%20H%204%20C%204%2C3%204%2C3%204%2C3%202%2C3%202%2C5%202%2C6%20H%202%20C%202.1%2C5%202.5%2C4%204%2C4%20H%205%206%20V%203%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%207H1V8H0z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2015%2C2%20H%2012%2010%20C%208%2C2%208%2C3%208%2C5%20H%208%20C%208%2C3.7%208.3%2C3%2010%2C3%20h%202%203%20c%201.7%2C0%201.9%2C0.7%202%2C2%20h%200%20C%2017%2C3%2017%2C2%2015%2C2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%209L4%209%203%208%202%208%202%209%202%209%202%209%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%207%2C11%20C%206%2C11%206%2C10.6%206%2C10%20v%201%20c%200%2C0.6%200%2C1%201%2C1%20v%20-1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2018%2C11%20v%201%20c%201%2C0%201%2C-0.4%201%2C-1%20v%20-1%20c%200%2C0.6%200%2C1%20-1%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19%206H20V7H19z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%2011L1%2011%201%2012%203%2012%203%2011%205%2011%205%207%205%207%205%2010%203%2010z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16%2013H18V14H16z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5%206H6V7H5z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2013L7%2013%207%2014%209%2014%209%2012%2016%2012%2016%2011%209%2011z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23444%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%202%2C6%20C%202%2C6.4%202%2C6.7%202%2C7%20H%205%20V%206%20H%202%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2%209L2%2010%204%2010%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%204%2C3%20H%206%20V%202%20H%204%20C%201%2C2%201%2C5%201%2C6%20H%200%20V%207%20H%201%20C%201%2C6%201%2C3%204%2C3%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2018%2C4%20C%2018%2C3%2017%2C0%2015%2C0%20H%2012%2010%20C%208%2C0%207%2C3%207%2C4%20H%206%205%20V%205%20H%207%20C%207%2C4%208%2C1%2010%2C1%20h%202%203%20c%202%2C0%203%2C3%203%2C4%20h%202%20V%204%20h%20-2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C10%20H%209%20C%209.6%2C10%2010%2C9.6%2010%2C9%2010%2C8.8%209.9%2C8.6%209.8%2C8.5%209.7%2C8.8%209.4%2C9%209%2C9%20H%208%20C%207.6%2C9%207.3%2C8.8%207.2%2C8.5%207.1%2C8.6%207%2C8.8%207%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C6%20C%2017%2C5.6%2017%2C5.3%2017%2C5%20H%208%20c%200%2C0.3%200%2C0.6%200%2C1%20h%209%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017.8%2C8.5%20C%2017.7%2C8.8%2017.4%2C9%2017%2C9%20H%2016%20C%2015.6%2C9%2015.3%2C8.8%2015.2%2C8.5%2015.1%2C8.6%2015%2C8.8%2015%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20h%201%20c%200.6%2C0%201%2C-0.4%201%2C-1%200%2C-0.2%20-0.1%2C-0.4%20-0.2%2C-0.5%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);width:20px;height:14px;background-size:20px 14px;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.dg-control-round__icon_name_traffic:active:after,.no-touch .dg-control-round__icon_name_traffic:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2214%22%20viewBox%3D%220%200%2020%2014%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%2018%2C5%20C%2018%2C4%2017%2C1%2015%2C1%20H%2012%2010%20C%208%2C1%207%2C4%207%2C5%20H%205%20v%202%20h%201%20v%204%20c%200%2C0.6%200%2C1%201%2C1%20v%202%20h%202%20v%20-2%20h%207%20v%202%20h%202%20v%20-2%20c%201%2C0%201%2C-0.4%201%2C-1%20V%207%20h%201%20V%205%20H%2018%20z%20M%2010%2C3%20h%202%203%20c%202%2C0%202%2C1%202%2C3%20H%208%20C%208%2C4%208%2C3%2010%2C3%20z%20M%209%2C10%20H%208%20C%207.4%2C10%207%2C9.6%207%2C9%207%2C8.4%207.4%2C8%208%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20m%208%2C0%20H%2016%20C%2015.4%2C10%2015%2C9.6%2015%2C9%2015%2C8.4%2015.4%2C8%2016%2C8%20h%201%20c%200.6%2C0%201%2C0.4%201%2C1%200%2C0.6%20-0.4%2C1%20-1%2C1%20z%20M%204%2C4%20H%206%20V%203%20H%204%20C%201%2C3%201%2C6%201%2C7%20H%200%20v%201%20h%201%20v%204%20H%203%20V%2011%20H%205%20V%207%20H%202%20C%202%2C6%202%2C4%204%2C4%20z%20M%203%2C9%204%2C10%20H%202%20V%209%20h%201%20z%22%20fill%3D%22%23424242%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%20%20%20%20%3Cg%20fill%3D%22%23fff%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2016%2C8%20h%201%20c%200.4%2C0%200.7%2C0.2%200.8%2C0.5%20C%2017.9%2C8.4%2018%2C8.2%2018%2C8%2018%2C7.4%2017.6%2C7%2017%2C7%20h%20-1%20c%20-0.6%2C0%20-1%2C0.4%20-1%2C1%200%2C0.2%200.1%2C0.4%200.2%2C0.5%20C%2015.3%2C8.2%2015.6%2C8%2016%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C8%20H%209%20C%209.4%2C8%209.7%2C8.2%209.8%2C8.5%209.9%2C8.4%2010%2C8.2%2010%2C8%2010%2C7.4%209.6%2C7%209%2C7%20H%208%20C%207.4%2C7%207%2C7.4%207%2C8%207%2C8.2%207.1%2C8.4%207.2%2C8.5%207.3%2C8.2%207.6%2C8%208%2C8%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%206%2C3%20H%204%20C%204%2C3%204%2C3%204%2C3%202%2C3%202%2C5%202%2C6%20H%202%20C%202.1%2C5%202.5%2C4%204%2C4%20H%205%206%20V%203%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%207H1V8H0z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2015%2C2%20H%2012%2010%20C%208%2C2%208%2C3%208%2C5%20H%208%20C%208%2C3.7%208.3%2C3%2010%2C3%20h%202%203%20c%201.7%2C0%201.9%2C0.7%202%2C2%20h%200%20C%2017%2C3%2017%2C2%2015%2C2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%209L4%209%203%208%202%208%202%209%202%209%202%209%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%207%2C11%20C%206%2C11%206%2C10.6%206%2C10%20v%201%20c%200%2C0.6%200%2C1%201%2C1%20v%20-1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22m%2018%2C11%20v%201%20c%201%2C0%201%2C-0.4%201%2C-1%20v%20-1%20c%200%2C0.6%200%2C1%20-1%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19%206H20V7H19z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M3%2011L1%2011%201%2012%203%2012%203%2011%205%2011%205%207%205%207%205%2010%203%2010z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16%2013H18V14H16z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5%206H6V7H5z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2013L7%2013%207%2014%209%2014%209%2012%2016%2012%2016%2011%209%2011z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Cg%20fill%3D%22%232e2e2e%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%202%2C6%20C%202%2C6.4%202%2C6.7%202%2C7%20H%205%20V%206%20H%202%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2%209L2%2010%204%2010%203%209z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%204%2C3%20H%206%20V%202%20H%204%20C%201%2C2%201%2C5%201%2C6%20H%200%20V%207%20H%201%20C%201%2C6%201%2C3%204%2C3%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2018%2C4%20C%2018%2C3%2017%2C0%2015%2C0%20H%2012%2010%20C%208%2C0%207%2C3%207%2C4%20H%206%205%20V%205%20H%207%20C%207%2C4%208%2C1%2010%2C1%20h%202%203%20c%202%2C0%203%2C3%203%2C4%20h%202%20V%204%20h%20-2%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%208%2C10%20H%209%20C%209.6%2C10%2010%2C9.6%2010%2C9%2010%2C8.8%209.9%2C8.6%209.8%2C8.5%209.7%2C8.8%209.4%2C9%209%2C9%20H%208%20C%207.6%2C9%207.3%2C8.8%207.2%2C8.5%207.1%2C8.6%207%2C8.8%207%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017%2C6%20C%2017%2C5.6%2017%2C5.3%2017%2C5%20H%208%20c%200%2C0.3%200%2C0.6%200%2C1%20h%209%20z%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M%2017.8%2C8.5%20C%2017.7%2C8.8%2017.4%2C9%2017%2C9%20H%2016%20C%2015.6%2C9%2015.3%2C8.8%2015.2%2C8.5%2015.1%2C8.6%2015%2C8.8%2015%2C9%20c%200%2C0.6%200.4%2C1%201%2C1%20h%201%20c%200.6%2C0%201%2C-0.4%201%2C-1%200%2C-0.2%20-0.1%2C-0.4%20-0.2%2C-0.5%20z%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_traffic:hover:after{background-image:none}a.dg-traffic-control{z-index:0;color:#f2f2f2;text-decoration:none;text-shadow:0 1px 2px rgba(0,0,0,.3);font:400 15px/32px 'Arial narrow',Arial,sans-serif}a.dg-traffic-control_color_green:after,a.dg-traffic-control_color_red:after,a.dg-traffic-control_color_yellow:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;margin:auto;width:22px;height:22px;border-radius:50%;-webkit-box-shadow:inset 0 1px 0 0 rgba(0,0,0,.2),0 1px 0 0 #fff;box-shadow:inset 0 1px 0 0 rgba(0,0,0,.2),0 1px 0 0 #fff}.no-touch a.dg-traffic-control:hover{color:#f2f2f2}.no-touch a.dg-traffic-control_color_green:hover:after,.no-touch a.dg-traffic-control_color_red:hover:after,.no-touch a.dg-traffic-control_color_yellow:hover:after{width:22px;height:22px}a.dg-traffic-control_color_green:after{background:#3fc03b}.no-touch a.dg-traffic-control_color_green:hover:after,a.dg-traffic-control_color_green:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#2aa731),to(#53e13a)) #3ec435;background:-webkit-linear-gradient(bottom,#2aa731,#53e13a) #3ec435;background:linear-gradient(to top,#2aa731,#53e13a) #3ec435}a.dg-traffic-control_color_yellow:after{background:#f3b223}.no-touch a.dg-traffic-control_color_yellow:hover:after,a.dg-traffic-control_color_yellow:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#ef931b),to(#f7be26)) #f4a820;background:-webkit-linear-gradient(bottom,#ef931b,#f7be26) #f4a820;background:linear-gradient(to top,#ef931b,#f7be26) #f4a820}a.dg-traffic-control_color_red:after{background:#eb240c}.no-touch a.dg-traffic-control_color_red:hover:after,a.dg-traffic-control_color_red:active:after{background:-webkit-gradient(linear,left bottom,left top,from(#c01c0a),to(#f73416)) #db2811;background:-webkit-linear-gradient(bottom,#c01c0a,#f73416) #db2811;background:linear-gradient(to top,#c01c0a,#f73416) #db2811}.leaflet-rulerMarker-pane{z-index:600}.dg-ruler__label{position:absolute;top:0;left:0;z-index:200}.dg-ruler__label-spacer{display:block}.dg-ruler__label-container{display:none;padding:2px 4px;border:4px solid #fff;border-radius:13px;background:#0da5d5;background-clip:padding-box;color:#fff;white-space:nowrap;font-size:12px}.dg-ruler__point{display:inline-block;margin:2px 4px 0 0;width:10px;height:10px;border-radius:5px;background:#fff}.dg-ruler__label-remove-link{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%206%2C0%20C%202.687%2C0%200%2C2.687%200%2C6%200%2C9.313%202.687%2C12%206%2C12%209.313%2C12%2012%2C9.313%2012%2C6%2012%2C2.687%209.313%2C0%206%2C0%20z%20M%209.401%2C9.398%208.8%2C9.6%206%2C6.8%203.199%2C9.6%202.59%2C9.415%202.375%2C8.774%205.199%2C6%202.399%2C3.175%202.62%2C2.591%203.175%2C2.375%205.949%2C5.225%208.774%2C2.375%209.415%2C2.605%209.566%2C3.196%206.824%2C6%209.6%2C8.8%209.401%2C9.398%20z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:12px;height:12px;background-size:12px 12px;display:none;margin:1px 0 0 4px;vertical-align:top;-webkit-transition:all .2s ease;transition:all .2s ease}.no-touch .dg-ruler__label-remove-link:hover{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.dg-ruler__remove-link-overlay{position:absolute;top:-7px;right:-7px;bottom:-7px;width:40px}.no-touch .dg-ruler__remove-link-overlay{display:none}.dg-control-round__icon_name_ruler:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.998%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%23616161%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%23444%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%23444%22%2F%3E%0A%3C%2Fsvg%3E%0A);width:16px;height:9px;background-size:16px 9px;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto}.dg-control-round__icon_name_ruler:active:after,.no-touch .dg-control-round__icon_name_ruler:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.998%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%23424242%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%232e2e2e%22%2F%3E%0A%3C%2Fsvg%3E%0A)}.dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:active:after,.dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:after,.no-touch .dg-control-round__icon_state_active.dg-control-round__icon_name_ruler:hover:after{background-repeat:no-repeat;background-image:url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%229%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%2012.999%2C0%20v%204.001%20h%20-1%20V%200%20h%20-2%20v%202%20h%20-1%20V%200%20h%20-2%20V%202%20H%206%20V%200%20H%203.999%20v%204.001%20h%20-1%20V%200%20h%20-3%20V%208%20H%2016%20V%200%20z%22%20fill%3D%22%2321a7d6%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22m%202.999%2C4%20h%201%20v%201%20h%20-1%20z%20m%203%2C-2%20h%201%20v%201%20h%20-1%20z%20m%203%2C0%20h%201%20v%201%20h%20-1%20z%20m%203%2C2%20h%201%20v%201%20h%20-1%20z%22%20fill%3D%22%23147596%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C8%20H%2016%20V%209%20H%200%20z%22%20fill%3D%22%23fff%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M%200%2C0%20H%203%20V%201%20H%200%20z%20m%2013%2C0%20h%203%20v%201%20h%20-3%20z%20m%20-3%2C0%20h%202%20V%201%20H%2010%20z%20M%207%2C0%20H%209%20V%201%20H%207%20z%20M%204%2C0%20H%206%20V%201%20H%204%20z%22%20fill%3D%22%23147596%22%2F%3E%0A%3C%2Fsvg%3E%0A)}";
	t("browserify-css").createStyle(o,{href:"dist/css/styles.full.dark.css"},{insertAt:"bottom"}),e.exports=o},{"browserify-css":3}],2:[function(_dereq_,module,exports){(function(process){"function"!=typeof Array.prototype.reduce&&(Array.prototype.reduce=function(t,e){"use strict";if(null===this||"undefined"==typeof this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof t)throw new TypeError(t+" is not a function");var i,o,n=this.length>>>0,r=!1;for(1<arguments.length&&(o=e,r=!0),i=0;n>i;++i)this.hasOwnProperty(i)&&(r?o=t(o,this[i],i,this):(o=this[i],r=!0));if(!r)throw new TypeError("Reduce of empty array with no initial value");return o}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){"use strict";var i,o;if(null==this)throw new TypeError("this is null or not defined");var n,r=Object(this),s=r.length>>>0;if("[object Function]"!=={}.toString.call(t))throw new TypeError(t+" is not a function");for(arguments.length>=2&&(i=e),o=0;o<s;)o in r&&(n=r[o],t.call(i,n,o,r)),o++}),Object.keys||(Object.keys=function(){"use strict";var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),i=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],o=i.length;return function(n){if("object"!=typeof n&&("function"!=typeof n||null===n))throw new TypeError("Object.keys called on non-object");var r,s,a=[];for(r in n)t.call(n,r)&&a.push(r);if(e)for(s=0;s<o;s++)t.call(n,i[s])&&a.push(i[s]);return a}}()),Array.prototype.some||(Array.prototype.some=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=arguments.length>=2?arguments[1]:void 0,n=0;n<i;n++)if(n in e&&t.call(o,e[n],n,e))return!0;return!1}),Array.prototype.map||(Array.prototype.map=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=new Array(i),n=arguments.length>=2?arguments[1]:void 0,r=0;r<i;r++)r in e&&(o[r]=t.call(n,e[r],r,e));return o}),Array.prototype.filter||(Array.prototype.filter=function(t){"use strict";if(void 0===this||null===this)throw new TypeError;var e=Object(this),i=e.length>>>0;if("function"!=typeof t)throw new TypeError;for(var o=[],n=arguments.length>=2?arguments[1]:void 0,r=0;r<i;r++)if(r in e){var s=e[r];t.call(n,s,r,e)&&o.push(s)}return o}),Function.prototype.bind||(Function.prototype.bind=function(t){if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var e=Array.prototype.slice.call(arguments,1),i=this,o=function(){},n=function(){return i.apply(this instanceof o&&t?this:t,e.concat(Array.prototype.slice.call(arguments)))};return o.prototype=this.prototype,n.prototype=new o,n}),Array.prototype.indexOf||(Array.prototype.indexOf=function(t,e){if(void 0===this||null===this)throw new TypeError('"this" is null or not defined');var i=this.length>>>0;for(e=+e||0,Math.abs(e)===1/0&&(e=0),e<0&&(e+=i,e<0&&(e=0));e<i;e++)if(this[e]===t)return e;return-1}),"function"!=typeof Promise&&!function(){var t,e,i,o;!function(){var n={},r={};t=function(t,e,i){n[t]={deps:e,callback:i}},o=i=e=function(t){function i(e){if("."!==e.charAt(0))return e;for(var i=e.split("/"),o=t.split("/").slice(0,-1),n=0,r=i.length;n<r;n++){var s=i[n];if(".."===s)o.pop();else{if("."===s)continue;o.push(s)}}return o.join("/")}if(o._eak_seen=n,r[t])return r[t];if(r[t]={},!n[t])throw new Error("Could not find module "+t);for(var s,a=n[t],l=a.deps,u=a.callback,c=[],h=0,d=l.length;h<d;h++)"exports"===l[h]?c.push(s={}):c.push(e(i(l[h])));var p=u.apply(this,c);return r[t]=s||p}}(),t("promise/all",["./utils","exports"],function(t,e){"use strict";function i(t){var e=this;if(!o(t))throw new TypeError("You must pass an array to all.");return new e(function(e,i){function o(t){return function(e){r(t,e)}}function r(t,i){a[t]=i,0===--l&&e(a)}var s,a=[],l=t.length;0===l&&e([]);for(var u=0;u<t.length;u++)s=t[u],s&&n(s.then)?s.then(o(u),i):r(u,s)})}var o=t.isArray,n=t.isFunction;e.all=i}),t("promise/asap",["exports"],function(t){"use strict";function e(){return function(){process.nextTick(n)}}function i(){var t=0,e=new l(n),i=document.createTextNode("");return e.observe(i,{characterData:!0}),function(){i.data=t=++t%2}}function o(){return function(){u.setTimeout(n,1)}}function n(){for(var t=0;t<c.length;t++){var e=c[t],i=e[0],o=e[1];i(o)}c=[]}function r(t,e){var i=c.push([t,e]);1===i&&s()}var s,a="undefined"!=typeof window?window:{},l=a.MutationObserver||a.WebKitMutationObserver,u=window,c=[];s="undefined"!=typeof process&&"[object process]"==={}.toString.call(process)?e():l?i():o(),t.asap=r}),t("promise/config",["exports"],function(t){"use strict";function e(t,e){return 2!==arguments.length?i[t]:void(i[t]=e)}var i={instrument:!1};t.config=i,t.configure=e}),t("promise/polyfill",["./promise","./utils","exports"],function(t,e,i){"use strict";function o(){var t;t="undefined"!=typeof window&&window.document?window:self;var e="Promise"in t&&"resolve"in t.Promise&&"reject"in t.Promise&&"all"in t.Promise&&"race"in t.Promise&&function(){var e;return new t.Promise(function(t){e=t}),r(e)}();e||(t.Promise=n)}var n=t.Promise,r=e.isFunction;i.polyfill=o}),t("promise/promise",["./config","./utils","./all","./race","./resolve","./reject","./asap","exports"],function(t,e,i,o,n,r,s,a){"use strict";function l(t){if(!C(t))throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");if(!(this instanceof l))throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");this._subscribers=[],u(t,this)}function u(t,e){function i(t){_(e,t)}function o(t){f(e,t)}try{t(i,o)}catch(n){o(n)}}function c(t,e,i,o){var n,r,s,a,l=C(i);if(l)try{n=i(o),s=!0}catch(u){a=!0,r=u}else n=o,s=!0;p(e,n)||(l&&s?_(e,n):a?f(e,r):t===E?_(e,n):t===G&&f(e,n))}function h(t,e,i,o){var n=t._subscribers,r=n.length;n[r]=e,n[r+E]=i,n[r+G]=o}function d(t,e){for(var i,o,n=t._subscribers,r=t._detail,s=0;s<n.length;s+=3)i=n[s],o=n[s+e],c(e,i,o,r);t._subscribers=null}function p(t,e){var i,o=null;try{if(t===e)throw new TypeError("A promises callback cannot return that same promise.");if(b(e)&&(o=e.then,C(o)))return o.call(e,function(o){return!!i||(i=!0,void(e!==o?_(t,o):m(t,o)))},function(e){return!!i||(i=!0,void f(t,e))}),!0}catch(n){return!!i||(f(t,n),!0)}return!1}function _(t,e){t===e?m(t,e):p(t,e)||m(t,e)}function m(t,e){t._state===z&&(t._state=P,t._detail=e,y.async(g,t))}function f(t,e){t._state===z&&(t._state=P,t._detail=e,y.async(v,t))}function g(t){d(t,t._state=E)}function v(t){d(t,t._state=G)}var y=t.config,b=(t.configure,e.objectOrFunction),C=e.isFunction,w=(e.now,i.all),x=o.race,k=n.resolve,D=r.reject,L=s.asap;y.async=L;var z=void 0,P=0,E=1,G=2;l.prototype={constructor:l,_state:void 0,_detail:void 0,_subscribers:void 0,then:function(t,e){var i=this,o=new this.constructor(function(){});if(this._state){var n=arguments;y.async(function(){c(i._state,o,n[i._state-1],i._detail)})}else h(this,o,t,e);return o},"catch":function(t){return this.then(null,t)}},l.all=w,l.race=x,l.resolve=k,l.reject=D,a.Promise=l}),t("promise/race",["./utils","exports"],function(t,e){"use strict";function i(t){var e=this;if(!o(t))throw new TypeError("You must pass an array to race.");return new e(function(e,i){for(var o,n=0;n<t.length;n++)o=t[n],o&&"function"==typeof o.then?o.then(e,i):e(o)})}var o=t.isArray;e.race=i}),t("promise/reject",["exports"],function(t){"use strict";function e(t){var e=this;return new e(function(e,i){i(t)})}t.reject=e}),t("promise/resolve",["exports"],function(t){"use strict";function e(t){if(t&&"object"==typeof t&&t.constructor===this)return t;var e=this;return new e(function(e){e(t)})}t.resolve=e}),t("promise/utils",["exports"],function(t){"use strict";function e(t){return i(t)||"object"==typeof t&&null!==t}function i(t){return"function"==typeof t}function o(t){return"[object Array]"===Object.prototype.toString.call(t)}var n=Date.now||function(){return(new Date).getTime()};t.objectOrFunction=e,t.isFunction=i,t.isArray=o,t.now=n}),e("promise/polyfill").polyfill()}(),_dereq_("leaflet"),_dereq_("html5shiv");var oldDG=window.DG,DG=new(function(){var t=function(){},e=function(){};return e.prototype=L,t.prototype=new e,t}());for(var prop in oldDG)oldDG.hasOwnProperty(prop)&&"undefined"==typeof DG[prop]&&(DG[prop]=oldDG[prop]);window.__dgApi__=window.__dgApi__||{},DG.version=window.__dgApi__.version,DG.Icon.Default.imagePath="../img/vendors/leaflet",DG.Map.addInitHook(function(){var t=!1;return function(){t||(!function(t,e,i,o,n,r,s){t.GoogleAnalyticsObject=n,t[n]=t[n]||function(){(t[n].q=t[n].q||[]).push(arguments)},t[n].l=1*new Date,r=e.createElement(i),s=e.getElementsByTagName(i)[0],r.async=1,r.src=o,s.parentNode.insertBefore(r,s)}(window,document,"script",DG.config.googleAnalytics,"ga"),t=!0),ga("create",DG.config.gaCode,{storage:"none",name:DG.config.gaName,sampleRate:50}),ga(DG.config.gaName+".set","anonymizeIp",!0),ga(DG.config.gaName+".send","pageview")}}()),DG.Map.include({addHandler:function(t,e){if(!e)return this;var i=this.options[t],o=i===Object(i)?i:null,n=this[t]=new e(this,o);return this._handlers.push(n),i&&n.enable(),this}}),DG.Map.addInitHook(function(){DG.Browser.touchEnabled||DG.DomUtil.addClass(this._container,"no-touch")}),window.DG=DG,module.exports=DG;var handlers=window.__dgApi__.callbacks||[],chain=Promise.resolve();handlers.forEach(function(t){chain=chain.then(t[0],t[1])}),DG.then=function(t,e){return chain.then(t,e)},chain["catch"](function(t){console.error(t)}),DG.plugin=function(t){var e,i=new RegExp(/.js$/i),o=new RegExp(/.css$/i);return new Promise(function(n){function r(){e--,0===e&&n()}function s(t){var e=document.createElement("script");e.setAttribute("type","text/javascript"),e.setAttribute("src",t),e.onload=function(){r()},e.onerror=function(){r()},e.onreadystatechange=function(){"complete"!==e.readyState&&"loaded"!==e.readyState||r()},document.getElementsByTagName("head")[0].appendChild(e)}function a(t){var e=document.createElement("link");e.setAttribute("rel","stylesheet"),e.setAttribute("type","text/css"),e.setAttribute("href",t),document.getElementsByTagName("head")[0].appendChild(e),r()}function l(t){return i.test(t)}function u(t){return o.test(t)}function c(t){l(t)?s(t):u(t)?a(t):e--}DG.Util.isArray(t)&&(e=t.length,t.forEach(function(t){c(t)})),"string"==typeof t&&(e=1,c(t))})},DG.ajax=function(){function handleReadyState(t,e,i){return function(){return t._aborted?i(t.request):void(t.request&&4===t.request[readyState]&&(t.request.onreadystatechange=noop,twoHundo.test(t.request.status)?e(t.request):i(t.request)))}}function setHeaders(t,e){var i,o=e.headers||{};o.Accept=o.Accept||defaultHeaders.accept[e.dataType]||defaultHeaders.accept["*"],e.crossDomain||o[requestedWith]||(o[requestedWith]=defaultHeaders.requestedWith),o[contentType]||(o[contentType]=e.contentType||defaultHeaders.contentType);for(i in o)o.hasOwnProperty(i)&&"setRequestHeader"in t&&t.setRequestHeader(i,o[i])}function setCredentials(t,e){"undefined"!=typeof e.withCredentials&&"undefined"!=typeof t.withCredentials&&(t.withCredentials=!!e.withCredentials)}function generalCallback(t){lastValue=t}function urlappend(t,e){return t+(/\?/.test(t)?"&":"?")+e}function handleJsonp(t,e,i,o){var n=uniqid++,r=t.jsonpCallback||"callback",s=t.jsonpCallbackName||callbackPrefix,a=new RegExp("((^|\\?|&)"+r+")=([^&]+)"),l=o.match(a),u=doc.createElement("script"),c=0,h=navigator.userAgent.indexOf("MSIE 10.0")!==-1;return l?"?"===l[3]?o=o.replace(a,"$1="+s):s=l[3]:o=urlappend(o,r+"="+s),win[s]=generalCallback,u.type="text/javascript",u.src=o,u.async=!0,"undefined"==typeof u.onreadystatechange||h||(u.event="onclick",u.htmlFor=u.id="_request_"+n),u.onerror=function(){u.onerror=u.onload=u.onreadystatechange=null,i({},"Request unknown error",{}),lastValue=void 0,head.removeChild(u),c=1},u.onload=u.onreadystatechange=function(){return!(u[readyState]&&"complete"!==u[readyState]&&"loaded"!==u[readyState]||c)&&(u.onerror=u.onload=u.onreadystatechange=null,u.onclick&&u.onclick(),e(lastValue),lastValue=void 0,head.removeChild(u),void(c=1))},head.appendChild(u),{abort:function(){u.onerror=u.onload=u.onreadystatechange=null,i({},"Request is aborted: timeout",{}),lastValue=void 0,head.removeChild(u),c=1}}}function getRequest(t,e){var i,o=this.options,n=(o.type||"GET").toUpperCase(),r="string"==typeof o?o:o.url,s=o.processData!==!1&&o.data&&"string"!=typeof o.data?Ajax.toQueryString(o.data):o.data||null,a=!1;return"jsonp"!==o.type&&"GET"!==n||!s||(r=urlappend(r,s),s=null),"jsonp"===o.type?handleJsonp(o,t,e,r):(i=xhr(o),i.open(n,r,o.async!==!1),setHeaders(i,o),setCredentials(i,o),win[xDomainRequest]&&i instanceof win[xDomainRequest]?(i.onload=t,i.onprogress=function(){},i.ontimeout=function(){},i.onerror=e,a=!0):i.onreadystatechange=handleReadyState(this,t,e),a?setTimeout(function(){i.send(s)},200):i.send(s),i)}function buildParams(t,e,i,o){var n,r,s,a=/\[\]$/;if(DG.Util.isArray(e))for(r=0;e&&r<e.length;r++)s=e[r],i||a.test(t)?o(t,s):buildParams(t+"["+("object"==typeof s?r:"")+"]",s,i,o);else if(e&&"[object Object]"===e.toString())for(n in e)e.hasOwnProperty(n)&&buildParams(t+"["+n+"]",e[n],i,o);else o(t,e)}function setType(t){var e=t.match(/\.(json|jsonp|html|xml)(\?|$)/);return e?e[1]:"js"}function isCrossDomain(t){var e=rurl.exec(t.toLowerCase());return!(!e||e[1]===ajaxLocParts[1]&&e[2]===ajaxLocParts[2]&&(e[3]||("http:"===e[1]?"80":"443"))===(ajaxLocParts[3]||("http:"===ajaxLocParts[1]?"80":"443")))}function doRequest(o){"crossDomain"in o||(o.crossDomain=isCrossDomain(o.url));var self={};return self.promise=new Promise(function(resolve,reject){function complete(t){o.timeout&&clearTimeout(self.timeout),self.timeout=null,self._erred?reject(t):resolve(t)}function success(resp){resp="jsonp"!==type?self.request:resp;var filteredResponse=globalSetupOptions.dataFilter(resp.responseText,type),r=filteredResponse;try{resp.responseText=r}catch(e){}if(r)switch(type){case"json":try{resp=win.JSON.parse(r)}catch(err){return error(resp,"Could not parse JSON in response",err)}break;case"js":resp=eval("("+r+")");break;case"html":resp=r;break;case"xml":resp=resp.responseXML&&resp.responseXML.parseError&&resp.responseXML.parseError.errorCode&&resp.responseXML.parseError.reason?null:resp.responseXML}self._responseArgs.resp=resp,complete(resp)}function error(t,e,i){t=self.request,self._responseArgs.resp=t,self._responseArgs.msg=e,self._responseArgs.t=i,self._erred=!0,complete(t)}self.abort=function(){self._aborted=!0,reject("aborted")},self.url=o.url,self.timeout=null,self.options=o,self._aborted=!1,self._erred=!1,self._responseArgs={};var type="jsonp"===o.type?o.type:o.dataType||setType(self.url);o.timeout&&(self.timeout=setTimeout(function(){self.abort()},o.timeout)),self.request=getRequest.call(self,success,error)}),self}function Ajax(t,e){"[object Object]"===Object.prototype.toString.call(t)&&(e=t,t=void 0),e=e||{},e.url=t||e.url;var i=doRequest(e),o=i.promise;return(e.success||e.error||e.complete)&&o.then(e.success,e.error),o.abort=i.abort,o}var win=window,doc=document,rurl=/^([\w.+-]+:)?(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,twoHundo=/^20\d$/,ajaxLocParts,ajaxLocation,byTag="getElementsByTagName",readyState="readyState",contentType="Content-Type",requestedWith="X-Requested-With",head=doc[byTag]("head")[0],uniqid=0,callbackPrefix="l_dg_ajax_callback_"+ +new Date,lastValue,xmlHttpRequest="XMLHttpRequest",xDomainRequest="XDomainRequest",noop=function(){},defaultHeaders={contentType:"application/x-www-form-urlencoded",requestedWith:xmlHttpRequest,accept:{"*":"text/javascript, text/html, application/xml, text/xml, */*",xml:"application/xml, text/xml",html:"text/html",text:"text/plain",json:"application/json, text/javascript",js:"application/javascript, text/javascript"}},xhr=function(t){if(t.crossDomain===!0){var e=win[xmlHttpRequest]?new XMLHttpRequest:null;if(e&&"withCredentials"in e)return e;if(win[xDomainRequest])return new XDomainRequest;throw new Error("Browser does not support cross-origin requests")}return new XMLHttpRequest},globalSetupOptions={dataFilter:function(t){return t}};try{ajaxLocation=location.href}catch(e){ajaxLocation=document.createElement("a"),ajaxLocation.href="",ajaxLocation=ajaxLocation.href}ajaxLocParts=rurl.exec(ajaxLocation.toLowerCase())||[],Ajax.setup=function(t){t=t||{};for(var e in t)t.hasOwnProperty(e)&&(globalSetupOptions[e]=t[e])},Ajax.toQueryString=function(t,e){var i,o,n=e||!1,r=[],s=encodeURIComponent,a=function(t,e){e="function"==typeof e?e():e||"",r[r.length]=s(t)+"="+s(e)};if(DG.Util.isArray(t))for(o=0;t&&o<t.length;o++)a(t[o].name,t[o].value);else for(i in t)t.hasOwnProperty(i)&&buildParams(i,t[i],n,a);return r.join("&").replace(/%20/g,"+")};var testxhr=win[xmlHttpRequest]?new XMLHttpRequest:null;return Ajax.corsSupport=!(!(testxhr&&"withCredentials"in testxhr||win[xDomainRequest])||DG.Browser.ie&&document.location.host.toLowerCase().search(/[а-я]/)!=-1),Ajax}(),DG.Wkt={},DG.Wkt.toGeoJSON=function(t){function e(e){var i=t.substring(m).match(e);return i?(m+=i[0].length,i[0]):null}function i(t){return t&&f.match(/\d+/)&&(t.crs={type:"name",properties:{name:"urn:ogc:def:crs:EPSG::"+f}}),t}function o(){e(/^\s*/)}function n(){o();for(var t,i=0,n=[],r=[n],s=n;t=e(/^(\()/)||e(/^(\))/)||e(/^(\,)/)||e(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/);){if("("===t)r.push(s),s=[],r[r.length-1].push(s),i++;else if(")"===t){if(s=r.pop(),i--,0===i)break}else","===t?(s=[],r[r.length-1].push(s)):s.push(parseFloat(t));o()}return r.length=0,0!==i?null:n}function r(){for(var t,i,n=[];i=e(/^[-+]?([0-9]*\.[0-9]+|[0-9]+)/)||e(/^(\,)/);)","===i?(n.push(t),t=[]):(t||(t=[]),t.push(parseFloat(i))),o();return t&&n.push(t),n.length?n:null}function s(){if(!e(/^(point)/i))return null;if(o(),!e(/^(\()/))return null;var t=r();return o(),e(/^(\))/)?{type:"Point",coordinates:t[0]}:null}function a(){if(!e(/^(multipoint)/i))return null;o();var t=n();return o(),{type:"MultiPoint",coordinates:t}}function l(){if(!e(/^(multilinestring)/i))return null;o();var t=n();return o(),{type:"MultiLineString",coordinates:t}}function u(){if(!e(/^(linestring)/i))return null;if(o(),!e(/^(\()/))return null;var t=r();return e(/^(\))/)?{type:"LineString",coordinates:t}:null}function c(){return e(/^(polygon)/i)?(o(),{type:"Polygon",coordinates:n()}):null}function h(){return e(/^(multipolygon)/i)?(o(),{type:"MultiPolygon",coordinates:n()}):null}function d(){var t,i=[];if(!e(/^(geometrycollection)/i))return null;if(o(),!e(/^(\()/))return null;for(;t=p();)i.push(t),o(),e(/^(\,)/),o();return e(/^(\))/)?{type:"GeometryCollection",geometries:i}:null}function p(){return s()||u()||c()||a()||l()||h()||d()}DG.Util.isArray(t)&&(t=t[0]);var _=t.split(";");t=_.pop();var m=0,f=(_.shift()||"").split("=").pop();return i(p())},DG.Wkt.geoJsonLayer=function(t,e){return DG.geoJson(DG.Wkt.toGeoJSON(t),e)},DG.Wkt._coordsToLatLngs=function(t){return DG.Util.isArray(t)&&!DG.Util.isArray(t[0])?[DG.GeoJSON.coordsToLatLng(t)]:t.map(function(t){return DG.Wkt._coordsToLatLngs(t)}).reduce(function(t,e){return t.concat(e)})},DG.Wkt.toLatLngs=function(t){return DG.Util.isArray(t)||(t=[t]),t.map(function(t){var e=DG.Wkt.toGeoJSON(t).coordinates;return DG.Wkt._coordsToLatLngs(e)}).reduce(function(t,e){return t.concat(e)})},DG.Wkt.toPoints=function(t){return DG.Wkt.toGeoJSON(t).coordinates},DG.Wkt.pointsToLatLngOnMap=function(t,e){return function i(t){return Array.isArray(t)&&Array.isArray(t[0])?t.map(i):e.containerPointToLatLng(t)}(DG.Wkt.toPoints(t))},DG.ProjectDetector=DG.Handler.extend({initialize:function(t){this._map=t,this._osmViewport=!1,this._project=void 0,this._loadProjectList()},addHooks:function(){this._projectWatch(),this._map.on("move",this._projectWatch,this)},removeHooks:function(){this._map.off("move",this._projectWatch,this)},getProject:function(){return!!this._project&&DG.Util.extend({},this._project)},getProjectsList:function(){return this._projectList.slice(0)},isProjectHere:function(t,e,i){if(!t)return null;t instanceof DG.LatLng||t instanceof DG.LatLngBounds||(t=DG.latLng(t)),t=t instanceof DG.LatLngBounds?DG.latLngBounds(t.getSouthWest().wrap(),t.getNorthEast().wrap()):t.wrap(),i=i||(t instanceof DG.LatLngBounds?"intersects":"contains");var o="intersects"==i?this._testProjectIntersects:this._testProjectContains;return o=o.bind(this,t),e?o(e):this._projectList.filter(o)[0]},_projectWatch:function(){this._map._loaded&&(this._osmViewport===(this._project&&this._centerInProject(this._project,"contains"))&&(this._osmViewport=!this._osmViewport,this._map.attributionControl._update(null,this._osmViewport)),this._project&&this._zoomInProject(this._project)&&this._centerInProject(this._project)||(this._searchProject(),this._project&&(this._osmViewport===(this._project&&this._centerInProject(this._project,"contains"))&&(this._osmViewport=!this._osmViewport),this._map.attributionControl._update(null,this._osmViewport,this._project.country_code))))},_checkProjectData:function(t){function e(t){return void 0!==t&&null!==t}return t&&t.bounds&&e(t.code)&&e(t.domain)&&e(t.country_code)&&e(t.flags)&&t.zoom_level&&e(t.zoom_level.min)&&e(t.zoom_level.max)&&t.time_zone&&e(t.time_zone.offset)},_loadProjectList:function(){DG.fallbackProjectsList=DG.fallbackProjectsList||[],DG.projectsList||(DG.projectsList=DG.fallbackProjectsList),delete DG.fallbackProjectsList,this._projectList=DG.projectsList.filter(this._checkProjectData).map(function(t){var e=DG.Wkt.toGeoJSON(t.bounds),i=DG.geoJSON(e).getBounds(),o=t.default_pos?DG.latLng(t.default_pos.lat,t.default_pos.lon):null;return{id:t.id,code:t.code,minZoom:t.zoom_level.min,maxZoom:t.zoom_level.max,timeOffset:t.time_zone.offset,bound:e,latLngBounds:i,traffic:!!t.flags.traffic,transport:!!t.flags.public_transport,roads:!!t.flags.road_network,country_code:t.country_code,domain:t.domain,defaultPos:o}})},_searchProject:function(){var t=this._projectList.filter(this._zoomInProject,this),e=t.filter(this._centerInProject,this);if(0===e.length){var i=this._map.getBounds();if(e=t.filter(DG.bind(this._testProjectIntersects,this,i)),e.length>1){for(var o=this._map.getCenter(),n=e[0],r=1;r<e.length;r++){var s=e[r];s.defaultPos&&o.distanceTo(n.defaultPos)>o.distanceTo(s.defaultPos)&&(n=s)}e=[n]}}var a=e[0]||null;if(this._project!==a){var l=this;null!==this._project&&(this._project=null,setTimeout(function(){l._map.fire("projectleave")},1)),a&&(this._project=a,setTimeout(function(){l._map.fire("projectchange",{getProject:l.getProject.bind(l)})},1))}},_testProjectIntersects:function(t,e){return e.latLngBounds.intersects(t)},_testProjectContains:function(t,e){return DG.PolyUtil.inside([t.lng,t.lat],e.bound)},_centerInProject:function(t,e){return this.isProjectHere(this._map.getCenter(),t,e)},_zoomInProject:function(t){return this._map.getZoom()>=t.minZoom}}),DG.Map.mergeOptions({projectDetector:!0}),DG.Map.addInitHook("addHandler","projectDetector",DG.ProjectDetector),DG.Metric=function(){},DG.Metric.Segments=function(){this.length=0},DG.Metric.Segments.prototype={push:function(t){return this[this.length]=this.length>0?this[this.length-1]+t:t,this.length+=1,this},getLength:function(){return this[this.length-1]},getReverse:function(){var t=new DG.Metric.Segments,e=this.length-1;if(e<0)return t;for(;e--;)t.push(this[e+1]-this[e]);return t.push(this[0])},getIndex:function(t){var e=this.length-1;if(e<0)return e;for(;e--&&!(this[e]<=t););return e+1},getSegRatio:function(t){var e=this.getIndex(t),i=e>0?this[e-1]:0;return(t-i)/(this[e]-i)},getSegLength:function(t){var e=this.getIndex(t),i=e>0?this[e-1]:0;return t-i}},DG.VertexTransform=DG.Class.extend({initialize:function(t){this._vertices=t,this._scale=null,this._angle=null,this._trans=null,this._matrix=null,this.load()},load:function(){return this.vertices=this._vertices.map(function(t){return t.clone()}),this.vertices.clone=DG.VertexTransform.clone,this},save:function(){return this._vertices=this.vertices.map(function(t){return t.clone()}),this},setScale:function(t){return this._scale=t,this},getScale:function(){return this._scale},setAngle:function(t){return this._angle=t,this},getAngle:function(){return this._angle},setTranslation:function(t){return this._trans=t,this},getTranslation:function(){return this._trans},setMatrix:function(t){return this._matrix=t,this},getMatrix:function(){return this._matrix},scale:function(t){var e=this.vertices,i=e.length;for(t=t||this._scale||1;i--;)e[i].x*=t,e[i].y*=t;return this},unScale:function(t){return t=t||this._scale||1,this.scale(1/t)},rotate:function(t){for(var e,i,o=t?t.cos:this._angle?this._angle.cos:1,n=t?t.sin:this._angle?this._angle.sin:0,r=this.vertices,s=r.length;s--;)e=r[s].x,i=r[s].y,r[s].x=e*o-i*n,r[s].y=e*n+i*o;return this},unRotate:function(t){var e=t?t.cos:this._angle?this._angle.cos:1,i=t?t.sin:this._angle?this._angle.sin:0;return this.rotate({cos:e,sin:-i})},translate:function(t){for(var e=t?t.x:this._trans?this._trans.x:0,i=t?t.y:this._trans?this._trans.y:0,o=this.vertices,n=o.length;n--;)o[n].x+=e,o[n].y+=i;return this},unTranslate:function(t){var e=t?t.x:this._trans?this._trans.x:0,i=t?t.y:this._trans?this._trans.y:0;return this.translate({x:-e,y:-i})},transform:function(t){var e,i,o,n,r,s,a,l,u=this.vertices,c=u.length;for(t?(e=t[0],i=t[1],r=t[2],o=t[3],n=t[4],s=t[5]):this._matrix?(e=this._matrix[0],i=this._matrix[1],r=this._matrix[2],o=this._matrix[3],n=this._matrix[4],s=this._matrix[5]):(e=1,i=0,r=0,o=0,n=1,s=0);c--;)a=u[c].x,l=u[c].y,u[c].x=a*e+l*i+r,u[c].y=a*o+l*n+s;return this},statics:{scale:function(t,e){var i,o,n=t.vertices,r=[];e=e||1;for(var s=0;s<n.length;s++)i=n[s].x*e,o=n[s].y*e,r.push(new DG.Point(i,o));return r.clone=DG.VertexTransform.clone,r},unScale:function(t,e){return e=e||1,DG.VertexTransform.scale(t,1/e)},rotate:function(t,e){for(var i,o,n,r,s=e?e.cos:1,a=e?e.sin:0,l=t.vertices,u=[],c=0;c<l.length;c++)n=l[c].x,r=l[c].y,i=n*s-r*a,o=n*a+r*s,u.push(new DG.Point(i,o));return u.clone=DG.VertexTransform.clone,u},unRotate:function(t,e){var i=e?e.cos:1,o=e?e.sin:0;return DG.VertexTransform.rotate(t,{cos:i,sin:-o})},translate:function(t,e){for(var i,o,n=e?e.x:0,r=e?e.y:0,s=t.vertices,a=[],l=0;l<s.length;l++)i=s[l].x+n,o=s[l].y+r,a.push(new DG.Point(i,o));return a.clone=DG.VertexTransform.clone,a},unTranslate:function(t,e){var i=e?e.x:0,o=e?e.y:0;return DG.VertexTransform.translate(t,{x:-i,y:-o})},clone:function(){return new DG.VertexTransform(this).save()},getLength:function(t,e){var i,o;return"number"==typeof t?Math.sqrt(t*t+e*e):(i=e.x-t.x,o=e.y-t.y,Math.sqrt(i*i+o*o))},getScaled:function(t,e,i){var o,n;return"number"==typeof t?new DG.Point(t*i,e*i):(o=(e.x-t.x)*i,n=(e.y-t.y)*i,new DG.Point(t.x+o,t.y+n))},getAngle:function(t,e,i){var o,n,r,s,a,l;return"number"==typeof t?(o=Math.sqrt(t*t+e*e),o>0?{cos:t/o,sin:e/o}:{cos:1,sin:0}):(r=t.x,s=t.y,a=e.x,l=e.y,i&&(r-=i.x,s-=i.y,a-=i.x,l-=i.y),n=Math.sqrt(r*r+s*s)*Math.sqrt(a*a+l*l),{cos:(r*a+s*l)/n,sin:(r*l-a*s)/n})},getAnglesSum:function(t,e){return{cos:t.cos*e.cos-t.sin*e.sin,sin:t.sin*e.cos+t.cos*e.sin}},getAnglesDif:function(t,e){return{cos:t.cos*e.cos+t.sin*e.sin,sin:t.sin*e.cos-t.cos*e.sin}}}}),DG.ArrowPathTransform=DG.VertexTransform.extend({initialize:function(t){this._lengths=new DG.Metric.Segments,this._vertices=[[],[]],this._drawings=[[],[]],this._setPath(t),this.subPath(1)},load:function(){return this.subPath(1)},save:function(){return this},_setPath:function(t){var e,i,o,n,r,s,a,l=DG.ArrowPathTransform.transform,u=this._vertices,c=this._drawings,h=DG.Point,d=t.width,p=[[],[],[]],_=[];for(u.push(t.vertices),u[0].push(new DG.Point(t.offset,(+d))),u[1].push(new DG.Point(t.offset,(-d))),s=DG.ArrowPathTransform.getAngles(t),r=-t.offset,e=0;e<s.length;e++)i=t.vertices[e+1].x,o=d*s[e].cot,n=s[e].tan*d*8/3,o>0?(u[0].push(new h(i+o,(+d))),c[0].push("L"),p[2].push(1),p[1].push(u[1].length),u[1].push(new h(i+o,(-d))),u[1].push(new h(i+o-n,(-d))),l(u,s[e],{x:i,y:0}),u[1].push(new h(0-o+n,(-d))),u[1].push(new h(0-o,(-d))),c[1].push("L","C"),_.push(Math.abs(i+o)-r),r=+o):(u[1].push(new h(i-o,(-d))),c[1].push("L"),p[2].push(0),p[0].push(u[0].length),u[0].push(new h(i-o,(+d))),u[0].push(new h(i-o+n,(+d))),l(u,s[e],{x:i,y:0}),u[0].push(new h(0+o-n,(+d))),u[0].push(new h(0+o,(+d))),c[0].push("L","C"),_.push(Math.abs(i-o)-r),r=-o);o=t.vertices[e+1].x,n=4*d/3,u[0].push(new h(o,(+d))),u[1].push(new h(o,(-d))),u[0].push(new h(o-n,(+d))),u[1].push(new h(o-n,(-d))),c[0].push("L"),c[1].push("L"),_.push(Math.abs(o)-r),u[1].reverse(),c[1].reverse(),a=DG.VertexTransform.getAnglesSum(s.fullAngle,t.getAngle()),l(u,a,u.pop()[0]),o=u[0].length,n=u[1].length,this._arcs=p[2].map(function(t){return r=p[t].shift(),t>0?new DG.ArcBezier(u[1].slice(n-r-4,n-r)):new DG.ArcBezier(u[0].slice(r,r+4).reverse())}).reverse(),this._lengths.push(_.pop()),_.reverse().forEach(function(t,e){this._lengths.push(this._arcs[e].getLength()).push(t)},this),this[0]={vertices:[u[0][o-2],u[0][o-1],u[1][0],u[1][1]],drawings:["M","C"]},this[1]={vertices:u[0].concat(u[1]),drawings:["M"].concat(c[0],"C",c[1])}},_setAngleAndDisplacement:function(t,e){this.angle=DG.VertexTransform.getAngle({x:t.x-e.x,y:t.y-e.y},{x:0,y:1}),this.displ=e.clone()},subPath:function(t){if(t=t>1?1:t,0===t||1===t)return this.vertices=this[t].vertices.map(function(t){return t.clone()}),this.drawings=this[t].drawings,this._setAngleAndDisplacement(this.vertices[0],this.vertices[this.vertices.length-1]),this;for(var e,i,o=DG.VertexTransform.getScaled,n=this._vertices,r=this._drawings,s=this._lengths,a=s.getLength()*t,l=s.getIndex(a),u=s.getSegRatio(a),c=n[0].length-2,h=1,d=r[0].length-1,p=0,_=0,m=0;m++<l;)m%2==1?(c--,d--,h++,p++):("C"===r[0][d]?(c-=3,d-=1):(h+=3,p+=1),_++);return l%2==1?(_=this._arcs[_],"C"===r[0][d]?(_=_.getCurveBefore(_.getTbyL(s.getSegLength(a))),e=_.points[3],i=n[1][h],this.vertices=_.points.slice(1).reverse().concat(n[0].slice(c),n[1].slice(0,h+1)).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d),"C",r[1].slice(0,p))):(_=_.getCurveBefore(_.getTbyL(s.getSegLength(a))),e=n[0][c],i=_.points[3],this.vertices=n[0].slice(c).concat(n[1].slice(0,h+1),_.points.slice(1)).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d+1),"C",r[1].slice(0,p+1)))):(e=o(n[0][c],n[0][c-1],u),i=o(n[1][h],n[1][h+1],u),this.vertices=[e].concat(n[0].slice(c),n[1].slice(0,h+1),i).map(function(t){return t.clone()}),this.drawings=["M"].concat(r[0].slice(d),"C",r[1].slice(0,p+1))),this._setAngleAndDisplacement(e,i),this},statics:{getAngles:function(t){for(var e,i,o,n,r,s,a,l=DG.VertexTransform.getAngle,u={cos:1,sin:0},c=t.vertices,h=[],d=1,p=c.length-1;d<p;d++)i=l(c[d-1],c[d+1],c[d]),e=Math.abs(i.sin),e<1e-6?(c.splice(c.length-d-1,1),p--,d--):(i.cot=(1+i.cos)/i.sin,i.cos=-i.cos,r=(1+i.cos)/i.sin,a=r<0?-1:1,s=a*Math.sqrt(4*r*r+4),i.tan=-.5*(r+r-s),h.push(i),o=u.cos*i.cos-u.sin*i.sin,n=u.sin*i.cos+u.cos*i.sin,u={cos:o,sin:n});return h.fullAngle={cos:u.cos,sin:-u.sin},h},getTranslatedPath:function(t,e){var i=new DG.VertexTransform([]),o=e.length-1,n=t.project(e[o]),r=n.x,s=n.y;for(i.vertices.push(new DG.Point(0,0));o--;)n=t.project(e[o]),i.vertices.push(new DG.Point(n.x-r,n.y-s));return i.setAngle(DG.VertexTransform.getAngle(-i.vertices[1].x,-i.vertices[1].y)).unRotate()},transform:function(t,e,i){for(var o,n,r,s,a=t.length,l=e.cos,u=e.sin,c=i.x,h=i.y;a--;)for(o=t[a],s=o.length;s--;)n=o[s].x-c,r=o[s].y-h,o[s].x=n*l-r*u,o[s].y=n*u+r*l}}}),DG.ArrowTipTransform=DG.VertexTransform.extend({initialize:function(t,e){this.drawings=e.drawings,this._vertices=e.vertices,this._setShape(t,e)},_setShape:function(t,e){var i=e.vertices[0],o=Math.abs(i.y),n=t.vertices[1].x,r=i.x,s=n-r+o+o;t.width=o,t.offset=r+(s>0?s:0),t.vertices.length<3&&r>-10&&(t.offset+=2.5),this._vertices=this.load().unTranslate(i).vertices},subShape:function(t){return this.load().unRotate(t.angle).translate(t.displ),
	this}}),DG.ComplexPath=DG.Path.extend({options:{fill:!0,fillOpacity:1,interactive:!1},initialize:function(t){DG.setOptions(this,t),this._empty=[],this._pxEmpty=DG.bounds(DG.point(0,0),DG.point(0,0)),this._pxBounds=this._pxEmpty,this._vertices=[this._empty],this._drawings=[this._empty]},getEvents:function(){return{}},_project:function(){var t,e,i=this.options;this._map&&(t=this._map.getZoom(),i.visibility.isShown&&i.transform[t]?(e=2.2-.2*(19-t),i.weight!==e&&this.setStyle({weight:+e.toFixed(2)}),this._vertices[0]=i.transform[t].vertices,this._drawings[0]=i.transform[t].drawings,this._pxBounds=i.transform[t]._pxBounds):(this._vertices[0]=this._empty,this._drawings[0]=this._empty,this._pxBounds=this._pxEmpty))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateComplexPath(this)}}),DG.extend(L.Canvas.prototype,{_updateComplexPath:function(t,e){var i,o,n,r,s,a,l,u,c,h,d,p=t._drawings,_=t._vertices,m=this._ctx;for(this._drawnLayers[t._leaflet_id]=t,m.beginPath(),i=0;i<_.length;i++){for(d=_[i],s=a=0,o=n=0;o<d.length;)switch(r=p[i][n++]){case"M":s=d[o].x,a=d[o].y,o+=1,m.moveTo(s,a);break;case"m":s+=d[o].x,a+=d[o].y,o+=1,m.moveTo(s,a);break;case"L":s=d[o].x,a=d[o].y,o+=1,m.lineTo(s,a);break;case"l":s+=d[o].x,a+=d[o].y,o+=1,m.lineTo(s,a);break;case"C":l=d[o].x,u=d[o].y,o+=1,c=d[o].x,h=d[o].y,o+=1,s=d[o].x,a=d[o].y,o+=1,m.bezierCurveTo(l,u,c,h,s,a);break;case"c":l=s+d[o].x,u=a+d[o].y,o+=1,c=s+d[o].x,h=a+d[o].y,o+=1,s+=d[o].x,a+=d[o].y,o+=1,m.bezierCurveTo(l,u,c,h,s,a);break;case"Q":l=d[o].x,u=d[o].y,o+=1,s=d[o].x,a=d[o].y,o+=1,m.quadraticCurveTo(l,u,s,a);break;case"q":l=s+d[o].x,u=a+d[o].y,o+=1,s+=d[o].x,a+=d[o].y,o+=1,m.quadraticCurveTo(l,u,s,a)}e&&m.closePath()}this._fillStroke(m,t)}}),DG.extend(L.SVG.prototype,{_updateComplexPath:function(t,e){this._setPath(t,L.SVG.complexPointsToPath(t._vertices,t._drawings,e))}}),DG.extend(L.SVG,{complexPointsToPath:function(t,e,i){var o,n,r,s,a,l,u="",c=DG.Browser.svg;for(o=0;o<t.length;o++){if(l=t[o],c)for(n=r=0;n<l.length;){switch(a=e[o][r++]){case"C":case"c":s=3;break;case"Q":case"q":s=2;break;default:s=1}for(u+=a;s--;)u+=l[n].x.toFixed(4)+","+l[n].y.toFixed(4)+" ",n+=1}else for(n=r=0;n<l.length;){switch(a=e[o][r++]){case"M":a="m",s=1;break;case"m":a="t",s=1;break;case"L":a="l",s=1;break;case"l":a="r",s=1;break;case"C":a="c",s=3;break;case"c":a="v",s=3;break;case"Q":u+="C"+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n+1].x.toFixed(0)+","+l[n+1].y.toFixed(0)+" ",n+=2,a="",s=0;break;case"q":u+="c"+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" "+l[n+1].x.toFixed(0)+","+l[n+1].y.toFixed(0)+" ",n+=2,a="",s=0;break;default:s=1}for(u+=a;s--;)u+=l[n].x.toFixed(0)+","+l[n].y.toFixed(0)+" ",n+=1}u+=i?c?"z":"x":""}return u||"m0,0"}}),DG.Bezier=DG.Class.extend({initialize:function(t,e){e?this.points=t.map(function(t){return t.clone()}):this.points=t,this.dpoints=this._getDerivatives(),this.order=this.points.length-1,this._lut=[]},getPoint:function(t){var e,i,o,n,r,s,a,l=this.points;return 0===t?l[0]:1===t?l[this.order]:(e=1-t,i=e*e,o=t*t,this.order>2?(n=i*e,r=i*t*3,s=e*o*3,a=t*o):(l=[l[0],l[1],l[2],{x:0,y:0}],n=i,r=e*t*2,s=o,a=0),new DG.Point(n*l[0].x+r*l[1].x+s*l[2].x+a*l[3].x,n*l[0].y+r*l[1].y+s*l[2].y+a*l[3].y))},derivative:function(t){var e,i,o,n=this.dpoints[0],r=1-t;return this.order>2?(e=r*r,i=r*t*2,o=t*t):(n=[n[0],n[1],{x:0,y:0}],e=r,i=t,o=0),new DG.Point(e*n[0].x+i*n[1].x+o*n[2].x,e*n[0].y+i*n[1].y+o*n[2].y)},getLength:function(){for(var t,e,i,o=DG.Bezier.WEIGHT,n=DG.Bezier.ABSCISSA,r=.5,s=0,a=0;a<n.length;a++)i=r*n[a]+r,t=this.derivative(i),e=t.x*t.x+t.y*t.y,s+=o[a]*Math.sqrt(e);return r*s},getCurveBefore:function(t){var e,i,o,n,r,s,a,l,u,c=this.points;return 1===t?this.clone():(u=[],e=t*t,o=t-1,n=o*o,u[0]=new DG.Point(c[0].x,c[0].y),u[1]=new DG.Point(t*c[1].x-o*c[0].x,t*c[1].y-o*c[0].y),s=t*o*2,u[2]=new DG.Point(e*c[2].x-s*c[1].x+n*c[0].x,e*c[2].y-s*c[1].y+n*c[0].y),this.order>2&&(i=e*t,r=n*o,a=e*o*3,l=t*n*3,u[3]=new DG.Point(i*c[3].x-a*c[2].x+l*c[1].x-r*c[0].x,i*c[3].y-a*c[2].y+l*c[1].y-r*c[0].y)),new DG.Bezier(u))},getCurveAfter:function(t){var e,i,o,n,r,s,a,l,u,c=this.points,h=this.order;return 1===t?this.clone():(u=[],e=t*t,o=t-1,n=o*o,u[h]=new DG.Point(c[h].x,c[h].y),u[--h]=new DG.Point(t*c[h+1].x-o*c[h].x,t*c[h+1].y-o*c[h].y),s=t*o*2,u[--h]=new DG.Point(e*c[h+2].x-s*c[h+1].x+n*c[h].x,e*c[h+2].y-s*c[h+1].y+n*c[h].y),this.order>2&&(i=e*t,r=n*o,a=e*o*3,l=t*n*3,u[--h]=new DG.Point(i*c[h+3].x-a*c[h+2].x+l*c[h+1].x-r*c[h].x,i*c[h+3].y-a*c[h+2].y+l*c[h+1].y-r*c[h].y)),new DG.Bezier(u))},_getDerivatives:function(){var t,e,i,o,n=this.points,r=[];for(t=n.length,e=t-1;t>1;t--,e--){for(o=[],i=0;i<e;i++)o.push(new DG.Point(e*(n[i+1].x-n[i].x),e*(n[i+1].y-n[i].y)));r.push(o),n=o}return r},getLUT:function(t){return t=t||125,this._lut.length!==t+1&&(this.order>2?this._setLUT3(t):this._setLUT2(t)),this._lut},_setLUT2:function(t){var e,i,o,n,r,s=this._lut=[],a=this.points;s.push({x:a[0].x,y:a[0].y,l:0});for(var l=1;l<t;l++)e=l/t,i=1-e,o=i*i,n=i*e*2,r=e*e,s.push({x:o*a[0].x+n*a[1].x+r*a[2].x,y:o*a[0].y+n*a[1].y+r*a[2].y});s.push({x:a[2].x,y:a[2].y,l:0})},_setLUT3:function(t){var e,i,o,n,r,s,a,l,u=this._lut=[],c=this.points;u.push({x:c[0].x,y:c[0].y,l:0});for(var h=1;h<t;h++)e=h/t,o=1-e,n=o*o,i=e*e,r=n*o,s=n*e*3,a=o*i*3,l=e*i,u.push({x:r*c[0].x+s*c[1].x+a*c[2].x+l*c[3].x,y:r*c[0].y+s*c[1].y+a*c[2].y+l*c[3].y});u.push({x:c[3].x,y:c[3].y,l:0})},clone:function(){return new DG.Bezier(this.points,(!0))}}),DG.bezier=function(t){return("number"==typeof t||t instanceof DG.Point)&&(t=Array.prototype.slice.call(arguments)),"number"==typeof t[0]?(t=t.length<7?[new DG.Point(t[0],t[1]),new DG.Point(t[2],t[3]),new DG.Point(t[4],t[5])]:[new DG.Point(t[0],t[1]),new DG.Point(t[2],t[3]),new DG.Point(t[4],t[5]),new DG.Point(t[6],t[7])],new DG.Bezier(t)):new DG.Bezier(t,(!0))},DG.Bezier.WEIGHT=[.362683783378362,.362683783378362,.3137066458778873,.3137066458778873,.2223810344533745,.2223810344533745,.1012285362903763,.1012285362903763],DG.Bezier.ABSCISSA=[-.1834346424956498,.1834346424956498,-.525532409916329,.525532409916329,-.7966664774136267,.7966664774136267,-.9602898564975363,.9602898564975363],DG.TimeBezier=DG.Bezier.extend({initialize:function(t,e,i){DG.Bezier.prototype.initialize.call(this,[DG.TimeBezier.START,t,e,DG.TimeBezier.END],i)},getYbyX:function(t){var e,i=this.getLUT(),o=i.length-1,n=0;if(t<=0)return 0;if(t>=1)return 1;for(;;)if(e=n+(o-n>>1),t<i[e].x?o=e:n=e,o-n<2)break;return t=(t-i[n].x)/(i[o].x-i[n].x),i[n].y+(i[o].y-i[n].y)*t},getLUT:function(t){var e,i,o,n,r,s,a,l=this.points;if(t=t||240,this._lut.length===t+1)return this._lut;this._lut=a=[],a.push({x:0,y:0});for(var u=1;u<t;u++)e=u/t,o=1-e,i=e*e,n=o*o*e*3,r=o*i*3,s=e*i,a.push({x:n*l[1].x+r*l[2].x+s,y:n*l[1].y+r*l[2].y+s});return a.push({x:1,y:1}),a},clone:function(){return new DG.TimeBezier(this.points,(!0))}}),DG.TimeBezier.START=DG.point(0,0),DG.TimeBezier.END=DG.point(1,1),DG.ArcBezier=DG.Bezier.extend({initialize:function(t,e){DG.Bezier.prototype.initialize.call(this,t,e),this.getLUT(),this._setLutLengths()},getTbyL:function(t){var e,i,o,n=this.getLUT(),r=n.length-1,s=0;if(t<=0)return 0;if(t>=n[r].l)return 1;for(;;)if(e=s+(r-s>>1),t<n[e].l?r=e:s=e,r-s<2)break;t=(t-n[s].l)/(n[r].l-n[s].l),i=n[s].x+(n[r].x-n[s].x)*t,o=n[s].y+(n[r].y-n[s].y)*t;var a,l,u,c,h=r/n.length,d=s/n.length,p=1/n.length/10,_=Math.pow(2,53)-1;for(c=d;d<h;d+=p)a=this.getPoint(d),l=a.x-i,u=a.y-o,t=Math.sqrt(l*l+u*u),t<_&&(_=t,c=d);return c},_setLutLengths:function(){var t,e,i=this._lut;i[0].l=0;for(var o=1;o<i.length;o++)t=i[o].x-i[o-1].x,e=i[o].y-i[o-1].y,i[o].l=i[o-1].l+Math.sqrt(t*t+e*e)},getLength:function(){return this._lut[this._lut.length-1].l},clone:function(){return new DG.ArcBezier(this.points,(!0))}}),DG.Animation=DG.Evented.extend({options:{},initialize:function(t){DG.setOptions(this,t),this._animID=-1,this._startTime=0,this._running=!1,this._animation=null,this._durations=null},start:function(){this.stop(),this._prepare(),this._running=!0,this.fire("start"),this._startTime=(new Date).getTime(),this._animate()},stop:function(){this._running&&this._run(this._durations.getLength())},_prepare:function(){this._animation=DG.Util.isArray(this.options.animation)?this.options.animation:[this.options.animation],this._durations=new DG.Metric.Segments,this._animation.forEach(function(t){this.push(t.duration)},this._durations)},_animate:function(){this._animID=DG.Util.requestAnimFrame(this._animate,this),this._run()},_run:function(t){var e,i,o;t=t?t:(new Date).getTime()-this._startTime,t<this._durations.getLength()?(i=this._durations.getIndex(t),e=this._durations.getSegRatio(t),o=this._animation[i]["function"].getYbyX(e),this._step(this._getFrameValues(i,o))):(i=this._durations.length-1,this._step(this._getFrameValues(i,1)),this._complete())},_step:function(t){this.fire("step",t)},_complete:function(){DG.Util.cancelAnimFrame(this._animID),this._durations=null,this._animation=null,this._running=!1,this.fire("end")},_getFrameValues:function(t,e){var i,o,n=this._animation[t].frames,r={progress:e};if(n)for(var s in n)n[s].progress?r[s]=n[s].progress(e):(i=n[s].from,o=n[s].to,r[s]=i+(o-i)*e);return r}}),DG.animation=function(t){return new DG.Animation(t)},DG.Animation.LINEAR=new DG.TimeBezier(DG.point(0,0),DG.point(1,1)),DG.Animation.EASE=new DG.TimeBezier(DG.point(.25,.1),DG.point(.25,1)),DG.Animation.EASE_IN=new DG.TimeBezier(DG.point(.42,0),DG.point(1,1)),DG.Animation.EASE_IN_OUT=new DG.TimeBezier(DG.point(.42,0),DG.point(.58,1)),DG.Animation.EASE_OUT=new DG.TimeBezier(DG.point(0,0),DG.point(.58,1)),DG.Entrance=DG.FeatureGroup.extend({options:{vectors:[],fillColor:"#0085a0",strokeColor:"#fff",enableAnimation:!0,interactive:!1,autoClose:!0},initialize:function(t){DG.LayerGroup.prototype.initialize.call(this),DG.setOptions(this,t),this._bounds=new DG.LatLngBounds,this._animations={bounce:DG.animation(DG.Entrance.BOUNCE_ANIMATION),path:DG.animation(DG.Entrance.PATH_ANIMATION)},this._initArrows(),this._isShown=!1},onAdd:function(t){DG.LayerGroup.prototype.onAdd.call(this,t),this.show()},onRemove:function(t){this.hide(),DG.LayerGroup.prototype.onRemove.call(this,t)},getEvents:function(){var t={};return this.options.autoClose&&(t.layeradd=this._removeEntrance),this.options.enableAnimation&&(t.zoomend=this._animate),t},show:function(t){return this._layers&&(t&&this.fitBounds(),this._isShown||(this._isShown=!0,this.eachLayer(function(t){t.setVisibility(!0)}),this.options.enableAnimation&&this._animate(),this._map.fire("entranceshow"))),this},hide:function(){return this._layers&&this._isShown&&(this._isShown=!1,this.eachLayer(function(t){t.setVisibility(!1)}),this._map.fire("entrancehide")),this},isShown:function(){return this._isShown},getBounds:function(){return this._bounds},setFillColor:function(t){this.eachLayer(function(e){e.setStyle({fillColor:t})})},setStrokeColor:function(t){this.eachLayer(function(e){e.setStyle({color:t})})},_initArrows:function(){var t={color:this.options.strokeColor,fillColor:this.options.fillColor,interactive:this.options.interactive};this.options.vectors.map(function(t){return DG.Wkt.toLatLngs(t)}).forEach(function(e){var i=DG.Util.create(t),o=DG.latLngBounds(e);this._bounds.extend(o),i.latlngs=e,i.bounds=o,this.options.enableAnimation&&(e.length>2?i.animation=this._animations.path:(i.animation=this._animations.bounce,i.distance=!0)),this.addLayer(DG.entrance.arrow(i))},this)},_animate:function(){this._isShown&&(this._animations.bounce.start(),this._animations.path.start())},fitBounds:function(){var t,e=this._map,i=this.getBounds();return e.getBounds().contains(i)&&this._isAllowedZoom()||(t=this._getFitZoom(),e.projectDetector.getProject()||e.once("moveend",function(){e.setZoom(this._getFitZoom())},this),e.setView(i.getCenter(),t,{animate:!0})),this},_getFitZoom:function(){return this._map.projectDetector.getProject().maxZoom||DG.Entrance.SHOW_FROM_ZOOM},_isAllowedZoom:function(){return this._map.getZoom()>=DG.Entrance.SHOW_FROM_ZOOM},_removeEntrance:function(t){(t.layer instanceof DG.Popup||t.layer instanceof DG.Entrance&&t.layer!==this)&&this.remove()}}),DG.entrance=function(t){return new DG.Entrance(t)},DG.Entrance.SHOW_FROM_ZOOM=16,DG.Entrance.PATH_ANIMATION={animation:{"function":DG.Animation.EASE_IN_OUT,duration:750}},DG.Entrance.BOUNCE_ANIMATION={animation:[{"function":DG.Animation.EASE_IN_OUT,duration:250,frames:{distance:{from:0,to:.6}}},{"function":DG.Animation.EASE_IN,duration:135,frames:{distance:{from:.6,to:0}}},{"function":DG.Animation.EASE_OUT,duration:135,frames:{distance:{from:0,to:.16}}},{"function":DG.Animation.EASE_IN,duration:90,frames:{distance:{from:.16,to:0}}},{"function":DG.Animation.EASE_OUT,duration:90,frames:{distance:{from:0,to:.06}}},{"function":DG.Animation.EASE_IN,duration:50,frames:{distance:{from:.06,to:0}}}]},DG.Entrance.Arrow=DG.FeatureGroup.extend({initialize:function(t){DG.LayerGroup.prototype.initialize.call(this),DG.setOptions(this,t),this._progress=1,this._distance=0,this._visibility={isShown:!1},this._position=t.latlngs[t.latlngs.length-1],this._shape=this.options.shape||DG.Entrance.Arrow.SHAPE,this._apt={},this._att={}},beforeAdd:function(t){var e=this.options;!e.animation||t.options.preferCanvas||DG.Browser.ielt9?e.animation=null:e.animation.on("step",this._animation,this),this.projection(),this.addLayer(new DG.ComplexPath({lineCap:"butt",color:e.color,fillColor:e.fillColor,interactive:e.interactive,visibility:this._visibility,transform:this._apt})),this.addLayer(new DG.ComplexPath({lineJoin:"miter",color:e.color,fillColor:e.fillColor,interactive:e.interactive,visibility:this._visibility,transform:this._att}))},getEvents:function(){return{zoomend:this._project,moveend:this._update,viewreset:this._reset}},setVisibility:function(t){this._visibility.isShown!==t&&(this._visibility.isShown=t,t?this.options.animation||this._reset():this._reset())},getBounds:function(){return this.options.bounds},projection:function(){var t,e,i,o,n=this._map||this._mapToAdd,r=n?n.getZoom():0,s=this._shape.vertices[r],a=this._shape.drawings[r],l=this.options.latlngs;return r&&s&&a&&(this._att[r]||(e=DG.ArrowPathTransform.getTranslatedPath(n,l),t={vertices:s,drawings:a},this._att[r]=new DG.ArrowTipTransform(e,t),this._apt[r]=new DG.ArrowPathTransform(e)),i=n.latLngToLayerPoint(this._position),o=n.latLngToLayerPoint(l[l.length-2]),this._apt[r]._pxBounds||this._setBounds(i,o,this._apt[r],this._att[r]),this.options.distance&&(i=DG.VertexTransform.getScaled(i,o,this._distance)),this._apt[r].subPath(this._progress).translate(i),this._att[r].subShape(this._apt[r]).translate(i)),this},_animation:function(t){void 0!=t.distance?this._distance=t.distance:this._progress=t.progress,this._visibility.isShown&&(this._project(),this._update())},_project:function(){this.projection().invoke("_project")},_update:function(){this.invoke("_update")},_reset:function(){this._resetBounds(),this._project(),this._update()},_resetBounds:function(){var t;for(t in this._apt)this._apt[t]._pxBounds=null;for(t in this._att)this._att[t]._pxBounds=null},_setBounds:function(t,e,i,o){var n=i.subPath(1).translate(t).vertices,r=o.subShape(i).translate(t).vertices;i._pxBounds=new DG.Bounds(n),o._pxBounds=new DG.Bounds(r)}}),DG.entrance.arrow=function(t){return new DG.Entrance.Arrow(t)},DG.Entrance.Arrow.SHAPE={vertices:{16:[[-6.5,-1.8],[-6.0522,-1.8],[-7.0975,-5.2537],[-6.6619,-6.2565],[-6.598,-6.355],[-6.1757,-6.147],[.8371,-.3552],[.9275,-.1764],[.9275,.1764],[.8371,.3552],[-6.1757,6.147],[-6.598,6.355],[-6.6619,6.2565],[-7.0975,5.2537],[-6.0522,1.8],[-6.5,1.8]],17:[[-9,-2.4],[-7.889,-2.4],[-9.9245,-7.2548],[-9.3363,-8.6404],[-9.3448,-8.6448],[-8.8717,-8.3508],[1.0285,-.3552],[1.119,-.1764],[1.119,.1764],[1.0285,.3552],[-8.8717,8.3508],[-9.3448,8.6448],[-9.3363,8.6404],[-9.9245,7.2548],[-7.889,2.4],[-9,2.4]],18:[[-11.5,-3],[-10.0795,-3],[-12.4909,-9.3173],[-11.8402,-10.7654],[-11.5986,-10.7073],[-10.938,-10.2258],[1.1497,-.3552],[1.2402,-.1764],[1.2402,.1764],[1.1497,.3552],[-10.938,10.2258],[-11.5986,10.7073],[-11.8402,10.7654],[-12.4909,9.3173],[-10.0795,3],[-11.5,3]],19:[[-13,-3.6],[-11.66,-3.6],[-14.1696,-10.8351],[-13.5189,-12.2832],[-13.2773,-12.2251],[-12.6167,-11.7436],[1.3061,-.3552],[1.3966,-.1764],[1.3966,.1764],[1.3061,.3552],[-12.6167,11.7436],[-13.2773,12.2251],[-13.5189,12.2832],[-14.1696,10.8351],[-11.66,3.6],[-13,3.6]]},drawings:{16:["M","L","L","C","L","C","L","C","L","L"],17:["M","L","L","C","L","C","L","C","L","L"],18:["M","L","L","C","L","C","L","C","L","L"],19:["M","L","L","C","L","C","L","C","L","L"]}},function(t){for(var e in t)t[e]=t[e].map(function(t){return DG.point(t)})}(DG.Entrance.Arrow.SHAPE.vertices),DG.Label=DG.Layer.extend({options:{offset:new DG.Point(12,15),className:"dg-label",zIndexOffset:0,textDirection:"auto"},_typeOfString:Object.prototype.toString.call("s"),_defaultZIndex:100,initialize:function(t,e){DG.Util.setOptions(this,e),this._animated=DG.Browser.any3d,this._content=t},onAdd:function(t){this._map=t,this._el||this._initDOM(),this._visible=!0,this.setContent(this._content)._onViewReset(),t.on("viewreset",this._onViewReset,this).on("zoomanim",this._onZoomAnimation,this)},onRemove:function(t){t.off("viewreset",this._onViewReset,this).off("zoomanim",this._onZoomAnimation,this),this._visible=!1,this._el.removeChild(this._container),DG.Util.falseFn(this._container.offsetWidth),this._container=null,t.getPanes().tooltipPane.removeChild(this._el),this._el=null},_initDOM:function(){this._el=DG.DomUtil.create("div",this.options.className+" leaflet-zoom-"+(this._animated?"animated":"hide"),this._map.getPanes().tooltipPane),this._el.style.zIndex=this._defaultZIndex+this.options.zIndexOffset,this._container=DG.DomUtil.create("div",this.options.className+"__content",this._el),this._container.setAttribute("dir",this.options.textDirection),DG.DomEvent.disableClickPropagation(this._el).on(this._container,"mousewheel",DG.DomEvent.stopPropagation).on(this._container,"contextmenu",DG.DomEvent.stopPropagation)},_onViewReset:function(){this._visible&&this._latlng&&DG.DomUtil.setPosition(this._el,this._map.latLngToLayerPoint(this._latlng).add(this.options.offset),DG.Browser.ie)},_onZoomAnimation:function(t){this._latlng&&DG.DomUtil.setPosition(this._el,this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).add(this.options.offset))},setOffset:function(t){return t instanceof DG.Point&&(this.options.offset=t,this._onViewReset()),this},setZIndexOffset:function(t){return isNaN(+t)||(this.options.zIndexOffset=+t,this._visible&&(this._el.style.zIndex=this._defaultZIndex+this.options.zIndexOffset)),this},setContent:function(t){return Object.prototype.toString.call(t)!==this._typeOfString?this:(this._content=t,this._visible&&(this._container.innerHTML=t),this)},setPosition:function(t){return t instanceof DG.LatLng?(this._latlng=t,this._onViewReset(),this):this}}),DG.label=function(t,e){return new DG.Label(t,e)},DG.Marker.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),e&&(this.options.offset!==e.offset&&this._label.setOffset(this.options.offset=e.offset),this.options["static"]!==e["static"]&&this.unbindLabel().bindLabel(t,e))):(e=DG.extend({offset:new DG.Point(5,5)},e),this._label=DG.label(t,e),this.once("remove",this._onMarkerRemove),e["static"]?this.showLabel():this.on("mouseover",this._mouseOverLabel).on("mouseout",this._mouseOutLabel).on("dragstart",this._dragStartLabel).on("dragend",this._dragEndLabel),"undefined"!=typeof this._map?this._updateLabelZIndex():this.once("add",this._updateLabelZIndex)),this},unbindLabel:function(){return this._label&&(this.hideLabel().off("remove",this.unbindLabel).off("mouseover",this._mouseOverLabel).off("mouseout",this._mouseOutLabel).off("dragstart",this._dragStartLabel).off("dragend",this._dragEndLabel).off("move",this._updatePosition).off("add",this._updateLabelZIndex),this._label=null),this},_onMarkerRemove:function(){if(this._label){var t=this._label._content;this.once("add",function(){this._label||this.bindLabel(t)}),this.unbindLabel()}},getLabel:function(){return this._label?this._label:null},_originalUpdateZIndex:DG.Marker.prototype._updateZIndex,_updateZIndex:function(t){return this._zIndex||(this._zIndex=0),this._originalUpdateZIndex(t),this._updateLabelZIndex(),this},_updateLabelZIndex:function(){return this._label&&this._icon&&this._label.setZIndexOffset(this._icon.style.zIndex),this},showLabel:function(){return this._label&&this.on("move",this._updatePosition)._map.addLayer(this._label.setPosition(this.getLatLng())),this},hideLabel:function(){return this._label&&this.off("move",this._updatePosition)._map.removeLayer(this._label),this},_updatePosition:function(){this._label.setPosition(this.getLatLng())},_dragStartLabel:function(){this._label.isMarkerDragging=!0,this.hideLabel()},_dragEndLabel:function(){this._label.isMarkerDragging=!1,this._label.isMouseOverMarker&&this.showLabel()},_mouseOverLabel:function(){this._label.isMouseOverMarker=!0,this._label.isMarkerDragging||this.showLabel()},_mouseOutLabel:function(){this._label.isMouseOverMarker=!1,this.hideLabel()}}),DG.Marker.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.Path.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),this._label.options.offset!==e.offset&&this._label.setOffset(e.offset)):(this._label=DG.label(t,e),this.on(this._labelEvents,this)),this},unbindLabel:function(){return this._label&&(this.off(this._labelEvents,this),this._map.removeLayer(this._label),this._label=null),this},getLabel:function(){return this._label?this._label:null},_labelEvents:{mouseover:function(t){this._map.addLayer(this._label.setPosition(t.latlng)),DG.DomEvent.stop(t)},mousemove:function(t){this._label.setPosition(t.latlng),DG.DomEvent.stop(t)},mouseout:function(t){this._map.removeLayer(this._label),DG.DomEvent.stop(t)},remove:function(){this._map.removeLayer(this._label)}}}),DG.Path.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.Entrance.include({bindLabel:function(t,e){return this._label?(this._label.setContent(t),this._label.options.offset!==e.offset&&this._label.setOffset(e.offset)):(this._label=DG.label(t,e),this.on(this._labelEvents,this)),this},unbindLabel:function(){return this._label&&(this.off(this._labelEvents,this),this._map.removeLayer(this._label),this._label=null),this},getLabel:function(){return this._label?this._label:null},_labelEvents:{mouseover:function(t){this._map.addLayer(this._label.setPosition(t.latlng)),DG.DomEvent.stop(t)},mousemove:function(t){this._label.setPosition(t.latlng),DG.DomEvent.stop(t)},mouseout:function(){this._label.remove()},remove:function(){this._label.remove()}}}),DG.Entrance.addInitHook(function(){"undefined"!=typeof this.options.label&&this.bindLabel(this.options.label)}),DG.configTheme=DG.configTheme||{},DG.configTheme.balloonOptions={offset:{x:1,y:-43}},_dereq_("../../../vendors/baron"),function(){var t=DG.configTheme.balloonOptions.offset.x,e=DG.configTheme.balloonOptions.offset.y,i=DG.Popup.prototype.initialize,o=DG.Popup.prototype._initLayout,n=DG.Popup.prototype.onAdd,r=baron.noConflict(),s=function(t){this[0]=t,this.length=1};s.prototype={setAttribute:function(t,e){return this[0].setAttribute(t,e),this},getAttribute:function(t){return this[0].getAttribute(t)},removeAttribute:function(t){return this[0].removeAttribute(t),this},css:function(t,e){return e?(this[0].style[t]=e,this):DG.DomUtil.getStyle(this[0],t)}},DG.Popup.prototype.options.offset=DG.point(t,e),DG.Popup.mergeOptions({border:16,mapControlsWidth:60,textDirection:"auto"}),DG.Popup.include({_headerContent:null,_footerContent:null,_scroller:null,_scrollerBar:null,_barWrapper:null,_baron:null,_isBaronExist:!1,_popupShowClass:"leaflet-popup_show_true",_popupHideClass:"leaflet-popup_show_false",_popupTipClass:"leaflet-popup-tip-container",_tipSVGPath:"M0 0c12.643 0 28 7.115 28 44h2c0-36.885 15.358-44 28-44h-58z",_isAutoPanPaddingUserDefined:!1,initialize:function(t,e){this._popupStructure={},this._isAutoPanPaddingUserDefined=t&&t.hasOwnProperty("autoPanPadding"),i.call(this,t,e)},onAdd:function(t){t.on({entranceshow:this._closePopup,resize:this.resize},this),n.call(this,t),this._animateOpening(),void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Popup","Use")},onRemove:function(t){this._animateClosing(),t.off({entranceshow:this._closePopup,resize:this.resize},this),DG.DomUtil.TRANSITION?this._removeTimeout=setTimeout(L.bind(L.DomUtil.remove,L.DomUtil,this._container),200):L.DomUtil.remove(this._container),t.fire("popupclose",{popup:this}),this._source&&this._source.fire("popupclose",{popup:this},!0)},setContent:function(t){return this._isNode(t)||"object"!=typeof t?this._bodyContent=t:Object.keys(t).forEach(function(e){this["_"+e+"Content"]=t[e]},this),this.update(),this},setHeaderContent:function(t){return this._headerContent=t,this.update(),this},setFooterContent:function(t){return this._footerContent=t,this.update(),this},getContent:function(){return this._bodyContent},getHeaderContent:function(){return this._headerContent},getFooterContent:function(){return this._footerContent},clear:function(){return Object.keys(this._popupStructure).forEach(this._clearElement,this),this._isBaronExist=!1,this},clearHeader:function(){return this._clearElement("header")},clearFooter:function(){return this._clearElement("footer")},findElement:function(t){return this._contentNode.querySelector(t)},_animateOpening:function(){DG.DomUtil.addClass(this._innerContainer,this._popupShowClass),DG.DomUtil.removeClass(this._innerContainer,this._popupHideClass)},_animateClosing:function(){DG.DomUtil.addClass(this._innerContainer,this._popupHideClass),DG.DomUtil.removeClass(this._innerContainer,this._popupShowClass)},_closePopup:function(){this._map.closePopup(this)},_isNode:function(t){return!!t.nodeName},_onCloseButtonClick:function(t){this._map&&this._map.closePopup(this),L.DomEvent.stop(t)},_close:function(){this._map&&(DG.Browser.mobile&&this._map.geoclicker&&(this.options.closeOnClick||this._map.options.closePopupOnClick)&&(this._map.geoclicker.popupWasOpen=!0),this._map.closePopup(this))},_initLayout:function(){o.call(this),DG.DomEvent.on(this._contentNode,"wheel",function(t){var e;if(t.composedPath)e=t.composedPath();else{var i=t.target;for(e=[];i.parentNode;)e.push(i),i=i.parentNode}e.indexOf(this._scroller)!==-1&&e.indexOf(this._barWrapper)===-1||t.preventDefault()},this),this._innerContainer=DG.DomUtil.create("div","leaflet-popup-inner "+this._popupHideClass,this._container),DG.DomEvent.disableClickPropagation(this._innerContainer),this.options.closeButton&&this._innerContainer.appendChild(this._detachEl(this._closeButton)),this._innerContainer.appendChild(this._detachEl(this._wrapper));var t=this._detachEl(this._tipContainer);if(DG.Browser.svg){var e=DG.SVG.create("path"),i=this._popupTipClass+" "+this._popupTipClass+"_svg";e.setAttribute("d",this._tipSVGPath),t=DG.SVG.create("svg"),t.setAttribute("class",i),t.appendChild(e),DG.DomEvent.disableClickPropagation(e)}else DG.DomUtil.addClass(t,this._popupTipClass+"_image"),DG.DomEvent.disableClickPropagation(t);this._innerContainer.appendChild(t)},_clearElement:function(t){return this["_"+t+"Content"]=null,this._detachEl(this._popupStructure[t]),delete this._popupStructure[t],this},_updateScrollPosition:function(){this._baron&&this._baron.update()},resize:function(){var t=this._updateLayout();if(this._updatePosition(),t)if(this._isBaronExist){DG.DomUtil.removeClass(this._scroller,"dg-scroller_hidden_true"),DG.DomUtil.addClass(this._scroller,"dg-scroller");var e=!!this._isBaronExist&&this._scroller.scrollTop;e&&(this._scroller.scrollTop=e);var i=this.options.maxHeight-2*this.options.border-this._getDelta();this._scrollerWrapper.style.height=i+"px",this._updateScrollPosition()}else this._isContentHeightEnough()||(this._initBaronScroller(),this._initBaron());else this._isBaronExist&&(this._scrollerWrapper.style.height="",DG.DomUtil.removeClass(this._scroller,"dg-scroller"),DG.DomUtil.addClass(this._scroller,"dg-scroller_hidden_true"),DG.DomUtil.removeClass(this._scroller,"dg-scroller"),DG.DomEvent.off(this._scroller,"scroll",this._onScroll));this._adjustPan(),this._bindAdjustPanOnTransitionEnd()},_adjustPan:function(t){if(this._map){if(t){if("max-height"!==t.propertyName)return;DG.DomEvent.off(this._wrapper,DG.DomUtil.TRANSITION_END,this._adjustPan)}var e=this.options;if(e.autoPan){var i=this._map,o=this._container.offsetHeight,n=this._containerWidth,r=new L.Point(this._containerLeft,-o-this._containerBottom);this._zoomAnimated&&r._add(L.DomUtil.getPosition(this._container));var s=[e.autoPanPadding[0],e.autoPanPadding[1]];!this._isAutoPanPaddingUserDefined&&this._map._container.offsetWidth>=e.maxWidth+2*e.mapControlsWidth&&(s[0]=e.mapControlsWidth);var a=i.layerPointToContainerPoint(r),l=L.point(s),u=L.point(e.autoPanPaddingTopLeft||l),c=L.point(e.autoPanPaddingBottomRight||l),h=i.getSize(),d=0,p=0;0!==h.x&&0!==h.y&&(a.x+n+c.x>h.x&&(d=a.x+n-h.x+c.x),a.x-d-u.x<0&&(d=a.x-u.x),a.y+o+c.y>h.y&&(p=a.y+o-h.y+c.y),a.y-p-u.y<0&&(p=a.y-u.y),(d||p)&&i.fire("autopanstart").panBy([d,p]))}}},_bindAdjustPanOnTransitionEnd:function(){DG.DomUtil.TRANSITION?DG.DomEvent.on(this._wrapper,DG.DomUtil.TRANSITION_END,this._adjustPan,this):this._adjustPan()},_isContentHeightEnough:function(){var t=this.options;if(!t.maxHeight)return!0;var e=this._popupStructure.body?this._popupStructure.body.offsetHeight+this._getDelta():this._contentNode.offsetHeight;return e+=2*t.border,e<=t.maxHeight},_initBaronScroller:function(){var t=this._popupStructure.body.parentNode,e=this._scrollerWrapper=DG.DomUtil.create("div","dg-scroller__wrapper",t),i=this._scroller=DG.DomUtil.create("div","dg-scroller",e),o=this._barWrapper=DG.DomUtil.create("div","dg-scroller__bar-wrapper",i),n=this.options.maxHeight-2*this.options.border;this._scrollerBar=DG.DomUtil.create("div","dg-scroller__bar",o),i.appendChild(this._detachEl(this._popupStructure.body)),n-=this._getDelta(),e.style.height=Math.max(18,n)+"px",e.style.width=t.offsetWidth+5+"px",this._isBaronExist=!0,this._switchEvents()},_onScroll:function(t){this.fire("scroll",{originalEvent:t})},_onClick:function(t){t.target=t.target||t.srcElement,this._moving||this.fire("click",{originalEvent:t})},_onStart:function(t){if(this._moved=!1,!this._moving){var e=t.touches?t.touches[0]:t;this._startPoint=new DG.Point(e.clientX,e.clientY),this._toggleTouchEvents()}},_onEnd:function(t){this._toggleTouchEvents(!0),this._onClick(t),this._moving=!1},_onMove:function(t){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=DG.point(e.clientX,e.clientY),o=Math.abs(i.subtract(this._startPoint).y);!o||o<10||(this._moving=this._moved=!0)},_initBaron:function(){var t=this._scrollerWrapper;this._baron=r({scroller:".dg-scroller",bar:".dg-scroller__bar",track:".dg-scroller__bar-wrapper",$:function(e){var i="[object String]"==={}.toString.call(e)?t.querySelector(e):e;return new s(i)},event:function(t,e,i,o){e.split(" ").forEach(function(e){DG.DomEvent[o||"on"](t,e,i)})}})},_initHeader:function(){this._popupStructure.header=DG.DomUtil.create("header","dg-popup__header",this._contentNode),this._popupStructure.header.setAttribute("dir",this.options.textDirection)},_initFooter:function(){this._popupStructure.footer=DG.DomUtil.create("footer","dg-popup__footer",this._contentNode),this._popupStructure.footer.setAttribute("dir",this.options.textDirection)},_initBodyContainer:function(){this._popupStructure.wrapper=DG.DomUtil.create("div","dg-popup__container-wrapper",this._contentNode),this._popupStructure.body=DG.DomUtil.create("div","dg-popup__container",this._popupStructure.wrapper),this._popupStructure.body.setAttribute("dir",this.options.textDirection)},update:function(){if(this._map){if(DG.Browser.ielt9||(this._container.style.visibility="hidden"),this._switchEvents(!0),
	this._clearNode(this._contentNode),this._isBaronExist=!1,this._headerContent&&this._initHeader(),this._bodyContent&&this._initBodyContainer(),this._footerContent&&this._initFooter(),this._updatePopupStructure(),this.resize(),DG.DomEvent.on(this._wrapper,"click",DG.DomEvent.stopPropagation),this._switchEvents(),DG.Browser.ielt9){var t=this._popupStructure.footer;t&&(t.className+=" ie8")}DG.Browser.ielt9||(this._container.style.visibility="")}},_getDelta:function(){var t=0,e=this._popupStructure;return e.header&&(t+=e.header.offsetHeight),e.footer&&(t+=e.footer.offsetHeight),t},_updateLayout:function(){var t,e=this.options,i=this._contentNode,o=this._wrapper,n=i.style,r=o.style,s="leaflet-popup-scrolled",a=!1;n.margin=e.border+"px",DG.DomUtil.removeClass(i,s),this._isContentHeightEnough()?r.maxHeight=i.offsetHeight+2*e.border+"px":(r.maxHeight=e.maxHeight+"px",DG.DomUtil.addClass(i,s),a=!0);var l=2*e.autoPanPadding[0];return e.sprawling?(t=e.maxWidth,t=Math.min(t,this._map._container.offsetWidth-l),t=Math.max(t,e.minWidth)):(r.width="",n.whiteSpace="nowrap",t=o.offsetWidth,n.whiteSpace="",t=Math.min(t,this._map._container.offsetWidth-l),t=Math.min(Math.max(t,e.minWidth),e.maxWidth)),r.width=t+"px",this._containerWidth=this._container.offsetWidth,a},_updatePopupStructure:function(){Object.keys(this._popupStructure).forEach(function(t){this._insertContent(this["_"+t+"Content"],this._popupStructure[t])},this),this.fire("contentupdate")},_insertContent:function(t,e){t&&e&&(t="function"==typeof t?t(this._source||this):t,"string"==typeof t?e.innerHTML=t:(this._clearNode(e),e.appendChild(t)))},_clearNode:function(t){for(;t.hasChildNodes();)t.removeChild(t.firstChild)},_detachEl:function(t){return t.parentNode&&t.parentNode.removeChild(t),t},_switchEvents:function(t){var e=t?"off":"on";DG.Browser.touch?DG.DomEvent[e](this._contentNode,"touchstart mousedown mousemove",this._onStart,this):DG.DomEvent[e](this._contentNode,"click",this._onClick,this),this._isBaronExist&&DG.DomEvent[e](this._scroller,"scroll",this._onScroll,this)},_toggleTouchEvents:function(t){var e=t?"off":"on";DG.DomEvent[e](this._contentNode,"touchmove",this._onMove,this),DG.DomEvent[e](this._contentNode,"touchend",this._onEnd,this)}})}(),DG.Map.include({_markerClass:"dg-customization__marker_type_mushroom",_markerShowClass:"dg-customization__marker_appear",_markerHideClass:"dg-customization__marker_disappear",_dgHideClass:"dg-popup_hidden_true",openPopup:function(t,e,i){if(!(t instanceof L.Popup)){var o=t;t=new L.Popup(i).setContent(o)}return e&&t.setLatLng(e),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,t._source&&t._source._icon&&(t._source._icon.className.indexOf(this._markerClass)!==-1?(DG.DomUtil.removeClass(t._source._icon,this._markerShowClass),DG.DomUtil.addClass(t._source._icon,this._markerHideClass)):(DG.DomUtil.addClass(t._source._icon,this._dgHideClass),t._source._shadow&&DG.DomUtil.addClass(t._source._shadow,this._dgHideClass))),this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&(t._source&&t._source._icon&&(t._source._icon.className.indexOf(this._markerClass)!==-1?(DG.DomUtil.removeClass(t._source._icon,this._markerHideClass),DG.DomUtil.addClass(t._source._icon,this._markerShowClass)):(DG.DomUtil.removeClass(t._source._icon,this._dgHideClass),t._source._shadow&&DG.DomUtil.removeClass(t._source._shadow,this._dgHideClass))),this.removeLayer(t)),this}}),DG.Dictionary={},DG.Dictionary.ru={pluralRules:function(t){return t%10===1&&t%100!==11?0:t%10>=2&&t%10<=4&&t%10%1===0&&(t%100<12||t%100>14)?1:t%10===0||t%10>=5&&t%10<=9&&t%10%1===0||t%100>=11&&t%100<=14&&t%100%1===0?2:void 0}},DG.Dictionary.en={pluralRules:function(t){return 1===t?0:1}},DG.Dictionary.it={pluralRules:function(t){return 1===t?0:1}},DG.Dictionary.cs={pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2}},DG.Dictionary.es={pluralRules:function(t){return t>=2?1:0}},DG.Dictionary.ar={pluralRules:function(){return 0}},DG.Locale={t:function(t,e){var i,o,n,r=this._map.getLang(),s=!1;return"undefined"==typeof this.constructor.Dictionary[r]&&(r="ar"===r?"en":DG.config.defaultLang),o=this.constructor.Dictionary[r][t],(s="undefined"!=typeof o)?(i=s?o:t,void 0!==e&&(e=parseInt(e,10),e=isNaN(e)?0:e,n=this.constructor.Dictionary[r].pluralRules(e),i=o[n]),i=DG.Util.template(i,{n:e})):t}},DG.Map.include({setLang:function(t){t&&"[object String]"===Object.prototype.toString.call(t)&&(this.options.currentLang=t,this.fire("langchange",{lang:t}))},getLang:function(){if(!this.options.currentLang){var t=document.documentElement,e=t.lang||t.getAttributeNS&&t.getAttributeNS("http://www.w3.org/XML/1998/namespace","lang")||DG.config.defaultLang;this.options.currentLang=e}return this.options.currentLang}}),DG.RoundControl=DG.Control.extend({includes:DG.Mixin.Events,options:{position:"topright",iconClass:"default"},onAdd:function(t){var e=this._controlCLass="dg-control-round",i=this._controlIconCLass=this._controlCLass+"__icon",o=DG.DomUtil.create("div","");if(this._disable)return o;DG.DomUtil.addClass(o,e);var n=this._link=DG.DomUtil.create("a",i+" "+i+"_name_"+this.options.iconClass,o);return n.href="#",this._renderTranslation(),this._map=t,DG.DomEvent.on(o,"click",this._toggleControl,this).on(o,"dblclick",DG.DomEvent.stopPropagation).on(n,"mousedown",DG.DomEvent.stopPropagation),this.fireEvent("add"),o},onRemove:function(){this.fireEvent("remove"),DG.DomEvent.off(this._link,"click",this._toggleControl)},setState:function(t){return this._link&&this._container?(this._state&&(DG.DomUtil.removeClass(this._container,this._controlCLass+"_state_"+this._state),DG.DomUtil.removeClass(this._link,this._controlIconCLass+"_state_"+this._state),this._state=null),t&&(this._state=t,DG.DomUtil.addClass(this._container,this._controlCLass+"_state_"+this._state),DG.DomUtil.addClass(this._link,this._controlIconCLass+"_state_"+this._state)),this):this},_toggleControl:function(t){DG.DomEvent.stop(t),this.fireEvent("click")}}),DG.RoundControl.include(DG.Locale),DG.roundControl=function(t){return new DG.RoundControl(t)};var ie9=function(){var t=document.createElement("div"),e=t.getElementsByTagName("i");return t.innerHTML="<!--[if IE 9]><i></i><![endif]-->",Boolean(e[0])}(),safari51=DG.Browser.safari&&navigator.userAgent.indexOf("Version/5.1")!==-1,wasPreviouslyDisabled=!1;try{wasPreviouslyDisabled="false"===localStorage.getItem("DGMuseum")}catch(err){}DG.Map.mergeOptions({museum:!wasPreviouslyDisabled&&(DG.Browser.ielt9||ie9||DG.Browser.opera12||safari51)}),DG.Map.Museum=DG.Handler.extend({statics:{Dictionary:{ar:{wearesorry:"لا نضمن لك تشغيل ثابت للتطبيق على متصفحك. حاول التحديث:"},cs:{wearesorry:"Nezaručujeme stabilní fungování aplikace ve Vašem prohlížeči. Zkuste provést aktualizaci:"},en:{wearesorry:"We do not guarantee stable operation of the application in your browser. Try updating:"},es:{wearesorry:"No garantizamos un funcionamiento estable de la aplicación en su buscador. Intente actualizarlo:"},it:{wearesorry:"Non garantiamo il funzionamento stabile dell'applicazione nel tuo browser. Prova ad aggiornare:"},ru:{wearesorry:"Мы не гарантируем стабильную работу приложения в вашем браузере. Попробуйте обновиться:"}}},includes:[DG.Locale],initialize:function(t){this._map=t,this._element=document.createElement("div"),this._element.className="dg-museum",this._element.innerHTML='<span></span><a class="dg-museum-browser dg-museum__chrome" target="_blank" href="https://www.google.com/chrome/"></a><a class="dg-museum-browser dg-museum__firefox" target="_blank" href="https://www.mozilla.org/firefox/new/"></a><a class="dg-museum-browser dg-museum__safari" target="_blank" href="https://support.apple.com/downloads/safari"></a><a class="dg-museum-browser dg-museum__opera" target="_blank" href="https://www.opera.com/"></a><a class="dg-museum-browser dg-museum__ie" target="_blank" href="https://windows.microsoft.com/internet-explorer/download-ie"></a>',this._text=this._element.children[0],this._closeButton=document.createElement("span"),this._closeButton.className="dg-museum__close",this._element.appendChild(this._closeButton),this._renderTranslation()},addHooks:function(){this._map.getContainer().appendChild(this._element),this._map.on("langchange",this._renderTranslation,this),DG.DomEvent.on(this._closeButton,"click",this._onCloseButtonClick,this)},removeHooks:function(){this._map.getContainer().removeChild(this._element),this._map.off("langchange",this._renderTranslation,this),DG.DomEvent.off(this._closeButton,"click",this._onCloseButtonClick,this)},_onCloseButtonClick:function(t){DG.DomEvent.stop(t);try{localStorage.setItem("DGMuseum","false")}catch(e){}this.disable()},_renderTranslation:function(){var t=this._map.getLang();this._text.innerHTML=this.t("wearesorry"),this._element.setAttribute("dir","ar"===t?"rtl":"ltr")}}),DG.Map.addInitHook("addHandler","museum",DG.Map.Museum),DG.configTheme=DG.configTheme||{},DG.configTheme.markersData={iconSize:[22,34],className:"dg-customization__marker dg-customization__marker_type_mushroom",iconAnchor:[10,32]},DG.Map.mergeOptions({bounceAtZoomLimits:!1});var controlAddTo=DG.Control.prototype.addTo;DG.Control.include({addTo:function(t){return t.on("langchange",this._renderTranslation,this),controlAddTo.call(this,t)},_renderTranslation:function(){}}),DG.Browser.safari51=DG.Browser.safari&&navigator.userAgent.indexOf("Version/5.1")!==-1;var msPointer=navigator.msPointerEnabled&&navigator.msMaxTouchPoints&&!window.PointerEvent,pointer=window.PointerEvent&&navigator.pointerEnabled&&navigator.maxTouchPoints||msPointer,documentTouch=window.DocumentTouch&&document instanceof window.DocumentTouch;DG.Browser.touchEnabled=pointer||"ontouchstart"in window||documentTouch,DG.Marker.prototype.options.icon=DG.divIcon(DG.configTheme.markersData);var utilSetOptions=DG.Util.setOptions;if(DG.setOptions=L.setOptions=DG.Util.setOptions=function(t,e){return e&&"undefined"!=typeof e.clickable&&(e.interactive=e.clickable),utilSetOptions.call(this,t,e)},DG.Layer.mergeOptions({nonBubblingEvents:["click","dblclick","mouseover","mouseout","contextmenu"]}),L.Canvas.include({_initContainer:function(){var t=this._container=document.createElement("canvas");L.DomEvent.on(t,"mousemove",this._onMouseMove,this).on(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this).on(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")}}),DG.Path){var pathInitialize=DG.Path.prototype.onAdd,loggedGeometryTypes={};DG.Path.include({onAdd:function(t){var e="Unknown";return DG.Rectangle&&this instanceof DG.Rectangle?e="Rectangle":DG.Circle&&this instanceof DG.Circle?e="Circle":DG.CircleMarker&&this instanceof DG.CircleMarker?e="CircleMarker":DG.Polygon&&this instanceof DG.Polygon?e="Polygon":DG.Polyline&&this instanceof DG.Polyline&&(e="Polyline"),loggedGeometryTypes[e]||(loggedGeometryTypes[e]=!0,void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geometry","Use",e)),pathInitialize.call(this,t)}})}var initMap=DG.Map.prototype.initialize,panBy=DG.Map.prototype.panBy,getBoundsZoom=DG.Map.prototype.getBoundsZoom,setMaxZoom=DG.Map.prototype.setMaxZoom;DG.Map.include({_tileLayersNumber:0,_mapMaxZoomCache:null,initialize:function(t,e){e=DG.extend({wheelPxPerZoomLevel:1e4},e),this.metaLayers=[],initMap.call(this,t,e),this.options.center&&void 0!==this.options.zoom&&this.setView(DG.latLng(this.options.center),this.options.zoom,{reset:!0}),this._lastMetalayer={layer:void 0,entity:void 0}},setView:function(t,e,i){if(this._restrictZoom(t,e),e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(DG.latLng(t),e,this.options.maxBounds),i=i||{},i.animate&&(i.animate=this._testAnimation(t)),this._stop(),this._loaded&&!i.reset&&i!==!0){void 0!==i.animate&&(i.zoom=DG.extend({animate:i.animate,duration:i.duration},i.zoom),i.pan=DG.extend({animate:i.animate,duration:i.duration},i.pan));var o=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,i.zoom):this._tryAnimatedPan(t,i.pan);if(o)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){var i=panBy.call(this,t,e),o=this._restrictZoom(this.getCenter());return this.getZoom()>o&&this.setZoom(o),i},getBoundsZoom:function(t,e,i){return t=DG.latLngBounds(t),this._restrictZoom(t),getBoundsZoom.call(this,t,e,i)},getTileLayersNumber:function(){return this._tileLayersNumber},setMaxZoom:function(t){return this._mapMaxZoomCache=null,setMaxZoom.call(this,t)},_testAnimation:function(t){if(this.projectDetector.enabled()){var e=this.projectDetector.getProject(),i=this.projectDetector.isProjectHere(t);if(e&&i)return e.code===i.code}return!0},_updateTileLayers:function(t){t.layer instanceof DG.TileLayer&&!t.layer._isDg&&("layeradd"===t.type?this._tileLayersNumber++:this._tileLayersNumber--)},_getNewBounds:function(t,e){if(t instanceof DG.LatLngBounds)return t;var i=this.project(t,e),o=this.getSize().divideBy(2),n=this.unproject(i.subtract(o),e),r=this.unproject(i.add(o),e);return DG.latLngBounds(n,r)},_restrictZoom:function(t,e){if(this._layers&&this.projectDetector.enabled()&&0===this._tileLayersNumber){var i=this.options,o=!!i.maxZoom,n=this.baseLayer,r=this._getNewBounds(t,e),s=this.projectDetector.isProjectHere(r);return o?(this._mapMaxZoomCache||(this.baseLayer.options.detectRetina&&DG.Browser.retina&&i.maxZoom>0&&i.maxZoom--,this._mapMaxZoomCache=i.maxZoom),i.maxZoom=this._mapMaxZoomCache&&s?this._mapMaxZoomCache:DG.config.projectLeaveMaxZoom,s&&(this._mapMaxZoomCache=i.maxZoom),i.maxZoom):(s?n.options.detectRetina&&DG.Browser.retina&&s.maxZoom>0?n.options.maxZoom=s.maxZoom-1:n.options.maxZoom=s.maxZoom:n.options.maxZoom=DG.config.projectLeaveMaxZoom,n.options.maxNativeZoom=n.options.maxZoom,this._updateZoomLevels(),n.options.maxZoom)}},_fireDOMEvent:function(t,e,i){if(13!==t.keyCode){if("click"===t.type){var o=L.Util.extend({},t);o.type="preclick",this._fireDOMEvent(o,o.type,i)}if(!t._stopped&&(i=(i||[]).concat(this._findEventTargets(t,e)),i.length)){var n=i[0];"contextmenu"===e&&n.listens(e,!0)&&L.DomEvent.preventDefault(t);var r={originalEvent:t,eventTargets:i,eventTargetsMapIndex:i.indexOf(this)};if("keypress"!==t.type){var s=n instanceof L.Marker;r.containerPoint=s?this.latLngToContainerPoint(n.getLatLng()):this.mouseEventToContainerPoint(t),r.layerPoint=this.containerPointToLayerPoint(r.containerPoint),r.latlng=s?n.getLatLng():this.layerPointToLatLng(r.layerPoint)}for(var a=0;a<i.length;a++){if(i[a]===this){var l=this._getCurrentMetaLayer(r);"mousemove"===e?this._lastMetalayer.entity&&l.entity&&this._lastMetalayer.entity.id===l.entity.id?this._fireMetalayerEvent("mousemove",l,r):(this._fireMetalayerEvent("mouseout",this._lastMetalayer,r),this._fireMetalayerEvent("mouseover",l,r),this._fireMetalayerEvent("mousemove",l,r),this._lastMetalayer=l):this._fireMetalayerEvent(e,l,r),r.originalEvent._stopped||i[a].fire(e,r,!0)}else i[a].fire(e,r,!0),this._lastMetalayer.entity&&r.originalEvent._stopped&&(this._fireMetalayerEvent("mouseout",this._lastMetalayer,r),this._lastMetalayer={layer:void 0,entity:void 0});if(r.originalEvent._stopped||i[a].options.nonBubblingEvents&&L.Util.indexOf(i[a].options.nonBubblingEvents,e)!==-1)return}}}},_getCurrentMetaLayer:function(t){var e=t.originalEvent.target||t.originalEvent.srcElement,i="click"===t.originalEvent.type;if(e===this._container||DG.Browser.ie&&"leaflet-tile leaflet-tile-loaded"===e.className||"CANVAS"===e.tagName)for(var o=this.metaLayers.length-1;o>=0;o--){var n=this.metaLayers[o].getHoveredObject(t);if(n)return{layer:this.metaLayers[o],entity:n};if(i)return{layer:this.metaLayers[o],entity:void 0}}return{layer:void 0,entity:void 0}},_fireMetalayerEvent:function(t,e,i){if((e.entity||"click"===t)&&e.layer){var o=e.layer.mapEvents[t];o&&(i.entity=e.entity,o.call(e.layer,i))}}}),DG.Map.addInitHook(function(){this.on("layeradd layerremove",this._updateTileLayers)}),DG.Map.addInitHook(function(){0==this.options.dragging&&0==this.options.tap&&DG.DomUtil.addClass(this._container,"dg-dragging-false")}),DG.Map.addInitHook(function(){function t(){var t=this.getLang(),o=this.projectDetector&&this.projectDetector.getProject();"ru"!==t||o?this.baseLayer.options.errorTileUrl=e:this.baseLayer.options.errorTileUrl=i,""===u&&"ar"===t&&o&&"ae"===o.country_code?(u="ar",this.baseLayer.setUrl(s),this.baseLayer.setPreviewUrl&&this.baseLayer.setPreviewUrl(l)):"ar"!==u||"ar"===t&&o&&"ae"===o.country_code||(u="",this.baseLayer.setUrl(r),this.baseLayer.setPreviewUrl&&this.baseLayer.setPreviewUrl(a))}var e="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX28t5R0k5UAAAAH0lEQVR4Xu3AAQkAAADCMPunNsdhWxwAAAAAAAAAwAEhAAABg2UP5AAAAABJRU5ErkJggg==",i=DG.config.protocol+DG.config.baseUrl+"/img/nomap_ru.png",o=DG.Browser.mobile?DG.MobileTileLayer:DG.TileLayer,n=o.extend({initialize:function(t,e){this._isDg=!0,o.prototype.initialize.call(this,t,e)},getTiles:function(){return this._tiles}}),r=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTileServer:DG.config.tileServer),s=DG.config.protocol+(DG.Browser.retina?DG.config.arabicRetinaTileServer:DG.config.arabicTileServer),a=DG.config.protocol+(DG.Browser.retina?DG.config.previewRetinaTileServer:DG.config.previewTileServer),l=DG.config.protocol+(DG.Browser.retina?DG.config.arabicPreviewRetinaTileServer:DG.config.arabicPreviewTileServer);this.baseLayer=new n(r,{subdomains:"0123",errorTileUrl:"ru"===this.getLang()?i:e,detectRetina:DG.config.detectRetina,maxZoom:19,maxNativeZoom:19,zIndex:0,updateWhenIdle:!1,previewUrl:a});var u="";t.call(this),this.baseLayer.addTo(this),this.on({langchange:t,projectchange:t,projectleave:t},this)}),DG.Map.mergeOptions({tilesCheck:!0}),DG.Map.TilesCheck=DG.Handler.extend({initialize:function(t){this._map=t,this._layer=t.baseLayer,this._moveStartEventCounter=0,this._moveEndEventCounter=0,this._loadingEventCounter=0,this._loadEventCounter=0},addHooks:function(){this._map.on(this._mapEvents,this),this._layer.on(this._layerEvents,this)},removeHooks:function(){this._map.off(this._mapEvents,this),this._layer.off(this._layerEvents,this)},_mapEvents:{layeradd:function(t){t.layer==this._layer&&this.enable()},layerremove:function(t){t.layer==this._layer&&this.disable()},movestart:function(){this._stopWaiting(),this._moveStartEventCounter++,this._isWaiting=!0},moveend:function(){this._moveEndEventCounter++,(this._isWaiting||this._moveStartEventCounter===this._moveEndEventCounter)&&(this._isMoveEnd=!0,this._checkWaiting())}},_layerEvents:{loading:function(){this._loadingEventCounter++},load:function(){this._loadEventCounter++,(this._isWaiting||this._loadingEventCounter===this._loadEventCounter)&&(this._isLoad=!0,this._checkWaiting())}},_stopWaiting:function(){this._isWaiting=!1,this._isMoveEnd=!1,this._isLoad=!1},_checkWaiting:function(){this._isWaiting&&this._isLoad&&this._isMoveEnd&&(this._stopWaiting(),this._resetCounters(),this._checkTiles())},_checkTiles:function(){if(0===this._map.getTileLayersNumber()&&this._map._loaded){var t=this._layer._tileZoom,e=this._layer.options.errorTileUrl,i=this._layer.getTiles();for(var o in i)if(i[o].coords.z===t&&i[o].el.src!==e)return;this._map.zoomOut()}},_resetCounters:function(){this._moveStartEventCounter=0,this._moveEndEventCounter=0,this._loadingEventCounter=0,this._loadEventCounter=0}}),DG.Map.addInitHook("addHandler","tilesCheck",DG.Map.TilesCheck);var onDragEnd=DG.Map.Drag.prototype._onDragEnd;DG.Map.Drag.include({_rememberTimeAndPosition:function(){var t=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos;for(this._positions.push(e),this._times.push(t);t-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onDrag:function(t){this._map.options.inertia&&this._rememberTimeAndPosition(),this._map.fire("move",t).fire("drag",t)},_onDragEnd:function(){this._map.options.inertia&&!DG.Browser.touch&&this._rememberTimeAndPosition(),onDragEnd.call(this)}}),DG.PolyUtil.inside=function(t,e,i){i=i||DG.PolyUtil._defaultPointReduce;var o=e.coordinates,n=i(t);"Polygon"===e.type&&(o=[o]);for(var r=!1,s=0;s<o.length&&!r;){if(this._inRing(n,o[s][0],i)){for(var a=!1,l=1;l<o[s].length&&!a;)this._inRing(n,o[s][l],i)&&(a=!0),l++;a||(r=!0)}s++}return r},DG.PolyUtil._inRing=function(t,e,i){for(var o=!1,n=0,r=e.length-1;n<e.length;r=n++){var s=i(e[n]),a=i(e[r]),l=s[0],u=s[1],c=a[0],h=a[1],d=u>t[1]!=h>t[1]&&t[0]<(c-l)*(t[1]-u)/(h-u)+l;d&&(o=!o)}return o},DG.PolyUtil._defaultPointReduce=function(t){return t},DG.Browser.mobile&&!function(){var t=L.DomUtil.addClass;L.DomUtil.addClass=function(e,i){"leaflet-dragging"!==i&&"leaflet-drag-target"!==i&&t(e,i)};var e=L.DomUtil.removeClass;L.DomUtil.removeClass=function(t,i){"leaflet-dragging"!==i&&"leaflet-drag-target"!==i&&e(t,i)},L.Draggable.include({_onMove:function(t){if(!t._simulated&&this._enabled){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=new L.Point(e.clientX,e.clientY),o=i.subtract(this._startPoint);if((o.x||o.y)&&!(Math.abs(o.x)+Math.abs(o.y)<this.options.clickTolerance)){L.DomEvent.preventDefault(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=L.DomUtil.getPosition(this._element).subtract(o),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement));var n=this._startPos.add(o)._round();this._moving=!0,L.Util.cancelAnimFrame(this._animRequest),this._lastEvent=t,this._newPos&&this._newPos.x==n.x&&this._newPos.y==n.y||(this._newPos=n,this._animRequest=L.Util.requestAnimFrame(this._updatePosition,this,!0))}}}}),L.Map.Drag.include({_onDragEnd:function(t){var e=this._map,i=e.options,o=!i.inertia||this._times.length<2;if(e.fire("dragend",t),o)e.fire("moveend");else{var n=this._lastPos.subtract(this._positions[0]),r=(this._lastTime-this._times[0])/1e3,s=i.easeLinearity,a=n.multiplyBy(s/r),l=a.distanceTo([0,0]),u=Math.min(i.inertiaMaxSpeed,l),c=a.multiplyBy(u/l),h=1,d=c.multiplyBy(-h/2).round();d.x||d.y?(d=e._limitOffset(d,e.options.maxBounds),L.Util.requestAnimFrame(function(){e.panBy(d,{duration:h,easeLinearity:s,noMoveStart:!0,animate:!0})})):e.fire("moveend")}}})}(),L.MobileTileLayer=L.TileLayer.extend({initialize:function(t,e){L.TileLayer.prototype.initialize.call(this,t,e),this._previewUrl=e.previewUrl},setPreviewUrl:function(t){this._previewUrl=t,this.redraw()},createTile:function(t,e,i){var o=document.createElement("img");return o.onload=L.bind(this._tileOnLoad,this,e,o),o.onerror=L.bind(this._tileOnError,this,e,o),this.options.crossOrigin&&(o.crossOrigin=""),o.alt="",o.src=this.getTileUrl(t,i),o},_initTile:function(t){t.style.position="absolute";var e=this.getTileSize();return t.style.width=e.x+"px",t.style.height=e.y+"px",t.style.visibility="hidden",t.style.pointerEvents="none",t.onselectstart=L.Util.falseFn,t.onmousemove=L.Util.falseFn,L.Browser.android&&!L.Browser.android23&&(t.style.WebkitBackfaceVisibility="hidden"),t},_updateLevels:function(){var t=this._tileZoom,e=this.options.maxZoom;if(void 0!==t){for(var i in this._levels)this._levels[i].el.children.length||i===t?this._levels[i].el.style.zIndex=e-Math.abs(t-i):(L.DomUtil.remove(this._levels[i].el),this._removeTilesAtZoom(i),delete this._levels[i]);var o=this._levels[t],n=this._map;return o||(o=this._levels[t]={},o.el=L.DomUtil.create("div","leaflet-zoom-animated",this._container),o.el.style.zIndex=e,o.origin=n.project(n.unproject(n.getPixelOrigin()),t).round(),o.zoom=t,this._setZoomTransform(o,n.getCenter(),n.getZoom()),L.Util.falseFn(o.el.offsetWidth)),this._level=o,o}},_update:function(t){var e=this._map;if(e){var i=e.getZoom();if(void 0===t&&(t=e.getCenter()),void 0!==this._tileZoom){var o=this._getTiledPixelBounds(t),n=this._pxBoundsToTileRange(o),r=n.getCenter(),s=[],a=this.options.keepBuffer,l=new L.Bounds(n.getBottomLeft().subtract([a,-a]),n.getTopRight().add([a,-a]));for(var u in this._tiles){var c=this._tiles[u].coords;c.z===this._tileZoom&&l.contains(L.point(c.x,c.y))||(this._tiles[u].current=!1)}if(Math.abs(i-this._tileZoom)>1)return void this._setView(t,i);for(var h=n.min.y;h<=n.max.y;h++)for(var d=n.min.x;d<=n.max.x;d++){var p=new L.Point(d,h);if(p.z=this._tileZoom,this._isValidTile(p)){var _=this._tiles[this._tileCoordsToKey(p)];_?_.current=!0:s.push(p)}}if(s.sort(function(t,e){return t.distanceTo(r)-e.distanceTo(r)}),0!==s.length)for(this._loading||(this._loading=!0,this.fire("loading")),d=0;d<s.length;d++)this._addTile(s[d],this._level.el)}}},_needPreviewTile:function(t){return this._tileZoom-this._map.getZoom()>0?!this._existTileFromLowerZoom(t):!this._existTilesFromHigherZoom(t)},_existTileFromLowerZoom:function(t){var e=L.point(t.x/2,t.y/2)._floor();e.z=t.z-1;var i=this._tileCoordsToKey(e),o=this._tiles[i];return o&&!o.preview},_existTilesFromHigherZoom:function(t){for(var e=t.x,i=t.y,o=2*e;o<2*e+2;o++)for(var n=2*i;n<2*i+2;n++){var r=new L.Point(o,n);r.z=t.z+1;var s=this._tileCoordsToKey(r);if(!this._tiles[s])return!1}return!0},_addTile:function(t,e){var i=this._getTilePos(t),o=this._tileCoordsToKey(t),n=this._wrapCoords(t),r=this._needPreviewTile(n),s=r?this._previewUrl:this._url,a=this.createTile(n,L.bind(this._tileReady,this,t),s);this._initTile(a),L.DomUtil.setPosition(a,i),this._tiles[o]={el:a,preview:r,coords:t,current:!0},e.appendChild(a),this.fire("tileloadstart",{tile:a,coords:t})},_tileReady:function(t,e,i){if(this._map){e&&this.fire("tileerror",{error:e,tile:i,coords:t});var o=this._tileCoordsToKey(t);i=this._tiles[o],i&&(i.originalEl&&i.el.parentNode?(i.el.parentNode.replaceChild(i.originalEl,i.el),i.el=i.originalEl,i.originalEl=null,i.preview=!1):i.preview&&(i.originalEl=this.createTile(this._wrapCoords(t),L.bind(this._tileReady,this,t),this._url),this._initTile(i.originalEl),L.DomUtil.setPosition(i.originalEl,this._getTilePos(t))),i.loaded=+new Date,i.active=!0,this._pruneTiles(),e||(i.el.style.visibility="",this.fire("tileload",{tile:i.el,preview:i.preview,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),L.Browser.ielt9||!this._map._fadeAnimated?L.Util.requestAnimFrame(this._pruneTiles,this):setTimeout(L.bind(this._pruneTiles,this),250)))}},getTileUrl:function(t,e){var i={r:L.Browser.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var o=this._globalTileRange.max.y-t.y;this.options.tms&&(i.y=o),i["-y"]=o}return L.Util.template(e,L.extend(i,this.options))}}),DG.Control.Zoom.include(DG.Locale),DG.Control.Zoom.Dictionary={},DG.Control.Zoom.include({onAdd:function(t){var e="dg-zoom",i='<div class="dg-control-round__icon '+e+"__control "+e+"__button "+e+'__button_type_{type}"></div>',o=DG.DomUtil.create("div",e);return this._map=t,this._zoomInButton=this._createButton(DG.Util.template(i,{type:"in"}),this.t("zoom_in"),"dg-control-round "+e+"__in",o,this._zoomIn,this),this._zoomOutButton=this._createButton(DG.Util.template(i,{type:"out"}),this.t("zoom_out"),"dg-control-round "+e+"__out",o,this._zoomOut,this),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),o},_originalCreateButton:DG.Control.Zoom.prototype._createButton,_createButton:function(){var t=Array.prototype.slice.call(arguments),e=this._originalCreateButton.apply(this,t),i=e.children[0],o="dg-control-round_state_active",n="dg-control-round__icon_state_active";return DG.DomEvent.on(e,"touchstart",function(){DG.DomUtil.addClass(e,o),DG.DomUtil.addClass(i,n)}).on(e,"touchend touchcancel",function(){DG.DomUtil.removeClass(e,o),DG.DomUtil.removeClass(i,n)}),e},_renderTranslation:function(){this._zoomInButton&&this._zoomOutButton&&(this._zoomInButton.title=this.t("zoom_in"),this._zoomOutButton.title=this.t("zoom_out"))}}),DG.Control.Zoom.Dictionary.ru={zoom_in:"Приблизить",zoom_out:"Отдалить"},DG.Control.Zoom.Dictionary.it={zoom_in:"Zoom avanti",zoom_out:"Zoom indietro"},DG.Control.Zoom.Dictionary.cs={zoom_in:"Přiblížit",zoom_out:"Oddálit"},DG.Control.Zoom.Dictionary.en={zoom_in:"Zoom in",zoom_out:"Zoom out"},DG.Control.Zoom.Dictionary.es={zoom_in:"Acercar",zoom_out:"Alejar"},DG.Control.Zoom.Dictionary.ar={zoom_in:"",zoom_out:""};var dust=_dereq_("dustjs-linkedin");_dereq_("dustjs-helpers"),DG.dust=function(t,e){var i;return dust.render(t,e,function(t,e){i=e}),i},DG.Control.Attribution.include(DG.Locale),DG.Control.Attribution.Dictionary={},DG.Control.Attribution.include({options:{position:"bottomright"},_getLink:function(t){var e={ru:{copyright_logo:"http://info.2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://api.2gis.ru/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.ru/api-rules/"},it:{copyright_logo:"http://2gis.it/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://2gis.it/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.it/licensing-agreement/"},cz:{copyright_logo:"http://praha.2gis.cz/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://praha.2gis.cz/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.cz/api-rules/"},cl:{copyright_logo:"http://santiago.2gis.cl/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://santiago.2gis.cl/?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.cl/api-rules/"},cy:{copyright_logo:"http://info.2gis.com.cy/lemesos?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://info.2gis.com.cy/lemesos?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.com.cy/api-rules/"},ae:{copyright_logo:"http://info.2gis.ae/dubai?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_apilink:"http://info.2gis.ae/dubai?utm_source=copyright&utm_medium=map&utm_campaign=partners",copyright_license:"http://law.2gis.ae/api-rules/"}},i=this._countryCode in e?this._countryCode:"ru";return e[i][t]},onAdd:function(t){t._copyright||(t._copyright=!0,this._first=!0),t.attributionControl=this,this._container=DG.DomUtil.create("div","dg-attribution"),DG.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return this._update(),this._container},_update:function(t,e,i){if(this._map){"undefined"!=typeof e&&(this._osm=e),"undefined"!=typeof i&&(this._countryCode=i);var o=[];for(var n in this._attributions)this._attributions[n]&&o.push(n);var r=[],s="";this._first&&(s=this._getAttributionHTML(t)),this.options.prefix&&r.push(this.options.prefix),o.length&&r.push(o.join(", ")),this._container.innerHTML=s+r.join(" | ")}},_getData:function(t){return t=t||this._map.getLang(),{osm:this._osm,work_on:this.t("work_on"),work_on_with_osm:this.t("work_on_with_osm"),lang:t,copyright_apilink:this._getLink("copyright_apilink"),copyright_license:this._getLink("copyright_license"),copyright_logo:this._getLink("copyright_logo"),license_agreement:this.t("license_agreement"),dir:"ar"!==t?"ltr":"rtl"}},_getAttributionHTML:function(t){return DG.dust("DGAttribution/copyright",this._getData(t))},_renderTranslation:function(t){this._update(t.lang)}}),DG.Map.addInitHook(function(){this._copyright||DG.control.attribution().addTo(this)}),DG.Control.Attribution.Dictionary.ru={license_agreement:"Лицензионное соглашение",work_on:"Работает на API 2ГИС",work_on_with_osm:"API 2ГИС"},DG.Control.Attribution.Dictionary.it={license_agreement:"Accordo di licenza",work_on:"2GIS API",work_on_with_osm:"2GIS API"},DG.Control.Attribution.Dictionary.cs={license_agreement:"Licenční smlouva",work_on:"Pracuje na API 2GIS",work_on_with_osm:"API 2GIS"},DG.Control.Attribution.Dictionary.en={license_agreement:"License agreement",work_on:"Uses 2GIS API",work_on_with_osm:"2GIS API"},DG.Control.Attribution.Dictionary.es={license_agreement:"Acuerdo de licencia",
	work_on:"2GIS API",work_on_with_osm:"2GIS API"},DG.Control.Attribution.Dictionary.ar={license_agreement:"إتفاقية ترخيص",work_on:"يعمل بتطبيق 2GIS",work_on_with_osm:"API 2GIS"},DG.Control.Location=DG.RoundControl.extend({statics:{Dictionary:{}},options:{iconClass:"locate",position:DG.Browser.mobile?"bottomright":"topleft",drawCircle:!0,follow:!0,stopFollowingOnDrag:!1,metric:!0,onLocationError:function(){},onLocationOutsideMapBounds:function(){},locateOptions:{}},initialize:function(t){return DG.Util.setOptions(this,t),navigator.geolocation?(this._event=void 0,this._locateOptions={watch:!0,setView:!0,maximumAge:1/0,maxZoom:1/0},DG.extend(this._locateOptions,this.options.locateOptions),this._resetVariables(),void this.on({click:this._handleLocate,add:this._initLocate})):void(this._disable=!0)},_initLocate:function(){this._layer=new DG.LayerGroup,this._layer.addTo(this._map),this._map.on({locationfound:this._onLocationFound,locationerror:this._onLocationError},this)},_handleLocate:function(){this._active&&(!this._event||this._map.getBounds().contains(this._event.latlng)||this._isOutsideMapBounds())?this._stopLocate():(this._locateOnNextLocationFound=!0,this._active||this._map.locate(this._locateOptions),this._active=!0,this.options.follow&&this._startFollowing(),this._clearError(),this._event?this._visualizeLocation():this.setState("requesting"))},_onLocationFound:function(t){this._event&&this._event.latlng.lat===t.latlng.lat&&this._event.latlng.lng===t.latlng.lng&&this._event.accuracy===t.accuracy||this._active&&(this._event=t,this.options.follow&&this._following&&(this._locateOnNextLocationFound=!0),this._visualizeLocation())},_startFollowing:function(){this._following=!0,this.options.stopFollowingOnDrag&&this._map.on("dragstart",this._stopFollowing)},_stopFollowing:function(){this._following=!1,this.options.stopFollowingOnDrag&&this._map.off("dragstart",this._stopFollowing),this._visualizeLocation()},_isOutsideMapBounds:function(){return void 0!==this._event&&(this._map.options.maxBounds&&!this._map.options.maxBounds.contains(this._event.latlng))},_visualizeLocation:function(){void 0===this._event.accuracy&&(this._event.accuracy=0);var t=this._event.accuracy;if(this._locateOnNextLocationFound){if(this._isOutsideMapBounds())this.options.onLocationOutsideMapBounds(this);else if(this._locateOptions.setView){var e=this._map.projectDetector.getProject().maxZoom||DG.config.projectLeaveMaxZoom;e=Math.min(this._locateOptions.maxZoom,e),this._map.setView(this._event.latlng,e)}this._locateOnNextLocationFound=!1}var i={clickable:!1,color:"#FFF",fillColor:"#FFF",fillOpacity:.4,weight:0,opacity:.3};this.options.drawCircle&&(this._circle?this._circle.setLatLng(this._event.latlng).setRadius(t):this._circle=DG.circle(this._event.latlng,t,i).addTo(this._layer));var o="dg-location__pin";o+=this._following?" "+o+"state_following":"";var n={icon:DG.divIcon({className:o,iconSize:[20,20]})};this._marker?this._marker.setLatLng(this._event.latlng):this._marker=DG.marker(this._event.latlng,n).bindLabel(this.t("you_are_here")).addTo(this._layer),DG.DomEvent.on(this._marker,"click",function(){this._map.fireEvent("dgLocateClick")},this),this._container&&this.setState("active")},_resetVariables:function(){this._active=!1,this._following=!1},_stopLocate:function(){this._map.stopLocate(),this._map.off("dragstart",this._stopFollowing),this.setState(),this._resetVariables(),this._layer.clearLayers(),this._marker=void 0,this._circle=void 0,this._event=void 0},_onLocationError:function(t){if(3!==t.code||!this._locateOptions.watch){this._stopLocate(),this._error=DG.DomUtil.create("div","dg-label dg-label_name_location-error",this._container),this._errorText=DG.DomUtil.create("div","dg-label__content",this._error),this._errorText.innerHTML=this.t("cant_find");var e=this;setTimeout(function(){e._clearError()},3e3),this.options.onLocationError(t)}},_clearError:function(){this._error&&(this._container.removeChild(this._error),this._error=void 0,this._errorText=void 0)},_renderTranslation:function(){this._link&&(this._link.title=this.t("button_title")),this._marker&&this._marker.bindLabel(this.t("you_are_here"))}}),DG.control.location=function(t){return new DG.Control.Location(t)},DG.Map.addInitHook(function(){this.options.locationControl&&(this.locationControl=DG.control.location(this.options.locationControl),this.addControl(this.locationControl))}),DG.Control.Location.Dictionary.ru={cant_find:"Мы не смогли Вас найти",you_are_here:"Вы здесь",button_title:"Найти Вас на карте"},DG.Control.Location.Dictionary.it={cant_find:"Non siamo riusciti a localizzarti",you_are_here:"Voi siete qui",button_title:"Trova la tua posizione sulla mappa"},DG.Control.Location.Dictionary.cs={cant_find:"Nepodařilo se nám určit Vaši polohu",you_are_here:"Jste tady",button_title:"Určit Vaši polohu na mapě"},DG.Control.Location.Dictionary.en={cant_find:"We can't find you",you_are_here:"You are here",button_title:"Show your location"},DG.Control.Location.Dictionary.es={cant_find:"No pudimos encontrarte",you_are_here:"Tú estás aquí",button_title:"Encontrarte en el mapa"},DG.Control.Location.Dictionary.ar={cant_find:"لم نستطع تحديد موقعك",you_are_here:"أنت هنا",button_title:"موقعي"},DG.Screenfull=DG.Class.extend({_apiMap:[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],initialize:function(){this.api=this._api()},request:function(t){var e=this.api.requestFullscreen;t=t||document.documentElement,t[e](Element.ALLOW_KEYBOARD_INPUT)},exit:function(){document[this.api.exitFullscreen]()},isFullscreen:function(){return!!document[this.api.fullscreenElement]},isAvailable:function(){return Boolean(this.api)},_api:function(){var t={},e=this._apiMap;return e.forEach(function(i){i&&i[1]in document&&i.forEach(function(i,o){t[e[0][o]]=i})}),!!t.requestFullscreen&&t}}),DG.screenfull=new DG.Screenfull,DG.Control.Fullscreen=DG.RoundControl.extend({statics:{Dictionary:{}},options:{position:"topright",iconClass:"fullscreen"},initialize:function(t){DG.Util.setOptions(this,t),this._isFullscreen=!1,this.on("click",this._toggleFullscreen)},_toggleFullscreen:function(){this._isFullscreen?this._toggle(!1,"exit","on","cancelfullscreen"):this._toggle(!0,"request","on","requestfullscreen"),this._renderTranslation(),this._map.invalidateSize()},_renderTranslation:function(){this._link.title=this.t(this._isFullscreen?"title_min":"title_max")},_toggle:function(t,e,i,o){var n=this._map._container;this._isFullscreen=t,this.setState(t?"active":""),DG.screenfull[e](n),DG.DomEvent[i](document,DG.screenfull.api.fullscreenchange,this._onFullScreenStateChange,this),this._map.fire(o)},_onFullScreenStateChange:function(){DG.screenfull.isFullscreen()||this._toggle(!1,"exit","on","cancelfullscreen")}}),DG.control.fullscreen=function(t){return new DG.Control.Fullscreen(t)},DG.Map.mergeOptions({fullscreenControl:!0}),DG.Map.addInitHook(function(){this.options.fullscreenControl&&(this.fullscreenControl=DG.control.fullscreen(this.options.fullscreenControl),DG.screenfull.isAvailable()&&this.addControl(this.fullscreenControl))}),DG.Control.Fullscreen.Dictionary.ru={title_max:"Развернуть",title_min:"Восстановить"},DG.Control.Fullscreen.Dictionary.it={title_max:"Espandi",title_min:"Ripristina"},DG.Control.Fullscreen.Dictionary.cs={title_max:"Rozbalit",title_min:"Obnovit"},DG.Control.Fullscreen.Dictionary.en={title_max:"Expand",title_min:"Restore"},DG.Control.Fullscreen.Dictionary.es={title_max:"Maximizar",title_min:"Restaurar"},DG.Control.Fullscreen.Dictionary.ar={title_max:"",title_min:""},DG.Meta={},DG.Meta.Layer=DG.Layer.extend({options:{tileSize:256,minZoom:0,maxZoom:19,zoomOffset:0,eventBubbling:"transparent"},initialize:function(t,e){DG.TileLayer.prototype.initialize.call(this,null,e),delete this._url,this._currentTileKey="",this._currentTileData=[],this._lastEntity=void 0,this._dispatchMouseEvents=!0,this._origin=DG.Meta.origin(t,{dataFilter:this.options.dataFilter})},getOrigin:function(){return this._origin},onAdd:function(t){this._resetView(),t.metaLayers.push(this),t.on("rulerstart",this._disableDispatchMouseEvents,this),t.on("rulerend",this._enableDispatchMouseEvents,this);var e=this;DG.Browser.touchEnabled&&this.options.isPoi&&t.eachLayer(function(t){if(t instanceof L.TileLayer){t.on("tileloadstart",e._onTileLoadStart,e);for(var i in t._tiles)e._onTileLoadStart({coords:t._tiles[i].coords})}})},onRemove:function(t){var e=this;DG.Browser.touchEnabled&&this.options.isPoi&&t.eachLayer(function(t){t instanceof L.TileLayer&&t.off("tileloadstart",e._onTileLoadStart)}),this._tileZoom=null;var i=t.metaLayers.indexOf(this);i!==-1&&t.metaLayers.splice(i,1),t.off("rulerstart",this._disableDispatchMouseEvents,this),t.off("rulerend",this._enableDispatchMouseEvents,this)},getEvents:function(){return{viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd}},setUrl:function(t){this._currentTileKey="",this._currentTileData=[],this._lastEntity=void 0,this._dispatchMouseEvents=!0,this._origin.setURL(t,!0)},getHoveredObject:function(t){var e,i=this.getTileSize(),o=this._map.mouseEventToLayerPoint(t.originalEvent),n=this._map.getPixelOrigin().add(o),r=n.unscaleBy(i).floor(),s=DG.point(n.x%i.x,n.y%i.y),a=this._map.getZoom(),l=this;if(!(a>this.options.maxZoom+this.options.zoomOffset||a<this.options.minZoom-this.options.zoomOffset)&&this._isValidTile(r))return this._wrapCoords(r),r.z=this._getZoomForUrl(),r.key=i.x+"x"+i.y,e=this._origin.getTileKey(r),e===this._currentTileKey?l._lastEntity=l._getHoveredObject(s):this._origin.getTileData(r,function(t){l._currentTileKey=e,l._currentTileData=t,l._lastEntity=l._getHoveredObject(s)}),this._lastEntity},_removeAllTiles:DG.GridLayer.prototype._removeAllTiles,_getZoomForUrl:DG.TileLayer.prototype._getZoomForUrl,getTileSize:DG.TileLayer.prototype.getTileSize,_isValidTile:DG.GridLayer.prototype._isValidTile,_wrapCoords:DG.GridLayer.prototype._wrapCoords,_resetView:DG.GridLayer.prototype._resetView,_resetGrid:DG.GridLayer.prototype._resetGrid,_invalidateAll:DG.GridLayer.prototype._invalidateAll,_pxBoundsToTileRange:DG.GridLayer.prototype._pxBoundsToTileRange,_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._resetView()},_onTileLoadStart:function(t){var e=this.getTileSize();t.coords.key=e.x+"x"+e.y,this._origin.getTileData(t.coords)},_enableDispatchMouseEvents:function(){this._dispatchMouseEvents=!0},_disableDispatchMouseEvents:function(){this._dispatchMouseEvents=!1},mapEvents:{mousemove:function(t){this._fireMetalayerEvent("mousemove",t)},mouseover:function(t){this._fireMetalayerEvent("mouseover",t)},mouseout:function(t){this._fireMetalayerEvent("mouseout",t),this._currentTileKey=""},click:function(t){var e=this.getTileSize(),i=this._map.mouseEventToLayerPoint(t.originalEvent),o=this._map.getPixelOrigin().add(i),n=o.unscaleBy(e).floor(),r=DG.point(o.x%e.x,o.y%e.y);n.z=this._getZoomForUrl(),n.key=e.x+"x"+e.y;var s=this._origin.getTileKey(n),a=this,l=function(e){a._currentTileData=e,a._currentTileKey=s,a._lastEntity=a._getHoveredObject(r),a._mouseDown=!1,a._lastEntity&&(t.entity=a._lastEntity,a._fireMetalayerEvent("click",t))};this._origin.getTileData(n,function(e){e?l(e):a._origin._requests[s]&&(DG.DomEvent.stop(t),a._origin._requests[s].then(function(){if(delete t.originalEvent._stopped,l(a._origin._tileStorage[s]),!t.originalEvent._stopped)for(var e=t.eventTargets,i=t.eventTargetsMapIndex;i<e.length;i++)if(e[i].fire("click",t,!0),t.originalEvent._stopped||e[i].options.nonBubblingEvents&&L.Util.indexOf(e[i].options.nonBubblingEvents,"click")!==-1)return}))})},dblclick:function(t){this._fireMetalayerEvent("dblclick",t)},mousedown:function(t){this._mouseDown=!0,this._fireMetalayerEvent("mousedown",t)},contextmenu:function(t){this._fireMetalayerEvent("contextmenu",t)}},_fireMetalayerEvent:function(t,e){if(e.entity&&this._dispatchMouseEvents){this.fire(t,{meta:e.entity,latlng:this._map.mouseEventToLatLng(e.originalEvent)});var i="mousedown"===t||this._mouseDown&&"mousemove"===t;"layer"!==this.options.eventBubbling||i||DG.DomEvent.stop(e)}},_getHoveredObject:function(t){if(this._currentTileData)for(var e=0;e<this._currentTileData.length;e++)if(DG.PolyUtil.inside(t,this._currentTileData[e].geometry,this._pointReduceHelper))return this._currentTileData[e]},_pointReduceHelper:function(t){return[t.x,t.y]},_setView:function(t,e,i,o){var n=Math.round(e),r=this._tileZoom!==n;!o&&r&&(this._tileZoom=n,this._resetGrid())}}),DG.Meta.layer=function(t,e){return new DG.Meta.Layer(t,e)},DG.Meta.Origin=DG.Class.extend({options:{subdomains:"0123",dataFilter:null},_url:!1,initialize:function(t,e){this._url=t,this._requests={},this._tileStorage={},e=DG.setOptions(this,e),"string"==typeof e.subdomains&&(e.subdomains=e.subdomains.split(""))},getTileData:function(t,e){var i=this.getTileKey(t),o=this,n="function"==typeof e?e:function(){};if("undefined"==typeof this._tileStorage[i]&&"undefined"==typeof this._requests[i]){this._tileStorage[i]=!1;var r=this._requests[i]=this._requestData(t).then(function(e){return o._requests[i]!==r?void n(!1):(o.setTileData(i,o.options.dataFilter?o.options.dataFilter(e,t):e),delete o._requests[i],void n(o._tileStorage[i]))})}else n(this._tileStorage[i])},setTileData:function(t,e){return"string"!=typeof t&&(t=this.getTileKey(t)),e.forEach(function(e){e.geometry.constructor!==Object&&(e.geometry=DG.Wkt.toGeoJSON(e.geometry)),this._tileStorage[t]||(this._tileStorage[t]=[]),this._tileStorage[t].push(e)},this),this},flush:function(){return this._tileStorage={},Object.keys(this._requests).forEach(function(t){this[t].abort&&this[t].abort()},this._requests),this._requests={},this},setURL:function(t,e){return this._url=t,e&&this.flush(),this},getTileKey:function(t){return[t.x,t.y,t.z,t.key].join(":")},_requestData:function(t){return this._url?this._performRequest(t):Promise.resolve([])},_performRequest:function(t){return DG.ajax(this._prepareURL(t),{type:"get",dataType:"json"})},_prepareURL:function(t){return DG.Util.template(this._url,{x:t.x,y:t.y,z:t.z,s:this._getSubdomain(t)})},_getSubdomain:DG.TileLayer.prototype._getSubdomain}),DG.Meta.origin=function(t,e){return new DG.Meta.Origin(t,e)},DG.Map.mergeOptions({poi:!0}),DG.Poi=DG.Handler.extend({options:{disableLabel:!1},initialize:function(t,e){this._map=t,DG.Util.setOptions(this,e);var i=DG.config.protocol+(DG.Browser.retina?DG.config.retinaPoiMetaServer:DG.config.poiMetaServer);this._metaLayer=DG.Meta.layer(i,{minZoom:DG.config.poiLayerMinZoom,maxNativeZoom:19,detectRetina:DG.config.detectRetina,eventBubbling:"layer",dataFilter:DG.bind(this._processData,this),isPoi:!0}),this._currentTilesLang=""},addHooks:function(){this._map.addLayer(this._metaLayer),this.options.disableLabel||(this._labelHelper=DG.label()),this._metaLayer.on(this._layerEventsListeners,this),this._map.on("langchange",this._updateUrl,this),this._map.on("projectchange",this._updateUrl,this),this._map.on("projectleave",this._updateUrl,this)},removeHooks:function(){this._map.removeLayer(this._metaLayer),this.options.disableLabel||(this._map.removeLayer(this._labelHelper),this._labelHelper=null),this._metaLayer.off(this._layerEventsListeners,this),this._map.off("langchange",this._updateUrl,this),this._map.off("projectchange",this._updateUrl,this),this._map.off("projectleave",this._updateUrl,this)},getMetaLayer:function(){return this._metaLayer},_updateUrl:function(){var t=DG.config.protocol+(DG.Browser.retina?DG.config.retinaPoiMetaServer:DG.config.poiMetaServer),e=DG.config.protocol+(DG.Browser.retina?DG.config.arabicRetinaPoiMetaServer:DG.config.arabicPoiMetaServer),i=this._map.getLang(),o=this._map.projectDetector&&this._map.projectDetector.getProject();""===this._currentTilesLang&&"ar"===i&&o&&"ae"===o.country_code?(this._currentTilesLang="ar",this._metaLayer.setUrl(e)):"ar"!==this._currentTilesLang||"ar"===i&&o&&"ae"===o.country_code||(this._currentTilesLang="",this._metaLayer.setUrl(t))},_processData:function(t,e){var i=e.scaleBy(this._metaLayer.getTileSize()),o=DG.bind(this._polygonLngLatToPoints,this,i,e.z);return""===t.responseText?[]:t.result.poi.map(function(t){var e=void 0!==t.hovers?t.hovers:[t.hover];return{id:t.id,hint:t.links[0].name,linked:t.links[0],geometry:e.map(DG.Wkt.toGeoJSON)}}).map(function(t){var e=t.geometry.reduce(function(t,e){return"Polygon"===e.type?t.push(o(e.coordinates)):"MultiPolygon"===e.type&&(t=t.concat(e.coordinates.map(o))),t},[]);return t.geometry={type:"MultiPolygon",coordinates:e},t})},_polygonLngLatToPoints:function(t,e,i){var o=this._map;return i.map(function(i){return i.map(function(i){return o.project([i[1],i[0]],e).round().subtract(t)})})},_layerEventsListeners:{mouseover:function(t){this._setCursor("pointer"),t.meta.hint&&t.meta.hint.length&&!this.options.disableLabel&&(this._labelHelper.setPosition(t.latlng).setContent(t.meta.hint).setZIndexOffset(300),this._map.addLayer(this._labelHelper)),this._map.fire("poihover",{latlng:t.latlng,meta:t.meta})},mouseout:function(t){this._setCursor(""),this.options.disableLabel||this._map.removeLayer(this._labelHelper),this._map.fire("poileave",{latlng:t.latlng,meta:t.meta})},mousemove:function(t){this.options.disableLabel||this._labelHelper.setPosition(t.latlng)}},_setCursor:function(t){this._map.getContainer().style.cursor=t}}),DG.Map.addInitHook("addHandler","poi",DG.Poi),DG.Map.mergeOptions({geoclicker:!1}),DG.Geoclicker=DG.Handler.extend({clickCount:0,pendingClick:0,timeout:250,initialize:function(t,e){this._map=t,this._controller=new DG.Geoclicker.Controller(t,e)},addHooks:function(){this._toggleEvents(!0),void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geoclicker","Enable"),this._map.on("rulerstart",this._pause,this).on("rulerend",this._unpause,this)},removeHooks:function(){this._toggleEvents(),this._map.off("rulerstart",this._pause,this).off("rulerend",this._unpause,this)},_checkOpenPopup:function(){DG.Browser.mobile&&this._map._popup&&(this._map._popup.options.closeOnClick||this._map.options.closePopupOnClick)&&(this.popupWasOpen=!0)},_pause:function(){this._toggleEvents()},_unpause:function(){this.enabled()&&this._toggleEvents(!0)},_toggleEvents:function(t){this._map[t?"on":"off"](this._mapEventsListeners,this),this._map.poi&&this._map.poi.getMetaLayer()[t?"on":"off"]("click",this._onMetaClick,this)},getController:function(){return this._controller},_onMetaClick:function(t){this.clickCount=0,clearTimeout(this.pendingClick),this.popupWasOpen=!1,this._mapEventsListeners.click.call(this,t)},_mapEventsListeners:{langchange:function(){this._controller.reinvokeHandler()},popupclose:function(t){this._controller.handlePopupClose(t.popup)},click:function(t){0===this.clickCount?(this.clickCount=1,this._singleClick(t)):(this.clickCount=0,clearTimeout(this.pendingClick),this.popupWasOpen=!1)},dblclick:function(){DG.Browser.ielt9&&(this.clickCount=0,this.popupWasOpen=!1,clearTimeout(this.pendingClick))}},_singleClick:function(t){var e=this;clearTimeout(this.pendingClick),this.pendingClick=setTimeout(function(){if(t.meta&&(e._checkOpenPopup(),e._map.closePopup()),!e.popupWasOpen){var i=e._map.getZoom();e._controller.handleClick(t.latlng,i,t.meta)}e.clickCount=0,e.popupWasOpen=!1},this.timeout)}}),DG.Map.addInitHook("addHandler","geoclicker",DG.Geoclicker),DG.Geoclicker.clampHelper=function(t,e){var i,o,n,r,s,a,l,u,c,h=document.createElement.bind(document),d=document.createTextNode.bind(document);if(i=h("span"),function(t){t.position="absolute",t.whiteSpace="pre",t.visibility="hidden",t.margin="0 18px 8px 0"}(i.style),t.ownerDocument&&t.ownerDocument===document){for(r=a=0,s=1,c=!1,n=t.clientWidth,o=(t.textContent||t.innerText).replace(/\n/g," ");null!==t.firstChild;)t.removeChild(t.firstChild);t.appendChild(i),o.replace(/ |-/g,function(p,_){s!==e&&(i.appendChild(d(o.substr(r,_-r))),n<i.clientWidth?(c?(u=o.substr(r,_+1-r),r=_+1):(u=o.substr(r,a-r),r=a),l=h("span"),l.appendChild(d(u)),t.appendChild(l),l.className="dg-map-geoclicker__clamped-line",c=!0,s++):c=!1,a=_+1,i.removeChild(i.firstChild))}),t.removeChild(i),l=h("span"),l.className="dg-map-geoclicker__clamped-line dg-map-geoclicker__clamped-line_last",l.appendChild(d(o.substr(r))),t.appendChild(l)}},DG.Geoclicker.Provider={},DG.Geoclicker.Provider.CatalogApi=DG.Class.extend({initialize:function(t){this._map=t;var e=DG.config.protocol+DG.config.webApiServer+"/"+DG.config.webApiVersion+"/";this._urlGeoSearch=e+"geo/search",this._urlGeoGet=e+"geo/get",this._urlDetails=e+"catalog/branch/get",this._urlFirmsInHouse=e+"catalog/branch/list",this._key=DG.config.geoclickerCatalogApiKey,this._geoFields=DG.config.geoAdditionalFields,this._firmInfoFields=DG.config.firmInfoFields},getLocations:function(t){var e=t.zoom,i=t.latlng,o=t.beforeRequest||function(){},n=this.getTypesByZoom(e),r=i.lng+","+i.lat;return n?(o(),this.geoSearch(r,n,e).then(DG.bind(function(t){return this._filterResponse(t,n)},this))):Promise.reject("no type")},firmsInHouse:function(t,e){e=e||{};var i={building_id:t,page:e.page||1};return this._performRequest(i,this._urlFirmsInHouse)},getFirmInfo:function(t){return this._performRequest({type:"filial",id:t,fields:this._firmInfoFields},this._urlDetails)},geoSearch:function(t,e,i){var o={point:t,type:e,zoom_level:i,fields:this._geoFields};return this._performRequest(o,this._urlGeoSearch)},geoGet:function(t){var e={id:t,fields:this._geoFields};return this._performRequest(e,this._urlGeoGet)},cancelLastRequest:function(){this._lastRequest&&this._lastRequest.abort()},getTypesByZoom:function(t){var e={"adm_div.settlement":8,"adm_div.city":8,"adm_div.division":11,"adm_div.district":12,street:14,building:14,"adm_div.place":15,poi:15,attraction:17},i=[];return Object.keys(e).forEach(function(o){t>=e[o]&&i.push(o)}),i.length?i.join(","):null},_performRequest:function(t,e){var i=DG.extend({key:this._key},t),o="get";return this.cancelLastRequest(),DG.ajax.corsSupport||(o=i.format="jsonp"),this._lastRequest=DG.ajax(e,{type:o,data:i,timeout:this._timeoutMs,withCredentials:!0}),this._lastRequest},_filterResponse:function(t,e){var i,o,n,r,s,a={};if(this._isNotFound(t))return!1;for(r=t.result.items,i=r.length-1;i>=0;i--)o=r[i],s=o.type,o.subtype&&(s+="."+o.subtype),e&&e.indexOf(s)===-1||(a[s]=o,n=!0);return!!n&&a},_isNotFound:function(t){return!(t&&(!t.meta||!t.meta.error)&&t.result&&t.result.items&&t.result.items.length)}}),DG.Geoclicker.Handler={},DG.Geoclicker.Handler.Default=DG.Class.extend({includes:DG.Locale,statics:{Dictionary:{}},_eventHandlers:{},initialize:function(t,e,i){this._controller=t,this._view=e,this._map=i},handle:function(){return Promise.resolve({tmpl:"popupHeader",data:{title:this.t("we_have_not")}})},addClickEvent:function(){this._view._popup.on("click",this._runEventHandlers,this),this._map.once("popupclose",this._removeClickEvent,this)},_removeClickEvent:function(){this._view._popup.off("click",this._runEventHandlers,this)},_addEventHandler:function(t,e){this._eventHandlers[t]=e},_runEventHandlers:function(t){var e=t.originalEvent.target;for(var i in this._eventHandlers)if(this._eventHandlers.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._eventHandlers[i].call(this,e)},_clearEventHandlers:function(){this._eventHandlers={}},_getDirectionsUrl:function(t){return DG.Util.template(DG.config.ppnotLink,{domain:this._map.projectDetector.getProject().domain,projectCode:this._map.projectDetector.getProject().code,center:this._map.getCenter().lng+","+this._map.getCenter().lat,zoom:this._map.getZoom(),name:encodeURIComponent(t),rsType:this._map.projectDetector.getProject().transport?"bus":"car",point:this._popup._latlng.lng+","+this._popup._latlng.lat})},_getDrilldown:function(t){var e,i=[];return t.adm_div&&(i=t.adm_div.reduce(function(t,e){return e.name&&t.push(e.name),t},[]).reverse()),i.length&&t.address&&t.address.postcode&&i.push(t.address.postcode),e=i.join(", ")}}),DG.Geoclicker.Handler.HandlerExample=DG.Geoclicker.Handler.Default.extend({handle:function(t,e){return Promise.resolve({tmpl:e+":<br/>"+t[e].id})}}),DG.Geoclicker.Handler.ApiError=DG.Geoclicker.Handler.Default.extend({handle:function(){var t=this._view.render({tmpl:"popupHeader",data:{title:this.t("apiErrorTitle")}});return Promise.resolve({header:t,tmpl:this.t("apiErrorBody")})}}),DG.Geoclicker.Handler.CityArea=DG.Geoclicker.Handler.Default.extend({_polylineStyleDefault:{fillColor:"#ff9387",color:"#ff9387",noClip:!0,opacity:1},_polylineStyles:{11:{fillOpacity:.18,weight:1},12:{fillOpacity:.12,weight:1},13:{fillOpacity:.08,weight:2},18:{fillOpacity:0,weight:3}},handle:function(t,e){return!!t[e]&&(this._stylesInited||this._initStyles(),this._geometry&&this._map.removeLayer(this._geometry),this._popup=this._view.getPopup(),this._geometryZoomStyle=this._getPolyStyleNum(),this._geometry=DG.Wkt.geoJsonLayer(t[e].geometry.selection,{style:this._polylineStyles[this._geometryZoomStyle],interactive:!1}).addTo(this._map),this._map.on("zoomend",this._updateGeometry,this).once("popupclose",this._clearPopup,this),Promise.resolve(this._fillCityAreaObject(t,e)))},_fillCityAreaObject:function(t,e){var i={name:this.t("noname"),drilldown:"",purpose:this.t(e),type:e.split(".").join("_")};return i.drilldown=this._getDrilldown(t[e]),t[e].name&&(i.name=t[e].name),{tmpl:"cityarea",data:i,header:this._view.render({tmpl:"popupHeader",data:{title:i.name}})}},_initStyles:function(){this._stylesInited=!0,Object.keys(this._polylineStyles).forEach(function(t){DG.extend(this._polylineStyles[t],this._polylineStyleDefault)},this)},_getPolyStyleNum:function(){var t=this._map.getZoom();return Object.keys(this._polylineStyles).filter(function(e){return t<=e})[0]||!1},_updateGeometry:function(){var t=this._getPolyStyleNum();t&&t!==this._geometryZoomStyle&&(this._geometryZoomStyle=t,this._geometry.setStyle(this._polylineStyles[t]))},_clearPopup:function(){this._map.removeLayer(this._geometry).off("zoomend",this._updateGeometry,this)}}),DG.Geoclicker.Handler.House=DG.Geoclicker.Handler.Default.extend({_firmsOnPage:20,_scrollThrottleInterval:400,_scrollHeightReserve:60,options:{showBooklet:!0,showPhotos:!0,showRouteSearch:!0},handle:function(t){return!!t.building&&(this.firmCard=null,this._page=1,this._houseObject=null,this._firmList=null,this._firmListObject=null,this._firmCardObject=null,this._onScroll=!1,this._isFirmlistOpen=!1,this._id=t.building.id,this._totalPages=1,this._api=this._controller.getCatalogApi(),this._popup=this._view.getPopup(),this._initedPopupClose=!1,this._directionsUrl=this._getDirectionsUrl(t.building.name),this._firmListLoader=this._view.initLoader(!0),this._houseObject=this._fillHouseObject(t.building),Promise.resolve(this._houseObject))},_isRouteSearchAllowed:function(){var t=this._controller.getMap().projectDetector.getProject();return t.transport||t.roads},_firmCardSetup:function(){return{render:this._view.renderTemplate,lang:this._map.getLang(),domain:this._controller.getMap().projectDetector.getProject().domain,ajax:DG.bind(this._api.getFirmInfo,this._api),timezoneOffset:this._controller.getMap().projectDetector.getProject().timeOffset,map:this._map,popup:this._popup,isMobile:DG.Browser.mobile,showEntrance:DG.Entrance,gotoUrl:this._directionsUrl,onFirmReady:DG.bind(this._onFirmReady,this),onToggle:DG.bind(this._popup.resize,this._popup),showBooklet:this.options.showBooklet,showPhotos:this.options.showPhotos,showRouteSearch:this.options.showRouteSearch&&this._isRouteSearchAllowed(),t:DG.bind(this.t,this)}},_fillFirmCardObject:function(t){var e=this._firmCardSetup();return this.firmCard=new FirmCard(t,e),this._initPopupClose(),this.firmCard.getContainer()},_firmListSetup:function(){var t=this._firmCardSetup();return DG.extend(t,{backBtn:DG.bind(this._showHousePopup,this),onFirmClick:DG.bind(this._onFirmListClick,this),onShowLess:DG.bind(this._showHousePopup,this),pasteLoader:DG.bind(this._pasteLoader,this)}),{firmCard:t,firmlistItemTmpl:"firmlistItem",onListReady:DG.bind(this._renderFirmList,this)}},_initShortFirmList:function(t){var e=this._firmListSetup();return this._shortFirmList=new FirmCard.List(t,e),this._shortFirmList.renderList()},_initFirmList:function(t){if(!t)return!1;var e=t.result.items,i=this._firmListSetup();i.firmCard.backBtn=DG.bind(this._showListPopup,this),this._shortFirmList._toggleEventHandlers(!0),this._firmList=new FirmCard.List(e,i),this._firmListObject=this._fillFirmListObject(this._firmList.renderList()),this._clearAndRenderPopup(this._firmListObject)},_fillFirmListObject:function(t){var e=this;return{tmpl:t,header:this._header,footer:this._view.render({tmpl:"popupFooterBtns",data:{btns:[{name:"back",label:this.t("back_button"),icon:!0}]}}),afterRender:function(){e._initPopupClose(),e._totalPages>1&&e._firmListLoader&&this.tmpl.parentNode.appendChild(e._firmListLoader)}}},_onFirmReady:function(t){var e=this;t.afterRender=function(){var t=e._popup._popupStructure.header.firstChild;DG.Browser.ielt9||t.offsetHeight>72&&(DG.DomUtil.addClass(t,"dg-popup__header-teaser"),DG.Browser.webkit||DG.Geoclicker.clampHelper(t,3))},this._clearAndRenderPopup(t)},_showHousePopup:function(){this._popup.off("scroll",this._onScroll),this._clearAndRenderPopup(this._houseObject),this._shortFirmList._toggleEventHandlers()},_onFirmListClick:function(){this._popup.off("scroll",this._onScroll)},_pasteLoader:function(){var t=DG.DomUtil.create("div","dg-map-geoclicker__preloader-wrapper"),e=this._view.initLoader();t.insertBefore(e,t.firstChild),t.style.height=this._popup._contentNode.offsetHeight-1+"px",t.style.width=this._popup._contentNode.offsetWidth+"px",this._clearAndRenderPopup({tmpl:t})},_initPopupClose:function(){this._initedPopupClose||(this._controller.getMap().once("popupclose",DG.bind(this._onPopupClose,this)),this._initedPopupClose=!0)},_showListPopup:function(){var t=this._firmListObject;this._pasteLoader(),t?(this._clearAndRenderPopup(t),this._firmList._toggleEventHandlers()):t=this._api.firmsInHouse(this._id).then(DG.bind(this._initFirmList,this)),this._onScroll||(this._onScroll=DG.Util.throttle(this._handlePopupScroll,this._scrollThrottleInterval,this)),this._popup.on("scroll",this._onScroll)},_renderFirmList:function(){this._isFirmlistOpen||(this._popup.resize(),this._isFirmlistOpen=!0)},_onPopupClose:function(){this._initedPopupClose=!1,this._firmList&&(this._firmList.clearList(),this._firmList=null,this._popup.off("scroll",this._onScroll)),this._firmId=null,this.firmCard&&(this.firmCard._toggleEventHandlers(!0),this.firmCard=null),this._firmListLoader=null,this._page=1,this._clearEventHandlers()},_initShowMore:function(){var t=this._popup.findElement(".dg-popup__button_name_all");t&&this._addEventHandler("dg-popup__button_name_all",DG.bind(this._showListPopup,this))},_clearAndRenderPopup:function(t){this._clearEventHandlers(),this._popup.clear("header","footer"),this._view.renderPopup(t)},_appendFirmList:function(t){this._firmList.addFirms(t.result.items),this._popup._updateScrollPosition()},_handlePopupScroll:function(t){var e=t.originalEvent.target||t.target._scroller;DG.DomEvent.stop(t),this._totalPages<=1||e&&e.scrollHeight<=e.scrollTop+e.offsetHeight+this._scrollHeightReserve&&this._handlePaging()},_handlePaging:function(){if(this._page++,this._totalPages&&this._page<=this._totalPages&&this._api.firmsInHouse(this._id,{page:this._page}).then(DG.bind(this._appendFirmList,this)),this._page===this._totalPages){var t=this._firmListLoader;t&&t.parentNode&&t.parentNode.removeChild(t),this._popup.off("scroll",this._onScroll)}}}),DG.Geoclicker.Handler.House.include({_getAddressString:function(t){return t.address&&t.address.components?t.address.components.filter(function(t){
	return"street_number"===t.type}).map(function(t){return t.street+", "+t.number}).join(" / "):""},_fillBody:function(t){var e={},i=DG.DomUtil.create("div","dg-building-callout__body"),o=t.links&&t.links.branches,n=this._getDrilldown(t);return t.building_name?e.address={header:this._getAddressString(t),drilldown:n}:n&&(e.address={drilldown:n}),e.purpose=t.purpose_name+(t.floors?", "+this.t("n_floors",t.floors.ground_count):""),o&&o.count>0&&(this._totalPages=Math.ceil(t.links.branches.count/this._firmsOnPage)),t.links&&t.links.attractions&&t.links.attractions.length&&(e.attractions=t.links.attractions.reduce(function(t,e){return e.name&&t.push(e.name),t},[])),i.innerHTML=this._view.render({tmpl:"house",data:e}),o&&o.items&&i.appendChild(this._initShortFirmList(o.items)),i},_fillHeader:function(t){var e={};return t.building_name?e.title=t.building_name:t.address&&t.address.components?e.title=this._getAddressString(t):e.title=t.purpose_name,this._header=this._view.render({tmpl:"popupHeader",data:e}),this._header},_fillFooter:function(t){var e=[],i=t.links&&t.links.branches;return i&&i.items&&i.items.length&&i.count>i.items.length&&e.push(this._getShowAllData(i.count)),this._isRouteSearchAllowed()&&e.push({name:"goto",label:this.t("go_to"),icon:!0,href:this._directionsUrl}),this._view.render({tmpl:"popupFooterBtns",data:{btns:e}})},_getShowAllData:function(t){return{name:"all",label:this.t("show_organization_in_building",t)}},_fillHouseObject:function(t){var e=this;return{header:this._fillHeader(t),tmpl:this._fillBody(t),footer:this._fillFooter(t),afterRender:function(){e._initShowMore(),e._initPopupClose()}}}}),DG.Geoclicker.Handler.Poi=DG.Geoclicker.Handler.House.extend({handle:function(t){if(!t.poi)return!1;if(this.firmCard=null,this._page=1,this._houseObject=null,this._firmList=null,this._firmListObject=null,this._firmCardObject=null,this._onScroll=!1,this._isFirmlistOpen=!1,this._id=t.poi.reference.id,this._totalPages=1,this._api=this._controller.getCatalogApi(),this._popup=this._view.getPopup(),this._initedPopupClose=!1,this._directionsUrl=this._getDirectionsUrl(t.poi.reference.name),this._firmListLoader=this._view.initLoader(!0),"building"===t.poi.reference.type){var e=this;return e._api.geoGet(t.poi.reference.id).then(function(t){return e._houseObject=e._fillHouseObject(t.result.items[0]),Promise.resolve(e._houseObject)})}return"branch"===t.poi.reference.type&&(this._fillFirmCardObject(t.poi.reference.id),!0)}}),DG.Geoclicker.Handler.Sight=DG.Geoclicker.Handler.Default.extend({handle:function(t){return!!t.attraction&&(this._popup=this._view.getPopup(),this._initedPopupClose=!1,Promise.resolve(this._fillSightObject(t)))},_fillSightObject:function(t){var e=t.attraction,i={},o=this,n={btns:[{name:"goto",label:this.t("go_to"),icon:!0}]};return e.name?(i.buildingName=e.name,i.purpose=e.subtype_name):i.buildingName=e.subtype_name,i.description=e.description,i.drillDown=this._getDrilldown(e),this._checkDescFieldHeight(i.description)&&(i.showMoreText=this.t("show_more_about_sight")),n.btns[0].href=this._getDirectionsUrl(i.buildingName),{tmpl:"sight",data:i,header:this._view.render({tmpl:"popupHeader",data:{title:i.buildingName}}),footer:this._view.render({tmpl:"popupFooterBtns",data:n}),afterRender:function(){o._needShowMore&&o._initShowMore(),o._initPopupClose()}}},_initPopupClose:function(){this._initedPopupClose||(this._controller.getMap().once("popupclose",DG.bind(this._clearPopup,this)),this._initedPopupClose=!0)},_clearPopup:function(){this._initedPopupClose=!1,this._clearEventHandlers()},_showMoreText:function(){this._desc.style.maxHeight="100%",this._link.parentNode.removeChild(this._link),this._popup.resize()},_initShowMore:function(){this._link=this._popup.findElement(".dg-map-geoclicker__show-more-sights-link"),this._desc=this._popup.findElement(".dg-map-geoclicker__sight-description"),this._link&&this._desc&&this._addEventHandler("dg-map-geoclicker__show-more-sights-link",DG.bind(this._showMoreText,this))},_checkDescFieldHeight:function(t){var e,i=DG.DomUtil.create("div","");return i.style.visibility="hidden",i.innerHTML=t,this._popup._contentNode.appendChild(i),e=i.offsetHeight,this._popup._contentNode.removeChild(i),this._needShowMore=e>40,this._needShowMore}}),DG.Geoclicker.View=DG.Class.extend({initialize:function(t,e){this._map=t,this._popup=DG.popup({maxHeight:300,minHeight:50,maxWidth:385,minWidth:310,sprawling:!0,closeOnClick:!0}),e&&DG.Util.setOptions(this,e)},initLoader:function(t){var e=document.createElement("div");return e.innerHTML=DG.dust("DGGeoclicker/loader",{small:t,anim:this._detectCssAnimation()}),e.firstChild},showPopup:function(t,e){this._popup.setContent(e).setLatLng(t).openOn(this._map)},render:function(t){var e,i={};return t=t||{},t.tmpl=t.tmpl||"",e=t.data?this.renderTemplate(t.tmpl,t.data):t.tmpl,t.beforeRender&&t.beforeRender(),t.popup&&(t.header&&(i.header=t.header),t.footer&&(i.footer=t.footer),i.body=e,this._popup.setContent(i)),t.afterRender&&t.afterRender(),e},renderTemplate:function(t,e){return DG.dust("DGGeoclicker/"+t,e)},renderPopup:function(t){return t.popup=!0,this.render(t)},getPopup:function(){return this._popup},_detectCssAnimation:function(){var t=!1,e="Webkit Moz O ms Khtml".split(" "),i=document.createElement("div");if(i.style.animationName&&(t=!0),t===!1)for(var o=0;o<e.length;o++)if(void 0!==i.style[e[o]+"AnimationName"]){t=!0;break}return t}}),DG.Geoclicker.Controller=DG.Class.extend({options:{handlersSequence:{poi:DG.Geoclicker.Handler.Poi,attraction:DG.Geoclicker.Handler.Sight,building:DG.Geoclicker.Handler.House,street:DG.Geoclicker.Handler.CityArea,"adm_div.place":DG.Geoclicker.Handler.CityArea,"adm_div.district":DG.Geoclicker.Handler.CityArea,"adm_div.division":DG.Geoclicker.Handler.CityArea,"adm_div.settlement":DG.Geoclicker.Handler.CityArea,"adm_div.city":DG.Geoclicker.Handler.CityArea,"default":DG.Geoclicker.Handler.Default,apiError:DG.Geoclicker.Handler.ApiError}},initialize:function(t,e){this._options=e,this._handlers={},this._catalogApi=new DG.Geoclicker.Provider.CatalogApi(t),this._map=t,this._view=new DG.Geoclicker.View(t),this._renderHandlerResult=DG.bind(this._renderHandlerResult,this),this._lastHandleClickArguments=null},handlePopupClose:function(t){t===this._view.getPopup()&&(this._lastHandleClickArguments=null,this._catalogApi.cancelLastRequest())},handleClick:function(t,e,i){function o(){var e=n._view.initLoader();n._view._popup.clear(),n._view.showPopup(t,e),n._lastHandleClickArguments=r}var n=this,r=Array.prototype.slice.call(arguments,0);if(void 0!==typeof ga&&ga(DG.config.gaName+".send","event","Geoclicker","Use"),i&&i.linked&&"sight"!=i.linked.type&&"attraction"!=i.linked.type){if("branch"!=i.linked.type&&"building"!=i.linked.type)return;o(),n.handleResponse({poi:{reference:i.linked}})}else this._catalogApi.getLocations({latlng:t,zoom:e,beforeRequest:o}).then(function(t){n.handleResponse(t)},function(t){n.handleResponse(t)})},handleResponse:function(t){var e;if(!t)return void this._runHandler("default");if("no type"!==t){if("aborted"===t)return void this._runHandler("apiError");for(e=this.findHandler(t);e;){if(this._runHandler(e,t))return;delete t[e],e=this.findHandler(t)}this._runHandler("default")}},findHandler:function(t){for(var e in this.options.handlersSequence)if(t[e])return e;return null},getCatalogApi:function(){return this._catalogApi},getMap:function(){return this._map},reinvokeHandler:function(){this._lastHandleClickArguments&&this.handleClick.apply(this,this._lastHandleClickArguments)},_runHandler:function(t,e){e=e||{},this._initHandlerOnce(t),this._handlers[t].addClickEvent();var i=this._handlers[t].handle(e,t);return i&&i.then?i.then(this._renderHandlerResult):i},_renderHandlerResult:function(t){this._view.renderPopup(t)},_initHandlerOnce:function(t){this._handlers[t]||(this._handlers[t]=new this.options.handlersSequence[t](this,this._view,this._map,this._options))}}),DG.Geoclicker.Handler.Default.Dictionary.it=DG.extend({apiErrorTitle:"Oh oh, c'è&nbsp;un&nbsp;errore",apiErrorBody:"I nostri server si rifiutano di rispondere. Stiamo facendo del nostro meglio per convincerli a&nbsp;comportarsi bene. Ritorna tra qualche minuto.",we_have_not:"Non disponiamo ancora di informazioni su questo posto",noname:"Nome non indicato","adm_div.place":"Luogo","adm_div.division":"Zona","adm_div.settlement":"Comune",street:"Via","adm_div.district":"Municipalità","adm_div.city":"Сittà",go_to:"Come arrivare",show_organization_in_building:["{n} azienda in tutto","{n} aziende in tutto"],show_more_about_sight:"Maggiori informazioni",back_button:"Indietro",n_floors:["{n} piano","{n} piani"]},DG.Dictionary.it),DG.Geoclicker.Handler.Default.Dictionary.ru=DG.extend({apiErrorTitle:"Ошибочка вышла",apiErrorBody:"Наши серверы отказываются отвечать. Мы уже прикладываем все силы, чтобы вразумить их. Возвращайтесь к&nbsp;нам через&nbsp;несколько минут.",we_have_not:"Это место мы ещё не успели изучить",noname:"Без названия","adm_div.place":"Место","adm_div.division":"Округ","adm_div.settlement":"Населенный пункт",street:"Улица","adm_div.district":"Район","adm_div.city":"Город",go_to:"Проехать сюда",show_organization_in_building:["Всего {n} организация","Всего {n} организации","Всего {n} организаций"],show_more_about_sight:"Подробнее",back_button:"Назад",n_floors:["{n} этаж","{n} этажа","{n} этажей"]},DG.Dictionary.ru),DG.Geoclicker.Handler.Default.Dictionary.en=DG.extend({apiErrorTitle:"Oops! Error detected.",apiErrorBody:"Our servers are not responding. We are doing our best to straighten them out. Please return to us in a few minutes.",we_have_not:"We haven't collected info about this place yet",noname:"No name","adm_div.place":"Place","adm_div.division":"Area","adm_div.settlement":"Village",street:"Street","adm_div.district":"District","adm_div.city":"City",go_to:"Directions to here",show_organization_in_building:["{n} organization total","{n} organizations total"],back_button:"Back",show_more_about_sight:"More information",n_floors:["{n} floor","{n} floors"]},DG.Dictionary.en),DG.Geoclicker.Handler.Default.Dictionary.cs=DG.extend({apiErrorTitle:"Chybička se&nbsp;vloudila",apiErrorBody:"Naše servery odmítají reagovat. Již nyní vynakládáme veškeré úsilí, abychom je přivedli k rozumu. Zkuste akci opakovat za několik minut.",we_have_not:"O tomto místě zatím nemáme informace",noname:"Bez názvu","adm_div.place":"Místo","adm_div.division":"Správní obvod","adm_div.settlement":"Obec",street:"Ulice","adm_div.district":"Městská část","adm_div.city":"Město",go_to:"Cesta sem",show_organization_in_building:["Celkem {n} organizace","Celkem {n} organizace","Celkem {n} organizací"],back_button:"Zpět",show_more_about_sight:"Více",n_floors:["{n} patro","{n} patra","{n} pater"]},DG.Dictionary.cs),DG.Geoclicker.Handler.Default.Dictionary.es=DG.extend({apiErrorTitle:"Vaya, ha ocurrido un error",apiErrorBody:"Nuestros servidores se niegan a responder. Ya nos estamos esforzando por hacerlos entrar en razón. Vuelva con nosotros pasados unos minutos.",we_have_not:"Todavía no hemos recopilado la información sobre este lugar",noname:"Sin nombre","adm_div.place":"Lugar","adm_div.division":"Comuna","adm_div.settlement":"Población",street:"Calle","adm_div.district":"Comuna","adm_div.city":"Ciudad",go_to:"Ir para allá",show_organization_in_building:["Total {n} organización","Total {n} organizaciones","Total {n} organizaciones"],show_more_about_sight:"Read more",back_button:"Atrás",n_floors:["{n} piso","{n} pisos"]},DG.Dictionary.es);var FirmCard=function(t,e){this._setOptions(e),this._firmContentObject={},this._schedule=new FirmCard.Schedule({localLang:this.options.lang,dict:this.dict}),this.render(t)};FirmCard.prototype={render:function(t){if(t)return t!==this._firmId?(this._firmContentObject={},this._renderCardById(t)):this._toggleEventHandlers(),this._firmContentObject},getSchedule:function(){return this._schedule},getContainer:function(){return this._container},_renderCardById:function(t){var e=this;this.options.ajax(t).then(function(i){if(!i)return!1;var o=i.result.items;"undefined"!==o&&(e._firmData=o[0],e._convertWebsite(),e._firmId=t,e._renderFirmCard(),e._toggleEventHandlers())},function(t){e._renderError()})},_createFirmContainer:function(){var t=document.createElement("div");return t.setAttribute("id","dg-map-firm-full-"+this._firmId),t.setAttribute("class","dg-map-firm-full"),t},_getPaymentTypes:function(t){var e=[],i="general_payment_type";return t.attribute_groups?(t.attribute_groups.forEach(function(t){t.name||t.attributes.forEach(function(t){t.tag.substring(0,i.length)===i&&e.push(t.name)})}),e):e},_groupRubrics:function(t){var e={primary:[],additional:[]};return t.rubrics&&t.rubrics.length?(t.rubrics.forEach(function(t){e[t.kind].push(t)}),e):e},_convertWebsite:function(){this._firmData.contact_groups&&this._firmData.contact_groups.forEach(function(t){t.contacts&&t.contacts.forEach(function(t){"website"==t.type&&(t.url||(t.url=t.value))})})},_renderFirmCard:function(){var t,e,i,o,n,r,s,a=this._firmData,l=this._container=this._createFirmContainer();e=this._schedule.transform(a.schedule,{zoneOffset:this.options.timezoneOffset,apiLang:this.options.lang,localLang:this.options.lang}),i=this._schedule.forecast(e),r=this._getPaymentTypes(a),s=this._groupRubrics(a),t=this._buildFirmCardBody(this._getConfigFirmCardBody(a,e,i,r,s)),o=this._fillHeaderLinks(),n=this._fillFooterButtons(),this._firmContentObject.header=this.options.render("firmCardHeader",{firmName:a.name,links:o}),l.innerHTML=t,this._firmContentObject.tmpl=l,n.length&&(this._footerContainer=document.createElement("div"),this._footerContainer.innerHTML=this.options.render("popupFooterBtns",{btns:n}),this._firmContentObject.footer=this._footerContainer),this.options.onFirmReady&&this.options.onFirmReady(this._firmContentObject)},_renderError:function(){this._firmContentObject.header=this.options.render("popupHeader",{title:this.options.t("apiErrorTitle")}),this._firmContentObject.tmpl=this.options.t("apiErrorBody"),this.options.onFirmReady&&this.options.onFirmReady(this._firmContentObject)},_getConfigFirmCardBody:function(t,e,i,o,n){return[{tmpl:"firmCardAddr",data:{address:t.address_name,comment:t.address_comment}},{tmpl:"firmCardContacts",data:{groups:t.contact_groups}},{tmpl:"firmCardSchedule",data:{schedule:e,forecast:i}},{tmpl:"frimCardPayments",data:{payments:o}},{tmpl:"firmCardRubric",data:{rubrics:n}}]},_buildFirmCardBody:function(t){var e=this;return t.reduce(function(t,i){var o=e.options.render(i.tmpl,i.data);return t+o},"")},_fillFooterButtons:function(){var t=[];return this.options.backBtn&&t.push({name:"firm-card-back",label:this.dict.t(this.options.lang,"btnBack"),icon:!0}),this.options.showRouteSearch&&t.push({name:"goto",label:this.dict.t(this.options.lang,"btnFindWay"),icon:!0,href:this.options.gotoUrl}),this._firmData.links&&this._firmData.links.entrances&&this.options.showEntrance&&t.push({name:"show-entrance",label:this.dict.t(this.options.lang,"btnEntrance"),icon:!0}),t},_fillHeaderLinks:function(){var t,e,i=[],o=this._firmData.reviews;this._firmData.external_content&&this._firmData.external_content.forEach(function(e){e&&"booklet"==e.type&&(t=e)}),o&&o.is_reviewable&&(i.push({name:"flamp_stars",width:20*o.rating}),i.push({name:"flamp_reviews",label:this.dict.t(this.options.lang,"linkReviews",o.review_count?o.review_count:0),href:FirmCard.DataHelper.getFlampUrl(this._firmId)}));for(var n,r=this._firmData.external_content,s=0;s<r.length;s++)if("photo_album"==r[s].type&&"common"==r[s].subtype){n=r[s];break}return!this.options.isMobile&&n&&n.count&&this.options.showPhotos&&(e=L.Util.template(DG.config.photosLink,{id:this._firmId,domain:this.options.domain}),i.push({name:"photos",href:e,label:this.dict.t(this.options.lang,"linkPhoto",n.count)})),!this.options.isMobile&&t&&t.url&&this.options.showBooklet&&i.push({name:"booklet",href:t.url,label:this.dict.t(this.options.lang,"linkBooklet")}),i},_events:{"dg-popup__button_name_firm-card-back":function(){this.options.backBtn(),this._toggleEventHandlers(!0)},"dg-popup__button_name_show-entrance":function(){var t=new this.options.showEntrance({vectors:this._firmData.links.entrances[0].geometry.vectors});t.addTo(this.options.map),t.fitBounds(),this._toggleEventHandlers(!0)},"dg-schedule__today":function(){this._onToggleSchedule()}},_toggleEventHandlers:function(t){this.options.popup[t?"off":"on"]("click",this._onClick,this),this.options.map[t?"off":"on"]("popupclose",this._onClose,this)},_onClick:function(t){var e=t.originalEvent.target;for(var i in this._events)if(this._events.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._events[i].call(this,e)},_onClose:function(t){this._toggleEventHandlers(!0)},_onToggleSchedule:function(){var t=this._container.querySelector(".dg-schedule__table"),e=this._container.querySelector(".dg-schedule__now"),i=this._container.querySelector(".dg-schedule__today"),o=" dg-schedule__today_shown_true";t&&("block"===t.style.display?(t.style.display="none",e.style.display="block",i.className=i.className.replace(o,"")):(e.style.display="none",t.style.display="block",i.className+=o),this.options.onToggle&&this.options.onToggle())},_setOptions:function(t){var e,t=t||{};this.options=t,t.lang=t.lang||"ru";for(e in t)t.hasOwnProperty(e)&&(this.options[e]=t[e])},_hasTouch:function(){return"ontouchstart"in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0}},FirmCard.DataHelper={payMethods:["americanexpress","cash","dinersclub","goldcrown","internet","mastercard","noncash","visa"],_msgs:{},getFlampUrl:function(t){return DG.config.flampUrl.concat(t,"?",DG.config.flampGoogleAnalytics)},msg:function(t){return this._msgs.hasOwnProperty(t)?this._msgs[t]:(console&&console.log("Cant't find translation for '"+t+"'."),t.toString().replace("_"," "))},getProjectTime:function(t,e){var i,o;return i=e?new Date(e):new Date,t?(o=i.getTime()+6e4*i.getTimezoneOffset(),new Date(o+6e4*t)):i}},function(){FirmCard.List=function(t,e){this._firms={},this._setOptions(e),this._container=e&&e.container||document.createElement("ul"),this._container.setAttribute("class","dg-building-callout__list"),this._eventHandlersInited=!1,this._firmCard=this._createFirm(),this.renderList(t)},FirmCard.List.prototype={renderList:function(t){return t&&(this._toggleEventHandlers(),this.addFirms(t)),this.options.onListReady&&this.options.onListReady(this._container),this._container},_processFirms:function(t,e){if(t){var i="_"+e+"Firm";if(this._isArray(t))for(var o=0,n=t.length;o<n;o++)this[i](t[o]);else this[i](t)}},addFirms:function(t){this._processFirms(t,"add")},removeFirms:function(t){this._processFirms(t,"remove")},setLang:function(t){this.options.firmCard.lang=t},getLang:function(){return this.options.firmCard.lang},getContainer:function(){return this._container},clearList:function(){this._firms={},this._toggleEventHandlers(!0),this._clearContainer()},_removeFirm:function(t){return!!this._firms[t]&&(this._container.removeChild(this._firms[t]),void delete this._firms[t])},_addFirm:function(t){var e,i,o,n=this.options.firmlistItemTmpl;i={name:t.name,id:t.id.split("_").slice(0,1)},i.id in this._firms||(e=this._createListItem(),o=n?this.options.firmCard.render(n,{firm:i}):i.name,e.insertAdjacentHTML("beforeend",o),this._firms[i.id]=e,this._container.appendChild(e))},_createListItem:function(){var t=document.createElement("li");return t.setAttribute("class","dg-building-callout__list-item"),t},_isArray:function(t){return"[object Array]"==={}.toString.call(t)},_createFirm:function(t){return new FirmCard(t,this.options.firmCard)},_isEmptyObj:function(t){for(var e in t)if(t.hasOwnProperty(e))return!1;return!0},_events:{"dg-popup__link":function(t){var e=this._firmCard.render(t.id);this.options.firmCard[this._isEmptyObj(e)?"pasteLoader":"onFirmReady"](e),this.options.firmCard.onFirmClick&&this.options.firmCard.onFirmClick(),this._toggleEventHandlers(!0)},"dg-building-callout__list-item":function(t){t=t.children[0],this._events["dg-popup__link"].call(this,t)},"dg-popup__button_name_back":function(){this.options.firmCard.onShowLess(),this._toggleEventHandlers(!0)}},_toggleEventHandlers:function(t){this.options.firmCard.popup[t?"off":"on"]("click",this._onClick,this)},_onClick:function(t){var e=t.originalEvent.target;for(var i in this._events)if(this._events.hasOwnProperty(i)&&e.className.indexOf(i)>-1)return DG.DomEvent.preventDefault(t.originalEvent),void this._events[i].call(this,e)},_clearContainer:function(){for(var t=this._container;t.hasChildNodes();)t.removeChild(t.firstChild)},_setOptions:function(t){t||(t={}),this.options=t,this.options.firmCard||(this.options.firmCard={}),t.firmCard.lang||(this.options.firmCard.lang="ru");for(var e in t)t.hasOwnProperty(e)&&(this.options[e]=t[e])}}}(),FirmCard.Schedule=function(t){return t=t||{},this.localLang=t.localLang||"ru",this.dict=t.dict,this},FirmCard.Schedule.prototype={setLang:function(t){return this.localLang=t||"ru",this},transform:function(t,e){function i(t,e){var i=arguments.length>2?Array.prototype.slice.call(arguments,2):null;return function(){return t.apply(e,i||arguments)}}function o(t){return t.charAt(0).toUpperCase()+t.slice(1)}function n(t){return t.substr(0,2)}function r(t){return t.substr(3,2)}function s(t){var e=+n(t)%24+"";return 1===e.length&&(e="0"+e),e+":"+r(t)}function a(t){return(t+70)%7}function l(t,e){if(null!=t)return null==e?t[t.length-1]:slice.call(t,Math.max(t.length-e,0))}function u(t,e){if(t===e)return!0;if(!(t instanceof Object&&e instanceof Object))return!1;if(t.constructor!==e.constructor)return!1;for(var i in t)if(t.hasOwnProperty(i)){if(!e.hasOwnProperty(i))return!1;if(t[i]!==e[i]){if("object"!=typeof t[i])return!1;if(!u(t[i],e[i]))return!1}}for(i in e)if(e.hasOwnProperty(i)&&!t.hasOwnProperty(i))return!1;return!0}function c(t,e,i){arguments.length<=1&&(e=t||0,t=0),i=arguments[2]||1;for(var o=Math.max(Math.ceil((e-t)/i),0),n=0,r=new Array(o);n<o;)r[n++]=t,t+=i;return r}function h(t){var e=Array.prototype.slice.call(arguments,1);return e.forEach(function(e){if(e)for(var i in e)void 0===t[i]&&(t[i]=e[i])}),t}function d(t,e){return p(t.map(function(t,i,o){return{value:t,index:i,criteria:e.call(this,t,i,o)}}).sort(function(t,e){var i=t.criteria,o=e.criteria;if(i!==o){if(i>o||void 0===i)return 1;if(i<o||void 0===o)return-1}return t.index-e.index}),"value")}function p(t,e){var i,o=[];for(i=0;i<t.length;++i)o[i]=t[i][e];return o}function _(t){var e,i,o,s,a=[];if(!t||!t.working_hours)return[];for(var l=0;l<t.working_hours.length;l++)e=t.working_hours[l].from,i=t.working_hours[l].to,o=n(i)-n(e),s=r(i)-r(e),(o<0||0===o&&s<=0)&&(i=+n(i)+24+":"+r(i)),a[2*l]={time:e,type:"open"},a[2*l+1]={time:i,type:t.working_hours.length-1===l?"close":"lunch"};return a}function m(t){for(var e,i,o=[],s=[],l=E.indexOf(w),u=0;u<7;u++)i=a(l+u),e=_(t[E[i]]),e.forEach(function(t){var e=new Date(P);e.setDate(e.getDate()+u),e.setHours(n(t.time)),e.setMinutes(r(t.time));var i=e.getTime();o.push({ts:i,type:t.type}),o[o.length-1]&&o[o.length-2]&&o[o.length-1].ts===o[o.length-2].ts&&(o.pop(),o.pop()),o[o.length-1]&&o[o.length-2]&&o[o.length-1].ts<=P&&o[o.length-2].ts<=P&&(o[o.length-1].ts+=6048e5,o[o.length-2].ts+=6048e5)});for(o=d(o,function(t){return t.ts}),u=0;u<o.length;)o[u+1]&&o[u].ts===o[u+1].ts?u++:s.push(o[u].ts),u++;return 2===s.length&&s[1]-s[0]===6048e5?[]:o}function f(t,e,i){if(1===e&&t>F)return H(O,"tommorow");if(e>1)switch(i){case 0:return H(O,"nextSun");case 1:return H(O,"nextMon");case 2:return H(O,"nextTue");case 3:return H(O,"nextWed");case 4:return H(O,"nextThu");case 5:return H(O,"nextFri");case 6:return H(O,"nextSat")}}function g(t,e){var i,o=864e5,n=new Date(t.ts);return i=Math.round((n-e)/o),"open"===t.type&&n.getHours()<1&&i++,i}function v(e){var i,o,n=[];z.now={},o=m(t),o.length||(z.always=!0,z.now.open=!0);for(var r=0;r<o.length;r++)if(P>=(o[r-1]&&o[r-1].ts||0)&&P<o[r].ts){var a=Math.floor((o[r].ts-P)/36e5),u=Math.floor((o[r].ts-P)/6e4-60*a),c=new Date(P),h="open"!==o[r].type,d=g(o[r],c);u=10*Math.floor(u/10)?10*Math.floor(u/10):5,z.now.open=h,z.now.lunch=!!(o[r-1]&&"lunch"===o[r-1].type||"lunch"===l(o).type),z.will={willType:o[r].type,d:d,h:a,m:u};var v=new Date(o[r].ts);z.will.when=f(a,d,v.getDay());var y=new Date(o[r].ts),b=y.getHours(),C=y.getMinutes();b<10&&(b="0"+b),C<10&&(C="0"+C),z.will.till=b+":"+C}if(e){for(i=p(_(e),"time"),r=2;r<i.length;r+=2)n.push({from:i[r-1],to:i[r]});k=s(i[0]),D=s(i[i.length-1]),k===D?z.today={alltime:!0,alltimeStr:H(O,"worksAroundTheClock"),from:"00:00",to:"24:00"}:z.today={from:k,to:D},n.length>0&&(z.lunch=n,z.lunchStr=H(O,"lunch"))}}function y(){for(var e=[],i=!1,o=0;o<7;o++){var n=E[o],r=0;if(e[o]={},t[n]){for(var a=t[n],l=p(_(a),"time"),u=[],d=2;d<l.length;d+=2)i=!0,u.push({from:l[d-1],to:l[d]});r=Math.max(l.length/2,r),e[o]={from:s(l[0]),to:s(l[l.length-1]),lunch:u}}n===w&&(e[o].active=!0),e[o].key=G[o]}return e.forEach(function(t){t.lunch&&h(t.lunch,c(1,r))}),{table:e,hasLunch:i}}function b(t,e){var i,n={dayList:[],lunch:[]},r=[];if(t&&t.working_hours&&t.working_hours.length){i=p(_(t),"time"),i.forEach(function(t,e){0===e?n.from=s(t):e===i.length-1?n.to=s(t):r.push(s(t))});for(var l=0;l<r.length;l+=2)n.lunch.push({from:r[l],to:r[l+1],lunchStr:o(H(O,"lunch"))});"00:00"==n.from&&"00:00"==n.to&&(n.to="24:00"),t.round_the_clock&&(n.alltime=!0,n.alltimeStr=H(O,"worksAroundTheClock"))}else n.holiday=!0;var c=[0,0,0,0,0,0,0],h=0;return E.forEach(function(i,o){if(u(e[i],t)||!e[i]&&null===t)n.dayList.push(T[o]),c[a(o+B)]=1,h++;else{if(h>2){for(var r=n.dayList.pop(),s=1;s<h-1;s++)n.dayList.pop();n.dayList[n.dayList.length-1]+=" — "+r}h=0}}),n.budni=u(S,c),n.everyday=1===Math.min.apply(Math,c),n.holiday&&(n.holidayStr=H(O,"restDay",n.dayList.length).slice(2)),n.dayList=n.dayList.join(", "),n.dayList=n.dayList.charAt(0).toUpperCase()+n.dayList.slice(1),n}function C(t,e){for(var i=[],o=t.length-1;o>=0;o--)i.push(b(t[o],e));return i}if(t){e=e||{};for(var w,x,k,D,L=e.zoneOffset||0,z={},P=e.now||FirmCard.DataHelper.getProjectTime(L).getTime(),E=[],G=[],T=[],A=["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],M=["monday","tuesday","wednesday","thursday","friday","saturday","sunday"],O=e.localLang||this.localLang,S=e.localWorkingDays||[0,1,1,1,1,1,0],B=e.firstdayOffset||1,F=e.minHoursToDisplayClosure||4,H=i(this.dict.t,this.dict),N=0;N<7;N++)E[N]=A[N],G[N]=this.dict.t(O,A[N].toLowerCase()),T[N]=this.dict.t(O,M[N]);w=A[a(new Date(P).getDay()-B)],x=t[w],v(x);var U=[],R=0,j=0,I=[];if(Object.keys(t).forEach(function(e){t[e]&&t[e].working_hours&&(R++,u(t[e],l(U))||U.push(t[e]))}),j=U.length,R<7&&j++,j>2)z.week=y(t);else if(1===j)z.week={evently:[b(t[E[0]],t)]};else{for(N=0;N<j;N++)if(I[N]=0,U[N])for(var Z=p(_(U[N]),"time"),V=0;V<Z.length;V+=2){var W=n(Z[V+1])+r(Z[V+1])/60-(n(Z[V])+r(Z[V])/60);I[N]+=W}else U[N]=null;var Y=d(U,function(t,e){return I[e]});z.week={evently:C(Y,t)}}return z.comment=t.comment,z.week&&z.week.evently&&1===z.week.evently.length&&(z.everyday=z.week.evently[0].everyday),z}},forecast:function(t,e){var i,o,n="",r={},s=e&&e.maxHours||1;return t?t.always?{today:{text:this.dict.t(this.localLang,"aroundTheClock")},open:!0}:(t.will&&t.will.h<s&&(t.will.h&&(n+=this.dict.t(this.localLang,"nHours",t.will.h)+" "),t.will.m&&(n+=this.dict.t(this.localLang,"nMins",t.will.m))),t.today?(r.text=this.dict.t(this.localLang,"today"),t.everyday&&(r.text=this.dict.t(this.localLang,"everyday")),r.from=t.today.from,r.to=t.today.to,r.lunch=t.lunch,r.lunch&&(r.lunchStr=this.dict.t(this.localLang,"lunch"))):r.text=this.dict.t(this.localLang,"todayIsRestDay"),t.always?(r.text=this.dict.t(this.localLang,"aroundTheClock"),i=!0):t.now&&(i=t.now.open,o=i?t.will&&"lunch"===t.will.willType?t.will&&t.will.h<s?this.dict.t(this.localLang,"_in")+" "+this.dict.t(this.localLang,"nMins",n)+this.dict.t(this.localLang,"isClosingOnDinner"):this.dict.t(this.localLang,"isOpen"):t.will.h<s?this.dict.t(this.localLang,"closeIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"isOpen"):t.will&&t.will.when?this.dict.t(this.localLang,"open")+t.will.when:t.now&&t.now.lunch?t.will.h<s?this.dict.t(this.localLang,"Lunch")+this.dict.t(this.localLang,"openIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"Lunch")+this.dict.t(this.localLang,"openAt")+t.will.till:t.will&&t.will.h<s?this.dict.t(this.localLang,"openIn")+this.dict.t(this.localLang,"nMins",n):this.dict.t(this.localLang,"openAt")+t.will.till),{today:r,now:o,open:i,week:t.week,comment:t.comment,everyday:t.everyday}):{}}},FirmCard.prototype.dict={t:function(t,e,i){var o,n,r,s=!1;return"undefined"==typeof this[t]&&(t="ar"===t?"en":"ru"),n=this[t][e],(s="undefined"!=typeof n)?(o=s?n:e,void 0!==i&&(i=parseInt(i,10),i=isNaN(i)?0:i,r=this[t].pluralRules(i),o=i+" "+n[r]),o):e},ru:{pluralRules:function(t){return t%10===1&&t%100!==11?0:t%10>=2&&t%10<=4&&t%10%1===0&&(t%100<12||t%100>14)?1:t%10===0||t%10>=5&&t%10<=9&&t%10%1===0||t%100>=11&&t%100<=14&&t%100%1===0?2:void 0},btnBack:"Назад",btnFindWay:"Проехать сюда",btnEntrance:"Найти вход",linkReviews:["отзыв","отзыва","отзывов"],linkPhoto:["фото","фото","фото"],linkBooklet:"Буклет",tommorow:"завтра",afterTommorow:"послезавтра",afterWeek:"через неделю",nextSun:"в воскресенье",nextMon:"в понедельник",nextTue:"во вторник",nextWed:"в среду",nextThu:"в четверг",nextFri:"в пятницу",nextSat:"в субботу",willOpen:"откроется",willClose:"закроется",isOpen:"Открыто",openTill:"Открыто до ",closeIn:"Закроется через ",openAt:"Откроется в ",openIn:"Откроется через ",open:"Откроется ",nHours:["час","часа","часов"],nMins:["минуту","минуты","минут"],lunch:"обед",Lunch:"Обед. ",workingDays:"Рабочие дни",weekdays:"Будние дни",restDay:["выходной","выходные","выходные"],reviewsOnFlamp:"Отзывы на Флампе",writeReviewOnFlamp:"Написать отзыв на Флампе",payment:"оплата",everyday:"Ежедневно c",worksAroundTheClock:"Работает круглосуточно",aroundTheClock:"Круглосуточно",knowMore:"узнать больше",toClose:"до закрытия",monday:"понедельник",tuesday:"вторник",wednesday:"среда",thursday:"четверг",friday:"пятница",saturday:"суббота",sunday:"воскресенье",mon:"пон",tue:"втр",wed:"срд",thu:"чтв",fri:"птн",sat:"сбт",sun:"вск",toLunch:"до обеда",today:"Сегодня",lessThenHour:"менее часа",youCouldLate:"вы можете не успеть",workingTime:"рабочее время",showAllOrgInRubric:"Показать все организации рубрики",todayIsRestDay:"Сегодня выходной",internet:"Оплата через Интернет",noncash:"Безналичный расчет",goldcrown:"Золотая Корона",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Наличный расчет",americanexpress:"American Express",hour:"час",less:"менее",_in:"Через",isClosingOnDinner:" закрывается на обед"},it:{pluralRules:function(t){return 1===t?0:1},btnBack:"Indietro",btnFindWay:"Come arrivare ",btnEntrance:"Trova l'ingresso",linkReviews:["recensione","recensioni"],linkPhoto:["fotografia","fotografie"],linkBooklet:"Sull'azienda",tommorow:"domani",afterTommorow:"dopodomani",afterWeek:"tra una settimana",nextSun:"la domenica",nextMon:"il lunedi",nextTue:"il martedì",nextWed:"il mercoledì",nextThu:"il giovedi",nextFri:"il venerdì",nextSat:"il sabato",willOpen:"apre",willClose:"ciuso",isOpen:"Aperto",openTill:"Aperto fino alle ",closeIn:"Chiude tra ",openAt:"Apre alle ",openIn:"Apre tra ",open:"Apre ",nHours:["ora","ore"],nMins:["minuto","minuti"],lunch:"pausa pranzo",Lunch:"Pausa pranzo. ",workingDays:"Giorni feriali",weekdays:"Giorni feriali",restDay:["chiusura","chiusura"],reviewsOnFlamp:"Recensioni su Flamp",writeReviewOnFlamp:"Scrivi una recensione su Flamp",payment:"pagamento",everyday:"Ogni giorno dalole",worksAroundTheClock:"Operativo 24 ore su 24",aroundTheClock:"24 ore su 24",knowMore:"ulteriori informazioni",toClose:"fino alla chiusura",monday:"lunedi",tuesday:"martedì",wednesday:"mercoledì",thursday:"giovedi",friday:"venerdì",saturday:"sabato",sunday:"domenica",mon:"lun",tue:"mar",wed:"mer",thu:"gio",fri:"ven",sat:"sab",sun:"dom",toLunch:"fino alla pausa pranzo",today:"Oggi",lessThenHour:"meno di un'ora",
	youCouldLate:"affrettarsi, chiusura imminente",workingTime:"orario di lavoro",showAllOrgInRubric:"Visualizza tutte le aziende della categoria",todayIsRestDay:"oggi chiuso",internet:"Pagamento on-line",noncash:"Pagamento non in contanti",goldcrown:"Zolotaja Korona",dinersclub:"Diners Club",mastercard:"MasterCard",maestrocard:"MaestroCard",visa:"Visa",cash:"Pagamento in contanti",americanexpress:"American Express",hour:"un'ora",less:"meno di",_in:"Tra",isClosingOnDinner:"chiude per pausa pranzo"},en:{pluralRules:function(t){return 1===t?0:1},btnBack:"Back",btnFindWay:"Get here",btnEntrance:"Find entrance",linkReviews:["review","reviews"],linkPhoto:["photo","photos"],linkBooklet:"About company",tommorow:"tomorrow",afterTommorow:"the day after tomorrow",afterWeek:"in a week",nextSun:"on Sunday",nextMon:"on Monday",nextTue:"on Tuesday",nextWed:"on Wednesday",nextThu:"on Thursday",nextFri:"on Friday",nextSat:"on Saturday",willOpen:"opens ",willClose:"closes",isOpen:"Open",openTill:"Open till ",closeIn:"Closes in ",openAt:"Opens at ",openIn:"Opens in ",open:"Opens ",nHours:["hour","hours"],nMins:["minute","minutes"],lunch:"lunch break",Lunch:"Lunch break. ",workingDays:"Working days",weekdays:"Weekdays",restDay:["day off","days off"],reviewsOnFlamp:"Reviews on Flamp",writeReviewOnFlamp:"Write a review on Flamp",payment:"payment",everyday:"Daily from",worksAroundTheClock:"Open 24 hours",aroundTheClock:"24h",knowMore:"see also",toClose:"until closing",monday:"Monday",tuesday:"Tuesday",wednesday:"Wednesday",thursday:"Thursday",friday:"Friday",saturday:"Saturday",sunday:"Sunday",mon:"Mon",tue:"Tue",wed:"Wed",thu:"Thu",fri:"Fri",sat:"Sat",sun:"Sun",toLunch:"until lunch",today:"Today",lessThenHour:"less then one hour",youCouldLate:"you might be late",workingTime:"working hours",showAllOrgInRubric:"Show all organizations in the category",todayIsRestDay:"closed today",internet:"Online",noncash:" No-cash",goldcrown:"Golden Crown",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Cash",americanexpress:"American Express",hour:"hour",less:"less",_in:"In",isClosingOnDinner:"will be closing for lunch"},cs:{pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2},btnBack:"Zpět",btnFindWay:"Jet sem",btnEntrance:"Hledat vstup",linkReviews:["recenze","recenze","recenzí"],linkPhoto:["fotografie","fotografie","fotografií"],linkBooklet:"Leták",tommorow:"zítra",afterTommorow:"pozítří",afterWeek:"za týden",nextSun:"v neděli",nextMon:"v pondělí",nextTue:"v úterý",nextWed:"ve středu",nextThu:"ve čtvrtek",nextFri:"v pátek",nextSat:"v sobotu",willOpen:"otevře se",willClose:"zavře se",isOpen:"Otevřeno",openTill:"Otevřeno do ",closeIn:"Zavře se za ",openAt:"Otevře se v ",openIn:"Otevře se za ",open:"Otevře se ",nHours:["hodinu","hodiny","hodin"],nMins:["minutu","minuty","minut"],lunch:"polední přestávka",Lunch:"Polední přestávka. ",workingDays:"Všední dny",weekdays:"Všední dny",restDay:["zavřeno","zavřeno"],reviewsOnFlamp:"Recenze na Flampu",writeReviewOnFlamp:"Napsat recenzi na Flampu",payment:"platba",everyday:"Denně od ",worksAroundTheClock:"Pracuje nonstop",aroundTheClock:"Nonstop",knowMore:"dozvědět se více",toClose:"do uzavření",monday:"pondělí",tuesday:"úterý",wednesday:"středa",thursday:"čtvrtek",friday:"pátek",saturday:"sobota",sunday:"neděle",mon:"po",tue:"út",wed:"st",thu:"čt",fri:"pá",sat:"so",sun:"ne",toLunch:"do polední přestávky",today:"Dnes",lessThenHour:"méně než hodinu",youCouldLate:"nemusíte to stihnout",workingTime:"pracovní doba",showAllOrgInRubric:"Zobrazit všechny organizace v rubrice",todayIsRestDay:"Dnes je zavřeno",internet:"Platba prostřednictvím Internetu",noncash:"Bezhotovostní platba",goldcrown:"Zolotaja Korona",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Platba hotově",americanexpress:"American Express",hour:"hodinu",less:"méně",_in:"Za",isClosingOnDinner:"začíná polední přestávka"},es:{pluralRules:function(t){return 1===t?0:t>=2&&t<=4?1:2},btnBack:"Atrás",btnFindWay:"Ir para allá",btnEntrance:"Buscar acceso",linkReviews:["comentario","comentarios","comentarios"],linkPhoto:["foto","fotos","fotos"],linkBooklet:"Folleto",tommorow:"mañana",afterTommorow:"pasado mañana",afterWeek:"en una semana más",nextSun:"el domingo",nextMon:"el lunes",nextTue:"el martes",nextWed:"el miércoles",nextThu:"el jueves",nextFri:"el viernes",nextSat:"el sábado",willOpen:"se abrirá",willClose:"se cerrará",isOpen:"Abierto",openTill:"Abierto hasta ",closeIn:"Se cerrará dentro de ",openAt:"Se abrirá el ",openIn:"Se abrirá dentro de ",open:"Se abrirá ",nHours:["hora","horas","horas"],nMins:["minuto","minutos","minutos"],lunch:"hora de colación",Lunch:"Hora de colación. ",workingDays:"Días laborables",weekdays:"Días laborables",restDay:["cerrado","cerrado"],reviewsOnFlamp:"Comentarios en Flamp",writeReviewOnFlamp:"Escribir un comentario en Flamp",payment:"pago",everyday:"Cada día desde",worksAroundTheClock:"Abierto las 24 horas",aroundTheClock:"24 horas",knowMore:"para saber más",toClose:"hasta el cierre",monday:"lunes",tuesday:"martes",wednesday:"miércoles",thursday:"jueves",friday:"viernes",saturday:"sábado",sunday:"domingo",mon:"lun",tue:"mar",wed:"mié",thu:"jue",fri:"vie",sat:"sáb",sun:"dom",toLunch:"antes de la hora de colación",today:"Hoy",lessThenHour:"menos de una hora",youCouldLate:"puede ser que no alcanzas a llegar",workingTime:"horario de trabajo",showAllOrgInRubric:"Mostrar todas las empresas de la categoría",todayIsRestDay:"Hoy cerrado",internet:"Pago por Internet",noncash:"Pago sin efectivo",goldcrown:"Zolotaya Korona",dinersclub:"Diners Club",mastercard:"Mastercard",maestrocard:"MaestroCard",visa:"Visa",cash:"Pago en efectivo",americanexpress:"American Express",hour:"hora",less:"menos de",_in:"Dentro de",isClosingOnDinner:"se cierra por hora de colación"}},DG.Traffic=DG.TileLayer.extend({options:{period:0,disableLabel:!1,updateWhenIdle:!1},statics:{Dictionary:{}},initialize:function(t){this._tileUrl=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTrafficTileServer:DG.config.trafficTileServer),this._metaUrl=DG.config.protocol+(DG.Browser.retina?DG.config.retinaTrafficMetaServer:DG.config.trafficMetaServer),this._timeUrl=DG.config.protocol+DG.config.trafficTimestampServer,this._updateInterval=DG.config.trafficLayerUpdateInterval,this._layersOptions={errorTileUrl:"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",subdomains:"012345679",maxNativeZoom:18,detectRetina:DG.config.detectRetina,minZoom:DG.config.trafficLayerMinZoom},t=DG.setOptions(this,DG.extend(t||{},this._layersOptions)),this._metaLayer=DG.Meta.layer(null,{detectRetina:t.detectRetina,maxNativeZoom:t.maxNativeZoom,dataFilter:DG.bind(this._processData,this),minZoom:t.minZoom}),this._isDg=!0,this._isOnRequest=!1,this._onTimer=DG.bind(this._onTimer,this),DG.TileLayer.prototype.initialize.call(this,this._tileUrl,t)},onAdd:function(t){if(this._initContainer(),this._levels={},this._tiles={},this.options.period)this.options.timestampString="",this._onAddSetParams(t);else{var e=this;this._isOnRequest=!0,this._getTimestampString().then(function(t){e.options.timestampString="?"+t},function(){e.options.timestampString="?"+(new Date).getTime()}).then(function(){e._isOnRequest=!1,e._map&&e._onAddSetParams(t)})}},onRemove:function(t){this._isOnRequest?(L.DomUtil.remove(this._container),t._removeZoomLimit(this),this._container=null):(clearInterval(this._updateTimer),t.removeLayer(this._metaLayer).off("projectchange projectleave",this._onMapProjectChange,this),this.options.disableLabel||(this._metaLayer.off(this._layerEventsListeners,this),this._map.removeLayer(this._labelHelper),this._labelHelper=null,this._map.off("langchange",this._updateLang,this)),DG.TileLayer.prototype.onRemove.call(this,t))},update:function(){var t=this;this._getTimestampString().then(function(e){t.options.timestampString="?"+e},function(){t.options.timestampString="?"+(new Date).getTime()}).then(function(){t.fire("update",{timestamp:t.options.timestampString}),t._layerEventsListeners.mouseout.call(t),t._metaLayer.getOrigin().setURL(t._prepareMetaURL(),t),t.redraw()})},getSubdomain:function(){return this._layersOptions.subdomains[Math.floor(Math.random()*this._layersOptions.subdomains.length)]},_updateLang:function(){var t=this._map.getLang();"ar"===t?this._labelHelper.options.textDirection="rtl":this._labelHelper.options.textDirection="auto"},_getTimestampString:function(){return DG.ajax(DG.Util.template(this._timeUrl,DG.extend({s:this.getSubdomain(),projectCode:this._map.projectDetector.getProject().code},this.options||{})),{type:"get"})},_onTimer:function(){0===this.options.period&&this.update()},_processData:function(t,e){var i=e.scaleBy(this.getTileSize()),o=DG.bind(this._polygonLngLatToPoints,this,i),n={};return DG.Util.isArray(t)?(t[1].forEach(function(t){this[t.graph_id]=t.speed_text},n),t[0].map(function(t){return{id:t.graph_id,speed:n[t.graph_id],geometry:DG.Wkt.toGeoJSON(t.geometry[0].object[0])}}).filter(function(t){return"Polygon"==t.geometry.type||"MultiPolygon"==t.geometry.type}).map(function(t){var e=t.geometry;return"Polygon"==e.type?e.coordinates=o(e.coordinates):"MultiPolygon"==e.type&&(e.coordinates=e.coordinates.map(o)),t})):[]},_polygonLngLatToPoints:function(t,e){var i=this._map;return e.map(function(e){return e.map(function(e){return i.project([e[1],e[0]]).round().subtract(t)})})},_prepareMetaURL:function(){return DG.Util.template(this._metaUrl,DG.extend({x:"{x}",y:"{y}",z:"{z}",s:"{s}"},this.options))},_updateLayerProject:function(){var t=this._map.projectDetector.getProject();DG.setOptions(this,t&&t.traffic?{projectCode:t.code,bounds:t.latLngBounds,minZoom:Math.max(t.minZoom,this._layersOptions.minZoom),maxZoom:t.maxZoom}:{maxZoom:t?t.maxZoom:DG.config.projectLeaveMaxZoom,minZoom:0}),this._metaLayer.getOrigin().setURL(this._prepareMetaURL())},_onMapProjectChange:function(){this._updateLayerProject(),this.redraw()},_layerEventsListeners:{mouseover:function(t){this._setCursor("pointer"),this._labelHelper&&t.meta.speed&&this._labelHelper.setPosition(t.latlng).setContent(t.meta.speed+" "+this.t("speed_unit_km_h")).addTo(this._map)},mouseout:function(){this._setCursor(""),this._labelHelper&&this._map.removeLayer(this._labelHelper)},mousemove:function(t){this._labelHelper&&this._labelHelper.setPosition(t.latlng)}},_setCursor:function(t){this._map.getContainer().style.cursor=t},_onAddSetParams:function(t){this._updateLayerProject(),t.addLayer(this._metaLayer).on("projectchange projectleave",this._onMapProjectChange,this),this.options.disableLabel||(this._metaLayer.on(this._layerEventsListeners,this),this._labelHelper=DG.label(),this._map.on("langchange",this._updateLang,this)),this._updateInterval&&(this._updateTimer=setInterval(this._onTimer,this._updateInterval)),this._resetView(),this._update()},_update:function(t){this._isOnRequest||DG.TileLayer.prototype._update.call(this,t)}}),DG.Traffic.include(DG.Locale),DG.traffic=function(t){return new DG.Traffic(t)},DG.Traffic.Dictionary.ru={speed_unit_km_h:"км/ч"},DG.Traffic.Dictionary.it={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.cs={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.es={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.en={speed_unit_km_h:"km/h"},DG.Traffic.Dictionary.ar={speed_unit_km_h:"كم/ساعة"},DG.Control.Traffic=DG.RoundControl.extend({options:{position:"topright",iconClass:"traffic"},statics:{Dictionary:{}},initialize:function(t){this._trafficClass="dg-traffic-control",this._controlHideClass="dg-control-round_is-hidden_true",DG.setOptions(this,t),DG.extend(this,{_active:!1,_trafficLayer:null}).on(this._controlEvents,this)},_controlEvents:{add:function(){this._trafficLayer=DG.traffic(),this._map.on("zoomend projectchange projectleave",this._updateControlVisibility,this)},click:function(){this._active=!this._active,this._active?(this.setState("active"),this._showTraffic()):(this.setState(""),this._hideTraffic())},remove:function(){this.off(this._controlEvents,this),this._map.off("zoomend projectchange projectleave",this._updateControlVisibility,this),this._active&&(this._map.removeLayer(this._trafficLayer),this._active=!1),this._trafficLayer=null}},_showTraffic:function(){this._updateTrafficScore(),this._map.addLayer(this._trafficLayer)},_hideTraffic:function(){this._handleDom("remove"),this._map.removeLayer(this._trafficLayer)},_handleDom:function(t,e){var i=this._link;i.innerHTML=isNaN(e)?"":e,DG.DomUtil[t+"Class"](i,this._trafficClass),DG.DomUtil[t+"Class"](i,this._trafficClass+"_color_"+this._scoreRate)},_getTrafficColor:function(t){var e="green";return t>7?e="red":t>4&&(e="yellow"),e},_updateControlVisibility:function(){var t=this._map.projectDetector.getProject(),e=t&&t.traffic,i=this._map.getZoom()<DG.config.trafficLayerMinZoom||!e?"addClass":"removeClass";DG.DomUtil[i](this._container,this._controlHideClass),this._active&&e&&this._updateTrafficScore()},_updateTrafficScore:function(){var t=this;this._getTrafficScore().then(function(e){e=parseInt(e,10),t._scoreRate=t._getTrafficColor(e),t._handleDom("add",e)})},_getTrafficScore:function(){var t=DG.Util.template(DG.config.protocol+DG.config.trafficScoreServer,{s:this._trafficLayer.getSubdomain(),projectCode:this._map.projectDetector.getProject().code});return DG.ajax(t,{type:"get"})},_renderTranslation:function(){this._link.title=this.t("button_title")}}),DG.control.traffic=function(t){return new DG.Control.Traffic(t)},DG.Map.mergeOptions({trafficControl:!1}),DG.Map.addInitHook(function(){this.options.trafficControl&&(this.trafficControl=DG.control.traffic(this.options.trafficControl),this.addControl(this.trafficControl))}),DG.Control.Traffic.Dictionary.ru={button_title:"Пробки"},DG.Control.Traffic.Dictionary.it={button_title:"Colonna"},DG.Control.Traffic.Dictionary.cs={button_title:"Zácpy"},DG.Control.Traffic.Dictionary.es={button_title:"Taco"},DG.Control.Traffic.Dictionary.en={button_title:"Traffic"},DG.Control.Traffic.Dictionary.ar={button_title:"حركة السير"},DG.Ruler=DG.Layer.extend({options:{editable:!0},includes:[DG.Locale],statics:{Dictionary:{}},initialize:function(t,e){DG.Util.setOptions(this,e),this._layers={back:null,middle:null,front:null,mouse:null},this._points=[],this._layersContainer=DG.featureGroup(),Object.keys(this._layers).forEach(function(t){this._layersContainer.addLayer(this._layers[t]=DG.featureGroup())},this),this._reset(),DG.Browser.mobile?(delete this._lineMouseEvents.mouseover,delete this._lineMouseEvents.mouseout,delete this._lineMouseEvents.mousemove):delete this._lineMouseEvents.click,t&&t.length&&this.setLatLngs(t)},onAdd:function(t){this._map=t.on("langchange",this._updateDistance,this),this._map.getPane("rulerMarkerPane")||this._map.createPane("rulerMarkerPane"),this._map.getPane("rulerPane")||this._map.createPane("rulerPane"),this._layersContainer.addTo(this._map),this._points.length&&(this._layers.mouse.fire("layeradd"),this._updateDistance()),this._layers.mouse.on(this._lineMouseEvents,this)},onRemove:function(t){t.off("langchange",this._updateDistance,this).removeLayer(this._layersContainer),this._layers.mouse.off(this._lineMouseEvents,this),this._reset()},getTotalDistance:function(){return this._calcDistance()},spliceLatLngs:function(t){var e=this._points.length,i=t>=0?Math.min(t,e):e-t,o=Array.prototype.splice.apply(this._points,arguments).map(function(t){return this._layers.mouse.removeLayer(t),t.off().getLatLng()},this),n=this._points.length;if(n){for(var r=i;r<n;r++)this._points[r]instanceof DG.Ruler.LayeredMarker||(this._points[r]=this._createPoint(this._points[r],this.options.iconStyles.large).on(this._pointEvents,this).once("add",this._addCloseHandler,this).addTo(this._layers.mouse,this._layers)),r&&!this._points[r-1]._legs&&this._addLegs(this._points[r-1]),this._points[r].setPointStyle(this.options.iconStyles[r&&r<n-1?"small":"large"]),this._points[r]._pos=r;this._removeLegs(this._points[n-1]),e>0&&e<n&&this._points[e-1].collapse(),this._points[i]&&this._updateLegs(this._points[i]),i>1&&this._points[i-1].setPointStyle(this.options.iconStyles.small),this._updateDistance(),this._normalizeRulerPoints()}return DG.Browser.touch&&this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),this._fireChangeEvent(),o},addLatLng:function(t){var e=this._points[this._points.length-1]||null;return t=DG.latLng(t),e&&(t=this._normalizeLatLng(t,e.getLatLng())),this.spliceLatLngs(this._points.length,0,t),this},getLatLngs:function(){return this._points.map(function(t){return t.getLatLng()})},setLatLngs:function(t){var e=t.slice();return e.unshift(0,this._points.length),this.spliceLatLngs.apply(this,e),this},_reset:function(){DG.extend(this,{_lineMarkerHelper:null,_morphingNow:!1})},_lineMouseEvents:{click:function(t){var e=t.layer;if(e instanceof DG.Marker&&e._pos!==this._points.length-1)this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),e.setText(this._getFormatedDistance(e)),this._lineMarkerHelper=e;else if(e instanceof DG.Path&&this.options.editable){var i=t.latlng,o=e._point._pos+1;this.spliceLatLngs(o,0,i)}},mouseover:function(t){var e=t.layer;if(e._hovered=!0,!this._morphingNow)if(e instanceof DG.Marker&&e._pos!==this._points.length-1)e.setText(this._getFormatedDistance(e));else if(e instanceof DG.Path&&!this._lineMarkerHelper){var i=e._point;this._lineMarkerHelper=this._addRunningLabel(this._nearestPoint(i._legs.middle,t.latlng),i)}},mouseout:function(t){var e=t.layer,i=t.originalEvent;e._hovered=!1,this._morphingNow||e._pos===this._points.length-1||(e instanceof DG.Marker?(!i.relatedTarget||i.relatedTarget!==e.querySelector("container")&&i.relatedTarget.parentNode!==e.querySelector("container"))&&e.collapse():this._removeRunningLabel())},mousemove:function(t){if(!this._morphingNow&&this._lineMarkerHelper){var e=t.layer._point,i=this._nearestPoint(e._legs.middle,t.latlng);this._lineMarkerHelper.setLatLng(i).setText(this._getFormatedDistance(e,e.getLatLng().distanceTo(i)))}},layeradd:function(){Object.keys(this._layers).forEach(function(t){this._layers[t].bringToFront()},this)}},_fireChangeEvent:function(){this.fire("changed",{latlngs:this.getLatLngs()})},_addRunningLabel:function(t,e){var i=this._createPoint(t).addTo(this._layers.mouse,this._layers),o=this._map.getPane("rulerPane");return o.insertBefore(i._icon,o.lastElementChild),i.setText(this._getFormatedDistance(e,e.getLatLng().distanceTo(t)))},_removeRunningLabel:function(){this._lineMarkerHelper&&(this._layers.mouse.removeLayer(this._lineMarkerHelper),this._lineMarkerHelper=null)},_insertPointInLine:function(t){var e,i=this._lineMarkerHelper.getLatLng(),o=t.target._point._pos+1;if(L.Browser.ie){var n=t.originalEvent.target||t.originalEvent.srcElement,r=n.parentNode;r.appendChild(n)}L.DomEvent.stopPropagation(t.originalEvent),this.spliceLatLngs(o,0,i),e=this._points[o],e.setText(this._getFormatedDistance(e)),setTimeout(function(){if(document.createEvent){var t=document.createEvent("MouseEvents");t.initMouseEvent("mouseup",!1,!1,document.defaultView,1,0,0,0,0,!1,!1,!1,!1,1,e._icon),document.dispatchEvent(t),t=document.createEvent("MouseEvents"),t.initMouseEvent("mousedown",!1,!1,document.defaultView,1,0,0,0,0,!1,!1,!1,!1,1,e._icon),e._icon.dispatchEvent(t)}else e._icon.fireEvent("onMouseUp",DG.extend(document.createEventObject(),{button:1,bubbles:!1,cancelable:!1})),e._icon.fireEvent("onMouseDown",DG.extend(document.createEventObject(),{button:1,bubbles:!1,cancelable:!1}))},0),this._removeRunningLabel(),this._updateLegs(e)},_nearestPoint:function(t,e){for(var i,o,n=this,r=this._project(e),s=t.getLatLngs().map(function(t){return n._project(t)}),a=0;a<s.length-1;a++){var l=DG.LineUtil.pointToSegmentDistance(r,s[a],s[a+1]);(void 0===i||l<i)&&(i=l,o=a)}var u=DG.LineUtil.closestPointOnSegment(r,s[o],s[o+1]);return this._unproject(u)},_addCloseHandler:function(t){t.target.on("click",this._deletePoint,this).querySelector("remove-link").style.display="inline-block"},_createPoint:function(t,e){var i=e?e:this.options.iconStyles.large,o={};return Object.keys(i).forEach(function(e){o[e]=DG.circleMarker(t,i[e])}),DG.Ruler.layeredMarker(t,{layers:o,draggable:this.options.editable,textDirection:"ar"!==this._map.getLang()?"auto":"rtl"})},_normalizeLatLng:function(t,e){for(var i=t.lng<e.lng?360:-360,o=t.lng;Math.abs(o-e.lng)>180;)o+=i;return DG.latLng(t.lat,o)},_normalizeRulerPoints:function(t){t=t||this._points[0];var e,i,o,n,r,s=this,a=t._pos,l=[];for(e=a+1;e<this._points.length;e++)i=this._points[e],o=this._points[e-1],n=i.getLatLng(),r=this._normalizeLatLng(n,o.getLatLng()),r.equals(n)||(i.setLatLng(r),l.push(e));for(e=a-1;e>=0;e--)i=this._points[e],o=this._points[e+1],n=i.getLatLng(),r=this._normalizeLatLng(n,o.getLatLng()),r.equals(n)||(i.setLatLng(r),l.push(e));l.sort().reduce(function(t,e){var i=t&&t===e-1;return s._updateLegs(s._points[e],i),e},null)},_pointEvents:{drag:function(t){var e=t.target;this._normalizeRulerPoints(e),DG.Browser.touch||e===this._points[this._points.length-1]||e.setText(this._getFormatedDistance(e)),this._updateLegs(e),this._updateDistance()},dragend:function(t){var e=t.target;this._morphingNow=!1,e._hovered||e===this._points[this._points.length-1]||e.collapse(),this._fireChangeEvent()},dragstart:function(){DG.Browser.touch&&this._lineMarkerHelper&&this._lineMarkerHelper.collapse(),this._morphingNow=!0}},_deletePoint:function(t){var e=t.originalEvent,i=e.target||e.srcElement;"dg-ruler__label-remove-link"!==i.className&&"dg-ruler__remove-link-overlay"!==i.className||(DG.DomEvent.stop(t.originalEvent),this.spliceLatLngs(t.target._pos,1))},_degToRad:function(t){return Math.PI/180*t},_radToDeg:function(t){return 180/Math.PI*t},_project:function(t){return this._map?this._map.project(t):DG.CRS.EPSG3857.latLngToPoint(t,1)},_unproject:function(t){return this._map?this._map.unproject(t):DG.CRS.EPSG3857.pointToLatLng(t,1)},_calcAngle:function(t,e,i){e=this._normalizeLatLng(e,t),i=this._normalizeLatLng(i,t),t=this._project(t),e=this._project(e),i=this._project(i);var o=e.x-t.x,n=i.x-t.x,r=e.y-t.y,s=i.y-t.y,a=o*n+r*s,l=Math.sqrt(o*o+r*r),u=Math.sqrt(n*n+s*s);return Math.acos(a/(l*u))},_calcMidPoint:function(t,e){var i=this._degToRad(t.lng),o=this._degToRad(t.lat),n=this._degToRad(e.lng),r=this._degToRad(e.lat),s=Math.acos(Math.sin(o)*Math.sin(r)+Math.cos(o)*Math.cos(r)*Math.cos(i-n)),a=.5,l=Math.sin((1-a)*s)/Math.sin(s),u=Math.sin(a*s)/Math.sin(s),c=l*Math.cos(o)*Math.cos(i)+u*Math.cos(r)*Math.cos(n),h=l*Math.cos(o)*Math.sin(i)+u*Math.cos(r)*Math.sin(n),d=l*Math.sin(o)+u*Math.sin(r),p=Math.atan2(d,Math.sqrt(c*c+h*h)),_=Math.atan2(h,c);return DG.latLng(this._radToDeg(p),this._radToDeg(_))},_adaptiveSample:function(t,e,i,o){if(i>9)return[];o=o||this._calcMidPoint(t,e);var n=this._calcMidPoint(t,o),r=this._calcMidPoint(o,e),s=this._calcAngle(n,o,t),a=this._calcAngle(o,t,e),l=this._calcAngle(r,o,e),u=3.1;if(s>u&&a>u&&l>u)return[];var c=[];return c=c.concat(this._adaptiveSample(t,o,i+1,n)),c.push(o),c=c.concat(this._adaptiveSample(o,e,i+1,r))},_calcGreatCircle:function(t,e){if(e=this._normalizeLatLng(e,t),t.equals(e,1))return[t,e];if(180==Math.abs(e.lng-t.lng)){var i=t.lat+e.lat>0?90:-90;return[t,DG.latLng(i,t.lng),DG.latLng(i,e.lng),e]}var o=[];o.push(t),o=o.concat(this._adaptiveSample(t,e,0)),o.push(e);for(var n=1;n<o.length;n++)o[n]=this._normalizeLatLng(o[n],o[n-1]);return o},_addLegs:function(t){var e=this.options.pathStyles,i=this._calcGreatCircle(t.getLatLng(),this._points[t._pos+1].getLatLng());t._legs={},Object.keys(e).forEach(function(o){t._legs[o]=DG.polyline(i,e[o]).addTo(this._layers[o])},this),t._legs.mouse._point=t.once("remove",this._clearRemovingPointLegs,this),this.options.editable&&!DG.Browser.mobile&&t._legs.mouse.on("mousedown",this._insertPointInLine,this),this._map&&this._layers.mouse.addLayer(t._legs.mouse)},_clearRemovingPointLegs:function(t){this._removeLegs(t.target)},_removeLegs:function(t){t._legs&&(Object.keys(t._legs).forEach(function(e){this._layers[e].removeLayer(t._legs[e])},this),t._legs=null)},_updateLegs:function(t,e){var i,o=t.getLatLng(),n=this._points[t._pos-1],r=this._points[t._pos+1],s=this;n&&!e&&(i=s._calcGreatCircle(n.getLatLng(),o),Object.keys(n._legs).forEach(function(t){n._legs[t].setLatLngs(i)})),r&&(i=s._calcGreatCircle(o,r.getLatLng()),Object.keys(t._legs).forEach(function(e){t._legs[e].setLatLngs(i)}))},_calcDistance:function(t,e){for(var i=e?e:0,o=t?t._pos:this._points.length-1,n=0;n<o;n++)i+=this._points[n].getLatLng().distanceTo(this._points[n+1].getLatLng());return i},_getFormatedDistance:function(){var t=this._calcDistance.apply(this,arguments),e="m";return t>1e3?(t/=1e3,e="km",t>1e3?(t=t.toFixed(),t=t.slice(0,-3)+" "+t.slice(-3)):t=t.toFixed(2).split(".").join(this.t("delimiter"))):t=Math.round(t),[t||0," ",this.t(e)].join("")},_updateDistance:function(){this._map&&this._points.length&&this._points[this._points.length-1].setText(this._getFormatedDistance())}}),DG.ruler=function(t,e){return new DG.Ruler(t,e)},DG.Ruler.LayeredMarker=DG.Marker.extend({options:{draggable:!1,keyboard:!1,riseOnHover:!0,pane:"rulerMarkerPane",textDirection:"auto",iconHTML:['<img class="dg-ruler__label-spacer" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" width="26" height="26" />','<div class="dg-ruler__label-container">','    <div class="dg-ruler__point"></div>','    <span class="dg-ruler__label-distance">0 км</span>','    <span class="dg-ruler__label-remove-link"></span>','    <div class="dg-ruler__remove-link-overlay"></div>',"</div>"].join("\n")},statics:{domClass:"dg-ruler__label"},addTo:function(t,e){return Object.keys(this._layers).forEach(function(t){e[t].addLayer(this._layers[t])},this),this._viewport=e,DG.Marker.prototype.addTo.call(this.on("move",this._onMove),t)},onRemove:function(t){return Object.keys(this._layers).forEach(function(t){this._viewport[t].removeLayer(this._layers[t])},this),this.off("move",this._onMove),this._viewport=null,this._style=null,DG.Marker.prototype.onRemove.call(this,t)},setText:function(t){return this._iconCollapsed&&this.expand(),this._iconNodes.label.innerHTML=t,this._iconNodes.label.setAttribute("dir",this.options.textDirection),this},setPointStyle:function(t){return this._style!==t&&Object.keys(this._style=t).forEach(function(e){this._layers[e].setStyle(t[e])},this),this},expand:function(){return this._iconCollapsed=!1,this._iconNodes.container.style.display="block",this._iconNodes.spacer.style.display="none",this},collapse:function(){return this._iconCollapsed=!0,this._iconNodes.container.style.display="none",this._iconNodes.spacer.style.display="block",this},querySelector:function(t){return this._icon.querySelector("."+DG.Ruler.LayeredMarker.domClass+"-"+t)},_onMove:function(t){var e=t.latlng;Object.keys(this._layers).forEach(function(t){this._layers[t].setLatLng(e)},this)},_initIcon:function(){DG.Marker.prototype._initIcon.call(this),this._iconCollapsed=!0,this._icon.style.width="",this._iconNodes={label:this.querySelector("distance"),spacer:this.querySelector("spacer"),container:this.querySelector("container")}},_setPos:function(t){L.DomUtil.setPosition(this._icon,t),this._shadow&&L.DomUtil.setPosition(this._shadow,t)},_afterInit:function(){this._layers=this.options.layers||null,this.options.icon=DG.divIcon({className:DG.Ruler.LayeredMarker.domClass,iconSize:[26,26],iconAnchor:[13,13],html:this.options.iconHTML})}}),DG.Ruler.LayeredMarker.addInitHook("_afterInit"),DG.Ruler.layeredMarker=function(t,e){return new DG.Ruler.LayeredMarker(t,e)};var rulerRenderer=DG.svg({pane:"rulerPane"}),hoverRenderer=DG.svg({pane:"rulerPane"});DG.Ruler.mergeOptions({pathStyles:{back:{color:"#fff",opacity:1,weight:12,pointerEvents:"none",noClip:!0,renderer:rulerRenderer,smoothFactor:0},middle:{color:"#0da5d5",opacity:1,weight:4,pointerEvents:"none",noClip:!0,renderer:rulerRenderer,smoothFactor:0},mouse:{color:"#fff",opacity:DG.Browser.vml?.1:0,weight:DG.Browser.touch?40:20,pointerEvents:"painted",noClip:!0,renderer:hoverRenderer,smoothFactor:0}},iconStyles:{large:{back:{color:"#fff",opacity:1,fillColor:"#fff",fillOpacity:1,weight:1,radius:13,renderer:rulerRenderer},middle:{color:"#0da5d5",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:1,radius:9,renderer:rulerRenderer},front:{color:"#fff",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:4,radius:5,renderer:rulerRenderer}},small:{back:{color:"#fff",opacity:1,fillColor:"#fff",fillOpacity:1,weight:1,radius:9,renderer:rulerRenderer},middle:{color:"#0da5d5",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:1,radius:5,renderer:rulerRenderer},front:{color:"#fff",opacity:1,fillColor:"#0da5d5",fillOpacity:1,weight:4,radius:2,renderer:rulerRenderer}}}}),DG.Ruler.Dictionary.ru={km:"км",m:"м",delimiter:","},DG.Ruler.Dictionary.it={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.cs={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.es={km:"km",m:"m",delimiter:","},DG.Ruler.Dictionary.en={km:"km",m:"m",delimiter:"."},DG.Ruler.Dictionary.ar={km:"كم",m:"م",delimiter:"."},DG.Control.Ruler=DG.RoundControl.extend({options:{position:"topright",iconClass:"ruler"},statics:{Dictionary:{}},initialize:function(t){DG.setOptions(this,t),DG.extend(this,{_active:!1,_drawingHelper:null,_geoclickerNeedRestore:!1}).on(this._controlEvents,this)},_controlEvents:{add:function(){this._drawingHelper=DG.ruler([])},click:function(){this._active=!this._active,this._active?(this.setState("active"),this._startDrawing()):(this.setState(""),this._finishDrawing())},remove:function(){this.off(this._controlEvents,this),this._active&&(this._map.removeLayer(this._drawingHelper),this._active=!1),this._drawingHelper=null}},_startDrawing:function(){this._map.addLayer(this._drawingHelper).on("click",this._handleMapClick,this),this._map.fire("rulerstart")},_finishDrawing:function(){this._map.off("click",this._handleMapClick,this).removeLayer(this._drawingHelper),this._drawingHelper.setLatLngs([]),this._map.fire("rulerend")},_handleMapClick:function(t){this._drawingHelper.addLatLng(t.latlng)},_renderTranslation:function(){this._link.title=this.t("button_title")}}),DG.control.ruler=function(t){return new DG.Control.Ruler(t)},DG.Map.mergeOptions({rulerControl:!1}),DG.Map.addInitHook(function(){this.options.rulerControl&&(this.rulerControl=DG.control.ruler(this.options.rulerControl),this.addControl(this.rulerControl))}),DG.Control.Ruler.Dictionary.ru={button_title:"Линейка"},DG.Control.Ruler.Dictionary.it={button_title:"Righello"},DG.Control.Ruler.Dictionary.cs={button_title:"Pravítko"},DG.Control.Ruler.Dictionary.es={button_title:"Regla"},DG.Control.Ruler.Dictionary.en={button_title:"Ruler"},DG.Control.Ruler.Dictionary.ar={button_title:"مسطرة"},function(t){function e(t,e){return t.w('<div class="dg-attribution__copyright"><ul class="dg-attribution__links"><li class="dg-attribution__link-item">').x(e.get(["osm"],!1),e,{"else":i,block:o},{}).w('</li><li class="dg-attribution__link-item"><a href="').f(e.get(["copyright_license"],!1),e,"h").w('" target="_blank" class="dg-attribution__link">').f(e.get(["license_agreement"],!1),e,"h").w('</a></li></ul><a href="').f(e.get(["copyright_logo"],!1),e,"h").w('" target="_blank" class="dg-attribution__logo-url"></a></div>')}function i(t,e){return t.w('<a href="').f(e.get(["copyright_apilink"],!1),e,"h").w('" target="_blank" class="dg-attribution__link" dir="').f(e.get(["dir"],!1),e,"h").w('">').f(e.get(["work_on"],!1),e,"h").w("</a>")}function o(t,e){return t.w('© <a href="http://www.openstreetmap.org/copyright" target="_blank" class="dg-attribution__link">OpenStreetMap contributors</a>, <a href="').f(e.get(["copyright_apilink"],!1),e,"h").w('" target="_blank" class="dg-attribution__link" dir="').f(e.get(["dir"],!1),e,"h").w('">').f(e.get(["work_on_with_osm"],!1),e,"h").w("</a>")}return t.register("DGAttribution/copyright",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_').f(e.get(["type"],!1),e,"h").w('">').f(e.get(["purpose"],!1),e,"h").w("</div>").s(e.get(["drilldown"],!1),e,{
	block:i},{})}function i(t,e){return t.w('<div class="dg-map-geoclicker__drilldown">').f(e.get(["drilldown"],!1),e,"h").w("</div>")}return t.register("DGGeoclicker/cityarea",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<address class="dg-firm-card__address dg-firm-card__icon">').f(e.get(["address"],!1),e,"h").s(e.get(["comment"],!1),e,{block:i},{}).w("</address>")}function i(t,e){return t.w('<span class="dg-firm-card__comment">&mdash; ').f(e.getPath(!0,[]),e,"h").w("</span>")}return t.register("DGGeoclicker/firmCardAddr",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["groups"],!1),e,{block:i},{})}function i(t,e){return t.s(e.get(["contacts"],!1),e,{block:o},{})}function o(t,e){return t.h("select",e,{block:n},{key:e.get(["type"],!1),type:"string"},"h")}function n(t,e){return t.h("eq",e,{block:r},{value:"phone",type:"string"},"h").h("eq",e,{block:a},{value:"fax",type:"string"},"h").h("eq",e,{block:u},{value:"website",type:"string"},"h").h("eq",e,{block:c},{value:"email",type:"string"},"h")}function r(t,e){return t.w('<div class="dg-firm-card__phone dg-firm-card__icon"><span class="dg-firm-card__phone-num">').f(e.get(["text"],!1),e,"h").s(e.get(["comment"],!1),e,{block:s},{}).w("</span></div>")}function s(t,e){return t.w('<span class="dg-firm-card__comment" title="').f(e.getPath(!0,[]),e,"h").w('">&mdash;&nbsp;&nbsp;').f(e.getPath(!0,[]),e,"h").w("</span>")}function a(t,e){return t.w('<div class="dg-firm-card__phone dg-firm-card__icon"><span class="dg-firm-card__phone-num">').f(e.get(["text"],!1),e,"h").s(e.get(["comment"],!1),e,{block:l},{}).w("</span></div>")}function l(t,e){return t.w('<span class="dg-firm-card__comment" title="').f(e.getPath(!0,[]),e,"h").w('">&mdash;&nbsp;&nbsp;').f(e.getPath(!0,[]),e,"h").w("</span>")}function u(t,e){return t.w('<div class="dg-firm-card__link dg-firm-card__site dg-firm-card__icon"><a href="').f(e.get(["url"],!1),e,"h").w('" target="_blank" class="dg-link_scheme_dark dg-firm-card__sitelink">').f(e.get(["text"],!1),e,"h").w("</a></div>")}function c(t,e){return t.w('<div class="dg-firm-card__link dg-firm-card__email dg-firm-card__icon"><a href="mailto:').f(e.get(["value"],!1),e,"h").w('">').f(e.get(["value"],!1),e,"h").w("</a></div>")}return t.register("DGGeoclicker/firmCardContacts",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,a.__dustBody=!0,l.__dustBody=!0,u.__dustBody=!0,c.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-popup__header-title dg-popup__header-title_for_firmcard" title="').f(e.get(["firmName"],!1),e,"h").w('">').f(e.get(["firmName"],!1),e,"h").w("</div>").x(e.get(["links"],!1),e,{block:i},{})}function i(t,e){return t.w('<div class="dg-popup__header-links">').s(e.get(["links"],!1),e,{block:o},{}).w("</div>")}function o(t,e){return t.h("eq",e,{"else":n,block:a},{key:l,value:"flamp_stars",type:"string"},"h")}function n(t,e){return t.w('<a class="dg-popup__header-link dg-popup__link dg-popup__link_type_').f(e.get(["name"],!1),e,"h").w('"').x(e.get(["href"],!1),e,{"else":r,block:s},{}).w(">").f(e.get(["label"],!1),e,"h").w("</a>")}function r(t,e){return t.w('href="javascript:void(0)"')}function s(t,e){return t.w("href=").f(e.get(["href"],!1),e,"h").w(' target="_blank"')}function a(t,e){return t.w('<div class="dg-popup__rating"><div class="dg-popup__rating-stars" style="width: ').f(e.get(["width"],!1),e,"h").w('%"></div></div>')}function l(t,e){return t.f(e.get(["name"],!1),e,"h")}return t.register("DGGeoclicker/firmCardHeader",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,a.__dustBody=!0,l.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["rubrics"],!1),e,{block:i},{})}function i(t,e){return t.w('<section class="dg-firm-card__rubrics">').x(e.get(["primary"],!1),e,{block:o},{}).x(e.get(["additional"],!1),e,{block:r},{}).w("</section>")}function o(t,e){return t.w('<ul class="dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_primary">').s(e.get(["primary"],!1),e,{block:n},{}).w("</ul>")}function n(t,e){return t.w('<li class="dg-firm-card__rubrics-list-item">').f(e.get(["name"],!1),e,"h").w("</li>")}function r(t,e){return t.w('<ul class="dg-firm-card__rubrics-list dg-firm-card__rubrics-list_type_additional">').s(e.get(["additional"],!1),e,{block:s},{}).w("</ul>")}function s(t,e){return t.w('<li class="dg-firm-card__rubrics-list-item">').f(e.get(["name"],!1),e,"h").w("</li>")}return t.register("DGGeoclicker/firmCardRubric",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-firm-card__schedule dg-schedule dg-schedule_open_').x(e.getPath(!1,["forecast","open"]),e,{"else":i,block:o},{}).w(" dg-schedule_works-everyday_").x(e.getPath(!1,["schedule","everyday"]),e,{"else":n,block:r},{}).w('">').x(e.get(["schedule"],!1),e,{block:s},{}).w("</div>")}function i(t,e){return t.w("false")}function o(t,e){return t.w("true")}function n(t,e){return t.w("false")}function r(t,e){return t.w("true")}function s(t,e){return t.x(e.getPath(!1,["forecast","today"]),e,{block:a},{}).s(e.getPath(!1,["forecast","now"]),e,{block:h},{}).nx(e.getPath(!1,["schedule","everyday"]),e,{block:p},{})}function a(t,e){return t.w('<div class="dg-schedule__today"><div class="dg-schedule__today-inner">').f(e.getPath(!1,["forecast","today","text"]),e,"h").w("&nbsp;").x(e.getPath(!1,["forecast","today","from"]),e,{block:l},{}).x(e.getPath(!1,["schedule","lunch"]),e,{block:u},{}).w("</div></div>")}function l(t,e){return t.f(e.getPath(!1,["forecast","today","from"]),e,"h").w("&ndash;").f(e.getPath(!1,["forecast","today","to"]),e,"h")}function u(t,e){return t.w(",&nbsp;").f(e.getPath(!1,["forecast","today","lunchStr"]),e,"h").w("&nbsp;").s(e.getPath(!1,["schedule","lunch"]),e,{block:c},{})}function c(t,e){return t.f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h")}function h(t,e){return t.w('<div class="dg-schedule__now"><span class="dg-schedule__now-text">').f(e.getPath(!0,[]),e,"h").s(e.getPath(!1,["schedule","comment"]),e,{block:d},{}).w("</span></div>")}function d(t,e){return t.w(", ").f(e.getPath(!0,[]),e,"h")}function p(t,e){return t.x(e.getPath(!1,["schedule","week"]),e,{block:_},{})}function _(t,e){return t.x(e.getPath(!1,["schedule","week","evently"]),e,{block:m},{}).x(e.getPath(!1,["schedule","week","table"]),e,{block:x},{})}function m(t,e){return t.w('<div class="dg-schedule__table">').s(e.getPath(!1,["schedule","week","evently"]),e,{block:f},{}).w("</div>")}function f(t,e){return t.w('<div class="dg-schedule__string">').x(e.get(["alltime"],!1),e,{block:g},{}).x(e.get(["everyday"],!1),e,{"else":v,block:y},{}).x(e.get(["holiday"],!1),e,{"else":b,block:w},{}).w("</div>")}function g(t,e){return t.f(e.get(["alltimeStr"],!1),e,"h")}function v(t,e){return t.f(e.get(["dayList"],!1),e,"h")}function y(t,e){return t.f(e.getPath(!1,["forecast","today","text"]),e,"h")}function b(t,e){return t.w('<span class="schedule__string-time">&nbsp;').f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h").w("</span>").s(e.get(["lunch"],!1),e,{block:C},{})}function C(t,e){return t.w("<p>").f(e.get(["lunchStr"],!1),e,"h").w('&mdash;<span class="schedule__string-time">').f(e.get(["from"],!1),e,"h").w("&ndash;").f(e.get(["to"],!1),e,"h").w("</span></p>")}function w(t,e){return t.w('&nbsp;&mdash;<span class="schedule__string-time">&nbsp;').f(e.get(["holidayStr"],!1),e,"h").w("</span>")}function x(t,e){return t.w('<div><div class="dg-schedule__table"><div class="dg-schedule__tc dg-schedule__tc_pre"><div class="dg-schedule__day-name">&nbsp;</div><div class="dg-schedule__table-clock dg-schedule__td"></div>').x(e.getPath(!1,["schedule","week","hasLunch"]),e,{block:k},{}).w("</div>").s(e.getPath(!1,["schedule","week","table"]),e,{block:D},{}).w("</div>  </div>")}function k(t,e){return t.w('<div class="dg-schedule__table-lunch dg-schedule__td"></div>')}function D(t,e){return t.h("if",e,{block:L},{cond:z},"h").w('<div class="dg-schedule__tc').x(e.get(["active"],!1),e,{block:P},{}).w('"><div class="dg-schedule__day-name">').f(e.get(["key"],!1),e,"h").w('</div><div class="dg-schedule__td">').x(e.get(["from"],!1),e,{"else":E,block:G},{}).w("</div>").s(e.get(["lunch"],!1),e,{block:T},{}).w("</div> ").h("if",e,{block:O},{cond:S},"h")}function L(t,e){return t.w('<span class="dg-schedule__table-cell-group">')}function z(t,e){return t.w("(").f(e.get(["$idx"],!1),e,"h").w(" == ").f(e.get(["$len"],!1),e,"h").w(" - 2)")}function P(t,e){return t.w(" dg-schedule__tc_active_true")}function E(t,e){return t.w("&ndash;")}function G(t,e){return t.f(e.get(["from"],!1),e,"h").w(" ").f(e.get(["to"],!1),e,"h")}function T(t,e){return t.w('<div class="dg-schedule__td">').x(e.get(["from"],!1),e,{"else":A,block:M},{}).w("</div>")}function A(t,e){return t.w("&ndash;")}function M(t,e){return t.f(e.get(["from"],!1),e,"h").w(" ").f(e.get(["to"],!1),e,"h")}function O(t,e){return t.w("</span>")}function S(t,e){return t.w("(").f(e.get(["$idx"],!1),e,"h").w(" == ").f(e.get(["$len"],!1),e,"h").w(")")}return t.register("DGGeoclicker/firmCardSchedule",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,a.__dustBody=!0,l.__dustBody=!0,u.__dustBody=!0,c.__dustBody=!0,h.__dustBody=!0,d.__dustBody=!0,p.__dustBody=!0,_.__dustBody=!0,m.__dustBody=!0,f.__dustBody=!0,g.__dustBody=!0,v.__dustBody=!0,y.__dustBody=!0,b.__dustBody=!0,C.__dustBody=!0,w.__dustBody=!0,x.__dustBody=!0,k.__dustBody=!0,D.__dustBody=!0,L.__dustBody=!0,z.__dustBody=!0,P.__dustBody=!0,E.__dustBody=!0,G.__dustBody=!0,T.__dustBody=!0,A.__dustBody=!0,M.__dustBody=!0,O.__dustBody=!0,S.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<a id="').f(e.getPath(!1,["firm","id"]),e,"h").w('" class="dg-popup__link" href="#">').f(e.getPath(!1,["firm","name"]),e,"h").w("</a>")}return t.register("DGGeoclicker/firmlistItem",e),e.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.x(e.get(["payments"],!1),e,{block:i},{})}function i(t,e){return t.w('<section class="dg-firm-card__aa"><ul class="dg-firm-card__aa-list">').s(e.get(["payments"],!1),e,{block:o},{}).w("</ul></section>")}function o(t,e){return t.w('<li class="dg-firm-card__aa-list-item">').f(e.getPath(!0,[]),e,"h").w("</li>")}return t.register("DGGeoclicker/frimCardPayments",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["address"],!1),e,{block:i},{}).s(e.get(["purpose"],!1),e,{block:r},{}).s(e.get(["attractions"],!1),e,{block:s},{})}function i(t,e){return t.w('<address class="dg-map-geoclicker__address">').s(e.getPath(!1,["address","header"]),e,{block:o},{}).s(e.getPath(!1,["address","drilldown"]),e,{block:n},{}).w("</address>")}function o(t,e){return t.w('<div class="dg-map-geoclicker__address-header">').f(e.getPath(!0,[]),e,"h").w("</div>")}function n(t,e){return t.w('<div class="dg-map-geoclicker__address-drilldown">').f(e.getPath(!0,[]),e,"h").w("</div>")}function r(t,e){return t.w('<div class="dg-map-geoclicker__purpose">').f(e.getPath(!0,[]),e,"h").w("</div>")}function s(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight">').f(e.getPath(!0,[]),e,"h").w("</div>")}return t.register("DGGeoclicker/house",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-preloader dg-preloader_scheme_regular dg-preloader_animation_').x(e.get(["anim"],!1),e,{"else":i,block:o},{}).x(e.get(["small"],!1),e,{block:n},{}).w('"></div>')}function i(t,e){return t.w("false")}function o(t,e){return t.w("true")}function n(t,e){return t.w(" dg-preloader_size_small")}return t.register("DGGeoclicker/loader",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.w('<div class="dg-popup__footer-title"><a class="dg-popup__show-less-house-link" href="javascript:void(0)">').f(e.get(["hideFirmsText"],!1),e,"h").w("</a></div>")}return t.register("DGGeoclicker/popupFooter",e),e.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.x(e.get(["btns"],!1),e,{block:i},{})}function i(t,e){return t.w('<footer class="dg-popup__footer-buttons">').s(e.get(["btns"],!1),e,{block:o},{}).w("</footer>")}function o(t,e){return t.w('<div class="dg-popup__footer-button-wrapper"><a class="dg-popup__button_name_').f(e.get(["name"],!1),e,"h").w(" dg-popup__footer-button").x(e.get(["icon"],!1),e,{block:n},{}).w('"').x(e.get(["href"],!1),e,{"else":r,block:s},{}).w(">").f(e.get(["label"],!1),e,"h").w("</a></div>")}function n(t,e){return t.w(" dg-popup__footer-icon-button")}function r(t,e){return t.w('href="javascript:void(0)"')}function s(t,e){return t.w("href=").f(e.get(["href"],!1),e,"h").w(' target="_blank"')}return t.register("DGGeoclicker/popupFooterBtns",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["title"],!1),e,{block:i},{})}function i(t,e){return t.w('<div class="dg-popup__header-title">').f(e.getPath(!0,[]),e,"h").w("</div>")}return t.register("DGGeoclicker/popupHeader",e),e.__dustBody=!0,i.__dustBody=!0,e}(dust),function(t){function e(t,e){return t.s(e.get(["purpose"],!1),e,{block:i},{}).s(e.get(["address"],!1),e,{block:o},{}).s(e.get(["description"],!1),e,{block:s},{})}function i(t,e){return t.w('<div class="dg-map-geoclicker__purpose dg-map-geoclicker__purpose_type_sight">').f(e.getPath(!0,[]),e,"h").w("</div>")}function o(t,e){return t.w('<address class="dg-map-geoclicker__address">').s(e.getPath(!1,["address","header"]),e,{block:n},{}).s(e.getPath(!1,["address","drilldown"]),e,{block:r},{}).w("</address>")}function n(t,e){return t.w('<div class="dg-map-geoclicker__address-header">').f(e.getPath(!0,[]),e,"h").w("</div>")}function r(t,e){return t.w('<div class="dg-map-geoclicker__address-drilldown">').f(e.getPath(!0,[]),e,"h").w("</div>")}function s(t,e){return t.w('<div class="dg-map-geoclicker__sight-description">').f(e.getPath(!0,[]),e,"h").w("</div>").s(e.get(["showMoreText"],!1),e,{block:a},{})}function a(t,e){return t.w('<a class="dg-map-geoclicker__show-more-sights-link" href="javascript:void(0)">').f(e.getPath(!0,[]),e,"h").w("</a>")}return t.register("DGGeoclicker/sight",e),e.__dustBody=!0,i.__dustBody=!0,o.__dustBody=!0,n.__dustBody=!0,r.__dustBody=!0,s.__dustBody=!0,a.__dustBody=!0,e}(dust),DG.fallbackProjectsList=JSON.parse('[{"bounds":"POLYGON((34.280779 35.226702,34.230518 35.176645,34.311619 35.053578,34.333255 34.94624,34.30553 34.86475,34.246532 34.802092,34.131869 34.756001,33.987598 34.764336,33.917176 34.742875,33.835702 34.739903,33.790212 34.684859,33.72822 34.642865,33.448103 34.538793,33.259541 34.501493,33.192432 34.413254,33.066976 34.363612,32.915196 34.369952,32.805837 34.40138,32.743846 34.438844,32.58024 34.461878,32.38906 34.52014,32.257081 34.592284,32.192743 34.651138,32.082486 34.819072,32.02449 35.022688,32.045537 35.17596,32.115025 35.264403,32.213492 35.309184,32.362822 35.30542,32.471669 35.368093,32.671189 35.399121,32.678969 35.453037,32.711632 35.513637,32.766439 35.562413,32.837579 35.594163,32.949971 35.603965,33.302016 35.553834,33.553453 35.562031,33.937128 35.666397,34.067997 35.744069,34.543625 35.906784,34.67294 35.905835,34.78423 35.852299,34.837429 35.785874,34.855318 35.707916,34.841183 35.642705,34.776411 35.536547,34.710709 35.47953,34.280779 35.226702))","code":"cyprus","country_code":"cy","domain":"com.cy","flags":{"2gis_reviews":true,"flamp":false,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"173","name":"Cyprus","time_zone":{"name":"Asia/Nicosia","offset":180},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((14.219495 49.934897,14.215528 50.17879,14.713797 50.181086,14.715245 49.937173,14.219495 49.934897))","code":"praha","country_code":"cz","domain":"cz","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"public_transport":true,"road_network":true},"id":"92","name":"Praha","time_zone":{"name":"Europe/Prague","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((-70.483526 -33.665691,-70.857156 -33.660641,-70.849333 -33.293335,-70.477276 -33.298315,-70.483526 -33.665691))","code":"santiago","country_code":"cl","domain":"cl","flags":{"2gis_reviews":false,"flamp":false,"metro":true,"public_transport":true,"road_network":true},"id":"101","name":"Santiago","time_zone":{"name":"America/Santiago","offset":-240},"type":"region","zoom_level":{"max":19,"min":9}},{"bounds":"POLYGON((55.13142 25.544679,55.203999 25.567715,55.279599 25.566579,55.43176 25.759947,55.55436 25.811148,55.666094 25.897751,55.76817 25.925981,55.826597 26.007005,55.888369 26.151722,56.086425 26.050441,56.15912 26.062127,56.195513 25.979301,56.163975 25.946893,56.177561 25.892732,56.139167 25.8325,56.1725 25.769167,56.140833 25.735,56.143611 25.676111,56.191111 25.648056,56.201874 25.611984,56.253291 25.60219,56.266328 25.606335,56.254586 25.613159,56.264173 25.627665,56.418384 25.682657,56.549221 25.692716,56.591385 25.549234,56.602446 25.323577,56.585359 25.087633,56.594079 25.007481,56.323288 24.972644,56.348923 24.934376,56.338442 24.914535,56.259358 24.859817,56.205659 24.850507,56.201022 24.784219,56.144333 24.741556,56.060585 24.746639,56.036157 24.810922,55.978341 24.877363,55.980164 24.894492,56.062185 24.870801,56.042048 24.886589,56.058722 24.949126,56.042075 24.947686,56.045483 24.967887,56.006871 24.994727,55.960882 25.005958,55.910907 24.965663,55.851301 24.965812,55.812409 24.910874,55.836502 24.671031,55.793833 24.637012,55.816207 24.615223,55.767784 24.572526,55.764989 24.52949,55.834202 24.409554,55.833944 24.327733,55.759405 24.261142,55.752895 24.234821,55.833523 24.200902,55.954447 24.222568,55.969652 24.182449,55.960753 24.170318,56.017506 24.066605,55.902317 24.046941,55.833035 24.01459,55.801126 24.025482,55.781754 24.055948,55.731246 24.058066,55.485274 23.944384,55.533725 23.849352,55.531869 23.757286,55.569228 23.720734,55.572308 23.629646,55.452588 23.465217,55.430691 23.399593,55.416507 23.382151,55.401537 23.392525,55.232271 23.110348,55.216283 23.02621,55.227508 22.791619,55.21284 22.705686,55.137388 22.631591,52.58104 22.939203,51.590376 24.126971,51.589825 24.26588,51.529512 24.336352,51.416071 24.393194,51.466454 24.462489,51.565206 24.553035,51.589187 24.619704,51.586122 24.664189,52.02542 24.75828,52.309194 24.842176,52.378334 24.900336,52.337088 24.949252,52.345961 24.997718,52.405921 25.018775,52.450032 24.982958,52.647202 25.143128,52.894479 25.470458,54.182354 25.450646,55.13142 25.544679))","code":"dubai","country_code":"ae","domain":"ae","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"public_transport":true,"road_network":true,"traffic":true},"id":"99","name":"UAE","time_zone":{"name":"Asia/Dubai","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((11.381405 45.733677,12.61199 45.701369,12.572035 45.071337,11.355023 45.102946,11.381405 45.733677))","code":"padova","country_code":"it","domain":"it","flags":{"2gis_reviews":false,"flamp":false,"metro":false,"public_transport":true,"road_network":false},"id":"66","name":"Venezia e Padova","time_zone":{"name":"Europe/Rome","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((91.070624 53.65785,90.694431 53.829965,90.641338 53.937449,91.044722 54.011745,91.169475 54.054245,91.247741 54.10893,91.454448 54.134677,91.622967 54.067042,91.640045 53.973842,91.814639 53.94927,91.845442 53.91996,91.819053 53.85101,91.82396 53.765818,91.840532 53.753093,91.822802 53.717291,91.837259 53.573118,91.83061 53.553066,91.796923 53.549953,91.777709 53.528422,91.820605 53.472974,91.902092 53.464155,91.975795 53.380563,91.957949 53.348546,91.844535 53.29356,91.791986 53.215861,91.791488 53.190281,91.630564 53.142953,91.608241 53.066422,91.635951 52.945221,91.682944 52.871745,91.610779 52.766581,91.448948 52.715568,91.323567 52.698296,90.875829 53.015332,90.790707 53.059612,90.70189 53.141567,90.663858 53.198743,90.688715 53.225401,90.723102 53.232022,90.802796 53.311734,91.04732 53.437432,91.105621 53.481836,91.148065 53.559012,91.060276 53.614685,91.070624 53.65785))","code":"abakan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"69","name":"Абакан","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.989242 43.559453,50.700278 43.960347,50.548767 44.143806,50.310331 44.173939,50.159119 44.240731,50.077464 44.316906,50.050169 44.386403,50.033572 44.549467,49.924839 44.758753,49.858647 44.834275,49.815392 44.920822,49.816353 45.023361,49.847194 45.094706,49.8831 45.134367,50.017069 45.186872,50.314389 45.198264,50.4106 45.185556,50.707747 45.080803,50.871631 45.115622,51.078633 45.264022,51.269189 45.462642,51.342392 45.507019,51.730008 45.592703,52.155669 45.534531,52.290372 45.552439,52.471922 45.607825,52.541508 45.719714,53.021861 46.091373,53.191789 46.012055,53.684004 46.0156,53.895303 46.127348,53.968557 46.192437,53.971735 46.24613,54.30769 46.257033,54.504746 46.30105,54.692764 46.323051,54.832578 46.363543,55.089586 46.379528,55.270475 46.367362,55.487919 46.520131,55.602653 46.421094,55.657382 46.419648,55.698046 46.399684,55.81798 46.401193,55.824929 46.349698,55.860157 46.305272,55.820425 46.276012,55.837026 46.251191,55.90249 46.237314,55.95692 46.260008,55.981457 46.210459,56.04476 46.211476,56.121737 46.154545,56.201516 46.135755,56.286168 46.151583,56.46663 46.132189,56.516505 46.097356,56.552526 46.005868,56.605778 45.926133,56.744109 45.177249,55.998743 45.000314,56.001508 41.324124,55.876714 41.331786,55.816356 41.297155,55.811717 41.278338,55.743336 41.302058,55.721496 41.293192,55.727086 41.279493,55.63561 41.282813,55.603316 41.246392,55.600034 41.272913,55.576874 41.27195,55.567019 41.294407,55.545235 41.287966,55.557026 41.27561,55.542728 41.259293,55.499612 41.251587,55.450623 41.269299,55.442191 41.293651,55.430472 41.279495,55.398313 41.337222,55.315465 41.390882,55.119606 41.604653,55.066234 41.699339,54.949976 41.833213,54.952115 41.906308,54.928925 41.928325,54.779482 42.052549,54.21781 42.379087,53.570558 42.288924,52.984788 42.121175,52.449984 41.761967,52.335076 41.719338,52.259144 41.724447,52.229019 42.117106,52.258633 42.212153,52.440644 42.469697,52.392847 42.601758,52.195397 42.6508,51.836542 42.695872,51.737094 42.757403,51.635567 42.893483,51.557783 42.967481,51.262286 43.003889,51.132642 43.05145,51.077578 43.123231,51.071017 43.160703,51.096811 43.450783,50.989242 43.559453))","code":"aktau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"196","name":"Актау","time_zone":{"name":"Asia/Aqtau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((57.131233 50.565431,57.29241 50.584455,57.319324 50.522876,57.456565 50.507563,57.508771 50.537321,57.653998 50.489218,57.702377 50.502943,57.760821 50.488773,57.770117 50.410886,57.71458 50.374648,57.76243 50.353087,57.773313 50.330205,57.744175 50.275572,57.755202 50.257032,57.669871 50.241394,57.687866 50.19675,57.573892 50.188895,57.558014 50.169447,57.425888 50.121144,57.148367 50.120826,56.977926 50.152601,56.914478 50.21554,56.94188 50.275119,56.88205 50.313889,56.862849 50.343913,56.861403 50.3877,57.073194 50.556581,57.131233 50.565431))","code":"aktobe","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"167","name":"Актобе","time_zone":{"name":"Asia/Aqtobe","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.721521 43.311356,76.698817 43.366891,76.69697 43.442281,76.773217 43.495902,76.887808 43.478949,76.919061 43.491006,76.964974 43.461021,77.024019 43.475405,77.071052 43.468224,77.111197 43.420876,77.092545 43.384974,77.121697 43.350398,77.130764 43.288623,77.160741 43.243627,77.107785 43.073856,77.089632 43.070938,77.077184 43.034066,76.966515 43.049618,76.943479 43.033771,76.906183 43.037882,76.900697 43.083947,76.741722 43.103095,76.70909 43.167253,76.721521 43.311356))","code":"almaty","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"67","name":"Алматы","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.223466 54.858607,52.225581 54.896841,52.201091 54.925634,52.271902 54.972811,52.353207 54.986941,52.466983 54.87767,52.482409 54.827772,52.452724 54.803623,52.391155 54.816144,52.308586 54.807339,52.231899 54.837975,52.223466 54.858607))","code":"almetevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"108","name":"Альметьевск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((177.442943 64.716762,177.461329 64.743255,177.548927 64.732752,177.536236 64.715542,177.442943 64.716762))","code":"anadyr","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"155","name":"Анадырь","time_zone":{"name":"Asia/Anadyr","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.306107 44.718112,41.249612 44.671822,41.186821 44.715704,41.1145 44.66542,41.070272 44.69744,41.054013 44.687595,41.018874 44.743803,40.974331 44.728943,40.940735 44.766746,40.900976 44.752949,40.873061 44.793149,40.838805 44.781364,40.800459 44.857603,40.902811 44.893435,40.864347 44.961848,40.900608 44.987223,40.842616 45.033578,40.878791 45.056262,40.854148 45.076757,40.900974 45.107242,40.866832 45.134524,40.858846 45.150726,40.880047 45.165058,40.858388 45.184086,40.938913 45.241526,41.005788 45.241262,41.00537 45.229101,41.039447 45.22527,41.35348 45.223054,41.353171 45.186895,41.365911 45.186898,41.352481 45.150892,41.31891 45.15106,41.316496 45.091465,41.267332 45.056419,41.322559 45.016188,41.286438 44.991202,41.367978 44.932597,41.287273 44.860127,41.342416 44.830816,41.317765 44.793729,41.347284 44.746855,41.306107 44.718112))","code":"armawir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"106","name":"Армавир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.467082 64.829966,41.321175 64.812571,41.276671 64.284305,39.458118 64.301293,39.467082 64.829966))","code":"arkhangelsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"49","name":"Архангельск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.747405 46.794839,47.776244 46.800521,47.810135 46.761605,47.907265 46.740644,47.928378 46.720807,48.067759 46.731313,48.098791 46.712483,48.151499 46.714994,48.33634 46.663608,48.395222 46.544961,48.402786 46.492407,48.379384 46.340769,48.362235 46.327207,48.372658 46.316606,48.355751 46.22781,48.383153 46.195758,48.44409 46.171003,48.381341 46.137798,48.348806 46.057503,48.15419 46.054404,48.107321 46.033126,47.985383 46.019315,47.894663 46.029965,47.871002 46.061984,47.697541 46.053889,47.667071 46.097238,47.702048 46.117454,47.666533 46.152288,47.655593 46.258052,47.608108 46.303432,47.626158 46.340853,47.613269 46.362228,47.624706 46.701364,47.747405 46.794839))","code":"astrakhan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"8","name":"Астрахань","time_zone":{"name":"Europe/Astrakhan","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.81079 47.15804,51.773854 47.185327,51.783515 47.206253,51.838706 47.218498,51.861149 47.208672,51.876595 47.175483,51.983982 47.184051,52.057235 47.159303,52.067301 47.149367,52.044594 47.140455,52.046404 47.121763,52.091744 47.095943,51.972771 47.045744,51.928291 47.054367,51.917185 47.009789,51.882894 47.012164,51.873782 47.039007,51.837904 47.008341,51.823097 47.013373,51.852235 47.05764,51.819873 47.049269,51.780297 47.104107,51.81079 47.15804))","code":"atyrau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"168","name":"Атырау","time_zone":{"name":"Asia/Atyrau","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.725427 52.036702,47.748714 52.060939,47.860251 52.057786,47.850971 52.029011,47.879672 52.020045,47.878343 51.997199,47.829159 51.970019,47.802026 51.964036,47.79878 51.97669,47.720913 51.954501,47.699814 52.016127,47.725427 52.036702))","code":"balakovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"121","name":"Балаково","time_zone":{"name":"Europe/Volgograd","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((83.928748 53.507088,83.958924 53.474057,84.085515 53.473398,84.175059 53.491398,84.244766 53.479354,84.252861 53.450982,84.212018 53.445806,84.220531 53.397514,84.153577 53.393644,84.113666 53.342338,84.065249 53.322099,84.085325 53.299145,84.007656 53.124723,83.829412 53.119967,83.841391 53.105761,83.82457 53.091551,83.752618 53.110593,83.765491 53.119643,83.743587 53.128187,83.66524 53.124648,83.62449 53.145085,83.62725 53.129512,83.597794 53.129087,83.480861 53.171378,83.447607 53.152209,83.423017 53.173034,83.440163 53.184845,83.393189 53.243041,83.420765 53.275431,83.355743 53.326489,83.417758 53.339642,83.39828 53.373223,83.359899 53.358989,83.345893 53.372393,83.4203 53.408614,83.423045 53.420274,83.385145 53.425419,83.41033 53.445014,83.401345 53.460413,83.454096 53.455281,83.510199 53.504089,83.604538 53.478418,83.69242 53.482115,83.700773 53.473259,83.686064 53.462011,83.70283 53.453045,83.773714 53.458918,83.928748 53.507088))","code":"barnaul","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"4","name":"Барнаул","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.408454 50.586924,36.364963 50.614887,36.375499 50.618519,36.351604 50.645128,36.360667 50.672724,36.498137 50.712983,36.5567 50.702049,36.558012 50.689755,36.58454 50.697503,36.598181 50.682437,36.660204 50.70429,36.707462 50.693417,36.800423 50.735202,36.792352 50.715029,36.80311 50.70913,36.953653 50.68767,36.916122 50.620099,36.793726 50.595649,36.791261 50.57059,36.74007 50.54822,36.707136 50.505906,36.607104 50.497135,36.610968 50.482069,36.422398 50.503675,36.407339 50.51763,36.460387 50.542201,36.458536 50.563008,36.408454 50.586924))","code":"belgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"46","name":"Белгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((84.874519 52.630301,84.96163 52.640567,84.982697 52.620134,85.093095 52.688834,85.116926 52.689539,85.153911 52.634772,85.220059 52.615266,85.344146 52.674309,85.416886 52.616859,85.538556 52.454311,85.544664 52.424316,85.680389 52.416048,85.773647 52.385701,85.790168 52.29163,85.731543 52.277005,85.730345 52.210825,85.577013 52.212472,85.57808 52.180982,85.614329 52.140175,85.608661 52.111591,85.549344 52.104764,85.545184 52.090548,85.552467 52.04871,85.590302 52.027,85.584219 51.981935,85.544145 51.942899,85.558749 51.906102,85.415412 51.879329,85.364843 51.890686,85.252811 51.873429,85.052969 51.887588,84.909731 51.82692,84.777548 51.897267,84.763076 51.88263,84.715642 51.905948,84.678258 51.877171,84.59717 51.888289,84.558869 51.925041,84.512641 51.932725,84.500581 51.956761,84.464805 51.945612,84.450834 51.973785,84.463158 51.992048,84.504642 52.021509,84.532127 52.022362,84.553064 52.053188,84.504543 52.079354,84.473112 52.075977,84.449089 52.100058,84.573503 52.137237,84.503848 52.222385,84.483005 52.277609,84.588967 52.290758,84.612451 52.484775,84.573893 52.523347,84.680635 52.549619,84.669706 52.572998,84.874519 52.630301))","code":"biysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"20","name":"Бийск","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((133.076389 48.722009,132.924515 48.698156,132.88111 48.731395,132.778214 48.736631,132.79836 48.781288,132.825762 48.781726,132.838483 48.89423,132.915111 48.887804,132.938004 48.851563,133.130378 48.732886,133.076389 48.722009))","code":"birobidzhan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"157","name":"Биробиджан","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.33643 42.85545,75.570302 42.830459,75.716812 42.797344,75.761433 42.833491,75.786311 42.899161,75.823518 42.940253,75.937224 42.955718,75.949176 42.933001,76.028275 42.911042,76.194148 42.931117,76.200932 42.91645,76.302069 42.910942,76.303927 42.874442,76.343846 42.860756,76.47828 42.884302,76.522591 42.922249,76.575247 42.906103,76.603487 42.916155,76.708886 42.904153,76.749231 42.921514,76.755876 42.949774,76.822744 42.955093,76.835842 42.982848,76.917246 42.965857,76.9719 42.986711,77.004469 42.98309,77.035094 42.947192,77.062577 42.976592,77.154973 42.972254,77.156765 42.944425,77.179907 42.946993,77.234786 42.911813,77.302013 42.916541,77.350501 42.898513,77.47156 42.939266,77.485265 42.924637,77.552523 42.941107,77.581041 42.915514,77.670445 42.917955,77.696993 42.903906,77.780651 42.914754,77.82376 42.884439,77.874056 42.888611,77.911121 42.870732,77.934015 42.881626,77.968122 42.85082,78.002178 42.870654,78.054338 42.847632,78.091759 42.849356,78.116667 42.864588,78.171543 42.860289,78.197829 42.881989,78.348808 42.854848,78.370535 42.886981,78.430884 42.878797,78.464812 42.896432,78.566261 42.511021,78.677523 42.274735,77.64754 41.928742,77.283159 41.907998,77.092381 41.914309,76.583726 41.973638,76.17608 42.104976,76.021959 42.228659,75.992606 42.278642,75.996152 42.316469,75.982604 42.334876,75.995431 42.383247,75.984839 42.390884,75.908185 42.398192,75.884981 42.362349,75.80915 42.354528,75.77166 42.393324,75.679856 42.418715,75.635548 42.448328,75.568927 42.419523,75.530117 42.424251,75.515018 42.454551,75.486241 42.434229,75.407376 42.424195,75.376071 42.450156,75.280345 42.417396,75.197902 42.435125,75.153735 42.42587,75.108622 42.4444,75.079342 42.420226,75.045402 42.419472,75.007472 42.445055,74.969555 42.423173,74.916158 42.438041,74.791378 42.409699,74.416615 42.409699,74.414462 42.78905,74.39828 42.813256,74.413494 42.891453,74.4117 43.079799,74.633389 43.080409,74.749879 42.989881,74.853304 42.999852,75.223534 42.855173,75.33643 42.85545))","code":"bishkek","country_code":"kg","domain":"kg","flags":{"2gis_reviews":true,"flamp":false,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"112","name":"Бишкек","time_zone":{"name":"Asia/Bishkek","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((127.363676 50.403782,127.352443 50.441714,127.286463 50.467049,127.308368 50.520539,127.35453 50.542847,127.365778 50.577122,127.32975 50.625076,127.339437 50.679426,127.37608 50.702813,127.438103 50.784749,127.502736 50.82393,127.470168 50.892265,127.506464 50.931666,127.518609 51.029694,127.581071 51.042821,127.551575 51.089284,127.557909 51.128425,127.778 51.188068,127.817906 51.171164,127.921142 51.188613,127.923196 51.300574,127.944321 51.314406,127.93066 51.355243,127.985511 51.358863,128.022633 51.429539,128.070445 51.46957,128.257926 51.483286,128.329658 51.519172,128.389503 51.521946,128.395878 51.446126,128.453377 51.399746,128.451067 51.370352,128.523637 51.234533,128.522651 51.192067,128.569036 51.149161,128.599768 51.017885,128.663862 50.963103,128.657126 50.91772,128.681753 50.845115,128.566439 50.837419,128.392974 50.766518,128.36949 50.723945,128.252358 50.667232,128.175873 50.678308,128.165733 50.646583,128.132461 50.646556,128.10285 50.592973,128.007649 50.597843,127.984834 50.55919,128.031558 50.508262,128.062677 50.515051,128.059117 50.460764,128.005363 50.446487,127.957847 50.382386,127.953517 50.353369,127.911761 50.344062,127.869282 50.309829,127.900232 50.296527,127.877986 50.272908,127.83693 50.287922,127.826364 50.272383,127.768876 50.273176,127.73903 50.224478,127.612184 50.208694,127.598956 50.238392,127.37093 50.289745,127.325315 50.33611,127.363676 50.403782))","code":"blagoveshensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"52","name":"Благовещенск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((101.089619 56.502645,102.059766 56.482523,102.016041 55.92995,101.059727 55.949659,101.089619 56.502645))","code":"bratsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"51","name":"Братск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.306993 53.164362,34.180919 53.124632,34.121062 53.140568,34.091692 53.164732,34.097431 53.204355,34.11895 53.226269,34.088316 53.250407,34.103132 53.263035,34.089647 53.278232,34.154639 53.367685,34.144788 53.411926,34.193721 53.450275,34.297092 53.452291,34.34449 53.486122,34.464258 53.473829,34.543914 53.407776,34.606363 53.270293,34.581757 53.171344,34.432761 53.148647,34.306993 53.164362))","code":"bryansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"62","name":"Брянск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((31.211943 58.6702,31.254682 58.712294,31.34888 58.696046,31.373219 58.722165,31.419891 58.716772,31.4286 58.697627,31.518878 58.684671,31.518065 58.618393,31.642191 58.534742,31.323177 58.410328,31.255009 58.436947,31.261078 58.452358,31.18483 58.473859,31.121912 58.437613,31.055469 58.474338,31.121487 58.536682,31.143158 58.634691,31.182295 58.677821,31.211943 58.6702))","code":"v_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"77","name":"Великий Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.275102 43.150151,132.21611 43.028072,132.078173 42.898095,131.953248 42.837472,131.683704 42.786249,131.556063 42.836001,131.587829 43.001127,131.576277 43.03842,131.463549 43.143762,131.411051 43.399272,131.352056 43.462375,131.469144 43.517281,131.542647 43.523577,131.624304 43.564967,131.656048 43.582531,131.684033 43.635493,131.730653 43.665958,131.972032 43.633195,132.025225 43.594097,132.144108 43.572415,132.264317 43.527039,132.291052 43.534936,132.377914 43.481564,132.356268 43.458463,132.371029 43.453495,132.343238 43.430952,132.364157 43.419062,132.349499 43.396926,132.363818 43.367117,132.337976 43.336729,132.275102 43.150151))","code":"vladivostok","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"25","name":"Владивосток","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.664457 42.774425,44.673451 42.752473,44.636215 42.744987,44.577743 42.745408,44.551647 42.769135,44.573402 42.819361,44.558996 42.879702,44.598999 42.937189,44.586232 42.960717,44.623482 42.987794,44.628743 43.033283,44.571988 43.080116,44.619739 43.12101,44.704355 43.117526,44.703771 43.068887,44.74241 43.055611,44.727759 43.028178,44.729312 42.964361,44.688017 42.961324,44.668556 42.940746,44.676302 42.915877,44.646184 42.91671,44.632926 42.891378,44.646862 42.844371,44.665573 42.832257,44.664457 42.774425))","code":"vladikavkaz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"114","name":"Владикавказ","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.553697 56.016865,40.321166 56.021603,40.181044 56.034779,40.141737 56.053492,40.159347 56.071072,40.162239 56.12833,40.185872 56.155526,40.161254 56.184066,40.179205 56.210653,40.158592 56.250966,40.162371 56.288428,40.181312 56.297852,40.17218 56.344226,40.198005 56.43593,40.259638 56.467022,40.303939 56.466565,40.695168 56.461839,40.743413 56.430182,40.70655 56.397878,40.703366 56.336406,40.716351 56.326915,40.678552 56.280342,40.688775 56.179039,40.713729 56.10864,40.613067 56.009461,40.553697 56.016865))","code":"vladimir","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true},"id":"59","name":"Владимир","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.516273 48.264479,44.516501 48.286667,44.428333 48.293447,44.399822 48.305594,44.396745 48.328586,44.344889 48.33147,44.196749 48.239567,43.979783 48.328917,43.961466 48.345426,43.97311 48.362576,43.965729 48.407124,44.027168 48.465634,43.980829 48.472365,43.967298 48.506967,43.93733 48.506507,43.938644 48.52096,43.905835 48.519426,43.914095 48.547647,43.87482 48.582051,43.861216 48.623052,43.92897 48.621593,43.903636 48.658218,43.948472 48.707149,43.93956 48.731587,43.866099 48.764575,43.887828 48.792165,43.973955 48.851479,44.016491 48.828807,44.031502 48.841955,44.019816 48.847323,44.074949 48.89183,44.051643 48.903585,44.085706 48.932574,44.204013 48.899536,44.28802 48.924258,44.328352 48.985704,44.515948 48.948977,44.539657 48.963183,44.615677 48.950562,44.62823 48.972865,44.657701 48.955667,44.859461 48.923239,45.067555 48.808391,45.084772 48.779438,45.070885 48.765136,45.013591 48.761033,45.018099 48.743039,44.962483 48.700986,44.972802 48.677196,45.01123 48.663225,44.992745 48.646118,44.996412 48.618735,45.061759 48.574899,45.028151 48.572541,44.973857 48.454641,45.010793 48.444727,45.025871 48.383055,45.025853 48.357655,44.991761 48.3592,44.983554 48.293086,44.660355 48.266084,44.621043 48.277476,44.626912 48.258531,44.615641 48.25488,44.516273 48.264479))","code":"volgograd","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"33","name":"Волгоград","time_zone":{"name":"Europe/Volgograd","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.038487 47.559392,42.02831 47.573005,42.076024 47.573168,42.099772 47.613783,42.381517 47.622752,42.398058 47.600464,42.306525 47.553131,42.30273 47.462394,42.234895 47.460529,42.070756 47.505232,42.040161 47.550891,42.049593 47.560952,42.038487 47.559392))","code":"volgodonsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"122","name":"Волгодонск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.515933 59.121961,38.470498 59.099405,38.287173 59.086542,38.242049 59.06971,38.256449 59.06776,38.249376 59.060387,38.13843 59.057545,37.884693 59.011516,37.711939 59.029731,37.664721 59.081546,37.70754 59.099668,37.682968 59.118858,37.65629 59.212859,37.773079 59.211941,37.763425 59.225848,37.792745 59.234262,37.780588 59.268631,37.808478 59.305886,37.842804 59.311179,37.858537 59.336171,37.92028 59.34456,38.00095 59.328976,38.056271 59.346564,38.264175 59.320357,38.288699 59.328943,38.294461 59.306707,38.345585 59.291117,38.364161 59.312854,38.431422 59.30282,38.469535 59.318513,38.579894 59.291833,38.619833 59.303979,38.639694 59.288489,38.772389 59.30097,38.797706 59.285033,39.147462 59.305821,39.286558 59.337414,39.341859 59.330348,39.369125 59.306394,39.389929 59.335065,39.446643 59.35701,39.517848 59.358059,39.564516 59.331783,39.64683 59.350232,39.706341 59.344757,39.73792 59.371294,39.844323 59.411915,39.889432 59.392979,39.954988 59.398814,40.02458 59.371897,40.030302 59.35394,40.084607 59.349239,40.106504 59.356582,40.089706 59.374115,40.130857 59.382287,40.216618 59.391638,40.27283 59.375595,40.250158 59.354497,40.26296 59.346693,40.242702 59.342184,40.252141 59.332838,40.225744 59.336649,40.246397 59.325743,40.228672 59.316877,40.247251 59.311451,40.224826 59.310067,40.240377 59.299427,40.21765 59.300999,40.218215 59.278978,40.240547 59.266124,40.181195 59.256487,40.251511 59.213126,40.243574 59.204086,40.265573 59.213458,40.31158 59.19275,40.29853 59.186994,40.31338 59.169114,40.302155 59.15758,40.320565 59.15105,40.307792 59.141563,40.278849 59.152818,40.274394 59.132783,40.314184 59.123407,40.280647 59.101449,40.226748 59.096124,40.224546 59.077343,40.197595 59.066177,40.21457 59.039474,40.020498 59.016182,39.97751 59.031356,39.986346 59.045589,39.954664 59.067231,39.591774 59.041542,39.263641 59.061524,39.210222 59.076502,39.203899 59.063475,39.174891 59.062283,39.178316 59.072796,39.159241 59.060182,38.800039 59.068355,38.515933 59.121961))","code":"vologda","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"78","name":"Вологда","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.636447 51.797968,39.607537 51.754585,39.622517 51.734659,39.606708 51.714575,39.610185 51.660125,39.58174 51.613567,39.610219 51.594727,39.587116 51.548658,39.595572 51.472616,39.432197 51.463614,39.367228 51.482856,39.282321 51.47193,39.239086 51.494705,39.043242 51.47568,39.036446 51.460721,38.985148 51.451112,38.95836 51.467983,38.975484 51.587634,38.951825 51.601623,38.981717 51.616267,39.01502 51.668308,39.004525 51.686329,38.963301 51.685541,38.949909 51.702812,38.961571 51.744377,38.993182 51.762764,38.986398 51.78014,39.03206 51.824939,38.998914 51.869945,39.080845 51.918867,39.110392 51.906079,39.171912 51.925341,39.17323 51.913889,39.208998 51.916168,39.213598 51.938079,39.277114 51.947584,39.360584 51.926612,39.352964 51.907998,39.5571 51.903533,39.654444 51.882491,39.686652 51.855648,39.66049 51.849479,39.636447 51.797968))","code":"voronezh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"31","name":"Воронеж","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.577119 43.322029,45.569157 43.338831,45.433189 43.386976,45.536872 43.389929,45.543081 43.405992,45.629672 43.419276,45.788784 43.395464,45.792415 43.376378,45.910888 43.3694,45.941572 43.352295,45.99123 43.378517,46.009982 43.422896,46.048764 43.452756,46.177622 43.450007,46.233921 43.420396,46.266297 43.442051,46.309888 43.433662,46.313981 43.466559,46.333912 43.458682,46.335194 43.400712,46.369918 43.341747,46.409527 43.324279,46.424985 43.294635,46.392708 43.186772,46.300198 43.174001,46.301016 43.143115,46.207397 43.13973,46.208392 43.088745,46.177689 43.08407,46.17819 43.065086,46.158127 43.052675,46.132947 43.050947,46.134143 43.068942,46.106337 43.093019,46.062857 43.10399,46.071517 43.063537,46.002833 43.073933,46.002547 43.03333,45.941575 43.023107,45.874379 42.977407,45.827314 43.00629,45.823516 42.993303,45.757554 42.989992,45.715126 43.022704,45.725559 43.082159,45.779478 43.16482,45.737936 43.163041,45.742157 43.178823,45.699717 43.199359,45.605135 43.215637,45.574259 43.247789,45.591963 43.30267,45.577119 43.322029))","code":"grozny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"115","name":"Грозный","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((48.346708 42.031048,48.37332 41.961938,48.303196 41.947685,48.282269 41.926195,48.26107 41.934388,48.222667 42.044229,48.148408 42.125359,48.156477 42.137878,48.204371 42.123042,48.243518 42.142903,48.296653 42.113955,48.346708 42.031048))","code":"derbent","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"123","name":"Дербент","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.632743 54.297011,49.623729 54.247956,49.716905 54.230516,49.667931 54.210197,49.655248 54.176591,49.609521 54.194435,49.496141 54.161071,49.288109 54.138944,49.238025 54.180657,49.171741 54.162852,49.001212 54.192089,49.007885 54.208045,48.976294 54.215558,48.976672 54.24835,48.942332 54.283077,48.938859 54.327409,48.911705 54.332877,48.930143 54.378176,48.953981 54.3627,49.223432 54.334876,49.341397 54.354755,49.531337 54.328455,49.632743 54.297011))","code":"dimitrovgrad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"124","name":"Димитровград","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.759612 48.586275,34.736228 48.631322,34.815791 48.680499,34.844227 48.665649,34.867387 48.680492,34.895435 48.662045,35.045173 48.689446,35.071796 48.661897,35.169567 48.648367,35.223556 48.694563,35.259655 48.677302,35.334139 48.680447,35.387332 48.665332,35.362011 48.621528,35.375749 48.60847,35.27671 48.531025,35.270174 48.501914,35.304892 48.412197,35.294232 48.397961,35.169144 48.347736,35.062569 48.346052,35.001881 48.297516,34.981502 48.309395,34.962903 48.355925,34.932853 48.370919,34.897326 48.377422,34.779704 48.345199,34.751465 48.364636,34.739059 48.383722,34.760305 48.427639,34.709615 48.46969,34.70723 48.488172,34.761707 48.520954,34.776767 48.55535,34.759612 48.586275))","code":"dnepropetrovsk","country_code":"ua","domain":"ua","flags":{"2gis_reviews":true,"flamp":false,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"105","name":"Днепр","time_zone":{"name":"Europe/Kiev","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((59.714357 57.010251,59.843218 57.01357,59.858607 57.032897,59.904726 57.03104,59.923061 57.050275,59.965298 57.054922,60.047762 57.045734,60.038449 57.016691,60.267319 56.995452,60.271682 57.013143,60.419812 57.069198,60.505544 57.043206,60.549708 57.055081,60.70108 57.03633,60.708262 57.058072,60.956449 57.021245,60.940021 56.971993,60.987937 56.928045,60.923753 56.789944,60.976652 56.751103,61.013608 56.744555,60.980369 56.72748,60.977227 56.693708,60.924551 56.702746,60.91685 56.678767,60.963803 56.613703,60.922024 56.602385,60.569054 56.588469,60.2624 56.607099,60.255886 56.591301,60.051382 56.601268,60.043108 56.579619,59.770501 56.602052,59.744221 56.627375,59.74666 56.694076,59.700893 56.827711,59.699866 56.855848,59.726605 56.870853,59.714357 57.010251))","code":"ekaterinburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"9","name":"Екатеринбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.464331 52.588624,38.425164 52.634715,38.498277 52.665741,38.584921 52.654962,38.61107 52.641374,38.624907 52.609917,38.612751 52.58612,38.552223 52.575046,38.50826 52.584209,38.466957 52.571241,38.464331 52.588624))","code":"elets","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"126","name":"Елец","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.197218 56.988588,41.188512 56.952433,41.209276 56.910049,41.142312 56.875722,40.950307 56.862373,40.826517 56.883451,40.832547 56.923862,40.787609 57.009888,40.794165 57.055793,40.834003 57.092259,41.203988 57.090369,41.223977 57.050149,41.197218 56.988588))","code":"ivanovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"65","name":"Иваново","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((52.95169 57.057889,53.495625 57.04823,53.550964 56.995238,53.679549 56.97602,53.710571 56.952482,53.757688 56.946247,53.770523 56.914248,53.729858 56.900484,53.766593 56.879291,53.751346 56.865929,53.793498 56.866158,53.790847 56.836664,53.812192 56.823012,53.756184 56.785803,53.769296 56.690065,53.812523 56.597041,53.804306 56.520944,53.697942 56.519048,53.616029 56.577276,53.379702 56.597815,53.304241 56.670729,52.93186 56.675205,52.939246 56.818944,52.922659 56.824009,52.943466 56.90041,52.95169 57.057889))","code":"izhevsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"41","name":"Ижевск","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((103.618853 52.641505,103.558668 52.756303,103.558686 52.82878,103.732417 52.82878,103.733328 52.754448,103.754112 52.726338,103.806039 52.685174,103.854878 52.68341,103.928989 52.644714,104.97019 52.64955,104.970807 51.718225,103.975229 51.71376,103.657739 51.697291,103.635022 51.734936,103.646101 51.753829,103.625789 52.419895,103.576145 52.430001,103.568526 52.448971,103.624012 52.476944,103.618853 52.641505))","code":"irkutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"11","name":"Иркутск","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.410092 56.087254,69.355807 56.089424,69.351066 56.100919,69.439472 56.13218,69.516173 56.137615,69.585121 56.121264,69.580699 56.096063,69.525227 56.08951,69.530126 56.066142,69.513621 56.05274,69.410092 56.087254))","code":"ishim","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"205","name":"Ишим","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.588902 56.761482,48.153297 56.748478,48.147576 56.680101,48.161312 56.671347,48.145753 56.658248,48.133249 56.507529,47.572432 56.520416,47.588902 56.761482))","code":"yoshkarola","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"70","name":"Йошкар-Ола","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.578142 44.002138,42.61262 44.127676,42.580833 44.178897,42.578513 44.269256,42.844476 44.304247,42.898396 44.287205,43.109725 44.285919,43.30466 44.306366,43.370345 44.261905,43.494471 44.253583,43.551152 44.211293,43.50578 44.139313,43.558606 44.083451,43.505289 44.031903,43.547468 43.948391,43.608438 43.924491,43.608506 43.901408,43.596063 43.901416,43.589321 43.846011,43.408126 43.84147,43.320009 43.801639,43.305784 43.816049,43.109967 43.767679,42.940469 43.810721,42.895215 43.799429,42.733643 43.817514,42.68112 43.807332,42.647469 43.825702,42.62712 43.86502,42.637268 43.879558,42.586434 43.920709,42.578142 44.002138))","code":"minvody","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"89","name":"Кавказские Минеральные Воды","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((48.293219 55.785858,48.300915 55.83784,48.210824 55.87347,48.264539 55.975911,48.333619 55.987526,48.465319 55.962675,48.549971 55.968903,48.585898 55.99431,48.863615 56.001223,48.935786 56.022691,48.980327 55.999077,49.132549 56.014912,49.172108 55.997201,49.23801 55.998644,49.268193 56.018944,49.425019 55.99398,49.532486 56.012359,49.576513 55.960059,49.572622 55.90025,49.603065 55.871306,49.564515 55.850699,49.569746 55.828722,49.549902 55.803099,49.576929 55.762639,49.553998 55.746684,49.548006 55.711488,49.587559 55.691345,49.549204 55.677128,49.533053 55.652126,49.535477 55.587187,48.477911 55.569986,48.446543 55.546812,48.335021 55.542882,48.302773 55.562068,48.299046 55.576462,48.332055 55.606612,48.289505 55.669048,48.312089 55.675824,48.310374 55.700797,48.265838 55.766996,48.293219 55.785858))","code":"kazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"21","name":"Казань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((19.833135 54.586099,19.539731 54.713885,19.592596 54.772306,19.580491 54.890235,19.602075 54.967186,19.681958 55.065929,19.760019 55.116599,19.921503 55.158093,20.201823 55.16015,20.401084 55.18063,20.653783 55.384,20.953702 55.280833,21.137338 55.253862,21.136177 54.889236,21.196062 54.84523,21.163697 54.806789,21.1801 54.783729,21.169734 54.745675,21.143762 54.746284,21.121719 54.718137,21.179906 54.65098,21.15228 54.629143,21.173176 54.569384,21.151091 54.554846,20.822897 54.548373,20.766945 54.528812,20.516593 54.505253,20.495685 54.489603,20.400609 54.518031,20.279696 54.524275,20.205102 54.496552,20.090973 54.539175,20.018733 54.522701,19.833135 54.586099))","code":"kaliningrad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"40","name":"Калининград","time_zone":{"name":"Europe/Kaliningrad","offset":120},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.894818 54.755461,36.233835 54.780396,36.305069 54.765277,36.455305 54.768523,36.469927 54.533953,36.484893 54.525984,36.470977 54.516984,36.482233 54.33388,36.210971 54.327911,36.181685 54.299591,36.116858 54.321124,35.927655 54.321024,35.919922 54.424265,35.908394 54.430411,35.909715 54.559813,35.894602 54.569411,35.905908 54.610036,35.901032 54.674135,35.886054 54.687341,35.899607 54.69282,35.894818 54.755461))","code":"kaluga","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"61","name":"Калуга","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((61.715751 56.571122,62.254705 56.57552,62.260467 56.279794,61.725677 56.275445,61.72515 56.29129,61.694373 56.30755,61.559193 56.348059,61.550908 56.439793,61.613644 56.493314,61.698796 56.477302,61.718449 56.491317,61.715751 56.571122))","code":"k_uralskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"109","name":"Каменск-Уральский","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.305955 50.108969,45.334659 50.135989,45.379769 50.121318,45.416263 50.147737,45.50263 50.114011,45.392887 49.993251,45.312501 50.029989,45.287717 50.075894,45.305955 50.108969))","code":"kamyshin","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"127","name":"Камышин","time_zone":{"name":"Europe/Volgograd","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.86687 49.97048,72.864145 50.031985,72.830379 50.071579,72.835457 50.132364,72.846029 50.159294,72.930852 50.192972,73.145574 50.170885,73.166584 50.157115,73.353485 50.153223,73.413468 50.005306,73.38921 49.686854,73.2999 49.65147,73.198415 49.637712,72.861947 49.688026,72.877067 49.738372,72.86687 49.97048))","code":"karaganda","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"84","name":"Караганда","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.326511 55.27068,86.327501 55.212118,85.914901 55.209146,85.909911 55.391534,85.878124 55.455955,85.975237 55.53017,86.147776 55.546002,86.177738 55.53357,86.322012 55.534428,86.326511 55.27068))","code":"kemerovo","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"5","name":"Кемерово","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.036766 58.786454,49.936128 58.797004,49.939573 58.684007,49.959251 58.673889,49.93995 58.668113,49.941856 58.608637,49.954576 58.598196,49.934361 58.587878,49.947791 58.410879,49.279365 58.403646,49.046044 58.381452,49.013389 58.401974,49.056584 58.431236,49.044913 58.641473,49.024698 58.656477,49.042463 58.685214,49.036766 58.786454))","code":"kirov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"58","name":"Киров","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((30.22961 50.267519,30.223507 50.300093,30.25384 50.347728,30.182345 50.379717,30.215735 50.383491,30.2129 50.410805,30.233945 50.426908,30.189932 50.495419,30.184392 50.542952,30.159363 50.551394,30.195035 50.592759,30.17089 50.624591,30.231123 50.608696,30.237532 50.620663,30.533346 50.642951,30.863637 50.622122,30.879715 50.64059,30.966927 50.626768,31.024126 50.643575,31.035615 50.607792,31.060791 50.596683,31.037552 50.535067,31.050481 50.516185,31.009887 50.473547,31.033795 50.466554,31.022826 50.429117,31.037104 50.420592,30.981337 50.390454,31.028961 50.320665,31.008512 50.285742,31.021363 50.275282,30.936583 50.173499,30.827588 50.20094,30.707049 50.185771,30.693523 50.164134,30.580134 50.195841,30.535508 50.182902,30.491132 50.205966,30.426931 50.212479,30.387748 50.191182,30.395631 50.139307,30.382961 50.137256,30.28915 50.170345,30.292954 50.181097,30.217764 50.178859,30.234774 50.201299,30.207971 50.224888,30.225589 50.232737,30.22961 50.267519))","code":"kiev","country_code":"ua","domain":"ua","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"107","name":"Київ","time_zone":{"name":"Europe/Kiev","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.324341 56.41256,41.360712 56.411533,41.375763 56.391722,41.369469 56.371691,41.38204 56.364131,41.369496 56.355751,41.392262 56.297302,41.226105 56.321779,41.225754 56.349508,41.260902 56.352017,41.257121 56.375225,41.324341 56.41256))","code":"kovrov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"129","name":"Ковров","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.438523 62.183881,74.420135 62.270479,74.430153 62.278546,74.397794 62.298115,74.415774 62.30622,74.344315 62.334832,74.393193 62.369046,74.540709 62.360474,74.610183 62.388361,74.723418 62.39534,74.786843 62.423937,74.850658 62.409232,74.803643 62.249431,74.70658 62.252803,74.577864 62.209883,74.555755 62.197961,74.538665 62.159626,74.438523 62.183881))","code":"kogalym","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"207","name":"Когалым","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.004116 53.276659,68.997167 53.318062,69.167949 53.327877,69.161429 53.39313,69.274826 53.383133,69.277034 53.397231,69.315124 53.404166,69.327714 53.370948,69.426323 53.365164,69.615022 53.377566,69.762747 53.305991,69.867178 53.20418,70.039459 53.155209,70.24582 53.165043,70.368026 53.153623,70.404051 53.116561,70.478959 52.928993,70.201804 52.871445,70.179755 52.895084,70.141435 52.904612,69.911928 52.819776,69.682352 52.812507,69.557302 52.828986,69.320958 52.938954,69.146486 52.881871,69.012816 52.910955,69.147482 53.140112,69.27637 53.224041,69.012491 53.225447,69.004116 53.276659))","code":"kokshetau","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"201","name":"Кокшетау","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((136.753811 50.349972,136.732015 50.546639,136.73738 50.63626,136.77424 50.671445,136.80805 50.6719,136.854575 50.708454,137.019275 50.726093,137.047688 50.709087,137.256608 50.703973,137.300987 50.652509,137.309118 50.592302,137.281873 50.545506,137.254966 50.304488,137.178429 50.223625,137.11257 50.180152,137.020128 50.156,136.927338 50.192698,136.781474 50.184059,136.673594 50.228365,136.66226 50.244675,136.69045 50.321326,136.753811 50.349972))","code":"komsomolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"94","name":"Комсомольск-на-Амуре","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((63.570864 53.081786,63.541088 53.060798,63.459462 53.101271,63.510712 53.125499,63.455974 53.201547,63.485376 53.216818,63.484464 53.256371,63.624834 53.31686,63.646629 53.291543,63.746165 53.288387,63.629891 53.161294,63.673836 53.157604,63.570864 53.081786))","code":"kostanay","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"203","name":"Костанай","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.788473 57.681147,40.721084 57.692701,40.692564 57.764686,40.707715 57.874069,40.735404 57.932043,40.981818 57.9303,41.147257 57.918584,41.160962 57.905824,41.137488 57.675732,40.788473 57.681147))","code":"kostroma","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"34","name":"Кострома","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.648205 45.176459,38.711098 45.219943,38.64025 45.271538,38.739748 45.340829,38.781788 45.31473,38.809501 45.327281,38.918451 45.294308,39.028441 45.284592,39.133021 45.284649,39.126668 45.316536,39.18719 45.315047,39.203489 45.300914,39.195239 45.289067,39.229994 45.265847,39.342399 45.254044,39.341222 45.278697,39.375139 45.284872,39.375049 45.305136,39.42069 45.309048,39.420767 45.33267,39.438429 45.332534,39.438452 45.305691,39.476685 45.305822,39.515106 45.314946,39.514719 45.360149,39.590516 45.360254,39.58218 45.375156,39.61652 45.377122,39.616013 45.441469,39.782302 45.441817,39.884814 45.419673,39.884766 45.432944,39.974064 45.432962,39.972445 45.45423,40.033952 45.458633,40.053085 45.413529,40.05355 45.358697,40.066274 45.359836,40.061038 45.260974,40.084628 45.256029,40.120102 45.278532,40.121369 45.245675,40.087582 45.197403,40.125426 45.184296,40.091663 45.135792,40.103098 45.131839,40.090267 45.099343,40.075233 45.109694,40.067071 45.094767,40.040236 45.102505,39.968812 45.080594,39.932968 45.095803,39.893669 45.084306,39.900028 45.096349,39.8718 45.111831,39.811315 45.113393,39.801652 45.129778,39.779674 45.123251,39.763667 45.136796,39.748665 45.128406,39.679284 45.167582,39.512034 45.037447,39.471249 45.035691,39.477936 44.987874,39.494979 44.975921,39.519018 44.987239,39.504601 44.968403,39.575083 44.942018,39.598598 44.911517,39.642513 44.894467,39.636756 44.878842,39.652507 44.87109,39.56203 44.837481,39.559578 44.806959,39.528955 44.811802,39.525045 44.789938,39.552019 44.795464,39.577078 44.765319,39.607462 44.775225,39.601502 44.742373,39.538293 44.691646,39.527854 44.65156,39.471062 44.640018,39.44626 44.575409,39.400566 44.576687,39.399677 44.556433,39.348204 44.529861,39.434926 44.505319,39.429588 44.483089,39.393221 44.455096,39.318938 44.459505,39.270371 44.426891,39.139535 44.457873,39.087526 44.448877,39.023849 44.38142,39.016852 44.409412,38.988065 44.397481,38.919437 44.421173,38.978084 44.443491,38.917879 44.495954,38.835643 44.510765,38.82169 44.500486,38.801122 44.513945,38.648179 44.489009,38.621174 44.718423,38.637552 44.732517,38.654426 44.726165,38.661505 44.828782,38.628541 44.83052,38.632211 44.886243,38.571424 44.976362,38.57103 45.038671,38.558308 45.040626,38.558543 45.053779,38.583641 45.05373,38.593846 45.138214,38.648205 45.176459))","code":"krasnodar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"23","name":"Краснодар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((92.113779 56.321481,92.546479 56.312921,92.686641 56.325006,92.698244 56.291704,92.880347 56.302262,92.918469 56.291319,92.944001 56.307758,92.963621 56.302029,92.967659 56.283178,92.996031 56.282857,93.02555 56.286858,93.024781 56.301334,93.089399 56.288399,93.351495 56.315506,93.353739 56.342098,93.385382 56.363574,93.483792 56.38784,93.525359 56.374674,93.77863 56.398338,93.778276 56.380571,93.821835 56.380351,93.812101 56.372773,93.825779 56.354057,93.727457 56.346694,93.733019 56.312658,93.651538 56.2072,93.676809 56.082704,93.676166 55.971304,93.645915 55.960206,93.693796 55.933158,93.663013 55.903518,93.698591 55.864907,93.668272 55.853942,93.681915 55.826012,93.654649 55.815941,93.650075 55.798052,93.344177 55.79616,93.321039 55.768104,93.279456 55.75733,92.945976 55.703893,92.906977 55.71333,92.906321 55.728977,92.823133 55.719781,92.795316 55.731038,92.781834 55.71597,92.76803 55.762376,92.720126 55.706235,92.706141 55.730738,92.545351 55.70355,92.477531 55.726778,92.405115 55.714618,92.34148 55.750768,92.272349 55.750681,92.271845 55.76861,92.227358 55.785552,92.226932 55.808601,92.118327 55.809971,92.105462 55.889204,91.850422 55.921905,91.746327 55.980599,91.291593 56.116023,91.146534 56.138309,90.665944 56.126281,90.207837 56.179432,90.201484 56.209533,90.182071 56.213938,90.210508 56.261959,90.143113 56.33793,90.479371 56.361035,90.582924 56.405539,90.676753 56.418299,90.8965 56.387376,91.040676 56.345942,91.102184 56.350933,91.305577 56.280725,91.373457 56.331809,91.535323 56.305279,91.781009 56.295613,92.113779 56.321481))","code":"krasnoyarsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"7","name":"Красноярск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.632239 52.673496,55.647402 52.696432,55.705649 52.699064,55.752857 52.753508,55.765115 52.859657,55.839739 52.898032,55.966195 52.877797,55.94339 52.863599,55.863068 52.72594,55.809336 52.734984,55.766443 52.690968,55.716005 52.670173,55.632239 52.673496))","code":"kumertau","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"210","name":"Кумертау","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.113307 55.505372,65.3122 55.533618,65.467434 55.529287,65.583217 55.483367,65.594049 55.449838,65.66975 55.429862,65.617468 55.423847,65.574765 55.388161,65.627644 55.301062,65.58624 55.287247,65.576998 55.258639,65.546631 55.243932,65.340727 55.245305,65.185597 55.308037,65.132927 55.350148,65.151683 55.427834,65.119873 55.444896,65.131751 55.467184,65.113307 55.505372))","code":"kurgan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"10","name":"Курган","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.849262 51.606059,35.879043 51.638528,35.8626 51.657259,35.886388 51.672482,35.871927 51.686705,35.895263 51.728444,35.883312 51.751074,35.897331 51.765358,35.891286 51.788043,35.934091 51.831118,36.017808 51.855342,36.110698 51.829456,36.276347 51.856813,36.413323 51.838129,36.425002 51.820996,36.444293 51.714533,36.421006 51.691959,36.432607 51.674272,36.416084 51.660402,36.414402 51.596078,36.391361 51.577032,36.262953 51.554483,36.243018 51.569354,36.13865 51.563039,36.132669 51.548845,35.978087 51.54813,35.820868 51.567552,35.849262 51.606059))","code":"kursk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"73","name":"Курск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((94.270724 51.665494,94.315145 51.695673,94.324847 51.744437,94.34902 51.76571,94.433205 51.771844,94.463731 51.76166,94.473999 51.729721,94.541766 51.71555,94.72518 51.714792,94.735961 51.662461,94.446121 51.599531,94.434067 51.594795,94.430591 51.550679,94.319692 51.601377,94.270724 51.665494))","code":"kyzyl","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"130","name":"Кызыл","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.83133 56.417848,75.849032 56.460447,75.835948 56.479004,75.855155 56.496727,75.962049 56.507491,76.016979 56.569103,76.038233 56.61783,76.166647 56.618004,76.152728 56.638789,76.289127 56.696968,76.261009 56.818521,76.240549 56.826138,76.260543 56.884586,76.195032 56.943321,76.095015 57.235533,76.697895 57.215498,76.916861 57.160251,78.463438 57.16501,78.440323 57.113345,78.252691 56.891085,78.122337 56.878974,78.118677 56.778235,78.130267 56.773227,78.069011 56.742264,78.08469 56.735129,78.009249 56.729582,78.003673 56.759058,77.989307 56.759934,77.992549 56.79605,77.895217 56.806984,77.886653 56.77042,77.828486 56.759285,77.849893 56.704511,77.898144 56.701257,77.836752 56.651943,77.78349 56.651784,77.800055 56.626421,77.790699 56.566868,77.724373 56.52058,77.726159 56.565965,77.616663 56.5704,77.569647 56.552952,77.599297 56.51611,77.454045 56.468986,77.288048 56.383263,77.245756 56.40064,77.207303 56.3642,77.186045 56.36289,77.171071 56.35122,77.215019 56.259475,77.248342 56.261192,77.252352 56.246418,76.960854 56.217765,76.923424 56.250769,76.77721 56.237521,76.706766 56.275057,76.643522 56.282925,76.576631 56.257768,76.61042 56.24636,76.59326 56.232816,76.456567 56.222195,76.368308 56.28198,76.318385 56.270625,76.291706 56.226861,76.259947 56.227112,76.216552 56.233683,76.170564 56.281305,76.126709 56.268224,76.078777 56.292992,76.0984 56.299962,76.081243 56.325375,76.083815 56.386065,76.055935 56.416088,76.125137 56.41769,76.108008 56.446056,76.086603 56.441415,76.047237 56.464173,76.010281 56.44546,76.012132 56.459923,75.98261 56.465573,75.950472 56.438536,75.942409 56.448429,75.900561 56.434034,75.913224 56.427764,75.8999 56.41418,75.880391 56.420512,75.855621 56.401265,75.83133 56.417848))","code":"kyshtovka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":false,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"187","name":"Кыштовка","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.750103 54.768861,86.495701 54.774252,86.502903 54.184679,85.767947 54.179404,85.766991 54.211526,85.745419 54.22624,85.764502 54.294869,85.761107 54.407891,85.705274 54.437493,85.759129 54.473382,85.750103 54.768861))","code":"lenkuz","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"86","name":"Ленинск-Кузнецкий","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.379824 52.626781,39.37616 52.689433,39.437992 52.71159,39.492999 52.757372,39.569775 52.721367,39.602138 52.740383,39.679225 52.720608,39.755873 52.732008,39.865104 52.702656,39.878631 52.711235,39.903903 52.688304,39.838586 52.667735,39.875348 52.630581,39.799054 52.595293,39.869859 52.538809,39.850993 52.479662,39.807101 52.503142,39.546783 52.477641,39.387742 52.513898,39.376843 52.520679,39.41612 52.57348,39.392041 52.58361,39.395286 52.600255,39.36358 52.602605,39.379824 52.626781))","code":"lipetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"56","name":"Липецк","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((150.981148 59.477574,150.939542 59.434108,150.758137 59.418591,150.470178 59.487482,150.506553 59.514398,150.610509 59.542555,150.589885 59.663479,150.701035 59.719942,150.854744 59.743567,151.041303 59.714109,151.034671 59.674065,151.011971 59.658931,151.035755 59.575523,150.981148 59.477574))","code":"magadan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"158","name":"Магадан","time_zone":{"name":"Asia/Magadan","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((59.504226 53.910884,59.464288 53.229865,58.523119 53.245612,58.525287 53.306553,58.507627 53.308733,58.489263 53.338765,58.528757 53.403605,58.547823 53.927025,59.12927 53.927438,59.504226 53.910884))","code":"magnitogorsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"26","name":"Магнитогорск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.089402 44.753763,40.101092 44.757209,40.124716 44.715356,40.113022 44.712041,40.123781 44.692476,40.139033 44.695048,40.134765 44.672794,40.166019 44.622423,40.149476 44.578957,40.166096 44.565791,40.09583 44.557513,40.072631 44.574347,40.042474 44.559919,39.935305 44.615197,39.915045 44.608277,39.920423 44.626134,39.904357 44.641697,39.915984 44.651078,39.896584 44.661932,39.912612 44.676425,39.901178 44.706653,39.942788 44.736295,39.987368 44.717275,40.028921 44.746893,39.994287 44.784918,40.026405 44.793709,40.042246 44.764569,40.077824 44.774653,40.089402 44.753763))","code":"maikop","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"131","name":"Майкоп","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.200468 43.105297,47.206434 43.159023,47.25122 43.157566,47.369732 43.200312,47.446098 43.181238,47.667854 43.183177,47.892502 42.734118,47.626102 42.670573,47.553966 42.677473,47.533198 42.703034,47.452585 42.721253,47.229907 42.714954,47.22188 42.75158,47.161086 42.796062,46.950734 42.735095,46.763845 42.843271,46.634338 42.885493,46.648901 42.916593,46.735891 42.953757,46.757967 43.000438,46.722449 43.019986,46.76681 43.046117,46.789511 43.099039,46.77783 43.148056,46.787127 43.169173,46.823701 43.166458,46.829457 43.18766,46.879266 43.175464,46.966967 43.184592,47.143842 43.103686,47.200468 43.105297))","code":"makhachkala","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"113","name":"Махачкала","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((59.545758 55.280232,60.184965 55.273894,60.46938 55.240542,60.469595 55.204122,60.500618 55.181581,60.469789 55.133977,60.471651 54.972711,60.453588 54.936386,60.464407 54.921845,60.453185 54.904964,60.271228 54.841976,60.250821 54.794839,59.944492 54.895408,59.771438 54.866503,59.729146 54.886954,59.734627 54.900317,59.522002 54.90492,59.545758 55.280232))","code":"miass","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"87","name":"Миасс и Златоуст","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.843932 55.391978,36.784794 55.397859,36.777835 55.41889,36.815383 55.465206,36.8162 55.507692,36.752402 55.555974,36.766606 55.578763,36.801687 55.582252,36.79972 55.645047,36.773692 55.685786,36.789344 55.74412,36.764182 55.789763,36.789031 55.849394,36.774963 55.851828,36.788479 55.861756,36.771319 55.932067,36.812267 55.953735,36.778755 55.980113,36.768954 56.033447,36.738275 56.063624,36.78088 56.105518,36.764686 56.14976,36.867981 56.193348,36.940014 56.203627,36.970816 56.222263,36.958287 56.238762,36.993291 56.2415,37.011411 56.221677,37.1412 56.186516,37.350372 56.224372,37.459617 56.200237,37.553765 56.22045,37.787512 56.230706,37.859514 56.218694,38.144384 56.237691,38.284403 56.225313,38.514408 56.244101,38.527957 56.227682,38.756502 56.230105,38.953443 56.213203,39.079952 56.240858,39.1025 56.228962,39.116844 56.127081,39.090756 56.066463,39.142483 56.020898,39.107487 55.925753,39.130746 55.864247,39.102731 55.80784,39.056191 55.775004,39.034139 55.688025,39.046769 55.638546,39.145126 55.566943,39.074506 55.526778,39.079897 55.500779,39.118629 55.481078,39.093981 55.464646,39.110068 55.373845,39.144718 55.352206,39.084704 55.23022,39.091986 55.184523,39.1251 55.151805,39.089913 55.078944,39.06333 55.066245,39.07943 55.055834,39.055515 55.022353,39.004875 55.036595,38.950345 55.004012,38.888025 55.039996,38.599576 55.020946,38.466983 55.054381,38.086314 55.012933,38.008821 55.024609,37.999858 55.042258,37.94916 55.057919,37.864935 55.020766,37.680995 55.006601,37.663283 55.022916,37.619529 55.025243,37.544039 54.989247,37.420827 54.981554,37.415807 54.962128,37.316566 54.96838,36.773438 55.138651,36.8076 55.152578,36.812302 55.214944,36.787527 55.246629,36.803125 55.284317,36.915699 55.347485,36.843932 55.391978))","code":"moscow","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"32","name":"Москва","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((33.225325 69.064731,33.265186 69.064731,33.265186 69.027421,33.286743 68.9972,33.294137 68.761176,33.566892 68.660816,33.5178 68.538753,33.75677 68.511817,33.741198 68.388309,33.751091 68.341711,33.838172 68.344937,33.99075 68.220577,34.016668 68.173774,34.087206 68.110861,33.990565 68.061996,33.952018 68.022917,33.970512 67.924501,34.17425 67.898561,34.297463 67.90726,34.355219 67.89508,34.354257 67.828489,34.385445 67.778911,34.468613 67.731858,34.597987 67.691075,34.643639 67.587172,34.63382 67.546138,34.431674 67.485337,33.571687 67.444568,32.632767 67.545538,32.211875 67.677328,31.949716 67.689008,31.734705 67.720632,31.760746 67.833984,31.738646 67.934812,31.783979 67.971397,31.892181 67.996356,32.073269 68.159487,32.23191 68.509206,32.289074 68.570651,32.174659 68.65378,32.067711 68.708298,32.347924 68.778872,32.634009 68.817618,32.679829 68.856852,32.703928 68.859229,32.701158 69.064619,33.225325 69.064731))","code":"murmansk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true},"id":"96","name":"Мурманск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.075511 55.619342,42.068549 55.589226,42.105556 55.523023,42.022669 55.523826,42.016003 55.504829,41.982415 55.501001,41.949284 55.512605,41.944547 55.529745,41.967243 55.550761,41.952801 55.580551,41.992303 55.616841,42.026374 55.630186,42.075511 55.619342))","code":"murom","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"132","name":"Муром","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.723646 55.554874,51.646247 55.574375,51.662207 55.58784,51.65101 55.6276,51.687547 55.640433,51.750524 55.710224,51.706732 55.771285,51.674603 55.784503,51.655854 55.845784,51.789333 55.84846,51.805722 55.856219,51.796582 55.868951,51.914799 55.885486,52.095047 55.849758,52.174898 55.881161,52.234244 55.881702,52.293636 55.853347,52.311799 55.877797,52.33168 55.878953,52.464703 55.858961,52.527841 55.866224,52.622474 55.830049,52.60666 55.798331,52.612551 55.769244,52.591918 55.760726,52.605917 55.756947,52.598503 55.722374,52.632144 55.713565,52.609146 55.696526,52.605417 55.632693,52.618832 55.614353,52.582857 55.607379,52.576773 55.590283,52.510541 55.555623,52.413221 55.54469,52.295177 55.563714,52.171722 55.543903,52.117172 55.555648,51.996244 55.529149,51.935327 55.546367,51.888186 55.540568,51.874118 55.567662,51.723646 55.554874))","code":"nabchelny","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"29","name":"Набережные Челны","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.781815 43.187166,44.824282 43.189667,44.83776 43.173946,44.831593 43.14971,44.757225 43.159379,44.747979 43.189734,44.705508 43.226212,44.728521 43.280859,44.768018 43.277796,44.795221 43.248833,44.818011 43.246919,44.781815 43.187166))","code":"nazran","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"154","name":"Назрань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.478522 43.423768,43.518069 43.52891,43.560881 43.513483,43.677653 43.547885,43.747049 43.525597,43.732109 43.502325,43.682558 43.487309,43.691447 43.474771,43.665693 43.437481,43.597604 43.38447,43.478522 43.423768))","code":"nalchik","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"134","name":"Нальчик","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.022348 67.607263,52.888393 67.622759,52.935412 67.668792,53.120081 67.697897,53.162703 67.684555,53.158178 67.666698,53.173465 67.658365,53.159913 67.636462,53.022348 67.607263))","code":"naryanmar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"159","name":"Нарьян-Мар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((132.750811 42.90212,133.241339 42.910709,133.248191 42.668281,132.759571 42.659764,132.750811 42.90212))","code":"nahodka","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"82","name":"Находка","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.004171 44.635492,41.991175 44.580785,41.909319 44.583164,41.897376 44.611711,41.911555 44.62582,41.871447 44.658472,41.886618 44.671456,41.866398 44.698941,41.884867 44.717085,41.94802 44.699055,42.004171 44.635492))","code":"nevinnomyssk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"135","name":"Невинномысск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((54.28712 56.135492,54.377048 56.10069,54.366146 56.036602,54.206936 56.03527,54.181859 56.067069,54.185012 56.091371,54.233773 56.127646,54.260228 56.11908,54.28712 56.135492))","code":"neftekamsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"136","name":"Нефтекамск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.931826 61.190935,77.028582 61.178947,77.007817 60.862874,76.79989 60.811169,76.675993 60.819973,76.608242 60.866834,76.574744 60.87297,76.405904 60.85454,75.922257 60.863009,75.931826 61.190935))","code":"nizhnevartovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"12","name":"Нижневартовск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((43.698905 55.546439,43.70569 55.558721,43.681576 55.561972,43.67454 55.578248,43.593297 55.572642,43.590418 55.602468,43.510025 55.663714,43.534796 55.689363,43.539725 55.72664,43.620532 55.727312,43.632723 55.745959,43.602127 55.74409,43.570877 55.762944,43.570502 55.781537,43.533283 55.778601,43.538975 55.806361,43.525344 55.798613,43.483009 55.820534,43.438804 55.801096,43.435333 55.823104,43.474067 55.84075,43.439979 55.895645,43.449855 55.962492,43.400646 55.983169,43.403214 56.02306,43.350545 56.011747,43.334068 56.019705,43.348812 56.028625,43.30845 56.023735,43.318973 56.03415,43.266285 56.085781,43.285191 56.135121,43.229605 56.165666,43.27404 56.176864,43.268324 56.224575,43.333095 56.277604,43.331742 56.291613,43.262507 56.288856,43.232795 56.46447,43.478804 56.50302,43.556139 56.484948,43.578748 56.436087,43.674309 56.463834,43.651633 56.489502,43.673258 56.501015,43.662704 56.510861,43.74359 56.504769,43.746049 56.537651,43.760063 56.544098,43.898733 56.56825,43.918577 56.550293,43.902015 56.531725,43.929245 56.519835,44.117989 56.489175,44.302017 56.487725,44.257758 56.303471,44.285621 56.293472,44.326035 56.18255,44.263031 56.143551,44.287549 56.109782,44.336492 56.112459,44.324849 56.089192,44.337515 56.078338,44.110198 56.038875,44.119245 56.01916,44.093979 56.002272,44.121 55.997692,44.107902 55.988437,44.123674 55.967723,44.097652 55.9638,44.08311 55.922851,44.103838 55.916349,44.054165 55.890125,44.040117 55.859208,44.110739 55.824992,44.040112 55.80138,44.064329 55.787559,44.066411 55.737674,44.026988 55.659793,44.039148 55.654767,44.011864 55.646937,44.028688 55.631216,44.001 55.611813,43.996515 55.586966,44.026632 55.537536,44.008255 55.530253,44.001105 55.495508,43.966379 55.476111,44.016565 55.438413,44.003405 55.36925,43.913842 55.332731,43.86906 55.287421,43.837718 55.292673,43.802249 55.331555,43.74567 55.33908,43.735367 55.36641,43.687526 55.356322,43.682425 55.372337,43.722341 55.438373,43.727634 55.49936,43.660456 55.500093,43.698905 55.546439))","code":"n_novgorod","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"19","name":"Нижний Новгород","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((60.386228 58.025926,60.543553 58.1012,60.591976 58.084258,60.59383 58.065848,60.629422 58.071692,60.626558 58.034145,60.588851 58.030923,60.56379 57.970664,60.525869 57.975302,60.478097 57.921059,60.322368 57.884501,60.2264 57.751651,59.763185 57.762607,59.779216 57.972882,59.753076 57.975012,59.802461 58.102842,60.216094 58.067059,60.238445 58.084283,60.309211 58.076303,60.302152 58.057252,60.33775 58.05346,60.329853 58.033965,60.386228 58.025926))","code":"ntagil","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"45","name":"Нижний Тагил","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.517836 53.497554,86.514138 53.82036,86.500994 53.827564,86.513934 53.838037,86.512736 53.941118,86.480362 53.944854,86.458678 53.991061,86.492783 54.018733,86.46447 54.054813,86.4792 54.065258,86.618448 54.103252,86.651443 54.130632,87.463657 54.121473,87.456823 53.497654,87.274477 53.498212,87.265593 53.487551,87.067651 53.502008,86.517836 53.497554))","code":"novokuznetsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"6","name":"Новокузнецк","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.611788 44.334654,38.50188 44.149785,38.424852 44.176741,38.29588 44.189945,38.06936 44.261427,37.909643 44.39079,37.826166 44.417904,37.75347 44.470943,37.508447 44.490233,37.333602 44.54604,37.216533 44.607242,37.148688 44.663571,37.114741 44.747825,37.062663 44.794421,37.035232 44.845064,36.84376 44.913379,36.952521 45.139209,36.955897 45.231096,37.270595 45.252601,37.323008 45.221241,37.370325 45.225698,37.418648 45.190935,37.469267 45.200845,37.483318 45.221778,37.632022 45.195207,37.665645 45.213873,37.777513 45.211867,37.850508 45.240846,37.862296 45.226127,37.969276 45.232012,38.140004 45.188567,38.395601 45.212132,38.450284 45.20257,38.499801 45.235955,38.581237 45.224853,38.648205 45.176459,38.593846 45.138214,38.583641 45.05373,38.558543 45.053779,38.558308 45.040626,38.57103 45.038671,38.571424 44.976362,38.632211 44.886243,38.628541 44.83052,38.661505 44.828782,38.654426 44.726165,38.637552 44.732517,38.621174 44.718423,38.648179 44.489009,38.670827 44.489693,38.665686 44.474828,38.688965 44.46535,38.630156 44.366958,38.608527 44.361301,38.611788 44.334654))","code":"novorossiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"74","name":"Новороссийск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((85.088133 54.816411,85.002688 54.800048,85.013252 54.779662,84.964301 54.781279,84.89515 54.728577,84.980047 54.704903,85.004084 54.6799,84.986639 54.667145,85.011185 54.637544,84.934464 54.60996,85.115898 54.438163,84.824313 54.325904,84.803815 54.352028,84.694421 54.290784,84.65606 54.28607,84.575667 54.235287,84.577444 54.205114,84.536029 54.158157,84.437398 54.141003,84.423005 54.147726,84.429822 54.161854,84.397627 54.178217,84.357598 54.160274,84.282223 54.158341,84.275305 54.178281,84.223933 54.192175,83.877706 54.08136,83.857861 54.087293,83.884281 54.12064,83.830747 54.12978,83.722303 54.101173,83.553128 54.109112,83.531248 54.078262,83.474428 54.062407,83.48778 53.979297,83.439161 53.973706,83.448509 53.947246,83.349582 53.933688,83.292679 54.085893,83.274482 54.051634,83.220299 54.050249,83.196775 54.065401,83.165888 54.051188,83.049376 53.969325,83.025492 53.975652,83.021283 54.00262,82.994051 54.01605,82.76229 54.012318,82.693122 54.106213,82.693979 54.131095,82.645574 54.14543,82.634722 54.248572,82.664822 54.29484,82.68705 54.30104,82.661704 54.35505,82.61106 54.369053,82.547634 54.419858,82.470375 54.420101,82.370414 54.412567,82.371804 54.399905,82.127851 54.268898,82.118361 54.252095,82.134209 54.241847,82.083649 54.219871,82.059678 54.184372,82.068814 54.177768,82.027336 54.157662,82.00034 54.171321,81.941353 54.133285,81.823904 54.099327,81.805615 54.061834,81.756478 54.033153,81.751897 53.99627,81.661622 53.981295,81.587024 53.921394,81.542805 53.909614,81.568083 54.00842,81.613035 54.021479,81.493979 54.02924,81.482831 54.058427,81.442213 54.041825,81.342891 54.08114,81.248852 54.070884,81.216226 54.124181,81.211528 54.112355,81.137057 54.109871,81.087729 54.19626,80.98516 54.294763,80.95166 54.375446,81.015929 54.437403,81.069744 54.449125,81.206379 54.469828,81.232671 54.43442,81.349135 54.442051,81.553585 54.533401,81.510757 54.591568,81.533405 54.612019,81.619201 54.634727,81.648241 54.614816,81.697814 54.622579,81.666411 54.644833,81.719479 54.657871,81.535705 54.795751,81.525131 54.835634,81.576033 54.854323,81.569753 54.873304,81.486161 54.938744,81.457861 54.932468,81.40791 54.950068,81.360969 54.937569,81.361438 54.979388,81.414723 55.001194,81.428126 55.044341,81.472002 55.050177,81.474095 55.080272,81.397608 55.101903,81.459733 55.139028,81.446447 55.247257,81.477305 55.251991,81.330338 55.319242,81.467239 55.352554,81.500579 55.380705,82.154603 55.51402,82.046328 55.623863,81.735848 56.025943,81.553507 56.235201,81.873966 56.305406,82.3392 56.357462,82.499393 56.405493,82.56553 56.399756,82.69004 56.425818,82.774176 56.409006,82.818171 56.429882,82.796319 56.46359,82.80499 56.512522,82.862728 56.535243,82.946637 56.537902,83.02902 56.518057,83.095518 56.54937,83.285825 56.445179,83.254023 56.433978,83.273679 56.431915,83.247805 56.395426,83.143274 56.374558,83.170399 56.342775,83.163827 56.314939,83.114137 56.290972,83.131482 56.275494,83.064804 56.230587,83.108472 56.211577,83.156686 56.227959,83.211845 56.209412,83.213935 56.180724,83.169868 56.18774,83.154684 56.176784,83.183089 56.166603,83.178743 56.153147,83.12927 56.120556,83.182767 56.112253,83.22148 56.086762,83.274055 56.113913,83.301553 56.095779,83.233736 56.059526,83.245146 56.024221,83.230086 56.013203,83.340089 55.978252,83.313369 55.961143,83.403008 55.896203,83.37566 55.89601,83.392788 55.863976,83.385188 55.851263,83.318525 55.854541,83.211507 55.729573,83.314218 55.70373,83.31518 55.687675,83.338522 55.710005,83.445276 55.723903,83.444876 55.694989,83.417853 55.673155,83.428686 55.664132,83.501531 55.706658,83.585493 55.670769,83.599621 55.650771,83.590415 55.616456,83.631408 55.605505,83.597281 55.578084,83.643364 55.58456,83.74695 55.537542,83.793479 55.544837,83.835711 55.529631,83.909543 55.54795,83.926346 55.568309,83.972523 55.555768,83.939427 55.51155,83.964213 55.51613,84.042645 55.444071,84.000495 55.408305,84.150837 55.400365,84.139598 55.439327,84.161904 55.455684,84.213271 55.462875,84.284625 55.43016,84.330678 55.462837,84.456308 55.468194,84.51098 55.506032,84.541189 55.468097,84.595177 55.483997,84.660798 55.479568,84.725026 55.446609,84.620578 55.404334,84.652652 55.380482,84.754742 55.379815,84.818767 55.361752,84.858737 55.375536,84.916854 55.324764,84.915525 55.277327,84.85607 55.260773,84.815445 55.227775,84.917085 55.183553,84.927023 55.163725,84.903557 55.053879,84.837145 54.997021,84.887657 54.969707,84.887673 54.9523,84.971822 54.944968,85.038038 54.873817,85.07845 54.857497,85.046502 54.844635,85.088133 54.816411))","code":"novosibirsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"1","name":"Новосибирск","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.279946 47.428434,40.282366 47.396003,40.143212 47.344641,40.141957 47.32975,40.049015 47.326963,39.998114 47.354118,40.026464 47.37416,40.013292 47.39774,39.970354 47.400067,40.03631 47.428998,40.012236 47.457735,40.057056 47.486347,40.054334 47.511039,40.138377 47.487506,40.136878 47.453853,40.175715 47.42226,40.279946 47.428434))","code":"novocherkassk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"137","name":"Новочеркасск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.824717 47.738537,39.788042 47.749911,39.786221 47.765157,39.819184 47.76806,39.830504 47.862381,39.876304 47.863572,39.891586 47.889442,39.936437 47.879171,39.938209 47.853071,40.017472 47.832192,40.030386 47.810257,39.97941 47.806857,39.973289 47.75403,40.017849 47.739613,40.004332 47.702684,39.827083 47.724308,39.824717 47.738537))","code":"novoshakhtinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"138","name":"Новошахтинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((76.550608 66.176745,77.02186 66.185037,77.085372 66.076551,77.246806 66.036483,77.502758 66.038639,77.717867 66.101555,77.822187 66.070509,78.095049 66.132742,78.197085 66.137732,78.314914 66.113537,78.336981 66.071776,78.412791 66.007583,78.499318 65.98269,78.481427 65.958847,78.460859 65.962934,78.305241 65.861272,78.20881 65.777623,78.042981 65.718308,78.024399 65.691381,77.930064 65.689318,77.877699 65.659784,77.64937 65.641188,77.201953 65.800799,76.921259 65.790684,76.713723 65.823542,76.647881 65.84942,76.600136 65.89055,76.461521 65.914944,76.373292 66.091023,76.387134 66.109593,76.550608 66.176745))","code":"n_urengoy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"139","name":"Новый Уренгой","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((88.529535 69.242435,86.000942 69.246318,85.986318 69.559455,88.551918 69.555507,88.529535 69.242435))","code":"norilsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"76","name":"Норильск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((74.30478 63.879187,76.263372 63.875343,76.226155 63.018251,74.325265 63.021954,74.30478 63.879187))","code":"noyabrsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true},"id":"103","name":"Ноябрьск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((71.25763 50.949137,71.15911 51.015405,71.127413 51.259035,71.33122 51.306666,71.641526 51.331666,71.718671 51.378815,71.842987 51.217734,71.87991 51.02963,71.86563 50.971068,71.609524 50.928205,71.25763 50.949137))","code":"nur_sultan","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"68","name":"Нур-Султан","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((65.639774 62.289704,65.836829 62.290875,65.799189 62.263694,65.808049 62.239531,65.77183 62.218361,65.765344 62.197036,65.774669 62.175323,65.821512 62.161631,65.845589 62.136144,65.873049 62.136289,65.870532 62.045859,65.889685 62.046089,65.89304 61.970194,65.158167 62.002836,65.157159 62.061542,65.4281 62.196723,65.483196 62.285717,65.639774 62.289704))","code":"nyagan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"202","name":"Нягань","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.646351 55.086464,36.632509 55.057227,36.612321 55.051415,36.563754 55.067207,36.575797 55.076421,36.556412 55.088942,36.576812 55.098854,36.531879 55.100693,36.556018 55.139507,36.661994 55.141738,36.646351 55.086464))","code":"obninsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"140","name":"Обнинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((30.506989 46.430705,30.518192 46.431862,30.485573 46.594299,30.513522 46.664318,30.579165 46.664532,30.608994 46.647233,30.805363 46.655465,30.807606 46.643526,30.888062 46.643435,30.914609 46.522769,30.85932 46.479501,30.797545 46.358129,30.701159 46.261262,30.605848 46.256172,30.529617 46.297192,30.506989 46.430705))","code":"odessa","country_code":"ua","domain":"ua","flags":{"2gis_reviews":true,"flamp":false,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"14","name":"Одесса","time_zone":{"name":"Europe/Kiev","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.9275 54.78532,72.877229 54.78445,72.844079 55.404999,73.25143 55.411503,73.27756 55.430606,73.32946 55.412594,73.75247 55.41764,73.762279 55.10337,73.7772 55.094703,73.763533 55.06273,73.771665 54.796804,73.213126 54.789864,73.074267 54.775192,73.059208 54.787499,72.9275 54.78532))","code":"omsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"2","name":"Омск","time_zone":{"name":"Asia/Omsk","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.397659 51.620872,55.28373 51.637597,54.906781 51.643137,54.906756 51.728877,54.849285 51.718242,54.83241 51.765792,54.875718 51.813504,54.842325 51.851931,55.069006 51.965505,55.133556 51.92549,55.190471 51.924788,55.250638 51.947908,55.269167 51.92153,55.379206 51.921589,55.380686 51.890251,55.463369 51.890643,55.462422 51.862277,55.506478 51.820429,55.515763 51.763054,55.602497 51.740792,55.578399 51.705268,55.603926 51.693925,55.584852 51.664817,55.537511 51.664477,55.499267 51.610351,55.397659 51.620872))","code":"orenburg","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"48","name":"Оренбург","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((58.488695 51.315425,58.683778 51.321673,58.697439 51.338826,58.776011 51.329791,58.78373 51.286852,58.798574 51.279821,58.786295 51.273122,58.814319 51.25288,58.899106 51.230952,59.016141 51.233939,58.987539 51.148002,59.018013 51.142934,59.030411 51.124558,59.0638 51.125372,59.085204 51.104943,59.068243 51.088276,59.08644 51.075581,59.081675 51.044506,59.054369 51.048772,59.044033 51.01299,58.941536 51.012503,58.849571 51.043631,58.731824 51.03686,58.656259 51.058501,58.598708 51.037005,58.52222 51.084149,58.382833 51.073463,58.372624 51.113302,58.403007 51.11479,58.374864 51.171941,58.391928 51.176526,58.388383 51.191967,58.415445 51.1822,58.417958 51.200327,58.388948 51.238106,58.367131 51.241517,58.340683 51.291723,58.353263 51.295716,58.351853 51.337987,58.38256 51.337957,58.382577 51.317872,58.488695 51.315425))","code":"orsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"142","name":"Орск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.853124 52.882663,35.840989 52.911897,35.84926 52.994905,35.878061 53.038401,35.860952 53.047981,35.874297 53.056616,35.860656 53.072489,35.871515 53.088745,35.93747 53.082329,35.965898 53.100819,36.064945 53.105009,36.199071 53.086792,36.249337 53.100916,36.329336 53.080138,36.284661 53.059816,36.295392 53.040838,36.284711 53.027058,36.313628 53.019657,36.31769 52.992176,36.346317 52.983267,36.305475 52.952624,36.32892 52.932396,36.28261 52.885783,36.235773 52.876645,36.203546 52.846229,36.106135 52.835902,36.014244 52.859097,35.902308 52.84126,35.864119 52.857087,35.853124 52.882663))","code":"orel","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"71","name":"Орёл","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.880651 40.410746,72.824373 40.386391,72.716869 40.41987,72.700391 40.551882,72.71733 40.589844,72.760236 40.572754,72.74911 40.597372,72.762679 40.627708,72.791396 40.616625,72.843441 40.651018,72.875985 40.619755,72.893399 40.544166,72.880651 40.410746))","code":"osh","country_code":"kg","domain":"kg","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"171","name":"Ош","time_zone":{"name":"Asia/Bishkek","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.223834 52.214201,77.241662 52.014535,76.992875 51.991758,76.9173 51.989277,76.769674 52.020351,76.660819 52.166653,76.600238 52.180226,76.645111 52.229329,76.675924 52.439188,76.992228 52.479541,77.235345 52.446979,77.223834 52.214201))","code":"pavlodar","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"111","name":"Павлодар","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.104058 53.066054,44.963755 53.041572,44.794662 53.061626,44.776161 53.076518,44.770048 53.262088,44.810489 53.286551,44.832085 53.335556,44.977002 53.363303,45.02642 53.389323,45.054239 53.376283,45.061104 53.348888,45.35881 53.348717,45.357781 53.225766,45.391043 53.135605,45.340927 53.030362,45.300415 53.009999,45.155505 53.031889,45.104058 53.066054))","code":"penza","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"42","name":"Пенза","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((56.921347 59.020265,56.905943 59.002546,56.972596 58.803898,56.885783 58.649364,56.849216 58.539439,56.843605 58.463639,56.899714 58.459027,56.898912 58.430923,56.921007 58.426045,56.899566 58.37942,56.872117 58.368386,56.873707 58.348237,56.909328 58.336781,56.895896 58.307611,56.912771 58.295503,56.896229 58.300431,56.853229 58.270343,56.857187 58.168006,56.825286 58.162266,56.786944 58.052761,56.831451 58.041996,56.816486 58.03891,56.829434 58.018053,56.816349 58.01115,56.824115 57.977059,56.770845 57.981386,56.71997 57.962514,56.749126 57.96009,56.734893 57.949979,56.746497 57.929909,56.815844 57.899191,56.81149 57.874553,56.759037 57.870989,56.822721 57.848471,56.831583 57.830761,56.649625 57.770252,56.606307 57.780272,56.445855 57.745008,56.436767 57.738924,56.461364 57.718418,56.438413 57.713822,56.463189 57.701114,56.454315 57.685357,56.468739 57.658593,56.254311 57.681783,56.249596 57.664133,55.976853 57.68302,55.955104 57.673509,55.983188 57.723328,55.97954 57.755518,55.900356 57.761933,55.908485 57.791562,55.814272 57.782843,55.748424 57.755537,55.716144 57.780353,55.687488 57.780003,55.709884 57.799233,55.702676 57.807087,55.591751 57.823949,55.554895 57.814259,55.589075 57.888804,55.503048 57.902516,55.648536 58.003859,55.619639 58.01355,55.520852 57.993174,55.520067 58.01337,55.504631 58.013045,55.569992 58.050236,55.575935 58.067054,55.554071 58.096959,55.572171 58.120218,55.562953 58.133018,55.648806 58.144972,55.637379 58.15999,55.686498 58.175148,55.681709 58.212463,55.742136 58.205958,55.740747 58.243583,55.788805 58.267762,55.846184 58.287641,55.955649 58.277983,55.980887 58.306921,55.961852 58.316612,55.963489 58.333627,56.007718 58.34083,56.002223 58.323261,56.028648 58.316982,56.068234 58.36527,56.124484 58.364976,56.162678 58.409374,56.148442 58.412692,56.15577 58.430813,56.122181 58.431366,56.071865 58.462076,56.103019 58.501165,56.069958 58.58524,56.260193 58.779141,56.302683 58.883024,56.253783 58.95531,56.239793 59.0072,56.199364 59.01991,56.177032 59.046108,56.221751 59.150502,56.215606 59.220063,56.252426 59.25211,56.472407 59.33059,56.460479 59.357147,56.484969 59.366504,56.39135 59.396913,56.321278 59.389305,56.323657 59.408076,56.413663 59.451677,56.525174 59.578228,56.574141 59.59962,56.643024 59.602979,56.662338 59.592683,56.65927 59.569141,56.72323 59.556509,56.798945 59.56039,56.824834 59.616743,56.87807 59.609381,56.914826 59.622718,56.988254 59.561737,57.076139 59.520211,57.178887 59.512805,57.301958 59.426418,57.268844 59.379168,57.2326 59.378983,57.199205 59.297491,57.164119 59.292824,57.178037 59.284982,57.167344 59.274844,57.192223 59.275825,57.166065 59.265167,57.187326 59.259679,57.171776 59.25297,57.179179 59.244273,57.140821 59.2268,57.16359 59.219585,57.07673 59.192596,57.076428 59.175407,57.128875 59.155157,57.054208 59.148638,57.039587 59.130936,57.057589 59.11709,57.018078 59.098206,56.97406 59.10476,56.921347 59.020265))","code":"perm","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"16","name":"Пермь","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((34.102722 61.959477,34.70885 61.953295,34.694352 61.691472,34.093364 61.697587,34.102722 61.959477))","code":"petrozavodsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"80","name":"Петрозаводск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((158.93997 52.708399,158.207589 52.869935,158.098651 52.921805,158.103729 52.978899,158.122863 53.005263,158.070474 53.123971,158.038502 53.158854,158.036961 53.18785,158.110492 53.246335,158.115759 53.275807,158.172805 53.29123,158.185568 53.360891,158.767001 53.363873,158.934418 53.326234,159.031063 53.266487,159.282336 52.942785,159.099675 52.85838,158.93997 52.708399))","code":"p_kamchatskiy","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"95","name":"Петропавловск-Камчатский","time_zone":{"name":"Asia/Kamchatka","offset":720},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((28.236627 57.893868,28.487391 57.87357,28.506529 57.852656,28.489222 57.82986,28.475856 57.739093,28.383826 57.720002,28.314786 57.730288,28.165414 57.714437,28.066706 57.753157,27.879575 57.697647,27.844135 57.700623,27.81286 57.73521,27.718068 57.752111,27.662905 57.797518,27.618062 57.782609,27.541574 57.823176,27.70805 57.848448,27.740926 57.827721,27.795637 57.841216,27.800355 57.854737,27.8879 57.839632,27.916041 57.860544,27.912105 57.876503,28.167686 57.912474,28.236627 57.893868))","code":"pskov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"90","name":"Псков","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((86.741415 52.1575,86.740159 52.171359,86.801044 52.158722,86.805639 52.187755,86.723874 52.197203,86.767102 52.243,86.783393 52.293024,86.693579 52.294799,86.68961 52.341377,86.667052 52.342734,86.642405 52.402575,86.62298 52.406021,86.62298 52.423775,86.679427 52.43683,86.676711 52.466176,86.649409 52.494794,86.661859 52.498895,86.627938 52.52683,86.722129 52.508723,86.763347 52.524257,86.794917 52.514808,86.775138 52.595801,86.821192 52.608641,86.809816 52.648098,86.844945 52.6264,86.932994 52.635155,86.936726 52.654524,86.989466 52.658492,87.012755 52.642514,87.068836 52.657448,87.099071 52.619226,87.134484 52.616339,87.11888 52.598563,87.197136 52.57321,87.218457 52.58875,87.297162 52.59237,87.33368 52.572745,87.37119 52.573691,87.371806 52.498746,87.428271 52.49947,87.494308 52.474214,87.539995 52.483464,87.583791 52.46215,87.611621 52.47148,87.623351 52.464791,87.610656 52.456439,87.617976 52.438341,87.653327 52.422416,87.700823 52.464322,87.732916 52.462713,87.755305 52.484868,87.845122 52.491026,87.864908 52.518856,87.892618 52.525854,87.891369 52.539479,88.021112 52.511055,88.123465 52.462634,88.143614 52.428852,88.231529 52.400058,88.281036 52.414455,88.310877 52.436896,88.317271 52.464244,88.445685 52.432956,88.442629 52.40601,88.406032 52.378341,88.463945 52.341503,88.403297 52.311662,88.391393 52.292277,88.402091 52.276754,88.380374 52.273215,88.396944 52.239674,88.363573 52.169065,88.374518 52.154623,88.360185 52.146284,88.378254 52.12461,88.286261 52.111732,88.248387 52.07755,88.25247 52.0458,88.178285 52.065758,88.151791 52.095988,88.126426 52.068234,88.061536 52.044389,88.057627 52.016808,88.087596 52.000021,87.97684 51.952266,88.001771 51.941712,88.001424 51.916173,87.945307 51.885704,87.934536 51.848568,87.898573 51.822291,87.882589 51.782897,87.932712 51.784547,87.991173 51.751386,88.084121 51.758335,88.110094 51.740266,88.106794 51.70856,88.076043 51.674834,88.019145 51.664388,88.00125 51.632399,88.003943 51.58927,87.959032 51.576348,87.950085 51.55133,87.900397 51.551548,87.934449 51.526312,87.945742 51.475191,88.052328 51.466461,88.141106 51.428543,88.125209 51.394057,88.143278 51.386152,88.133288 51.374165,88.156395 51.348495,88.187319 51.359006,88.315101 51.344413,88.325265 51.32452,88.401447 51.308059,88.424641 51.286255,88.590383 51.323347,88.631385 51.385349,88.700879 51.39093,88.693842 51.440444,88.680552 51.44444,88.692452 51.480816,88.658053 51.52805,88.750393 51.545358,88.763075 51.561429,88.79735 51.549455,88.814539 51.520634,88.846101 51.516319,88.863883 51.467884,88.919894 51.46392,89.004949 51.398852,89.006801 51.373922,88.985834 51.361067,88.997689 51.321504,88.960126 51.248341,88.9765 51.239932,88.960719 51.228301,88.963313 51.206481,89.031326 51.186793,89.049849 51.159806,89.036513 51.144358,89.048664 51.119576,89.022288 51.102517,89.054147 51.08231,89.054221 51.047136,89.100972 51.037486,89.123199 51.007425,89.192472 50.982957,89.241964 50.921557,89.268044 50.915982,89.267748 50.880456,89.346949 50.881253,89.348579 50.859675,89.398663 50.850525,89.375918 50.826409,89.390217 50.809925,89.453415 50.79257,89.477939 50.745449,89.528394 50.724075,89.582776 50.645801,89.639825 50.642893,89.631972 50.617147,89.649457 50.576936,89.729103 50.568638,89.85135 50.524889,89.842163 50.499885,89.865649 50.472046,89.8189 50.411201,89.735772 50.409274,89.707322 50.384121,89.664721 50.38501,89.655164 50.369729,89.613229 50.374267,89.58989 50.428129,89.50291 50.459801,89.510615 50.449948,89.4915 50.44528,89.48135 50.399919,89.501577 50.385732,89.496835 50.363912,89.381479 50.338889,89.379479 50.314921,89.406595 50.314032,89.390296 50.28636,89.343768 50.264245,89.333026 50.21668,89.308428 50.207937,89.403485 50.177932,89.440603 50.203696,89.520175 50.191731,89.532474 50.147871,89.511507 50.11931,89.58241 50.106974,89.592042 50.084192,89.533956 50.065855,89.524696 50.03935,89.543959 50.01503,89.592932 50.01553,89.598711 49.984524,89.62479 49.970855,89.608713 49.963743,89.614715 49.939182,89.591721 49.912627,89.63088 49.899345,89.611741 49.86352,89.651037 49.82644,89.624463 49.806369,89.673452 49.783475,89.711881 49.790098,89.7192 49.7283,89.6074 49.686,89.461564 49.666217,89.427352 49.619381,89.405269 49.621127,89.3846 49.6062,89.391 49.5953,89.36 49.5844,89.2506 49.6423,89.193637 49.634683,89.182398 49.622898,89.199073 49.604776,89.191469 49.58602,89.2327 49.5537,89.2009 49.5228,88.9845 49.4637,88.9326 49.5168,88.9295 49.5429,88.90009 49.558961,88.869615 49.546741,88.879675 49.513767,88.8571 49.4918,88.8801 49.4781,88.8534 49.4667,88.8628 49.4595,88.8429 49.4416,88.8022 49.4604,88.6836 49.4622,88.5992 49.5009,88.4949 49.4719,88.445 49.4726,88.4059 49.4946,88.368004 49.483846,88.3312 49.4935,88.297742 49.470898,88.221784 49.47966,88.165591 49.445452,88.184379 49.415928,88.118763 49.390801,88.124131 49.372926,88.160451 49.362761,88.170112 49.293567,88.106706 49.256569,88.054756 49.258389,88.056412 49.241085,88.017979 49.226295,87.988438 49.18302,87.805862 49.168484,87.695023 49.175738,87.670519 49.15207,87.492854 49.138516,87.503232 49.09253,87.427347 49.071318,87.28579 49.115872,87.303812 49.172181,87.291593 49.201769,87.309671 49.233885,87.198325 49.252499,87.02935 49.253989,87.006045 49.298864,86.970987 49.305851,86.926469 49.348878,86.924715 49.369818,86.9492 49.379942,86.936266 49.400195,86.947328 49.409624,86.833377 49.452247,86.82972 49.48174,86.855415 49.49914,86.814847 49.532322,86.827174 49.545425,86.739513 49.571169,86.665905 49.560272,86.618249 49.570377,86.597577 49.609524,86.615549 49.628524,86.659159 49.643789,86.665733 49.665502,86.699725 49.684973,86.72419 49.676651,86.778924 49.696016,86.752998 49.742395,86.782843 49.793792,86.735862 49.787154,86.688375 49.810899,86.590212 49.80559,86.6105 49.768929,86.582292 49.724142,86.509239 49.690951,86.488451 49.65791,86.428612 49.629352,86.420003 49.60759,86.2716 49.5827,86.267004 49.546539,86.202038 49.466113,86.17391 49.478979,86.166345 49.503304,86.112922 49.524383,86.037199 49.521846,86.024507 49.503727,85.968991 49.487116,85.929409 49.535866,85.944281 49.561326,85.883737 49.566907,85.826225 49.544254,85.809912 49.565881,85.75689 49.57715,85.677689 49.550396,85.589914 49.614381,85.553288 49.594414,85.490205 49.598129,85.38844 49.634803,85.321261 49.590847,85.257519 49.588524,85.264671 49.619788,85.210125 49.627086,85.215526 49.71853,85.203369 49.745268,85.148748 49.76791,85.144565 49.796419,85.101607 49.824213,85.100427 49.852116,85.059699 49.885036,84.985489 49.906772,84.984927 49.949919,84.972947 49.954279,84.994726 49.970128,84.978046 49.976294,85.049258 50.010397,85.035365 50.018876,85.035543 50.052494,84.974827 50.066958,84.945831 50.09661,84.8507 50.0939,84.813908 50.120772,84.825375 50.142985,84.75802 50.136943,84.692012 50.188623,84.628187 50.210679,84.567522 50.196841,84.456801 50.247256,84.409847 50.209226,84.362523 50.205465,84.251587 50.290141,84.272029 50.320659,84.269559 50.353755,84.242026 50.376855,84.241988 50.408662,84.203975 50.468975,84.232571 50.483066,84.248707 50.515566,84.230577 50.540242,84.169136 50.551745,84.144961 50.605966,84.115294 50.609194,84.080418 50.639877,84.127972 50.659636,84.343851 50.686268,84.397739 50.710053,84.42595 50.682196,84.473729 50.687078,84.514354 50.721437,84.511298 50.765456,84.557563 50.779921,84.589885 50.823992,84.539808 50.847646,84.437357 50.859917,84.438271 50.908374,84.490696 50.948059,84.34091 50.980694,84.305924 51.003878,84.222168 50.987377,84.127497 51.014216,84.101388 51.042257,84.061625 51.032231,84.02079 51.044188,84.038283 51.057608,83.943117 51.069148,83.956379 51.11019,83.932919 51.138087,84.042042 51.15374,84.096635 51.143349,84.069691 51.110609,84.120656 51.071237,84.146973 51.104134,84.153865 51.182773,84.179634 51.192381,84.200886 51.227941,84.192322 51.247157,84.234305 51.255878,84.256471 51.282613,84.331794 51.290341,84.376937 51.267314,84.412915 51.271282,84.452913 51.287731,84.458891 51.317025,84.633715 51.34705,84.641286 51.374725,84.68306 51.391487,84.716156 51.426799,84.766555 51.417022,84.849529 51.442452,84.897987 51.437753,84.923129 51.465532,84.92057 51.482868,84.989627 51.513625,85.111038 51.524095,85.166854 51.486525,85.195571 51.485502,85.244031 51.499162,85.260818 51.528716,85.29912 51.530649,85.305882 51.555556,85.449976 51.566314,85.446007 51.601769,85.479896 51.623074,85.48206 51.69047,85.582319 51.697222,85.626286 51.747247,85.623264 51.782779,85.539096 51.838252,85.536318 51.859355,85.616988 51.871872,85.544145 51.942899,85.585383 51.992331,85.682498 52.024578,85.701278 52.096576,85.74295 52.113436,85.850951 52.105479,85.869512 52.130262,85.898144 52.119127,85.914404 52.147076,86.116311 52.165694,86.114619 52.151813,86.132003 52.149228,86.172874 52.173167,86.282628 52.190286,86.4337 52.165022,86.466748 52.142065,86.456421 52.12839,86.60878 52.104938,86.648831 52.105669,86.688594 52.140995,86.725961 52.139143,86.741415 52.1575))","code":"gornoaltaysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"27","name":"Республика Алтай","time_zone":{"name":"Asia/Barnaul","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.35785 47.239013,39.358001 47.261508,39.310916 47.264747,39.31884 47.283311,39.486713 47.328345,39.559365 47.376813,39.734563 47.385205,39.734689 47.417805,39.804088 47.425666,39.868718 47.455781,39.864309 47.46816,39.878046 47.471547,39.834574 47.516331,39.861573 47.526634,39.996426 47.5208,40.038389 47.479463,40.012236 47.457735,40.036528 47.436502,40.028784 47.420259,39.983399 47.415849,39.96051 47.363195,39.924723 47.358403,39.919436 47.053314,39.746241 47.04353,39.743526 47.06029,39.619994 47.050119,39.618758 47.062267,39.541011 47.061609,39.535676 47.040827,39.367812 47.036168,39.355318 47.048678,39.35785 47.239013))","code":"rostov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"24","name":"Ростов-на-Дону","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((81.297565 51.474847,81.250661 51.472574,81.238183 51.45736,81.168923 51.46669,81.176956 51.479149,81.128237 51.499905,81.131718 51.521494,81.215223 51.581969,81.242809 51.575603,81.326653 51.534967,81.297565 51.474847))","code":"rubtsovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"143","name":"Рубцовск","time_zone":{"name":"Asia/Krasnoyarsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.742087 58.109103,38.947676 58.112986,38.898472 58.066256,38.953373 58.04675,38.976142 58.022331,38.913496 57.99886,38.823836 58.006161,38.648513 58.104084,38.702778 58.122775,38.742087 58.109103))","code":"rybinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"144","name":"Рыбинск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.404406 54.733859,39.344055 54.776871,39.415177 54.839913,39.388799 54.854473,39.401008 54.870252,39.444898 54.883538,39.576876 54.908518,39.610584 54.901857,39.615095 54.881368,40.082101 54.878236,40.072595 54.486578,39.402002 54.490668,39.391534 54.582714,39.402966 54.588546,39.404406 54.733859))","code":"ryazan","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"44","name":"Рязань","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.673202 66.456385,66.45835 66.508525,66.479577 66.580807,66.524881 66.622681,66.581182 66.63831,66.752996 66.623089,66.708104 66.581039,66.728105 66.556098,66.783327 66.532325,66.822744 66.477071,66.673202 66.456385))","code":"salekhard","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"160","name":"Салехард","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.611911 53.434343,50.619539 53.39416,50.664011 53.362732,50.772367 53.333177,50.795636 53.284691,50.741778 53.204916,50.569355 53.164164,50.543375 53.056351,50.51171 53.05486,50.507699 53.037506,50.412611 53.01015,49.973323 53.005299,49.910829 53.01341,49.899516 53.033312,49.747249 53.03528,49.787691 53.052236,49.794395 53.092844,49.807912 53.096481,49.77879 53.208185,49.796888 53.215506,49.792086 53.25618,49.777904 53.256952,49.787115 53.322185,49.74678 53.316751,49.707458 53.33157,49.681209 53.442657,49.728745 53.443838,49.733939 53.534138,49.794308 53.574405,49.762931 53.605617,49.797112 53.630996,49.7745 53.644768,49.811818 53.695905,50.005342 53.741546,50.225728 53.761331,50.240908 53.787848,50.328294 53.771345,50.364095 53.787345,50.497233 53.712068,50.535737 53.662852,50.535066 53.640486,50.588739 53.573857,50.567375 53.566267,50.611911 53.434343))","code":"samara","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"18","name":"Самара","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((29.434359 59.946365,29.445579 59.959851,29.384119 60.174382,29.405012 60.224502,29.400164 60.252241,29.521252 60.258295,29.627703 60.278179,29.66498 60.299917,29.84095 60.308972,30.06164 60.281094,30.242995 60.303807,30.447249 60.290476,30.523715 60.320691,30.752071 60.301317,30.816189 60.315166,30.855095 60.301614,30.942787 60.325074,31.105005 60.16026,31.168335 60.018131,31.106791 59.898566,31.063075 59.885463,31.112742 59.796151,31.086122 59.724592,31.033585 59.698741,31.064892 59.563652,31.04545 59.524782,30.970836 59.485961,30.80349 59.478467,30.697059 59.506842,30.561983 59.47743,30.428788 59.490007,30.359155 59.480736,30.348887 59.463495,30.110774 59.492718,30.080227 59.491851,30.062839 59.468795,29.931194 59.489972,29.738708 59.469542,29.602223 59.489989,29.523615 59.476495,29.456031 59.535583,29.458275 59.633169,29.434451 59.70411,29.45926 59.780422,29.482875 59.793804,29.406808 59.808405,29.390717 59.828508,29.430398 59.891821,29.419245 59.945138,29.434359 59.946365))","code":"spb","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"38","name":"Санкт-Петербург","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.081871 54.301948,45.511721 54.300891,45.507836 53.984632,44.868027 53.985633,44.867159 54.263361,44.852386 54.305301,45.081871 54.301948))","code":"saransk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true},"id":"85","name":"Саранск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((45.856039 51.724488,45.992106 51.720064,46.06242 51.754989,46.09597 51.802026,46.136889 51.825832,46.181012 51.820402,46.208087 51.850335,46.357733 51.821791,46.430843 51.835331,46.409443 51.716977,46.433873 51.728667,46.486963 51.718232,46.493745 51.696684,46.540915 51.696023,46.588358 51.65045,46.525517 51.644371,46.496915 51.621779,46.531394 51.605031,46.510981 51.609141,46.51517 51.59486,46.418306 51.562717,46.334533 51.362232,46.364391 51.356598,46.309454 51.254999,46.280529 51.260371,46.253535 51.195964,45.636831 51.218825,45.629584 51.289772,45.675365 51.374963,45.57571 51.450277,45.542994 51.5536,45.559352 51.587834,45.534988 51.607904,45.560031 51.644779,45.527193 51.639659,45.502507 51.673286,45.531848 51.694726,45.520355 51.708246,45.581883 51.699862,45.63943 51.74748,45.71945 51.781457,45.77254 51.765501,45.81311 51.725493,45.856039 51.724488))","code":"saratov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"43","name":"Саратов","time_zone":{"name":"Europe/Saratov","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((77.288048 56.383263,77.454045 56.468986,77.599297 56.51611,77.569647 56.552952,77.616663 56.5704,77.726159 56.565965,77.724373 56.52058,77.790699 56.566868,77.800055 56.626421,77.78349 56.651784,77.836752 56.651943,77.898144 56.701257,77.849893 56.704511,77.828486 56.759285,77.886653 56.77042,77.895217 56.806984,77.992549 56.79605,77.989307 56.759934,78.003673 56.759058,78.009249 56.729582,78.08469 56.735129,78.069011 56.742264,78.130267 56.773227,78.118677 56.778235,78.122337 56.878974,78.252691 56.891085,78.4324 57.114533,79.198214 57.001034,79.588576 56.92316,80.263517 56.422445,80.543437 56.456212,80.363866 56.318184,80.239862 56.320537,79.96416 56.150933,79.675672 56.017025,79.639678 56.11954,79.447263 56.092997,79.412685 56.061602,79.383459 56.068905,79.358932 56.130272,79.243368 56.093084,79.225643 56.050962,79.127867 56.022805,79.106696 55.97037,79.128278 55.915258,78.98939 55.915343,78.964252 55.79673,78.912238 55.786908,78.877863 55.732001,78.793349 55.746961,78.82667 55.764642,78.806093 55.783544,78.7489 55.7886,78.734688 55.806132,78.63822 55.803788,78.648278 55.816984,78.63627 55.834332,78.485951 55.806512,78.490894 55.905403,78.431215 55.878071,78.361223 55.900973,78.330244 55.867139,78.323154 55.889076,78.191637 55.863793,78.038254 55.860068,78.024838 55.916901,78.280004 55.979905,78.203968 56.020003,78.21015 56.053664,78.188242 56.055808,78.180551 56.089483,78.244645 56.0916,78.23325 56.121973,78.18002 56.146129,78.213551 56.164202,78.1593 56.167551,78.15677 56.189451,77.910392 56.18577,77.893975 56.16669,77.765355 56.170548,77.71608 56.130474,77.613666 56.196344,77.634017 56.203744,77.615689 56.208297,77.634202 56.213942,77.62789 56.224887,77.687976 56.23219,77.673362 56.240157,77.704755 56.262341,77.691797 56.280907,77.712457 56.279146,77.68577 56.293854,77.685633 56.312682,77.575291 56.32744,77.417658 56.306844,77.366817 56.317073,77.348699 56.302888,77.305081 56.325029,77.288048 56.383263))","code":"severnoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":false,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"188","name":"Северное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.463615 56.261756,38.496675 56.24063,38.284403 56.225313,38.191135 56.237466,38.001366 56.228403,37.925174 56.23193,37.922708 56.247703,38.068216 56.387367,38.232856 56.373681,38.234444 56.355464,38.463615 56.261756))","code":"s_posad","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"146","name":"Сергиев Посад","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.520885 54.880488,37.512424 54.8648,37.418341 54.880951,37.352234 54.874361,37.346587 54.923465,37.316566 54.96838,37.415807 54.962128,37.420827 54.981554,37.544039 54.989247,37.560985 54.978506,37.536971 54.966343,37.520885 54.880488))","code":"serpuhov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"147","name":"Серпухов","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((32.015394 54.690209,31.835486 54.688614,31.7783 54.707531,31.759145 54.729714,31.758252 54.779403,31.779213 54.858475,31.799064 54.879794,31.835458 54.883678,31.999494 54.881113,32.100553 54.907209,32.168106 54.944012,32.211606 54.918212,32.270858 54.815571,32.247847 54.735598,32.167074 54.698384,32.015394 54.690209))","code":"smolensk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"63","name":"Смоленск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.383094 43.821667,40.365371 43.773998,40.389201 43.76582,40.370934 43.72688,40.452068 43.724357,40.464546 43.712482,40.44948 43.671334,40.460069 43.655847,40.552923 43.623576,40.604766 43.587745,40.653978 43.584486,40.661776 43.563048,40.564559 43.519058,40.50541 43.524875,40.477821 43.549126,40.259202 43.586214,40.103393 43.568154,40.095163 43.529315,40.010289 43.425017,40.009014 43.385546,39.88448 43.224431,39.849882 43.228041,39.713913 43.282428,39.641385 43.368903,39.517373 43.438142,39.471188 43.494287,39.398814 43.537163,39.334137 43.608194,39.12771 43.776747,38.852504 43.952338,38.797372 44.002146,38.691373 44.050731,38.623879 44.118782,38.50188 44.149785,38.612587 44.335728,38.608527 44.361301,38.630156 44.366958,38.638208 44.396334,38.678873 44.431986,38.688965 44.46535,38.665686 44.474828,38.670827 44.489693,38.801122 44.513945,38.937865 44.485387,38.978084 44.443491,38.919437 44.421173,38.988065 44.397481,39.016852 44.409412,39.029765 44.392764,39.017479 44.38142,39.063696 44.409298,39.05287 44.420898,39.083895 44.44668,39.139535 44.457873,39.417834 44.381504,39.490156 44.346222,39.482191 44.324272,39.503685 44.298895,39.585877 44.276664,39.634013 44.283478,39.673372 44.314531,39.733904 44.282985,39.793339 44.332707,39.895499 44.351638,39.974611 44.338574,40.067177 44.369326,40.077202 44.320229,40.104932 44.310694,40.193777 44.355403,40.189229 44.337124,40.204925 44.326856,40.284236 44.329373,40.336778 44.304877,40.384576 44.319191,40.384083 44.284023,40.418532 44.278134,40.359829 44.246745,40.406793 44.167246,40.405546 44.132848,40.432671 44.114017,40.413294 44.063314,40.480476 43.964506,40.409687 43.938768,40.402758 43.894816,40.420424 43.882593,40.383094 43.821667))","code":"sochi","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"30","name":"Сочи","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.71342 44.893581,41.685529 44.896281,41.667935 44.929958,41.661667 45.008331,41.692812 45.027643,41.698853 45.060774,41.669371 45.069375,41.670132 45.103091,41.657403 45.103223,41.65798 45.130207,41.677233 45.13,41.671025 45.193197,41.697373 45.19275,41.697868 45.248583,41.812934 45.256127,41.954393 45.233953,41.994568 45.261419,42.147241 45.270428,42.304986 45.202801,42.366514 45.133954,42.317058 45.003834,42.242955 44.960936,42.11413 44.931575,42.061039 44.894863,42.040056 44.90999,41.999899 44.895762,41.944234 44.913399,41.71342 44.893581))","code":"stavropol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"57","name":"Ставрополь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((37.988967 51.393172,38.033751 51.338068,38.014496 51.330424,38.029978 51.322342,38.065141 51.230624,37.99364 51.155762,37.975804 51.115372,37.89047 51.137642,37.867872 51.194118,37.752363 51.240665,37.711636 51.276762,37.748802 51.303268,37.718561 51.367014,37.830964 51.42328,37.971237 51.414969,37.988967 51.393172))","code":"staroskol","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true},"id":"60","name":"Старый Оскол","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((56.141291 53.395949,56.132481 53.322821,56.107835 53.306713,55.876997 53.303411,55.850201 53.317461,55.762754 53.429216,55.710701 53.440577,55.691776 53.492937,55.796363 53.556787,55.817194 53.688315,55.940534 53.745092,56.108566 53.731209,56.140225 53.685013,56.150362 53.610702,56.128378 53.523897,56.141291 53.395949))","code":"sterlitamak","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"54","name":"Стерлитамак","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((72.38176 61.388553,73.693324 61.407472,73.718338 61.430866,73.826706 61.418172,73.782279 61.384658,73.797164 60.996565,72.41568 60.977161,72.38176 61.388553))","code":"surgut","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"39","name":"Сургут","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((50.657504 61.527715,50.636068 61.539362,50.589385 61.519683,50.584943 61.502181,50.358049 61.524635,50.374515 61.558666,50.155553 61.579157,50.192685 61.663327,50.211824 61.66137,50.219814 61.67932,50.259702 61.675254,50.297554 61.796039,50.390698 61.787261,50.470677 61.976617,50.518438 62.005444,50.658374 61.998829,50.700115 61.965373,50.831057 61.968262,51.042965 61.943237,51.023169 61.898419,51.300937 61.871537,51.285704 61.836303,51.363189 61.812802,51.439821 61.82162,51.438722 61.778192,51.451565 61.776999,51.394151 61.675321,51.254831 61.689574,51.204445 61.576752,51.047363 61.592638,51.012532 61.514285,50.742016 61.546535,50.657504 61.527715))","code":"syktyvkar","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"72","name":"Сыктывкар","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.960129 47.28818,38.973252 47.204558,38.95631 47.187762,38.765481 47.21002,38.808288 47.238429,38.799428 47.250036,38.820496 47.271938,38.960129 47.28818))","code":"taganrog","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"116","name":"Таганрог","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((41.260005 52.567998,41.268479 52.731323,41.236387 52.735174,41.271138 52.78225,41.274267 52.841987,41.459271 52.838296,41.480049 52.862206,41.51864 52.846945,41.517378 52.833462,41.638962 52.800252,41.641853 52.769172,41.602466 52.733497,41.596914 52.674708,41.615396 52.638425,41.609795 52.616906,41.625776 52.610338,41.587211 52.551951,41.481204 52.574653,41.359109 52.55523,41.260005 52.567998))","code":"tambov","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"81","name":"Тамбов","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((35.607908 56.678784,35.570898 56.695545,35.538946 56.757706,35.588963 56.772938,35.591409 56.789031,35.571466 56.851008,35.537348 56.874905,35.532145 56.924343,35.508421 56.938997,35.556666 56.956783,35.570436 56.978595,35.664379 57.00865,35.73051 57.007665,35.808084 57.041392,35.898954 57.050067,35.97844 57.037342,36.015941 57.015087,36.337513 56.974103,36.352173 56.854836,36.323448 56.787361,36.361046 56.758043,36.270183 56.694838,36.239273 56.682469,35.607908 56.678784))","code":"tver","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true},"id":"47","name":"Тверь","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.027461 58.334051,68.202464 58.347584,68.330932 58.333173,68.627747 58.337205,68.630591 58.064257,68.610922 58.051367,68.515642 58.063872,68.03489 58.061137,68.027461 58.334051))","code":"tobolsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"97","name":"Тобольск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((49.757851 53.315548,49.787115 53.322185,49.777904 53.256952,49.792086 53.25618,49.796888 53.215506,49.77879 53.208185,49.807912 53.096481,49.794395 53.092844,49.787691 53.052236,49.664636 53.027741,49.576552 53.034333,49.572233 53.048521,49.544847 53.040739,49.543582 53.06297,49.510492 53.066913,49.456518 53.050985,49.452008 53.035115,49.41868 53.036828,49.417156 53.018136,49.366877 53.00935,49.341312 52.985902,49.198784 53.018644,49.194897 52.941977,49.182276 52.932441,49.108312 52.935222,49.107225 52.912333,49.025792 52.908694,48.986242 52.882038,48.929584 52.908165,48.946418 52.921663,48.892282 52.946993,48.850016 52.927677,48.73638 52.978646,48.715833 52.962543,48.666568 52.986212,48.634927 52.967427,48.576346 52.99159,48.487947 52.989752,48.519065 52.958914,48.499645 52.940519,48.449405 52.952114,48.439113 52.972607,48.359834 52.957324,48.353057 52.973451,48.371755 52.99315,48.325122 52.997345,48.342014 53.058921,48.159756 53.086096,48.212202 53.137432,48.107527 53.180833,48.111779 53.204457,48.218927 53.261041,48.246979 53.305485,48.275755 53.290227,48.385685 53.315284,48.472727 53.283413,48.536172 53.325795,48.611318 53.314063,48.637623 53.320761,48.640492 53.338086,48.705562 53.336534,48.731976 53.373765,48.769055 53.382194,48.758106 53.407056,48.849668 53.39149,48.872272 53.435382,48.830441 53.465481,48.909851 53.478603,48.894586 53.491142,48.90861 53.509192,48.933523 53.515975,48.941069 53.497287,48.98353 53.533523,48.949824 53.578564,48.939025 53.648958,48.994808 53.706596,48.998043 53.871958,49.07379 53.872534,49.084687 53.89076,49.078093 53.871636,49.211523 53.872496,49.249735 53.836495,49.300351 53.831284,49.370744 53.789309,49.4156 53.784704,49.410478 53.766899,49.476604 53.760069,49.481771 53.777859,49.56319 53.782712,49.647911 53.754543,49.640868 53.72903,49.815231 53.714027,49.804274 53.670863,49.7745 53.644768,49.797836 53.632407,49.762931 53.605617,49.794308 53.574405,49.733939 53.534138,49.728745 53.443838,49.681209 53.442657,49.707458 53.33157,49.757851 53.315548))","code":"togliatti","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"22","name":"Тольятти","time_zone":{"name":"Europe/Samara","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((84.783402 56.581901,84.991724 56.591998,84.974638 56.639988,85.004481 56.687753,85.045182 56.688676,85.070721 56.678106,85.073288 56.650464,85.096105 56.650621,85.097019 56.637889,85.206565 56.608536,85.279646 56.569455,85.342194 56.524661,85.372239 56.469756,85.402749 56.459643,85.375987 56.453381,85.389566 56.411841,85.248355 56.351724,85.170078 56.345417,85.137633 56.327633,84.831578 56.323503,84.680085 56.540089,84.760897 56.558353,84.783402 56.581901))","code":"tomsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"3","name":"Томск","time_zone":{"name":"Asia/Tomsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((38.399267 54.266118,38.470992 54.193999,38.508234 54.178173,38.515886 54.160246,38.501516 54.156541,38.534027 54.123972,38.600428 54.112699,38.569552 54.063692,38.592478 54.044262,38.572731 54.016646,38.551337 54.01423,38.550516 53.995377,38.638449 53.9623,38.568617 53.959038,38.457578 53.848801,38.401631 53.820618,38.220688 53.849514,38.198672 53.864001,38.200643 53.890444,38.147397 53.902982,38.12458 53.891291,38.069076 53.910786,38.051279 53.901962,38.027663 53.918465,37.919557 53.890565,37.899904 53.90477,37.464798 53.889914,37.429616 53.899539,37.418328 54.197775,37.368526 54.228625,37.38038 54.252292,37.415747 54.265208,37.425436 54.309681,37.53468 54.311057,37.552533 54.334955,37.677493 54.300075,37.744368 54.322819,37.915046 54.315078,37.962779 54.325534,37.98144 54.352026,38.159244 54.352882,38.194297 54.365283,38.205572 54.354426,38.289137 54.372007,38.298507 54.345095,38.340918 54.328254,38.343188 54.300073,38.399267 54.266118))","code":"tula","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"36","name":"Тула","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((66.665516 57.236788,66.690851 57.236046,66.695691 57.221026,66.673562 57.06223,66.712652 57.016171,66.674961 56.962332,66.657754 56.901559,66.621048 56.52188,66.655094 56.516231,66.618862 56.498976,66.609235 56.397678,65.560375 56.416201,65.461425 56.437632,65.307668 56.400165,65.196699 56.429248,65.170515 56.463611,65.216947 56.494441,65.243024 56.934976,65.203136 57.082456,65.184508 57.090626,65.199421 57.108857,65.184607 57.113573,65.198384 57.119297,65.193532 57.136906,65.170763 57.143838,65.18333 57.151991,65.169414 57.165587,65.199666 57.186041,65.169046 57.188989,65.182515 57.232831,65.217693 57.249693,65.203272 57.271272,65.124472 57.264667,65.065351 57.290124,65.106968 57.323991,65.262697 57.284443,65.345841 57.318081,65.414268 57.316686,65.412894 57.300163,65.762215 57.307211,65.809373 57.258866,66.665516 57.236788))","code":"tyumen","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"13","name":"Тюмень","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((107.698215 51.61448,107.656415 51.609405,107.624279 51.572851,107.548805 51.555526,107.541877 51.517282,107.567665 51.508801,107.469426 51.468505,107.452452 51.446251,107.375663 51.461414,107.335109 51.452981,107.312194 51.415791,107.227579 51.449089,107.197667 51.498784,107.176147 51.487953,107.164052 51.503259,107.074201 51.467997,106.983028 51.383154,106.923413 51.391313,106.866786 51.358268,106.79604 51.373625,106.76303 51.338582,106.740467 51.35286,106.678838 51.35375,106.670929 51.331613,106.569966 51.257375,106.498137 51.240369,106.232683 51.337765,106.248455 51.395382,106.220399 51.453036,106.241276 51.48265,106.226641 51.504262,106.192484 51.507823,106.288071 51.57077,106.30722 51.608868,106.310649 51.645341,106.283352 51.667014,106.28283 51.733313,106.305681 51.758435,106.218217 51.785023,106.204013 51.835589,105.872764 52.053418,106.172533 52.361056,106.999934 52.716939,108.012655 53.233717,108.297403 53.673511,108.373418 53.764052,108.929363 54.269942,109.543217 54.137962,109.571009 54.113442,109.576767 54.085589,109.623624 54.05345,109.783346 54.037236,109.79646 54.023096,109.820289 54.032949,110.109045 53.946227,110.190087 53.942366,110.228012 53.881763,110.033421 53.822867,110.026644 53.786567,109.95741 53.769449,109.79495 53.658651,109.827281 53.640473,109.82049 53.63228,109.774956 53.628465,109.772408 53.611417,109.728834 53.582666,109.676847 53.576952,109.681191 53.513946,109.693225 53.506872,109.665725 53.503162,109.672112 53.452787,109.586413 53.447626,109.606989 53.431008,109.586024 53.413111,109.606315 53.368601,109.208361 52.884073,109.140834 52.856747,109.056377 52.847811,108.921689 52.788249,108.905273 52.758485,108.857134 52.727341,108.866852 52.705676,108.836543 52.692437,108.837103 52.654528,108.806788 52.65392,108.750081 52.613573,108.756079 52.587244,108.72445 52.553625,108.743334 52.538009,108.735983 52.524572,108.709908 52.507941,108.614333 52.500895,108.59248 52.474767,108.520384 52.453709,108.455362 52.391449,108.417289 52.327266,108.384674 52.31775,108.396699 52.298447,108.366236 52.255853,108.316805 52.246193,108.328595 52.207626,108.223087 52.173129,108.113563 51.929275,108.179722 51.914889,108.165325 51.853771,108.117598 51.837772,108.044288 51.757771,108.053087 51.744034,108.016956 51.70757,108.041837 51.704255,108.037249 51.679814,107.956945 51.625796,107.979753 51.606006,107.95509 51.588001,107.929383 51.597187,107.92106 51.573883,107.82198 51.553036,107.786141 51.604749,107.698215 51.61448))","code":"ulanude","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"37","name":"Улан-Удэ","time_zone":{"name":"Asia/Irkutsk","offset":480},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((48.634539 54.121281,48.56085 54.0901,48.552474 54.05428,48.524714 54.061226,48.519761 54.077286,48.445814 54.090836,48.408869 54.074805,48.322982 54.099049,48.179784 54.107706,48.159518 54.09732,48.069958 54.124575,48.04981 54.173416,48.00799 54.217115,48.035851 54.233839,48.022491 54.271162,48.035469 54.305415,48.056294 54.310561,48.041922 54.337865,47.965906 54.379922,47.992768 54.38293,47.984027 54.401357,48.035637 54.40986,48.011365 54.436125,48.029376 54.461865,48.08464 54.477654,48.318008 54.451123,48.336596 54.476568,48.861951 54.469107,48.860767 54.430261,48.924566 54.399153,48.914048 54.377469,48.930143 54.378176,48.929059 54.361941,48.911705 54.332877,48.938859 54.327409,48.942332 54.283077,48.976672 54.24835,48.976294 54.215558,48.93621 54.182404,48.856589 54.159136,48.634539 54.121281))","code":"ulyanovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"55","name":"Ульяновск","time_zone":{"name":"Europe/Ulyanovsk","offset":240},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((51.568736 51.248864,51.580605 51.225437,51.56813 51.155685,51.241077 51.03227,51.217932 51.048987,51.272711 51.217896,51.258108 51.243037,51.265796 51.293382,51.323377 51.295239,51.353126 51.31411,51.446775 51.281324,51.535491 51.289132,51.568736 51.248864))","code":"uralsk","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"162","name":"Уральск","time_zone":{"name":"Asia/Oral","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((131.816747 43.70959,131.787156 43.708761,131.73639 43.752125,131.756949 43.851284,131.749195 43.962278,132.076996 43.975946,132.130901 43.964375,132.142052 43.718194,132.01259 43.703639,131.816747 43.70959))","code":"ussuriysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"83","name":"Уссурийск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((82.661138 49.798516,82.545707 49.841691,82.44862 49.846928,82.392522 49.92013,82.454 49.961702,82.43318 50.045936,82.450724 50.059192,82.715976 50.057306,82.806336 50.028657,82.796278 50.00252,82.911019 49.864261,82.904611 49.819293,82.95274 49.801722,82.980783 49.761077,82.834545 49.762443,82.661138 49.798516))","code":"ustkam","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"91","name":"Усть-Каменогорск","time_zone":{"name":"Asia/Qyzylorda","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((55.513299 54.50669,55.494061 54.522228,55.482358 54.499942,55.370533 54.502842,55.333781 54.478486,55.337286 54.466929,55.274856 54.490371,55.260739 54.468126,54.842509 54.456509,54.843068 54.473374,54.814564 54.483257,54.769627 54.445091,54.72315 54.443431,54.560293 54.483057,54.5318 54.466239,54.418596 54.494966,54.313238 54.485285,54.271603 54.443735,54.199599 54.436248,54.075626 54.458357,53.976709 54.41731,53.943558 54.374826,53.782489 54.397594,53.778182 54.378343,53.6907 54.386323,53.682825 54.407089,53.6494 54.40974,53.647372 54.396844,53.549588 54.40325,53.551157 54.422996,53.44346 54.416616,53.382596 54.452052,53.3771 54.502991,53.39054 54.504767,53.37469 54.540229,53.538948 54.687529,53.586984 54.678888,53.607935 54.696374,53.636725 54.686446,53.631588 54.66209,53.789475 54.637296,53.823796 54.605438,53.903618 54.607387,54.024752 54.643675,54.064318 54.60893,54.116066 54.608192,54.267083 54.620174,54.386915 54.667322,54.651514 54.672082,54.683258 54.687295,54.700007 54.717494,54.805092 54.724984,54.985053 54.786446,54.980276 54.803046,55.071891 54.802814,55.076182 54.82451,55.140601 54.829387,55.152037 54.79505,55.207401 54.802098,55.215732 54.787228,55.318581 54.78635,55.349396 54.816566,55.409092 54.807305,55.413453 54.832513,55.492898 54.819783,55.531936 54.879929,55.628156 54.866742,55.7174 55.045024,55.687956 55.06524,55.690124 55.083961,55.857773 55.122048,56.097268 55.058446,56.139163 54.955363,56.190417 54.951962,56.258965 54.975092,56.318201 54.969843,56.343234 54.922513,56.492011 54.850912,56.513835 54.781042,56.437825 54.744877,56.419164 54.698865,56.390362 54.677768,56.403507 54.630328,56.355509 54.617458,56.342237 54.597848,56.348497 54.57342,56.38673 54.581848,56.415958 54.559888,56.353748 54.527367,56.366215 54.501712,56.326085 54.49152,56.352179 54.466123,56.290272 54.435125,56.2344 54.458465,56.045708 54.41963,55.949653 54.46844,55.917946 54.44712,55.894078 54.474544,55.865215 54.467268,55.870203 54.476916,55.850475 54.4818,55.81172 54.462923,55.670207 54.520705,55.576685 54.523908,55.513299 54.50669))","code":"ufa","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"17","name":"Уфа","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((53.551092 63.592989,53.574443 63.644158,53.641697 63.680307,53.819455 63.687831,54.082849 63.642387,54.203436 63.597614,54.215629 63.566954,54.159605 63.533982,53.877096 63.524755,53.757877 63.493643,53.659685 63.50421,53.618081 63.539573,53.553547 63.556476,53.564484 63.583696,53.551092 63.592989))","code":"ukhta","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"204","name":"Ухта","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((135.258155 48.433811,135.257422 48.288578,135.064085 48.274463,134.874409 48.288797,134.873526 48.629594,135.259151 48.629372,135.275151 48.597403,135.268659 48.51501,135.229014 48.490393,135.250281 48.488475,135.233596 48.470107,135.258308 48.464082,135.258155 48.433811))","code":"khabarovsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"35","name":"Хабаровск","time_zone":{"name":"Asia/Vladivostok","offset":600},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((68.949135 61.067994,69.064458 61.116854,69.102442 61.116618,69.183856 61.081996,69.257216 61.115126,69.359066 61.080996,69.396555 61.036198,69.418585 61.034991,69.418699 61.009458,69.335942 60.960712,69.075245 60.916376,68.976026 60.950316,68.957839 61.015554,68.915346 61.051847,68.918141 61.070311,68.949135 61.067994))","code":"kh_mansiysk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":true,"road_network":true},"id":"150","name":"Ханты-Мансийск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((36.034468 50.060655,36.045996 50.115501,36.087143 50.14146,36.416935 50.127697,36.499253 50.101702,36.487564 50.080172,36.504004 50.071658,36.484201 50.060952,36.503267 50.051183,36.474218 50.04183,36.481798 49.972727,36.464678 49.942426,36.511907 49.918553,36.5113 49.883519,36.481252 49.879861,36.463851 49.838002,36.365981 49.847881,36.347059 49.833716,36.346506 49.80937,36.136868 49.852873,36.092277 49.83968,36.053934 49.849966,36.041616 49.873391,36.054222 49.88199,36.02314 49.919707,36.033015 49.932738,36.010819 49.947633,36.032366 49.979732,35.981617 49.992965,36.024417 50.011032,36.034468 50.060655))","code":"kharkov","country_code":"ua","domain":"ua","flags":{"2gis_reviews":true,"flamp":false,"metro":true,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"110","name":"Харьков","time_zone":{"name":"Europe/Kiev","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((46.648661 43.209742,46.602332 43.198957,46.562281 43.21131,46.538973 43.238001,46.542462 43.281203,46.617797 43.281587,46.648661 43.209742))","code":"khasavyurt","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"151","name":"Хасавюрт","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((47.003696 56.264089,47.157621 56.330593,47.604562 56.313312,47.577505 56.071351,47.599217 56.03641,47.584692 56.032973,47.57594 55.988608,47.5156 55.968684,47.423278 55.984072,47.366692 55.97116,47.307714 55.990549,47.198503 55.967518,47.167182 55.981611,46.993093 55.988177,46.96654 56.009043,46.986605 56.02278,46.984365 56.072908,46.997421 56.078488,46.939627 56.229502,47.003696 56.264089))","code":"cheboksary","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"53","name":"Чебоксары","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((61.252272 54.968614,61.203292 54.974499,61.154767 55.001658,61.045568 55.121512,61.100754 55.175448,61.084098 55.195727,61.149519 55.295912,61.284521 55.36403,61.360806 55.379536,61.385601 55.362557,61.470025 55.375552,61.600387 55.321009,61.69485 55.304482,61.756228 55.265544,61.745198 55.160898,61.779485 55.083582,61.76733 55.046807,61.746429 55.036978,61.757873 54.97934,61.70127 54.987808,61.599819 54.966064,61.54954 54.932824,61.570157 54.915237,61.501835 54.895912,61.469463 54.906971,61.470091 54.938297,61.403401 54.928846,61.368564 54.96636,61.252272 54.968614))","code":"chelyabinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"15","name":"Челябинск","time_zone":{"name":"Asia/Yekaterinburg","offset":300},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((42.063351 44.174307,42.032856 44.157802,42.004777 44.168195,42.005763 44.256884,42.046537 44.293932,42.057868 44.263238,42.094895 44.27978,42.095012 44.263651,42.123356 44.262439,42.101315 44.222423,42.100775 44.181605,42.063351 44.174307))","code":"cherkessk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"118","name":"Черкесск","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((75.686808 54.339198,75.691058 54.546033,75.804033 54.540152,75.827073 54.599356,75.851847 54.607591,75.824601 54.666402,75.802915 54.671206,75.808816 54.691725,75.749846 54.698077,75.742036 54.726761,75.831039 54.751395,75.83673 54.765373,76.116773 54.805004,76.113976 54.826611,76.204396 54.838058,76.187993 54.953681,76.280991 54.961576,76.264282 54.977541,76.304965 54.996075,76.338001 54.992109,76.335635 55.022439,76.440171 55.038288,76.452665 55.061816,76.544476 55.043883,76.546711 54.995993,76.821444 55.014068,76.824396 54.955724,76.881168 54.955805,76.897089 54.887204,77.248122 54.740518,77.24815 54.723542,77.104291 54.665849,77.114532 54.632769,77.151328 54.606349,76.982077 54.580964,76.993312 54.536018,76.941441 54.496476,76.909563 54.491753,76.928961 54.457768,76.795529 54.419024,76.729759 54.418029,76.674806 54.344999,76.645675 54.336778,76.598158 54.343092,76.475925 54.31824,76.25729 54.359271,76.229287 54.323222,76.186484 54.301553,76.227822 54.276096,76.201393 54.259799,75.688777 54.122625,75.686808 54.339198))","code":"chistoozernoe","country_code":"ru","domain":"ru","flags":{"2gis_reviews":false,"flamp":false,"metro":false,"public_transport":false,"road_network":false},"id":"193","name":"Чистоозёрное","time_zone":{"name":"Asia/Novosibirsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((113.069162 52.396705,113.152477 52.452545,113.371366 52.464993,113.470022 52.356606,113.534077 52.332884,113.516717 52.31346,113.536592 52.3132,113.527842 52.29535,113.560493 52.277937,113.551234 52.264949,113.666419 52.217868,113.764267 52.222663,113.798989 52.19943,113.815862 52.148641,113.785471 51.966389,113.676566 51.862738,113.451038 51.818171,113.370101 51.78102,113.348087 51.718262,113.272946 51.744414,113.219211 51.796579,113.144941 51.825077,113.064818 51.827423,112.930694 51.886475,112.505278 51.925249,112.39496 51.950602,112.334198 51.982953,112.33115 51.996715,112.361117 52.021256,112.322516 52.033757,112.323024 52.086064,112.343848 52.109777,112.332928 52.123188,112.359593 52.18084,112.436054 52.228411,112.511075 52.249215,112.505306 52.294373,112.546581 52.346365,112.610136 52.357394,112.653274 52.340795,112.680258 52.354375,112.735469 52.326659,112.804526 52.326126,112.881217 52.351024,112.922137 52.329699,112.981963 52.376365,113.008415 52.370063,113.069162 52.396705))","code":"chita","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"64","name":"Чита","time_zone":{"name":"Asia/Chita","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((40.196701 47.783662,40.282522 47.783729,40.387246 47.750448,40.348815 47.708697,40.325883 47.709878,40.318424 47.671348,40.243614 47.668837,40.203531 47.641568,40.186315 47.640497,40.132498 47.68707,40.073416 47.688098,40.087176 47.726971,40.080282 47.809139,40.139919 47.811535,40.15313 47.792018,40.196701 47.783662))","code":"shakhty","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"152","name":"Шахты","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((88.071027 52.880742,88.0044 52.768839,87.913372 52.715666,87.821154 52.726087,87.779438 52.751649,87.771905 52.838728,87.614726 52.916859,87.470702 52.897774,87.435344 52.912503,87.340253 53.00986,87.320082 53.062793,87.224531 53.144865,87.115495 53.210666,87.110063 53.280727,86.93067 53.471467,86.927436 53.498504,87.250459 53.498264,87.265593 53.487551,87.274477 53.498212,87.456823 53.497654,87.602184 53.410864,87.608344 53.365748,87.659453 53.306464,87.786968 53.341895,87.859751 53.303815,87.874373 53.25503,87.958889 53.265176,88.002464 53.218799,88.090335 53.216248,88.118962 53.10632,88.086288 53.074775,88.11326 53.022493,88.073015 52.961427,88.091294 52.939008,88.071027 52.880742))","code":"sheregesh","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true},"id":"206","name":"Шерегеш","time_zone":{"name":"Asia/Novokuznetsk","offset":420},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((69.416245 42.43852,69.802137 42.436468,69.799675 42.242484,69.414967 42.244521,69.416245 42.43852))","code":"shymkent","country_code":"kz","domain":"kz","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"161","name":"Шымкент","time_zone":{"name":"Asia/Almaty","offset":360},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((44.15612 46.265719,44.132718 46.263692,44.170768 46.387705,44.36002 46.37322,44.37314 46.35283,44.362824 46.338897,44.400949 46.322676,44.401341 46.31164,44.361345 46.315885,44.352137 46.279184,44.323492 46.27843,44.303645 46.23794,44.15612 46.265719))","code":"elista","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":false,"metro":false,"public_transport":false,"road_network":true},"id":"153","name":"Элиста","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((141.675118 47.669621,141.68309 47.687322,141.996815 47.620946,142.054915 47.55946,142.061898 47.524003,142.091643 47.501389,142.137566 47.497304,142.204846 47.523722,142.193993 47.575909,142.235882 47.559828,142.277984 47.599893,142.379936 47.641676,142.34477 47.668283,142.367085 47.708999,142.433038 47.712816,142.391115 47.759771,142.40718 47.802399,142.363027 47.810485,142.335671 47.859543,142.35035 47.872389,142.319167 47.908044,142.370514 47.950153,142.36785 47.967077,142.430172 48.004207,142.498338 47.965237,142.528036 47.977203,142.840258 47.976952,142.823431 47.796041,142.862919 47.705495,142.929041 47.619192,143.129518 47.50829,143.201995 47.44488,143.304514 47.297502,143.335109 47.108297,143.648645 46.992415,143.716886 46.939107,143.762274 46.870484,143.79941 46.735728,143.825875 46.545657,143.890542 46.444329,143.903581 46.350373,143.879647 46.289696,143.772449 46.143633,143.736816 46.032721,143.665992 45.923211,143.595467 45.864906,143.472308 45.824532,143.33642 45.828324,143.236326 45.864426,143.165438 45.9208,143.129995 45.983756,143.109984 46.088789,143.117793 46.22435,143.064302 46.324019,142.933805 46.40737,142.847268 46.408042,142.768372 46.398919,142.588021 46.335876,142.540337 46.242406,142.52034 46.126556,142.457837 45.977249,142.34959 45.822267,142.291767 45.656078,141.716427 45.742255,141.762841 45.852956,141.677199 45.939908,141.643665 45.996301,141.600864 46.276621,141.542085 46.432746,141.52014 46.544633,141.530207 46.654188,141.716865 46.997716,141.758166 47.128712,141.690923 47.226766,141.671864 47.284024,141.659125 47.521747,141.675118 47.669621))","code":"yuzhnosakhalinsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"88","name":"Южно-Сахалинск","time_zone":{"name":"Asia/Sakhalin","offset":660},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((129.586408 62.268402,129.881158 62.266844,129.928407 62.288252,129.931495 62.266516,129.994959 62.266076,129.994415 62.249586,130.074459 62.2591,130.106225 62.303491,130.116464 62.4261,130.034484 62.508088,129.971715 62.608182,129.87579 62.686043,129.867655 62.746745,129.834456 62.766592,129.719662 63.069852,129.903214 63.064516,130.628021 62.872738,131.10201 62.821206,131.510086 62.667691,131.809064 62.376579,132.20485 62.172118,132.605365 62.154489,132.645819 61.993152,132.538766 61.960015,132.368896 61.767607,132.307298 61.623673,132.345091 61.51414,132.901052 61.374474,132.756845 61.279243,132.733495 61.183413,132.082012 60.815271,131.543676 60.612425,131.29284 60.720121,130.760567 61.038314,130.333489 61.200906,128.596587 61.226232,128.449352 61.28631,128.385933 61.356958,128.359823 61.498674,128.278246 61.544112,128.042763 61.546686,127.859237 61.623452,127.740559 61.640124,127.469812 61.744924,127.327083 61.772595,127.231878 61.821748,127.119728 61.833251,126.621593 62.006493,126.669435 62.084154,126.626105 62.163748,126.668957 62.187302,126.756555 62.185521,126.918528 62.243751,127.120169 62.258118,127.16015 62.300908,127.635516 62.42181,128.03065 62.387201,128.061234 62.407978,128.237143 62.329893,128.549061 62.292032,128.789878 62.393458,128.856015 62.4011,129.14712 62.332013,129.303296 62.258639,129.492454 62.261807,129.519606 62.250452,129.533901 62.268614,129.586408 62.268402))","code":"yakutsk","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"pedestrian_routing":true,"public_transport":true,"road_network":true,"traffic":true},"id":"50","name":"Якутск","time_zone":{"name":"Asia/Yakutsk","offset":540},"type":"region","zoom_level":{"max":18,"min":9}},{"bounds":"POLYGON((39.707415 57.626018,39.726133 57.726358,39.696686 57.753943,39.783415 57.776164,40.004961 57.777804,40.032512 57.763814,40.010655 57.728992,40.043694 57.636403,40.130122 57.612294,40.192697 57.616615,40.1857 57.575858,40.21788 57.557747,40.215279 57.541949,40.115893 57.524251,40.096326 57.496959,39.952198 57.523612,39.71074 57.507271,39.677242 57.526629,39.675203 57.549456,39.692672 57.560453,39.664961 57.581545,39.707584 57.585252,39.707415 57.626018))","code":"yaroslavl","country_code":"ru","domain":"ru","flags":{"2gis_reviews":true,"flamp":true,"has_net_booklet":true,"metro":false,"public_transport":true,"road_network":true,"traffic":true},"id":"28","name":"Ярославль","time_zone":{"name":"Europe/Moscow","offset":180},"type":"region","zoom_level":{"max":18,"min":9}}]'),
	DG.config={host:null,port:3e3,defaultSkin:"dark",defaultLang:"ru",trafficLayerMinZoom:10,trafficLayerUpdateInterval:3e5,ppnotLink:"http://2gis.{domain}/{projectCode}/center/{center}/zoom/{zoom}/routeTab/rsType/{rsType}/to/{point}╎{name}",photosLink:"http://2gis.{domain}/photos/{id}",poiLayerMinZoom:0,detectRetina:!1,webApiKey:"ruregt3044",webApiVersion:"2.0",regionListFields:"items.bounds,items.zoom_level,items.time_zone,items.code,items.flags,items.country_code,items.domain,items.default_pos",firmInfoFields:"items.reviews,items.links,items.external_content",geoAdditionalFields:"items.geometry.selection,items.links,items.adm_div,items.address,items.floors,items.description",geoclickerCatalogApiKey:"ruregt3044",projectLeaveMaxZoom:13,flampUrl:"http://flamp.ru/r/",flampGoogleAnalytics:"utm_source=api2gis&utm_medium=api&utm_campaign=geoclicker",gaCode:"UA-38243181-2",gaName:"mapsapi2gis",protocol:"https:",baseUrl:"//maps.api.2gis.ru/2.0",tileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd",retinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd",previewTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd",previewRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd",arabicTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar",arabicRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar",arabicPreviewTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_sd_ar",arabicPreviewRetinaTileServer:"//tile{s}.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1&size=64&ts=online_hd_ar",trafficTileServer:"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/{timestampString}",retinaTrafficTileServer:"//traffic{s}.maps.2gis.com/{projectCode}/traffic/{z}/{x}/{y}/speed/{period}/retina/{timestampString}",trafficMetaServer:"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/{timestampString}",retinaTrafficMetaServer:"//meta{s}.maps.2gis.com/{projectCode}/meta/{z}/{x}/{y}/graph_speed/{period}/retina/{timestampString}",trafficTimestampServer:"//traffic{s}.maps.2gis.com/{projectCode}/meta/speed/time/",trafficScoreServer:"//traffic{s}.maps.2gis.com/{projectCode}/meta/score/0/",poiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd",retinaPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd",arabicPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_sd_ar",arabicRetinaPoiMetaServer:"//tile{s}.maps.2gis.com/poi?x={x}&y={y}&z={z}&v=1&ts=online_hd_ar",webApiServer:"//catalog.api.2gis.ru",googleAnalytics:"https://www.google-analytics.com/analytics.js",loadProjectListTimeout:5e3},_dereq_("../../../dist/css/styles.full.dark.css")}).call(this,_dereq_("_process"))},{"../../../dist/css/styles.full.dark.css":1,"../../../vendors/baron":9,_process:8,"dustjs-helpers":4,"dustjs-linkedin":5,html5shiv:6,leaflet:7}],3:[function(t,e,i){"use strict";var o=[],n=function(t,e){var i=document.head||document.getElementsByTagName("head")[0],n=o[o.length-1];if(e=e||{},e.insertAt=e.insertAt||"bottom","top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),o.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}};e.exports={createLink:function(t,e){var i=document.head||document.getElementsByTagName("head")[0],o=document.createElement("link");o.href=t,o.rel="stylesheet";for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];o.setAttribute("data-"+n,r)}i.appendChild(o)},createStyle:function(t,e,i){i=i||{};var o=document.createElement("style");o.type="text/css";for(var r in e)if(e.hasOwnProperty(r)){var s=e[r];o.setAttribute("data-"+r,s)}o.sheet?(o.innerHTML=t,o.sheet.cssText=t,n(o,{insertAt:i.insertAt})):o.styleSheet?(n(o,{insertAt:i.insertAt}),o.styleSheet.cssText=t):(o.appendChild(document.createTextNode(t)),n(o,{insertAt:i.insertAt}))}}},{}],4:[function(t,e,i){!function(o,n){"function"==typeof define&&define.amd&&define.amd.dust===!0?define(["dust.core"],n):"object"==typeof i?e.exports=n(t("dustjs-linkedin")):n(o.dust)}(this,function(t){function e(e,i,o){o=o||"INFO",e=e?"{@"+e+"}: ":"",t.log(e+i,o)}function i(t){h[t]||(e(t,"Deprecation warning: "+t+" is deprecated and will be removed in a future version of dustjs-helpers","WARN"),e(null,"For help and a deprecation timeline, see https://github.com/linkedin/dustjs-helpers/wiki/Deprecated-Features#"+t.replace(/\W+/g,""),"WARN"),h[t]=!0)}function o(t){return t.stack.tail&&t.stack.tail.head&&"undefined"!=typeof t.stack.tail.head.__select__}function n(t){return o(t)&&t.get("__select__")}function r(t,e){var i,o=t.stack.head,n=t.rebase();t.stack&&t.stack.tail&&(n.stack=t.stack.tail);var r={isPending:!1,isResolved:!1,isDeferredComplete:!1,deferreds:[]};for(i in e)r[i]=e[i];return n.push({__select__:r}).push(o,t.stack.index,t.stack.of)}function s(t){var e,i;if(t.isDeferredPending=!0,t.deferreds.length)for(t.isDeferredComplete=!0,e=0,i=t.deferreds.length;e<i;e++)t.deferreds[e]();t.isDeferredPending=!1}function a(t,e){return"function"==typeof e?e.toString().replace(/(^\s+|\s+$)/gm,"").replace(/\n/gm,"").replace(/,\s*/gm,", ").replace(/\)\{/gm,") {"):e}function l(t,e){return function(i,o,n,r){return u(i,o,n,r,t,e)}}function u(t,i,o,r,s,a){var l,u,h,d,p=o.block,_=o["else"],m=n(i)||{};if(m.isResolved&&!m.isDeferredPending)return t;if(r.hasOwnProperty("key"))u=r.key;else{if(!m.hasOwnProperty("key"))return e(s,"No key specified","WARN"),t;u=m.key}return d=r.type||m.type,u=c(i.resolve(u),d),h=c(i.resolve(r.value),d),a(u,h)?(m.isPending||(l=!0,m.isPending=!0),p&&(t=t.render(p,i)),l&&(m.isResolved=!0)):_&&(t=t.render(_,i)),t}function c(t,e){switch(e&&(e=e.toLowerCase()),e){case"number":return+t;case"string":return String(t);case"boolean":return t="false"!==t&&t,Boolean(t);case"date":return new Date(t)}return t}var h={},d={tap:function(t,e,o){return i("tap"),o.resolve(t)},sep:function(t,e,i){var o=i.block;return e.stack.index===e.stack.of-1?t:o?o(t,e):t},first:function(t,e,i){return 0===e.stack.index?i.block(t,e):t},last:function(t,e,i){return e.stack.index===e.stack.of-1?i.block(t,e):t},contextDump:function(t,i,o,n){var r,s,l=i.resolve(n.to),u=i.resolve(n.key);switch(u){case"full":r=i.stack;break;default:r=i.stack.head}switch(s=JSON.stringify(r,a,2),l){case"console":e("contextDump",s);break;default:s=s.replace(/</g,"\\u003c"),t=t.write(s)}return t},math:function(t,i,o,a){var l,u=a.key,c=a.method,h=a.operand,d=a.round;if(!a.hasOwnProperty("key")||!a.method)return e("math","`key` or `method` was not provided","ERROR"),t;switch(u=parseFloat(i.resolve(u)),h=parseFloat(i.resolve(h)),c){case"mod":0===h&&e("math","Division by 0","ERROR"),l=u%h;break;case"add":l=u+h;break;case"subtract":l=u-h;break;case"multiply":l=u*h;break;case"divide":0===h&&e("math","Division by 0","ERROR"),l=u/h;break;case"ceil":case"floor":case"round":case"abs":l=Math[c](u);break;case"toint":l=parseInt(u,10);break;default:e("math","Method `"+c+"` is not supported","ERROR")}return"undefined"!=typeof l&&(d&&(l=Math.round(l)),o&&o.block?(i=r(i,{key:l}),t=t.render(o.block,i),s(n(i))):t=t.write(l)),t},select:function(t,i,o,a){var l=o.block,u={};return a.hasOwnProperty("key")&&(u.key=i.resolve(a.key)),a.hasOwnProperty("type")&&(u.type=a.type),l?(i=r(i,u),t=t.render(l,i),s(n(i))):e("select","Missing body block","WARN"),t},eq:l("eq",function(t,e){return t===e}),ne:l("ne",function(t,e){return t!==e}),lt:l("lt",function(t,e){return t<e}),lte:l("lte",function(t,e){return t<=e}),gt:l("gt",function(t,e){return t>e}),gte:l("gte",function(t,e){return t>=e}),any:function(t,i,o,r){var s=n(i);return s?s.isDeferredComplete?e("any","Must not be nested inside {@any} or {@none} block","ERROR"):t=t.map(function(t){s.deferreds.push(function(){s.isResolved&&(t=t.render(o.block,i)),t.end()})}):e("any","Must be used inside a {@select} block","ERROR"),t},none:function(t,i,o,r){var s=n(i);return s?s.isDeferredComplete?e("none","Must not be nested inside {@any} or {@none} block","ERROR"):t=t.map(function(t){s.deferreds.push(function(){s.isResolved||(t=t.render(o.block,i)),t.end()})}):e("none","Must be used inside a {@select} block","ERROR"),t},size:function(e,i,o,n){var r,s,a=n.key;if(a=i.resolve(n.key),a&&a!==!0)if(t.isArray(a))r=a.length;else if(!isNaN(parseFloat(a))&&isFinite(a))r=a;else if("object"==typeof a){r=0;for(s in a)a.hasOwnProperty(s)&&r++}else r=(a+"").length;else r=0;return e.write(r)}};for(var p in d)t.helpers[p]=d[p];return t})},{"dustjs-linkedin":5}],5:[function(_dereq_,module,exports){(function(process){!function(t,e){"function"==typeof define&&define.amd&&define.amd.dust===!0?define("dust.core",[],e):"object"==typeof exports?module.exports=e():t.dust=e()}(this,function(){function getTemplate(t,e){if(t)return"function"==typeof t&&t.template?t.template:dust.isTemplateFn(t)?t:e!==!1?dust.cache[t]:void 0}function load(t,e,i){if(!t)return e.setError(new Error("No template or template name provided to render"));var o=getTemplate(t,dust.config.cache);return o?o(e,Context.wrap(i,o.templateName)):dust.onLoad?e.map(function(e){function o(t,o){var r;if(t)return e.setError(t);if(r=getTemplate(o,!1)||getTemplate(n,dust.config.cache),!r){if(!dust.compile)return e.setError(new Error("Dust compiler not available"));r=dust.loadSource(dust.compile(o,n))}r(e,Context.wrap(i,r.templateName)).end()}var n=t;3===dust.onLoad.length?dust.onLoad(n,i.options,o):dust.onLoad(n,o)}):e.setError(new Error("Template Not Found: "+t))}function Context(t,e,i,o,n){void 0===t||t instanceof Stack||(t=new Stack(t)),this.stack=t,this.global=e,this.options=i,this.blocks=o,this.templateName=n,this._isContext=!0}function getWithResolvedData(t,e,i){return function(o){return t.push(o)._get(e,i)}}function Stack(t,e,i,o){this.tail=e,this.isObject=t&&"object"==typeof t,this.head=t,this.index=i,this.of=o}function Stub(t){this.head=new Chunk(this),this.callback=t,this.out=""}function Stream(){this.head=new Chunk(this)}function Chunk(t,e,i){this.root=t,this.next=e,this.data=[],this.flushable=!1,this.taps=i}function Tap(t,e){this.head=t,this.tail=e}var dust={version:"2.7.5"},NONE="NONE",ERROR="ERROR",WARN="WARN",INFO="INFO",DEBUG="DEBUG",EMPTY_FUNC=function(){};dust.config={whitespace:!1,amd:!1,cjs:!1,cache:!0},dust._aliases={write:"w",end:"e",map:"m",render:"r",reference:"f",section:"s",exists:"x",notexists:"nx",block:"b",partial:"p",helper:"h"},function(){var t,e,i={DEBUG:0,INFO:1,WARN:2,ERROR:3,NONE:4};"undefined"!=typeof console&&console.log?(t=console.log,e="function"==typeof t?function(){t.apply(console,arguments)}:function(){t(Array.prototype.slice.apply(arguments).join(" "))}):e=EMPTY_FUNC,dust.log=function(t,o){o=o||INFO,i[o]>=i[dust.debugLevel]&&e("[DUST:"+o+"]",t)},dust.debugLevel=NONE,"undefined"!=typeof process&&process.env&&/\bdust\b/.test(process.env.DEBUG)&&(dust.debugLevel=DEBUG)}(),dust.helpers={},dust.cache={},dust.register=function(t,e){t&&(e.templateName=t,dust.config.cache!==!1&&(dust.cache[t]=e))},dust.render=function(t,e,i){var o=new Stub(i).head;try{load(t,o,e).end()}catch(n){o.setError(n)}},dust.stream=function(t,e){var i=new Stream,o=i.head;return dust.nextTick(function(){try{load(t,o,e).end()}catch(i){o.setError(i)}}),i},dust.loadSource=function(source){return eval(source)},Array.isArray?dust.isArray=Array.isArray:dust.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)},dust.nextTick=function(){return function(t){setTimeout(t,0)}}(),dust.isEmpty=function(t){return 0!==t&&(!(!dust.isArray(t)||t.length)||!t)},dust.isEmptyObject=function(t){var e;if(null===t)return!1;if(void 0===t)return!1;if(t.length>0)return!1;for(e in t)if(Object.prototype.hasOwnProperty.call(t,e))return!1;return!0},dust.isTemplateFn=function(t){return"function"==typeof t&&t.__dustBody},dust.isThenable=function(t){return t&&"object"==typeof t&&"function"==typeof t.then},dust.isStreamable=function(t){return t&&"function"==typeof t.on&&"function"==typeof t.pipe},dust.filter=function(t,e,i,o){var n,r,s,a;if(i)for(n=0,r=i.length;n<r;n++)s=i[n],s.length&&(a=dust.filters[s],"s"===s?e=null:"function"==typeof a?t=a(t,o):dust.log("Invalid filter `"+s+"`",WARN));return e&&(t=dust.filters[e](t,o)),t},dust.filters={h:function(t){return dust.escapeHtml(t)},j:function(t){return dust.escapeJs(t)},u:encodeURI,uc:encodeURIComponent,js:function(t){return dust.escapeJSON(t)},jp:function(t){return JSON?JSON.parse(t):(dust.log("JSON is undefined; could not parse `"+t+"`",WARN),t)}},dust.makeBase=dust.context=function(t,e){return new Context((void 0),t,e)},dust.isContext=function(t){return"object"==typeof t&&t._isContext===!0},Context.wrap=function(t,e){return dust.isContext(t)?t:new Context(t,{},{},null,e)},Context.prototype.get=function(t,e){return"string"==typeof t&&("."===t[0]&&(e=!0,t=t.substr(1)),t=t.split(".")),this._get(e,t)},Context.prototype._get=function(t,e){var i,o,n,r,s,a=this.stack||{},l=1;if(o=e[0],n=e.length,t&&0===n)r=a,a=a.head;else{if(t)a&&(a=a.head?a.head[o]:void 0);else{for(;a&&(!a.isObject||(r=a.head,i=a.head[o],void 0===i));)a=a.tail;a=void 0!==i?i:this.global&&this.global[o]}for(;a&&l<n;){if(dust.isThenable(a))return a.then(getWithResolvedData(this,t,e.slice(l)));r=a,a=a[e[l]],l++}}return"function"==typeof a?(s=function(){try{return a.apply(r,arguments)}catch(t){throw dust.log(t,ERROR),t}},s.__dustBody=!!a.__dustBody,s):(void 0===a&&dust.log("Cannot find reference `{"+e.join(".")+"}` in template `"+this.getTemplateName()+"`",INFO),a)},Context.prototype.getPath=function(t,e){return this._get(t,e)},Context.prototype.push=function(t,e,i){return void 0===t?(dust.log("Not pushing an undefined variable onto the context",INFO),this):this.rebase(new Stack(t,this.stack,e,i))},Context.prototype.pop=function(){var t=this.current();return this.stack=this.stack&&this.stack.tail,t},Context.prototype.rebase=function(t){return new Context(t,this.global,this.options,this.blocks,this.getTemplateName())},Context.prototype.clone=function(){var t=this.rebase();return t.stack=this.stack,t},Context.prototype.current=function(){return this.stack&&this.stack.head},Context.prototype.getBlock=function(t){var e,i,o;if("function"==typeof t&&(t=t(new Chunk,this).data.join("")),e=this.blocks,!e)return dust.log("No blocks for context `"+t+"` in template `"+this.getTemplateName()+"`",DEBUG),!1;for(i=e.length;i--;)if(o=e[i][t])return o;return dust.log("Malformed template `"+this.getTemplateName()+"` was missing one or more blocks."),!1},Context.prototype.shiftBlocks=function(t){var e,i=this.blocks;return t?(e=i?i.concat([t]):[t],new Context(this.stack,this.global,this.options,e,this.getTemplateName())):this},Context.prototype.resolve=function(t){var e;return"function"!=typeof t?t:(e=(new Chunk).render(t,this),e instanceof Chunk?e.data.join(""):e)},Context.prototype.getTemplateName=function(){return this.templateName},Stub.prototype.flush=function(){for(var t=this.head;t;){if(!t.flushable)return t.error?(this.callback(t.error),dust.log("Rendering failed with error `"+t.error+"`",ERROR),void(this.flush=EMPTY_FUNC)):void 0;this.out+=t.data.join(""),t=t.next,this.head=t}this.callback(null,this.out)},Stream.prototype.flush=function(){for(var t=this.head;t;){if(!t.flushable)return t.error?(this.emit("error",t.error),this.emit("end"),dust.log("Streaming failed with error `"+t.error+"`",ERROR),void(this.flush=EMPTY_FUNC)):void 0;this.emit("data",t.data.join("")),t=t.next,this.head=t}this.emit("end")},Stream.prototype.emit=function(t,e){var i,o,n=this.events||{},r=n[t]||[];if(!r.length)return dust.log("Stream broadcasting, but no listeners for `"+t+"`",DEBUG),!1;for(r=r.slice(0),i=0,o=r.length;i<o;i++)r[i](e);return!0},Stream.prototype.on=function(t,e){var i=this.events=this.events||{},o=i[t]=i[t]||[];return"function"!=typeof e?dust.log("No callback function provided for `"+t+"` event listener",WARN):o.push(e),this},Stream.prototype.pipe=function(t){if("function"!=typeof t.write||"function"!=typeof t.end)return dust.log("Incompatible stream passed to `pipe`",WARN),this;var e=!1;return"function"==typeof t.emit&&t.emit("pipe",this),"function"==typeof t.on&&t.on("error",function(){e=!0}),this.on("data",function(i){if(!e)try{t.write(i,"utf8")}catch(o){dust.log(o,ERROR)}}).on("end",function(){if(!e)try{t.end(),e=!0}catch(i){dust.log(i,ERROR)}})},Chunk.prototype.write=function(t){var e=this.taps;return e&&(t=e.go(t)),this.data.push(t),this},Chunk.prototype.end=function(t){return t&&this.write(t),this.flushable=!0,this.root.flush(),this},Chunk.prototype.map=function(t){var e=new Chunk(this.root,this.next,this.taps),i=new Chunk(this.root,e,this.taps);this.next=i,this.flushable=!0;try{t(i)}catch(o){dust.log(o,ERROR),i.setError(o)}return e},Chunk.prototype.tap=function(t){var e=this.taps;return e?this.taps=e.push(t):this.taps=new Tap(t),this},Chunk.prototype.untap=function(){return this.taps=this.taps.tail,this},Chunk.prototype.render=function(t,e){return t(this,e)},Chunk.prototype.reference=function(t,e,i,o){return"function"==typeof t?(t=t.apply(e.current(),[this,e,null,{auto:i,filters:o}]),t instanceof Chunk?t:this.reference(t,e,i,o)):dust.isThenable(t)?this.await(t,e,null,i,o):dust.isStreamable(t)?this.stream(t,e,null,i,o):dust.isEmpty(t)?this:this.write(dust.filter(t,i,o,e))},Chunk.prototype.section=function(t,e,i,o){var n,r,s,a=i.block,l=i["else"],u=this;if("function"==typeof t&&!dust.isTemplateFn(t)){try{t=t.apply(e.current(),[this,e,i,o])}catch(c){return dust.log(c,ERROR),this.setError(c)}if(t instanceof Chunk)return t}if(dust.isEmptyObject(i))return u;if(dust.isEmptyObject(o)||(e=e.push(o)),dust.isArray(t)){if(a){if(r=t.length,r>0){for(s=e.stack&&e.stack.head||{},s.$len=r,n=0;n<r;n++)s.$idx=n,u=a(u,e.push(t[n],n,r));return s.$idx=void 0,s.$len=void 0,u}if(l)return l(this,e)}}else{if(dust.isThenable(t))return this.await(t,e,i);if(dust.isStreamable(t))return this.stream(t,e,i);if(t===!0){if(a)return a(this,e)}else if(t||0===t){if(a)return a(this,e.push(t))}else if(l)return l(this,e)}return dust.log("Section without corresponding key in template `"+e.getTemplateName()+"`",DEBUG),this},Chunk.prototype.exists=function(t,e,i){var o=i.block,n=i["else"];if(dust.isEmpty(t)){if(n)return n(this,e)}else{if(o)return o(this,e);dust.log("No block for exists check in template `"+e.getTemplateName()+"`",DEBUG)}return this},Chunk.prototype.notexists=function(t,e,i){var o=i.block,n=i["else"];if(dust.isEmpty(t)){if(o)return o(this,e);dust.log("No block for not-exists check in template `"+e.getTemplateName()+"`",DEBUG)}else if(n)return n(this,e);return this},Chunk.prototype.block=function(t,e,i){var o=t||i.block;return o?o(this,e):this},Chunk.prototype.partial=function(t,e,i,o){var n;return void 0===o&&(o=i,i=e),dust.isEmptyObject(o)||(i=i.clone(),n=i.pop(),i=i.push(o).push(n)),dust.isTemplateFn(t)?this.capture(t,e,function(t,e){i.templateName=t,load(t,e,i).end()}):(i.templateName=t,load(t,this,i))},Chunk.prototype.helper=function(t,e,i,o,n){var r,s=this,a=o.filters;if(void 0===n&&(n="h"),!dust.helpers[t])return dust.log("Helper `"+t+"` does not exist",WARN),s;try{return r=dust.helpers[t](s,e,i,o),r instanceof Chunk?r:("string"==typeof a&&(a=a.split("|")),dust.isEmptyObject(i)?s.reference(r,e,n,a):s.section(r,e,i,o))}catch(l){return dust.log("Error in helper `"+t+"`: "+l.message,ERROR),s.setError(l)}},Chunk.prototype.await=function(t,e,i,o,n){return this.map(function(r){t.then(function(t){r=i?r.section(t,e,i):r.reference(t,e,o,n),r.end()},function(t){var o=i&&i.error;o?r.render(o,e.push(t)).end():(dust.log("Unhandled promise rejection in `"+e.getTemplateName()+"`",INFO),r.end())})})},Chunk.prototype.stream=function(t,e,i,o,n){var r=i&&i.block,s=i&&i.error;return this.map(function(a){var l=!1;t.on("data",function(t){l||(r?a=a.map(function(i){i.render(r,e.push(t)).end()}):i||(a=a.reference(t,e,o,n)))}).on("error",function(t){l||(s?a.render(s,e.push(t)):dust.log("Unhandled stream error in `"+e.getTemplateName()+"`",INFO),l||(l=!0,a.end()))}).on("end",function(){l||(l=!0,a.end())})})},Chunk.prototype.capture=function(t,e,i){return this.map(function(o){var n=new Stub(function(t,e){t?o.setError(t):i(e,o)});t(n.head,e).end()})},Chunk.prototype.setError=function(t){return this.error=t,this.root.flush(),this};for(var f in Chunk.prototype)dust._aliases[f]&&(Chunk.prototype[dust._aliases[f]]=Chunk.prototype[f]);Tap.prototype.push=function(t){return new Tap(t,this)},Tap.prototype.go=function(t){for(var e=this;e;)t=e.head(t),e=e.tail;return t};var HCHARS=/[&<>"']/,AMP=/&/g,LT=/</g,GT=/>/g,QUOT=/\"/g,SQUOT=/\'/g;dust.escapeHtml=function(t){return"string"==typeof t||t&&"function"==typeof t.toString?("string"!=typeof t&&(t=t.toString()),HCHARS.test(t)?t.replace(AMP,"&amp;").replace(LT,"&lt;").replace(GT,"&gt;").replace(QUOT,"&quot;").replace(SQUOT,"&#39;"):t):t};var BS=/\\/g,FS=/\//g,CR=/\r/g,LS=/\u2028/g,PS=/\u2029/g,NL=/\n/g,LF=/\f/g,SQ=/'/g,DQ=/"/g,TB=/\t/g;return dust.escapeJs=function(t){return"string"==typeof t?t.replace(BS,"\\\\").replace(FS,"\\/").replace(DQ,'\\"').replace(SQ,"\\'").replace(CR,"\\r").replace(LS,"\\u2028").replace(PS,"\\u2029").replace(NL,"\\n").replace(LF,"\\f").replace(TB,"\\t"):t},dust.escapeJSON=function(t){return JSON?JSON.stringify(t).replace(LS,"\\u2028").replace(PS,"\\u2029").replace(LT,"\\u003c"):(dust.log("JSON is undefined; could not escape `"+t+"`",WARN),t)},dust})}).call(this,_dereq_("_process"))},{_process:8}],6:[function(t,e,i){!function(t,i){function o(t,e){var i=t.createElement("p"),o=t.getElementsByTagName("head")[0]||t.documentElement;return i.innerHTML="x<style>"+e+"</style>",o.insertBefore(i.lastChild,o.firstChild)}function n(){var t=b.elements;return"string"==typeof t?t.split(" "):t}function r(t,e){var i=b.elements;"string"!=typeof i&&(i=i.join(" ")),"string"!=typeof t&&(t=t.join(" ")),b.elements=i+" "+t,c(e)}function s(t){var e=y[t[g]];return e||(e={},v++,t[g]=v,y[v]=e),e}function a(t,e,o){if(e||(e=i),d)return e.createElement(t);o||(o=s(e));var n;return n=o.cache[t]?o.cache[t].cloneNode():f.test(t)?(o.cache[t]=o.createElem(t)).cloneNode():o.createElem(t),!n.canHaveChildren||m.test(t)||n.tagUrn?n:o.frag.appendChild(n)}function l(t,e){if(t||(t=i),d)return t.createDocumentFragment();e=e||s(t);for(var o=e.frag.cloneNode(),r=0,a=n(),l=a.length;r<l;r++)o.createElement(a[r]);return o}function u(t,e){e.cache||(e.cache={},e.createElem=t.createElement,e.createFrag=t.createDocumentFragment,e.frag=e.createFrag()),t.createElement=function(i){return b.shivMethods?a(i,t,e):e.createElem(i)},t.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+n().join().replace(/[\w\-:]+/g,function(t){return e.createElem(t),e.frag.createElement(t),'c("'+t+'")'})+");return n}")(b,e.frag)}function c(t){t||(t=i);var e=s(t);return!b.shivCSS||h||e.hasCSS||(e.hasCSS=!!o(t,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),d||u(t,e),t}var h,d,p="3.7.3-pre",_=t.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,f=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var t=i.createElement("a");t.innerHTML="<xyz></xyz>",h="hidden"in t,d=1==t.childNodes.length||function(){i.createElement("a");var t=i.createDocumentFragment();return"undefined"==typeof t.cloneNode||"undefined"==typeof t.createDocumentFragment||"undefined"==typeof t.createElement}()}catch(e){h=!0,d=!0}}();var b={elements:_.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:p,shivCSS:_.shivCSS!==!1,supportsUnknownElements:d,shivMethods:_.shivMethods!==!1,type:"default",shivDocument:c,createElement:a,createDocumentFragment:l,addElements:r};t.html5=b,c(i),"object"==typeof e&&e.exports&&(e.exports=b)}("undefined"!=typeof window?window:this,document)},{}],7:[function(t,e,i){function o(){var t=window.L;n.noConflict=function(){return window.L=t,this},window.L=n}var n={version:"1.0.1"};"object"==typeof e&&"object"==typeof e.exports?e.exports=n:"function"==typeof define&&define.amd&&define(n),"undefined"!=typeof window&&o(),n.Util={extend:function(t){var e,i,o,n;for(i=1,o=arguments.length;i<o;i++){n=arguments[i];for(e in n)t[e]=n[e]}return t},create:Object.create||function(){function t(){}return function(e){return t.prototype=e,new t}}(),bind:function(t,e){var i=Array.prototype.slice;if(t.bind)return t.bind.apply(t,i.call(arguments,1));var o=i.call(arguments,2);return function(){return t.apply(e,o.length?o.concat(i.call(arguments)):arguments)}},stamp:function(t){return t._leaflet_id=t._leaflet_id||++n.Util.lastId,t._leaflet_id},lastId:0,throttle:function(t,e,i){var o,n,r,s;return s=function(){o=!1,n&&(r.apply(i,n),n=!1)},r=function(){o?n=arguments:(t.apply(i,arguments),setTimeout(s,e),o=!0)}},wrapNum:function(t,e,i){var o=e[1],n=e[0],r=o-n;return t===o&&i?t:((t-n)%r+r)%r+n},falseFn:function(){return!1},formatNum:function(t,e){var i=Math.pow(10,e||5);return Math.round(t*i)/i},trim:function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")},splitWords:function(t){return n.Util.trim(t).split(/\s+/)},setOptions:function(t,e){t.hasOwnProperty("options")||(t.options=t.options?n.Util.create(t.options):{});for(var i in e)t.options[i]=e[i];return t.options},getParamString:function(t,e,i){var o=[];for(var n in t)o.push(encodeURIComponent(i?n.toUpperCase():n)+"="+encodeURIComponent(t[n]));return(e&&e.indexOf("?")!==-1?"&":"?")+o.join("&")},template:function(t,e){return t.replace(n.Util.templateRe,function(t,i){var o=e[i];if(void 0===o)throw new Error("No value provided for variable "+t);return"function"==typeof o&&(o=o(e)),o})},templateRe:/\{ *([\w_\-]+) *\}/g,isArray:Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},indexOf:function(t,e){for(var i=0;i<t.length;i++)if(t[i]===e)return i;return-1},emptyImageUrl:"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="},function(){function t(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}function e(t){var e=+new Date,o=Math.max(0,16-(e-i));return i=e+o,window.setTimeout(t,o)}var i=0,o=window.requestAnimationFrame||t("RequestAnimationFrame")||e,r=window.cancelAnimationFrame||t("CancelAnimationFrame")||t("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)};n.Util.requestAnimFrame=function(t,i,r){return r&&o===e?void t.call(i):o.call(window,n.bind(t,i))},n.Util.cancelAnimFrame=function(t){t&&r.call(window,t)}}(),n.extend=n.Util.extend,n.bind=n.Util.bind,n.stamp=n.Util.stamp,n.setOptions=n.Util.setOptions,n.Class=function(){},n.Class.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},i=e.__super__=this.prototype,o=n.Util.create(i);o.constructor=e,e.prototype=o;for(var r in this)this.hasOwnProperty(r)&&"prototype"!==r&&(e[r]=this[r]);return t.statics&&(n.extend(e,t.statics),delete t.statics),t.includes&&(n.Util.extend.apply(null,[o].concat(t.includes)),delete t.includes),o.options&&(t.options=n.Util.extend(n.Util.create(o.options),t.options)),n.extend(o,t),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){i.callInitHooks&&i.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,e=o._initHooks.length;t<e;t++)o._initHooks[t].call(this)}},e},n.Class.include=function(t){return n.extend(this.prototype,t),this},n.Class.mergeOptions=function(t){return n.extend(this.prototype.options,t),this},n.Class.addInitHook=function(t){var e=Array.prototype.slice.call(arguments,1),i="function"==typeof t?t:function(){this[t].apply(this,e)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(i),this},n.Evented=n.Class.extend({on:function(t,e,i){if("object"==typeof t)for(var o in t)this._on(o,t[o],e);else{t=n.Util.splitWords(t);for(var r=0,s=t.length;r<s;r++)this._on(t[r],e,i)}return this},off:function(t,e,i){if(t)if("object"==typeof t)for(var o in t)this._off(o,t[o],e);else{t=n.Util.splitWords(t);for(var r=0,s=t.length;r<s;r++)this._off(t[r],e,i)}else delete this._events;return this},_on:function(t,e,i){this._events=this._events||{};var o=this._events[t];o||(o=[],this._events[t]=o),i===this&&(i=void 0);for(var n={fn:e,ctx:i},r=o,s=0,a=r.length;s<a;s++)if(r[s].fn===e&&r[s].ctx===i)return;r.push(n),o.count++},_off:function(t,e,i){var o,r,s;if(this._events&&(o=this._events[t])){if(!e){for(r=0,s=o.length;r<s;r++)o[r].fn=n.Util.falseFn;return void delete this._events[t]}if(i===this&&(i=void 0),o)for(r=0,s=o.length;r<s;r++){var a=o[r];if(a.ctx===i&&a.fn===e)return a.fn=n.Util.falseFn,this._firingCount&&(this._events[t]=o=o.slice()),void o.splice(r,1)}}},fire:function(t,e,i){if(!this.listens(t,i))return this;var o=n.Util.extend({},e,{type:t,target:this});if(this._events){var r=this._events[t];if(r){this._firingCount=this._firingCount+1||1;for(var s=0,a=r.length;s<a;s++){var l=r[s];l.fn.call(l.ctx||this,o)}this._firingCount--}}return i&&this._propagateEvent(o),this},listens:function(t,e){var i=this._events&&this._events[t];if(i&&i.length)return!0;if(e)for(var o in this._eventParents)if(this._eventParents[o].listens(t,e))return!0;return!1},once:function(t,e,i){if("object"==typeof t){for(var o in t)this.once(o,t[o],e);return this}var r=n.bind(function(){this.off(t,e,i).off(t,r,i)},this);return this.on(t,e,i).on(t,r,i)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[n.stamp(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[n.stamp(t)],this},_propagateEvent:function(t){for(var e in this._eventParents)this._eventParents[e].fire(t.type,n.extend({layer:t.target},t),!0)}});var r=n.Evented.prototype;r.addEventListener=r.on,r.removeEventListener=r.clearAllEventListeners=r.off,r.addOneTimeEventListener=r.once,r.fireEvent=r.fire,r.hasEventListeners=r.listens,n.Mixin={Events:r},function(){var t=navigator.userAgent.toLowerCase(),e=document.documentElement,i="ActiveXObject"in window,o=t.indexOf("webkit")!==-1,r=t.indexOf("phantom")!==-1,s=t.search("android [23]")!==-1,a=t.indexOf("chrome")!==-1,l=t.indexOf("gecko")!==-1&&!o&&!window.opera&&!i,u=0===navigator.platform.indexOf("Win"),c="undefined"!=typeof orientation||t.indexOf("mobile")!==-1,h=!window.PointerEvent&&window.MSPointerEvent,d=window.PointerEvent||h,p=i&&"transition"in e.style,_="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!s,m="MozPerspective"in e.style,f="OTransition"in e.style,g=!window.L_NO_TOUCH&&(d||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch);n.Browser={ie:i,ielt9:i&&!document.addEventListener,edge:"msLaunchUri"in navigator&&!("documentMode"in document),webkit:o,gecko:l,android:t.indexOf("android")!==-1,android23:s,chrome:a,safari:!a&&t.indexOf("safari")!==-1,win:u,ie3d:p,webkit3d:_,gecko3d:m,opera12:f,any3d:!window.L_DISABLE_3D&&(p||_||m)&&!f&&!r,mobile:c,mobileWebkit:c&&o,mobileWebkit3d:c&&_,mobileOpera:c&&window.opera,mobileGecko:c&&l,touch:!!g,msPointer:!!h,pointer:!!d,retina:(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1}}(),n.Point=function(t,e,i){this.x=i?Math.round(t):t,this.y=i?Math.round(e):e},n.Point.prototype={clone:function(){return new n.Point(this.x,this.y)},add:function(t){return this.clone()._add(n.point(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(n.point(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){
	return this.x*=t,this.y*=t,this},scaleBy:function(t){return new n.Point(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new n.Point(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},distanceTo:function(t){t=n.point(t);var e=t.x-this.x,i=t.y-this.y;return Math.sqrt(e*e+i*i)},equals:function(t){return t=n.point(t),t.x===this.x&&t.y===this.y},contains:function(t){return t=n.point(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+n.Util.formatNum(this.x)+", "+n.Util.formatNum(this.y)+")"}},n.point=function(t,e,i){return t instanceof n.Point?t:n.Util.isArray(t)?new n.Point(t[0],t[1]):void 0===t||null===t?t:"object"==typeof t&&"x"in t&&"y"in t?new n.Point(t.x,t.y):new n.Point(t,e,i)},n.Bounds=function(t,e){if(t)for(var i=e?[t,e]:t,o=0,n=i.length;o<n;o++)this.extend(i[o])},n.Bounds.prototype={extend:function(t){return t=n.point(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new n.Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new n.Point(this.min.x,this.max.y)},getTopRight:function(){return new n.Point(this.max.x,this.min.y)},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var e,i;return t="number"==typeof t[0]||t instanceof n.Point?n.point(t):n.bounds(t),t instanceof n.Bounds?(e=t.min,i=t.max):e=i=t,e.x>=this.min.x&&i.x<=this.max.x&&e.y>=this.min.y&&i.y<=this.max.y},intersects:function(t){t=n.bounds(t);var e=this.min,i=this.max,o=t.min,r=t.max,s=r.x>=e.x&&o.x<=i.x,a=r.y>=e.y&&o.y<=i.y;return s&&a},overlaps:function(t){t=n.bounds(t);var e=this.min,i=this.max,o=t.min,r=t.max,s=r.x>e.x&&o.x<i.x,a=r.y>e.y&&o.y<i.y;return s&&a},isValid:function(){return!(!this.min||!this.max)}},n.bounds=function(t,e){return!t||t instanceof n.Bounds?t:new n.Bounds(t,e)},n.Transformation=function(t,e,i,o){this._a=t,this._b=e,this._c=i,this._d=o},n.Transformation.prototype={transform:function(t,e){return this._transform(t.clone(),e)},_transform:function(t,e){return e=e||1,t.x=e*(this._a*t.x+this._b),t.y=e*(this._c*t.y+this._d),t},untransform:function(t,e){return e=e||1,new n.Point((t.x/e-this._b)/this._a,(t.y/e-this._d)/this._c)}},n.DomUtil={get:function(t){return"string"==typeof t?document.getElementById(t):t},getStyle:function(t,e){var i=t.style[e]||t.currentStyle&&t.currentStyle[e];if((!i||"auto"===i)&&document.defaultView){var o=document.defaultView.getComputedStyle(t,null);i=o?o[e]:null}return"auto"===i?null:i},create:function(t,e,i){var o=document.createElement(t);return o.className=e||"",i&&i.appendChild(o),o},remove:function(t){var e=t.parentNode;e&&e.removeChild(t)},empty:function(t){for(;t.firstChild;)t.removeChild(t.firstChild)},toFront:function(t){t.parentNode.appendChild(t)},toBack:function(t){var e=t.parentNode;e.insertBefore(t,e.firstChild)},hasClass:function(t,e){if(void 0!==t.classList)return t.classList.contains(e);var i=n.DomUtil.getClass(t);return i.length>0&&new RegExp("(^|\\s)"+e+"(\\s|$)").test(i)},addClass:function(t,e){if(void 0!==t.classList)for(var i=n.Util.splitWords(e),o=0,r=i.length;o<r;o++)t.classList.add(i[o]);else if(!n.DomUtil.hasClass(t,e)){var s=n.DomUtil.getClass(t);n.DomUtil.setClass(t,(s?s+" ":"")+e)}},removeClass:function(t,e){void 0!==t.classList?t.classList.remove(e):n.DomUtil.setClass(t,n.Util.trim((" "+n.DomUtil.getClass(t)+" ").replace(" "+e+" "," ")))},setClass:function(t,e){void 0===t.className.baseVal?t.className=e:t.className.baseVal=e},getClass:function(t){return void 0===t.className.baseVal?t.className:t.className.baseVal},setOpacity:function(t,e){"opacity"in t.style?t.style.opacity=e:"filter"in t.style&&n.DomUtil._setOpacityIE(t,e)},_setOpacityIE:function(t,e){var i=!1,o="DXImageTransform.Microsoft.Alpha";try{i=t.filters.item(o)}catch(n){if(1===e)return}e=Math.round(100*e),i?(i.Enabled=100!==e,i.Opacity=e):t.style.filter+=" progid:"+o+"(opacity="+e+")"},testProp:function(t){for(var e=document.documentElement.style,i=0;i<t.length;i++)if(t[i]in e)return t[i];return!1},setTransform:function(t,e,i){var o=e||new n.Point(0,0);t.style[n.DomUtil.TRANSFORM]=(n.Browser.ie3d?"translate("+o.x+"px,"+o.y+"px)":"translate3d("+o.x+"px,"+o.y+"px,0)")+(i?" scale("+i+")":"")},setPosition:function(t,e){t._leaflet_pos=e,n.Browser.any3d?n.DomUtil.setTransform(t,e):(t.style.left=e.x+"px",t.style.top=e.y+"px")},getPosition:function(t){return t._leaflet_pos||new n.Point(0,0)}},function(){n.DomUtil.TRANSFORM=n.DomUtil.testProp(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]);var t=n.DomUtil.TRANSITION=n.DomUtil.testProp(["webkitTransition","transition","OTransition","MozTransition","msTransition"]);if(n.DomUtil.TRANSITION_END="webkitTransition"===t||"OTransition"===t?t+"End":"transitionend","onselectstart"in document)n.DomUtil.disableTextSelection=function(){n.DomEvent.on(window,"selectstart",n.DomEvent.preventDefault)},n.DomUtil.enableTextSelection=function(){n.DomEvent.off(window,"selectstart",n.DomEvent.preventDefault)};else{var e=n.DomUtil.testProp(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);n.DomUtil.disableTextSelection=function(){if(e){var t=document.documentElement.style;this._userSelect=t[e],t[e]="none"}},n.DomUtil.enableTextSelection=function(){e&&(document.documentElement.style[e]=this._userSelect,delete this._userSelect)}}n.DomUtil.disableImageDrag=function(){n.DomEvent.on(window,"dragstart",n.DomEvent.preventDefault)},n.DomUtil.enableImageDrag=function(){n.DomEvent.off(window,"dragstart",n.DomEvent.preventDefault)},n.DomUtil.preventOutline=function(t){for(;t.tabIndex===-1;)t=t.parentNode;t&&t.style&&(n.DomUtil.restoreOutline(),this._outlineElement=t,this._outlineStyle=t.style.outline,t.style.outline="none",n.DomEvent.on(window,"keydown",n.DomUtil.restoreOutline,this))},n.DomUtil.restoreOutline=function(){this._outlineElement&&(this._outlineElement.style.outline=this._outlineStyle,delete this._outlineElement,delete this._outlineStyle,n.DomEvent.off(window,"keydown",n.DomUtil.restoreOutline,this))}}(),n.LatLng=function(t,e,i){if(isNaN(t)||isNaN(e))throw new Error("Invalid LatLng object: ("+t+", "+e+")");this.lat=+t,this.lng=+e,void 0!==i&&(this.alt=+i)},n.LatLng.prototype={equals:function(t,e){if(!t)return!1;t=n.latLng(t);var i=Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng));return i<=(void 0===e?1e-9:e)},toString:function(t){return"LatLng("+n.Util.formatNum(this.lat,t)+", "+n.Util.formatNum(this.lng,t)+")"},distanceTo:function(t){return n.CRS.Earth.distance(this,n.latLng(t))},wrap:function(){return n.CRS.Earth.wrapLatLng(this)},toBounds:function(t){var e=180*t/40075017,i=e/Math.cos(Math.PI/180*this.lat);return n.latLngBounds([this.lat-e,this.lng-i],[this.lat+e,this.lng+i])},clone:function(){return new n.LatLng(this.lat,this.lng,this.alt)}},n.latLng=function(t,e,i){return t instanceof n.LatLng?t:n.Util.isArray(t)&&"object"!=typeof t[0]?3===t.length?new n.LatLng(t[0],t[1],t[2]):2===t.length?new n.LatLng(t[0],t[1]):null:void 0===t||null===t?t:"object"==typeof t&&"lat"in t?new n.LatLng(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===e?null:new n.LatLng(t,e,i)},n.LatLngBounds=function(t,e){if(t)for(var i=e?[t,e]:t,o=0,n=i.length;o<n;o++)this.extend(i[o])},n.LatLngBounds.prototype={extend:function(t){var e,i,o=this._southWest,r=this._northEast;if(t instanceof n.LatLng)e=t,i=t;else{if(!(t instanceof n.LatLngBounds))return t?this.extend(n.latLng(t)||n.latLngBounds(t)):this;if(e=t._southWest,i=t._northEast,!e||!i)return this}return o||r?(o.lat=Math.min(e.lat,o.lat),o.lng=Math.min(e.lng,o.lng),r.lat=Math.max(i.lat,r.lat),r.lng=Math.max(i.lng,r.lng)):(this._southWest=new n.LatLng(e.lat,e.lng),this._northEast=new n.LatLng(i.lat,i.lng)),this},pad:function(t){var e=this._southWest,i=this._northEast,o=Math.abs(e.lat-i.lat)*t,r=Math.abs(e.lng-i.lng)*t;return new n.LatLngBounds(new n.LatLng(e.lat-o,e.lng-r),new n.LatLng(i.lat+o,i.lng+r))},getCenter:function(){return new n.LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new n.LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new n.LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t="number"==typeof t[0]||t instanceof n.LatLng?n.latLng(t):n.latLngBounds(t);var e,i,o=this._southWest,r=this._northEast;return t instanceof n.LatLngBounds?(e=t.getSouthWest(),i=t.getNorthEast()):e=i=t,e.lat>=o.lat&&i.lat<=r.lat&&e.lng>=o.lng&&i.lng<=r.lng},intersects:function(t){t=n.latLngBounds(t);var e=this._southWest,i=this._northEast,o=t.getSouthWest(),r=t.getNorthEast(),s=r.lat>=e.lat&&o.lat<=i.lat,a=r.lng>=e.lng&&o.lng<=i.lng;return s&&a},overlaps:function(t){t=n.latLngBounds(t);var e=this._southWest,i=this._northEast,o=t.getSouthWest(),r=t.getNorthEast(),s=r.lat>e.lat&&o.lat<i.lat,a=r.lng>e.lng&&o.lng<i.lng;return s&&a},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t){return!!t&&(t=n.latLngBounds(t),this._southWest.equals(t.getSouthWest())&&this._northEast.equals(t.getNorthEast()))},isValid:function(){return!(!this._southWest||!this._northEast)}},n.latLngBounds=function(t,e){return t instanceof n.LatLngBounds?t:new n.LatLngBounds(t,e)},n.Projection={},n.Projection.LonLat={project:function(t){return new n.Point(t.lng,t.lat)},unproject:function(t){return new n.LatLng(t.y,t.x)},bounds:n.bounds([-180,-90],[180,90])},n.Projection.SphericalMercator={R:6378137,MAX_LATITUDE:85.0511287798,project:function(t){var e=Math.PI/180,i=this.MAX_LATITUDE,o=Math.max(Math.min(i,t.lat),-i),r=Math.sin(o*e);return new n.Point(this.R*t.lng*e,this.R*Math.log((1+r)/(1-r))/2)},unproject:function(t){var e=180/Math.PI;return new n.LatLng((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*e,t.x*e/this.R)},bounds:function(){var t=6378137*Math.PI;return n.bounds([-t,-t],[t,t])}()},n.CRS={latLngToPoint:function(t,e){var i=this.projection.project(t),o=this.scale(e);return this.transformation._transform(i,o)},pointToLatLng:function(t,e){var i=this.scale(e),o=this.transformation.untransform(t,i);return this.projection.unproject(o)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var e=this.projection.bounds,i=this.scale(t),o=this.transformation.transform(e.min,i),r=this.transformation.transform(e.max,i);return n.bounds(o,r)},infinite:!1,wrapLatLng:function(t){var e=this.wrapLng?n.Util.wrapNum(t.lng,this.wrapLng,!0):t.lng,i=this.wrapLat?n.Util.wrapNum(t.lat,this.wrapLat,!0):t.lat,o=t.alt;return n.latLng(i,e,o)}},n.CRS.Simple=n.extend({},n.CRS,{projection:n.Projection.LonLat,transformation:new n.Transformation(1,0,(-1),0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,e){var i=e.lng-t.lng,o=e.lat-t.lat;return Math.sqrt(i*i+o*o)},infinite:!0}),n.CRS.Earth=n.extend({},n.CRS,{wrapLng:[-180,180],R:6371e3,distance:function(t,e){var i=Math.PI/180,o=t.lat*i,n=e.lat*i,r=Math.sin(o)*Math.sin(n)+Math.cos(o)*Math.cos(n)*Math.cos((e.lng-t.lng)*i);return this.R*Math.acos(Math.min(r,1))}}),n.CRS.EPSG3857=n.extend({},n.CRS.Earth,{code:"EPSG:3857",projection:n.Projection.SphericalMercator,transformation:function(){var t=.5/(Math.PI*n.Projection.SphericalMercator.R);return new n.Transformation(t,.5,(-t),.5)}()}),n.CRS.EPSG900913=n.extend({},n.CRS.EPSG3857,{code:"EPSG:900913"}),n.CRS.EPSG4326=n.extend({},n.CRS.Earth,{code:"EPSG:4326",projection:n.Projection.LonLat,transformation:new n.Transformation(1/180,1,-1/180,.5)}),n.Map=n.Evented.extend({options:{crs:n.CRS.EPSG3857,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,e){e=n.setOptions(this,e),this._initContainer(t),this._initLayout(),this._onResize=n.bind(this._onResize,this),this._initEvents(),e.maxBounds&&this.setMaxBounds(e.maxBounds),void 0!==e.zoom&&(this._zoom=this._limitZoom(e.zoom)),e.center&&void 0!==e.zoom&&this.setView(n.latLng(e.center),e.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._addLayers(this.options.layers)},setView:function(t,e){return e=void 0===e?this.getZoom():e,this._resetView(n.latLng(t),e),this},setZoom:function(t,e){return this._loaded?this.setView(this.getCenter(),t,{zoom:e}):(this._zoom=t,this)},zoomIn:function(t,e){return t=t||(n.Browser.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+t,e)},zoomOut:function(t,e){return t=t||(n.Browser.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-t,e)},setZoomAround:function(t,e,i){var o=this.getZoomScale(e),r=this.getSize().divideBy(2),s=t instanceof n.Point?t:this.latLngToContainerPoint(t),a=s.subtract(r).multiplyBy(1-1/o),l=this.containerPointToLatLng(r.add(a));return this.setView(l,e,{zoom:i})},_getBoundsCenterZoom:function(t,e){e=e||{},t=t.getBounds?t.getBounds():n.latLngBounds(t);var i=n.point(e.paddingTopLeft||e.padding||[0,0]),o=n.point(e.paddingBottomRight||e.padding||[0,0]),r=this.getBoundsZoom(t,!1,i.add(o));r="number"==typeof e.maxZoom?Math.min(e.maxZoom,r):r;var s=o.subtract(i).divideBy(2),a=this.project(t.getSouthWest(),r),l=this.project(t.getNorthEast(),r),u=this.unproject(a.add(l).divideBy(2).add(s),r);return{center:u,zoom:r}},fitBounds:function(t,e){if(t=n.latLngBounds(t),!t.isValid())throw new Error("Bounds are not valid.");var i=this._getBoundsCenterZoom(t,e);return this.setView(i.center,i.zoom,e)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,e){return this.setView(t,this._zoom,{pan:e})},panBy:function(t){return this.fire("movestart"),this._rawPanBy(n.point(t)),this.fire("move"),this.fire("moveend")},setMaxBounds:function(t){return t=n.latLngBounds(t),t.isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){return this.options.minZoom=t,this._loaded&&this.getZoom()<this.options.minZoom?this.setZoom(t):this},setMaxZoom:function(t){return this.options.maxZoom=t,this._loaded&&this.getZoom()>this.options.maxZoom?this.setZoom(t):this},panInsideBounds:function(t,e){this._enforcingBounds=!0;var i=this.getCenter(),o=this._limitCenter(i,this._zoom,n.latLngBounds(t));return i.equals(o)||this.panTo(o,e),this._enforcingBounds=!1,this},invalidateSize:function(t){if(!this._loaded)return this;t=n.extend({animate:!1,pan:!0},t===!0?{animate:!0}:t);var e=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var i=this.getSize(),o=e.divideBy(2).round(),r=i.divideBy(2).round(),s=o.subtract(r);return s.x||s.y?(t.animate&&t.pan?this.panBy(s):(t.pan&&this._rawPanBy(s),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(n.bind(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:e,newSize:i})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},addHandler:function(t,e){if(!e)return this;var i=this[t]=new e(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}n.DomUtil.remove(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this._loaded&&this.fire("unload");for(var e in this._layers)this._layers[e].remove();return this},createPane:function(t,e){var i="leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),o=n.DomUtil.create("div",i,e||this._mapPane);return t&&(this._panes[t]=o),o},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds(),e=this.unproject(t.getBottomLeft()),i=this.unproject(t.getTopRight());return new n.LatLngBounds(e,i)},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,e,i){t=n.latLngBounds(t),i=n.point(i||[0,0]);var o=this.getZoom()||0,r=this.getMinZoom(),s=this.getMaxZoom(),a=t.getNorthWest(),l=t.getSouthEast(),u=this.getSize().subtract(i),c=this.project(l,o).subtract(this.project(a,o)),h=n.Browser.any3d?this.options.zoomSnap:1,d=Math.min(u.x/c.x,u.y/c.y);return o=this.getScaleZoom(d,o),h&&(o=Math.round(o/(h/100))*(h/100),o=e?Math.ceil(o/h)*h:Math.floor(o/h)*h),Math.max(r,Math.min(s,o))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new n.Point(this._container.clientWidth,this._container.clientHeight),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,e){var i=this._getTopLeftPoint(t,e);return new n.Bounds(i,i.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,e){var i=this.options.crs;return e=void 0===e?this._zoom:e,i.scale(t)/i.scale(e)},getScaleZoom:function(t,e){var i=this.options.crs;e=void 0===e?this._zoom:e;var o=i.zoom(t*i.scale(e));return isNaN(o)?1/0:o},project:function(t,e){return e=void 0===e?this._zoom:e,this.options.crs.latLngToPoint(n.latLng(t),e)},unproject:function(t,e){return e=void 0===e?this._zoom:e,this.options.crs.pointToLatLng(n.point(t),e)},layerPointToLatLng:function(t){var e=n.point(t).add(this.getPixelOrigin());return this.unproject(e)},latLngToLayerPoint:function(t){var e=this.project(n.latLng(t))._round();return e._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(n.latLng(t))},distance:function(t,e){return this.options.crs.distance(n.latLng(t),n.latLng(e))},containerPointToLayerPoint:function(t){return n.point(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return n.point(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var e=this.containerPointToLayerPoint(n.point(t));return this.layerPointToLatLng(e)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(n.latLng(t)))},mouseEventToContainerPoint:function(t){return n.DomEvent.getMousePosition(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var e=this._container=n.DomUtil.get(t);if(!e)throw new Error("Map container not found.");if(e._leaflet_id)throw new Error("Map container is already initialized.");n.DomEvent.addListener(e,"scroll",this._onScroll,this),this._containerId=n.Util.stamp(e)},_initLayout:function(){var t=this._container;this._fadeAnimated=this.options.fadeAnimation&&n.Browser.any3d,n.DomUtil.addClass(t,"leaflet-container"+(n.Browser.touch?" leaflet-touch":"")+(n.Browser.retina?" leaflet-retina":"")+(n.Browser.ielt9?" leaflet-oldie":"")+(n.Browser.safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var e=n.DomUtil.getStyle(t,"position");"absolute"!==e&&"relative"!==e&&"fixed"!==e&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),n.DomUtil.setPosition(this._mapPane,new n.Point(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(n.DomUtil.addClass(t.markerPane,"leaflet-zoom-hide"),n.DomUtil.addClass(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,e){n.DomUtil.setPosition(this._mapPane,new n.Point(0,0));var i=!this._loaded;this._loaded=!0,e=this._limitZoom(e),this.fire("viewprereset");var o=this._zoom!==e;this._moveStart(o)._move(t,e)._moveEnd(o),this.fire("viewreset"),i&&this.fire("load")},_moveStart:function(t){return t&&this.fire("zoomstart"),this.fire("movestart")},_move:function(t,e,i){void 0===e&&(e=this._zoom);var o=this._zoom!==e;return this._zoom=e,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),(o||i&&i.pinch)&&this.fire("zoom",i),this.fire("move",i)},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return n.Util.cancelAnimFrame(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){n.DomUtil.setPosition(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){if(n.DomEvent){this._targets={},this._targets[n.stamp(this._container)]=this;var e=t?"off":"on";n.DomEvent[e](this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&n.DomEvent[e](window,"resize",this._onResize,this),n.Browser.any3d&&this.options.transform3DLimit&&this[e]("moveend",this._onMoveEnd)}},_onResize:function(){n.Util.cancelAnimFrame(this._resizeRequest),this._resizeRequest=n.Util.requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,e){for(var i,o=[],r="mouseout"===e||"mouseover"===e,s=t.target||t.srcElement,a=!1;s;){if(i=this._targets[n.stamp(s)],i&&("click"===e||"preclick"===e)&&!t._simulated&&this._draggableMoved(i)){a=!0;break}if(i&&i.listens(e,!0)){if(r&&!n.DomEvent._isExternalTarget(s,t))break;if(o.push(i),r)break}if(s===this._container)break;s=s.parentNode}return o.length||a||r||!n.DomEvent._isExternalTarget(s,t)||(o=[this]),o},_handleDOMEvent:function(t){if(this._loaded&&!n.DomEvent._skipped(t)){var e="keypress"===t.type&&13===t.keyCode?"click":t.type;"mousedown"===e&&n.DomUtil.preventOutline(t.target||t.srcElement),this._fireDOMEvent(t,e)}},_fireDOMEvent:function(t,e,i){if("click"===t.type){var o=n.Util.extend({},t);o.type="preclick",this._fireDOMEvent(o,o.type,i)}if(!t._stopped&&(i=(i||[]).concat(this._findEventTargets(t,e)),i.length)){var r=i[0];"contextmenu"===e&&r.listens(e,!0)&&n.DomEvent.preventDefault(t);var s={originalEvent:t};if("keypress"!==t.type){var a=r instanceof n.Marker;s.containerPoint=a?this.latLngToContainerPoint(r.getLatLng()):this.mouseEventToContainerPoint(t),s.layerPoint=this.containerPointToLayerPoint(s.containerPoint),s.latlng=a?r.getLatLng():this.layerPointToLatLng(s.layerPoint)}for(var l=0;l<i.length;l++)if(i[l].fire(e,s,!0),s.originalEvent._stopped||i[l].options.nonBubblingEvents&&n.Util.indexOf(i[l].options.nonBubblingEvents,e)!==-1)return}},_draggableMoved:function(t){return t=t.dragging&&t.dragging.enabled()?t:this,t.dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,e=this._handlers.length;t<e;t++)this._handlers[t].disable()},whenReady:function(t,e){return this._loaded?t.call(e||this,{target:this}):this.on("load",t,e),this},_getMapPanePos:function(){return n.DomUtil.getPosition(this._mapPane)||new n.Point(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,e){var i=t&&void 0!==e?this._getNewPixelOrigin(t,e):this.getPixelOrigin();return i.subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,e){var i=this.getSize()._divideBy(2);return this.project(t,e)._subtract(i)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,e,i){var o=this._getNewPixelOrigin(i,e);return this.project(t,e)._subtract(o)},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,e,i){if(!i)return t;var o=this.project(t,e),r=this.getSize().divideBy(2),s=new n.Bounds(o.subtract(r),o.add(r)),a=this._getBoundsOffset(s,i,e);return a.round().equals([0,0])?t:this.unproject(o.add(a),e)},_limitOffset:function(t,e){if(!e)return t;var i=this.getPixelBounds(),o=new n.Bounds(i.min.add(t),i.max.add(t));return t.add(this._getBoundsOffset(o,e))},_getBoundsOffset:function(t,e,i){var o=n.bounds(this.project(e.getNorthEast(),i),this.project(e.getSouthWest(),i)),r=o.min.subtract(t.min),s=o.max.subtract(t.max),a=this._rebound(r.x,-s.x),l=this._rebound(r.y,-s.y);return new n.Point(a,l)},_rebound:function(t,e){return t+e>0?Math.round(t-e)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(e))},_limitZoom:function(t){var e=this.getMinZoom(),i=this.getMaxZoom(),o=n.Browser.any3d?this.options.zoomSnap:1;return o&&(t=Math.round(t/o)*o),Math.max(e,Math.min(i,t))}}),n.map=function(t,e){return new n.Map(t,e)},n.Layer=n.Evented.extend({options:{pane:"overlayPane",nonBubblingEvents:[]},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[n.stamp(t)]=this,this},removeInteractiveTarget:function(t){return delete this._map._targets[n.stamp(t)],this},_layerAdd:function(t){var e=t.target;if(e.hasLayer(this)){if(this._map=e,this._zoomAnimated=e._zoomAnimated,this.getEvents){var i=this.getEvents();e.on(i,this),this.once("remove",function(){e.off(i,this)},this)}this.onAdd(e),this.getAttribution&&this._map.attributionControl&&this._map.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),e.fire("layeradd",{layer:this})}}}),n.Map.include({addLayer:function(t){var e=n.stamp(t);return this._layers[e]?this:(this._layers[e]=t,t._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t),this)},removeLayer:function(t){var e=n.stamp(t);return this._layers[e]?(this._loaded&&t.onRemove(this),t.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(t.getAttribution()),delete this._layers[e],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null,this):this},hasLayer:function(t){return!!t&&n.stamp(t)in this._layers},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},_addLayers:function(t){t=t?n.Util.isArray(t)?t:[t]:[];for(var e=0,i=t.length;e<i;e++)this.addLayer(t[e])},_addZoomLimit:function(t){!isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[n.stamp(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){var e=n.stamp(t);this._zoomBoundLayers[e]&&(delete this._zoomBoundLayers[e],this._updateZoomLevels())},_updateZoomLevels:function(){var t=1/0,e=-(1/0),i=this._getZoomSpan();for(var o in this._zoomBoundLayers){var n=this._zoomBoundLayers[o].options;t=void 0===n.minZoom?t:Math.min(t,n.minZoom),e=void 0===n.maxZoom?e:Math.max(e,n.maxZoom)}this._layersMaxZoom=e===-(1/0)?void 0:e,this._layersMinZoom=t===1/0?void 0:t,i!==this._getZoomSpan()&&this.fire("zoomlevelschange")}}),n.Projection.Mercator={R:6378137,R_MINOR:6356752.314245179,bounds:n.bounds([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var e=Math.PI/180,i=this.R,o=t.lat*e,r=this.R_MINOR/i,s=Math.sqrt(1-r*r),a=s*Math.sin(o),l=Math.tan(Math.PI/4-o/2)/Math.pow((1-a)/(1+a),s/2);return o=-i*Math.log(Math.max(l,1e-10)),new n.Point(t.lng*e*i,o)},unproject:function(t){for(var e,i=180/Math.PI,o=this.R,r=this.R_MINOR/o,s=Math.sqrt(1-r*r),a=Math.exp(-t.y/o),l=Math.PI/2-2*Math.atan(a),u=0,c=.1;u<15&&Math.abs(c)>1e-7;u++)e=s*Math.sin(l),e=Math.pow((1-e)/(1+e),s/2),c=Math.PI/2-2*Math.atan(a*e)-l,l+=c;return new n.LatLng(l*i,t.x*i/o)}},n.CRS.EPSG3395=n.extend({},n.CRS.Earth,{code:"EPSG:3395",projection:n.Projection.Mercator,transformation:function(){var t=.5/(Math.PI*n.Projection.Mercator.R);return new n.Transformation(t,.5,(-t),.5)}()}),n.GridLayer=n.Layer.extend({options:{tileSize:256,opacity:1,updateWhenIdle:n.Browser.mobile,updateWhenZooming:!0,updateInterval:200,attribution:null,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){n.setOptions(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),n.DomUtil.remove(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=null},bringToFront:function(){return this._map&&(n.DomUtil.toFront(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(n.DomUtil.toBack(this._container),this._setAutoZIndex(Math.min)),this},getAttribution:function(){return this.options.attribution},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=n.Util.throttle(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof n.Point?t:new n.Point(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var e,i=this.getPane().children,o=-t(-(1/0),1/0),n=0,r=i.length;n<r;n++)e=i[n].style.zIndex,
	i[n]!==this._container&&e&&(o=t(o,+e));isFinite(o)&&(this.options.zIndex=o+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!n.Browser.ielt9){n.DomUtil.setOpacity(this._container,this.options.opacity);var t=+new Date,e=!1,i=!1;for(var o in this._tiles){var r=this._tiles[o];if(r.current&&r.loaded){var s=Math.min(1,(t-r.loaded)/200);n.DomUtil.setOpacity(r.el,s),s<1?e=!0:(r.active&&(i=!0),r.active=!0)}}i&&!this._noPrune&&this._pruneTiles(),e&&(n.Util.cancelAnimFrame(this._fadeFrame),this._fadeFrame=n.Util.requestAnimFrame(this._updateOpacity,this))}},_initContainer:function(){this._container||(this._container=n.DomUtil.create("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,e=this.options.maxZoom;if(void 0!==t){for(var i in this._levels)this._levels[i].el.children.length||i===t?this._levels[i].el.style.zIndex=e-Math.abs(t-i):(n.DomUtil.remove(this._levels[i].el),this._removeTilesAtZoom(i),delete this._levels[i]);var o=this._levels[t],r=this._map;return o||(o=this._levels[t]={},o.el=n.DomUtil.create("div","leaflet-tile-container leaflet-zoom-animated",this._container),o.el.style.zIndex=e,o.origin=r.project(r.unproject(r.getPixelOrigin()),t).round(),o.zoom=t,this._setZoomTransform(o,r.getCenter(),r.getZoom()),n.Util.falseFn(o.el.offsetWidth)),this._level=o,o}},_pruneTiles:function(){if(this._map){var t,e,i=this._map.getZoom();if(i>this.options.maxZoom||i<this.options.minZoom)return void this._removeAllTiles();for(t in this._tiles)e=this._tiles[t],e.retain=e.current;for(t in this._tiles)if(e=this._tiles[t],e.current&&!e.active){var o=e.coords;this._retainParent(o.x,o.y,o.z,o.z-5)||this._retainChildren(o.x,o.y,o.z,o.z+2)}for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}},_removeTilesAtZoom:function(t){for(var e in this._tiles)this._tiles[e].coords.z===t&&this._removeTile(e)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)n.DomUtil.remove(this._levels[t].el),delete this._levels[t];this._removeAllTiles(),this._tileZoom=null},_retainParent:function(t,e,i,o){var r=Math.floor(t/2),s=Math.floor(e/2),a=i-1,l=new n.Point((+r),(+s));l.z=+a;var u=this._tileCoordsToKey(l),c=this._tiles[u];return c&&c.active?(c.retain=!0,!0):(c&&c.loaded&&(c.retain=!0),a>o&&this._retainParent(r,s,a,o))},_retainChildren:function(t,e,i,o){for(var r=2*t;r<2*t+2;r++)for(var s=2*e;s<2*e+2;s++){var a=new n.Point(r,s);a.z=i+1;var l=this._tileCoordsToKey(a),u=this._tiles[l];u&&u.active?u.retain=!0:(u&&u.loaded&&(u.retain=!0),i+1<o&&this._retainChildren(r,s,i+1,o))}},_resetView:function(t){var e=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),e,e)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_setView:function(t,e,i,o){var n=Math.round(e);(void 0!==this.options.maxZoom&&n>this.options.maxZoom||void 0!==this.options.minZoom&&n<this.options.minZoom)&&(n=void 0);var r=this.options.updateWhenZooming&&n!==this._tileZoom;o&&!r||(this._tileZoom=n,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==n&&this._update(t),i||this._pruneTiles(),this._noPrune=!!i),this._setZoomTransforms(t,e)},_setZoomTransforms:function(t,e){for(var i in this._levels)this._setZoomTransform(this._levels[i],t,e)},_setZoomTransform:function(t,e,i){var o=this._map.getZoomScale(i,t.zoom),r=t.origin.multiplyBy(o).subtract(this._map._getNewPixelOrigin(e,i)).round();n.Browser.any3d?n.DomUtil.setTransform(t.el,r,o):n.DomUtil.setPosition(t.el,r)},_resetGrid:function(){var t=this._map,e=t.options.crs,i=this._tileSize=this.getTileSize(),o=this._tileZoom,n=this._map.getPixelWorldBounds(this._tileZoom);n&&(this._globalTileRange=this._pxBoundsToTileRange(n)),this._wrapX=e.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,e.wrapLng[0]],o).x/i.x),Math.ceil(t.project([0,e.wrapLng[1]],o).x/i.y)],this._wrapY=e.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([e.wrapLat[0],0],o).y/i.x),Math.ceil(t.project([e.wrapLat[1],0],o).y/i.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var e=this._map,i=e._animatingZoom?Math.max(e._animateToZoom,e.getZoom()):e.getZoom(),o=e.getZoomScale(i,this._tileZoom),r=e.project(t,this._tileZoom).floor(),s=e.getSize().divideBy(2*o);return new n.Bounds(r.subtract(s),r.add(s))},_update:function(t){var e=this._map;if(e){var i=e.getZoom();if(void 0===t&&(t=e.getCenter()),void 0!==this._tileZoom){var o=this._getTiledPixelBounds(t),r=this._pxBoundsToTileRange(o),s=r.getCenter(),a=[],l=this.options.keepBuffer,u=new n.Bounds(r.getBottomLeft().subtract([l,-l]),r.getTopRight().add([l,-l]));for(var c in this._tiles){var h=this._tiles[c].coords;h.z===this._tileZoom&&u.contains(n.point(h.x,h.y))||(this._tiles[c].current=!1)}if(Math.abs(i-this._tileZoom)>1)return void this._setView(t,i);for(var d=r.min.y;d<=r.max.y;d++)for(var p=r.min.x;p<=r.max.x;p++){var _=new n.Point(p,d);if(_.z=this._tileZoom,this._isValidTile(_)){var m=this._tiles[this._tileCoordsToKey(_)];m?m.current=!0:a.push(_)}}if(a.sort(function(t,e){return t.distanceTo(s)-e.distanceTo(s)}),0!==a.length){this._loading||(this._loading=!0,this.fire("loading"));var f=document.createDocumentFragment();for(p=0;p<a.length;p++)this._addTile(a[p],f);this._level.el.appendChild(f)}}}},_isValidTile:function(t){var e=this._map.options.crs;if(!e.infinite){var i=this._globalTileRange;if(!e.wrapLng&&(t.x<i.min.x||t.x>i.max.x)||!e.wrapLat&&(t.y<i.min.y||t.y>i.max.y))return!1}if(!this.options.bounds)return!0;var o=this._tileCoordsToBounds(t);return n.latLngBounds(this.options.bounds).overlaps(o)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToBounds:function(t){var e=this._map,i=this.getTileSize(),o=t.scaleBy(i),r=o.add(i),s=e.unproject(o,t.z),a=e.unproject(r,t.z);return this.options.noWrap||(s=e.wrapLatLng(s),a=e.wrapLatLng(a)),new n.LatLngBounds(s,a)},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var e=t.split(":"),i=new n.Point((+e[0]),(+e[1]));return i.z=+e[2],i},_removeTile:function(t){var e=this._tiles[t];e&&(n.DomUtil.remove(e.el),delete this._tiles[t],this.fire("tileunload",{tile:e.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){n.DomUtil.addClass(t,"leaflet-tile");var e=this.getTileSize();t.style.width=e.x+"px",t.style.height=e.y+"px",t.onselectstart=n.Util.falseFn,t.onmousemove=n.Util.falseFn,n.Browser.ielt9&&this.options.opacity<1&&n.DomUtil.setOpacity(t,this.options.opacity),n.Browser.android&&!n.Browser.android23&&(t.style.WebkitBackfaceVisibility="hidden")},_addTile:function(t,e){var i=this._getTilePos(t),o=this._tileCoordsToKey(t),r=this.createTile(this._wrapCoords(t),n.bind(this._tileReady,this,t));this._initTile(r),this.createTile.length<2&&n.Util.requestAnimFrame(n.bind(this._tileReady,this,t,null,r)),n.DomUtil.setPosition(r,i),this._tiles[o]={el:r,coords:t,current:!0},e.appendChild(r),this.fire("tileloadstart",{tile:r,coords:t})},_tileReady:function(t,e,i){if(this._map){e&&this.fire("tileerror",{error:e,tile:i,coords:t});var o=this._tileCoordsToKey(t);i=this._tiles[o],i&&(i.loaded=+new Date,this._map._fadeAnimated?(n.DomUtil.setOpacity(i.el,0),n.Util.cancelAnimFrame(this._fadeFrame),this._fadeFrame=n.Util.requestAnimFrame(this._updateOpacity,this)):(i.active=!0,this._pruneTiles()),e||(n.DomUtil.addClass(i.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:i.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),n.Browser.ielt9||!this._map._fadeAnimated?n.Util.requestAnimFrame(this._pruneTiles,this):setTimeout(n.bind(this._pruneTiles,this),250)))}},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var e=new n.Point(this._wrapX?n.Util.wrapNum(t.x,this._wrapX):t.x,this._wrapY?n.Util.wrapNum(t.y,this._wrapY):t.y);return e.z=t.z,e},_pxBoundsToTileRange:function(t){var e=this.getTileSize();return new n.Bounds(t.min.unscaleBy(e).floor(),t.max.unscaleBy(e).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}}),n.gridLayer=function(t){return new n.GridLayer(t)},n.TileLayer=n.GridLayer.extend({options:{minZoom:0,maxZoom:18,maxNativeZoom:null,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(t,e){this._url=t,e=n.setOptions(this,e),e.detectRetina&&n.Browser.retina&&e.maxZoom>0&&(e.tileSize=Math.floor(e.tileSize/2),e.zoomReverse?(e.zoomOffset--,e.minZoom++):(e.zoomOffset++,e.maxZoom--),e.minZoom=Math.max(0,e.minZoom)),"string"==typeof e.subdomains&&(e.subdomains=e.subdomains.split("")),n.Browser.android||this.on("tileunload",this._onTileRemove)},setUrl:function(t,e){return this._url=t,e||this.redraw(),this},createTile:function(t,e){var i=document.createElement("img");return n.DomEvent.on(i,"load",n.bind(this._tileOnLoad,this,e,i)),n.DomEvent.on(i,"error",n.bind(this._tileOnError,this,e,i)),this.options.crossOrigin&&(i.crossOrigin=""),i.alt="",i.src=this.getTileUrl(t),i},getTileUrl:function(t){var e={r:n.Browser.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var i=this._globalTileRange.max.y-t.y;this.options.tms&&(e.y=i),e["-y"]=i}return n.Util.template(this._url,n.extend(e,this.options))},_tileOnLoad:function(t,e){n.Browser.ielt9?setTimeout(n.bind(t,this,null,e),0):t(null,e)},_tileOnError:function(t,e,i){var o=this.options.errorTileUrl;o&&(e.src=o),t(i,e)},getTileSize:function(){var t=this._map,e=n.GridLayer.prototype.getTileSize.call(this),i=this._tileZoom+this.options.zoomOffset,o=this.options.maxNativeZoom;return null!==o&&i>o?e.divideBy(t.getZoomScale(o,i)).round():e},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this.options,e=this._tileZoom;return t.zoomReverse&&(e=t.maxZoom-e),e+=t.zoomOffset,null!==t.maxNativeZoom?Math.min(e,t.maxNativeZoom):e},_getSubdomain:function(t){var e=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[e]},_abortLoading:function(){var t,e;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&(e=this._tiles[t].el,e.onload=n.Util.falseFn,e.onerror=n.Util.falseFn,e.complete||(e.src=n.Util.emptyImageUrl,n.DomUtil.remove(e)))}}),n.tileLayer=function(t,e){return new n.TileLayer(t,e)},n.TileLayer.WMS=n.TileLayer.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,e){this._url=t;var i=n.extend({},this.defaultWmsParams);for(var o in e)o in this.options||(i[o]=e[o]);e=n.setOptions(this,e),i.width=i.height=e.tileSize*(e.detectRetina&&n.Browser.retina?2:1),this.wmsParams=i},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var e=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[e]=this._crs.code,n.TileLayer.prototype.onAdd.call(this,t)},getTileUrl:function(t){var e=this._tileCoordsToBounds(t),i=this._crs.project(e.getNorthWest()),o=this._crs.project(e.getSouthEast()),r=(this._wmsVersion>=1.3&&this._crs===n.CRS.EPSG4326?[o.y,i.x,i.y,o.x]:[i.x,o.y,o.x,i.y]).join(","),s=n.TileLayer.prototype.getTileUrl.call(this,t);return s+n.Util.getParamString(this.wmsParams,s,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+r},setParams:function(t,e){return n.extend(this.wmsParams,t),e||this.redraw(),this}}),n.tileLayer.wms=function(t,e){return new n.TileLayer.WMS(t,e)},n.ImageOverlay=n.Layer.extend({options:{opacity:1,alt:"",interactive:!1,attribution:null,crossOrigin:!1},initialize:function(t,e,i){this._url=t,this._bounds=n.latLngBounds(e),n.setOptions(this,i)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(n.DomUtil.addClass(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){n.DomUtil.remove(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&n.DomUtil.toFront(this._image),this},bringToBack:function(){return this._map&&n.DomUtil.toBack(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=t,this._map&&this._reset(),this},getAttribution:function(){return this.options.attribution},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t=this._image=n.DomUtil.create("img","leaflet-image-layer "+(this._zoomAnimated?"leaflet-zoom-animated":""));t.onselectstart=n.Util.falseFn,t.onmousemove=n.Util.falseFn,t.onload=n.bind(this.fire,this,"load"),this.options.crossOrigin&&(t.crossOrigin=""),t.src=this._url,t.alt=this.options.alt},_animateZoom:function(t){var e=this._map.getZoomScale(t.zoom),i=this._map._latLngToNewLayerPoint(this._bounds.getNorthWest(),t.zoom,t.center);n.DomUtil.setTransform(this._image,i,e)},_reset:function(){var t=this._image,e=new n.Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),i=e.getSize();n.DomUtil.setPosition(t,e.min),t.style.width=i.x+"px",t.style.height=i.y+"px"},_updateOpacity:function(){n.DomUtil.setOpacity(this._image,this.options.opacity)}}),n.imageOverlay=function(t,e,i){return new n.ImageOverlay(t,e,i)},n.Icon=n.Class.extend({initialize:function(t){n.setOptions(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,e){var i=this._getIconUrl(t);if(!i){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var o=this._createImg(i,e&&"IMG"===e.tagName?e:null);return this._setIconStyles(o,t),o},_setIconStyles:function(t,e){var i=this.options,o=i[e+"Size"];"number"==typeof o&&(o=[o,o]);var r=n.point(o),s=n.point("shadow"===e&&i.shadowAnchor||i.iconAnchor||r&&r.divideBy(2,!0));t.className="leaflet-marker-"+e+" "+(i.className||""),s&&(t.style.marginLeft=-s.x+"px",t.style.marginTop=-s.y+"px"),r&&(t.style.width=r.x+"px",t.style.height=r.y+"px")},_createImg:function(t,e){return e=e||document.createElement("img"),e.src=t,e},_getIconUrl:function(t){return n.Browser.retina&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}}),n.icon=function(t){return new n.Icon(t)},n.Icon.Default=n.Icon.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return n.Icon.Default.imagePath||(n.Icon.Default.imagePath=this._detectIconPath()),(this.options.imagePath||n.Icon.Default.imagePath)+n.Icon.prototype._getIconUrl.call(this,t)},_detectIconPath:function(){var t=n.DomUtil.create("div","leaflet-default-icon-path",document.body),e=n.DomUtil.getStyle(t,"background-image")||n.DomUtil.getStyle(t,"backgroundImage");return document.body.removeChild(t),0===e.indexOf("url")?e.replace(/^url\([\"\']?/,"").replace(/marker-icon\.png[\"\']?\)$/,""):""}}),n.Marker=n.Layer.extend({options:{icon:new n.Icon.Default,interactive:!0,draggable:!1,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",nonBubblingEvents:["click","dblclick","mouseover","mouseout","contextmenu"]},initialize:function(t,e){n.setOptions(this,e),this._latlng=n.latLng(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var e=this._latlng;return this._latlng=n.latLng(t),this.update(),this.fire("move",{oldLatLng:e,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon){var t=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(t)}return this},_initIcon:function(){var t=this.options,e="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),i=t.icon.createIcon(this._icon),o=!1;i!==this._icon&&(this._icon&&this._removeIcon(),o=!0,t.title&&(i.title=t.title),t.alt&&(i.alt=t.alt)),n.DomUtil.addClass(i,e),t.keyboard&&(i.tabIndex="0"),this._icon=i,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var r=t.icon.createShadow(this._shadow),s=!1;r!==this._shadow&&(this._removeShadow(),s=!0),r&&n.DomUtil.addClass(r,e),this._shadow=r,t.opacity<1&&this._updateOpacity(),o&&this.getPane().appendChild(this._icon),this._initInteraction(),r&&s&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),n.DomUtil.remove(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&n.DomUtil.remove(this._shadow),this._shadow=null},_setPos:function(t){n.DomUtil.setPosition(this._icon,t),this._shadow&&n.DomUtil.setPosition(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(e)},_initInteraction:function(){if(this.options.interactive&&(n.DomUtil.addClass(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),n.Handler.MarkerDrag)){var t=this.options.draggable;this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new n.Handler.MarkerDrag(this),t&&this.dragging.enable()}},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;n.DomUtil.setOpacity(this._icon,t),this._shadow&&n.DomUtil.setOpacity(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)}}),n.marker=function(t,e){return new n.Marker(t,e)},n.DivIcon=n.Icon.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var e=t&&"DIV"===t.tagName?t:document.createElement("div"),i=this.options;if(e.innerHTML=i.html!==!1?i.html:"",i.bgPos){var o=n.point(i.bgPos);e.style.backgroundPosition=-o.x+"px "+-o.y+"px"}return this._setIconStyles(e,"icon"),e},createShadow:function(){return null}}),n.divIcon=function(t){return new n.DivIcon(t)},n.DivOverlay=n.Layer.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(t,e){n.setOptions(this,t),this._source=e},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&n.DomUtil.setOpacity(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&n.DomUtil.setOpacity(this._container,1),this.bringToFront()},onRemove:function(t){t._fadeAnimated?(n.DomUtil.setOpacity(this._container,0),this._removeTimeout=setTimeout(n.bind(n.DomUtil.remove,n.DomUtil,this._container),200)):n.DomUtil.remove(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=n.latLng(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&n.DomUtil.toFront(this._container),this},bringToBack:function(){return this._map&&n.DomUtil.toBack(this._container),this},_updateContent:function(){if(this._content){var t=this._contentNode,e="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof e)t.innerHTML=e;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(e)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),e=n.point(this.options.offset),i=this._getAnchor();this._zoomAnimated?n.DomUtil.setPosition(this._container,t.add(i)):e=e.add(t).add(i);var o=this._containerBottom=-e.y,r=this._containerLeft=-Math.round(this._containerWidth/2)+e.x;this._container.style.bottom=o+"px",this._container.style.left=r+"px"}},_getAnchor:function(){return[0,0]}}),n.Popup=n.DivOverlay.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,className:""},openOn:function(t){return t.openPopup(this),this},onAdd:function(t){n.DivOverlay.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof n.Path||this._source.on("preclick",n.DomEvent.stopPropagation))},onRemove:function(t){n.DivOverlay.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof n.Path||this._source.off("preclick",n.DomEvent.stopPropagation))},getEvents:function(){var t=n.DivOverlay.prototype.getEvents.call(this);return("closeOnClick"in this.options?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t="leaflet-popup",e=this._container=n.DomUtil.create("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated");if(this.options.closeButton){var i=this._closeButton=n.DomUtil.create("a",t+"-close-button",e);i.href="#close",i.innerHTML="&#215;",n.DomEvent.on(i,"click",this._onCloseButtonClick,this)}var o=this._wrapper=n.DomUtil.create("div",t+"-content-wrapper",e);this._contentNode=n.DomUtil.create("div",t+"-content",o),n.DomEvent.disableClickPropagation(o).disableScrollPropagation(this._contentNode).on(o,"contextmenu",n.DomEvent.stopPropagation),this._tipContainer=n.DomUtil.create("div",t+"-tip-container",e),this._tip=n.DomUtil.create("div",t+"-tip",this._tipContainer)},_updateLayout:function(){var t=this._contentNode,e=t.style;e.width="",e.whiteSpace="nowrap";var i=t.offsetWidth;i=Math.min(i,this.options.maxWidth),i=Math.max(i,this.options.minWidth),e.width=i+1+"px",e.whiteSpace="",e.height="";var o=t.offsetHeight,r=this.options.maxHeight,s="leaflet-popup-scrolled";r&&o>r?(e.height=r+"px",n.DomUtil.addClass(t,s)):n.DomUtil.removeClass(t,s),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),i=this._getAnchor();n.DomUtil.setPosition(this._container,e.add(i))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var t=this._map,e=parseInt(n.DomUtil.getStyle(this._container,"marginBottom"),10)||0,i=this._container.offsetHeight+e,o=this._containerWidth,r=new n.Point(this._containerLeft,-i-this._containerBottom);r._add(n.DomUtil.getPosition(this._container));var s=t.layerPointToContainerPoint(r),a=n.point(this.options.autoPanPadding),l=n.point(this.options.autoPanPaddingTopLeft||a),u=n.point(this.options.autoPanPaddingBottomRight||a),c=t.getSize(),h=0,d=0;s.x+o+u.x>c.x&&(h=s.x+o-c.x+u.x),s.x-h-l.x<0&&(h=s.x-l.x),s.y+i+u.y>c.y&&(d=s.y+i-c.y+u.y),s.y-d-l.y<0&&(d=s.y-l.y),(h||d)&&t.fire("autopanstart").panBy([h,d])}},_onCloseButtonClick:function(t){this._close(),n.DomEvent.stop(t)},_getAnchor:function(){return n.point(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}}),n.popup=function(t,e){return new n.Popup(t,e)},n.Map.mergeOptions({closePopupOnClick:!0}),n.Map.include({openPopup:function(t,e,i){return t instanceof n.Popup||(t=new n.Popup(i).setContent(t)),e&&t.setLatLng(e),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&this.removeLayer(t),this}}),n.Layer.include({bindPopup:function(t,e){return t instanceof n.Popup?(n.setOptions(t,e),this._popup=t,t._source=this):(this._popup&&!e||(this._popup=new n.Popup(e,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on({click:this._openPopup,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t,e){if(t instanceof n.Layer||(e=t,t=this),t instanceof n.FeatureGroup)for(var i in this._layers){t=this._layers[i];break}return e||(e=t.getCenter?t.getCenter():t.getLatLng()),this._popup&&this._map&&(this._popup._source=t,this._popup.update(),this._map.openPopup(this._popup,e)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(t){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(t)),this},isPopupOpen:function(){return this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var e=t.layer||t.target;if(this._popup&&this._map)return n.DomEvent.stop(t),e instanceof n.Path?void this.openPopup(t.layer||t.target,t.latlng):void(this._map.hasLayer(this._popup)&&this._popup._source===e?this.closePopup():this.openPopup(e,t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)}}),n.Marker.include({_getPopupAnchor:function(){return this.options.icon.options.popupAnchor||[0,0]}}),n.Tooltip=n.DivOverlay.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(t){n.DivOverlay.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(t){n.DivOverlay.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var t=n.DivOverlay.prototype.getEvents.call(this);return n.Browser.touch&&!this.options.permanent&&(t.preclick=this._close),t},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var t="leaflet-tooltip",e=t+" "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=n.DomUtil.create("div",e)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var e=this._map,i=this._container,o=e.latLngToContainerPoint(e.getCenter()),r=e.layerPointToContainerPoint(t),s=this.options.direction,a=i.offsetWidth,l=i.offsetHeight,u=n.point(this.options.offset),c=this._getAnchor();"top"===s?t=t.add(n.point(-a/2+u.x,-l+u.y+c.y)):"bottom"===s?t=t.subtract(n.point(a/2-u.x,-u.y)):"center"===s?t=t.subtract(n.point(a/2+u.x,l/2-c.y+u.y)):"right"===s||"auto"===s&&r.x<o.x?(s="right",t=t.add([u.x+c.x,c.y-l/2+u.y])):(s="left",t=t.subtract(n.point(a+c.x-u.x,l/2-c.y-u.y))),n.DomUtil.removeClass(i,"leaflet-tooltip-right"),n.DomUtil.removeClass(i,"leaflet-tooltip-left"),n.DomUtil.removeClass(i,"leaflet-tooltip-top"),n.DomUtil.removeClass(i,"leaflet-tooltip-bottom"),n.DomUtil.addClass(i,"leaflet-tooltip-"+s),n.DomUtil.setPosition(i,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&n.DomUtil.setOpacity(this._container,t)},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(e)},_getAnchor:function(){return n.point(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}}),n.tooltip=function(t,e){return new n.Tooltip(t,e)},n.Map.include({openTooltip:function(t,e,i){return t instanceof n.Tooltip||(t=new n.Tooltip(i).setContent(t)),e&&t.setLatLng(e),this.hasLayer(t)?this:this.addLayer(t)},closeTooltip:function(t){return t&&this.removeLayer(t),this}}),n.Layer.include({bindTooltip:function(t,e){return t instanceof n.Tooltip?(n.setOptions(t,e),this._tooltip=t,t._source=this):(this._tooltip&&!e||(this._tooltip=n.tooltip(e,this)),this._tooltip.setContent(t)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){if(t||!this._tooltipHandlersAdded){var e=t?"off":"on",i={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?i.add=this._openTooltip:(i.mouseover=this._openTooltip,i.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(i.mousemove=this._moveTooltip),n.Browser.touch&&(i.click=this._openTooltip)),this[e](i),this._tooltipHandlersAdded=!t}},openTooltip:function(t,e){if(t instanceof n.Layer||(e=t,t=this),t instanceof n.FeatureGroup)for(var i in this._layers){t=this._layers[i];break}return e||(e=t.getCenter?t.getCenter():t.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=t,this._tooltip.update(),this._map.openTooltip(this._tooltip,e),this._tooltip.options.interactive&&this._tooltip._container&&(n.DomUtil.addClass(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(n.DomUtil.removeClass(this._tooltip._container,"leaflet-clickable"),this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(t){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(t)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){var e=t.layer||t.target;this._tooltip&&this._map&&this.openTooltip(e,this._tooltip.options.sticky?t.latlng:void 0)},_moveTooltip:function(t){var e,i,o=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(e=this._map.mouseEventToContainerPoint(t.originalEvent),i=this._map.containerPointToLayerPoint(e),
	o=this._map.layerPointToLatLng(i)),this._tooltip.setLatLng(o)}}),n.Marker.include({_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor||[0,0]}}),n.LayerGroup=n.Layer.extend({initialize:function(t){this._layers={};var e,i;if(t)for(e=0,i=t.length;e<i;e++)this.addLayer(t[e])},addLayer:function(t){var e=this.getLayerId(t);return this._layers[e]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var e=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[e]&&this._map.removeLayer(this._layers[e]),delete this._layers[e],this},hasLayer:function(t){return!!t&&(t in this._layers||this.getLayerId(t)in this._layers)},clearLayers:function(){for(var t in this._layers)this.removeLayer(this._layers[t]);return this},invoke:function(t){var e,i,o=Array.prototype.slice.call(arguments,1);for(e in this._layers)i=this._layers[e],i[t]&&i[t].apply(i,o);return this},onAdd:function(t){for(var e in this._layers)t.addLayer(this._layers[e])},onRemove:function(t){for(var e in this._layers)t.removeLayer(this._layers[e])},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];for(var e in this._layers)t.push(this._layers[e]);return t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:function(t){return n.stamp(t)}}),n.layerGroup=function(t){return new n.LayerGroup(t)},n.FeatureGroup=n.LayerGroup.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),n.LayerGroup.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),t.removeEventParent(this),n.LayerGroup.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t=new n.LatLngBounds;for(var e in this._layers){var i=this._layers[e];t.extend(i.getBounds?i.getBounds():i.getLatLng())}return t}}),n.featureGroup=function(t){return new n.FeatureGroup(t)},n.Renderer=n.Layer.extend({options:{padding:.1},initialize:function(t){n.setOptions(this,t),n.stamp(this)},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&n.DomUtil.addClass(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update()},onRemove:function(){n.DomUtil.remove(this._container)},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,e){var i=this._map.getZoomScale(e,this._zoom),o=n.DomUtil.getPosition(this._container),r=this._map.getSize().multiplyBy(.5+this.options.padding),s=this._map.project(this._center,e),a=this._map.project(t,e),l=a.subtract(s),u=r.multiplyBy(-i).add(o).add(r).subtract(l);n.Browser.any3d?n.DomUtil.setTransform(this._container,u,i):n.DomUtil.setPosition(this._container,u)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom)},_update:function(){var t=this.options.padding,e=this._map.getSize(),i=this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();this._bounds=new n.Bounds(i,i.add(e.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),n.Map.include({getRenderer:function(t){var e=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer;return e||(e=this._renderer=this.options.preferCanvas&&n.canvas()||n.svg()),this.hasLayer(e)||this.addLayer(e),e},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var e=this._paneRenderers[t];return void 0===e&&(e=n.SVG&&n.svg({pane:t})||n.Canvas&&n.canvas({pane:t}),this._paneRenderers[t]=e),e}}),n.Path=n.Layer.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this),this._renderer.on("update",this._update,this)},onRemove:function(){this._renderer._removePath(this),this._renderer.off("update",this._update,this)},getEvents:function(){return{zoomend:this._project,viewreset:this._reset}},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return n.setOptions(this,t),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+(n.Browser.touch?10:0)}}),n.LineUtil={simplify:function(t,e){if(!e||!t.length)return t.slice();var i=e*e;return t=this._reducePoints(t,i),t=this._simplifyDP(t,i)},pointToSegmentDistance:function(t,e,i){return Math.sqrt(this._sqClosestPointOnSegment(t,e,i,!0))},closestPointOnSegment:function(t,e,i){return this._sqClosestPointOnSegment(t,e,i)},_simplifyDP:function(t,e){var i=t.length,o=typeof Uint8Array!=void 0+""?Uint8Array:Array,n=new o(i);n[0]=n[i-1]=1,this._simplifyDPStep(t,n,e,0,i-1);var r,s=[];for(r=0;r<i;r++)n[r]&&s.push(t[r]);return s},_simplifyDPStep:function(t,e,i,o,n){var r,s,a,l=0;for(s=o+1;s<=n-1;s++)a=this._sqClosestPointOnSegment(t[s],t[o],t[n],!0),a>l&&(r=s,l=a);l>i&&(e[r]=1,this._simplifyDPStep(t,e,i,o,r),this._simplifyDPStep(t,e,i,r,n))},_reducePoints:function(t,e){for(var i=[t[0]],o=1,n=0,r=t.length;o<r;o++)this._sqDist(t[o],t[n])>e&&(i.push(t[o]),n=o);return n<r-1&&i.push(t[r-1]),i},clipSegment:function(t,e,i,o,n){var r,s,a,l=o?this._lastCode:this._getBitCode(t,i),u=this._getBitCode(e,i);for(this._lastCode=u;;){if(!(l|u))return[t,e];if(l&u)return!1;r=l||u,s=this._getEdgeIntersection(t,e,r,i,n),a=this._getBitCode(s,i),r===l?(t=s,l=a):(e=s,u=a)}},_getEdgeIntersection:function(t,e,i,o,r){var s,a,l=e.x-t.x,u=e.y-t.y,c=o.min,h=o.max;return 8&i?(s=t.x+l*(h.y-t.y)/u,a=h.y):4&i?(s=t.x+l*(c.y-t.y)/u,a=c.y):2&i?(s=h.x,a=t.y+u*(h.x-t.x)/l):1&i&&(s=c.x,a=t.y+u*(c.x-t.x)/l),new n.Point(s,a,r)},_getBitCode:function(t,e){var i=0;return t.x<e.min.x?i|=1:t.x>e.max.x&&(i|=2),t.y<e.min.y?i|=4:t.y>e.max.y&&(i|=8),i},_sqDist:function(t,e){var i=e.x-t.x,o=e.y-t.y;return i*i+o*o},_sqClosestPointOnSegment:function(t,e,i,o){var r,s=e.x,a=e.y,l=i.x-s,u=i.y-a,c=l*l+u*u;return c>0&&(r=((t.x-s)*l+(t.y-a)*u)/c,r>1?(s=i.x,a=i.y):r>0&&(s+=l*r,a+=u*r)),l=t.x-s,u=t.y-a,o?l*l+u*u:new n.Point(s,a)}},n.Polyline=n.Path.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,e){n.setOptions(this,e),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var e,i,o=1/0,r=null,s=n.LineUtil._sqClosestPointOnSegment,a=0,l=this._parts.length;a<l;a++)for(var u=this._parts[a],c=1,h=u.length;c<h;c++){e=u[c-1],i=u[c];var d=s(t,e,i,!0);d<o&&(o=d,r=s(t,e,i))}return r&&(r.distance=Math.sqrt(o)),r},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,e,i,o,n,r,s,a=this._rings[0],l=a.length;if(!l)return null;for(t=0,e=0;t<l-1;t++)e+=a[t].distanceTo(a[t+1])/2;if(0===e)return this._map.layerPointToLatLng(a[0]);for(t=0,o=0;t<l-1;t++)if(n=a[t],r=a[t+1],i=n.distanceTo(r),o+=i,o>e)return s=(o-e)/i,this._map.layerPointToLatLng([r.x-s*(r.x-n.x),r.y-s*(r.y-n.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,e){return e=e||this._defaultShape(),t=n.latLng(t),e.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new n.LatLngBounds,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return n.Polyline._flat(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var e=[],i=n.Polyline._flat(t),o=0,r=t.length;o<r;o++)i?(e[o]=n.latLng(t[o]),this._bounds.extend(e[o])):e[o]=this._convertLatLngs(t[o]);return e},_project:function(){var t=new n.Bounds;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t);var e=this._clickTolerance(),i=new n.Point(e,e);this._bounds.isValid()&&t.isValid()&&(t.min._subtract(i),t.max._add(i),this._pxBounds=t)},_projectLatlngs:function(t,e,i){var o,r,s=t[0]instanceof n.LatLng,a=t.length;if(s){for(r=[],o=0;o<a;o++)r[o]=this._map.latLngToLayerPoint(t[o]),i.extend(r[o]);e.push(r)}else for(o=0;o<a;o++)this._projectLatlngs(t[o],e,i)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t)){if(this.options.noClip)return void(this._parts=this._rings);var e,i,o,r,s,a,l,u=this._parts;for(e=0,o=0,r=this._rings.length;e<r;e++)for(l=this._rings[e],i=0,s=l.length;i<s-1;i++)a=n.LineUtil.clipSegment(l[i],l[i+1],t,i,!0),a&&(u[o]=u[o]||[],u[o].push(a[0]),a[1]===l[i+1]&&i!==s-2||(u[o].push(a[1]),o++))}},_simplifyPoints:function(){for(var t=this._parts,e=this.options.smoothFactor,i=0,o=t.length;i<o;i++)t[i]=n.LineUtil.simplify(t[i],e)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)}}),n.polyline=function(t,e){return new n.Polyline(t,e)},n.Polyline._flat=function(t){return!n.Util.isArray(t[0])||"object"!=typeof t[0][0]&&"undefined"!=typeof t[0][0]},n.PolyUtil={},n.PolyUtil.clipPolygon=function(t,e,i){var o,r,s,a,l,u,c,h,d,p=[1,4,2,8],_=n.LineUtil;for(r=0,c=t.length;r<c;r++)t[r]._code=_._getBitCode(t[r],e);for(a=0;a<4;a++){for(h=p[a],o=[],r=0,c=t.length,s=c-1;r<c;s=r++)l=t[r],u=t[s],l._code&h?u._code&h||(d=_._getEdgeIntersection(u,l,h,e,i),d._code=_._getBitCode(d,e),o.push(d)):(u._code&h&&(d=_._getEdgeIntersection(u,l,h,e,i),d._code=_._getBitCode(d,e),o.push(d)),o.push(l));t=o}return t},n.Polygon=n.Polyline.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,e,i,o,n,r,s,a,l,u=this._rings[0],c=u.length;if(!c)return null;for(r=s=a=0,t=0,e=c-1;t<c;e=t++)i=u[t],o=u[e],n=i.y*o.x-o.y*i.x,s+=(i.x+o.x)*n,a+=(i.y+o.y)*n,r+=3*n;return l=0===r?u[0]:[s/r,a/r],this._map.layerPointToLatLng(l)},_convertLatLngs:function(t){var e=n.Polyline.prototype._convertLatLngs.call(this,t),i=e.length;return i>=2&&e[0]instanceof n.LatLng&&e[0].equals(e[i-1])&&e.pop(),e},_setLatLngs:function(t){n.Polyline.prototype._setLatLngs.call(this,t),n.Polyline._flat(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return n.Polyline._flat(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var t=this._renderer._bounds,e=this.options.weight,i=new n.Point(e,e);if(t=new n.Bounds(t.min.subtract(i),t.max.add(i)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(t)){if(this.options.noClip)return void(this._parts=this._rings);for(var o,r=0,s=this._rings.length;r<s;r++)o=n.PolyUtil.clipPolygon(this._rings[r],t,!0),o.length&&this._parts.push(o)}},_updatePath:function(){this._renderer._updatePoly(this,!0)}}),n.polygon=function(t,e){return new n.Polygon(t,e)},n.Rectangle=n.Polygon.extend({initialize:function(t,e){n.Polygon.prototype.initialize.call(this,this._boundsToLatLngs(t),e)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=n.latLngBounds(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}}),n.rectangle=function(t,e){return new n.Rectangle(t,e)},n.CircleMarker=n.Path.extend({options:{fill:!0,radius:10},initialize:function(t,e){n.setOptions(this,e),this._latlng=n.latLng(t),this._radius=this.options.radius},setLatLng:function(t){return this._latlng=n.latLng(t),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var e=t&&t.radius||this._radius;return n.Path.prototype.setStyle.call(this,t),this.setRadius(e),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,e=this._radiusY||t,i=this._clickTolerance(),o=[t+i,e+i];this._pxBounds=new n.Bounds(this._point.subtract(o),this._point.add(o))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)}}),n.circleMarker=function(t,e){return new n.CircleMarker(t,e)},n.Circle=n.CircleMarker.extend({initialize:function(t,e,i){if("number"==typeof e&&(e=n.extend({},i,{radius:e})),n.setOptions(this,e),this._latlng=n.latLng(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new n.LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:n.Path.prototype.setStyle,_project:function(){var t=this._latlng.lng,e=this._latlng.lat,i=this._map,o=i.options.crs;if(o.distance===n.CRS.Earth.distance){var r=Math.PI/180,s=this._mRadius/n.CRS.Earth.R/r,a=i.project([e+s,t]),l=i.project([e-s,t]),u=a.add(l).divideBy(2),c=i.unproject(u).lat,h=Math.acos((Math.cos(s*r)-Math.sin(e*r)*Math.sin(c*r))/(Math.cos(e*r)*Math.cos(c*r)))/r;(isNaN(h)||0===h)&&(h=s/Math.cos(Math.PI/180*e)),this._point=u.subtract(i.getPixelOrigin()),this._radius=isNaN(h)?0:Math.max(Math.round(u.x-i.project([c,t-h]).x),1),this._radiusY=Math.max(Math.round(u.y-a.y),1)}else{var d=o.unproject(o.project(this._latlng).subtract([this._mRadius,0]));this._point=i.latLngToLayerPoint(this._latlng),this._radius=this._point.x-i.latLngToLayerPoint(d).x}this._updateBounds()}}),n.circle=function(t,e,i){return new n.Circle(t,e,i)},n.SVG=n.Renderer.extend({getEvents:function(){var t=n.Renderer.prototype.getEvents.call(this);return t.zoomstart=this._onZoomStart,t},_initContainer:function(){this._container=n.SVG.create("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=n.SVG.create("g"),this._container.appendChild(this._rootGroup)},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){n.Renderer.prototype._update.call(this);var t=this._bounds,e=t.getSize(),i=this._container;this._svgSize&&this._svgSize.equals(e)||(this._svgSize=e,i.setAttribute("width",e.x),i.setAttribute("height",e.y)),n.DomUtil.setPosition(i,t.min),i.setAttribute("viewBox",[t.min.x,t.min.y,e.x,e.y].join(" ")),this.fire("update")}},_initPath:function(t){var e=t._path=n.SVG.create("path");t.options.className&&n.DomUtil.addClass(e,t.options.className),t.options.interactive&&n.DomUtil.addClass(e,"leaflet-interactive"),this._updateStyle(t)},_addPath:function(t){this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){n.DomUtil.remove(t._path),t.removeInteractiveTarget(t._path)},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var e=t._path,i=t.options;e&&(i.stroke?(e.setAttribute("stroke",i.color),e.setAttribute("stroke-opacity",i.opacity),e.setAttribute("stroke-width",i.weight),e.setAttribute("stroke-linecap",i.lineCap),e.setAttribute("stroke-linejoin",i.lineJoin),i.dashArray?e.setAttribute("stroke-dasharray",i.dashArray):e.removeAttribute("stroke-dasharray"),i.dashOffset?e.setAttribute("stroke-dashoffset",i.dashOffset):e.removeAttribute("stroke-dashoffset")):e.setAttribute("stroke","none"),i.fill?(e.setAttribute("fill",i.fillColor||i.color),e.setAttribute("fill-opacity",i.fillOpacity),e.setAttribute("fill-rule",i.fillRule||"evenodd")):e.setAttribute("fill","none"))},_updatePoly:function(t,e){this._setPath(t,n.SVG.pointsToPath(t._parts,e))},_updateCircle:function(t){var e=t._point,i=t._radius,o=t._radiusY||i,n="a"+i+","+o+" 0 1,0 ",r=t._empty()?"M0 0":"M"+(e.x-i)+","+e.y+n+2*i+",0 "+n+2*-i+",0 ";this._setPath(t,r)},_setPath:function(t,e){t._path.setAttribute("d",e)},_bringToFront:function(t){n.DomUtil.toFront(t._path)},_bringToBack:function(t){n.DomUtil.toBack(t._path)}}),n.extend(n.SVG,{create:function(t){return document.createElementNS("http://www.w3.org/2000/svg",t)},pointsToPath:function(t,e){var i,o,r,s,a,l,u="";for(i=0,r=t.length;i<r;i++){for(a=t[i],o=0,s=a.length;o<s;o++)l=a[o],u+=(o?"L":"M")+l.x+" "+l.y;u+=e?n.Browser.svg?"z":"x":""}return u||"M0 0"}}),n.Browser.svg=!(!document.createElementNS||!n.SVG.create("svg").createSVGRect),n.svg=function(t){return n.Browser.svg||n.Browser.vml?new n.SVG(t):null},n.Browser.vml=!n.Browser.svg&&function(){try{var t=document.createElement("div");t.innerHTML='<v:shape adj="1"/>';var e=t.firstChild;return e.style.behavior="url(#default#VML)",e&&"object"==typeof e.adj}catch(i){return!1}}(),n.SVG.include(n.Browser.vml?{_initContainer:function(){this._container=n.DomUtil.create("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(n.Renderer.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var e=t._container=n.SVG.create("shape");n.DomUtil.addClass(e,"leaflet-vml-shape "+(this.options.className||"")),e.coordsize="1 1",t._path=n.SVG.create("path"),e.appendChild(t._path),this._updateStyle(t)},_addPath:function(t){var e=t._container;this._container.appendChild(e),t.options.interactive&&t.addInteractiveTarget(e)},_removePath:function(t){var e=t._container;n.DomUtil.remove(e),t.removeInteractiveTarget(e)},_updateStyle:function(t){var e=t._stroke,i=t._fill,o=t.options,r=t._container;r.stroked=!!o.stroke,r.filled=!!o.fill,o.stroke?(e||(e=t._stroke=n.SVG.create("stroke")),r.appendChild(e),e.weight=o.weight+"px",e.color=o.color,e.opacity=o.opacity,o.dashArray?e.dashStyle=n.Util.isArray(o.dashArray)?o.dashArray.join(" "):o.dashArray.replace(/( *, *)/g," "):e.dashStyle="",e.endcap=o.lineCap.replace("butt","flat"),e.joinstyle=o.lineJoin):e&&(r.removeChild(e),t._stroke=null),o.fill?(i||(i=t._fill=n.SVG.create("fill")),r.appendChild(i),i.color=o.fillColor||o.color,i.opacity=o.fillOpacity):i&&(r.removeChild(i),t._fill=null)},_updateCircle:function(t){var e=t._point.round(),i=Math.round(t._radius),o=Math.round(t._radiusY||i);this._setPath(t,t._empty()?"M0 0":"AL "+e.x+","+e.y+" "+i+","+o+" 0,23592600")},_setPath:function(t,e){t._path.v=e},_bringToFront:function(t){n.DomUtil.toFront(t._container)},_bringToBack:function(t){n.DomUtil.toBack(t._container)}}:{}),n.Browser.vml&&(n.SVG.create=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}()),n.Canvas=n.Renderer.extend({onAdd:function(){n.Renderer.prototype.onAdd.call(this),this._layers=this._layers||{},this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");n.DomEvent.on(t,"mousemove",n.Util.throttle(this._onMouseMove,32,this),this).on(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this).on(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},n.Renderer.prototype._update.call(this);var t=this._bounds,e=this._container,i=t.getSize(),o=n.Browser.retina?2:1;n.DomUtil.setPosition(e,t.min),e.width=o*i.x,e.height=o*i.y,e.style.width=i.x+"px",e.style.height=i.y+"px",n.Browser.retina&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update")}},_initPath:function(t){this._updateDashArray(t),this._layers[n.stamp(t)]=t},_addPath:n.Util.falseFn,_removePath:function(t){t._removed=!0,this._requestRedraw(t)},_updatePath:function(t){this._redrawBounds=t._pxBounds,this._draw(!0),t._project(),t._update(),this._draw(),this._redrawBounds=null},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if(t.options.dashArray){var e,i=t.options.dashArray.split(","),o=[];for(e=0;e<i.length;e++)o.push(Number(i[e]));t.options._dashArray=o}},_requestRedraw:function(t){if(this._map){var e=(t.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new n.Bounds,this._redrawBounds.extend(t._pxBounds.min.subtract([e,e])),this._redrawBounds.extend(t._pxBounds.max.add([e,e])),this._redrawRequest=this._redrawRequest||n.Util.requestAnimFrame(this._redraw,this)}},_redraw:function(){this._redrawRequest=null,this._draw(!0),this._draw(),this._redrawBounds=null},_draw:function(t){this._clear=t;var e,i=this._redrawBounds;this._ctx.save(),i&&(this._ctx.beginPath(),this._ctx.rect(i.min.x,i.min.y,i.max.x-i.min.x,i.max.y-i.min.y),this._ctx.clip());for(var o in this._layers)e=this._layers[o],(!i||e._pxBounds&&e._pxBounds.intersects(i))&&e._updatePath(),t&&e._removed&&(delete e._removed,delete this._layers[o]);this._ctx.restore()},_updatePoly:function(t,e){var i,o,n,r,s=t._parts,a=s.length,l=this._ctx;if(a){for(this._drawnLayers[t._leaflet_id]=t,l.beginPath(),l.setLineDash&&l.setLineDash(t.options&&t.options._dashArray||[]),i=0;i<a;i++){for(o=0,n=s[i].length;o<n;o++)r=s[i][o],l[o?"lineTo":"moveTo"](r.x,r.y);e&&l.closePath()}this._fillStroke(l,t)}},_updateCircle:function(t){if(!t._empty()){var e=t._point,i=this._ctx,o=t._radius,n=(t._radiusY||o)/o;this._drawnLayers[t._leaflet_id]=t,1!==n&&(i.save(),i.scale(1,n)),i.beginPath(),i.arc(e.x,e.y/n,o,0,2*Math.PI,!1),1!==n&&i.restore(),this._fillStroke(i,t)}},_fillStroke:function(t,e){var i=this._clear,o=e.options;t.globalCompositeOperation=i?"destination-out":"source-over",o.fill&&(t.globalAlpha=i?1:o.fillOpacity,t.fillStyle=o.fillColor||o.color,t.fill(o.fillRule||"evenodd")),o.stroke&&0!==o.weight&&(t.globalAlpha=i?1:o.opacity,e._prevWeight=t.lineWidth=i?e._prevWeight+1:o.weight,t.strokeStyle=o.color,t.lineCap=o.lineCap,t.lineJoin=o.lineJoin,t.stroke())},_onClick:function(t){var e,i=this._map.mouseEventToLayerPoint(t),o=[];for(var r in this._layers)e=this._layers[r],e.options.interactive&&e._containsPoint(i)&&!this._map._draggableMoved(e)&&(n.DomEvent._fakeStop(t),o.push(e));o.length&&this._fireEvent(o,t)},_onMouseMove:function(t){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var e=this._map.mouseEventToLayerPoint(t);this._handleMouseOut(t,e),this._handleMouseHover(t,e)}},_handleMouseOut:function(t,e){var i=this._hoveredLayer;!i||"mouseout"!==t.type&&i._containsPoint(e)||(n.DomUtil.removeClass(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(t,e){var i,o;for(i in this._drawnLayers)o=this._drawnLayers[i],o.options.interactive&&o._containsPoint(e)&&(n.DomUtil.addClass(this._container,"leaflet-interactive"),this._fireEvent([o],t,"mouseover"),this._hoveredLayer=o);this._hoveredLayer&&this._fireEvent([this._hoveredLayer],t)},_fireEvent:function(t,e,i){this._map._fireDOMEvent(e,i||e.type,t)},_bringToFront:n.Util.falseFn,_bringToBack:n.Util.falseFn}),n.Browser.canvas=function(){return!!document.createElement("canvas").getContext}(),n.canvas=function(t){return n.Browser.canvas?new n.Canvas(t):null},n.Polyline.prototype._containsPoint=function(t,e){var i,o,r,s,a,l,u=this._clickTolerance();if(!this._pxBounds.contains(t))return!1;for(i=0,s=this._parts.length;i<s;i++)for(l=this._parts[i],o=0,a=l.length,r=a-1;o<a;r=o++)if((e||0!==o)&&n.LineUtil.pointToSegmentDistance(t,l[r],l[o])<=u)return!0;return!1},n.Polygon.prototype._containsPoint=function(t){var e,i,o,r,s,a,l,u,c=!1;if(!this._pxBounds.contains(t))return!1;for(r=0,l=this._parts.length;r<l;r++)for(e=this._parts[r],s=0,u=e.length,a=u-1;s<u;a=s++)i=e[s],o=e[a],i.y>t.y!=o.y>t.y&&t.x<(o.x-i.x)*(t.y-i.y)/(o.y-i.y)+i.x&&(c=!c);return c||n.Polyline.prototype._containsPoint.call(this,t,!0)},n.CircleMarker.prototype._containsPoint=function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()},n.GeoJSON=n.FeatureGroup.extend({initialize:function(t,e){n.setOptions(this,e),this._layers={},t&&this.addData(t)},addData:function(t){var e,i,o,r=n.Util.isArray(t)?t:t.features;if(r){for(e=0,i=r.length;e<i;e++)o=r[e],(o.geometries||o.geometry||o.features||o.coordinates)&&this.addData(o);return this}var s=this.options;if(s.filter&&!s.filter(t))return this;var a=n.GeoJSON.geometryToLayer(t,s);return a?(a.feature=n.GeoJSON.asFeature(t),a.defaultOptions=a.options,this.resetStyle(a),s.onEachFeature&&s.onEachFeature(t,a),this.addLayer(a)):this},resetStyle:function(t){return t.options=n.Util.extend({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this},setStyle:function(t){return this.eachLayer(function(e){this._setLayerStyle(e,t)},this)},_setLayerStyle:function(t,e){"function"==typeof e&&(e=e(t.feature)),t.setStyle&&t.setStyle(e)}}),n.extend(n.GeoJSON,{geometryToLayer:function(t,e){var i,o,r,s,a="Feature"===t.type?t.geometry:t,l=a?a.coordinates:null,u=[],c=e&&e.pointToLayer,h=e&&e.coordsToLatLng||this.coordsToLatLng;if(!l&&!a)return null;switch(a.type){case"Point":return i=h(l),c?c(t,i):new n.Marker(i);case"MultiPoint":for(r=0,s=l.length;r<s;r++)i=h(l[r]),u.push(c?c(t,i):new n.Marker(i));return new n.FeatureGroup(u);case"LineString":case"MultiLineString":return o=this.coordsToLatLngs(l,"LineString"===a.type?0:1,h),new n.Polyline(o,e);case"Polygon":case"MultiPolygon":return o=this.coordsToLatLngs(l,"Polygon"===a.type?1:2,h),new n.Polygon(o,e);case"GeometryCollection":for(r=0,s=a.geometries.length;r<s;r++){var d=this.geometryToLayer({geometry:a.geometries[r],type:"Feature",properties:t.properties},e);d&&u.push(d)}return new n.FeatureGroup(u);default:throw new Error("Invalid GeoJSON object.")}},coordsToLatLng:function(t){return new n.LatLng(t[1],t[0],t[2])},coordsToLatLngs:function(t,e,i){for(var o,n=[],r=0,s=t.length;r<s;r++)o=e?this.coordsToLatLngs(t[r],e-1,i):(i||this.coordsToLatLng)(t[r]),n.push(o);return n},latLngToCoords:function(t){return void 0!==t.alt?[t.lng,t.lat,t.alt]:[t.lng,t.lat]},latLngsToCoords:function(t,e,i){for(var o=[],r=0,s=t.length;r<s;r++)o.push(e?n.GeoJSON.latLngsToCoords(t[r],e-1,i):n.GeoJSON.latLngToCoords(t[r]));return!e&&i&&o.push(o[0]),o},getFeature:function(t,e){return t.feature?n.extend({},t.feature,{geometry:e}):n.GeoJSON.asFeature(e)},asFeature:function(t){return"Feature"===t.type?t:{type:"Feature",properties:{},geometry:t}}});var s={toGeoJSON:function(){return n.GeoJSON.getFeature(this,{type:"Point",coordinates:n.GeoJSON.latLngToCoords(this.getLatLng())})}};n.Marker.include(s),n.Circle.include(s),n.CircleMarker.include(s),n.Polyline.prototype.toGeoJSON=function(){var t=!n.Polyline._flat(this._latlngs),e=n.GeoJSON.latLngsToCoords(this._latlngs,t?1:0);return n.GeoJSON.getFeature(this,{type:(t?"Multi":"")+"LineString",coordinates:e})},n.Polygon.prototype.toGeoJSON=function(){var t=!n.Polyline._flat(this._latlngs),e=t&&!n.Polyline._flat(this._latlngs[0]),i=n.GeoJSON.latLngsToCoords(this._latlngs,e?2:t?1:0,!0);return t||(i=[i]),n.GeoJSON.getFeature(this,{type:(e?"Multi":"")+"Polygon",coordinates:i})},n.LayerGroup.include({toMultiPoint:function(){var t=[];return this.eachLayer(function(e){t.push(e.toGeoJSON().geometry.coordinates)}),n.GeoJSON.getFeature(this,{type:"MultiPoint",coordinates:t})},toGeoJSON:function(){var t=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===t)return this.toMultiPoint();var e="GeometryCollection"===t,i=[];return this.eachLayer(function(t){if(t.toGeoJSON){var o=t.toGeoJSON();i.push(e?o.geometry:n.GeoJSON.asFeature(o))}}),e?n.GeoJSON.getFeature(this,{geometries:i,type:"GeometryCollection"}):{type:"FeatureCollection",features:i}}}),n.geoJSON=function(t,e){return new n.GeoJSON(t,e)},n.geoJson=n.geoJSON;var a="_leaflet_events";n.DomEvent={on:function(t,e,i,o){if("object"==typeof e)for(var r in e)this._on(t,r,e[r],i);else{e=n.Util.splitWords(e);for(var s=0,a=e.length;s<a;s++)this._on(t,e[s],i,o)}return this},off:function(t,e,i,o){if("object"==typeof e)for(var r in e)this._off(t,r,e[r],i);else{e=n.Util.splitWords(e);for(var s=0,a=e.length;s<a;s++)this._off(t,e[s],i,o)}return this},_on:function(t,e,i,o){var r=e+n.stamp(i)+(o?"_"+n.stamp(o):"");if(t[a]&&t[a][r])return this;var s=function(e){return i.call(o||t,e||window.event)},l=s;return n.Browser.pointer&&0===e.indexOf("touch")?this.addPointerListener(t,e,s,r):n.Browser.touch&&"dblclick"===e&&this.addDoubleTapListener?this.addDoubleTapListener(t,s,r):"addEventListener"in t?"mousewheel"===e?t.addEventListener("onwheel"in t?"wheel":"mousewheel",s,!1):"mouseenter"===e||"mouseleave"===e?(s=function(e){e=e||window.event,n.DomEvent._isExternalTarget(t,e)&&l(e)},t.addEventListener("mouseenter"===e?"mouseover":"mouseout",s,!1)):("click"===e&&n.Browser.android&&(s=function(t){return n.DomEvent._filterClick(t,l)}),t.addEventListener(e,s,!1)):"attachEvent"in t&&t.attachEvent("on"+e,s),t[a]=t[a]||{},t[a][r]=s,this},_off:function(t,e,i,o){var r=e+n.stamp(i)+(o?"_"+n.stamp(o):""),s=t[a]&&t[a][r];return s?(n.Browser.pointer&&0===e.indexOf("touch")?this.removePointerListener(t,e,r):n.Browser.touch&&"dblclick"===e&&this.removeDoubleTapListener?this.removeDoubleTapListener(t,r):"removeEventListener"in t?"mousewheel"===e?t.removeEventListener("onwheel"in t?"wheel":"mousewheel",s,!1):t.removeEventListener("mouseenter"===e?"mouseover":"mouseleave"===e?"mouseout":e,s,!1):"detachEvent"in t&&t.detachEvent("on"+e,s),t[a][r]=null,this):this},stopPropagation:function(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,n.DomEvent._skipped(t),this},disableScrollPropagation:function(t){return n.DomEvent.on(t,"mousewheel",n.DomEvent.stopPropagation)},disableClickPropagation:function(t){var e=n.DomEvent.stopPropagation;return n.DomEvent.on(t,n.Draggable.START.join(" "),e),n.DomEvent.on(t,{click:n.DomEvent._fakeStop,dblclick:e})},preventDefault:function(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this},stop:function(t){return n.DomEvent.preventDefault(t).stopPropagation(t)},getMousePosition:function(t,e){if(!e)return new n.Point(t.clientX,t.clientY);var i=e.getBoundingClientRect();return new n.Point(t.clientX-i.left-e.clientLeft,t.clientY-i.top-e.clientTop)},_wheelPxFactor:n.Browser.win&&n.Browser.chrome?2:n.Browser.gecko?window.devicePixelRatio:1,getWheelDelta:function(t){return n.Browser.edge?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/n.DomEvent._wheelPxFactor:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0},_skipEvents:{},_fakeStop:function(t){n.DomEvent._skipEvents[t.type]=!0},_skipped:function(t){var e=this._skipEvents[t.type];return this._skipEvents[t.type]=!1,e},_isExternalTarget:function(t,e){var i=e.relatedTarget;if(!i)return!0;try{for(;i&&i!==t;)i=i.parentNode}catch(o){return!1}return i!==t},_filterClick:function(t,e){var i=t.timeStamp||t.originalEvent&&t.originalEvent.timeStamp,o=n.DomEvent._lastClick&&i-n.DomEvent._lastClick;return o&&o>100&&o<500||t.target._simulatedClick&&!t._simulated?void n.DomEvent.stop(t):(n.DomEvent._lastClick=i,void e(t))}},n.DomEvent.addListener=n.DomEvent.on,n.DomEvent.removeListener=n.DomEvent.off,n.Draggable=n.Evented.extend({options:{clickTolerance:3
	},statics:{START:n.Browser.touch?["touchstart","mousedown"]:["mousedown"],END:{mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},MOVE:{mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"}},initialize:function(t,e,i){this._element=t,this._dragStartTarget=e||t,this._preventOutline=i},enable:function(){this._enabled||(n.DomEvent.on(this._dragStartTarget,n.Draggable.START.join(" "),this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(n.DomEvent.off(this._dragStartTarget,n.Draggable.START.join(" "),this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){if(!t._simulated&&this._enabled&&(this._moved=!1,!n.DomUtil.hasClass(this._element,"leaflet-zoom-anim")&&!(n.Draggable._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches)&&this._enabled&&(n.Draggable._dragging=!0,this._preventOutline&&n.DomUtil.preventOutline(this._element),n.DomUtil.disableImageDrag(),n.DomUtil.disableTextSelection(),!this._moving))){this.fire("down");var e=t.touches?t.touches[0]:t;this._startPoint=new n.Point(e.clientX,e.clientY),n.DomEvent.on(document,n.Draggable.MOVE[t.type],this._onMove,this).on(document,n.Draggable.END[t.type],this._onUp,this)}},_onMove:function(t){if(!t._simulated&&this._enabled){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var e=t.touches&&1===t.touches.length?t.touches[0]:t,i=new n.Point(e.clientX,e.clientY),o=i.subtract(this._startPoint);(o.x||o.y)&&(Math.abs(o.x)+Math.abs(o.y)<this.options.clickTolerance||(n.DomEvent.preventDefault(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=n.DomUtil.getPosition(this._element).subtract(o),n.DomUtil.addClass(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),n.DomUtil.addClass(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(o),this._moving=!0,n.Util.cancelAnimFrame(this._animRequest),this._lastEvent=t,this._animRequest=n.Util.requestAnimFrame(this._updatePosition,this,!0)))}},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),n.DomUtil.setPosition(this._element,this._newPos),this.fire("drag",t)},_onUp:function(t){if(!t._simulated&&this._enabled){n.DomUtil.removeClass(document.body,"leaflet-dragging"),this._lastTarget&&(n.DomUtil.removeClass(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var e in n.Draggable.MOVE)n.DomEvent.off(document,n.Draggable.MOVE[e],this._onMove,this).off(document,n.Draggable.END[e],this._onUp,this);n.DomUtil.enableImageDrag(),n.DomUtil.enableTextSelection(),this._moved&&this._moving&&(n.Util.cancelAnimFrame(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,n.Draggable._dragging=!1}}}),n.Handler=n.Class.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}}),n.Map.mergeOptions({dragging:!0,inertia:!n.Browser.android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0}),n.Map.Drag=n.Handler.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new n.Draggable(t._mapPane,t._container),this._draggable.on({down:this._onDown,dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))}n.DomUtil.addClass(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){n.DomUtil.removeClass(this._map._container,"leaflet-grab"),n.DomUtil.removeClass(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDown:function(){this._map._stop()},_onDragStart:function(){var t=this._map;if(this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var e=n.latLngBounds(this._map.options.maxBounds);this._offsetLimit=n.bounds(this._map.latLngToContainerPoint(e.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(e.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;t.fire("movestart").fire("dragstart"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){if(this._map.options.inertia){var e=this._lastTime=+new Date,i=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(i),this._times.push(e),e-this._times[0]>50&&(this._positions.shift(),this._times.shift())}this._map.fire("move",t).fire("drag",t)},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),e=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=e.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,e){return t-(t-e)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var t=this._draggable._newPos.subtract(this._draggable._startPos),e=this._offsetLimit;t.x<e.min.x&&(t.x=this._viscousLimit(t.x,e.min.x)),t.y<e.min.y&&(t.y=this._viscousLimit(t.y,e.min.y)),t.x>e.max.x&&(t.x=this._viscousLimit(t.x,e.max.x)),t.y>e.max.y&&(t.y=this._viscousLimit(t.y,e.max.y)),this._draggable._newPos=this._draggable._startPos.add(t)}},_onPreDragWrap:function(){var t=this._worldWidth,e=Math.round(t/2),i=this._initialWorldOffset,o=this._draggable._newPos.x,n=(o-e+i)%t+e-i,r=(o+e+i)%t-e-i,s=Math.abs(n+i)<Math.abs(r+i)?n:r;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=s},_onDragEnd:function(t){var e=this._map,i=e.options,o=!i.inertia||this._times.length<2;if(e.fire("dragend",t),o)e.fire("moveend");else{var r=this._lastPos.subtract(this._positions[0]),s=(this._lastTime-this._times[0])/1e3,a=i.easeLinearity,l=r.multiplyBy(a/s),u=l.distanceTo([0,0]),c=Math.min(i.inertiaMaxSpeed,u),h=l.multiplyBy(c/u),d=c/(i.inertiaDeceleration*a),p=h.multiplyBy(-d/2).round();p.x||p.y?(p=e._limitOffset(p,e.options.maxBounds),n.Util.requestAnimFrame(function(){e.panBy(p,{duration:d,easeLinearity:a,noMoveStart:!0,animate:!0})})):e.fire("moveend")}}}),n.Map.addInitHook("addHandler","dragging",n.Map.Drag),n.Map.mergeOptions({doubleClickZoom:!0}),n.Map.DoubleClickZoom=n.Handler.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var e=this._map,i=e.getZoom(),o=e.options.zoomDelta,n=t.originalEvent.shiftKey?i-o:i+o;"center"===e.options.doubleClickZoom?e.setZoom(n):e.setZoomAround(t.containerPoint,n)}}),n.Map.addInitHook("addHandler","doubleClickZoom",n.Map.DoubleClickZoom),n.Map.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60}),n.Map.ScrollWheelZoom=n.Handler.extend({addHooks:function(){n.DomEvent.on(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){n.DomEvent.off(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var e=n.DomEvent.getWheelDelta(t),i=this._map.options.wheelDebounceTime;this._delta+=e,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var o=Math.max(i-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(n.bind(this._performZoom,this),o),n.DomEvent.stop(t)},_performZoom:function(){var t=this._map,e=t.getZoom(),i=this._map.options.zoomSnap||0;t._stop();var o=this._delta/(4*this._map.options.wheelPxPerZoomLevel),n=4*Math.log(2/(1+Math.exp(-Math.abs(o))))/Math.LN2,r=i?Math.ceil(n/i)*i:n,s=t._limitZoom(e+(this._delta>0?r:-r))-e;this._delta=0,this._startTime=null,s&&("center"===t.options.scrollWheelZoom?t.setZoom(e+s):t.setZoomAround(this._lastMousePos,e+s))}}),n.Map.addInitHook("addHandler","scrollWheelZoom",n.Map.ScrollWheelZoom),n.PosAnimation=n.Evented.extend({run:function(t,e,i,o){this.stop(),this._el=t,this._inProgress=!0,this._duration=i||.25,this._easeOutPower=1/Math.max(o||.5,.2),this._startPos=n.DomUtil.getPosition(t),this._offset=e.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=n.Util.requestAnimFrame(this._animate,this),this._step()},_step:function(t){var e=+new Date-this._startTime,i=1e3*this._duration;e<i?this._runFrame(this._easeOut(e/i),t):(this._runFrame(1),this._complete())},_runFrame:function(t,e){var i=this._startPos.add(this._offset.multiplyBy(t));e&&i._round(),n.DomUtil.setPosition(this._el,i),this.fire("step")},_complete:function(){n.Util.cancelAnimFrame(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),n.Map.include({setView:function(t,e,i){if(e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(n.latLng(t),e,this.options.maxBounds),i=i||{},this._stop(),this._loaded&&!i.reset&&i!==!0){void 0!==i.animate&&(i.zoom=n.extend({animate:i.animate},i.zoom),i.pan=n.extend({animate:i.animate,duration:i.duration},i.pan));var o=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,i.zoom):this._tryAnimatedPan(t,i.pan);if(o)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){if(t=n.point(t).round(),e=e||{},!t.x&&!t.y)return this.fire("moveend");if(e.animate!==!0&&!this.getSize().contains(t))return this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new n.PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),e.noMoveStart||this.fire("movestart"),e.animate!==!1){n.DomUtil.addClass(this._mapPane,"leaflet-pan-anim");var i=this._getMapPanePos().subtract(t).round();this._panAnim.run(this._mapPane,i,e.duration||.25,e.easeLinearity)}else this._rawPanBy(t),this.fire("move").fire("moveend");return this},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){n.DomUtil.removeClass(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,e){var i=this._getCenterOffset(t)._floor();return!((e&&e.animate)!==!0&&!this.getSize().contains(i))&&(this.panBy(i,e),!0)}}),n.Map.mergeOptions({zoomAnimation:!0,zoomAnimationThreshold:4});var l=n.DomUtil.TRANSITION&&n.Browser.any3d&&!n.Browser.mobileOpera;l&&n.Map.addInitHook(function(){this._zoomAnimated=this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),n.DomEvent.on(this._proxy,n.DomUtil.TRANSITION_END,this._catchTransitionEnd,this))}),n.Map.include(l?{_createAnimProxy:function(){var t=this._proxy=n.DomUtil.create("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(e){var i=n.DomUtil.TRANSFORM,o=t.style[i];n.DomUtil.setTransform(t,this.project(e.center,e.zoom),this.getZoomScale(e.zoom,1)),o===t.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var e=this.getCenter(),i=this.getZoom();n.DomUtil.setTransform(t,this.project(e,i),this.getZoomScale(i,1))},this)},_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,e,i){if(this._animatingZoom)return!0;if(i=i||{},!this._zoomAnimated||i.animate===!1||this._nothingToAnimate()||Math.abs(e-this._zoom)>this.options.zoomAnimationThreshold)return!1;var o=this.getZoomScale(e),r=this._getCenterOffset(t)._divideBy(1-1/o);return!(i.animate!==!0&&!this.getSize().contains(r))&&(n.Util.requestAnimFrame(function(){this._moveStart(!0)._animateZoom(t,e,!0)},this),!0)},_animateZoom:function(t,e,i,o){i&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=e,n.DomUtil.addClass(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:e,noUpdate:o}),setTimeout(n.bind(this._onZoomTransitionEnd,this),250)},_onZoomTransitionEnd:function(){this._animatingZoom&&(n.DomUtil.removeClass(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),n.Util.requestAnimFrame(function(){this._moveEnd(!0)},this))}}:{}),n.Map.include({flyTo:function(t,e,i){function o(t){var e=t?-1:1,i=t?g:f,o=g*g-f*f+e*b*b*v*v,n=2*i*b*v,r=o/n,s=Math.sqrt(r*r+1)-r,a=s<1e-9?-18:Math.log(s);return a}function r(t){return(Math.exp(t)-Math.exp(-t))/2}function s(t){return(Math.exp(t)+Math.exp(-t))/2}function a(t){return r(t)/s(t)}function l(t){return f*(s(C)/s(C+y*t))}function u(t){return f*(s(C)*a(C+y*t)-r(C))/b}function c(t){return 1-Math.pow(1-t,1.5)}function h(){var i=(Date.now()-w)/k,o=c(i)*x;i<=1?(this._flyToFrame=n.Util.requestAnimFrame(h,this),this._move(this.unproject(d.add(p.subtract(d).multiplyBy(u(o)/v)),m),this.getScaleZoom(f/l(o),m),{flyTo:!0})):this._move(t,e)._moveEnd(!0)}if(i=i||{},i.animate===!1||!n.Browser.any3d)return this.setView(t,e,i);this._stop();var d=this.project(this.getCenter()),p=this.project(t),_=this.getSize(),m=this._zoom;t=n.latLng(t),e=void 0===e?m:e;var f=Math.max(_.x,_.y),g=f*this.getZoomScale(m,e),v=p.distanceTo(d)||1,y=1.42,b=y*y,C=o(0),w=Date.now(),x=(o(1)-C)/y,k=i.duration?1e3*i.duration:1e3*x*.8;return this._moveStart(!0),h.call(this),this},flyToBounds:function(t,e){var i=this._getBoundsCenterZoom(t,e);return this.flyTo(i.center,i.zoom,e)}}),n.extend(n.DomEvent,{_touchstart:n.Browser.msPointer?"MSPointerDown":n.Browser.pointer?"pointerdown":"touchstart",_touchend:n.Browser.msPointer?"MSPointerUp":n.Browser.pointer?"pointerup":"touchend",addDoubleTapListener:function(t,e,i){function o(t){var e;if(e=n.Browser.pointer?n.DomEvent._pointersCount:t.touches.length,!(e>1)){var i=Date.now(),o=i-(s||i);a=t.touches?t.touches[0]:t,l=o>0&&o<=u,s=i}}function r(){if(l&&!a.cancelBubble){if(n.Browser.pointer){var t,i,o={};for(i in a)t=a[i],o[i]=t&&t.bind?t.bind(a):t;a=o}a.type="dblclick",e(a),s=null}}var s,a,l=!1,u=250,c="_leaflet_",h=this._touchstart,d=this._touchend;return t[c+h+i]=o,t[c+d+i]=r,t[c+"dblclick"+i]=e,t.addEventListener(h,o,!1),t.addEventListener(d,r,!1),n.Browser.edge||t.addEventListener("dblclick",e,!1),this},removeDoubleTapListener:function(t,e){var i="_leaflet_",o=t[i+this._touchstart+e],r=t[i+this._touchend+e],s=t[i+"dblclick"+e];return t.removeEventListener(this._touchstart,o,!1),t.removeEventListener(this._touchend,r,!1),n.Browser.edge||t.removeEventListener("dblclick",s,!1),this}}),n.extend(n.DomEvent,{POINTER_DOWN:n.Browser.msPointer?"MSPointerDown":"pointerdown",POINTER_MOVE:n.Browser.msPointer?"MSPointerMove":"pointermove",POINTER_UP:n.Browser.msPointer?"MSPointerUp":"pointerup",POINTER_CANCEL:n.Browser.msPointer?"MSPointerCancel":"pointercancel",TAG_WHITE_LIST:["INPUT","SELECT","OPTION"],_pointers:{},_pointersCount:0,addPointerListener:function(t,e,i,o){return"touchstart"===e?this._addPointerStart(t,i,o):"touchmove"===e?this._addPointerMove(t,i,o):"touchend"===e&&this._addPointerEnd(t,i,o),this},removePointerListener:function(t,e,i){var o=t["_leaflet_"+e+i];return"touchstart"===e?t.removeEventListener(this.POINTER_DOWN,o,!1):"touchmove"===e?t.removeEventListener(this.POINTER_MOVE,o,!1):"touchend"===e&&(t.removeEventListener(this.POINTER_UP,o,!1),t.removeEventListener(this.POINTER_CANCEL,o,!1)),this},_addPointerStart:function(t,e,i){var o=n.bind(function(t){if("mouse"!==t.pointerType&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE){if(!(this.TAG_WHITE_LIST.indexOf(t.target.tagName)<0))return;n.DomEvent.preventDefault(t)}this._handlePointer(t,e)},this);if(t["_leaflet_touchstart"+i]=o,t.addEventListener(this.POINTER_DOWN,o,!1),!this._pointerDocListener){var r=n.bind(this._globalPointerUp,this);document.documentElement.addEventListener(this.POINTER_DOWN,n.bind(this._globalPointerDown,this),!0),document.documentElement.addEventListener(this.POINTER_MOVE,n.bind(this._globalPointerMove,this),!0),document.documentElement.addEventListener(this.POINTER_UP,r,!0),document.documentElement.addEventListener(this.POINTER_CANCEL,r,!0),this._pointerDocListener=!0}},_globalPointerDown:function(t){this._pointers[t.pointerId]=t,this._pointersCount++},_globalPointerMove:function(t){this._pointers[t.pointerId]&&(this._pointers[t.pointerId]=t)},_globalPointerUp:function(t){delete this._pointers[t.pointerId],this._pointersCount--},_handlePointer:function(t,e){t.touches=[];for(var i in this._pointers)t.touches.push(this._pointers[i]);t.changedTouches=[t],e(t)},_addPointerMove:function(t,e,i){var o=n.bind(function(t){(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&"mouse"!==t.pointerType||0!==t.buttons)&&this._handlePointer(t,e)},this);t["_leaflet_touchmove"+i]=o,t.addEventListener(this.POINTER_MOVE,o,!1)},_addPointerEnd:function(t,e,i){var o=n.bind(function(t){this._handlePointer(t,e)},this);t["_leaflet_touchend"+i]=o,t.addEventListener(this.POINTER_UP,o,!1),t.addEventListener(this.POINTER_CANCEL,o,!1)}}),n.Map.mergeOptions({touchZoom:n.Browser.touch&&!n.Browser.android23,bounceAtZoomLimits:!0}),n.Map.TouchZoom=n.Handler.extend({addHooks:function(){n.DomUtil.addClass(this._map._container,"leaflet-touch-zoom"),n.DomEvent.on(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){n.DomUtil.removeClass(this._map._container,"leaflet-touch-zoom"),n.DomEvent.off(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var e=this._map;if(t.touches&&2===t.touches.length&&!e._animatingZoom&&!this._zooming){var i=e.mouseEventToContainerPoint(t.touches[0]),o=e.mouseEventToContainerPoint(t.touches[1]);this._centerPoint=e.getSize()._divideBy(2),this._startLatLng=e.containerPointToLatLng(this._centerPoint),"center"!==e.options.touchZoom&&(this._pinchStartLatLng=e.containerPointToLatLng(i.add(o)._divideBy(2))),this._startDist=i.distanceTo(o),this._startZoom=e.getZoom(),this._moved=!1,this._zooming=!0,e._stop(),n.DomEvent.on(document,"touchmove",this._onTouchMove,this).on(document,"touchend",this._onTouchEnd,this),n.DomEvent.preventDefault(t)}},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var e=this._map,i=e.mouseEventToContainerPoint(t.touches[0]),o=e.mouseEventToContainerPoint(t.touches[1]),r=i.distanceTo(o)/this._startDist;if(this._zoom=e.getScaleZoom(r,this._startZoom),!e.options.bounceAtZoomLimits&&(this._zoom<e.getMinZoom()&&r<1||this._zoom>e.getMaxZoom()&&r>1)&&(this._zoom=e._limitZoom(this._zoom)),"center"===e.options.touchZoom){if(this._center=this._startLatLng,1===r)return}else{var s=i._add(o)._divideBy(2)._subtract(this._centerPoint);if(1===r&&0===s.x&&0===s.y)return;this._center=e.unproject(e.project(this._pinchStartLatLng,this._zoom).subtract(s),this._zoom)}this._moved||(e._moveStart(!0),this._moved=!0),n.Util.cancelAnimFrame(this._animRequest);var a=n.bind(e._move,e,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=n.Util.requestAnimFrame(a,this,!0),n.DomEvent.preventDefault(t)}},_onTouchEnd:function(){return this._moved&&this._zooming?(this._zooming=!1,n.Util.cancelAnimFrame(this._animRequest),n.DomEvent.off(document,"touchmove",this._onTouchMove).off(document,"touchend",this._onTouchEnd),void(this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom)))):void(this._zooming=!1)}}),n.Map.addInitHook("addHandler","touchZoom",n.Map.TouchZoom),n.Map.mergeOptions({tap:!0,tapTolerance:15}),n.Map.Tap=n.Handler.extend({addHooks:function(){n.DomEvent.on(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){n.DomEvent.off(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){if(t.touches){if(n.DomEvent.preventDefault(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var e=t.touches[0],i=e.target;this._startPos=this._newPos=new n.Point(e.clientX,e.clientY),i.tagName&&"a"===i.tagName.toLowerCase()&&n.DomUtil.addClass(i,"leaflet-active"),this._holdTimeout=setTimeout(n.bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",e))},this),1e3),this._simulateEvent("mousedown",e),n.DomEvent.on(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),n.DomEvent.off(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&t&&t.changedTouches){var e=t.changedTouches[0],i=e.target;i&&i.tagName&&"a"===i.tagName.toLowerCase()&&n.DomUtil.removeClass(i,"leaflet-active"),this._simulateEvent("mouseup",e),this._isTapValid()&&this._simulateEvent("click",e)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var e=t.touches[0];this._newPos=new n.Point(e.clientX,e.clientY),this._simulateEvent("mousemove",e)},_simulateEvent:function(t,e){var i=document.createEvent("MouseEvents");i._simulated=!0,e.target._simulatedClick=!0,i.initMouseEvent(t,!0,!0,window,1,e.screenX,e.screenY,e.clientX,e.clientY,!1,!1,!1,!1,0,null),e.target.dispatchEvent(i)}}),n.Browser.touch&&!n.Browser.pointer&&n.Map.addInitHook("addHandler","tap",n.Map.Tap),n.Map.mergeOptions({boxZoom:!0}),n.Map.BoxZoom=n.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){n.DomEvent.on(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){n.DomEvent.off(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_resetState:function(){this._moved=!1},_onMouseDown:function(t){return!(!t.shiftKey||1!==t.which&&1!==t.button)&&(this._resetState(),n.DomUtil.disableTextSelection(),n.DomUtil.disableImageDrag(),this._startPoint=this._map.mouseEventToContainerPoint(t),void n.DomEvent.on(document,{contextmenu:n.DomEvent.stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this))},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=n.DomUtil.create("div","leaflet-zoom-box",this._container),n.DomUtil.addClass(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var e=new n.Bounds(this._point,this._startPoint),i=e.getSize();n.DomUtil.setPosition(this._box,e.min),this._box.style.width=i.x+"px",this._box.style.height=i.y+"px"},_finish:function(){this._moved&&(n.DomUtil.remove(this._box),n.DomUtil.removeClass(this._container,"leaflet-crosshair")),n.DomUtil.enableTextSelection(),n.DomUtil.enableImageDrag(),n.DomEvent.off(document,{contextmenu:n.DomEvent.stop,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){if((1===t.which||1===t.button)&&(this._finish(),this._moved)){setTimeout(n.bind(this._resetState,this),0);var e=new n.LatLngBounds(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(e).fire("boxzoomend",{boxZoomBounds:e})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}}),n.Map.addInitHook("addHandler","boxZoom",n.Map.BoxZoom),n.Map.mergeOptions({keyboard:!0,keyboardPanDelta:80}),n.Map.Keyboard=n.Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),n.DomEvent.on(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),n.DomEvent.off(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var t=document.body,e=document.documentElement,i=t.scrollTop||e.scrollTop,o=t.scrollLeft||e.scrollLeft;this._map._container.focus(),window.scrollTo(o,i)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){var e,i,o=this._panKeys={},n=this.keyCodes;for(e=0,i=n.left.length;e<i;e++)o[n.left[e]]=[-1*t,0];for(e=0,i=n.right.length;e<i;e++)o[n.right[e]]=[t,0];for(e=0,i=n.down.length;e<i;e++)o[n.down[e]]=[0,t];for(e=0,i=n.up.length;e<i;e++)o[n.up[e]]=[0,-1*t]},_setZoomDelta:function(t){var e,i,o=this._zoomKeys={},n=this.keyCodes;for(e=0,i=n.zoomIn.length;e<i;e++)o[n.zoomIn[e]]=t;for(e=0,i=n.zoomOut.length;e<i;e++)o[n.zoomOut[e]]=-t},_addHooks:function(){n.DomEvent.on(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){n.DomEvent.off(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e,i=t.keyCode,o=this._map;if(i in this._panKeys){if(o._panAnim&&o._panAnim._inProgress)return;e=this._panKeys[i],t.shiftKey&&(e=n.point(e).multiplyBy(3)),o.panBy(e),o.options.maxBounds&&o.panInsideBounds(o.options.maxBounds)}else if(i in this._zoomKeys)o.setZoom(o.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[i]);else{if(27!==i)return;o.closePopup()}n.DomEvent.stop(t)}}}),n.Map.addInitHook("addHandler","keyboard",n.Map.Keyboard),n.Handler.MarkerDrag=n.Handler.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new n.Draggable(t,t,(!0))),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),n.DomUtil.addClass(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&n.DomUtil.removeClass(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onDrag:function(t){var e=this._marker,i=e._shadow,o=n.DomUtil.getPosition(e._icon),r=e._map.layerPointToLatLng(o);i&&n.DomUtil.setPosition(i,o),e._latlng=r,t.latlng=r,t.oldLatLng=this._oldLatLng,e.fire("move",t).fire("drag",t)},_onDragEnd:function(t){delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),n.Control=n.Class.extend({options:{position:"topright"},initialize:function(t){n.setOptions(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var e=this._map;return e&&e.removeControl(this),this.options.position=t,e&&e.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var e=this._container=this.onAdd(t),i=this.getPosition(),o=t._controlCorners[i];return n.DomUtil.addClass(e,"leaflet-control"),i.indexOf("bottom")!==-1?o.insertBefore(e,o.firstChild):o.appendChild(e),this},remove:function(){return this._map?(n.DomUtil.remove(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(t){this._map&&t&&t.screenX>0&&t.screenY>0&&this._map.getContainer().focus()}}),n.control=function(t){return new n.Control(t)},n.Map.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){function t(t,r){var s=i+t+" "+i+r;e[t+r]=n.DomUtil.create("div",s,o)}var e=this._controlCorners={},i="leaflet-",o=this._controlContainer=n.DomUtil.create("div",i+"control-container",this._container);t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){n.DomUtil.remove(this._controlContainer)}}),n.Control.Zoom=n.Control.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"-",zoomOutTitle:"Zoom out"},onAdd:function(t){var e="leaflet-control-zoom",i=n.DomUtil.create("div",e+" leaflet-bar"),o=this.options;return this._zoomInButton=this._createButton(o.zoomInText,o.zoomInTitle,e+"-in",i,this._zoomIn),this._zoomOutButton=this._createButton(o.zoomOutText,o.zoomOutTitle,e+"-out",i,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),i},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,e,i,o,r){var s=n.DomUtil.create("a",i,o);return s.innerHTML=t,s.href="#",s.title=e,n.DomEvent.on(s,"mousedown dblclick",n.DomEvent.stopPropagation).on(s,"click",n.DomEvent.stop).on(s,"click",r,this).on(s,"click",this._refocusOnMap,this),s},_updateDisabled:function(){var t=this._map,e="leaflet-disabled";n.DomUtil.removeClass(this._zoomInButton,e),n.DomUtil.removeClass(this._zoomOutButton,e),(this._disabled||t._zoom===t.getMinZoom())&&n.DomUtil.addClass(this._zoomOutButton,e),(this._disabled||t._zoom===t.getMaxZoom())&&n.DomUtil.addClass(this._zoomInButton,e)}}),n.Map.mergeOptions({zoomControl:!0}),n.Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new n.Control.Zoom,this.addControl(this.zoomControl))}),n.control.zoom=function(t){return new n.Control.Zoom(t)},n.Control.Attribution=n.Control.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(t){n.setOptions(this,t),this._attributions={}},onAdd:function(t){t.attributionControl=this,this._container=n.DomUtil.create("div","leaflet-control-attribution"),n.DomEvent&&n.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return this._update(),this._container},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):this},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):this},_update:function(){if(this._map){var t=[];for(var e in this._attributions)this._attributions[e]&&t.push(e);var i=[];this.options.prefix&&i.push(this.options.prefix),t.length&&i.push(t.join(", ")),this._container.innerHTML=i.join(" | ")}}}),n.Map.mergeOptions({attributionControl:!0}),n.Map.addInitHook(function(){this.options.attributionControl&&(new n.Control.Attribution).addTo(this)}),n.control.attribution=function(t){return new n.Control.Attribution(t)},n.Control.Scale=n.Control.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var e="leaflet-control-scale",i=n.DomUtil.create("div",e),o=this.options;return this._addScales(o,e+"-line",i),t.on(o.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,e,i){
	t.metric&&(this._mScale=n.DomUtil.create("div",e,i)),t.imperial&&(this._iScale=n.DomUtil.create("div",e,i))},_update:function(){var t=this._map,e=t.getSize().y/2,i=t.distance(t.containerPointToLatLng([0,e]),t.containerPointToLatLng([this.options.maxWidth,e]));this._updateScales(i)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var e=this._getRoundNum(t),i=e<1e3?e+" m":e/1e3+" km";this._updateScale(this._mScale,i,e/t)},_updateImperial:function(t){var e,i,o,n=3.2808399*t;n>5280?(e=n/5280,i=this._getRoundNum(e),this._updateScale(this._iScale,i+" mi",i/e)):(o=this._getRoundNum(n),this._updateScale(this._iScale,o+" ft",o/n))},_updateScale:function(t,e,i){t.style.width=Math.round(this.options.maxWidth*i)+"px",t.innerHTML=e},_getRoundNum:function(t){var e=Math.pow(10,(Math.floor(t)+"").length-1),i=t/e;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:1,e*i}}),n.control.scale=function(t){return new n.Control.Scale(t)},n.Control.Layers=n.Control.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1},initialize:function(t,e,i){n.setOptions(this,i),this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var o in t)this._addLayer(t[o],o);for(o in e)this._addLayer(e[o],o,!0)},onAdd:function(t){return this._initLayout(),this._update(),this._map=t,t.on("zoomend",this._checkDisabledLayers,this),this._container},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,e){return this._addLayer(t,e),this._map?this._update():this},addOverlay:function(t,e){return this._addLayer(t,e,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);var e=this._getLayer(n.stamp(t));return e&&this._layers.splice(this._layers.indexOf(e),1),this._map?this._update():this},expand:function(){n.DomUtil.addClass(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._form.clientHeight?(n.DomUtil.addClass(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=t+"px"):n.DomUtil.removeClass(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return n.DomUtil.removeClass(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",e=this._container=n.DomUtil.create("div",t);e.setAttribute("aria-haspopup",!0),n.DomEvent.disableClickPropagation(e),n.Browser.touch||n.DomEvent.disableScrollPropagation(e);var i=this._form=n.DomUtil.create("form",t+"-list");if(this.options.collapsed){n.Browser.android||n.DomEvent.on(e,{mouseenter:this.expand,mouseleave:this.collapse},this);var o=this._layersLink=n.DomUtil.create("a",t+"-toggle",e);o.href="#",o.title="Layers",n.Browser.touch?n.DomEvent.on(o,"click",n.DomEvent.stop).on(o,"click",this.expand,this):n.DomEvent.on(o,"focus",this.expand,this),n.DomEvent.on(i,"click",function(){setTimeout(n.bind(this._onInputClick,this),0)},this),this._map.on("click",this.collapse,this)}else this.expand();this._baseLayersList=n.DomUtil.create("div",t+"-base",i),this._separator=n.DomUtil.create("div",t+"-separator",i),this._overlaysList=n.DomUtil.create("div",t+"-overlays",i),e.appendChild(i)},_getLayer:function(t){for(var e=0;e<this._layers.length;e++)if(this._layers[e]&&n.stamp(this._layers[e].layer)===t)return this._layers[e]},_addLayer:function(t,e,i){t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:e,overlay:i}),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex))},_update:function(){if(!this._container)return this;n.DomUtil.empty(this._baseLayersList),n.DomUtil.empty(this._overlaysList);var t,e,i,o,r=0;for(i=0;i<this._layers.length;i++)o=this._layers[i],this._addItem(o),e=e||o.overlay,t=t||!o.overlay,r+=o.overlay?0:1;return this.options.hideSingleBase&&(t=t&&r>1,this._baseLayersList.style.display=t?"":"none"),this._separator.style.display=e&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var e=this._getLayer(n.stamp(t.target)),i=e.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;i&&this._map.fire(i,e)},_createRadioElement:function(t,e){var i='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(e?' checked="checked"':"")+"/>",o=document.createElement("div");return o.innerHTML=i,o.firstChild},_addItem:function(t){var e,i=document.createElement("label"),o=this._map.hasLayer(t.layer);t.overlay?(e=document.createElement("input"),e.type="checkbox",e.className="leaflet-control-layers-selector",e.defaultChecked=o):e=this._createRadioElement("leaflet-base-layers",o),e.layerId=n.stamp(t.layer),n.DomEvent.on(e,"click",this._onInputClick,this);var r=document.createElement("span");r.innerHTML=" "+t.name;var s=document.createElement("div");i.appendChild(s),s.appendChild(e),s.appendChild(r);var a=t.overlay?this._overlaysList:this._baseLayersList;return a.appendChild(i),this._checkDisabledLayers(),i},_onInputClick:function(){var t,e,i,o=this._form.getElementsByTagName("input"),n=[],r=[];this._handlingClick=!0;for(var s=o.length-1;s>=0;s--)t=o[s],e=this._getLayer(t.layerId).layer,i=this._map.hasLayer(e),t.checked&&!i?n.push(e):!t.checked&&i&&r.push(e);for(s=0;s<r.length;s++)this._map.removeLayer(r[s]);for(s=0;s<n.length;s++)this._map.addLayer(n[s]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,e,i=this._form.getElementsByTagName("input"),o=this._map.getZoom(),n=i.length-1;n>=0;n--)t=i[n],e=this._getLayer(t.layerId).layer,t.disabled=void 0!==e.options.minZoom&&o<e.options.minZoom||void 0!==e.options.maxZoom&&o>e.options.maxZoom},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),n.control.layers=function(t,e,i){return new n.Control.Layers(t,e,i)},n.Map.include({_defaultLocateOptions:{timeout:1e4,watch:!1},locate:function(t){if(t=this._locateOptions=n.extend({},this._defaultLocateOptions,t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var e=n.bind(this._handleGeolocationResponse,this),i=n.bind(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(e,i,t):navigator.geolocation.getCurrentPosition(e,i,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var e=t.code,i=t.message||(1===e?"permission denied":2===e?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:e,message:"Geolocation error: "+i+"."})},_handleGeolocationResponse:function(t){var e=t.coords.latitude,i=t.coords.longitude,o=new n.LatLng(e,i),r=o.toBounds(t.coords.accuracy),s=this._locateOptions;if(s.setView){var a=this.getBoundsZoom(r);this.setView(o,s.maxZoom?Math.min(a,s.maxZoom):a)}var l={latlng:o,bounds:r,timestamp:t.timestamp};for(var u in t.coords)"number"==typeof t.coords[u]&&(l[u]=t.coords[u]);this.fire("locationfound",l)}})},{}],8:[function(t,e,i){function o(){throw new Error("setTimeout has not been defined")}function n(){throw new Error("clearTimeout has not been defined")}function r(t){if(h===setTimeout)return setTimeout(t,0);if((h===o||!h)&&setTimeout)return h=setTimeout,setTimeout(t,0);try{return h(t,0)}catch(e){try{return h.call(null,t,0)}catch(e){return h.call(this,t,0)}}}function s(t){if(d===clearTimeout)return clearTimeout(t);if((d===n||!d)&&clearTimeout)return d=clearTimeout,clearTimeout(t);try{return d(t)}catch(e){try{return d.call(null,t)}catch(e){return d.call(this,t)}}}function a(){f&&_&&(f=!1,_.length?m=_.concat(m):g=-1,m.length&&l())}function l(){if(!f){var t=r(a);f=!0;for(var e=m.length;e;){for(_=m,m=[];++g<e;)_&&_[g].run();g=-1,e=m.length}_=null,f=!1,s(t)}}function u(t,e){this.fun=t,this.array=e}function c(){}var h,d,p=e.exports={};!function(){try{h="function"==typeof setTimeout?setTimeout:o}catch(t){h=o}try{d="function"==typeof clearTimeout?clearTimeout:n}catch(t){d=n}}();var _,m=[],f=!1,g=-1;p.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var i=1;i<arguments.length;i++)e[i-1]=arguments[i];m.push(new u(t,e)),1!==m.length||f||r(l)},u.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},{}],9:[function(t,e,o){!function(t,e){"use strict";function o(e,i,o){e._eventHandlers=e._eventHandlers||[{element:e.scroller,handler:function(t){e.scroll(t)},type:"scroll"},{element:e.bar,handler:function(t){t.preventDefault?t.preventDefault():t.returnValue=!1,e.selection(),e.drag.now=1},type:"touchstart mousedown"},{element:document,handler:function(){e.selection(1),e.drag.now=0},type:"mouseup blur touchend"},{element:e.bar,handler:function(t){2!=t.button&&e._pos0(t)},type:"touchstart mousedown"},{element:document,handler:function(t){e.drag.now&&e.drag(t)},type:"mousemove touchmove"},{element:t,handler:function(){e.update()},type:"resize"},{element:e.root,handler:function(){e.update()},type:"sizeChange"}],d(e._eventHandlers,function(t){t.element&&i(t.element,t.type,t.handler,o)})}function n(t,e,i){var o="data-baron-"+e;if("on"==i)t.setAttribute(o,"inited");else{if("off"!=i)return t.getAttribute(o);t.removeAttribute(o)}}function r(t){if(!n(t.root,t.direction)){var e=new _.prototype.constructor(t);return o(e,t.event,"on"),n(e.root,t.direction,"on"),e.update(),e}}function s(t){var e={};t=t||{};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return e}function a(t){var e=s(t);e.direction=e.direction||"v";var i=t.event||function(t,i,o,n){e.$(t)[n||"on"](i,o)};return e.event=function(t,e,o,n){d(t,function(t){i(t,e,o,n)})},e}function l(t){if(this.events&&this.events[t])for(var e=0;e<this.events[t].length;e++){var i=Array.prototype.slice.call(arguments,1);this.events[t][e].apply(this,i)}}if(t){var u=t.baron,c=t.jQuery,h={v:{x:"Y",pos:"top",crossPos:"left",size:"height",crossSize:"width",client:"clientHeight",crossClient:"clientWidth",offset:"offsetHeight",crossOffset:"offsetWidth",offsetPos:"offsetTop",scroll:"scrollTop",scrollSize:"scrollHeight"},h:{x:"X",pos:"left",crossPos:"top",size:"width",crossSize:"height",client:"clientWidth",crossClient:"clientHeight",offset:"offsetWidth",crossOffset:"offsetHeight",offsetPos:"offsetLeft",scroll:"scrollLeft",scrollSize:"scrollWidth"}},d=function(i,o){var n=0;for(i.length!==e&&i!==t||(i=[i]);i[n];)o.call(this,i[n],n),n++},p=function(e){var i,o,n=!1;return e=e||{},o=e.$||t.jQuery,n?e.root=i=this:i=o(e.root||e.scroller),new p.fn.constructor(i,e,o)};p.fn={constructor:function(t,e,i){var o=a(e);o.$=i,d.call(this,t,function(t,e){var i=s(o);o.root&&o.scroller?(i.scroller=o.$(o.scroller,t),i.scroller.length||(i.scroller=t)):i.scroller=t,i.root=t,this[e]=r(i),this.length=e+1}),this.params=o},dispose:function(){var t=this.params;d(this,function(e){e.dispose(t)}),this.params=null},update:function(){for(var t=0;this[t];)this[t].update.apply(this[t],arguments),t++},baron:function(t){return t.root=[],t.scroller=this.params.scroller,d.call(this,this,function(e){t.root.push(e.root)}),t.direction="v"==this.params.direction?"h":"v",t._chain=!0,p(t)}};var _={};_.prototype={constructor:function(t){function i(t,e){return c(t,e)[0]}function o(t){var e=this.barMinSize||20;t>0&&t<e&&(t=e),this.bar&&c(this.bar).css(this.origin.size,parseInt(t,10)+"px")}function n(t){this.bar&&c(this.bar).css(this.origin.pos,+t+"px")}function r(){return _[this.origin.client]-this.barTopLimit-this.bar[this.origin.offset]}function s(t){return t*r.call(this)+this.barTopLimit}function a(t){return(t-this.barTopLimit)/r.call(this)}function u(){return!1}var c,d,p,_,m,f,g,v,y;return y=v=(new Date).getTime(),c=this.$=t.$,this.event=t.event,this.events={},this.root=t.root,this.scroller=i(t.scroller),this.bar=i(t.bar,this.root),_=this.track=i(t.track,this.root),!this.track&&this.bar&&(_=this.bar.parentNode),this.clipper=this.scroller.parentNode,this.direction=t.direction,this.origin=h[this.direction],this.barOnCls=t.barOnCls,this.barTopLimit=0,g=1e3*t.pause||0,this.cursor=function(t){return t["client"+this.origin.x]||(((t.originalEvent||t).touches||{})[0]||{})["page"+this.origin.x]},this.pos=function(t){var i="page"+this.origin.x+"Offset",o=this.scroller[i]?i:this.origin.scroll;return t!==e&&(this.scroller[o]=t),this.scroller[o]},this.rpos=function(t){var e,i=this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client];return e=t?this.pos(t*i):this.pos(),e/(i||1)},this.barOn=function(t){this.barOnCls&&(t||this.scroller[this.origin.client]>=this.scroller[this.origin.scrollSize]?c(this.root).removeClass(this.barOnCls):c(this.root).addClass(this.barOnCls))},this._pos0=function(t){p=this.cursor(t)-d},this.drag=function(t){this.scroller[this.origin.scroll]=a.call(this,this.cursor(t)-p)*(this.scroller[this.origin.scrollSize]-this.scroller[this.origin.client])},this.selection=function(t){this.event(document,"selectpos selectstart",u,t?"off":"on")},this.resize=function(){function e(){var e=i.scroller[i.origin.crossOffset]-i.scroller[i.origin.crossClient];t.freeze&&!i.clipper.style[i.origin.crossSize]&&c(i.clipper).css(i.origin.crossSize,i.clipper[i.origin.crossClient]-e+"px"),c(i.scroller).css(i.origin.crossSize,i.clipper[i.origin.crossClient]+e+"px"),Array.prototype.unshift.call(arguments,"resize"),l.apply(i,arguments),y=(new Date).getTime()}var i=this,o=0;(new Date).getTime()-y<g&&(clearTimeout(m),o=g),o?m=setTimeout(e,o):e()},this.scroll=function(){function t(){a.bar&&(i=(_[a.origin.client]-a.barTopLimit)*a.scroller[a.origin.client]/a.scroller[a.origin.scrollSize],e!=i&&(o.call(a,i),e=i),d=s.call(a,a.rpos()),n.call(a,d)),Array.prototype.unshift.call(arguments,"scroll"),l.apply(a,arguments),v=(new Date).getTime()}var e,i,r=0,a=this;(new Date).getTime()-v<g&&(clearTimeout(f),r=g),r?f=setTimeout(t,r):t()},this},update:function(t){return l.call(this,"upd",t),this.resize(1),this.barOn(),this.scroll(),this},dispose:function(t){o(this,this.event,"off"),n(this.root,t.direction,"off"),c(this.scroller).css(this.origin.crossSize,""),this.barOn(!0),l.call(this,"dispose")},on:function(t,e,i){for(var o=t.split(" "),n=0;n<o.length;n++)"init"==o[n]?e.call(this,i):(this.events[o[n]]=this.events[o[n]]||[],this.events[o[n]].push(function(t){e.call(this,t||i)}))}},p.fn.constructor.prototype=p.fn,_.prototype.constructor.prototype=_.prototype,p.noConflict=function(){return t.baron=u,p},p.version="0.6.6",c&&c.fn&&(c.fn.baron=p),t.baron=p;var m=function(t){function o(t,i){a<(l.minView||0)&&(i=e),i!==e?(i+="px",this.$(s[t]).css(this.origin.pos,i).addClass(l.outside)):this.$(s[t]).css(this.origin.pos,"").removeClass(l.outside)}function n(t){try{i=document.createEvent("WheelEvent"),i.initWebKitWheelEvent(t.originalEvent.wheelDeltaX,t.originalEvent.wheelDeltaY),d.dispatchEvent(i),t.preventDefault()}catch(t){}}function r(t){var e;for(var i in t)l[i]=t[i];if(s=this.$(l.elements,this.scroller)){a=this.scroller[this.origin.client];for(var o=0;o<s.length;o++)e={},e[this.origin.size]=s[o][this.origin.offset],s[o].parentNode!==this.scroller&&this.$(s[o].parentNode).css(e),e={},e[this.origin.crossSize]=s[o].parentNode[this.origin.crossClient],this.$(s[o]).css(e),a-=s[o][this.origin.offset],h[o]=s[o].parentNode[this.origin.offsetPos],u[o]=u[o-1]||0,c[o]=c[o-1]||Math.min(h[o],0),s[o-1]&&(u[o]+=s[o-1][this.origin.offset],c[o]+=s[o-1][this.origin.offset]),0==o&&0==h[o]||(this.event(s[o],"mousewheel",n,"off"),this.event(s[o],"mousewheel",n));l.limiter&&s[0]&&(this.track&&this.track!=this.scroller?(e={},e[this.origin.pos]=s[0].parentNode[this.origin.offset],this.$(this.track).css(e)):this.barTopLimit=s[0].parentNode[this.origin.offset],this.scroll()),l.limiter===!1&&(this.barTopLimit=0)}var r={element:s,handler:function(){for(var t,e=_(this)[0].parentNode,i=e.offsetTop,o=0;o<s.length;o++)s[o]===this&&(t=o);var n=i-u[t];l.scroll?l.scroll({x1:m.scroller.scrollTop,x2:n}):m.scroller.scrollTop=n},type:"click"};l.clickable&&(this._eventHandlers.push(r),p(r.element,r.type,r.handler,"off"),p(r.element,r.type,r.handler,"on"))}var s,a,l={outside:"",before:"",after:"",past:"",future:"",radius:0,minView:0},u=[],c=[],h=[],d=this.scroller,p=this.event,_=this.$,m=this;this.on("init",r,t),this.on("init scroll",function(){var t,i,n=[];if(s){for(var r,d=0;d<s.length;d++)t=0,h[d]-this.pos()<c[d]+l.radius?(t=1,i=u[d]):h[d]-this.pos()>c[d]+a-l.radius?(t=2,i=u[d]+a):(t=3,i=e),t!=n[d]&&(o.call(this,d,i),n[d]=t,r=!0);if(r)for(d=0;d<s.length;d++)1==n[d]&&l.past&&this.$(s[d]).addClass(l.past).removeClass(l.future),2==n[d]&&l.future&&this.$(s[d]).addClass(l.future).removeClass(l.past),3==n[d]&&(l.future||l.past)&&this.$(s[d]).removeClass(l.past).removeClass(l.future),n[d]!=n[d+1]&&1==n[d]&&l.before?this.$(s[d]).addClass(l.before).removeClass(l.after):n[d]!=n[d-1]&&2==n[d]&&l.after?this.$(s[d]).addClass(l.after).removeClass(l.before):this.$(s[d]).removeClass(l.before).removeClass(l.after)}}),this.on("resize upd",function(t){r.call(this,t&&t.fix)})};p.fn.fix=function(t){for(var e=0;this[e];)m.call(this[e],t),e++;return this};var f=function(t){var e,i,o,n,r=this;n=t.screen||.9,t.forward&&(e=this.$(t.forward,this.clipper),this.event(e,"click",function(){var e=r.pos()-t.delta||30;r.pos(e)})),t.backward&&(i=this.$(t.backward,this.clipper),this.event(i,"click",function(){var e=r.pos()+t.delta||30;r.pos(e)})),t.track&&(o=t.track===!0?this.track:this.$(t.track,this.clipper)[0],o&&this.event(o,"mousedown",function(t){var e=t["offset"+r.origin.x],i=r.bar[r.origin.offsetPos],o=0;e<i?o=-1:e>i+r.bar[r.origin.offset]&&(o=1);var s=r.pos()+o*n*r.scroller[r.origin.client];r.pos(s)}))};p.fn.controls=function(t){for(var e=0;this[e];)f.call(this[e],t),e++;return this};var g=function(t){function e(){return g.scroller[g.origin.scroll]+g.scroller[g.origin.offset]}function i(){return g.scroller[g.origin.scrollSize]}function o(){return g.scroller[g.origin.client]}function n(t,e){var i=5e-4*t;return Math.floor(e-i*(t+550))}function r(t){c=t,t?(s(),a=setInterval(s,200)):clearInterval(a)}function s(){var s,a,c={},w=e(),x=i(),k=1==v;if(a=0,v>0&&(a=40),s=n(b,a),w>=x-b&&v>-1?k&&(b+=s):b=0,b<0&&(b=0),c[d]=b+"px",o()<=i()){g.$(h).css(c);for(var D=0;D<m.length;D++)g.$(m[D].self).css(m[D].property,Math.min(b/p*100,100)+"%")}f&&b&&g.$(g.root).addClass(f),0==b&&t.onCollapse&&t.onCollapse(),v=0,l=setTimeout(function(){v=-1},C),_&&b>p&&!u&&(_(),u=!0),0==b?y++:y=0,y>1&&(r(!1),u=!1,f&&g.$(g.root).removeClass(f))}var a,l,u,c,h=this.$(t.block),d=t.size||this.origin.size,p=t.limit||80,_=t.onExpand,m=t.elements||[],f=t.inProgress||"",g=this,v=0,y=0,b=0,C=t.waiting||500;this.on("init",function(){r(!0)}),this.on("dispose",function(){r(!1)}),this.event(this.scroller,"mousewheel DOMMouseScroll",function(t){var o=t.wheelDelta<0||t.originalEvent&&t.originalEvent.wheelDelta<0||t.detail>0;o&&(v=1,clearTimeout(l),!c&&e()>=i()&&r(!0))})};p.fn.pull=function(t){for(var e=0;this[e];)g.call(this[e],t),e++;return this}}}(window)},{}]},{},[2])(2)});
	//# sourceMappingURL=script.full.js.map


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	  }
	
	  _createClass(Button, [{
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      e.preventDefault();
	      this.props.onSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'button',
	        { className: 'button ' + classes,
	          onMouseEnter: this.props.onMouseEnter,
	          onMouseLeave: this.props.onMouseLeave,
	          onClick: this.props.onClick,
	          onSubmit: this.onSubmit.bind(this)
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	exports.default = Button;

/***/ },
/* 22 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(183);
	var PooledClass = __webpack_require__(42);
	var ReactFeatureFlags = __webpack_require__(191);
	var ReactReconciler = __webpack_require__(43);
	var Transaction = __webpack_require__(77);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(42);
	
	var emptyFunction = __webpack_require__(25);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var addField = exports.addField = function addField(field, value) {
	  return function (dispatch) {
	    dispatch({ type: 'FIELD_VALUE', field: field, value: value });
	  };
	};
	
	var deleteField = exports.deleteField = function deleteField(field) {
	  return function (dispatch) {
	    dispatch({ type: 'DELETE_FIELD', field: field });
	  };
	};
	
	var clearFields = exports.clearFields = function clearFields() {
	  return function (dispatch) {
	    dispatch({ type: 'CLEAR_FIELDS' });
	  };
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(47)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 32 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setInitialState = exports.fixServerError = exports.validationFailed = exports.downloadInstituteList = exports.downloadSchoolList = exports.postSaveRestore = exports.postRestore = exports.postAuth = exports.postRegister = exports.formSubmit = undefined;
	
	__webpack_require__(34);
	
	var _reactRouter = __webpack_require__(12);
	
	var _participantAction = __webpack_require__(65);
	
	var formSubmit = exports.formSubmit = function formSubmit() {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    dispatch({ type: 'FORM_SUBMIT' });
	    setTimeout(function () {
	      dispatch({ type: 'AFTER_VALIDATE' });
	    }, 500);
	  };
	};
	
	var postRegister = exports.postRegister = function postRegister(regData) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    fetch('/api/signup-submit.json', {
	      method: 'post',
	      body: regData
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'REGISTRATION_SUCCESS',
	          successMessage: json.successMessage
	        });
	      } else {
	        dispatch({
	          type: 'ERRORS_FROM_SERVER',
	          errors: json.errors
	        });
	      }
	      window.scrollTo(0, 0);
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	};
	
	var postAuth = exports.postAuth = function postAuth(authData) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    fetch('/api/j_spring_security_check', {
	      method: 'post',
	      body: authData,
	      credentials: 'include',
	      headers: {
	        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
	        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
	      }
	    }).then(function (response) {
	      if (response.ok) {
	        dispatch({
	          type: 'AUTH_SUCCESS'
	        });
	        (0, _participantAction.getUserQuery)(dispatch);
	        _reactRouter.browserHistory.push('/');
	      } else {
	        dispatch({
	          type: 'AUTH_FAIL',
	          failMessage: 'Email или пароль не верны.'
	        });
	        window.scrollTo(0, 0);
	      }
	    }).catch(function (err) {
	      console.log(err);
	      //TODO:: remove 2 lines after error fixing:
	      //Mixed Content: The page at 'https://happydev-lite.ru/auth' was loaded over HTTPS, but requested an insecure resource 'http://happydev-lite.ru/'. This request has been blocked; the content must be served over HTTPS.
	      //Fetch API cannot load https://happydev-lite.ru/api/j_spring_security_check. Redirect failed.
	      //TypeError: Failed to fetch
	      (0, _participantAction.getUserQuery)(dispatch);
	      _reactRouter.browserHistory.push('/');
	    });
	  };
	};
	var postRestore = exports.postRestore = function postRestore(regData) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    fetch('/api/restore-password.json', {
	      method: 'post',
	      body: regData
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'RESTORE_SUCCESS',
	          successMessage: json.successMessage
	        });
	      } else {
	        dispatch({
	          type: 'ERRORS_FROM_SERVER',
	          errors: json.errors
	        });
	      }
	      window.scrollTo(0, 0);
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	};
	
	var postSaveRestore = exports.postSaveRestore = function postSaveRestore(regData) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    fetch('/api/set-password.json', {
	      method: 'post',
	      body: regData
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'RESTORE_SAVE_SUCCESS',
	          successMessage: json.successMessage
	        });
	      } else {
	        if (json.errors) {
	          dispatch({
	            type: 'ERRORS_FROM_SERVER',
	            errors: json.errors
	          });
	        } else {
	          dispatch({
	            type: 'RESTORE_SAVE_FAIL',
	            message: 'Возможно вы уже сбросили пароль. Если нет, проверьте почту ещё раз'
	          });
	        }
	      }
	      window.scrollTo(0, 0);
	    }).catch(function (err) {
	      console.log(err);
	    });
	  };
	};
	
	var downloadSchoolList = exports.downloadSchoolList = function downloadSchoolList() {
	  return function (dispatch) {
	    fetch('/api/schools-dictionary.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'SCHOOL_LIST',
	          schoolList: json.schoolViewList
	        });
	      }
	    });
	  };
	};
	
	var downloadInstituteList = exports.downloadInstituteList = function downloadInstituteList() {
	  return function (dispatch) {
	    fetch('/api/institutes-dictionary1.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'INSTITUTE_LIST',
	          instituteList: json.instituteViewList
	        });
	      }
	    });
	  };
	};
	
	var validationFailed = exports.validationFailed = function validationFailed() {
	  return function (dispatch) {
	    dispatch({ type: 'VALIDATION_FAILED' });
	  };
	};
	
	var fixServerError = exports.fixServerError = function fixServerError(serverErrors, field) {
	  return function (dispatch) {
	    delete serverErrors[field];
	    dispatch({
	      type: 'FIX_SERVER_ERROR',
	      serverErrors: serverErrors
	    });
	  };
	};
	
	var setInitialState = exports.setInitialState = function setInitialState() {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	  };
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(22);
	var ctx = __webpack_require__(150);
	var hide = __webpack_require__(48);
	var has = __webpack_require__(37);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 37 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(152);
	var toPrimitive = __webpack_require__(97);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(153);
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(421)();
	}


/***/ },
/* 42 */
[561, 3],
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(465);
	var ReactInstrumentation = __webpack_require__(20);
	
	var warning = __webpack_require__(5);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(221);
	var ReactChildren = __webpack_require__(539);
	var ReactDOMFactories = __webpack_require__(540);
	var ReactElement = __webpack_require__(56);
	var ReactPropTypes = __webpack_require__(541);
	var ReactVersion = __webpack_require__(542);
	
	var createReactClass = __webpack_require__(543);
	var onlyChild = __webpack_require__(547);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REGEXP_VALID_EMAIL_ADDRESS = /^[-\w.+]+@([A-zА-яЁё0-9][-A-zА-яЁё0-9]+\.)+[A-zА-яЁё]{2,6}$/i;
	
	var notEmptyHandler = exports.notEmptyHandler = function notEmptyHandler(field) {
	  if (field.value === '') {
	    return 'Пожалуйста, заполните поле';
	  }
	  return null;
	};
	
	var emailHandler = exports.emailHandler = function emailHandler(field) {
	
	  var errors = notEmptyHandler(field);
	  if (errors != null) {
	    return errors;
	  } else if (field.value.search(REGEXP_VALID_EMAIL_ADDRESS) === -1) {
	    return 'Некорректный email';
	  }
	
	  return null;
	};
	
	var phoneHandler = exports.phoneHandler = function phoneHandler(field) {
	  var phoneReg = /^(\+)?(\d{6,12})$/i;
	  var errors = notEmptyHandler(field);
	  if (errors != null) {
	    return errors;
	  } else if (field.value.search(phoneReg) === -1) {
	    return 'Некорректный номер телефона';
	  }
	
	  return null;
	};
	
	var passwordHandler = exports.passwordHandler = function passwordHandler(field) {
	  if (field.value.length < 8) {
	    return 'Должен быть длиннее 8 символов';
	  }
	  return null;
	};
	
	var newPasswordHandler = exports.newPasswordHandler = function newPasswordHandler(field) {
	  if (field.value.length !== 0) {
	    return passwordHandler(field);
	  }
	  return null;
	};
	
	var newNotEmptyHandler = exports.newNotEmptyHandler = function newNotEmptyHandler(fieldValue) {
	  if (fieldValue === '') {
	    return 'Пожалуйста, заполните поле';
	  }
	  return null;
	};
	
	var newEmailHandler = exports.newEmailHandler = function newEmailHandler(fieldValue) {
	
	  var errors = newNotEmptyHandler(fieldValue);
	  if (errors != null) {
	    return errors;
	  } else if (fieldValue.search(REGEXP_VALID_EMAIL_ADDRESS) === -1) {
	    return 'Некорректный email';
	  }
	
	  return null;
	};

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(38);
	var createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(31) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(95)('wks');
	var uid = __webpack_require__(72);
	var Symbol = __webpack_require__(32).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(445);


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(107);
	var setInnerHTML = __webpack_require__(79);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	var setTextContent = __webpack_require__(206);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(225);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(223);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(8);
	
	var _authAction = __webpack_require__(35);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormField = function (_Component) {
	  _inherits(FormField, _Component);
	
	  function FormField() {
	    _classCallCheck(this, FormField);
	
	    return _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).apply(this, arguments));
	  }
	
	  _createClass(FormField, [{
	    key: 'onFocus',
	    value: function onFocus() {
	      this.refs.errorMessage.innerHTML = '';
	      this.refs.input.classList.remove('field-element__field_error');
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.props.fixServerError(Object.assign({}, this.props.serverErrors), this.props.fieldName);
	      this.checkField();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.deleteField(this.props.fieldName);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.validate) {
	        this.checkField();
	      }
	    }
	  }, {
	    key: 'checkField',
	    value: function checkField() {
	      if (this.refs.input !== undefined) {
	        var fieldName = this.props.fieldName;
	        var msg = null;
	        if (fieldName in this.props.serverErrors) {
	          msg = this.props.serverErrors[fieldName];
	        } else {
	          msg = this.props.errorHandler(this.refs.input);
	        }
	        this.refs.errorMessage.innerHTML = msg;
	        if (msg !== null) {
	          this.refs.input.classList.add('field-element__field_error');
	          this.props.validationFailed();
	        } else {
	          this.props.addField(this.props.fieldName, this.refs.input.value);
	          this.refs.input.classList.remove('field-element__field_error');
	        }
	      }
	    }
	  }, {
	    key: 'clearField',
	    value: function clearField() {
	      if (this.refs.input) {
	        this.refs.input.value = '';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.validate) {
	        this.checkField();
	      }
	
	      if (this.props.clearFields) {
	        this.clearField();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'field-element', ref: this.props.blockRef },
	        _react2.default.createElement(
	          'label',
	          { className: 'field-element__label' },
	          this.props.title
	        ),
	        _react2.default.createElement('input', {
	          onBlur: this.onBlur.bind(this), className: 'field-element__field',
	          type: this.props.fieldType, name: this.props.fieldName,
	          onFocus: this.onFocus.bind(this), ref: 'input',
	          defaultValue: this.props.defaultValue
	        }),
	        _react2.default.createElement('div', { ref: 'errorMessage', className: 'field-element__error' })
	      );
	    }
	  }]);
	
	  return FormField;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    validate: state.auth.validate,
	    serverErrors: state.auth.serverErrors
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    validationFailed: (0, _redux.bindActionCreators)(_authAction.validationFailed, dispatch),
	    fixServerError: (0, _redux.bindActionCreators)(_authAction.fixServerError, dispatch),
	    addField: (0, _redux.bindActionCreators)(_fieldAction.addField, dispatch),
	    deleteField: (0, _redux.bindActionCreators)(_fieldAction.deleteField, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FormField);

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(108);
	var EventPluginUtils = __webpack_require__(109);
	var ReactErrorUtils = __webpack_require__(113);
	
	var accumulateInto = __webpack_require__(200);
	var forEachAccumulated = __webpack_require__(201);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(60);
	var EventPluginUtils = __webpack_require__(109);
	
	var accumulateInto = __webpack_require__(200);
	var forEachAccumulated = __webpack_require__(201);
	var warning = __webpack_require__(5);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	var getEventTarget = __webpack_require__(118);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 64 */
3,
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.test = exports.clearAllMessages = exports.logoutUser = exports.clearSectionMessages = exports.saveSectionChanges = exports.saveUserChanges = exports.downloadSectionsList = exports.getUser = exports.getUserQuery = undefined;
	
	__webpack_require__(34);
	
	var _reactRouter = __webpack_require__(12);
	
	var getUserQuery = exports.getUserQuery = function getUserQuery(dispatch) {
	  fetch('/api/whoami1.json', {
	    credentials: 'same-origin'
	  }).then(function (response) {
	    return response.json();
	  }).then(function (json) {
	    if (json.success) {
	      dispatch({
	        type: 'PARSE_GET_USER',
	        data: {
	          userView: json.userView,
	          participantView: json.participantView,
	          sectionsUser: json.participantView.eventBranchIds,
	          sections: json.eventBranchViews,
	          registrationClosed: json.registrationClosed
	        }
	      });
	    } else {
	      dispatch({
	        type: 'UNAUTHORIZED_USER',
	        registrationClosed: json.registrationClosed
	      });
	    }
	  }).catch(function (err) {
	    dispatch({
	      type: 'GET_USER_ERROR',
	      error: err
	    });
	  });
	};
	
	var getUser = exports.getUser = function getUser() {
	  return function (dispatch) {
	    getUserQuery(dispatch);
	  };
	};
	
	var downloadSectionsList = exports.downloadSectionsList = function downloadSectionsList() {
	  return function (dispatch) {
	    fetch('/api/get-sections-conference-list1.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'SECTIONS_LIST',
	          sectionsList: json.eventBranchViews
	        });
	      }
	    });
	  };
	};
	
	var saveUserChanges = exports.saveUserChanges = function saveUserChanges(form) {
	  return function (dispatch) {
	    dispatch({ type: 'RESET_VALIDATION' });
	    fetch('/api/user-full-profile-submit.json', {
	      method: 'post',
	      body: form,
	      credentials: 'same-origin'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        getUser();
	        dispatch({ type: 'SUCCESS_USER_CHANGING', message: json.successMessage });
	        dispatch({ type: 'RESET_VALIDATION' });
	        window.scrollTo(0, 0);
	        setTimeout(function () {
	          dispatch({ type: 'CLEAR_PARTICIPANT_MESSAGES' });
	        }, 10000);
	      } else {
	        dispatch({
	          type: 'ERRORS_FROM_SERVER',
	          errors: json.errors
	        });
	      }
	    });
	  };
	};
	
	var saveSectionChanges = exports.saveSectionChanges = function saveSectionChanges(sections) {
	  return function (dispatch) {
	    var form = new FormData();
	    form.append('eventBranchIds', sections);
	    fetch('/api/user-participate.json', {
	      method: 'post',
	      body: form,
	      credentials: 'same-origin'
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        var message = void 0;
	        if (sections.length === 0) {
	          message = 'Вы отменили свое участие!';
	        } else {
	          message = 'Изменения сохранены.';
	        }
	        dispatch({
	          type: 'SUCCESS_CHANGING',
	          message: message,
	          userSections: sections
	        });
	      } else {
	        dispatch({
	          type: 'FAILED_CHANGING',
	          message: 'Изменения не сохранены.'
	        });
	      }
	    }).catch(function (err) {
	      console.log(err);
	      dispatch({
	        type: 'FAILED_CHANGING',
	        message: 'Изменения не сохранены.'
	      });
	    });
	  };
	};
	
	var clearSectionMessages = exports.clearSectionMessages = function clearSectionMessages() {
	  return function (dispatch) {
	    dispatch({ type: 'CLEAR_SECTION_MESSAGES' });
	  };
	};
	
	var logoutUser = exports.logoutUser = function logoutUser() {
	  return function (dispatch) {
	    fetch('/api/j_spring_security_logout', {
	      credentials: 'same-origin'
	    }).then(function (response) {
	      if (response.ok) {
	        dispatch({ type: 'USER_LOGOUT' });
	      }
	    }).catch(function (err) {
	      console.log(err);
	      //TODO:: remove 3 lines after error fixing:
	      //Mixed Content: The page at 'https://happydev-lite.ru/auth' was loaded over HTTPS, but requested an insecure resource 'http://happydev-lite.ru/'. This request has been blocked; the content must be served over HTTPS.
	      //Fetch API cannot load https://happydev-lite.ru/api/j_spring_security_logout. Redirect failed.
	      //TypeError: Failed to fetch
	      dispatch({ type: 'USER_LOGOUT' });
	      getUserQuery(dispatch);
	      _reactRouter.browserHistory.push('/');
	    });
	  };
	};
	
	var clearAllMessages = exports.clearAllMessages = function clearAllMessages() {
	  return function (dispatch) {
	    dispatch({ type: 'CLEAR_PARTICIPANT_MESSAGES' });
	  };
	};
	
	var test = exports.test = function test() {
	  return function (dispatch) {
	    dispatch({ type: 'SUCCESS_CHANGING', message: 'hello hello', userSections: [] });
	  };
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	  }
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      var title = this.props.title ? _react2.default.createElement(
	        'div',
	        { className: 'form__title' },
	        this.props.title
	      ) : null;
	      return _react2.default.createElement(
	        'form',
	        { className: 'form ' + classes, method: 'POST', ref: 'form' },
	        title,
	        _react2.default.createElement(
	          'div',
	          { className: 'form__success-message' },
	          this.props.successMessage
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	exports.default = Form;

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(157);
	var enumBugKeys = __webpack_require__(88);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(423);
	
	var _runTransitionHook = __webpack_require__(104);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(40);
	
	var _deprecate = __webpack_require__(103);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(108);
	var ReactEventEmitterMixin = __webpack_require__(458);
	var ViewportMetrics = __webpack_require__(199);
	
	var getVendorPrefixedEventName = __webpack_require__(489);
	var isEventSupported = __webpack_require__(120);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(63);
	var ViewportMetrics = __webpack_require__(199);
	
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	var DOMNamespaces = __webpack_require__(107);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(81);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(512);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.classStyle },
	        _react2.default.createElement('input', {
	          id: this.props.inputId, className: 'checkbox__check',
	          type: 'checkbox', name: this.props.name, hidden: true,
	          onChange: this.props.onChangeCallback,
	          defaultChecked: this.props.checked, ref: 'checkbox'
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            htmlFor: this.props.inputId,
	            className: 'checkbox__label ' + (this.props.isDev ? 'checkbox__label_dev' : '') + ' ' + (this.props.isSquare ? 'checkbox__label_square' : '')
	          },
	          this.props.title
	        )
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	exports.default = Checkbox;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(8);
	
	var _authAction = __webpack_require__(35);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordField = function (_Component) {
	  _inherits(PasswordField, _Component);
	
	  function PasswordField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PasswordField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordField.__proto__ || Object.getPrototypeOf(PasswordField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hidePass: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PasswordField, [{
	    key: 'onPassHideClick',
	    value: function onPassHideClick() {
	      this.setState({ hidePass: !this.state.hidePass });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      this.refs.errorMessage.innerHTML = '';
	      this.refs.input.classList.remove('field-element__field_error');
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur() {
	      this.props.fixServerError(Object.assign({}, this.props.serverErrors), this.props.fieldName);
	      this.checkField();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.validate) {
	        this.checkField();
	      }
	    }
	  }, {
	    key: 'clearField',
	    value: function clearField() {
	      if (this.refs.input) {
	        this.refs.input.value = '';
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.deleteField(this.props.fieldName);
	    }
	  }, {
	    key: 'checkField',
	    value: function checkField() {
	      if (this.refs.input !== undefined) {
	        var fieldName = this.props.fieldName;
	        var msg = null;
	        if (fieldName in this.props.serverErrors) {
	          msg = this.props.serverErrors[fieldName];
	        } else {
	          msg = this.props.errorHandler(this.refs.input);
	        }
	        this.refs.errorMessage.innerHTML = msg;
	        if (msg !== null) {
	          this.refs.input.classList.add('field-element__field_error');
	          this.props.validationFailed();
	        } else {
	          this.props.addField(this.props.fieldName, this.refs.input.value);
	          this.refs.input.classList.remove('field-element__field_error');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.validate) {
	        this.checkField();
	      }
	
	      if (this.props.clearFields) {
	        this.clearField();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'field-element' },
	        _react2.default.createElement(
	          'label',
	          { className: 'field-element__label' },
	          this.props.title
	        ),
	        _react2.default.createElement('input', { autoComplete: 'off', className: 'field-element__field',
	          type: this.state.hidePass ? 'password' : 'text',
	          onFocus: this.onFocus.bind(this), onBlur: this.onBlur.bind(this),
	          name: this.props.fieldName, ref: 'input'
	        }),
	        _react2.default.createElement('div', { className: this.state.hidePass ? 'field-element__field_pass-hidden' : 'field-element__field_pass-show',
	          onClick: this.onPassHideClick.bind(this) }),
	        _react2.default.createElement('div', { ref: 'errorMessage', className: 'field-element__error' })
	      );
	    }
	  }]);
	
	  return PasswordField;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    validate: state.auth.validate,
	    serverErrors: state.auth.serverErrors
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    validationFailed: (0, _redux.bindActionCreators)(_authAction.validationFailed, dispatch),
	    fixServerError: (0, _redux.bindActionCreators)(_authAction.fixServerError, dispatch),
	    addField: (0, _redux.bindActionCreators)(_fieldAction.addField, dispatch),
	    deleteField: (0, _redux.bindActionCreators)(_fieldAction.deleteField, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { withRef: true })(PasswordField);

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(146);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(309);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(308);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 88 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(58);
	var dPs = __webpack_require__(333);
	var enumBugKeys = __webpack_require__(88);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(151)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(327).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(69);
	var createDesc = __webpack_require__(70);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(97);
	var has = __webpack_require__(37);
	var IE8_DOM_DEFINE = __webpack_require__(152);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 92 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(38).f;
	var has = __webpack_require__(37);
	var TAG = __webpack_require__(50)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(95)('keys');
	var uid = __webpack_require__(72);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(22);
	var global = __webpack_require__(32);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(67) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 96 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(49);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(22);
	var LIBRARY = __webpack_require__(67);
	var wksExt = __webpack_require__(99);
	var defineProperty = __webpack_require__(38).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(50);


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(176);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(410),
	    getPrototype = __webpack_require__(412),
	    isObjectLike = __webpack_require__(417);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(53);
	var Danger = __webpack_require__(437);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(20);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(115);
	var setInnerHTML = __webpack_require__(79);
	var setTextContent = __webpack_require__(206);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 107 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactErrorUtils = __webpack_require__(113);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypesSecret = __webpack_require__(463);
	var propTypesFactory = __webpack_require__(179);
	
	var React = __webpack_require__(45);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactInstanceMap = __webpack_require__(62);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(444);
	var ReactEmptyComponent = __webpack_require__(190);
	var ReactHostComponent = __webpack_require__(192);
	
	var getNextDebugID = __webpack_require__(545);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(25);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(492);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 124 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(81);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(510);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(507);
	
	var _isActive2 = __webpack_require__(514);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(511);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(516);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(220);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 128 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postSponsor = exports.postParticipant = undefined;
	
	__webpack_require__(34);
	
	var postParticipant = exports.postParticipant = function postParticipant(data) {
	  return function (dispatch) {
	    dispatch({ type: 'PARTICIPANT_REGISTER_PENDING' });
	    fetch('https://docs.google.com/forms/d/e/1FAIpQLSeiwaBHy4ij2j6ECneM6kG6A_JvekRfKiiVasnDpDeZ1yj0kw/formResponse', {
	      method: 'post',
	      body: data
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      dispatch({
	        type: 'PARTICIPANT_REGISTER_DONE'
	      });
	    }).catch(function (err) {
	      console.log(err);
	      dispatch({
	        type: 'PARTICIPANT_REGISTER_DONE'
	      });
	    });
	  };
	};
	
	var postSponsor = exports.postSponsor = function postSponsor(data) {
	  return function (dispatch) {
	    dispatch({ type: 'SPONSOR_REGISTER_PENDING' });
	    fetch('https://docs.google.com/forms/d/e/1FAIpQLSekRjCj6_RIAgkzsdcBh7LzLBk33dPNOBmwWKoU_qgM6fKOhQ/formResponse', {
	      method: 'post',
	      body: data
	    }).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      dispatch({
	        type: 'SPONSOR_REGISTER_DONE'
	      });
	    }).catch(function (err) {
	      console.log(err);
	      dispatch({
	        type: 'SPONSOR_REGISTER_DONE'
	      });
	    });
	  };
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(8);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownField = function (_Component) {
	  _inherits(DropdownField, _Component);
	
	  function DropdownField() {
	    _classCallCheck(this, DropdownField);
	
	    return _possibleConstructorReturn(this, (DropdownField.__proto__ || Object.getPrototypeOf(DropdownField)).apply(this, arguments));
	  }
	
	  _createClass(DropdownField, [{
	    key: 'onChange',
	    value: function onChange() {
	      this.props.addField(this.props.fieldName, this.refs.select.value);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.deleteField(this.props.fieldName);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var optionList = this.props.optionList.map(function (option) {
	        return _react2.default.createElement(
	          'option',
	          { key: option.id, value: option.id },
	          option.name
	        );
	      });
	      if (this.props.defaultValue) {
	        this.props.addField(this.props.fieldName, this.props.defaultValue);
	      } else if (this.props.optionList.length !== 0) {
	        this.props.addField(this.props.fieldName, this.props.optionList[0].id);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'field-dropdown' },
	        _react2.default.createElement(
	          'label',
	          { className: 'field-dropdown__label' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'select',
	          {
	            ref: 'select', className: 'field-dropdown__field',
	            key: this.props.fieldName, name: this.props.fieldName,
	            defaultValue: this.props.defaultValue, onChange: this.onChange.bind(this)
	          },
	          optionList
	        )
	      );
	    }
	  }]);
	
	  return DropdownField;
	}(_react.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    addField: (0, _redux.bindActionCreators)(_fieldAction.addField, dispatch),
	    deleteField: (0, _redux.bindActionCreators)(_fieldAction.deleteField, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(DropdownField);

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormField = __webpack_require__(57);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _PasswordField = __webpack_require__(83);
	
	var _PasswordField2 = _interopRequireDefault(_PasswordField);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contacts = function (_Component) {
	  _inherits(Contacts, _Component);
	
	  function Contacts() {
	    _classCallCheck(this, Contacts);
	
	    return _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).apply(this, arguments));
	  }
	
	  _createClass(Contacts, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: classes + ' form__info-block' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form__tips' },
	            '\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043D\u0443\u0436\u043D\u0430 \u0434\u043B\u044F \u044D\u043A\u0441\u0442\u0440\u0435\u043D\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438. \u041C\u044B \u043D\u0435 \u0434\u0430\u0451\u043C \u044D\u0442\u0443 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form__inputs' },
	            _react2.default.createElement(_FormField2.default, {
	              title: 'Email', type: 'text', fieldName: 'email', clearFields: this.props.clearFields,
	              errorHandler: this.props.emailHandler, ref: 'email', defaultValue: this.props.defaultEmailValue
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'form__tips form__tips_pass-mobile' },
	              '\u041D\u0435 \u043C\u0435\u043D\u0435\u0435 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432'
	            ),
	            _react2.default.createElement(_PasswordField2.default, {
	              title: this.props.newPass ? 'Новый пароль' : 'Пароль', fieldName: 'password', clearFields: this.props.clearFields,
	              errorHandler: this.props.passwordHandler, ref: 'password'
	            }),
	            _react2.default.createElement(_FormField2.default, {
	              title: '\u0422\u0435\u043B\u0435\u0444\u043E\u043D', type: 'text',
	              fieldName: 'phoneNumber', clearFields: this.props.clearFields,
	              errorHandler: this.props.phoneHandler, defaultValue: this.props.defaultPhoneValue
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form__tips form__tips_pass-desktop' },
	            '\u041D\u0435 \u043C\u0435\u043D\u0435\u0435 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Contacts;
	}(_react.Component);
	
	exports.default = Contacts;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSimpletabs = __webpack_require__(528);
	
	var _reactSimpletabs2 = _interopRequireDefault(_reactSimpletabs);
	
	var _SchoolInfo = __webpack_require__(254);
	
	var _SchoolInfo2 = _interopRequireDefault(_SchoolInfo);
	
	var _InstituteInfo = __webpack_require__(253);
	
	var _InstituteInfo2 = _interopRequireDefault(_InstituteInfo);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Education = function (_Component) {
	  _inherits(Education, _Component);
	
	  function Education() {
	    _classCallCheck(this, Education);
	
	    return _possibleConstructorReturn(this, (Education.__proto__ || Object.getPrototypeOf(Education)).apply(this, arguments));
	  }
	
	  _createClass(Education, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'form__info-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__tips' },
	          '\u0412 \u0434\u0435\u043D\u044C \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0441\u0442\u0443\u0434\u0435\u043D\u0447\u0435\u0441\u043A\u0438\u043C \u0431\u0438\u043B\u0435\u0442\u043E\u043C \u0438\u043B\u0438 \u0441\u043F\u0440\u0430\u0432\u043A\u043E\u0439 \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A\u0430.'
	        ),
	        _react2.default.createElement(
	          _reactSimpletabs2.default,
	          { className: classes, tabActive: this.props.instituteId ? 2 : 1 },
	          _react2.default.createElement(
	            _reactSimpletabs.Panel,
	            { title: '\u044F \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A' },
	            _react2.default.createElement(_SchoolInfo2.default, {
	              schoolList: this.props.schoolList,
	              gradeHandler: this.props.gradeHandler,
	              clearFields: this.props.clearFields,
	              styleEducation: 'form__inputs_default',
	              schoolId: this.props.schoolId,
	              grade: this.props.grade
	            })
	          ),
	          _react2.default.createElement(
	            _reactSimpletabs.Panel,
	            { title: '\u044F \u0441\u0442\u0443\u0434\u0435\u043D\u0442' },
	            _react2.default.createElement(_InstituteInfo2.default, {
	              instituteList: this.props.instituteList,
	              departmentHandler: this.props.departmentHandler,
	              courseHandler: this.props.courseHandler,
	              clearFields: this.props.clearFields,
	              styleEducation: 'form__inputs_default',
	              instituteId: this.props.instituteId,
	              department: this.props.department,
	              course: this.props.course
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Education;
	}(_react.Component);
	
	exports.default = Education;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormField = __webpack_require__(57);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FLNames = function (_Component) {
	  _inherits(FLNames, _Component);
	
	  function FLNames() {
	    _classCallCheck(this, FLNames);
	
	    return _possibleConstructorReturn(this, (FLNames.__proto__ || Object.getPrototypeOf(FLNames)).apply(this, arguments));
	  }
	
	  _createClass(FLNames, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: classes + ' form__info-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__tips' },
	          '\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043C\u044F \u0438\xA0\u0444\u0430\u043C\u0438\u043B\u0438\u044E \u043D\u0430\xA0\u0440\u0443\u0441\u0441\u043A\u043E\u043C \u044F\u0437\u044B\u043A\u0435. \u0418\u0445\xA0\u043D\u0430\u043F\u0435\u0447\u0430\u0442\u0430\u044E\u0442 \u043D\u0430\xA0\u0432\u0430\u0448\u0435\u043C \u0431\u0435\u0439\u0434\u0436\u0435.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__inputs' },
	          _react2.default.createElement(_FormField2.default, {
	            title: '\u0418\u043C\u044F', type: 'text', clearFields: this.props.clearFields,
	            fieldName: 'firstName', errorHandler: this.props.firstNameHandler,
	            defaultValue: this.props.firstName
	          }),
	          _react2.default.createElement(_FormField2.default, {
	            title: '\u0424\u0430\u043C\u0438\u043B\u0438\u044F', type: 'text', clearFields: this.props.clearFields,
	            fieldName: 'lastName', errorHandler: this.props.lastNameHandler,
	            defaultValue: this.props.lastName
	          })
	        )
	      );
	    }
	  }]);
	
	  return FLNames;
	}(_react.Component);
	
	exports.default = FLNames;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormBlock = function (_Component) {
	  _inherits(FormBlock, _Component);
	
	  function FormBlock() {
	    _classCallCheck(this, FormBlock);
	
	    return _possibleConstructorReturn(this, (FormBlock.__proto__ || Object.getPrototypeOf(FormBlock)).apply(this, arguments));
	  }
	
	  _createClass(FormBlock, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'form__info-block' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return FormBlock;
	}(_react.Component);
	
	exports.default = FormBlock;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormSubmitAgreement = __webpack_require__(136);
	
	var _FormSubmitAgreement2 = _interopRequireDefault(_FormSubmitAgreement);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSubmit = function (_Component) {
	  _inherits(FormSubmit, _Component);
	
	  function FormSubmit() {
	    _classCallCheck(this, FormSubmit);
	
	    return _possibleConstructorReturn(this, (FormSubmit.__proto__ || Object.getPrototypeOf(FormSubmit)).apply(this, arguments));
	  }
	
	  _createClass(FormSubmit, [{
	    key: 'render',
	    value: function render() {
	      var blockClasses = this.props.blockClasses ? this.props.blockClasses.join(' ') : '';
	      var buttonClasses = this.props.buttonClasses ? this.props.buttonClasses : [];
	      return _react2.default.createElement(
	        'div',
	        { className: blockClasses + ' form__submit-container' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            styleClasses: buttonClasses.concat(['form__button']),
	            onClick: this.props.onClick
	          },
	          this.props.children
	        ),
	        _react2.default.createElement(_FormSubmitAgreement2.default, null)
	      );
	    }
	  }]);
	
	  return FormSubmit;
	}(_react.Component);
	
	exports.default = FormSubmit;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSubmitAgreement = function (_Component) {
	  _inherits(FormSubmitAgreement, _Component);
	
	  function FormSubmitAgreement() {
	    _classCallCheck(this, FormSubmitAgreement);
	
	    return _possibleConstructorReturn(this, (FormSubmitAgreement.__proto__ || Object.getPrototypeOf(FormSubmitAgreement)).apply(this, arguments));
	  }
	
	  _createClass(FormSubmitAgreement, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'form__additional form__additional_agree-to-process-info' },
	        '\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043D\u0430\xA0\u043A\u043D\u043E\u043F\u043A\u0443, \u0412\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u043D\u0430\xA0\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\xA0\u0434\u0430\u043D\u043D\u044B\u0445. \u041E\u0437\u043D\u0430\u043A\u043E\u043C\u044C\u0442\u0435\u0441\u044C \u0441\xA0',
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'form__additional form__additional_link',
	            href: 'https://drive.google.com/file/d/0B0enOOPZ0QwoUUh6WVhhR1VHZGM/view',
	            target: '_blank',
	            alt: 'agreement'
	          },
	          '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439\xA0\u0432\xA0\u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438\xA0\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\xA0\u0434\u0430\u043D\u043D\u044B\u0445'
	        )
	      );
	    }
	  }]);
	
	  return FormSubmitAgreement;
	}(_react.Component);
	
	exports.default = FormSubmitAgreement;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormField = __webpack_require__(57);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Job = function (_Component) {
	  _inherits(Job, _Component);
	
	  function Job() {
	    _classCallCheck(this, Job);
	
	    return _possibleConstructorReturn(this, (Job.__proto__ || Object.getPrototypeOf(Job)).apply(this, arguments));
	  }
	
	  _createClass(Job, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__tips' },
	          '\u0423\u0447\u0438\u0442\u0435\u0441\u044C \u0438 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442\u0435 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E? \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043C\u0435\u0441\u0442\u043E \u0432\u0430\u0448\u0435\u0439 \u0440\u0430\u0431\u043E\u0442\u044B.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__inputs' },
	          _react2.default.createElement(_FormField2.default, {
	            title: '\u041C\u0435\u0441\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B', type: 'text',
	            fieldName: 'company',
	            errorHandler: this.props.jobHandler,
	            clearFields: this.props.clearFields,
	            defaultValue: this.props.defaultCompanyName
	          }),
	          _react2.default.createElement(_FormField2.default, {
	            title: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C', type: 'text',
	            fieldName: 'jobPosition',
	            defaultValue: this.props.defaultJobPosition,
	            errorHandler: this.props.positionHandler,
	            clearFields: this.props.clearFields
	          })
	        )
	      );
	    }
	  }]);
	
	  return Job;
	}(_react.Component);
	
	exports.default = Job;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputField = function (_Component) {
	  _inherits(InputField, _Component);
	
	  function InputField(props) {
	    _classCallCheck(this, InputField);
	
	    var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));
	
	    _this.state = {
	      error: false,
	      errorCode: '',
	      fieldValue: props.value
	    };
	    return _this;
	  }
	
	  _createClass(InputField, [{
	    key: 'onValidate',
	    value: function onValidate(event) {
	      var validateResult = this.props.onValidate(this.state.fieldValue);
	      if (validateResult) {
	        this.setState({
	          error: true,
	          errorCode: validateResult
	        });
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'clearField',
	    value: function clearField() {
	      this.setState({ fieldValue: '' });
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus() {
	      this.setState({
	        error: false,
	        errorCode: ''
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.setState({ fieldValue: event.target.value });
	      this.props.onChange(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          disabled = _props.disabled,
	          classes = _props.classes,
	          name = _props.name,
	          placeholder = _props.placeholder,
	          tabIndex = _props.tabIndex;
	
	
	      var styleList = classes ? classes.join(' ') : '';
	      var errorStyle = this.state.error ? 'input-field__input_error' : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('input', {
	          type: type,
	          disabled: disabled,
	          className: 'input-field ' + styleList + ' ' + errorStyle,
	          value: this.state.fieldValue,
	          name: name,
	          placeholder: placeholder,
	          onChange: this.onChange.bind(this),
	          onBlur: this.onValidate.bind(this),
	          onFocus: this.onFocus.bind(this),
	          tabIndex: tabIndex
	        }),
	        this.state.error ? _react2.default.createElement(
	          'div',
	          { className: 'input-field__error' },
	          this.state.errorCode
	        ) : null
	      );
	    }
	  }]);
	
	  return InputField;
	}(_react.Component);
	
	InputField.propTypes = {
	  type: _react2.default.PropTypes.string,
	  value: _react2.default.PropTypes.string,
	  name: _react2.default.PropTypes.string.isRequired,
	  placeholder: _react2.default.PropTypes.string,
	  classes: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  disabled: _react2.default.PropTypes.bool,
	  tabIndex: _react2.default.PropTypes.number,
	
	  onBlur: _react2.default.PropTypes.func,
	  onFocus: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func
	};
	
	InputField.defaultProps = {
	  type: 'text',
	  value: '',
	  placeholder: '',
	  disabled: false,
	  classes: [],
	
	  onChange: function onChange() {}
	};
	
	exports.default = InputField;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumberSelector = function (_Component) {
	  _inherits(NumberSelector, _Component);
	
	  function NumberSelector() {
	    _classCallCheck(this, NumberSelector);
	
	    return _possibleConstructorReturn(this, (NumberSelector.__proto__ || Object.getPrototypeOf(NumberSelector)).apply(this, arguments));
	  }
	
	  _createClass(NumberSelector, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.onChange(null);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange() {
	      var that = this;
	      for (var i = this.props.start; i <= this.props.end; i++) {
	        if (that.refs['' + this.props.name + i].checked) {
	          this.props.onChange(i);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          name = _props.name,
	          label = _props.label,
	          classes = _props.classes,
	          title = _props.title;
	
	
	      var styleList = classes ? classes.join(' ') : '';
	
	      var numbers = [];
	      for (var i = this.props.start; i <= this.props.end; i++) {
	        numbers.push(_react2.default.createElement(
	          'div',
	          { className: 'number-selector__container ' + (i === this.props.end ? 'number-selector__container_last' : null) },
	          _react2.default.createElement('input', {
	            id: i,
	            hidden: true,
	            type: 'radio',
	            name: name,
	            defaultChecked: this.props.defaultValue === i ? true : this.props.checked,
	            onClick: function onClick() {
	              _this2.onChange();
	            },
	            className: 'number-selector__input',
	            ref: '' + name + i
	          }),
	          _react2.default.createElement(
	            'label',
	            {
	              className: 'number-selector__label',
	              htmlFor: i
	            },
	            i
	          )
	        ));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'number-selector ' + styleList },
	        _react2.default.createElement(
	          'span',
	          { className: 'number-selector__title' },
	          title
	        ),
	        numbers
	      );
	    }
	  }]);
	
	  return NumberSelector;
	}(_react.Component);
	
	exports.default = NumberSelector;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioButton = function (_Component) {
	  _inherits(RadioButton, _Component);
	
	  function RadioButton() {
	    _classCallCheck(this, RadioButton);
	
	    return _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
	  }
	
	  _createClass(RadioButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.classStyle },
	        _react2.default.createElement('input', {
	          id: this.props.inputId, className: 'radio__button',
	          type: 'radio', name: this.props.name, hidden: true,
	          onChange: this.props.onChangeCallback,
	          defaultChecked: this.props.checked, ref: 'radiobutton'
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            htmlFor: this.props.inputId,
	            className: 'radio__label'
	          },
	          this.props.title
	        )
	      );
	    }
	  }]);
	
	  return RadioButton;
	}(_react.Component);
	
	exports.default = RadioButton;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Comment = __webpack_require__(249);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _commentAction = __webpack_require__(247);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Tweets from './../twitter/TwitterComponent';
	
	
	var ReviewLanding = function (_Component) {
	  _inherits(ReviewLanding, _Component);
	
	  function ReviewLanding() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReviewLanding);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewLanding.__proto__ || Object.getPrototypeOf(ReviewLanding)).call.apply(_ref, [this].concat(args))), _this), _this.onButtonMoreClick = function (e) {
	      document.getElementsByClassName('js-more-reviews')[0].setAttribute('style', 'display: block;');
	      e.target.setAttribute('style', 'display: none;');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReviewLanding, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.downloadComments();
	      window.scroll(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var comments = void 0;
	      var unknownComments = void 0;
	      // let twitter;
	      var button = void 0;
	      var commentsListSort = [];
	      this.props.eventCommentList.map(function (comment) {
	        var commentKey = comment.idStr;
	        commentsListSort[commentKey] = comment;
	        return null;
	      });
	      console.log(this.props.eventCommentList.length);
	      if (this.props.isRand && this.props.eventCommentList.length > 2) {
	        var firstComment = Number.parseInt(Math.random() * this.props.eventCommentList.length, 10);
	        var secondComment = Number.parseInt(Math.random() * this.props.eventCommentList.length, 10);
	        while (this.props.eventCommentList[firstComment].commentAuthorView.companyName === 'none') {
	          firstComment = Number.parseInt(Math.random() * this.props.eventCommentList.length, 10);
	        }
	        while (firstComment === secondComment || this.props.eventCommentList[secondComment].commentAuthorView.companyName === 'none') {
	          secondComment = Number.parseInt(Math.random() * this.props.eventCommentList.length, 10);
	        }
	        comments = [_react2.default.createElement(_Comment2.default, { key: this.props.eventCommentList[firstComment].idStr, commentData: this.props.eventCommentList[firstComment], styleClasses: [' ', ' ', ' '] }), _react2.default.createElement(_Comment2.default, { key: this.props.eventCommentList[secondComment].idStr, commentData: this.props.eventCommentList[secondComment], styleClasses: [' ', ' ', ' '] })];
	      } else {
	        comments = this.props.eventCommentList.map(function (commentKey) {
	          if (commentKey.commentAuthorView.companyName !== 'none') {
	            return _react2.default.createElement(_Comment2.default, { key: commentKey.idStr, commentData: commentKey, styleClasses: ['review-column', 'review__text-min', ' '] });
	          }
	          return null;
	        });
	        button = _react2.default.createElement(
	          _Button2.default,
	          { styleClasses: ['review-button__more'], onClick: this.onButtonMoreClick.bind(this) },
	          '\u0435\u0449\u0435\xA0\u2192'
	        );
	        unknownComments = this.props.eventCommentList.map(function (commentKey) {
	          if (commentKey.commentAuthorView.companyName === 'none') {
	            return _react2.default.createElement(_Comment2.default, { key: commentKey.idStr, commentData: commentKey, styleClasses: ['review-column', 'review__text-min', 'review_none'], quotesElement: ['', ''] });
	          }
	          return null;
	        });
	        // twitter = <Tweets />
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'section',
	          { className: 'reviews clearfix' },
	          _react2.default.createElement(
	            'header',
	            { className: 'reviews__title' },
	            '\u041E\u0422\u0417\u042B\u0412\u042B \u0423\u0427\u0410\u0421\u0422\u041D\u0418\u041A\u041E\u0412'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'reviews__list clearfix' },
	            comments,
	            button,
	            _react2.default.createElement(
	              'div',
	              { className: 'review_none js-more-reviews' },
	              unknownComments
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ReviewLanding;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    eventCommentList: state.comment.eventCommentList
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadComments: (0, _redux.bindActionCreators)(_commentAction.downloadComments, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReviewLanding);

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _RadioButton = __webpack_require__(140);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _participantAction = __webpack_require__(65);
	
	__webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSections = function (_Component) {
	  _inherits(UserSections, _Component);
	
	  function UserSections() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserSections);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSections.__proto__ || Object.getPrototypeOf(UserSections)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      idSectionData: 25
	    }, _this.showTimeoutId = null, _this.hideTimeoutId = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserSections, [{
	    key: 'onCheckChange',
	    value: function onCheckChange() {
	      var that = this;
	      clearTimeout(this.showTimeoutId);
	      this.showTimeoutId = setTimeout(function () {
	        var eventBranchIds = [];
	        that.props.allSections.map(function (section) {
	          if (that.refs[section.id].refs.radiobutton.checked) {
	            eventBranchIds.push(section.id);
	          }
	          return null;
	        });
	        that.props.saveSectionChanges(eventBranchIds);
	        clearTimeout(that.hideTimeoutId);
	        that.hideTimeoutId = setTimeout(function () {
	          that.props.clearSectionMessages();
	        }, 10000);
	      }, 500);
	    }
	  }, {
	    key: 'onCancel',
	    value: function onCancel() {
	      var _this2 = this;
	
	      this.props.saveSectionChanges([]);
	      this.props.allSections.map(function (section) {
	        _this2.refs[section.id].refs.radiobutton.checked = false;
	        return null;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var confirmMenu = null;
	      var that = this;
	
	      if (this.props.participantView.userShortView) {
	        if (this.props.participantView.approved) {
	          var sectionClasses = this.props.sectionStyleClasses ? 'user-section__element ' + this.props.sectionStyleClasses.join(' ') : 'user-section__element';
	          var sections = this.props.allSections.map(function (section) {
	            var checked = false;
	            if (Array.isArray(that.props.userSections)) {
	              checked = that.props.userSections.filter(function (userSection) {
	                return section.id === userSection;
	              }).length > 0;
	            } else {
	              if (that.props.userSections.get(section.id) != null) {
	                checked = true;
	              }
	            }
	            return _react2.default.createElement(_RadioButton2.default, {
	              key: section.id,
	              name: 'user-section__event-branch',
	              title: section.name,
	              inputId: section.id,
	              ref: section.id,
	              onChangeCallback: _this3.onCheckChange.bind(_this3),
	              classStyle: sectionClasses,
	              checked: checked
	            });
	          });
	          var sectionsClasses = this.props.sectionsStyleClasses ? 'user-section__elements-container ' + this.props.sectionsStyleClasses.join(' ') : 'user-section__elements-container';
	          confirmMenu = _react2.default.createElement(
	            'form',
	            {
	              className: 'user-section',
	              ref: 'form',
	              onSubmit: function onSubmit(e) {
	                e.preventDefault();
	              }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: sectionsClasses },
	              sections
	            ),
	            this.props.userSections.length > 0 ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'user-section__submit-btn',
	                  type: 'submit',
	                  onClick: this.onCancel.bind(this)
	                },
	                '\u041E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u0443\u0447\u0430\u0441\u0442\u0438\u044F'
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'user-section__hint user-section__hint_success' },
	              this.props.successMessage
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'user-section__hint user-section__hint_warning' },
	              this.props.warningMessage
	            )
	          );
	        } else {
	          confirmMenu = _react2.default.createElement(
	            'div',
	            { className: 'user-section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'user-section__title user-section__title_not-approved' },
	              '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0438'
	            )
	          );
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        confirmMenu
	      );
	    }
	  }]);
	
	  return UserSections;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userSections: state.participant.userSections,
	    allSections: state.participant.allSections,
	    participantView: state.participant.participantView,
	    successMessage: state.participant.successMessage,
	    warningMessage: state.participant.warningMessage
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    saveSectionChanges: (0, _redux.bindActionCreators)(_participantAction.saveSectionChanges, dispatch),
	    clearSectionMessages: (0, _redux.bindActionCreators)(_participantAction.clearSectionMessages, dispatch),
	    test: (0, _redux.bindActionCreators)(_participantAction.test, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserSections);

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.downloadScheduleRoom = exports.downloadSchedule = undefined;
	
	__webpack_require__(34);
	
	var downloadSchedule = exports.downloadSchedule = function downloadSchedule() {
	  return function (dispatch) {
	    fetch('/api/schedule1.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        var sections = json.eventBranchViews.map(function (section) {
	          var scheduleViewList = json.scheduleView.roomEvents.filter(function (element) {
	            return element.roomEventShortView.eventBranchId === section.id;
	          });
	          var roomId = json.scheduleView.roomEvents.filter(function (element) {
	            return element.roomEventShortView.eventBranchId === section.id && element.type === 'Open';
	          })[0].roomId;
	          var roomName = json.scheduleView.rooms.filter(function (element) {
	            return element.id === roomId;
	          })[0].roomName;
	
	          var roomDate = scheduleViewList[0].eventDay;
	          return Object.assign({}, section, { scheduleViewList: scheduleViewList, roomName: roomName, roomDate: roomDate });
	        });
	        dispatch({
	          type: 'PARSE_SHEDULE_LIST',
	          sections: sections
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'SCHEDULE_ERROR',
	        error: err
	      });
	    });
	  };
	};
	var downloadScheduleRoom = exports.downloadScheduleRoom = function downloadScheduleRoom(room) {
	  return function (dispatch) {
	    fetch('/api/room-event-object/' + room.id + '.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'PARSE_SHEDULE_ROOM',
	          roomEventView: json.roomEventView
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'SCHEDULE_ERROR',
	        error: err
	      });
	    });
	  };
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.downloadSpeaker = exports.downloadSpeakers = undefined;
	
	__webpack_require__(34);
	
	var downloadSpeakers = exports.downloadSpeakers = function downloadSpeakers() {
	  return function (dispatch) {
	    fetch('/api/speakers-and-branches-list1.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        var sections = json.speakerViewList.eventBranchViews.map(function (section) {
	          var speakerViewList = json.speakerViewList.speakerViews.filter(function (element) {
	            var ev = element.roomEventShortViews.filter(function (room) {
	              if (room.eventBranchId === section.id) {
	                return room;
	              }
	              return null;
	            });
	            if (ev && ev.length !== 0) {
	              return ev[0];
	            }
	            return null;
	          });
	          return Object.assign({}, section, { speakerViewList: speakerViewList });
	        });
	        dispatch({
	          type: 'PARSE_SPEAKERS_LIST',
	          sections: sections
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'SPEAKERS_ERROR',
	        error: err
	      });
	    });
	  };
	};
	
	var downloadSpeaker = exports.downloadSpeaker = function downloadSpeaker(user) {
	  return function (dispatch) {
	    fetch('/api/speaker-object/' + user.id + '.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      console.log(json);
	      if (json.success) {
	        dispatch({
	          type: 'PARSE_SPEAKER_INFO',
	          speakerView: json.speakerViewWithRoomEventTime
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'SPEAKERS_ERROR',
	        error: err
	      });
	    });
	  };
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Speaker = function (_Component) {
	  _inherits(Speaker, _Component);
	
	  function Speaker() {
	    _classCallCheck(this, Speaker);
	
	    return _possibleConstructorReturn(this, (Speaker.__proto__ || Object.getPrototypeOf(Speaker)).apply(this, arguments));
	  }
	
	  _createClass(Speaker, [{
	    key: 'render',
	    value: function render() {
	      var speaker = this.props.speakerData;
	
	      var speakerCompany = [];
	      if (speaker.company.name) {
	        speakerCompany.push(_react2.default.createElement(
	          'a',
	          { target: '_blank', className: 'speaker__company', href: speaker.company.url },
	          speaker.company.name
	        ));
	        speakerCompany.push(', ');
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'speaker__info', key: speaker.idStr },
	        _react2.default.createElement(
	          'a',
	          { href: '/speaker?id=' + speaker.idStr },
	          _react2.default.createElement('img', { className: 'speaker__photo', src: speaker.pictureUrl, alt: speaker.userView.fullName })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'speaker__name' },
	          _react2.default.createElement(
	            'a',
	            { href: '/speaker?id=' + speaker.idStr, className: 'speaker__name' },
	            speaker.userView.fullName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'speaker__position' },
	          speakerCompany,
	          [speaker.jobPosition, speaker.userView.cityName].filter(function (value) {
	            return value;
	          }).join(', ')
	        )
	      );
	    }
	  }]);
	
	  return Speaker;
	}(_react.Component);
	
	exports.default = Speaker;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(317), __esModule: true };

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(86);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 149 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(323);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	var document = __webpack_require__(32).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(31) && !__webpack_require__(47)(function () {
	  return Object.defineProperty(__webpack_require__(151)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(149);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(67);
	var $export = __webpack_require__(36);
	var redefine = __webpack_require__(159);
	var hide = __webpack_require__(48);
	var Iterators = __webpack_require__(89);
	var $iterCreate = __webpack_require__(329);
	var setToStringTag = __webpack_require__(93);
	var getPrototypeOf = __webpack_require__(156);
	var ITERATOR = __webpack_require__(50)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(157);
	var hiddenKeys = __webpack_require__(88).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(37);
	var toObject = __webpack_require__(71);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(37);
	var toIObject = __webpack_require__(39);
	var arrayIndexOf = __webpack_require__(325)(false);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(36);
	var core = __webpack_require__(22);
	var fails = __webpack_require__(47);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(48);


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(59);
	var _invariant = __webpack_require__(2);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(86);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(353);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(314);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 162 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 163 */
23,
/* 164 */
23,
/* 165 */
23,
/* 166 */
23,
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(25);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 169 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(73);
	
	var _DOMUtils = __webpack_require__(102);
	
	var _createHistory = __webpack_require__(173);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(51);
	
	var _PathUtils = __webpack_require__(40);
	
	var _ExecutionEnvironment = __webpack_require__(73);
	
	var _DOMUtils = __webpack_require__(102);
	
	var _DOMStateStorage = __webpack_require__(170);
	
	var _createDOMHistory = __webpack_require__(171);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(354);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(40);
	
	var _AsyncUtils = __webpack_require__(401);
	
	var _Actions = __webpack_require__(51);
	
	var _createLocation2 = __webpack_require__(403);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(104);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(103);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(73);
	
	var _PathUtils = __webpack_require__(40);
	
	var _runTransitionHook = __webpack_require__(104);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(103);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(416);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(177);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(419);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 177 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 178 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(422);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(42);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(54);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(20);
	
	var quoteAttributeValueForBrowser = __webpack_require__(490);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(122);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(24);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(24);
	var Transaction = __webpack_require__(77);
	
	var emptyFunction = __webpack_require__(25);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(432);
	var BeforeInputEventPlugin = __webpack_require__(434);
	var ChangeEventPlugin = __webpack_require__(436);
	var DefaultEventPluginOrder = __webpack_require__(438);
	var EnterLeaveEventPlugin = __webpack_require__(439);
	var HTMLDOMPropertyConfig = __webpack_require__(441);
	var ReactComponentBrowserEnvironment = __webpack_require__(443);
	var ReactDOMComponent = __webpack_require__(446);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMEmptyComponent = __webpack_require__(447);
	var ReactDOMTreeTraversal = __webpack_require__(456);
	var ReactDOMTextComponent = __webpack_require__(454);
	var ReactDefaultBatchingStrategy = __webpack_require__(188);
	var ReactEventListener = __webpack_require__(459);
	var ReactInjection = __webpack_require__(460);
	var ReactReconcileTransaction = __webpack_require__(464);
	var SVGDOMPropertyConfig = __webpack_require__(469);
	var SelectEventPlugin = __webpack_require__(470);
	var SimpleEventPlugin = __webpack_require__(471);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(452);
	
	var containsNode = __webpack_require__(388);
	var focusNode = __webpack_require__(168);
	var getActiveElement = __webpack_require__(169);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(482);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(53);
	var DOMProperty = __webpack_require__(54);
	var React = __webpack_require__(45);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMContainerInfo = __webpack_require__(186);
	var ReactDOMFeatureFlags = __webpack_require__(448);
	var ReactFeatureFlags = __webpack_require__(191);
	var ReactInstanceMap = __webpack_require__(62);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMarkupChecksum = __webpack_require__(194);
	var ReactReconciler = __webpack_require__(43);
	var ReactUpdateQueue = __webpack_require__(114);
	var ReactUpdates = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(119);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(79);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(45);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(42);
	var Transaction = __webpack_require__(77);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactServerUpdateQueue = __webpack_require__(468);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(196);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var setInnerHTML = __webpack_require__(79);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(457);
	
	var getIteratorFn = __webpack_require__(487);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(110);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(453);


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _PatternUtils = __webpack_require__(55);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(81);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(74);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(174);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(404);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(217);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(81);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(74);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(174);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(245);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(224);
	
	var canDefineProperty = __webpack_require__(225);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(2);
	var lowPriorityWarning = __webpack_require__(546);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(29);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 223 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 226 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(557);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	var toObject = Object;
	var TypeErr = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== toObject(this)) {
			throw new TypeErr('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(229);
	
	var supportsDescriptors = __webpack_require__(100).supportsDescriptors;
	var gOPD = Object.getOwnPropertyDescriptor;
	var TypeErr = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if (/a/mig.flags === 'gim') {
			var descriptor = gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Circle = (function (_MapComponent) {
	    _inherits(Circle, _MapComponent);
	
	    function Circle() {
	        _classCallCheck(this, Circle);
	
	        _get(Object.getPrototypeOf(Circle.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: []
	        };
	    }
	
	    _createClass(Circle, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].circle(this.props.pos, this.props.radius);
	
	            if (this.props.style) {
	                dgElement.setStyle(this.props.style);
	            }
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	
	            this.props.element.addLayer(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var dgElement = this.state.dgElement;
	
	            this.updatePos(prevProps);
	
	            if (this.checkPropsChange('radius', prevProps)) {
	                dgElement.setRadius(this.props.radius);
	            }
	
	            this.updateLabel(prevProps);
	
	            this.updateStyle(prevProps);
	
	            this.updateEvents(dgElement, prevProps);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            pos: _react.PropTypes.array,
	            radius: _react.PropTypes.number,
	            label: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    return Circle;
	})(_MapComponent3['default']);
	
	exports['default'] = Circle;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var CircleMarker = (function (_MapComponent) {
	    _inherits(CircleMarker, _MapComponent);
	
	    function CircleMarker() {
	        _classCallCheck(this, CircleMarker);
	
	        _get(Object.getPrototypeOf(CircleMarker.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: []
	        };
	    }
	
	    _createClass(CircleMarker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].circleMarker(this.props.pos);
	
	            if (this.props.style) {
	                dgElement.setStyle(this.props.style);
	            }
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            if (this.props.radius) {
	                dgElement.setRadius(this.props.radius);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	
	            this.props.element.addLayer(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var dgElement = this.state.dgElement;
	
	            this.updatePos(prevProps);
	
	            if (this.checkPropsChange('radius', prevProps)) {
	                dgElement.setRadius(this.props.radius);
	            }
	
	            this.updateLabel(prevProps);
	
	            this.updateStyle(prevProps);
	
	            this.updateEvents(dgElement, prevProps);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            pos: _react.PropTypes.array,
	            radius: _react.PropTypes.number,
	            label: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    return CircleMarker;
	})(_MapComponent3['default']);
	
	exports['default'] = CircleMarker;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDomServer = __webpack_require__(208);
	
	var _reactDomServer2 = _interopRequireDefault(_reactDomServer);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var DivIcon = (function (_MapComponent) {
	    _inherits(DivIcon, _MapComponent);
	
	    function DivIcon() {
	        _classCallCheck(this, DivIcon);
	
	        _get(Object.getPrototypeOf(DivIcon.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DivIcon, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var iconHtml = '';
	            if (this.props.children) {
	                iconHtml = _reactDomServer2['default'].renderToString(_react2['default'].createElement(
	                    'div',
	                    { style: {
	                            padding: 0,
	                            margin: 0,
	                            display: 'inline'
	                        } },
	                    this.props.children
	                ));
	            } else {
	                iconHtml = this.props.dangerouslySetInnerHTML;
	            }
	
	            var icon = _gisMaps2['default'].divIcon({
	                iconSize: this.props.iconSize,
	                html: iconHtml
	            });
	
	            this.props.element.setIcon(icon);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            iconSize: _react.PropTypes.array,
	            dangerouslySetInnerHTML: _react.PropTypes.string
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            dangerouslySetInnerHTML: ''
	        },
	        enumerable: true
	    }]);
	
	    return DivIcon;
	})(_MapComponent3['default']);
	
	exports['default'] = DivIcon;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var GeoJSON = (function (_MapComponent) {
	    _inherits(GeoJSON, _MapComponent);
	
	    function GeoJSON() {
	        _classCallCheck(this, GeoJSON);
	
	        _get(Object.getPrototypeOf(GeoJSON.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null
	        };
	    }
	
	    _createClass(GeoJSON, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.renderGeoJSON();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.checkPropsChange(['data', 'style', 'pointToLayer', 'onEachFeature', 'onEachFeature'], prevProps)) {
	                this.renderGeoJSON();
	            }
	        }
	    }, {
	        key: 'renderGeoJSON',
	        value: function renderGeoJSON() {
	            var options = {
	                style: this.props.style,
	                pointToLayer: this.props.pointToLayer,
	                onEachFeature: this.props.onEachFeature,
	                filter: this.props.filter
	            };
	
	            if (this.state.dgElement) {
	                this.state.dgElement.remove();
	            }
	
	            var dgElement = _gisMaps2['default'].geoJson(this.props.data, options);
	            this.props.element.addLayer(dgElement);
	
	            this.setState({
	                dgElement: dgElement
	            });
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            data: _react.PropTypes.object,
	            style: _react.PropTypes.object,
	            pointToLayer: _react.PropTypes.func,
	            onEachFeature: _react.PropTypes.func,
	            filter: _react.PropTypes.func
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            style: null,
	            pointToLayer: null,
	            onEachFeature: null,
	            filter: null
	        },
	        enumerable: true
	    }]);
	
	    return GeoJSON;
	})(_MapComponent3['default']);
	
	exports['default'] = GeoJSON;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Icon = (function (_MapComponent) {
	    _inherits(Icon, _MapComponent);
	
	    function Icon() {
	        _classCallCheck(this, Icon);
	
	        _get(Object.getPrototypeOf(Icon.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Icon, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setIcon();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.iconUrl != this.props.iconUrl || prevProps.iconSize != this.props.iconSize) {
	                this.setIcon();
	            }
	            self.props.element._bringToFront();
	        }
	    }, {
	        key: 'setIcon',
	        value: function setIcon() {
	            this.props.element.setIcon(_gisMaps2['default'].icon({
	                iconUrl: this.props.iconUrl,
	                iconSize: this.props.iconSize
	            }));
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            iconUrl: _react.PropTypes.string,
	            iconSize: _react.PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    return Icon;
	})(_MapComponent3['default']);
	
	exports['default'] = Icon;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Map = (function (_MapComponent) {
	    _inherits(Map, _MapComponent);
	
	    function Map() {
	        _classCallCheck(this, Map);
	
	        _get(Object.getPrototypeOf(Map.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: []
	        };
	    }
	
	    _createClass(Map, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this = this;
	
	            var container = this.refs.container;
	
	            // Map options.
	            var _props = this.props;
	            var zoom = _props.zoom;
	            var center = _props.center;
	            var geoclicker = _props.geoclicker;
	            var projectDetector = _props.projectDetector;
	            var zoomControl = _props.zoomControl;
	            var fullscreenControl = _props.fullscreenControl;
	            var preferCanvas = _props.preferCanvas;
	            var touchZoom = _props.touchZoom;
	            var scrollWheelZoom = _props.scrollWheelZoom;
	            var doubleClickZoom = _props.doubleClickZoom;
	            var dragging = _props.dragging;
	            var maxBounds = _props.maxBounds;
	            var minZoom = _props.minZoom;
	            var maxZoom = _props.maxZoom;
	
	            var options = {
	                zoom: zoom, center: center, geoclicker: geoclicker, projectDetector: projectDetector, zoomControl: zoomControl, fullscreenControl: fullscreenControl, preferCanvas: preferCanvas, touchZoom: touchZoom,
	                scrollWheelZoom: scrollWheelZoom, doubleClickZoom: doubleClickZoom, dragging: dragging, maxBounds: maxBounds, minZoom: minZoom, maxZoom: maxZoom
	            };
	
	            // Check exist prop center.
	            if (!center) {
	                console.error('For initial map You should set prop \'center\'.');
	            }
	
	            // Check exist zoom center.
	            if (!zoom) {
	                console.error('For initial map You should set prop \'zoom\'.');
	            }
	
	            // Create Map.
	            var dgElement = _gisMaps2['default'].map(container, options);
	
	            if (this.props.onProjectChange) {
	                dgElement.on('projectchange', function (e) {
	                    return _this.props.onProjectChange(e);
	                });
	            }
	
	            if (this.props.onProjectLeave) {
	                dgElement.on('projectleave', function (e) {
	                    return _this.props.onProjectLeave(e);
	                });
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var dgElement = this.state.dgElement;
	
	            if (this.checkPropsChange('center', prevProps)) {
	                dgElement.setView(this.props.center);
	            }
	
	            if (this.checkPropsChange('zoom', prevProps)) {
	                dgElement.setZoom(this.props.zoom);
	            }
	
	            if (this.checkPropsChange('style', prevProps)) {
	                dgElement.invalidateSize();
	            }
	
	            this.updateEvents(dgElement, prevProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { ref: 'container', style: this.props.style },
	                _get(Object.getPrototypeOf(Map.prototype), 'render', this).call(this)
	            );
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            center: _react.PropTypes.array,
	            zoom: _react.PropTypes.number,
	            geoclicker: _react.PropTypes.bool,
	            projectDetector: _react.PropTypes.bool,
	            zoomControl: _react.PropTypes.bool,
	            fullscreenControl: _react.PropTypes.bool,
	            preferCanvas: _react.PropTypes.bool,
	            touchZoom: _react.PropTypes.bool,
	            scrollWheelZoom: _react.PropTypes.bool,
	            doubleClickZoom: _react.PropTypes.bool,
	            dragging: _react.PropTypes.bool,
	            maxBounds: _react.PropTypes.array,
	            minZoom: _react.PropTypes.number,
	            maxZoom: _react.PropTypes.number
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            zoom: false,
	            center: false,
	            geoclicker: false,
	            projectDetector: false,
	            zoomControl: true,
	            fullscreenControl: true,
	            preferCanvas: true,
	            touchZoom: true,
	            scrollWheelZoom: true,
	            doubleClickZoom: true,
	            dragging: true
	        },
	        enumerable: true
	    }]);
	
	    return Map;
	})(_MapComponent3['default']);
	
	exports['default'] = Map;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Marker = (function (_MapComponent) {
	    _inherits(Marker, _MapComponent);
	
	    function Marker() {
	        var _this = this;
	
	        _classCallCheck(this, Marker);
	
	        _get(Object.getPrototypeOf(Marker.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: [],
	            pos: this.props.pos || null
	        };
	
	        this.dragging = function (e) {
	            _this.setState({
	                dgElement: _this.state.dgElement,
	                childrenForRender: _this.state.childrenForRender,
	                pos: e.latlng
	            });
	        };
	    }
	
	    _createClass(Marker, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var dgElement = _gisMaps2['default'].marker(this.props.pos, {
	                draggable: this.props.draggable,
	                clickable: this.props.clickable
	            });
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            }, function () {
	                // For dragging Marker.
	                if (_this2.props.draggable) {
	                    _this2.draggingSwitchTo(true);
	                }
	            });
	
	            this.bindEvents(dgElement);
	
	            // todo: fix it after fix https://github.com/2gis/mapsapi/issues/332
	            if (this.props.staticLabel) {
	                this.props.element.addLayer(dgElement);
	
	                dgElement.bindLabel(this.props.staticLabel, { 'static': true });
	            } else {
	                this.props.element.addLayer(dgElement);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var dgElement = this.state.dgElement;
	
	            this.updatePos(prevProps);
	
	            this.updateLabel(prevProps);
	
	            // Update static label.
	            if (this.checkPropsChange('staticLabel', prevProps)) {
	                dgElement.bindLabel(this.props.staticLabel, { 'static': true });
	            }
	
	            // Update draggable.
	            if (this.checkPropsChange('draggable', prevProps)) {
	                this.draggingSwitchTo(this.props.draggable);
	            }
	
	            this.updateEvents(dgElement, prevProps);
	        }
	    }, {
	        key: 'draggingSwitchTo',
	        value: function draggingSwitchTo(isEnable) {
	            var dgElement = this.state.dgElement;
	
	            if (isEnable) {
	                dgElement.on('drag', this.dragging);
	                dgElement.dragging.enable();
	            } else {
	                dgElement.off('drag', this.dragging);
	                dgElement.dragging.disable();
	                dgElement.setLatLng(this.state.pos);
	            }
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            pos: _react.PropTypes.array,
	            label: _react.PropTypes.string,
	            staticLabel: _react.PropTypes.string,
	            draggable: _react.PropTypes.bool,
	            clickable: _react.PropTypes.bool
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            draggable: false,
	            clickable: true,
	            label: false,
	            staticLabel: false
	        },
	        enumerable: true
	    }]);
	
	    return Marker;
	})(_MapComponent3['default']);
	
	exports['default'] = Marker;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Polygon = (function (_MapComponent) {
	    _inherits(Polygon, _MapComponent);
	
	    function Polygon() {
	        _classCallCheck(this, Polygon);
	
	        _get(Object.getPrototypeOf(Polygon.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: []
	        };
	    }
	
	    _createClass(Polygon, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].polygon(this.props.points);
	
	            if (this.props.style) {
	                dgElement.setStyle(this.props.style);
	            }
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	
	            this.props.element.addLayer(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            this.updatePoints(prevProps);
	            this.updateLabel(prevProps);
	            this.updateStyle(prevProps);
	            this.updateEvents(this.state.dgElement);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            points: _react.PropTypes.array,
	            label: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    return Polygon;
	})(_MapComponent3['default']);
	
	exports['default'] = Polygon;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Polyline = (function (_MapComponent) {
	    _inherits(Polyline, _MapComponent);
	
	    function Polyline() {
	        _classCallCheck(this, Polyline);
	
	        _get(Object.getPrototypeOf(Polyline.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null
	        };
	    }
	
	    _createClass(Polyline, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].polyline(this.props.points, this.props.style);
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	
	            this.props.element.addLayer(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            this.updatePoints(prevProps);
	            this.updateLabel(prevProps);
	            this.updateStyle(prevProps);
	            this.updateEvents(this.state.dgElement);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            points: _react.PropTypes.array,
	            label: _react.PropTypes.string
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            style: null
	        },
	        enumerable: true
	    }]);
	
	    return Polyline;
	})(_MapComponent3['default']);
	
	exports['default'] = Polyline;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDomServer = __webpack_require__(208);
	
	var _reactDomServer2 = _interopRequireDefault(_reactDomServer);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Popup = (function (_MapComponent) {
	    _inherits(Popup, _MapComponent);
	
	    function Popup() {
	        _classCallCheck(this, Popup);
	
	        _get(Object.getPrototypeOf(Popup.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(Popup, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var popupHtml = this.renderChildren();
	
	            var element = this.props.element;
	
	            var dgElement = null;
	
	            // Popup options.
	            var _props = this.props;
	            var maxWidth = _props.maxWidth;
	            var minWidth = _props.minWidth;
	            var maxHeight = _props.maxHeight;
	            var sprawling = _props.sprawling;
	            var className = _props.className;
	
	            var options = {
	                maxWidth: maxWidth, minWidth: minWidth, maxHeight: maxHeight, sprawling: sprawling, className: className
	            };
	
	            if (this.insideMap()) {
	                dgElement = _gisMaps2['default'].popup(options).setLatLng(this.props.pos).setContent(popupHtml).openOn(element);
	            } else {
	                if (element.getPopup()) {
	                    element.setPopupContent(popupHtml);
	                } else {
	                    element.bindPopup(popupHtml, options);
	                }
	
	                dgElement = element.getPopup();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var element = this.props.element;
	
	            if (prevProps.children != this.props.children) {
	                var popupHtml = this.renderChildren();
	
	                if (this.insideMap()) {
	                    element.getPopup().setContent(popupHtml);
	                } else {
	                    element.setPopupContent(popupHtml);
	                }
	            }
	
	            this.updatePos(prevProps);
	
	            if (element.getPopup) {
	                this.updateEvents(element.getPopup());
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.props.element.unbindPopup();
	        }
	    }, {
	        key: 'renderChildren',
	        value: function renderChildren() {
	            return _reactDomServer2['default'].renderToString(_react2['default'].createElement(
	                'div',
	                { style: {
	                        padding: 0,
	                        margin: 0,
	                        display: 'inline'
	                    } },
	                this.props.children
	            ));
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            pos: _react.PropTypes.array,
	            maxWidth: _react.PropTypes.number,
	            minWidth: _react.PropTypes.number,
	            maxHeight: _react.PropTypes.number,
	            sprawling: _react.PropTypes.bool,
	            className: _react.PropTypes.string
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            maxWidth: 300,
	            minWidth: 50,
	            maxHeight: null,
	            sprawling: false,
	            className: ''
	        },
	        enumerable: true
	    }]);
	
	    return Popup;
	})(_MapComponent3['default']);
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Rectangle = (function (_MapComponent) {
	    _inherits(Rectangle, _MapComponent);
	
	    function Rectangle() {
	        _classCallCheck(this, Rectangle);
	
	        _get(Object.getPrototypeOf(Rectangle.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null,
	            childrenForRender: []
	        };
	    }
	
	    _createClass(Rectangle, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].rectangle(this.props.bounds);
	
	            if (this.props.style) {
	                dgElement.setStyle(this.props.style);
	            }
	
	            if (this.props.label) {
	                dgElement.bindLabel(this.props.label);
	            }
	
	            this.setState({
	                dgElement: dgElement
	            });
	
	            this.bindEvents(dgElement);
	
	            this.props.element.addLayer(dgElement);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var dgElement = this.state.dgElement;
	
	            if (this.checkPropsChange('bounds', prevProps)) {
	                dgElement.setBounds(this.props.bounds);
	            }
	            this.updateLabel(prevProps);
	            this.updateStyle(prevProps);
	            this.updateEvents(dgElement, prevProps);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            bounds: _react.PropTypes.array,
	            label: _react.PropTypes.string
	        },
	        enumerable: true
	    }]);
	
	    return Rectangle;
	})(_MapComponent3['default']);
	
	exports['default'] = Rectangle;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Ruler = (function (_MapComponent) {
	    _inherits(Ruler, _MapComponent);
	
	    function Ruler() {
	        _classCallCheck(this, Ruler);
	
	        _get(Object.getPrototypeOf(Ruler.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null
	        };
	    }
	
	    _createClass(Ruler, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var dgElement = _gisMaps2['default'].ruler(this.props.points);
	            this.props.element.addLayer(dgElement);
	            this.setState({
	                dgElement: dgElement
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            this.updatePoints(prevProps);
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            points: _react.PropTypes.array
	        },
	        enumerable: true
	    }]);
	
	    return Ruler;
	})(_MapComponent3['default']);
	
	exports['default'] = Ruler;
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(16)['default'];
	
	var _inherits = __webpack_require__(10)['default'];
	
	var _createClass = __webpack_require__(15)['default'];
	
	var _classCallCheck = __webpack_require__(14)['default'];
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMaps = __webpack_require__(19);
	
	var _gisMaps2 = _interopRequireDefault(_gisMaps);
	
	var _MapComponent2 = __webpack_require__(18);
	
	var _MapComponent3 = _interopRequireDefault(_MapComponent2);
	
	var Wkt = (function (_MapComponent) {
	    _inherits(Wkt, _MapComponent);
	
	    function Wkt() {
	        _classCallCheck(this, Wkt);
	
	        _get(Object.getPrototypeOf(Wkt.prototype), 'constructor', this).apply(this, arguments);
	
	        this.state = {
	            dgElement: null
	        };
	    }
	
	    _createClass(Wkt, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.renderWkt();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.checkPropsChange(['data', 'style'], prevProps)) {
	                this.renderWkt();
	            }
	        }
	    }, {
	        key: 'renderWkt',
	        value: function renderWkt() {
	            var dgElement = _gisMaps2['default'].Wkt.geoJsonLayer(this.props.data, this.props.style);
	
	            if (this.state.dgElement) {
	                this.state.dgElement.remove();
	            }
	
	            this.props.element.addLayer(dgElement);
	
	            this.setState({
	                dgElement: dgElement
	            });
	        }
	    }], [{
	        key: 'propsTypes',
	        value: {
	            style: _react.PropTypes.object,
	            data: _react.PropTypes.string
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            style: null
	        },
	        enumerable: true
	    }]);
	
	    return Wkt;
	})(_MapComponent3['default']);
	
	exports['default'] = Wkt;
	module.exports = exports['default'];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(13)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _MapJs = __webpack_require__(236);
	
	var _MapJs2 = _interopRequireDefault(_MapJs);
	
	exports.Map = _MapJs2['default'];
	
	var _MarkerJs = __webpack_require__(237);
	
	var _MarkerJs2 = _interopRequireDefault(_MarkerJs);
	
	exports.Marker = _MarkerJs2['default'];
	
	var _PopupJs = __webpack_require__(240);
	
	var _PopupJs2 = _interopRequireDefault(_PopupJs);
	
	exports.Popup = _PopupJs2['default'];
	
	var _IconJs = __webpack_require__(235);
	
	var _IconJs2 = _interopRequireDefault(_IconJs);
	
	exports.Icon = _IconJs2['default'];
	
	var _DivIconJs = __webpack_require__(233);
	
	var _DivIconJs2 = _interopRequireDefault(_DivIconJs);
	
	exports.DivIcon = _DivIconJs2['default'];
	
	var _RulerJs = __webpack_require__(242);
	
	var _RulerJs2 = _interopRequireDefault(_RulerJs);
	
	exports.Ruler = _RulerJs2['default'];
	
	var _GeoJSONJs = __webpack_require__(234);
	
	var _GeoJSONJs2 = _interopRequireDefault(_GeoJSONJs);
	
	exports.GeoJSON = _GeoJSONJs2['default'];
	
	var _WktJs = __webpack_require__(243);
	
	var _WktJs2 = _interopRequireDefault(_WktJs);
	
	exports.Wkt = _WktJs2['default'];
	
	var _CircleJs = __webpack_require__(231);
	
	var _CircleJs2 = _interopRequireDefault(_CircleJs);
	
	exports.Circle = _CircleJs2['default'];
	
	var _CircleMarkerJs = __webpack_require__(232);
	
	var _CircleMarkerJs2 = _interopRequireDefault(_CircleMarkerJs);
	
	exports.CircleMarker = _CircleMarkerJs2['default'];
	
	var _PolylineJs = __webpack_require__(239);
	
	var _PolylineJs2 = _interopRequireDefault(_PolylineJs);
	
	exports.Polyline = _PolylineJs2['default'];
	
	var _PolygonJs = __webpack_require__(238);
	
	var _PolygonJs2 = _interopRequireDefault(_PolygonJs);
	
	exports.Polygon = _PolygonJs2['default'];
	
	var _RectangleJs = __webpack_require__(241);
	
	var _RectangleJs2 = _interopRequireDefault(_RectangleJs);
	
	exports.Rectangle = _RectangleJs2['default'];

/***/ },
/* 245 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  publicationViews: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_ABOUT_PUBLICATIONS':
	      return Object.assign({}, state, { publicationViews: action.publicationViews });
	    default:
	      return state;
	  }
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.downloadComments = undefined;
	
	__webpack_require__(34);
	
	var URL_EVENT_COMMENTS_AFTER_EVENT = '/api/after-event-comment-list1.json';
	//const URL_EVENT_COMMENTS_BEFORE_EVENT = '/api/before-event-comment-list1.json';
	
	var downloadComments = exports.downloadComments = function downloadComments() {
	  return function (dispatch) {
	    fetch(URL_EVENT_COMMENTS_AFTER_EVENT).then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'PARSE_COMMENT_LIST',
	          eventCommentList: json.eventCommentList
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'COMMENT_ERROR',
	        error: err
	      });
	    });
	  };
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormField = __webpack_require__(57);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _PasswordField = __webpack_require__(83);
	
	var _PasswordField2 = _interopRequireDefault(_PasswordField);
	
	var _Form = __webpack_require__(66);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _authAction = __webpack_require__(35);
	
	var _formValidators = __webpack_require__(46);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Authorization = function (_Component) {
	  _inherits(Authorization, _Component);
	
	  function Authorization() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Authorization);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Authorization.__proto__ || Object.getPrototypeOf(Authorization)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFormAuth: true
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Authorization, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.participantView.userShortView || !this.props.withServer) {
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setInitialState();
	      this.props.clearFields();
	    }
	  }, {
	    key: 'onRestorePassword',
	    value: function onRestorePassword(e) {
	      e.preventDefault();
	      this.setState({ isFormAuth: false });
	    }
	  }, {
	    key: 'onAuthForm',
	    value: function onAuthForm(e) {
	      e.preventDefault();
	      this.setState({ isFormAuth: true });
	    }
	  }, {
	    key: 'afterValidation',
	    value: function afterValidation() {
	      if (this.props.isValidated) {
	        if (this.state.isFormAuth) {
	          var data = this.props.fields;
	          this.props.postAuth('j_username=' + data['j_username'] + '&j_password=' + data['j_password']);
	        } else {
	          this.props.postRestore(new FormData(this.refs.form.refs.form));
	        }
	      }
	    }
	  }, {
	    key: 'beforeFormSubmit',
	    value: function beforeFormSubmit() {
	      this.props.formSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.participantView.userShortView || !this.props.withServer) {
	        _reactRouter.browserHistory.push('/');
	      }
	
	      var that = this;
	
	      if (this.props.afterValidate) {
	        this.afterValidation();
	      }
	      if (this.props.successRestore) {
	        setTimeout(function () {
	          that.props.setInitialState();
	          _reactRouter.browserHistory.push('/');
	        }, 5000);
	      }
	      var formContent = void 0;
	      if (this.state.isFormAuth) {
	        formContent = _react2.default.createElement(
	          _Form2.default,
	          {
	            title: '\u0412\u0445\u043E\u0434 \u043D\u0430 \u0441\u0430\u0439\u0442',
	            ref: 'form',
	            name: 'loginForm'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'authorization__error' },
	            this.props.failMessage
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'authorization__field' },
	            _react2.default.createElement(_FormField2.default, {
	              title: 'Email', type: 'text', fieldName: 'j_username',
	              errorHandler: _formValidators.emailHandler, ref: 'email', key: 'j_username'
	            }),
	            _react2.default.createElement(_PasswordField2.default, {
	              title: '\u041F\u0430\u0440\u043E\u043B\u044C', fieldName: 'j_password', key: 'j_password',
	              errorHandler: _formValidators.passwordHandler, ref: 'password'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'authorization__link' },
	            _react2.default.createElement(
	              'div',
	              { className: 'authorization__link-text', onClick: this.onRestorePassword.bind(this) },
	              '\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?'
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              styleClasses: ['authorization__button'],
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this2.beforeFormSubmit();
	              }
	            },
	            '\u0412\u043E\u0439\u0442\u0438'
	          )
	        );
	      } else {
	        formContent = _react2.default.createElement(
	          _Form2.default,
	          {
	            title: '\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F',
	            ref: 'form',
	            name: 'restoreRequestForm',
	            successMessage: this.props.successMessage
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'authorization__field' },
	            _react2.default.createElement(_FormField2.default, {
	              title: 'Email', type: 'text', fieldName: 'email',
	              errorHandler: _formValidators.emailHandler, ref: 'email', key: 'email'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'authorization__link' },
	            _react2.default.createElement(
	              'div',
	              { className: 'authorization__link-text', onClick: this.onAuthForm.bind(this) },
	              '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A\u043E \u0432\u0445\u043E\u0434\u0443'
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: function onClick(e) {
	                e.preventDefault();
	                _this2.beforeFormSubmit();
	              },
	              styleClasses: ['authorization__button']
	            },
	            '\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C'
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'authorization' },
	        formContent
	      );
	    }
	  }]);
	
	  return Authorization;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    successRestore: state.auth.successRestore,
	    isValidated: state.auth.isValidated,
	    afterValidate: state.auth.afterValidate,
	    failMessage: state.auth.failMessage,
	    successMessage: state.auth.successMessage,
	    participantView: state.participant.participantView,
	    fields: state.fields,
	    withServer: state.participant.withServer
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    formSubmit: (0, _redux.bindActionCreators)(_authAction.formSubmit, dispatch),
	    postAuth: (0, _redux.bindActionCreators)(_authAction.postAuth, dispatch),
	    postRestore: (0, _redux.bindActionCreators)(_authAction.postRestore, dispatch),
	    setInitialState: (0, _redux.bindActionCreators)(_authAction.setInitialState, dispatch),
	    clearFields: (0, _redux.bindActionCreators)(_fieldAction.clearFields, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Authorization);

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comment = function (_Component) {
	  _inherits(Comment, _Component);
	
	  function Comment() {
	    _classCallCheck(this, Comment);
	
	    return _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).apply(this, arguments));
	  }
	
	  _createClass(Comment, [{
	    key: 'render',
	    value: function render() {
	      var comment = this.props.commentData;
	      var classes = this.props.styleClasses ? this.props.styleClasses : '';
	      var quotes = this.props.quotesElement ? this.props.quotesElement : '';
	      return _react2.default.createElement(
	        'li',
	        { className: 'review clearfix ' + classes[0] },
	        _react2.default.createElement('img', { className: 'review__avatar', src: comment.commentAuthorView.pictureUrl, alt: comment.commentAuthorView.fullName }),
	        _react2.default.createElement(
	          'div',
	          { className: 'review__column ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'review__author ' + classes[2] },
	            comment.commentAuthorView.fullName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'review__from ' + classes[2] },
	            _react2.default.createElement(
	              'span',
	              { className: 'review__org' },
	              comment.commentAuthorView.companyName,
	              ', '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'review__activities' },
	              comment.commentAuthorView.jobPosition,
	              ', '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'review__city' },
	              comment.commentAuthorView.city.name
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'review__text ' + classes[1] },
	            _react2.default.createElement(
	              'p',
	              null,
	              quotes[0],
	              comment.commentText,
	              quotes[1]
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Comment;
	}(_react.Component);
	
	exports.default = Comment;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	__webpack_require__(163);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Error404 = function (_Component) {
	  _inherits(Error404, _Component);
	
	  function Error404() {
	    _classCallCheck(this, Error404);
	
	    return _possibleConstructorReturn(this, (Error404.__proto__ || Object.getPrototypeOf(Error404)).apply(this, arguments));
	  }
	
	  _createClass(Error404, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        _react2.default.createElement(
	          'div',
	          { className: 'error__title' },
	          _react2.default.createElement(
	            'div',
	            { className: 'error__title-text error__title-text_left' },
	            '4'
	          ),
	          _react2.default.createElement('img', { src: '/static/images/head-boy.png', className: 'error__boy', alt: '\u041E\u0448\u0438\u0431\u043A\u0430' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'error__title-text error__title-text_right' },
	            '4'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'error__text' },
	          '\u0423\u043F\u0441... \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A!'
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/' },
	          _react2.default.createElement(
	            _Button2.default,
	            { styleClasses: ['error__button'] },
	            '\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Error404;
	}(_react.Component);
	
	exports.default = Error404;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	__webpack_require__(163);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Error404 = function (_Component) {
	  _inherits(Error404, _Component);
	
	  function Error404() {
	    _classCallCheck(this, Error404);
	
	    return _possibleConstructorReturn(this, (Error404.__proto__ || Object.getPrototypeOf(Error404)).apply(this, arguments));
	  }
	
	  _createClass(Error404, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        _react2.default.createElement(
	          'div',
	          { className: 'error__title' },
	          _react2.default.createElement('img', { src: '/static/images/head-boy.png', className: 'error__boy', alt: '\u041E\u0448\u0438\u0431\u043A\u0430' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'error__text' },
	          '\u0423\u043F\u0441... \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'error__text' },
	          '\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0441\u0441\u043B\u044B\u043A\u0438'
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/' },
	          _react2.default.createElement(
	            _Button2.default,
	            { styleClasses: ['error__button'] },
	            '\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Error404;
	}(_react.Component);
	
	exports.default = Error404;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmEvent = function (_Component) {
	  _inherits(ConfirmEvent, _Component);
	
	  function ConfirmEvent() {
	    _classCallCheck(this, ConfirmEvent);
	
	    return _possibleConstructorReturn(this, (ConfirmEvent.__proto__ || Object.getPrototypeOf(ConfirmEvent)).apply(this, arguments));
	  }
	
	  _createClass(ConfirmEvent, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: classes + ' form__info-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__tips' },
	          '\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F \u043F\u0440\u043E\u0439\u0434\u0435\u0442 \u0432\xA02\xA0\u0434\u043D\u044F. \u0412 \u0441\u0443\u0431\u0431\u043E\u0442\u0443 \u043C\u044B \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043C \u043E\xA0\u0432\u0435\u0431-\u0434\u0438\u0437\u0430\u0439\u043D\u0435, \u043C\u0435\u043D\u0435\u0434\u0436\u043C\u0435\u043D\u0442\u0435  IT-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0441\u0442\u0430\u0440\u0442\u0430\u043F\u0430\u0445 \u0438 soft\xA0skills. \u0410\xA0\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435 \u043F\u043E\u0441\u0432\u044F\u0442\u0438\u043C \u043E\u0431\u0437\u043E\u0440\u0443 \u043E\u0442\u0440\u0430\u0441\u043B\u0435\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__inputs' },
	          _react2.default.createElement(
	            'label',
	            { className: 'form__label' },
	            '\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435:'
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ConfirmEvent;
	}(_react.Component);
	
	exports.default = ConfirmEvent;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownField = __webpack_require__(130);
	
	var _DropdownField2 = _interopRequireDefault(_DropdownField);
	
	var _NumberSelector = __webpack_require__(139);
	
	var _NumberSelector2 = _interopRequireDefault(_NumberSelector);
	
	var _FormField = __webpack_require__(57);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InstituteInfo = function (_Component) {
	  _inherits(InstituteInfo, _Component);
	
	  function InstituteInfo() {
	    _classCallCheck(this, InstituteInfo);
	
	    return _possibleConstructorReturn(this, (InstituteInfo.__proto__ || Object.getPrototypeOf(InstituteInfo)).apply(this, arguments));
	  }
	
	  _createClass(InstituteInfo, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__inputs ' + this.props.styleEducation },
	          _react2.default.createElement(_DropdownField2.default, { key: 'institute',
	            fieldName: 'instituteId', title: '\u0412\u0423\u0417/\u043A\u043E\u043B\u043B\u0435\u0434\u0436',
	            ref: 'education', optionList: this.props.instituteList,
	            defaultValue: this.props.instituteId
	          }),
	          _react2.default.createElement(_FormField2.default, {
	            key: 'department', title: '\u0424\u0430\u043A\u0443\u043B\u044C\u0442\u0435\u0442',
	            type: 'text', fieldName: 'department',
	            errorHandler: this.props.departmentHandler,
	            clearFields: this.props.clearFields,
	            defaultValue: this.props.department
	          }),
	          _react2.default.createElement(_NumberSelector2.default, {
	            key: 'course',
	            start: 1,
	            end: 2,
	            name: 'course',
	            title: '\u041A\u0443\u0440\u0441',
	            onChange: this.props.courseHandler,
	            defaultValue: this.props.course
	          })
	        )
	      );
	    }
	  }]);
	
	  return InstituteInfo;
	}(_react.Component);
	
	exports.default = InstituteInfo;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NumberSelector = __webpack_require__(139);
	
	var _NumberSelector2 = _interopRequireDefault(_NumberSelector);
	
	var _DropdownField = __webpack_require__(130);
	
	var _DropdownField2 = _interopRequireDefault(_DropdownField);
	
	__webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import FormField from '../form-field/FormField';
	
	
	var SchoolInfo = function (_Component) {
	  _inherits(SchoolInfo, _Component);
	
	  function SchoolInfo() {
	    _classCallCheck(this, SchoolInfo);
	
	    return _possibleConstructorReturn(this, (SchoolInfo.__proto__ || Object.getPrototypeOf(SchoolInfo)).apply(this, arguments));
	  }
	
	  _createClass(SchoolInfo, [{
	    key: 'render',
	    value: function render() {
	      var classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'form__inputs ' + this.props.styleEducation },
	          _react2.default.createElement(_DropdownField2.default, {
	            key: 'school', title: '\u0428\u043A\u043E\u043B\u0430',
	            fieldName: 'schoolId',
	            optionList: this.props.schoolList,
	            defaultValue: this.props.schoolId
	          }),
	          _react2.default.createElement(_NumberSelector2.default, {
	            key: 'classSelector',
	            start: 8,
	            end: 11,
	            name: 'class',
	            title: '\u041A\u043B\u0430\u0441\u0441',
	            onChange: this.props.gradeHandler,
	            defaultValue: this.props.grade
	          })
	        )
	      );
	    }
	  }]);
	
	  return SchoolInfo;
	}(_react.Component);
	
	exports.default = SchoolInfo;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(82);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	__webpack_require__(366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PersonalDataCheckbox = function (_React$Component) {
	  _inherits(PersonalDataCheckbox, _React$Component);
	
	  function PersonalDataCheckbox() {
	    _classCallCheck(this, PersonalDataCheckbox);
	
	    return _possibleConstructorReturn(this, (PersonalDataCheckbox.__proto__ || Object.getPrototypeOf(PersonalDataCheckbox)).apply(this, arguments));
	  }
	
	  _createClass(PersonalDataCheckbox, [{
	    key: 'onChange',
	    value: function onChange(e) {
	      var isValid = e.target.checked;
	      this.props.onChange({
	        isValid: isValid
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = _react2.default.createElement(
	        'span',
	        null,
	        '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C\u0438 ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://bit.ly/7bits-policy-sp', target: '_blank', style: { color: 'inherit' } },
	          '\u043F\u043E \u0441\u0441\u044B\u043B\u043A\u0435'
	        )
	      );
	      return _react2.default.createElement(_Checkbox2.default, {
	        onChangeCallback: this.onChange.bind(this),
	        name: 'personalData',
	        inputId: 'personalData',
	        title: title,
	        isSquare: true
	      });
	    }
	  }]);
	
	  return PersonalDataCheckbox;
	}(_react2.default.Component);
	
	exports.default = PersonalDataCheckbox;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PasswordField = __webpack_require__(83);
	
	var _PasswordField2 = _interopRequireDefault(_PasswordField);
	
	var _Form = __webpack_require__(66);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _authAction = __webpack_require__(35);
	
	var _formValidators = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RestorePassword = function (_Component) {
	  _inherits(RestorePassword, _Component);
	
	  function RestorePassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RestorePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestorePassword.__proto__ || Object.getPrototypeOf(RestorePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      token: ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RestorePassword, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setInitialState();
	    }
	  }, {
	    key: 'afterValidation',
	    value: function afterValidation() {
	      if (this.props.isValidated) {
	        var form = new FormData(this.refs.form.refs.form);
	        var token = this.state.token;
	        form.append('token', token);
	        this.props.postSaveRestore(form);
	      }
	    }
	  }, {
	    key: 'beforeFormSubmit',
	    value: function beforeFormSubmit() {
	      this.props.formSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var that = this;
	      if (window.location.search === '') {
	        _reactRouter.browserHistory.push('/errors');
	      } else {
	        that.state.token = window.location.search.split('=')[1];
	      }
	      if (this.props.afterValidate) {
	        this.afterValidation();
	      }
	      if (this.props.successSaveRestore) {
	        setTimeout(function () {
	          that.props.setInitialState();
	          _reactRouter.browserHistory.push('/auth');
	        }, 5000);
	      }
	
	      var formContent = _react2.default.createElement(
	        _Form2.default,
	        {
	          title: '\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F',
	          ref: 'form',
	          name: 'restoreRequestForm',
	          successMessage: this.props.successMessage
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'authorization__error' },
	          this.props.failMessage
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'authorization__field' },
	          _react2.default.createElement(_PasswordField2.default, {
	            title: '\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', fieldName: 'password',
	            errorHandler: _formValidators.passwordHandler
	          }),
	          _react2.default.createElement(_PasswordField2.default, {
	            title: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C', fieldName: 'confirmedPassword',
	            errorHandler: _formValidators.passwordHandler
	          })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this2.beforeFormSubmit();
	            },
	            styleClasses: ['authorization__button']
	          },
	          '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C'
	        )
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'authorization' },
	        formContent
	      );
	    }
	  }]);
	
	  return RestorePassword;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isValidated: state.auth.isValidated,
	    afterValidate: state.auth.afterValidate,
	    failMessage: state.auth.failMessage,
	    successMessage: state.auth.successMessage,
	    successSaveRestore: state.auth.successSaveRestore
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    formSubmit: (0, _redux.bindActionCreators)(_authAction.formSubmit, dispatch),
	    setInitialState: (0, _redux.bindActionCreators)(_authAction.setInitialState, dispatch),
	    postSaveRestore: (0, _redux.bindActionCreators)(_authAction.postSaveRestore, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RestorePassword);

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './style.css';
	
	
	var SuccessRegistration = function (_Component) {
	  _inherits(SuccessRegistration, _Component);
	
	  function SuccessRegistration() {
	    _classCallCheck(this, SuccessRegistration);
	
	    return _possibleConstructorReturn(this, (SuccessRegistration.__proto__ || Object.getPrototypeOf(SuccessRegistration)).apply(this, arguments));
	  }
	
	  _createClass(SuccessRegistration, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        _react2.default.createElement(
	          'div',
	          { className: 'error__text' },
	          '\u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C! \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E'
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/' },
	          _react2.default.createElement(
	            _Button2.default,
	            { styleClasses: ['error__button'] },
	            '\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SuccessRegistration;
	}(_react.Component);
	
	exports.default = SuccessRegistration;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactRouter = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(6);
	
	var _store = __webpack_require__(301);
	
	var _Layout = __webpack_require__(265);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Landing = __webpack_require__(259);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	var _Register = __webpack_require__(287);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _ReviewLanding = __webpack_require__(141);
	
	var _ReviewLanding2 = _interopRequireDefault(_ReviewLanding);
	
	var _UserProfile = __webpack_require__(302);
	
	var _UserProfile2 = _interopRequireDefault(_UserProfile);
	
	var _Authorization = __webpack_require__(248);
	
	var _Authorization2 = _interopRequireDefault(_Authorization);
	
	var _Speakers = __webpack_require__(297);
	
	var _Speakers2 = _interopRequireDefault(_Speakers);
	
	var _SpeakerSection = __webpack_require__(299);
	
	var _SpeakerSection2 = _interopRequireDefault(_SpeakerSection);
	
	var _AllSpeakers = __webpack_require__(298);
	
	var _AllSpeakers2 = _interopRequireDefault(_AllSpeakers);
	
	var _Participants = __webpack_require__(276);
	
	var _Participants2 = _interopRequireDefault(_Participants);
	
	var _ParticipantsPanel = __webpack_require__(279);
	
	var _ParticipantsPanel2 = _interopRequireDefault(_ParticipantsPanel);
	
	var _Speaker = __webpack_require__(296);
	
	var _Speaker2 = _interopRequireDefault(_Speaker);
	
	var _SuccessRegistration = __webpack_require__(257);
	
	var _SuccessRegistration2 = _interopRequireDefault(_SuccessRegistration);
	
	var _ErrorRegistration = __webpack_require__(251);
	
	var _ErrorRegistration2 = _interopRequireDefault(_ErrorRegistration);
	
	var _Restore = __webpack_require__(289);
	
	var _Restore2 = _interopRequireDefault(_Restore);
	
	var _Schedule = __webpack_require__(291);
	
	var _Schedule2 = _interopRequireDefault(_Schedule);
	
	var _ScheduleSection = __webpack_require__(294);
	
	var _ScheduleSection2 = _interopRequireDefault(_ScheduleSection);
	
	var _ScheduleRoom = __webpack_require__(292);
	
	var _ScheduleRoom2 = _interopRequireDefault(_ScheduleRoom);
	
	var _Error = __webpack_require__(250);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	__webpack_require__(384);
	
	__webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _store.newStore)();
	// import About from './about-page/About';
	
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(
	    _reactRouter.Router,
	    { history: _reactRouter.browserHistory },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: '/', component: _Layout2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Landing2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/register', component: _Register2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/reviews', component: _ReviewLanding2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/profile', component: _UserProfile2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/auth', component: _Authorization2.default }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/speakers', component: _Speakers2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _AllSpeakers2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: '(:filter)', component: _SpeakerSection2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/participants', component: _Participants2.default },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _ParticipantsPanel2.default }),
	        _react2.default.createElement(_reactRouter.Route, { path: '(:filter)', component: _ParticipantsPanel2.default })
	      ),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: '/schedule', component: _Schedule2.default },
	        _react2.default.createElement(_reactRouter.Route, { path: '(:filter)', component: _ScheduleSection2.default })
	      ),
	      _react2.default.createElement(_reactRouter.Route, { path: '/room-event/(:filter)', component: _ScheduleRoom2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/speaker(:filter)', component: _Speaker2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/success-registration', component: _SuccessRegistration2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/fail-registration', component: _ErrorRegistration2.default }),
	      _react2.default.createElement(_reactRouter.Route, { path: '/restore-password', component: _Restore2.default })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _Error2.default })
	  )
	), document.getElementById('root'));

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SliderSmall = __webpack_require__(264);
	
	var _SliderSmall2 = _interopRequireDefault(_SliderSmall);
	
	var _ReviewLanding = __webpack_require__(141);
	
	var _ReviewLanding2 = _interopRequireDefault(_ReviewLanding);
	
	var _UserSections = __webpack_require__(142);
	
	var _UserSections2 = _interopRequireDefault(_UserSections);
	
	var _AfterAdditional = __webpack_require__(260);
	
	var _AfterAdditional2 = _interopRequireDefault(_AfterAdditional);
	
	var _BeforeDescription = __webpack_require__(262);
	
	var _BeforeDescription2 = _interopRequireDefault(_BeforeDescription);
	
	var _AfterVideo = __webpack_require__(261);
	
	var _AfterVideo2 = _interopRequireDefault(_AfterVideo);
	
	var _SubscribeToNews = __webpack_require__(263);
	
	var _SubscribeToNews2 = _interopRequireDefault(_SubscribeToNews);
	
	var _googleFormAction = __webpack_require__(129);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import BeforeAdditional from './blocks/BeforeAdditional';
	
	// import BeforeAbout from './blocks/BeforeAbout';
	
	// import AfterAbout from './blocks/AfterAbout';
	
	
	// import { newEmailHandler }from '../validators/form-validators';
	
	
	var Landing = function (_Component) {
	  _inherits(Landing, _Component);
	
	  function Landing() {
	    _classCallCheck(this, Landing);
	
	    return _possibleConstructorReturn(this, (Landing.__proto__ || Object.getPrototypeOf(Landing)).apply(this, arguments));
	  }
	
	  _createClass(Landing, [{
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(type, event) {
	      event.preventDefault();
	      var validateSuccess = true;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(this.refs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          if (!this.refs[key].onValidate() && key.indexOf(type) > -1) {
	            validateSuccess = false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (validateSuccess) {
	        var formData = new FormData(event.target);
	        this.props.postParticipant(formData);
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = Object.keys(this.refs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _key = _step2.value;
	
	            if (_key.indexOf(type) > -1) {
	              this.refs[_key].clearField();
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var regBtn = null;
	      if (!this.props.participantView.userShortView && this.props.withServer && !this.props.registrationClosed) {
	        regBtn = _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/register' },
	          _react2.default.createElement(
	            _Button2.default,
	            { styleClasses: ['landing__button-register'] },
	            '\u0420\u0415\u0413\u0418\u0421\u0422\u0420\u0410\u0426\u0418\u042F'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'landing' },
	        _react2.default.createElement(
	          'header',
	          { className: 'banner clearfix' },
	          _react2.default.createElement('img', { className: 'banner__logo', src: '/static/images/logo.png', alt: 'Logo' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'banner__date' },
	            '\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F \u043F\u0440\u043E\u0448\u043B\u0430 24 \u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F\u201917',
	            _react2.default.createElement('br', null),
	            '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0432 2018 \u0433\u043E\u0434\u0443'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'banner__bg-persons' },
	            _react2.default.createElement(
	              'span',
	              { className: 'banner__bg-person banner__bg-person_girl' },
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'banner__bg-person banner__bg-person_boy' },
	              '\xA0'
	            )
	          )
	        ),
	        _react2.default.createElement(_SubscribeToNews2.default, {
	          registrationStatus: !this.props.participantRegisterSuccess ? _SubscribeToNews.NOT_REGISTERED : _SubscribeToNews.ALREADY_REGISTERED,
	          onSubmit: this.handleFormSubmit.bind(this, 'participant'),
	          submitDisabled: this.props.participantDataSending
	        }),
	        _react2.default.createElement(_UserSections2.default, null),
	        _react2.default.createElement(
	          'div',
	          null,
	          regBtn
	        ),
	        _react2.default.createElement(_BeforeDescription2.default, null),
	        _react2.default.createElement(_AfterVideo2.default, null),
	        _react2.default.createElement(_AfterAdditional2.default, null),
	        _react2.default.createElement(_SliderSmall2.default, null),
	        _react2.default.createElement(_ReviewLanding2.default, { isRand: true }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: 'reviews' },
	            _react2.default.createElement(
	              _Button2.default,
	              { styleClasses: ['landing__button-reviews'] },
	              '\u0412\u0421\u0415 \u041E\u0422\u0417\u042B\u0412\u042B\xA0\u2192'
	            )
	          )
	        ),
	        _react2.default.createElement(_SubscribeToNews2.default, {
	          registrationStatus: !this.props.participantRegisterSuccess ? _SubscribeToNews.NOT_REGISTERED : _SubscribeToNews.ALREADY_REGISTERED,
	          onSubmit: this.handleFormSubmit.bind(this, 'participant'),
	          submitDisabled: this.props.participantDataSending
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          regBtn
	        )
	      );
	    }
	  }]);
	
	  return Landing;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    participantView: state.participant.participantView,
	    withServer: state.participant.withServer,
	    registrationClosed: state.participant.registrationClosed,
	    participantDataSending: state.googleFormReducer.participantDataSending,
	    participantRegisterSuccess: state.googleFormReducer.participantRegisterSuccess
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    postParticipant: (0, _redux.bindActionCreators)(_googleFormAction.postParticipant, dispatch),
	    clearFields: (0, _redux.bindActionCreators)(_fieldAction.clearFields, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Landing);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeforeAdditional = function (_Component) {
	  _inherits(BeforeAdditional, _Component);
	
	  function BeforeAdditional() {
	    _classCallCheck(this, BeforeAdditional);
	
	    return _possibleConstructorReturn(this, (BeforeAdditional.__proto__ || Object.getPrototypeOf(BeforeAdditional)).apply(this, arguments));
	  }
	
	  _createClass(BeforeAdditional, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'additional' },
	        _react2.default.createElement(
	          'header',
	          { className: 'additional__title' },
	          '\u041A\u0430\u043A \u044D\u0442\u043E \u0431\u044B\u043B\u043E?'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'additional__p' },
	          '\u041E\u0441\u0435\u043D\u044C \u043C\u044B \u043F\u043E\u0441\u0432\u044F\u0442\u0438\u043B\u0438 \u043E\u0431\u0437\u043E\u0440\u0443 \u0432\u0435\u0431- \u0438 \u043C\u043E\u0431\u0430\u0439\u043B-\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435. \u0420\u0430\u0437\u0431\u0430\u0432\u0438\u043B\u0438 \u0430\u0439\u0442\u0438\u0448\u043D\u044B\u0435 \u0434\u043E\u043A\u043B\u0430\u0434\u044B \u0441\u043C\u0435\u0436\u043D\u044B\u043C\u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u043F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043B\u0438 \u043E \u0432\u0435\u0431-\u0434\u0438\u0437\u0430\u0439\u043D\u0435, \u043C\u0435\u043D\u0435\u0434\u0436\u043C\u0435\u043D\u0442\u0435 IT-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0441\u0442\u0430\u0440\u0442\u0430\u043F\u0430\u0445 \u0438 \u0432\u0430\u0436\u043D\u043E\u0441\u0442\u0438 soft skills.'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'additional__p' },
	          '\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438 \u0443\u0437\u043D\u0430\u043B\u0438, \u0447\u0435\u043C \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0442\u0441\u044F IT-\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438, \u043A\u0430\u043A\u0438\u0435 \u0437\u043D\u0430\u043D\u0438\u044F \u043D\u0443\u0436\u043D\u044B, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043F\u0430\u0441\u0442\u044C \u043A \u043D\u0438\u043C, \u043A\u0430\u043A\u0438\u0435 \u0435\u0441\u0442\u044C \u043A\u0443\u0440\u0441\u044B, \u0441\u043F\u0435\u0446\u043A\u0443\u0440\u0441\u044B, \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438, \u0441\u0442\u0430\u0436\u0438\u0440\u043E\u0432\u043A\u0438 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 IT-\u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0432 2017-2018 \u0443\u0447\u0435\u0431\u043D\u043E\u043C \u0433\u043E\u0434\u0443.'
	        )
	      );
	    }
	  }]);
	
	  return BeforeAdditional;
	}(_react.Component);
	
	exports.default = BeforeAdditional;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AfterVideo = function (_Component) {
	  _inherits(AfterVideo, _Component);
	
	  function AfterVideo() {
	    _classCallCheck(this, AfterVideo);
	
	    return _possibleConstructorReturn(this, (AfterVideo.__proto__ || Object.getPrototypeOf(AfterVideo)).apply(this, arguments));
	  }
	
	  _createClass(AfterVideo, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('iframe', { className: 'about-video', src: 'https://www.youtube.com/embed/o_QzhUZccMw' });
	    }
	  }]);
	
	  return AfterVideo;
	}(_react.Component);
	
	exports.default = AfterVideo;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BeforeDescription = function (_Component) {
	  _inherits(BeforeDescription, _Component);
	
	  function BeforeDescription() {
	    _classCallCheck(this, BeforeDescription);
	
	    return _possibleConstructorReturn(this, (BeforeDescription.__proto__ || Object.getPrototypeOf(BeforeDescription)).apply(this, arguments));
	  }
	
	  _createClass(BeforeDescription, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'section',
	        { className: 'description' },
	        _react2.default.createElement(
	          'div',
	          { className: 'description__bg-color' },
	          _react2.default.createElement(
	            'div',
	            { className: 'description__content' },
	            _react2.default.createElement(
	              'section',
	              { className: 'description__column description__column_left' },
	              _react2.default.createElement(
	                'header',
	                { className: 'description__title description__title_small description__title_who' },
	                '\u041A\u041E\u041C\u0423?'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'description__list description__list_top' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0421\u0442\u0443\u0434\u0435\u043D\u0442\u0430\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u044C\u043D\u044B\u0445 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 1-2 \u043A\u0443\u0440\u0441\u0430 (\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0442\u0435\u0442 \u0438\xA0\u0431\u0430\u043A\u0430\u043B\u0430\u0432\u0440\u0438\u0430\u0442), \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0438\xA0\u0440\u0430\u0437\u0443 \u043D\u0435\xA0\u0431\u044B\u043B\u0438 \u0441\u0442\u0430\u0436\u0435\u0440\u0430\u043C\u0438 \u0438\u043B\u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C\u0438 IT-\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0423\u0447\u0430\u0449\u0438\u043C\u0441\u044F \u0444\u0438\u0437-\u043C\u0430\u0442 \u0448\u043A\u043E\u043B, \u0428\u043A\u043E\u043B\u044B \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442\u0430, \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C \u0428\u041C\u0418\u0422, \u041B\u0413\u041C\u0428 \u0438\xA0\u041D\u041E\u0423 \xAB\u041F\u043E\u0438\u0441\u043A\xBB'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0428\u043A\u043E\u043B\u044C\u043D\u0438\u043A\u0430\u043C 10-11\xA0\u043A\u043B\u0430\u0441\u0441\u043E\u0432, \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u044E\u0449\u0438\u0445\u0441\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u043C'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: 'description__column description__column_right' },
	              _react2.default.createElement(
	                'header',
	                { className: 'description__title description__title_small description__title_why' },
	                '\u0417\u0410\u0427\u0415\u041C?'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'description__list description__list_bottom' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043E\u0431\xA0IT-\u0438\u043D\u0434\u0443\u0441\u0442\u0440\u0438\u0438, \u043E\xA0\u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C, \u0431\u0443\u0434\u0443\u0449\u0435\u043C \u0438\xA0\u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u0442\u0435\u043D\u0434\u0435\u043D\u0446\u0438\u044F\u0445'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0423\u0437\u043D\u0430\u0442\u044C, \u0432\xA0\u043A\u0430\u043A\u0438\u0445 \u0432\u043E\u0441\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0441\u0444\u0435\u0440\u0430\u0445\xA0IT \u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0437\u0432\u0438\u0432\u0430\u0442\u044C\u0441\u044F'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u041F\u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441\xA0\u043E\u043C\u0441\u043A\u0438\u043C\u0438 IT-\u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u043C\u0438, \u0443\u0437\u043D\u0430\u0442\u044C \u043E\xA0\u0441\u0442\u0430\u0436\u0438\u0440\u043E\u0432\u043A\u0430\u0445 \u0438\xA0\u043A\u0430\u0440\u044C\u0435\u0440\u043D\u044B\u0445 \u043F\u0435\u0440\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430\u0445'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0417\u0430\u0432\u0435\u0441\u0442\u0438 \u0437\u043D\u0430\u043A\u043E\u043C\u0441\u0442\u0432\u0430 \u0441\xA0\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u043C\u0438 \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044F\u043C\u0438 \u0438\xA0\u0435\u0434\u0438\u043D\u043E\u043C\u044B\u0448\u043B\u0435\u043D\u043D\u0438\u043A\u0430\u043C\u0438'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'description__list-item' },
	                  '\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u043E\u0441\u043E\u0437\u043D\u0430\u043D\u043D\u044B\u0439 \u0432\u044B\u0431\u043E\u0440 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u0438'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BeforeDescription;
	}(_react.Component);
	
	exports.default = BeforeDescription;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NOT_REGISTERED = exports.ALREADY_REGISTERED = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputField = __webpack_require__(138);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _formValidators = __webpack_require__(46);
	
	var _FormSubmitAgreement = __webpack_require__(136);
	
	var _FormSubmitAgreement2 = _interopRequireDefault(_FormSubmitAgreement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Checkbox from '../../blocks/checkbox/Checkbox';
	
	var ALREADY_REGISTERED = exports.ALREADY_REGISTERED = 'already_registered';
	var NOT_REGISTERED = exports.NOT_REGISTERED = 'not_registered';
	
	var SubscribeToNews = function (_React$Component) {
	  _inherits(SubscribeToNews, _React$Component);
	
	  function SubscribeToNews() {
	    _classCallCheck(this, SubscribeToNews);
	
	    return _possibleConstructorReturn(this, (SubscribeToNews.__proto__ || Object.getPrototypeOf(SubscribeToNews)).apply(this, arguments));
	  }
	
	  _createClass(SubscribeToNews, [{
	    key: 'render',
	    value: function render() {
	      var _contentByRegistratio;
	
	      var _props = this.props,
	          registrationStatus = _props.registrationStatus,
	          onSubmit = _props.onSubmit,
	          submitDisabled = _props.submitDisabled;
	
	
	      var contentByRegistrationStatus = (_contentByRegistratio = {}, _defineProperty(_contentByRegistratio, NOT_REGISTERED, _react2.default.createElement(
	        'form',
	        {
	          className: 'participant-form',
	          onSubmit: onSubmit.bind(this, 'participant'),
	          disabled: submitDisabled
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'participant-form__field' },
	          _react2.default.createElement(_InputField2.default, {
	            name: 'entry.1212922480',
	            tabIndex: 1,
	            onValidate: _formValidators.newEmailHandler,
	            ref: 'participantEmail',
	            placeholder: 'Оставьте свой Email'
	          })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            styleClasses: ['participant-form__submit-btn']
	          },
	          '\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043D\u043E\u0432\u043E\u0441\u0442\u0438'
	        ),
	        _react2.default.createElement(_FormSubmitAgreement2.default, null)
	      )), _defineProperty(_contentByRegistratio, ALREADY_REGISTERED, _react2.default.createElement(
	        'div',
	        { className: 'participant-form_success' },
	        '\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E!'
	      )), _contentByRegistratio);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        contentByRegistrationStatus[registrationStatus]
	      );
	    }
	  }]);
	
	  return SubscribeToNews;
	}(_react2.default.Component);
	
	exports.default = SubscribeToNews;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(531);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var settings = {
	  dots: true,
	  infinite: true,
	  speed: 500,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: true,
	  nextArrow: _react2.default.createElement(_Button2.default, { styleClasses: ['slide-arrow slide-arrow_right'] }),
	  prevArrow: _react2.default.createElement(_Button2.default, { styleClasses: ['slide-arrow slide-arrow_left'] }),
	  autoplay: true
	};
	
	var SliderLanding = function (_Component) {
	  _inherits(SliderLanding, _Component);
	
	  function SliderLanding() {
	    _classCallCheck(this, SliderLanding);
	
	    return _possibleConstructorReturn(this, (SliderLanding.__proto__ || Object.getPrototypeOf(SliderLanding)).apply(this, arguments));
	  }
	
	  _createClass(SliderLanding, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'slider-small' },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_01' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_02' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_03' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_04' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_05' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_06' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_07' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_08' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_09' })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { src: '', alt: '', className: 'slider-small__img slider__img_10' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SliderLanding;
	}(_react.Component);
	
	exports.default = SliderLanding;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(272);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Content = __webpack_require__(268);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Footer = __webpack_require__(269);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
	  }
	
	  _createClass(Layout, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Header2.default, null),
	        _react2.default.createElement(
	          _Content2.default,
	          null,
	          this.props.children
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Layout;
	}(_react.Component);
	
	exports.default = Layout;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.downloadPartners = undefined;
	
	__webpack_require__(34);
	
	var downloadPartners = exports.downloadPartners = function downloadPartners() {
	  return function (dispatch) {
	    fetch('/api/hall-event-all-partner-list1.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        dispatch({
	          type: 'PARSE_PARTNER_LIST',
	          partnerViewList: json.partnerViewList
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'PARTNER_ERROR',
	        error: err
	      });
	    });
	  };
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(372);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contacts = function (_Component) {
	  _inherits(Contacts, _Component);
	
	  function Contacts() {
	    _classCallCheck(this, Contacts);
	
	    return _possibleConstructorReturn(this, (Contacts.__proto__ || Object.getPrototypeOf(Contacts)).apply(this, arguments));
	  }
	
	  _createClass(Contacts, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'contacts' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contacts__background' },
	          _react2.default.createElement(
	            'div',
	            { className: 'contacts__info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'contacts__title' },
	              '\u043F\u0438\u0448\u0438\u0442\u0435, \u0437\u0432\u043E\u043D\u0438\u0442\u0435!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contacts__item contacts__item_email' },
	              _react2.default.createElement(
	                'a',
	                { rel: 'nofollow', className: 'contacts__item-link', href: 'mailto: org@happydev-lite.ru' },
	                'org@happydev-lite.ru'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'contacts__item-description' },
	                '\u041C\u044B \u0433\u043E\u0442\u043E\u0432\u044B \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contacts__item contacts__item_phone', itemScope: true, itemType: 'http://schema.org/Person' },
	              _react2.default.createElement(
	                'a',
	                { rel: 'nofollow', className: 'contacts__item-link', href: 'tel:+79095350073' },
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'telephone' },
	                  '+ 7 (909) 535 00 73'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'contacts__item-description' },
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'givenName' },
	                  '\u0410\u043D\u043D\u0430'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'familyName' },
	                  ' \u0422\u0430\u0440\u0430\u0441\u0435\u043D\u043A\u043E'
	                ),
	                ',',
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'jobTitle' },
	                  ' \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contacts__item contacts__item_phone', itemScope: true, itemType: 'http://schema.org/Person' },
	              _react2.default.createElement(
	                'a',
	                { rel: 'nofollow', className: 'contacts__item-link', href: 'tel:+79136402868' },
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'telephone' },
	                  '+ 7 (913) 640 28 68'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'contacts__item-description' },
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'givenName' },
	                  '\u0410\u043B\u0451\u043D\u0430'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'familyName' },
	                  ' \u0411\u043E\u0440\u0437\u0443\u043D\u043E\u0432\u0430'
	                ),
	                ',',
	                _react2.default.createElement(
	                  'span',
	                  { itemProp: 'jobTitle' },
	                  ' \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Contacts;
	}(_react.Component);
	
	exports.default = Contacts;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Content = function (_Component) {
	  _inherits(Content, _Component);
	
	  function Content() {
	    _classCallCheck(this, Content);
	
	    return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).apply(this, arguments));
	  }
	
	  _createClass(Content, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Content;
	}(_react.Component);
	
	exports.default = Content;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Organization = __webpack_require__(274);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Map = __webpack_require__(273);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Contacts = __webpack_require__(267);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	__webpack_require__(374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'footer' },
	        _react2.default.createElement(_Organization2.default, null),
	        _react2.default.createElement(_Map2.default, null),
	        _react2.default.createElement(_Contacts2.default, null)
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	var _reactSimpleDropdown = __webpack_require__(525);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _participantAction = __webpack_require__(65);
	
	__webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderBottom = function (_Component) {
	  _inherits(HeaderBottom, _Component);
	
	  function HeaderBottom() {
	    _classCallCheck(this, HeaderBottom);
	
	    return _possibleConstructorReturn(this, (HeaderBottom.__proto__ || Object.getPrototypeOf(HeaderBottom)).apply(this, arguments));
	  }
	
	  _createClass(HeaderBottom, [{
	    key: 'onDropdownClick',
	    value: function onDropdownClick() {
	      this.refs.dropdown.hide();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.downloadSectionsList();
	      this.props.getUser();
	    }
	  }, {
	    key: 'onLogoutClick',
	    value: function onLogoutClick() {
	      this.onDropdownClick();
	      this.props.logoutUser();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classes = (0, _classnames2.default)('header__bottom', { 'header__bottom_fixed': this.props.fixed });
	      // let linkSchedule;
	      // if (this.props.sections.length > 0) {
	      //   let sectionUriList = [];
	      //   this.props.sections.map(section => {
	      //     sectionUriList.push('/schedule/' + section.id);
	      //   });
	      //   if (sectionUriList.includes(decodeURI(window.location.pathname))) {
	      //     linkSchedule = '/' + decodeURI(window.location.pathname.split('/')[2]);
	      //   } else {
	      //     linkSchedule = '/' + this.props.sections[0].id;
	      //   }
	      // }
	      var headerMenu = [_react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/', className: 'header__logo', key: 'main' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__menu-item header__menu-item_logo', onClick: this.onDropdownClick.bind(this) },
	          '\u0433\u043B\u0430\u0432\u043D\u0430\u044F'
	        )
	      ),
	      // (
	      //   <Link to={'/schedule' + linkSchedule} activeClassName='header__menu-item_active' key='schedule' >
	      //     <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
	      //       программа
	      //     </div>
	      //   </Link>
	      // ),
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/speakers', key: 'speakers', activeClassName: 'header__menu-item_active' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__menu-item', onClick: this.onDropdownClick.bind(this) },
	          '\u0434\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A\u0438'
	        )
	      ), _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/participants', key: 'participants', activeClassName: 'header__menu-item_active' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__menu-item', onClick: this.onDropdownClick.bind(this) },
	          '\u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438'
	        )
	      ), _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/reviews', key: 'reviews', activeClassName: 'header__menu-item_active' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__menu-item', onClick: this.onDropdownClick.bind(this) },
	          '\u0432\u0441\u0435 \u043E\u0442\u0437\u044B\u0432\u044B'
	        )
	      )];
	
	      var registrationStatus = null;
	      // if (this.props.registrationClosed) {
	      //   registrationStatus = (
	      //     <div className='header__menu-item header__menu-item_registration-closed'>
	      //       регистрация закрыта
	      //     </div>
	      //   );
	      // }
	
	      var userMenu = null;
	      if (this.props.withServer && this.props.user.userShortView) {
	        userMenu = _react2.default.createElement(
	          'div',
	          { className: 'header__user-menu' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { key: 'user', to: '/profile', className: 'header__auth-item', activeClassName: 'header__menu-item_active' },
	            _react2.default.createElement(
	              'div',
	              { className: 'header__menu-item', onClick: this.onDropdownClick.bind(this) },
	              this.props.user.userShortView.firstName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header__auth-item' },
	            _react2.default.createElement(
	              'div',
	              { key: 'logout', onClick: this.onLogoutClick.bind(this), className: 'header__menu-item' },
	              '\u0432\u044B\u0445\u043E\u0434'
	            )
	          ),
	          registrationStatus
	        );
	      } else if (this.props.withServer) {
	        var signUp = null;
	        var signIn = null;
	        //   signIn = (
	        //       <Link key='auth' to='/auth' className='header__auth-item' activeClassName='header__menu-item_active' >
	        //           <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)}>
	        //               вход
	        //           </div>
	        //       </Link>
	        // );
	        if (!this.props.registrationClosed) {
	          signUp = _react2.default.createElement(
	            _reactRouter.Link,
	            { activeClassName: 'header__menu-item_active', key: 'register', to: '/register', className: 'header__auth-item' },
	            _react2.default.createElement(
	              'div',
	              { className: 'header__menu-item', onClick: this.onDropdownClick.bind(this) },
	              '\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F'
	            )
	          );
	        }
	        userMenu = _react2.default.createElement(
	          'div',
	          { className: 'header__user-menu' },
	          signIn,
	          signUp,
	          registrationStatus
	        );
	      } else {
	        userMenu = _react2.default.createElement(
	          'div',
	          { className: 'header__user-menu' },
	          registrationStatus
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          _reactSimpleDropdown2.default,
	          { ref: 'dropdown',
	            className: 'header__menu_mobile' },
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownTrigger,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'dropdown__icon' },
	              '\u043C\u0435\u043D\u044E'
	            )
	          ),
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownContent,
	            null,
	            headerMenu,
	            this.props.withServer ? _react2.default.createElement('div', { className: 'dropdown__divider' }) : null,
	            userMenu
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header__container-bottom' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header__desktop' },
	            headerMenu,
	            userMenu
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderBottom;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.participant.participantView,
	    sections: state.participant.allSections,
	    withServer: state.participant.withServer,
	    registrationClosed: state.participant.registrationClosed
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadSectionsList: (0, _redux.bindActionCreators)(_participantAction.downloadSectionsList, dispatch),
	    getUser: (0, _redux.bindActionCreators)(_participantAction.getUser, dispatch),
	    logoutUser: (0, _redux.bindActionCreators)(_participantAction.logoutUser, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(HeaderBottom);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderTop = function (_Component) {
	  _inherits(HeaderTop, _Component);
	
	  function HeaderTop() {
	    _classCallCheck(this, HeaderTop);
	
	    return _possibleConstructorReturn(this, (HeaderTop.__proto__ || Object.getPrototypeOf(HeaderTop)).apply(this, arguments));
	  }
	
	  _createClass(HeaderTop, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'header__top', ref: 'topContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header__container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header__history-links' },
	            _react2.default.createElement(
	              'a',
	              { href: 'http://2015-autumn.happydev-lite.ru/', target: '_blank', className: 'header__history-link' },
	              'lite\'15 \u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'http://2016-spring.happydev-lite.ru/', target: '_blank', className: 'header__history-link' },
	              'lite\'16 \u0430\u043F\u0440\u0435\u043B\u044C'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'http://2016-autumn.happydev-lite.ru/', target: '_blank', className: 'header__history-link' },
	              'lite\'16 \u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'http://2017-spring.happydev-lite.ru/', target: '_blank', className: 'header__history-link' },
	              'lite\'17 \u043C\u0430\u0440\u0442'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header__following-container' },
	            _react2.default.createElement(
	              'a',
	              { className: 'header__following-link', href: 'http://bit.ly/hdl-2017-spring-vk-from-site', target: '_blank' },
	              _react2.default.createElement('div', { className: 'header__following-vk' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'header__following-link', href: 'http://bit.ly/hdl-2017-spring-twitter-from-site', target: '_blank' },
	              _react2.default.createElement('div', { className: 'header__following-twitter' })
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'header__following-link', href: 'http://bit.ly/hdl-2017-spring-youtube-from-site', target: '_blank' },
	              _react2.default.createElement('div', { className: 'header__following-youtube' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderTop;
	}(_react.Component);
	
	exports.default = HeaderTop;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeaderTop = __webpack_require__(271);
	
	var _HeaderTop2 = _interopRequireDefault(_HeaderTop);
	
	var _HeaderBottom = __webpack_require__(270);
	
	var _HeaderBottom2 = _interopRequireDefault(_HeaderBottom);
	
	__webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFixed: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (window.pageYOffset > this.refs.headerTop.refs.topContainer.clientHeight) {
	        this.setState({ isFixed: true });
	      }
	
	      var that = this;
	      window.onscroll = function () {
	        if (window.pageYOffset > _this2.refs.headerTop.refs.topContainer.clientHeight) {
	          that.setState({ isFixed: true });
	        } else {
	          that.setState({ isFixed: false });
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(_HeaderTop2.default, { ref: 'headerTop' }),
	        _react2.default.createElement(_HeaderBottom2.default, { fixed: this.state.isFixed })
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gisMapsReact = __webpack_require__(244);
	
	__webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomMap = function (_Component) {
	  _inherits(CustomMap, _Component);
	
	  function CustomMap() {
	    _classCallCheck(this, CustomMap);
	
	    return _possibleConstructorReturn(this, (CustomMap.__proto__ || Object.getPrototypeOf(CustomMap)).apply(this, arguments));
	  }
	
	  _createClass(CustomMap, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'map' },
	          _react2.default.createElement(
	            'div',
	            { className: 'map__title' },
	            '\u043C\u0435\u0441\u0442\u043E \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'map__info' },
	            '\u041E\u043C\u0441\u043A, \u043A\u043E\u0440\u043F\u0443\u0441 \u041E\u043C\u0413\u0422\u0423 \u043D\u0430 \u0443\u043B. \u041A\u0440\u0430\u0441\u043D\u043E\u0433\u0432\u0430\u0440\u0434\u0435\u0439\u0441\u043A\u0430\u044F, 9'
	          )
	        ),
	        _react2.default.createElement(
	          _gisMapsReact.Map,
	          {
	            style: { height: '341px', width: '100%' },
	            center: [54.991149, 73.358672],
	            zoom: 16,
	            scrollWheelZoom: false
	          },
	          _react2.default.createElement(
	            _gisMapsReact.Marker,
	            {
	              pos: [54.991149, 73.358672]
	            },
	            _react2.default.createElement(
	              _gisMapsReact.Popup,
	              { maxWidth: 150, sprawling: true },
	              '\u041E\u043C\u0413\u0423 \u0438\u043C. \u0424.\u041C.\u0414\u043E\u0441\u0442\u043E\u0435\u0432\u0441\u043A\u043E\u0433\u043E'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CustomMap;
	}(_react.Component);
	
	exports.default = CustomMap;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PersonalDataCheckbox = __webpack_require__(255);
	
	var _PersonalDataCheckbox2 = _interopRequireDefault(_PersonalDataCheckbox);
	
	var _actions = __webpack_require__(266);
	
	__webpack_require__(379);
	
	var _InputField = __webpack_require__(138);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _formValidators = __webpack_require__(46);
	
	var _googleFormAction = __webpack_require__(129);
	
	var _fieldAction = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Organization = function (_Component) {
	  _inherits(Organization, _Component);
	
	  function Organization(props) {
	    _classCallCheck(this, Organization);
	
	    var _this = _possibleConstructorReturn(this, (Organization.__proto__ || Object.getPrototypeOf(Organization)).call(this, props));
	
	    _this._generateOrgSection = function () {
	      return _this.props.viewList.map(function (partners) {
	        var registration = null;
	        // let registration = !this.props.sponsorRegisterSuccess ?
	        //   (
	        //     <form
	        //       className='sponsor-form'
	        //       onSubmit={this.handleFormSubmit.bind(this, 'sponsor')}
	        //       disabled={this.props.sponsorDataSending}
	        //     >
	        //       <div className='sponsor-form__field'>
	        //         <InputField
	        //           name='entry.1212922480'
	        //           tabIndex={1}
	        //           onValidate={newEmailHandler}
	        //           ref='sponsorEmail'
	        //           placeholder={'Оставьте свой Email'}
	        //         />
	        //         <div className='sponsor-form__personal-data'>
	        //           <PersonalDataCheckbox onChange={this.onClickPersonalDataCheckbox.bind(this)} />
	        //         </div>
	        //       </div>
	        //       <Button
	        //         styleClasses={['sponsor-form__submit-btn']}
	        //
	        //       >
	        //         Хотите стать спонсором?
	        //       </Button>
	        //     </form>
	        //   ) :
	        //   (
	        //     <div className='sponsor-form_success'>Спасибо за регистрацию!</div>
	        //   );
	
	        if (partners.partnerType === 'При поддержке' || partners.partnerType === 'Информационный партнер') {
	          return _react2.default.createElement('div', { key: partners.partnerType });
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { key: partners.partnerType },
	            _react2.default.createElement(
	              'div',
	              { className: 'organization__title' },
	              partners.partnerType
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'organization__companies' },
	              partners.partnerViews.map(function (company) {
	                return _react2.default.createElement(
	                  'a',
	                  { key: partners.partnerType + '_' + company.company.url,
	                    target: '_blank',
	                    className: 'organization__company',
	                    href: company.company.url },
	                  _react2.default.createElement('img', { className: 'organization__picture', src: company.pictureUrl, alt: company.name })
	                );
	              })
	            ),
	            partners.partnerType === 'Спонсоры' ? registration : null
	          );
	        }
	      });
	    };
	
	    _this.state = {
	      personalDataChecked: false
	    };
	    return _this;
	  }
	
	  _createClass(Organization, [{
	    key: 'onClickPersonalDataCheckbox',
	    value: function onClickPersonalDataCheckbox(params) {
	      this.setState({
	        personalDataChecked: params.isValid
	      });
	    }
	  }, {
	    key: 'handleFormSubmit',
	    value: function handleFormSubmit(type, event) {
	      event.preventDefault();
	      var validateSuccess = true;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = Object.keys(this.refs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          if (!this.refs[key].onValidate() && key.indexOf(type) > -1) {
	            validateSuccess = false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (validateSuccess && this.state.personalDataChecked) {
	        var formData = new FormData(event.target);
	        this.props.postSponsor(formData);
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = Object.keys(this.refs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _key = _step2.value;
	
	            if (_key.indexOf(type) > -1) {
	              this.refs[_key].clearField();
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.downloadPartners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var orgSection = this._generateOrgSection();
	      return _react2.default.createElement(
	        'div',
	        { className: 'organization' },
	        orgSection
	      );
	    }
	  }]);
	
	  return Organization;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    viewList: state.organization.viewList,
	    sponsorDataSending: state.googleFormReducer.sponsorDataSending,
	    sponsorRegisterSuccess: state.googleFormReducer.sponsorRegisterSuccess
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadPartners: (0, _redux.bindActionCreators)(_actions.downloadPartners, dispatch),
	    postSponsor: (0, _redux.bindActionCreators)(_googleFormAction.postSponsor, dispatch),
	    clearFields: (0, _redux.bindActionCreators)(_fieldAction.clearFields, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Organization);

/***/ },
/* 275 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  viewList: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_PARTNER_LIST':
	      return Object.assign({}, state, { viewList: action.partnerViewList });
	    default:
	      return state;
	  }
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _actions = __webpack_require__(277);
	
	__webpack_require__(381);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Participants = function (_Component) {
	  _inherits(Participants, _Component);
	
	  function Participants() {
	    _classCallCheck(this, Participants);
	
	    return _possibleConstructorReturn(this, (Participants.__proto__ || Object.getPrototypeOf(Participants)).apply(this, arguments));
	  }
	
	  _createClass(Participants, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.participants.counts.all === 0) {
	        this.props.downloadParticipants();
	      }
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var baseUrl = '/participants';
	
	      var ifShowTabs = this.props.participants.sections && this.props.participants.sections.length > 1;
	      var tabs = this.props.participants.sections.map(function (section) {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            key: section.id, type: section.id, to: baseUrl + '/' + section.id,
	            className: 'speaker__tabs-item participants__tabs-item speaker__tabs-item-' + section.id,
	            activeClassName: 'speaker__tabs-item_' + section.id
	          },
	          section.name + '(' + _this2.props.participants.counts[section.id] + ')'
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'participants' },
	        _react2.default.createElement(
	          'div',
	          { className: 'participants__title' },
	          '\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438',
	          ifShowTabs ? null : _react2.default.createElement(
	            'span',
	            null,
	            '(',
	            this.props.participants.counts.all,
	            ')'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'participants__container' },
	          ifShowTabs ? _react2.default.createElement(
	            'div',
	            { className: 'speaker__tabs' },
	            _react2.default.createElement(
	              _reactRouter.IndexLink,
	              {
	                to: baseUrl,
	                className: 'speaker__tabs-item participants__tabs-item speaker__tabs-item-all',
	                activeClassName: 'speaker__tabs-item_all'
	              },
	              '\u0432\u0441\u0435 (',
	              this.props.participants.counts.all,
	              ')'
	            ),
	            tabs
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'participant__filter',
	              onClick: this.props.checkoutFilter.bind(this)
	            },
	            this.props.filterText
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Participants;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    byEducation: state.participants.byEducation,
	    filterText: state.participants.filterText,
	    participants: state.participants.participants
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadParticipants: (0, _redux.bindActionCreators)(_actions.downloadParticipants, dispatch),
	    checkoutFilter: (0, _redux.bindActionCreators)(_actions.checkoutFilter, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(Participants);

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkoutFilter = exports.downloadParticipants = undefined;
	
	__webpack_require__(34);
	
	var downloadParticipants = exports.downloadParticipants = function downloadParticipants() {
	  return function (dispatch) {
	    fetch('/api/participants1.json?approved=true').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      if (json.success) {
	        var participants = {
	          byLastName: {},
	          byEducation: {},
	          counts: {
	            all: 0
	          },
	          sections: json.eventBranchViews
	        };
	
	        json.eventBranchViews.forEach(function (section) {
	          participants.counts[section.id] = 0;
	        });
	
	        json.participantViewList.forEach(function (participant) {
	          if (participant.eventBranchIds.length !== 0) {
	
	            var literal = participant.userShortView.lastName.charAt(0).toUpperCase();
	            if (!participants.byLastName[literal]) {
	              participants.byLastName[literal] = [];
	            }
	
	            var participantData = {
	              firstName: participant.userShortView.firstName,
	              lastName: participant.userShortView.lastName,
	              idStr: participant.idStr,
	              sections: participant.eventBranchIds
	            };
	            var cropEducation = void 0,
	                studyPlace = void 0;
	            if (participant.schoolProfileView) {
	              participantData.education = participant.schoolProfileView.schoolView.name + ', ' + participant.schoolProfileView.grade + ' \u043A\u043B\u0430\u0441\u0441';
	              cropEducation = participant.schoolProfileView.grade + ' \u043A\u043B\u0430\u0441\u0441';
	
	              studyPlace = participant.schoolProfileView.schoolView.name;
	              if (!participants.byEducation[studyPlace]) {
	                participants.byEducation[studyPlace] = [];
	              }
	            } else {
	              participantData.education = participant.studentProfileView.instituteView.name + ', ' + participant.studentProfileView.department + ', ' + participant.studentProfileView.course + ' \u043A\u0443\u0440\u0441';
	              cropEducation = participant.studentProfileView.department + ', ' + participant.studentProfileView.course + ' \u043A\u0443\u0440\u0441';
	
	              studyPlace = participant.studentProfileView.instituteView.name;
	              if (!participants.byEducation[studyPlace]) {
	                participants.byEducation[studyPlace] = [];
	              }
	            }
	
	            participant.eventBranchIds.forEach(function (section) {
	              participants.counts[section]++;
	            });
	
	            participants.byLastName[literal].push(Object.assign({}, participantData));
	            participantData.education = cropEducation;
	
	            participants.byEducation[studyPlace].push(participantData);
	            participants.counts.all++;
	          }
	        });
	
	        dispatch({
	          type: 'PARSE_PARTICIPANTS_LIST',
	          participants: participants
	        });
	      } else {
	        throw json.errorMessage;
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: 'PARTICIPANTS_ERROR',
	        error: err
	      });
	    });
	  };
	};
	
	var checkoutFilter = exports.checkoutFilter = function checkoutFilter() {
	  return function (dispatch) {
	    dispatch({ type: 'CHECKOUT_FILTER' });
	  };
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(359);
	
	var _rcCollapse = __webpack_require__(430);
	
	var _rcCollapse2 = _interopRequireDefault(_rcCollapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationBlock = function (_Component) {
	  _inherits(OrganizationBlock, _Component);
	
	  function OrganizationBlock() {
	    _classCallCheck(this, OrganizationBlock);
	
	    return _possibleConstructorReturn(this, (OrganizationBlock.__proto__ || Object.getPrototypeOf(OrganizationBlock)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationBlock, [{
	    key: 'getItems',
	    value: function getItems() {
	      var items = [];
	      var that = this;
	      Object.keys(this.props.organizationData).forEach(function (org) {
	        var participants = [];
	        that.props.organizationData[org].forEach(function (participant) {
	          if (that.props.filter === undefined || participant.sections.indexOf(parseInt(that.props.filter, 10)) !== -1) {
	            participants.push(_react2.default.createElement(
	              'div',
	              { key: participant.idStr, className: 'participant' },
	              _react2.default.createElement(
	                'div',
	                { className: 'participant__name' },
	                participant.lastName + ' ' + participant.firstName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'participant__about' },
	                participant.education
	              )
	            ));
	          }
	        });
	        if (participants.length !== 0) {
	          items.push(_react2.default.createElement(
	            _rcCollapse.Panel,
	            { key: org + '-' + that.props.filter, header: org + ' (' + participants.length + ')' },
	            participants
	          ));
	        }
	      });
	
	      return items;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _rcCollapse2.default,
	        {
	          accordion: false,
	          key: this.props.keyData
	        },
	        this.getItems()
	      );
	    }
	  }]);
	
	  return OrganizationBlock;
	}(_react.Component);
	
	exports.default = OrganizationBlock;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _OrganizationBlock = __webpack_require__(278);
	
	var _OrganizationBlock2 = _interopRequireDefault(_OrganizationBlock);
	
	var _AlphabeticView = __webpack_require__(280);
	
	var _AlphabeticView2 = _interopRequireDefault(_AlphabeticView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantsPanel = function (_Component) {
	  _inherits(ParticipantsPanel, _Component);
	
	  function ParticipantsPanel() {
	    _classCallCheck(this, ParticipantsPanel);
	
	    return _possibleConstructorReturn(this, (ParticipantsPanel.__proto__ || Object.getPrototypeOf(ParticipantsPanel)).apply(this, arguments));
	  }
	
	  _createClass(ParticipantsPanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var container = null;
	      if (this.props.byEducation) {
	        container = _react2.default.createElement(_OrganizationBlock2.default, {
	          keyData: this.props.params.filter ? this.props.params.filter : 'all', filter: this.props.params.filter,
	          organizationData: this.props.participants.byEducation
	        });
	      } else {
	        var participantData = this.props.participants.byLastName;
	
	        container = Object.keys(participantData).sort().map(function (literal) {
	          return _react2.default.createElement(_AlphabeticView2.default, {
	            key: literal, literal: literal, filter: _this2.props.params.filter,
	            participants: participantData[literal]
	          });
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'participants__container' },
	        container
	      );
	    }
	  }]);
	
	  return ParticipantsPanel;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    byEducation: state.participants.byEducation,
	    participants: state.participants.participants
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ParticipantsPanel);

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AlphabeticView = function (_Component) {
	  _inherits(AlphabeticView, _Component);
	
	  function AlphabeticView() {
	    _classCallCheck(this, AlphabeticView);
	
	    return _possibleConstructorReturn(this, (AlphabeticView.__proto__ || Object.getPrototypeOf(AlphabeticView)).apply(this, arguments));
	  }
	
	  _createClass(AlphabeticView, [{
	    key: 'render',
	    value: function render() {
	      var participantsData = [];
	      this.props.participants.map(function (participant) {
	        var name = participant.lastName.toUpperCase() + participant.firstName.toUpperCase();
	        participantsData[name] = participant;
	        return null;
	      });
	      var that = this;
	      var participants = Object.keys(participantsData).sort().map(function (participantKey) {
	        if (that.props.filter === undefined || participantsData[participantKey].sections.indexOf(parseInt(that.props.filter, 10)) !== -1) {
	          return _react2.default.createElement(
	            'div',
	            { key: participantsData[participantKey].idStr },
	            _react2.default.createElement(
	              'div',
	              { className: 'alphabet__username' },
	              participantsData[participantKey].lastName + ' ' + participantsData[participantKey].firstName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'alphabet__education' },
	              participantsData[participantKey].education
	            )
	          );
	        }
	        return null;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'alphabet' },
	        _react2.default.createElement(
	          'p',
	          { className: 'alphabet__literal' },
	          this.props.literal
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'alphabet__user-container' },
	          participants
	        )
	      );
	    }
	  }]);
	
	  return AlphabeticView;
	}(_react.Component);
	
	exports.default = AlphabeticView;

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  sections: {},
	  byEducation: false,
	  filterText: 'по учебному заведению',
	  participants: {
	    byLastName: {},
	    byEducation: {},
	    counts: {
	      all: 0
	    },
	    sections: []
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_PARTICIPANTS_LIST':
	      return Object.assign({}, state, {
	        sections: action.sections,
	        participants: action.participants
	      });
	    case 'CHECKOUT_FILTER':
	      return Object.assign({}, state, {
	        byEducation: !state.byEducation,
	        filterText: !state.byEducation ? 'по фамилии' : 'по учебному заведению'
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  schoolList: [],
	  instituteList: [],
	  validate: false,
	  serverErrors: {},
	  isValidated: true,
	  afterValidate: false,
	  successRegister: false,
	  successRestore: false,
	  successSaveRestore: false,
	  successMessage: '',
	  failMessage: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SCHOOL_LIST':
	      return Object.assign({}, state, { schoolList: action.schoolList });
	    case 'INSTITUTE_LIST':
	      return Object.assign({}, state, { instituteList: action.instituteList });
	    case 'RESET_VALIDATION':
	      return Object.assign({}, state, {
	        validate: false,
	        afterValidate: false,
	        successMessage: '',
	        failMessage: '',
	        successRegister: false,
	        successAuth: false,
	        successRestore: false,
	        successSaveRestore: false
	      });
	    case 'FORM_SUBMIT':
	      return Object.assign({}, state, { validate: true, isValidated: true });
	    case 'AFTER_VALIDATE':
	      return Object.assign({}, state, { afterValidate: true });
	    case 'VALIDATION_FAILED':
	      return Object.assign({}, state, { isValidated: false });
	    case 'ERRORS_FROM_SERVER':
	      return Object.assign({}, state, { serverErrors: action.errors, validate: true });
	    case 'FIX_SERVER_ERROR':
	      return Object.assign({}, state, { serverErrors: action.serverErrors });
	    case 'REGISTRATION_SUCCESS':
	      return Object.assign({}, state, {
	        successMessage: action.successMessage,
	        failMessage: '',
	        validate: false,
	        afterValidate: false,
	        successRegister: true
	      });
	    case 'AUTH_SUCCESS':
	      return Object.assign({}, state, {
	        validate: false,
	        afterValidate: false
	      });
	    case 'AUTH_FAIL':
	      return Object.assign({}, state, {
	        successMessage: '',
	        failMessage: action.failMessage
	      });
	    case 'RESTORE_SUCCESS':
	      return Object.assign({}, state, {
	        successMessage: action.successMessage,
	        failMessage: '',
	        validate: false,
	        afterValidate: false,
	        successRestore: true
	      });
	    case 'RESTORE_SAVE_SUCCESS':
	      return Object.assign({}, state, {
	        successMessage: action.successMessage,
	        failMessage: '',
	        validate: false,
	        afterValidate: false,
	        successSaveRestore: true
	      });
	    case 'RESTORE_SAVE_FAIL':
	      return Object.assign({}, state, {
	        failMessage: action.message,
	        successMessage: ''
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  eventCommentList: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_COMMENT_LIST':
	      return Object.assign({}, state, { eventCommentList: action.eventCommentList });
	    default:
	      return state;
	  }
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {};
	
	var _addField = function _addField(state, field, value) {
	  var obj = Object.assign({}, state);
	  obj[field] = value;
	  return obj;
	};
	
	var _deleteField = function _deleteField(state, field) {
	  var obj = Object.assign({}, state);
	  delete obj[field];
	  return obj;
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'FIELD_VALUE':
	      return _addField(state, action.field, action.value);
	    case 'DELETE_FIELD':
	      return _deleteField(state, action.field);
	    case 'CLEAR_FIELDS':
	      return Object.assign({}, initialState);
	    default:
	      return state;
	  }
	};

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  participantDataSending: false,
	  participantRegisterSuccess: false,
	  sponsorDataSending: false,
	  sponsorRegisterSuccess: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARTICIPANT_REGISTER_PENDING':
	      return Object.assign({}, state, {
	        participantDataSending: true,
	        participantRegisterSuccess: false
	      });
	    case 'PARTICIPANT_REGISTER_DONE':
	      return Object.assign({}, state, {
	        participantDataSending: false,
	        participantRegisterSuccess: true
	      });
	    case 'PARTICIPANT_REGISTER_ERROR':
	      return Object.assign({}, state, {
	        participantDataSending: false,
	        participantRegisterSuccess: false
	      });
	    case 'SPONSOR_REGISTER_PENDING':
	      return Object.assign({}, state, {
	        sponsorDataSending: true,
	        sponsorRegisterSuccess: false
	      });
	    case 'SPONSOR_REGISTER_DONE':
	      return Object.assign({}, state, {
	        sponsorDataSending: false,
	        sponsorRegisterSuccess: true
	      });
	    case 'SPONSOR_REGISTER_ERROR':
	      return Object.assign({}, state, {
	        sponsorDataSending: false,
	        sponsorRegisterSuccess: false
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 286 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  userSections: [],
	  allSections: [],
	  participantView: {},
	  userView: {},
	  successMessage: '',
	  warningMessage: '',
	  successUserChangingMessage: '',
	  withServer: true,
	  registrationClosed: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_GET_USER':
	      return Object.assign({}, state, {
	        userSections: action.data.sectionsUser,
	        participantView: action.data.participantView,
	        userView: action.data.userView,
	        withServer: true,
	        registrationClosed: action.data.registrationClosed
	      });
	    case 'UNAUTHORIZED_USER':
	      return Object.assign({}, state, { withServer: true, registrationClosed: action.registrationClosed });
	    case 'GET_USER_ERROR':
	      return Object.assign({}, state, { withServer: false });
	    case 'SECTIONS_LIST':
	      return Object.assign({}, state, { allSections: action.sectionsList });
	    case 'SUCCESS_CHANGING':
	      return Object.assign({}, state, {
	        successMessage: action.message,
	        warningMessage: '',
	        userSections: action.userSections
	      });
	    case 'FAILED_CHANGING':
	      return Object.assign({}, state, { successMessage: '', warningMessage: action.message });
	    case 'USER_LOGOUT':
	      return Object.assign({}, state, { userView: {}, participantView: {}, userSections: [] });
	    case 'CLEAR_SECTION_MESSAGES':
	      return Object.assign({}, state, { successMessage: '', warningMessage: '' });
	    case 'SUCCESS_USER_CHANGING':
	      return Object.assign({}, state, { successUserChangingMessage: action.message });
	    case 'CLEAR_PARTICIPANT_MESSAGES':
	      return Object.assign({}, state, {
	        successUserChangingMessage: '',
	        successMessage: '',
	        warningMessage: ''
	      });
	    default:
	      return state;
	  }
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(8);
	
	var _authAction = __webpack_require__(35);
	
	var _RegisterForm = __webpack_require__(288);
	
	var _RegisterForm2 = _interopRequireDefault(_RegisterForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Register = function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register() {
	    _classCallCheck(this, Register);
	
	    return _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).apply(this, arguments));
	  }
	
	  _createClass(Register, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.participantView.userShortView || !this.props.withServer || this.props.registrationClosed) {
	        _reactRouter.browserHistory.push('/');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.setInitialState();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.participantView.userShortView || !this.props.withServer || this.props.registrationClosed) {
	        _reactRouter.browserHistory.push('/');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_RegisterForm2.default, null)
	      );
	    }
	  }]);
	
	  return Register;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    participantView: state.participant.participantView,
	    withServer: state.participant.withServer,
	    registrationClosed: state.participant.registrationClosed
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setInitialState: (0, _redux.bindActionCreators)(_authAction.setInitialState, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Register);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Form = __webpack_require__(66);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FLNames = __webpack_require__(133);
	
	var _FLNames2 = _interopRequireDefault(_FLNames);
	
	var _Contacts = __webpack_require__(131);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Education = __webpack_require__(132);
	
	var _Education2 = _interopRequireDefault(_Education);
	
	var _Job = __webpack_require__(137);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _Checkbox = __webpack_require__(82);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _RadioButton = __webpack_require__(140);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _FormBlock = __webpack_require__(134);
	
	var _FormBlock2 = _interopRequireDefault(_FormBlock);
	
	var _authAction = __webpack_require__(35);
	
	var _ConfirmEvent = __webpack_require__(252);
	
	var _ConfirmEvent2 = _interopRequireDefault(_ConfirmEvent);
	
	var _FormSubmit = __webpack_require__(135);
	
	var _FormSubmit2 = _interopRequireDefault(_FormSubmit);
	
	var _formValidators = __webpack_require__(46);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterForm = function (_Component) {
	  _inherits(RegisterForm, _Component);
	
	  function RegisterForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RegisterForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegisterForm.__proto__ || Object.getPrototypeOf(RegisterForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isWorks: false,
	      idSectionData: 25
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RegisterForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.schoolList.length === 0) {
	        this.props.downloadSchoolList();
	        this.props.downloadInstituteList();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clearFields();
	    }
	  }, {
	    key: 'onCheckChange',
	    value: function onCheckChange() {
	      this.setState({ isWorks: !this.state.isWorks });
	    }
	  }, {
	    key: 'afterValidation',
	    value: function afterValidation() {
	      if (this.props.isValidated) {
	        var data = Object.assign({}, this.props.fields);
	        data['eventBranchIds'] = [];
	        data['cityId'] = 1;
	        var that = this;
	        this.props.sectionsList.forEach(function (section) {
	          if (that.refs[section.id].refs.radiobutton.checked) {
	            data.eventBranchIds.push(section.id);
	          }
	        });
	        if (this.state.grade) {
	          data['grade'] = this.state.grade;
	        }
	        if (this.state.course) {
	          data['course'] = this.state.course;
	        }
	        var form = new FormData();
	        Object.keys(data).forEach(function (field) {
	          form.append(field, data[field]);
	        });
	        console.log(data);
	        that.props.postRegister(form);
	      }
	    }
	  }, {
	    key: 'beforeFormSubmit',
	    value: function beforeFormSubmit() {
	      if (!this.state.grade && !this.state.course) {
	        this.props.validationFailed();
	      } else {
	        this.props.formSubmit();
	      }
	    }
	  }, {
	    key: 'courseHandler',
	    value: function courseHandler(course) {
	      this.setState({ course: course });
	    }
	  }, {
	    key: 'gradeHandler',
	    value: function gradeHandler(grade) {
	      this.setState({ grade: grade });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.afterValidate) {
	        this.afterValidation();
	      }
	
	      var workBlock = null;
	      if (this.state.isWorks) {
	        workBlock = _react2.default.createElement(_Job2.default, {
	          jobHandler: _formValidators.notEmptyHandler,
	          positionHandler: _formValidators.notEmptyHandler,
	          clearFields: this.props.successRegister
	        });
	      }
	      var ifOneBranch = this.props.sectionsList && this.props.sectionsList.length === 1;
	      var ifShouldBeSelected = ifOneBranch;
	      var sectionsBlock = this.props.sectionsList.map(function (section) {
	        return _react2.default.createElement(_RadioButton2.default, {
	          key: section.id,
	          name: 'event_branch',
	          title: section.name,
	          inputId: section.id,
	          ref: section.id,
	          checked: ifShouldBeSelected
	        });
	      });
	      return _react2.default.createElement(
	        _Form2.default,
	        {
	          title: '\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0430 happydev-lite',
	          successMessage: this.props.successMessage
	        },
	        _react2.default.createElement(_FLNames2.default, {
	          firstNameHandler: _formValidators.notEmptyHandler,
	          lastNameHandler: _formValidators.notEmptyHandler,
	          clearFields: this.props.successRegister
	        }),
	        _react2.default.createElement(_Contacts2.default, {
	          emailHandler: _formValidators.emailHandler,
	          passwordHandler: _formValidators.passwordHandler,
	          phoneHandler: _formValidators.phoneHandler,
	          clearFields: this.props.successRegister
	        }),
	        _react2.default.createElement(_Education2.default, {
	          schoolList: this.props.schoolList,
	          instituteList: this.props.instituteList,
	          gradeHandler: this.gradeHandler.bind(this),
	          departmentHandler: _formValidators.notEmptyHandler,
	          courseHandler: this.courseHandler.bind(this),
	          clearFields: this.props.successRegister
	        }),
	        _react2.default.createElement(
	          _FormBlock2.default,
	          null,
	          _react2.default.createElement(_Checkbox2.default, {
	            onChangeCallback: this.onCheckChange.bind(this),
	            name: 'isWorks',
	            inputId: 'works',
	            title: '\u044F \u0440\u0430\u0431\u043E\u0442\u0430\u044E'
	          }),
	          workBlock
	        ),
	        this.props.sectionsList.length > 0 ? _react2.default.createElement(
	          _ConfirmEvent2.default,
	          { styleClasses: [ifOneBranch ? 'event-branch-selector-invisible' : ''] },
	          sectionsBlock
	        ) : null,
	        _react2.default.createElement(
	          _FormSubmit2.default,
	          {
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this2.beforeFormSubmit();
	            }
	          },
	          '\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F'
	        )
	      );
	    }
	  }]);
	
	  return RegisterForm;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    schoolList: state.auth.schoolList,
	    instituteList: state.auth.instituteList,
	    sectionsList: state.participant.allSections,
	    isValidated: state.auth.isValidated,
	    afterValidate: state.auth.afterValidate,
	    successRegister: state.auth.successRegister,
	    successMessage: state.auth.successMessage,
	    fields: state.fields
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadInstituteList: (0, _redux.bindActionCreators)(_authAction.downloadInstituteList, dispatch),
	    downloadSchoolList: (0, _redux.bindActionCreators)(_authAction.downloadSchoolList, dispatch),
	    formSubmit: (0, _redux.bindActionCreators)(_authAction.formSubmit, dispatch),
	    postRegister: (0, _redux.bindActionCreators)(_authAction.postRegister, dispatch),
	    clearFields: (0, _redux.bindActionCreators)(_fieldAction.clearFields, dispatch),
	    validationFailed: (0, _redux.bindActionCreators)(_authAction.validationFailed, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RegisterForm);

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(6);
	
	var _RestorePassword = __webpack_require__(256);
	
	var _RestorePassword2 = _interopRequireDefault(_RestorePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Restore = function (_Component) {
	  _inherits(Restore, _Component);
	
	  function Restore() {
	    _classCallCheck(this, Restore);
	
	    return _possibleConstructorReturn(this, (Restore.__proto__ || Object.getPrototypeOf(Restore)).apply(this, arguments));
	  }
	
	  _createClass(Restore, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.participantView.userShortView) {
	        _reactRouter.browserHistory.push('/');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_RestorePassword2.default, null)
	      );
	    }
	  }]);
	
	  return Restore;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    participantView: state.participant.participantView
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Restore);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(8);
	
	var _reducers = __webpack_require__(275);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _commentReducer = __webpack_require__(283);
	
	var _commentReducer2 = _interopRequireDefault(_commentReducer);
	
	var _authReducer = __webpack_require__(282);
	
	var _authReducer2 = _interopRequireDefault(_authReducer);
	
	var _reducers3 = __webpack_require__(246);
	
	var _reducers4 = _interopRequireDefault(_reducers3);
	
	var _reducers5 = __webpack_require__(300);
	
	var _reducers6 = _interopRequireDefault(_reducers5);
	
	var _participantReducer = __webpack_require__(286);
	
	var _participantReducer2 = _interopRequireDefault(_participantReducer);
	
	var _reducers7 = __webpack_require__(281);
	
	var _reducers8 = _interopRequireDefault(_reducers7);
	
	var _reducers9 = __webpack_require__(295);
	
	var _reducers10 = _interopRequireDefault(_reducers9);
	
	var _fieldReducer = __webpack_require__(284);
	
	var _fieldReducer2 = _interopRequireDefault(_fieldReducer);
	
	var _googleFormReducer = __webpack_require__(285);
	
	var _googleFormReducer2 = _interopRequireDefault(_googleFormReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  organization: _reducers2.default, comment: _commentReducer2.default, publication: _reducers4.default,
	  auth: _authReducer2.default, speakers: _reducers6.default, participant: _participantReducer2.default, participants: _reducers8.default,
	  schedule: _reducers10.default, fields: _fieldReducer2.default, googleFormReducer: _googleFormReducer2.default
	});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _actions = __webpack_require__(143);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Schedule = function (_Component) {
	  _inherits(Schedule, _Component);
	
	  function Schedule() {
	    _classCallCheck(this, Schedule);
	
	    return _possibleConstructorReturn(this, (Schedule.__proto__ || Object.getPrototypeOf(Schedule)).apply(this, arguments));
	  }
	
	  _createClass(Schedule, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.downloadSchedule();
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var baseUrl = '/schedule';
	
	      if (this.props.sections.length > 0) {
	        var designUrl = baseUrl + '/' + this.props.sections[0].id;
	        var developUrl = baseUrl + '/' + this.props.sections[1].id;
	        if (decodeURI(window.location.pathname) !== designUrl && decodeURI(window.location.pathname) !== developUrl) {
	          window.location.pathname = designUrl;
	        }
	      }
	
	      var links = this.props.sections.map(function (section) {
	        var symbol = _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\u2014\xA0'
	        );
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            key: section.id, to: baseUrl + '/' + section.id,
	            className: 'speaker__tabs-item schedule__tabs-item speaker__tabs-item-' + section.id,
	            activeClassName: 'speaker__tabs-item_' + section.id
	          },
	          section.name,
	          symbol,
	          section.roomName
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'schedule' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__title' },
	          '\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u043A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u0438'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__tabs' },
	            links
	          ),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Schedule;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sections: state.schedule.sections
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadSchedule: (0, _redux.bindActionCreators)(_actions.downloadSchedule, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(Schedule);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(143);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	var ScheduleRoom = function (_Component) {
	  _inherits(ScheduleRoom, _Component);
	
	  function ScheduleRoom() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleRoom);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScheduleRoom.__proto__ || Object.getPrototypeOf(ScheduleRoom)).call.apply(_ref, [this].concat(args))), _this), _this._createScheduleRoom = function (room) {
	      var slides = void 0;
	      var videos = void 0;
	      console.log(room);
	      slides = room.speakerShortViews.map(function (slide) {
	        return _react2.default.createElement(
	          'a',
	          { href: 'https://yadi.sk/d/uEIOCu4i3UdTcU/2017-\u043E\u0441\u0435\u043D\u044C', target: '_blank', className: 'room__media-presentation' },
	          '\u043F\u0440\u0435\u0437\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0434\u043E\u043A\u043B\u0430\u0434\u0430'
	        );
	      });
	      console.log(slides);
	      videos = room.creativeVideoViews.map(function (video) {
	        return _react2.default.createElement('iframe', { key: video.url, src: video.url, className: 'room__media-element', allowFullScreen: 'allowfullscreen' });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'room__event', key: room.roomEventShortView.idStr },
	        _react2.default.createElement(
	          'div',
	          { className: 'room__event-title' },
	          room.roomEventShortView.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'room__time' },
	          room.eventDay + ' ' + room.startTime + '-' + room.endTime
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'room__event-desc' },
	          room.roomEventShortView.description
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'room__media' },
	          slides,
	          videos
	        )
	      );
	    }, _this._createSpeakersRoom = function (speakers) {
	      return speakers.map(function (speaker) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'speaker__schedule-info' },
	          _react2.default.createElement('img', { className: 'speaker__photo', src: speaker.pictureUrl, alt: speaker.userView.fullName }),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__name' },
	            _react2.default.createElement(
	              'a',
	              { href: '/speaker?id=' + speaker.idStr, className: 'speaker__name' },
	              speaker.userView.fullName
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__position' },
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', className: 'speaker__company', href: speaker.company.url },
	              speaker.company.name
	            ),
	            ', ',
	            speaker.jobPosition,
	            ', ',
	            speaker.userView.cityName
	          )
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScheduleRoom, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var room = {};
	      room.id = parseInt(window.location.pathname.split('/')[2], 10);
	      if (room.id) {
	        this.props.downloadScheduleRoom(room);
	      }
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var speakers = void 0;
	      var bodyRoom = void 0;
	      if (Object.keys(this.props.roomEventView).length > 0) {
	        speakers = this._createSpeakersRoom(this.props.roomEventView.speakerShortViews);
	        bodyRoom = this._createScheduleRoom(this.props.roomEventView);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'schedule' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'schedule__speakers' },
	            speakers
	          ),
	          bodyRoom
	        )
	      );
	    }
	  }]);
	
	  return ScheduleRoom;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    roomEventView: state.schedule.roomEventView
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadScheduleRoom: (0, _redux.bindActionCreators)(_actions.downloadScheduleRoom, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(ScheduleRoom);

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleEvent = function (_Component) {
	  _inherits(ScheduleEvent, _Component);
	
	  function ScheduleEvent() {
	    _classCallCheck(this, ScheduleEvent);
	
	    return _possibleConstructorReturn(this, (ScheduleEvent.__proto__ || Object.getPrototypeOf(ScheduleEvent)).apply(this, arguments));
	  }
	
	  _createClass(ScheduleEvent, [{
	    key: 'render',
	    value: function render() {
	      var speaker = this.props.speakerData;
	      var data = void 0;
	      if (speaker.speakerShortViews.length > 0) {
	        data = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__speaker' },
	            _react2.default.createElement(
	              'a',
	              { href: '/speaker?id=' + speaker.speakerShortViews[0].idStr, className: 'room-event__speaker-link' },
	              speaker.speakerShortViews[0].userView.fullName,
	              ','
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__speaker-job-position' },
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', className: 'room-event__speaker-job-link', href: speaker.speakerShortViews[0].company.url },
	              speaker.speakerShortViews[0].company.name
	            ),
	            ', ',
	            speaker.speakerShortViews[0].jobPosition,
	            ', ',
	            speaker.speakerShortViews[0].userView.cityName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'a',
	              { href: speaker.roomEventShortView.roomEventUrl, className: 'room-event__title-link' },
	              speaker.roomEventShortView.title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__description' },
	              speaker.roomEventShortView.description
	            )
	          )
	        );
	      } else {
	        data = _react2.default.createElement(
	          'div',
	          { className: 'room-event__event' },
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__title' },
	            speaker.roomEventShortView.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__description' },
	            speaker.roomEventShortView.description
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'schedule__room-event', key: speaker.roomEventShortView.idStr },
	        data
	      );
	    }
	  }]);
	
	  return ScheduleEvent;
	}(_react.Component);
	
	exports.default = ScheduleEvent;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _ScheduleEvent = __webpack_require__(293);
	
	var _ScheduleEvent2 = _interopRequireDefault(_ScheduleEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScheduleSection = function (_Component) {
	  _inherits(ScheduleSection, _Component);
	
	  function ScheduleSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScheduleSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScheduleSection.__proto__ || Object.getPrototypeOf(ScheduleSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      idSectionData: 24
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScheduleSection, [{
	    key: 'createScheduleBlock',
	    value: function createScheduleBlock() {
	      var _this2 = this;
	
	      var sectionData = this.props.sections.filter(function (section) {
	        return section.id === _this2.props.params.filter;
	      });
	      var beforeTime = void 0,
	          afterTime = void 0;
	      var LunchBlock = void 0,
	          Block = [];
	      if (sectionData[0].id === this.state.idSectionData) {
	        beforeTime = 1475315100000;
	        afterTime = 1475320500000;
	        // LunchBlock = this.getMiddleDesignBlock();
	      } else {
	        beforeTime = 1475394000000;
	        afterTime = 1475404800000;
	        // LunchBlock = this.getMiddleDevelopmentBlock();
	      }
	
	      sectionData[0].scheduleViewList.map(function (speaker) {
	        if (speaker.startTimeInMillis < beforeTime) {
	          Block.push(_react2.default.createElement(
	            'div',
	            { key: speaker.roomEventShortView.idStr, className: 'schedule__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              speaker.startTime + ' - ' + speaker.endTime
	            ),
	            _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_' + speaker.roomEventShortView.roomEventType }),
	            _react2.default.createElement(
	              _ScheduleEvent2.default,
	              { speakerData: speaker },
	              speaker
	            )
	          ));
	        }
	        return null;
	      });
	
	      Block.push(LunchBlock);
	
	      sectionData[0].scheduleViewList.map(function (speaker) {
	        if (speaker.startTimeInMillis >= afterTime) {
	          Block.push(_react2.default.createElement(
	            'div',
	            { key: speaker.roomEventShortView.idStr, className: 'schedule__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              speaker.startTime + ' - ' + speaker.endTime
	            ),
	            _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_' + speaker.roomEventShortView.roomEventType }),
	            _react2.default.createElement(
	              _ScheduleEvent2.default,
	              { speakerData: speaker },
	              speaker
	            )
	          ));
	        }
	        return null;
	      });
	      return Block;
	    }
	  }, {
	    key: 'getMiddleDesignBlock',
	    value: function getMiddleDesignBlock() {
	      var MiddleBlock = [];
	      MiddleBlock.push(_react2.default.createElement(
	        'div',
	        { key: '1', className: 'schedule__event schedule__event_not-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__time schedule__time_padding' },
	          '15:45 - 16:30'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__design-block' },
	          _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_Barcamp' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title' },
	              '\u0421\u043C\u0435\u043D\u0430 1: \u0441\u0442\u0435\u043D\u0434\u044B'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__design-block' },
	          _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title room-event__title_color' },
	              '\u0421\u043C\u0435\u043D\u0430 2: \u043F\u0435\u0440\u0435\u0440\u044B\u0432 \u043D\u0430 \u043E\u0431\u0435\u0434, \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043D\u0430\u044F \u0437\u043E\u043D\u0430'
	            )
	          )
	        )
	      ));
	      MiddleBlock.push(_react2.default.createElement(
	        'div',
	        { key: '2', className: 'schedule__event schedule__event_not-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__time schedule__time_padding' },
	          '16:30 - 17:15'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__block-design' },
	          _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title room-event__title_color' },
	              '\u0421\u043C\u0435\u043D\u0430 1: \u043F\u0435\u0440\u0435\u0440\u044B\u0432 \u043D\u0430 \u043E\u0431\u0435\u0434, \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043D\u0430\u044F \u0437\u043E\u043D\u0430'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__block-design' },
	          _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_Barcamp' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title' },
	              '\u0421\u043C\u0435\u043D\u0430 2: \u0441\u0442\u0435\u043D\u0434\u044B'
	            )
	          )
	        )
	      ));
	      return MiddleBlock;
	    }
	  }, {
	    key: 'getMiddleDevelopmentBlock',
	    value: function getMiddleDevelopmentBlock() {
	      var MiddleBlock = [];
	      MiddleBlock.push(_react2.default.createElement(
	        'div',
	        { key: '1' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__development-block' },
	          _react2.default.createElement(
	            'div',
	            { key: '1', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '13:40 - 13:55'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_min' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1068', className: 'room-event__speaker-link' },
	                  '\u041C\u0430\u0440\u0438\u043D\u0430 \u041F\u0430\u0439\u0447,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://www.adcisolutions.com/' },
	                  'ADCI Solutions'
	                ),
	                ', \u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/194', className: 'room-event__title-link' },
	                  '\u041E\u043C\u0441\u043A\u0430\u044F IT-\u0442\u0443\u0441\u043E\u0432\u043A\u0430'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '2', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '13:55 - 14:10'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_min' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1083', className: 'room-event__speaker-link' },
	                  '\u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440 \u041C\u0438\u0448\u0443\u0440\u0438\u043D,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://aciso.ru/' },
	                  '\u041C\u0420\u041E\u041E \xAB\u0410\u0420\u0421\u0418\u0411\xBB'
	                ),
	                ', \u0427\u043B\u0435\u043D \u0410\u0420\u0421\u0418\u0411 , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/193', className: 'room-event__title-link' },
	                  '\u0420\u0430\u0437\u0432\u0438\u0442\u0438\u0435 CTF-\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u041E\u043C\u0441\u043A\u0435'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '3', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '14:10 - 14:25'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_min' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1085', className: 'room-event__speaker-link' },
	                  '\u0421\u0435\u0440\u0433\u0435\u0439 \u0421\u0430\u0432\u0447\u0435\u043D\u043A\u043E,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://www.progschool.ru/_wp/' },
	                  '\u041E\u041E\u041E "\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0410\u0439\u0422\u0438"'
	                ),
	                ', \u0414\u0438\u0440\u0435\u043A\u0442\u043E\u0440 , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/192', className: 'room-event__title-link' },
	                  '\u0428\u043A\u043E\u043B\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442\u0430, \u0443\u0447\u0438\u043C \u0434\u0435\u0442\u0435\u0439 \u0438 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '4', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '14:25 - 14:40'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_min' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'room-event__title' },
	                  '\u0414\u043E\u043A\u043B\u0430\u0434 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__development-block schedule__development-block_min' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__event' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__title room-event__title_color room-event__title_mode' },
	                '\u0421\u043C\u0435\u043D\u0430 2: \u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0442\u0435\u043D\u0434\u0430\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__development-block schedule__development-block_min' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__event' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__title room-event__title_mode' },
	                '\u0421\u043C\u0435\u043D\u0430 3: \u043F\u0435\u0440\u0435\u0440\u044B\u0432 \u043D\u0430 \u043E\u0431\u0435\u0434'
	              )
	            )
	          )
	        )
	      ));
	      MiddleBlock.push(_react2.default.createElement('div', { className: 'schedule__event schedule__event_not-padding' }));
	      MiddleBlock.push(_react2.default.createElement(
	        'div',
	        { key: '2', className: 'schedule__event schedule__event_not-padding' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__time schedule__time_padding' },
	          '14:40 - 15:40'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__block-dev' },
	          _react2.default.createElement('div', { className: 'schedule__event-icon schedule__event-icon_Lunch' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title' },
	              '\u0421\u043C\u0435\u043D\u0430 1 \u0438 2: \u041F\u0435\u0440\u0435\u0440\u044B\u0432 \u043D\u0430 \u043E\u0431\u0435\u0434'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__block-dev' },
	          _react2.default.createElement(
	            'div',
	            { className: 'room-event__event' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__title room-event__title_color' },
	              '\u0421\u043C\u0435\u043D\u0430 3: \u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0442\u0435\u043D\u0434\u0430\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439'
	            )
	          )
	        )
	      ));
	      MiddleBlock.push(_react2.default.createElement(
	        'div',
	        { className: 'schedule__block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'schedule__color-block' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'div',
	              { className: 'room-event__event' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__title room-event__title_color room-event__title_mode' },
	                '\u0421\u043C\u0435\u043D\u0430 1: \u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0442\u0435\u043D\u0434\u0430\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { key: '3' },
	          _react2.default.createElement('div', { key: '0', className: 'schedule__event schedule__event_not-padding' }),
	          _react2.default.createElement(
	            'div',
	            { key: '1', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '15:40 - 15:55'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1068', className: 'room-event__speaker-link' },
	                  '\u041C\u0430\u0440\u0438\u043D\u0430 \u041F\u0430\u0439\u0447,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://www.adcisolutions.com/' },
	                  'ADCI Solutions'
	                ),
	                ', \u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/155', className: 'room-event__title-link' },
	                  '\u041E\u043C\u0441\u043A\u0430\u044F IT-\u0442\u0443\u0441\u043E\u0432\u043A\u0430'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '2', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '15:55 - 16:10'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1083', className: 'room-event__speaker-link' },
	                  '\u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440 \u041C\u0438\u0448\u0443\u0440\u0438\u043D,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://aciso.ru/' },
	                  '\u041C\u0420\u041E\u041E \xAB\u0410\u0420\u0421\u0418\u0411\xBB'
	                ),
	                ', \u0427\u043B\u0435\u043D \u0410\u0420\u0421\u0418\u0411 , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/170', className: 'room-event__title-link' },
	                  '\u0420\u0430\u0437\u0432\u0438\u0442\u0438\u0435 CTF-\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u041E\u043C\u0441\u043A\u0435'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '3', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '16:10 - 16:25'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/speaker?id=1085', className: 'room-event__speaker-link' },
	                  '\u0421\u0435\u0440\u0433\u0435\u0439 \u0421\u0430\u0432\u0447\u0435\u043D\u043A\u043E,'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__speaker-job-position' },
	                _react2.default.createElement(
	                  'a',
	                  { target: '_blank', className: 'room-event__speaker-job-link', href: 'http://www.progschool.ru/_wp/' },
	                  '\u041E\u041E\u041E "\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0410\u0439\u0422\u0438"'
	                ),
	                ', \u0414\u0438\u0440\u0435\u043A\u0442\u043E\u0440 , \u041E\u043C\u0441\u043A'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/room-event/172', className: 'room-event__title-link' },
	                  '\u0428\u043A\u043E\u043B\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0441\u0442\u0430, \u0443\u0447\u0438\u043C \u0434\u0435\u0442\u0435\u0439 \u0438 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: '4', className: 'schedule__event schedule__event_min' },
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__time' },
	              '16:25 - 16:40'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'schedule__room-event schedule__room-event_right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'room-event__event' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'room-event__title' },
	                  '\u0414\u043E\u043A\u043B\u0430\u0434 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F'
	                )
	              )
	            )
	          )
	        )
	      ));
	      MiddleBlock.push(_react2.default.createElement('div', { className: 'schedule__event schedule__event_not-padding' }));
	      return MiddleBlock;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var section = null;
	      // let location = null;
	      if (this.props.sections.length > 0) {
	        section = this.createScheduleBlock();
	        // location = this.props.sections[1].roomName;
	      }
	      // console.log(this.props.sections);
	      return _react2.default.createElement(
	        'div',
	        { className: 'schedule__container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          section
	        )
	      );
	    }
	  }]);
	
	  return ScheduleSection;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sections: state.schedule.sections
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ScheduleSection);

/***/ },
/* 295 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  sections: [],
	  roomEventView: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_SHEDULE_LIST':
	      return Object.assign({}, state, { sections: action.sections });
	    case 'PARSE_SHEDULE_ROOM':
	      return Object.assign({}, state, { roomEventView: action.roomEventView });
	    default:
	      return state;
	  }
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _actions = __webpack_require__(144);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	// import Error from './../blocks/errors/Error404';
	
	
	var Speaker = function (_Component) {
	  _inherits(Speaker, _Component);
	
	  function Speaker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Speaker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Speaker.__proto__ || Object.getPrototypeOf(Speaker)).call.apply(_ref, [this].concat(args))), _this), _this._returnSpeaker = function (speaker) {
	      var speakerCompany = [];
	      if (speaker.speakerShortView.company.name) {
	        speakerCompany.push(_react2.default.createElement(
	          'a',
	          { target: '_blank', className: 'speaker__company', href: speaker.speakerShortView.company.url },
	          speaker.speakerShortView.company.name
	        ));
	        speakerCompany.push(', ');
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'speaker__info_big', key: speaker.speakerShortView.idStr },
	        _react2.default.createElement('img', { className: 'speaker__photo', src: speaker.speakerShortView.pictureUrl, alt: speaker.speakerShortView.userView.fullName }),
	        _react2.default.createElement(
	          'div',
	          { className: 'speaker__about' },
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__name speaker__name_big simple_div' },
	            speaker.speakerShortView.userView.fullName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__position speaker__position_big' },
	            speakerCompany,
	            [speaker.speakerShortView.jobPosition, speaker.speakerShortView.userView.cityName].filter(function (value) {
	              return value;
	            }).join(', ')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__selfdesc' },
	            speaker.speakerShortView.selfDescription
	          )
	        )
	      );
	    }, _this._returnRoomEvent = function (speaker) {
	      return speaker.roomEventShortViewWithTime.map(function (eventRoom) {
	
	        var eventDay = eventRoom.eventDay ? eventRoom.eventDay : '';
	        var startTime = eventRoom.startTime ? eventRoom.startTime : '';
	        var endTime = eventRoom.endTime ? eventRoom.endTime : '';
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'speaker__event', key: eventRoom.idStr },
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__event-time' },
	            eventDay + ' ' + startTime + '-' + endTime
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__event-title' },
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', className: 'speaker__event-link', href: eventRoom.roomEventUrl },
	              eventRoom.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'speaker__event-desc' },
	            eventRoom.description
	          )
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Speaker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var user = {};
	      user.id = parseInt(window.location.search.split('=')[1], 10);
	      if (user.id) {
	        this.props.downloadSpeaker(user);
	      }
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var speaker = this.props.speakerView;
	      var user = void 0;
	      var roomEvent = void 0;
	      if (speaker && speaker.speakerShortView) {
	        user = this._returnSpeaker(speaker);
	        roomEvent = this._returnRoomEvent(speaker);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'speakers' },
	        _react2.default.createElement(
	          'div',
	          { className: 'speakers__container' },
	          user,
	          roomEvent
	        )
	      );
	    }
	  }]);
	
	  return Speaker;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    speakerView: state.speakers.speakerView
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadSpeaker: (0, _redux.bindActionCreators)(_actions.downloadSpeaker, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Speaker);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _actions = __webpack_require__(144);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Speakers = function (_Component) {
	  _inherits(Speakers, _Component);
	
	  function Speakers() {
	    _classCallCheck(this, Speakers);
	
	    return _possibleConstructorReturn(this, (Speakers.__proto__ || Object.getPrototypeOf(Speakers)).apply(this, arguments));
	  }
	
	  _createClass(Speakers, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.downloadSpeakers();
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var baseUrl = '/speakers';
	      // const links = this.props.sections.map(section => (
	      //   <Link
	      //     key={section.id} to={baseUrl + '/' + section.id}
	      //     className={'speaker__tabs-item speaker__tabs-item-' + section.id}
	      //     activeClassName={'speaker__tabs-item_' + section.id}
	      //   >
	      //     {section.name}
	      //   </Link>
	      // ));
	      return _react2.default.createElement(
	        'div',
	        { className: 'speakers' },
	        _react2.default.createElement(
	          'div',
	          { className: 'speakers__title' },
	          '\u0414\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A\u0438'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'speakers__container' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Speakers;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sections: state.speakers.sections
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadSpeakers: (0, _redux.bindActionCreators)(_actions.downloadSpeakers, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(Speakers);

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Speaker = __webpack_require__(145);
	
	var _Speaker2 = _interopRequireDefault(_Speaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllSpeakers = function (_Component) {
	  _inherits(AllSpeakers, _Component);
	
	  function AllSpeakers() {
	    _classCallCheck(this, AllSpeakers);
	
	    return _possibleConstructorReturn(this, (AllSpeakers.__proto__ || Object.getPrototypeOf(AllSpeakers)).apply(this, arguments));
	  }
	
	  _createClass(AllSpeakers, [{
	    key: 'render',
	    value: function render() {
	      var allSpeakers = [];
	      this.props.sections.forEach(function (section) {
	        section.speakerViewList.forEach(function (speaker) {
	          allSpeakers.push(_react2.default.createElement(_Speaker2.default, { key: speaker.speakerShortView.idStr, speakerData: speaker.speakerShortView }));
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'speakers__container speakers__container_users' },
	        allSpeakers
	      );
	    }
	  }]);
	
	  return AllSpeakers;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sections: state.speakers.sections
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AllSpeakers);

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Speaker = __webpack_require__(145);
	
	var _Speaker2 = _interopRequireDefault(_Speaker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpeakerSection = function (_Component) {
	  _inherits(SpeakerSection, _Component);
	
	  function SpeakerSection() {
	    _classCallCheck(this, SpeakerSection);
	
	    return _possibleConstructorReturn(this, (SpeakerSection.__proto__ || Object.getPrototypeOf(SpeakerSection)).apply(this, arguments));
	  }
	
	  _createClass(SpeakerSection, [{
	    key: 'createSpeakers',
	    value: function createSpeakers() {
	      var _this2 = this;
	
	      var sectionData = this.props.sections.filter(function (section) {
	        return section.id === _this2.props.params.filter;
	      });
	      return sectionData[0].speakerViewList.map(function (speaker) {
	        return _react2.default.createElement(_Speaker2.default, { key: speaker.speakerShortView.idStr, speakerData: speaker.speakerShortView });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var section = null;
	      if (this.props.sections.length > 0) {
	        section = this.createSpeakers();
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'speakers__container speakers__container_users' },
	        section
	      );
	    }
	  }]);
	
	  return SpeakerSection;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sections: state.speakers.sections
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SpeakerSection);

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  sections: [],
	  speakerView: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'PARSE_SPEAKERS_LIST':
	      return Object.assign({}, state, { sections: action.sections });
	    case 'PARSE_SPEAKER_INFO':
	      return Object.assign({}, state, { speakerView: action.speakerView });
	    default:
	      return state;
	  }
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newStore = undefined;
	
	var _redux = __webpack_require__(8);
	
	var _rootReducer = __webpack_require__(290);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	var _reduxThunk = __webpack_require__(549);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newStore = exports.newStore = function newStore() {
	  var store = (0, _redux.createStore)(_rootReducer2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	
	  if (false) {
	    module.hot.accept('../root-reducer', function () {
	      var nextRootReducer = require('../root-reducer');
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	
	  return store;
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(12);
	
	var _Form = __webpack_require__(66);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FLNames = __webpack_require__(133);
	
	var _FLNames2 = _interopRequireDefault(_FLNames);
	
	var _Contacts = __webpack_require__(131);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _Education = __webpack_require__(132);
	
	var _Education2 = _interopRequireDefault(_Education);
	
	var _Checkbox = __webpack_require__(82);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _FormBlock = __webpack_require__(134);
	
	var _FormBlock2 = _interopRequireDefault(_FormBlock);
	
	var _Job = __webpack_require__(137);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _FormSubmit = __webpack_require__(135);
	
	var _FormSubmit2 = _interopRequireDefault(_FormSubmit);
	
	var _authAction = __webpack_require__(35);
	
	var _participantAction = __webpack_require__(65);
	
	var _formValidators = __webpack_require__(46);
	
	var _UserSections = __webpack_require__(142);
	
	var _UserSections2 = _interopRequireDefault(_UserSections);
	
	var _fieldAction = __webpack_require__(30);
	
	__webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserProfile = function (_Component) {
	  _inherits(UserProfile, _Component);
	
	  function UserProfile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserProfile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isWorks: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserProfile, [{
	    key: 'onCheckChange',
	    value: function onCheckChange() {
	      this.setState({ isWorks: !this.state.isWorks });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.clearAllMessages();
	      this.props.clearFields();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.participantView.userShortView || !this.props.withServer) {
	        _reactRouter.browserHistory.push('/');
	      }
	      window.scrollTo(0, 0);
	      this.setState({
	        isWorks: this.props.participantView.jobProfileView != null,
	        grade: this.props.participantView.schoolProfileView ? this.props.participantView.schoolProfileView.grade : null,
	        course: this.props.participantView.studentProfileView ? this.props.participantView.studentProfileView.course : null
	      });
	
	      if (this.props.schoolList.length === 0) {
	        this.props.downloadSchoolList();
	        this.props.downloadInstituteList();
	      }
	    }
	  }, {
	    key: 'beforeFormSubmit',
	    value: function beforeFormSubmit() {
	      this.props.formSubmit();
	    }
	  }, {
	    key: 'afterValidation',
	    value: function afterValidation() {
	      if (this.props.isValidated) {
	        var data = Object.assign({}, this.props.fields);
	        data['cityId'] = 1;
	        if (data.password === '') {
	          delete data.password;
	        }
	        if (this.state.grade) {
	          data['grade'] = this.state.grade;
	        }
	        if (this.state.course) {
	          data['course'] = this.state.course;
	        }
	        var form = new FormData();
	        Object.keys(data).forEach(function (field) {
	          form.append(field, data[field]);
	        });
	        this.props.saveUserChanges(form);
	      }
	    }
	  }, {
	    key: 'courseHandler',
	    value: function courseHandler(course) {
	      this.setState({ course: course });
	    }
	  }, {
	    key: 'gradeHandler',
	    value: function gradeHandler(grade) {
	      this.setState({ grade: grade });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.participantView.userShortView || !this.props.withServer) {
	        _reactRouter.browserHistory.push('/');
	      }
	
	      if (this.props.afterValidate) {
	        this.afterValidation();
	      }
	
	      var workBlock = null;
	      if (this.state.isWorks) {
	        workBlock = _react2.default.createElement(_Job2.default, {
	          defaultCompanyName: this.props.participantView.jobProfileView ? this.props.participantView.jobProfileView.companyName : '',
	          defaultJobPosition: this.props.participantView.jobProfileView ? this.props.participantView.jobProfileView.jobPosition : '',
	          jobHandler: _formValidators.notEmptyHandler,
	          positionHandler: _formValidators.notEmptyHandler
	        });
	      }
	
	      var profileForm = [];
	      var educationSection = null;
	      if (this.props.participantView.userShortView) {
	        if (this.props.participantView.schoolProfileView) {
	          educationSection = _react2.default.createElement(_Education2.default, {
	            schoolList: this.props.schoolList,
	            instituteList: this.props.instituteList,
	            gradeHandler: this.gradeHandler.bind(this),
	            departmentHandler: _formValidators.notEmptyHandler,
	            courseHandler: this.courseHandler.bind(this),
	            key: 'education',
	            schoolId: this.props.participantView.schoolProfileView.schoolView.id,
	            grade: this.props.participantView.schoolProfileView.grade
	          });
	        } else if (this.props.participantView.studentProfileView) {
	          educationSection = _react2.default.createElement(_Education2.default, {
	            schoolList: this.props.schoolList,
	            instituteList: this.props.instituteList,
	            gradeHandler: this.gradeHandler.bind(this),
	            departmentHandler: _formValidators.notEmptyHandler,
	            courseHandler: this.courseHandler.bind(this),
	            key: 'education',
	            instituteId: this.props.participantView.studentProfileView.instituteView.id,
	            department: this.props.participantView.studentProfileView.department,
	            course: this.props.participantView.studentProfileView.course
	          });
	        }
	        var submitBlock = educationSection ? _react2.default.createElement(
	          _FormSubmit2.default,
	          {
	            key: 'submit',
	            onClick: function onClick(e) {
	              e.preventDefault();
	              _this2.beforeFormSubmit();
	            }
	          },
	          '\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C'
	        ) : null;
	        profileForm = [_react2.default.createElement(_FLNames2.default, {
	          firstName: this.props.participantView.userShortView.firstName,
	          lastName: this.props.participantView.userShortView.lastName,
	          firstNameHandler: _formValidators.notEmptyHandler,
	          lastNameHandler: _formValidators.notEmptyHandler,
	          key: 'names'
	        }), _react2.default.createElement(_Contacts2.default, {
	          defaultEmailValue: this.props.user.email,
	          defaultPhoneValue: this.props.user.phoneNumber,
	          emailHandler: _formValidators.emailHandler,
	          passwordHandler: _formValidators.newPasswordHandler,
	          phoneHandler: _formValidators.phoneHandler,
	          key: 'contact',
	          newPass: true,
	          ref: 'contacts'
	        }), educationSection, _react2.default.createElement(
	          _FormBlock2.default,
	          { key: 'block' },
	          _react2.default.createElement(_Checkbox2.default, {
	            onChangeCallback: this.onCheckChange.bind(this),
	            name: 'isWorks',
	            inputId: 'works',
	            title: '\u044F \u0440\u0430\u0431\u043E\u0442\u0430\u044E',
	            checked: this.state.isWorks
	          }),
	          workBlock
	        ), submitBlock];
	      }
	      var speakerMessage = educationSection ? null : _react2.default.createElement(
	        'div',
	        { className: 'profile__speaker-message' },
	        '\u0414\u043B\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0441\u0432\u043E\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0438\u0441\u044C \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440\u0430\u043C'
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'profile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'profile__title' },
	          '\u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442'
	        ),
	        _react2.default.createElement(_UserSections2.default, {
	          sectionsStyleClasses: ['profile__user-sections'],
	          sectionStyleClasses: ['profile__user-sections-element']
	        }),
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            ref: 'form',
	            successMessage: this.props.successUserChangingMessage
	          },
	          speakerMessage,
	          _react2.default.createElement('input', { hidden: 'hidden', name: 'cityId', value: 1, onChange: function onChange() {
	              return null;
	            } }),
	          profileForm
	        )
	      );
	    }
	  }]);
	
	  return UserProfile;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: state.participant.userView,
	    allSections: state.participant.allSections,
	    schoolList: state.auth.schoolList,
	    instituteList: state.auth.instituteList,
	    isValidated: state.auth.isValidated,
	    afterValidate: state.auth.afterValidate,
	    participantView: state.participant.participantView,
	    successUserChangingMessage: state.participant.successUserChangingMessage,
	    fields: state.fields,
	    withServer: state.participant.withServer,
	    registrationClosed: state.participant.registrationClosed
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    downloadInstituteList: (0, _redux.bindActionCreators)(_authAction.downloadInstituteList, dispatch),
	    downloadSchoolList: (0, _redux.bindActionCreators)(_authAction.downloadSchoolList, dispatch),
	    formSubmit: (0, _redux.bindActionCreators)(_authAction.formSubmit, dispatch),
	    saveUserChanges: (0, _redux.bindActionCreators)(_participantAction.saveUserChanges, dispatch),
	    clearAllMessages: (0, _redux.bindActionCreators)(_participantAction.clearAllMessages, dispatch),
	    clearFields: (0, _redux.bindActionCreators)(_fieldAction.clearFields, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserProfile);

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(315), __esModule: true };

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(318), __esModule: true };

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(319), __esModule: true };

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(146);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(303);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 312 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};

/***/ },
/* 313 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(148);
	} catch (err) {
	  var index = __webpack_require__(148);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(340);
	module.exports = __webpack_require__(22).Object.assign;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(341);
	var $Object = __webpack_require__(22).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(342);
	var $Object = __webpack_require__(22).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(343);
	var $Object = __webpack_require__(22).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(344);
	module.exports = __webpack_require__(22).Object.getPrototypeOf;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(345);
	module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(348);
	__webpack_require__(346);
	__webpack_require__(349);
	__webpack_require__(350);
	module.exports = __webpack_require__(22).Symbol;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(347);
	__webpack_require__(351);
	module.exports = __webpack_require__(99).f('iterator');


/***/ },
/* 323 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 324 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(338);
	var toAbsoluteIndex = __webpack_require__(337);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(92);
	var pIE = __webpack_require__(69);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(32).document;
	module.exports = document && document.documentElement;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(149);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(90);
	var descriptor = __webpack_require__(70);
	var setToStringTag = __webpack_require__(93);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(48)(IteratorPrototype, __webpack_require__(50)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 330 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(72)('meta');
	var isObject = __webpack_require__(49);
	var has = __webpack_require__(37);
	var setDesc = __webpack_require__(38).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(47)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(31);
	var getKeys = __webpack_require__(68);
	var gOPS = __webpack_require__(92);
	var pIE = __webpack_require__(69);
	var toObject = __webpack_require__(71);
	var IObject = __webpack_require__(153);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(47)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(38);
	var anObject = __webpack_require__(58);
	var getKeys = __webpack_require__(68);
	
	module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(39);
	var gOPN = __webpack_require__(155).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(49);
	var anObject = __webpack_require__(58);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(150)(Function.call, __webpack_require__(91).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(96);
	var defined = __webpack_require__(87);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(96);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(96);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(324);
	var step = __webpack_require__(330);
	var Iterators = __webpack_require__(89);
	var toIObject = __webpack_require__(39);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(154)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(36);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(332) });


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(36);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(90) });


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(36);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperty: __webpack_require__(38).f });


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(39);
	var $getOwnPropertyDescriptor = __webpack_require__(91).f;
	
	__webpack_require__(158)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(71);
	var $getPrototypeOf = __webpack_require__(156);
	
	__webpack_require__(158)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(36);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(335).set });


/***/ },
/* 346 */
/***/ function(module, exports) {



/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(336)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(154)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(32);
	var has = __webpack_require__(37);
	var DESCRIPTORS = __webpack_require__(31);
	var $export = __webpack_require__(36);
	var redefine = __webpack_require__(159);
	var META = __webpack_require__(331).KEY;
	var $fails = __webpack_require__(47);
	var shared = __webpack_require__(95);
	var setToStringTag = __webpack_require__(93);
	var uid = __webpack_require__(72);
	var wks = __webpack_require__(50);
	var wksExt = __webpack_require__(99);
	var wksDefine = __webpack_require__(98);
	var enumKeys = __webpack_require__(326);
	var isArray = __webpack_require__(328);
	var anObject = __webpack_require__(58);
	var isObject = __webpack_require__(49);
	var toObject = __webpack_require__(71);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(97);
	var createDesc = __webpack_require__(70);
	var _create = __webpack_require__(90);
	var gOPNExt = __webpack_require__(334);
	var $GOPD = __webpack_require__(91);
	var $GOPS = __webpack_require__(92);
	var $DP = __webpack_require__(38);
	var $keys = __webpack_require__(68);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(155).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(69).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(67)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(48)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(98)('asyncIterator');


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(98)('observable');


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(339);
	var global = __webpack_require__(32);
	var hide = __webpack_require__(48);
	var Iterators = __webpack_require__(89);
	var TO_STRING_TAG = __webpack_require__(50)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(160);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(176);
	var isArguments = __webpack_require__(406);
	var is = __webpack_require__(418);
	var isRegex = __webpack_require__(408);
	var flags = __webpack_require__(553);
	var isDate = __webpack_require__(407);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(357);
	var each = __webpack_require__(162).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(355);
	var Util = __webpack_require__(162);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 357 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(356);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 359 */
23,
/* 360 */
23,
/* 361 */
23,
/* 362 */
23,
/* 363 */
23,
/* 364 */
23,
/* 365 */
23,
/* 366 */
23,
/* 367 */
23,
/* 368 */
23,
/* 369 */
23,
/* 370 */
23,
/* 371 */
23,
/* 372 */
23,
/* 373 */
23,
/* 374 */
23,
/* 375 */
23,
/* 376 */
23,
/* 377 */
23,
/* 378 */
23,
/* 379 */
23,
/* 380 */
23,
/* 381 */
23,
/* 382 */
23,
/* 383 */
23,
/* 384 */
23,
/* 385 */
23,
/* 386 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(386);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(396);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var createArrayFromMixed = __webpack_require__(389);
	var getMarkupWrap = __webpack_require__(391);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 392 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 393 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(393);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 395 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(395);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 397 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 398 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(398);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(399);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(51);
	
	var _PathUtils = __webpack_require__(40);
	
	var _ExecutionEnvironment = __webpack_require__(73);
	
	var _DOMUtils = __webpack_require__(102);
	
	var _DOMStateStorage = __webpack_require__(170);
	
	var _createDOMHistory = __webpack_require__(171);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(51);
	
	var _PathUtils = __webpack_require__(40);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(26);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(40);
	
	var _Actions = __webpack_require__(51);
	
	var _createHistory = __webpack_require__(173);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(123);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 406 */
/***/ function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 407 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(400);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(556);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175),
	    getRawTag = __webpack_require__(413),
	    objectToString = __webpack_require__(414);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 411 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(415);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(175);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 414 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 415 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(411);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 417 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 418 */
/***/ function(module, exports) {

	"use strict";
	
	/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */
	
	var NumberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		} else if (a === b) {
			return true;
		} else if (NumberIsNaN(a) && NumberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(177); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(180);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(123);
	var assign = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(180);
	var checkPropTypes = __webpack_require__(420);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(555);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(311);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(310);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(84);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(85);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(147);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChildrenUtils = __webpack_require__(426);
	
	var _AnimateChild = __webpack_require__(425);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(181);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = Animate;
	module.exports = exports['default'];

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(84);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(85);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(147);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(161);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(181);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Panel = __webpack_require__(428);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _openAnimationFactory = __webpack_require__(431);
	
	var _openAnimationFactory2 = _interopRequireDefault(_openAnimationFactory);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIs = __webpack_require__(123);
	
	var _shallowequal = __webpack_require__(128);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _reactLifecyclesCompat = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toArray(activeKey) {
	  var currentActiveKey = activeKey;
	  if (!Array.isArray(currentActiveKey)) {
	    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
	  }
	  return currentActiveKey.map(function (key) {
	    return String(key);
	  });
	}
	
	var Collapse = function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = props.activeKey,
	        defaultActiveKey = props.defaultActiveKey;
	
	    var currentActiveKey = defaultActiveKey;
	    if ('activeKey' in props) {
	      currentActiveKey = activeKey;
	    }
	
	    _this.state = {
	      openAnimation: props.openAnimation || (0, _openAnimationFactory2['default'])(props.prefixCls),
	      activeKey: toArray(currentActiveKey)
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          style = _props.style,
	          accordion = _props.accordion;
	
	      var collapseClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
	      return _react2['default'].createElement(
	        'div',
	        { className: collapseClassName, style: style, role: accordion ? 'tablist' : null },
	        this.getItems()
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	      if ('activeKey' in nextProps) {
	        newState.activeKey = toArray(nextProps.activeKey);
	      }
	      if ('openAnimation' in nextProps) {
	        newState.openAnimation = nextProps.openAnimation;
	      }
	      return newState.activeKey || newState.openAnimation ? newState : null;
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClickItem = function (key) {
	    var activeKey = _this2.state.activeKey;
	    if (_this2.props.accordion) {
	      activeKey = activeKey[0] === key ? [] : [key];
	    } else {
	      activeKey = [].concat(_toConsumableArray(activeKey));
	      var index = activeKey.indexOf(key);
	      var isActive = index > -1;
	      if (isActive) {
	        // remove active state
	        activeKey.splice(index, 1);
	      } else {
	        activeKey.push(key);
	      }
	    }
	    _this2.setActiveKey(activeKey);
	  };
	
	  this.getNewChild = function (child, index) {
	    if (!child) return null;
	
	    var activeKey = _this2.state.activeKey;
	    var _props2 = _this2.props,
	        prefixCls = _props2.prefixCls,
	        accordion = _props2.accordion,
	        destroyInactivePanel = _props2.destroyInactivePanel,
	        expandIcon = _props2.expandIcon;
	    // If there is no key provide, use the panel order as default key
	
	    var key = child.key || String(index);
	    var _child$props = child.props,
	        header = _child$props.header,
	        headerClass = _child$props.headerClass,
	        disabled = _child$props.disabled;
	
	    var isActive = false;
	    if (accordion) {
	      isActive = activeKey[0] === key;
	    } else {
	      isActive = activeKey.indexOf(key) > -1;
	    }
	
	    var props = {
	      key: key,
	      panelKey: key,
	      header: header,
	      headerClass: headerClass,
	      isActive: isActive,
	      prefixCls: prefixCls,
	      destroyInactivePanel: destroyInactivePanel,
	      openAnimation: _this2.state.openAnimation,
	      accordion: accordion,
	      children: child.props.children,
	      onItemClick: disabled ? null : _this2.onClickItem,
	      expandIcon: expandIcon
	    };
	
	    return _react2['default'].cloneElement(child, props);
	  };
	
	  this.getItems = function () {
	    var children = _this2.props.children;
	
	    var childList = (0, _reactIs.isFragment)(children) ? children.props.children : children;
	    var newChildren = _react.Children.map(childList, _this2.getNewChild);
	
	    //  ref: https://github.com/ant-design/ant-design/issues/13884
	    if ((0, _reactIs.isFragment)(children)) {
	      return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        newChildren
	      );
	    }
	
	    return newChildren;
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (!('activeKey' in _this2.props)) {
	      _this2.setState({ activeKey: activeKey });
	    }
	    _this2.props.onChange(_this2.props.accordion ? activeKey[0] : activeKey);
	  };
	};
	
	Collapse.propTypes = {
	  children: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  activeKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  defaultActiveKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  openAnimation: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  accordion: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func
	};
	
	Collapse.defaultProps = {
	  prefixCls: 'rc-collapse',
	  onChange: function onChange() {},
	
	  accordion: false,
	  destroyInactivePanel: false
	};
	
	Collapse.Panel = _Panel2['default'];
	
	(0, _reactLifecyclesCompat.polyfill)(Collapse);
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelContent = __webpack_require__(429);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	var _rcAnimate = __webpack_require__(424);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _shallowequal = __webpack_require__(128);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsePanel = function (_Component) {
	  _inherits(CollapsePanel, _Component);
	
	  function CollapsePanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CollapsePanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function () {
	      var _this$props = _this.props,
	          onItemClick = _this$props.onItemClick,
	          panelKey = _this$props.panelKey;
	
	
	      if (typeof onItemClick === 'function') {
	        onItemClick(panelKey);
	      }
	    }, _this.handleKeyPress = function (e) {
	      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
	        _this.handleItemClick();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CollapsePanel, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames2;
	
	      var _props = this.props,
	          className = _props.className,
	          id = _props.id,
	          style = _props.style,
	          prefixCls = _props.prefixCls,
	          header = _props.header,
	          headerClass = _props.headerClass,
	          children = _props.children,
	          isActive = _props.isActive,
	          showArrow = _props.showArrow,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          disabled = _props.disabled,
	          accordion = _props.accordion,
	          forceRender = _props.forceRender,
	          expandIcon = _props.expandIcon,
	          extra = _props.extra;
	
	      var headerCls = (0, _classnames2['default'])(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
	      var itemCls = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
	
	      var icon = _react2['default'].createElement('i', { className: 'arrow' });
	      if (showArrow && typeof expandIcon === 'function') {
	        icon = expandIcon(this.props);
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: itemCls, style: style, id: id },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: headerCls,
	            onClick: this.handleItemClick,
	            role: accordion ? 'tab' : 'button',
	            tabIndex: disabled ? -1 : 0,
	            'aria-expanded': '' + isActive,
	            onKeyPress: this.handleKeyPress
	          },
	          showArrow && icon,
	          header,
	          extra && _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-extra' },
	            extra
	          )
	        ),
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            showProp: 'isActive',
	            exclusive: true,
	            component: '',
	            animation: this.props.openAnimation
	          },
	          _react2['default'].createElement(
	            _PanelContent2['default'],
	            {
	              prefixCls: prefixCls,
	              isActive: isActive,
	              destroyInactivePanel: destroyInactivePanel,
	              forceRender: forceRender,
	              role: accordion ? 'tabpanel' : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(_react.Component);
	
	CollapsePanel.propTypes = {
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  id: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  openAnimation: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  header: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].node]),
	  headerClass: _propTypes2['default'].string,
	  showArrow: _propTypes2['default'].bool,
	  isActive: _propTypes2['default'].bool,
	  onItemClick: _propTypes2['default'].func,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  accordion: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func,
	  extra: _propTypes2['default'].node,
	  panelKey: _propTypes2['default'].any
	};
	
	CollapsePanel.defaultProps = {
	  showArrow: true,
	  isActive: false,
	  destroyInactivePanel: false,
	  onItemClick: function onItemClick() {},
	
	  headerClass: '',
	  forceRender: false
	};
	
	exports['default'] = CollapsePanel;
	module.exports = exports['default'];

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(27);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _shallowequal = __webpack_require__(128);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanelContent = function (_Component) {
	  _inherits(PanelContent, _Component);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.forceRender || !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      this._isActived = this.props.forceRender || this._isActived || this.props.isActive;
	      if (!this._isActived) {
	        return null;
	      }
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          isActive = _props.isActive,
	          children = _props.children,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          forceRender = _props.forceRender,
	          role = _props.role;
	
	      var contentCls = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
	      var child = !forceRender && !isActive && destroyInactivePanel ? null : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-content-box' },
	        children
	      );
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: contentCls,
	          role: role
	        },
	        child
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.Component);
	
	PanelContent.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  isActive: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string
	};
	
	exports['default'] = PanelContent;
	module.exports = exports['default'];

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _Collapse = __webpack_require__(427);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Collapse2['default'];
	var Panel = exports.Panel = _Collapse2['default'].Panel;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cssAnimation = __webpack_require__(161);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function animate(node, show, transitionName, done) {
	  var height = void 0;
	  return (0, _cssAnimation2['default'])(node, transitionName, {
	    start: function start() {
	      if (!show) {
	        node.style.height = node.offsetHeight + 'px';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = 0;
	      }
	    },
	    active: function active() {
	      node.style.height = (show ? height : 0) + 'px';
	    },
	    end: function end() {
	      node.style.height = '';
	      done();
	    }
	  });
	}
	
	function animation(prefixCls) {
	  return {
	    enter: function enter(node, done) {
	      return animate(node, true, prefixCls + '-anim', done);
	    },
	    leave: function leave(node, done) {
	      return animate(node, false, prefixCls + '-anim', done);
	    }
	  };
	}
	
	exports['default'] = animation;
	module.exports = exports['default'];

/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var focusNode = __webpack_require__(168);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(61);
	var ExecutionEnvironment = __webpack_require__(17);
	var FallbackCompositionState = __webpack_require__(440);
	var SyntheticCompositionEvent = __webpack_require__(474);
	var SyntheticInputEvent = __webpack_require__(477);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(182);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactInstrumentation = __webpack_require__(20);
	
	var camelizeStyleName = __webpack_require__(387);
	var dangerousStyleValue = __webpack_require__(483);
	var hyphenateStyleName = __webpack_require__(394);
	var memoizeStringOnly = __webpack_require__(397);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(60);
	var EventPropagators = __webpack_require__(61);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(24);
	var SyntheticEvent = __webpack_require__(28);
	
	var inputValueTracking = __webpack_require__(204);
	var getEventTarget = __webpack_require__(118);
	var isEventSupported = __webpack_require__(120);
	var isTextInputElement = __webpack_require__(205);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(53);
	var ExecutionEnvironment = __webpack_require__(17);
	
	var createNodesFromMarkup = __webpack_require__(390);
	var emptyFunction = __webpack_require__(25);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(61);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticMouseEvent = __webpack_require__(76);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(42);
	
	var getTextContentAccessor = __webpack_require__(203);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(54);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(43);
	
	var instantiateReactComponent = __webpack_require__(119);
	var KeyEscapeUtils = __webpack_require__(110);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var traverseAllChildren = __webpack_require__(207);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(222);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(178)))

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(106);
	var ReactDOMIDOperations = __webpack_require__(449);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(45);
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactErrorUtils = __webpack_require__(113);
	var ReactInstanceMap = __webpack_require__(62);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactNodeTypes = __webpack_require__(196);
	var ReactReconciler = __webpack_require__(43);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(101);
	var shouldUpdateReactComponent = __webpack_require__(121);
	var warning = __webpack_require__(5);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDefaultInjection = __webpack_require__(189);
	var ReactMount = __webpack_require__(195);
	var ReactReconciler = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(24);
	var ReactVersion = __webpack_require__(198);
	
	var findDOMNode = __webpack_require__(484);
	var getHostComponentFromComposite = __webpack_require__(202);
	var renderSubtreeIntoContainer = __webpack_require__(491);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(433);
	var CSSPropertyOperations = __webpack_require__(435);
	var DOMLazyTree = __webpack_require__(53);
	var DOMNamespaces = __webpack_require__(107);
	var DOMProperty = __webpack_require__(54);
	var DOMPropertyOperations = __webpack_require__(184);
	var EventPluginHub = __webpack_require__(60);
	var EventPluginRegistry = __webpack_require__(108);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactDOMComponentFlags = __webpack_require__(185);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMInput = __webpack_require__(450);
	var ReactDOMOption = __webpack_require__(451);
	var ReactDOMSelect = __webpack_require__(187);
	var ReactDOMTextarea = __webpack_require__(455);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMultiChild = __webpack_require__(461);
	var ReactServerRenderingTransaction = __webpack_require__(197);
	
	var emptyFunction = __webpack_require__(25);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(120);
	var shallowEqual = __webpack_require__(101);
	var inputValueTracking = __webpack_require__(204);
	var validateDOMNesting = __webpack_require__(122);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 448 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(106);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(184);
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMSelect = __webpack_require__(187);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	var getNodeForCharacterOffset = __webpack_require__(488);
	var getTextContentAccessor = __webpack_require__(203);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(189);
	var ReactServerRendering = __webpack_require__(467);
	var ReactVersion = __webpack_require__(198);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(106);
	var DOMLazyTree = __webpack_require__(53);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(122);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(24);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 457 */
223,
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(60);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(167);
	var ExecutionEnvironment = __webpack_require__(17);
	var PooledClass = __webpack_require__(42);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(24);
	
	var getEventTarget = __webpack_require__(118);
	var getUnboundedScrollPosition = __webpack_require__(392);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(54);
	var EventPluginHub = __webpack_require__(60);
	var EventPluginUtils = __webpack_require__(109);
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactEmptyComponent = __webpack_require__(190);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactHostComponent = __webpack_require__(192);
	var ReactUpdates = __webpack_require__(24);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(112);
	var ReactInstanceMap = __webpack_require__(62);
	var ReactInstrumentation = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactReconciler = __webpack_require__(43);
	var ReactChildReconciler = __webpack_require__(442);
	
	var emptyFunction = __webpack_require__(25);
	var flattenChildren = __webpack_require__(485);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(183);
	var PooledClass = __webpack_require__(42);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactInputSelection = __webpack_require__(193);
	var ReactInstrumentation = __webpack_require__(20);
	var Transaction = __webpack_require__(77);
	var ReactUpdateQueue = __webpack_require__(114);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(462);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 466 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(45);
	var ReactDOMContainerInfo = __webpack_require__(186);
	var ReactDefaultBatchingStrategy = __webpack_require__(188);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMarkupChecksum = __webpack_require__(194);
	var ReactReconciler = __webpack_require__(43);
	var ReactServerBatchingStrategy = __webpack_require__(466);
	var ReactServerRenderingTransaction = __webpack_require__(197);
	var ReactUpdates = __webpack_require__(24);
	
	var emptyObject = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(119);
	var invariant = __webpack_require__(2);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(114);
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(61);
	var ExecutionEnvironment = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInputSelection = __webpack_require__(193);
	var SyntheticEvent = __webpack_require__(28);
	
	var getActiveElement = __webpack_require__(169);
	var isTextInputElement = __webpack_require__(205);
	var shallowEqual = __webpack_require__(101);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventListener = __webpack_require__(167);
	var EventPropagators = __webpack_require__(61);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticAnimationEvent = __webpack_require__(472);
	var SyntheticClipboardEvent = __webpack_require__(473);
	var SyntheticEvent = __webpack_require__(28);
	var SyntheticFocusEvent = __webpack_require__(476);
	var SyntheticKeyboardEvent = __webpack_require__(478);
	var SyntheticMouseEvent = __webpack_require__(76);
	var SyntheticDragEvent = __webpack_require__(475);
	var SyntheticTouchEvent = __webpack_require__(479);
	var SyntheticTransitionEvent = __webpack_require__(480);
	var SyntheticUIEvent = __webpack_require__(63);
	var SyntheticWheelEvent = __webpack_require__(481);
	
	var emptyFunction = __webpack_require__(25);
	var getEventCharCode = __webpack_require__(116);
	var invariant = __webpack_require__(2);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(63);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(63);
	
	var getEventCharCode = __webpack_require__(116);
	var getEventKey = __webpack_require__(486);
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(63);
	
	var getEventModifierState = __webpack_require__(117);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(28);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 482 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(182);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstanceMap = __webpack_require__(62);
	
	var getHostComponentFromComposite = __webpack_require__(202);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(110);
	var traverseAllChildren = __webpack_require__(207);
	var warning = __webpack_require__(5);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(222);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(178)))

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(116);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(17);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(195);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 492 */
/***/ function(module, exports) {

	/** @license React v16.10.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ },
/* 493 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(41);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(209);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(210);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(209);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(496);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(497);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(210);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(405);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 496 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(8);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(211);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(212);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(172);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(74);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(44);
	
	var _RouterContext = __webpack_require__(80);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _RouterUtils = __webpack_require__(213);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(80);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(124);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(80);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(402);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(215);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(55);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(124);
	
	var _makeStateWithLocation = __webpack_require__(216);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(55);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(172);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(215);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(55);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(51);
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(214);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(33);
	
	var _RouterUtils = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(124);
	
	var _makeStateWithLocation = __webpack_require__(216);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(55);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(74);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(126);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(9);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(11);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(519);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 519 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(523).enable();
	  window.Promise = __webpack_require__(522);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(524);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(521);


/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(218);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(218);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 524 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownContent = exports.DropdownTrigger = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownTrigger = __webpack_require__(527);
	
	var _DropdownTrigger2 = _interopRequireDefault(_DropdownTrigger);
	
	var _DropdownContent = __webpack_require__(526);
	
	var _DropdownContent2 = _interopRequireDefault(_DropdownContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dropdown = (0, _react.createClass)({
	  displayName: 'Dropdown',
	
	  getInitialState: function getInitialState() {
	    return {
	      active: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      className: ''
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    window.addEventListener('click', this._onWindowClick);
	    window.addEventListener('touchstart', this._onWindowClick);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('click', this._onWindowClick);
	    window.removeEventListener('touchstart', this._onWindowClick);
	  },
	  render: function render() {
	    var _this = this,
	        _arguments = arguments;
	
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	    // create component classes
	
	    var active = this.isActive();
	    var dropdown_classes = (0, _classnames2.default)({
	      dropdown: true,
	      'dropdown--active': active
	    });
	    dropdown_classes += ' ' + className;
	    // stick callback on trigger element
	    var bound_children = _react2.default.Children.map(children, function (child) {
	      if (child.type === _DropdownTrigger2.default) {
	        (function () {
	          var originalOnClick = child.props.onClick;
	          child = (0, _react.cloneElement)(child, {
	            ref: 'trigger',
	            onClick: function onClick(event) {
	              _this._onToggleClick(event);
	              if (originalOnClick) {
	                originalOnClick.apply(child, _arguments);
	              }
	            }
	          });
	        })();
	      }
	      return child;
	    });
	    return _react2.default.createElement(
	      'div',
	      {
	        style: this.props.style,
	        className: dropdown_classes },
	      bound_children
	    );
	  },
	  isActive: function isActive() {
	    return typeof this.props.active === 'boolean' ? this.props.active : this.state.active;
	  },
	  hide: function hide() {
	    this.setState({
	      active: false
	    });
	    if (this.props.onHide) {
	      this.props.onHide();
	    }
	  },
	  show: function show() {
	    this.setState({
	      active: true
	    });
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  _onWindowClick: function _onWindowClick(event) {
	    var dropdown_element = (0, _reactDom.findDOMNode)(this);
	    if (event.target !== dropdown_element && !dropdown_element.contains(event.target) && this.isActive()) {
	      this.hide();
	    }
	  },
	  _onToggleClick: function _onToggleClick(event) {
	    event.preventDefault();
	    if (this.isActive()) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  }
	});
	
	exports.DropdownTrigger = _DropdownTrigger2.default;
	exports.DropdownContent = _DropdownContent2.default;
	exports.default = Dropdown;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DropdownContent = (0, _react.createClass)({
	  displayName: 'DropdownContent',
	
	  propTypes: {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      className: ''
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _extends({}, this.props, {
	      className: 'dropdown__content ' + className
	    });
	
	    return _react2.default.createElement(
	      'div',
	      props,
	      children
	    );
	  }
	});
	
	exports.default = DropdownContent;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DropdownTrigger = (0, _react.createClass)({
	  displayName: 'DropdownTrigger',
	
	  propTypes: {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      className: ''
	    };
	  },
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _extends({}, this.props, {
	      className: 'dropdown__trigger ' + className
	    });
	
	    return _react2.default.createElement(
	      'a',
	      props,
	      children
	    );
	  }
	});
	
	exports.default = DropdownTrigger;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * 
	 *  React Simpletabs - Just a simple tabs component built with React
	 *  @version v0.7.0
	 *  @link https://github.com/pedronauck/react-simpletabs
	 *  @license MIT
	 *  @author Pedro Nauck (https://github.com/pedronauck)
	 * 
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["ReactSimpleTabs"] = factory(require("react"));
		else
			root["ReactSimpleTabs"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		/** @jsx React.DOM */'use strict';
	
		var React = __webpack_require__(1);
		var classNames = __webpack_require__(2);
	
		if (true) {
		  __webpack_require__(3);
		}
	
		var Tabs = React.createClass({
		  displayName: 'Tabs',
		  propTypes: {
		    className: React.PropTypes.oneOfType([
		      React.PropTypes.array,
		      React.PropTypes.string,
		      React.PropTypes.object
		    ]),
		    tabActive: React.PropTypes.number,
		    onMount: React.PropTypes.func,
		    onBeforeChange: React.PropTypes.func,
		    onAfterChange: React.PropTypes.func,
		    children: React.PropTypes.oneOfType([
		      React.PropTypes.array,
		      React.PropTypes.element
		    ]).isRequired
		  },
		  getDefaultProps:function () {
		    return { tabActive: 1 };
		  },
		  getInitialState:function () {
		    return {
		      tabActive: this.props.tabActive
		    };
		  },
		  componentDidMount:function() {
		    var index = this.state.tabActive;
		    var $selectedPanel = this.refs['tab-panel'];
		    var $selectedMenu = this.refs[("tab-menu-" + index)];
	
		    if (this.props.onMount) {
		      this.props.onMount(index, $selectedPanel, $selectedMenu);
		    }
		  },
		  componentWillReceiveProps: function(newProps){
		    if(newProps.tabActive && newProps.tabActive !== this.props.tabActive){
		      this.setState({tabActive: newProps.tabActive});
		    }
		  },
		  render:function () {
		    var className = classNames('tabs', this.props.className);
		    return (
		      React.createElement("div", {className: className}, 
		        this._getMenuItems(), 
		        this._getSelectedPanel()
		      )
		    );
		  },
		  setActive:function(index, e) {
		    e.preventDefault();
	
		    var onAfterChange = this.props.onAfterChange;
		    var onBeforeChange = this.props.onBeforeChange;
		    var $selectedPanel = this.refs['tab-panel'];
		    var $selectedTabMenu = this.refs[("tab-menu-" + index)];
	
		    if (onBeforeChange) {
		      var cancel = onBeforeChange(index, $selectedPanel, $selectedTabMenu);
		      if(cancel === false){ return }
		    }
	
		    this.setState({ tabActive: index }, function()  {
		      if (onAfterChange) {
		        onAfterChange(index, $selectedPanel, $selectedTabMenu);
		      }
		    });
		  },
		  _getMenuItems:function () {
		    if (!this.props.children) {
		      throw new Error('Tabs must contain at least one Tabs.Panel');
		    }
	
		    if (!Array.isArray(this.props.children)) {
		      this.props.children = [this.props.children];
		    }
	
		    var $menuItems = this.props.children
		      .map(function($panel)  {return typeof $panel === 'function' ? $panel() : $panel;})
		      .filter(function($panel)  {return $panel;})
		      .map(function($panel, index)  {
		        var ref = ("tab-menu-" + (index + 1));
		        var title = $panel.props.title;
		        var classes = classNames(
		          'tabs-menu-item',
		          this.state.tabActive === (index + 1) && 'is-active'
		        );
	
		        return (
		          React.createElement("li", {ref: ref, key: index, className: classes}, 
		            React.createElement("a", {onClick: this.setActive.bind(this, index + 1)}, 
		              title
		            )
		          )
		        );
		      }.bind(this));
	
		    return (
		      React.createElement("nav", {className: "tabs-navigation"}, 
		        React.createElement("ul", {className: "tabs-menu"}, $menuItems)
		      )
		    );
		  },
		  _getSelectedPanel:function () {
		    var index = this.state.tabActive - 1;
		    var $panel = this.props.children[index];
	
		    return (
		      React.createElement("article", {ref: "tab-panel", className: "tab-panel"}, 
		        $panel
		      )
		    );
		  }
		});
	
		Tabs.Panel = React.createClass({
		  displayName: 'Panel',
		  propTypes: {
		    title: React.PropTypes.string.isRequired,
		    children: React.PropTypes.oneOfType([
		      React.PropTypes.array,
		      React.PropTypes.element
		    ]).isRequired
		  },
		  render:function () {
		    return React.createElement("div", null, this.props.children);
		  }
		});
	
		module.exports = Tabs;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		/** @jsx React.DOM */function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames in case the script is included directly on a page
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }
	/******/ ])
	});


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(535);

/***/ },
/* 532 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(534);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(532);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(219);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(352);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(536);
	
	var _dots = __webpack_require__(530);
	
	var _arrows = __webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(220);
	
	var _helpers = __webpack_require__(127);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(533);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(409);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(219);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(313);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(358);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(27);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 537 */
110,
/* 538 */
[561, 64],
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(538);
	var ReactElement = __webpack_require__(56);
	
	var emptyFunction = __webpack_require__(25);
	var traverseAllChildren = __webpack_require__(548);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(56);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(56),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(179);
	
	module.exports = factory(isValidElement);

/***/ },
/* 542 */
198,
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(221),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(56),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(224);
	var factory = __webpack_require__(160);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 544 */
487,
/* 545 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactElement = __webpack_require__(56);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(64);
	
	var ReactCurrentOwner = __webpack_require__(29);
	var REACT_ELEMENT_TYPE = __webpack_require__(223);
	
	var getIteratorFn = __webpack_require__(544);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(537);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 549 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(226);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(227);
	
	var _isPlainObject = __webpack_require__(105);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(228);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(100);
	
	var implementation = __webpack_require__(229);
	var getPolyfill = __webpack_require__(230);
	var shim = __webpack_require__(554);
	
	var flagsBound = Function.call.bind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(100).supportsDescriptors;
	var getPolyfill = __webpack_require__(230);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 555 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 556 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(558);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(560)(module)))

/***/ },
/* 558 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 559 */
26,
/* 560 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f981ba7e.js